const pincodeData = [
  { pincode: 110001, serviceable: "Yes", tier: "1" },
  { pincode: 110002, serviceable: "Yes", tier: "1" },
  { pincode: 110003, serviceable: "Yes", tier: "1" },
  { pincode: 110004, serviceable: "Yes", tier: "1" },
  { pincode: 110005, serviceable: "Yes", tier: "1" },
  { pincode: 110006, serviceable: "Yes", tier: "1" },
  { pincode: 110007, serviceable: "Yes", tier: "1" },
  { pincode: 110008, serviceable: "Yes", tier: "1" },
  { pincode: 110009, serviceable: "Yes", tier: "1" },
  { pincode: 110010, serviceable: "Yes", tier: "1" },
  { pincode: 110011, serviceable: "Yes", tier: "1" },
  { pincode: 110012, serviceable: "Yes", tier: "1" },
  { pincode: 110013, serviceable: "Yes", tier: "1" },
  { pincode: 110014, serviceable: "Yes", tier: "1" },
  { pincode: 110015, serviceable: "Yes", tier: "1" },
  { pincode: 110016, serviceable: "Yes", tier: "1" },
  { pincode: 110017, serviceable: "Yes", tier: "1" },
  { pincode: 110018, serviceable: "Yes", tier: "1" },
  { pincode: 110019, serviceable: "Yes", tier: "1" },
  { pincode: 110020, serviceable: "Yes", tier: "1" },
  { pincode: 110021, serviceable: "Yes", tier: "1" },
  { pincode: 110022, serviceable: "Yes", tier: "1" },
  { pincode: 110023, serviceable: "Yes", tier: "1" },
  { pincode: 110024, serviceable: "Yes", tier: "1" },
  { pincode: 110025, serviceable: "Yes", tier: "1" },
  { pincode: 110026, serviceable: "Yes", tier: "1" },
  { pincode: 110027, serviceable: "Yes", tier: "1" },
  { pincode: 110028, serviceable: "Yes", tier: "1" },
  { pincode: 110029, serviceable: "Yes", tier: "1" },
  { pincode: 110030, serviceable: "Yes", tier: "1" },
  { pincode: 110031, serviceable: "Yes", tier: "1" },
  { pincode: 110032, serviceable: "Yes", tier: "1" },
  { pincode: 110033, serviceable: "Yes", tier: "1" },
  { pincode: 110034, serviceable: "Yes", tier: "1" },
  { pincode: 110035, serviceable: "Yes", tier: "1" },
  { pincode: 110036, serviceable: "Yes", tier: "1" },
  { pincode: 110037, serviceable: "Yes", tier: "1" },
  { pincode: 110038, serviceable: "Yes", tier: "1" },
  { pincode: 110039, serviceable: "Yes", tier: "1" },
  { pincode: 110040, serviceable: "Yes", tier: "1" },
  { pincode: 110041, serviceable: "Yes", tier: "1" },
  { pincode: 110042, serviceable: "Yes", tier: "1" },
  { pincode: 110043, serviceable: "Yes", tier: "1" },
  { pincode: 110044, serviceable: "Yes", tier: "1" },
  { pincode: 110045, serviceable: "Yes", tier: "1" },
  { pincode: 110046, serviceable: "Yes", tier: "1" },
  { pincode: 110047, serviceable: "Yes", tier: "1" },
  { pincode: 110048, serviceable: "Yes", tier: "1" },
  { pincode: 110049, serviceable: "Yes", tier: "1" },
  { pincode: 110050, serviceable: "Yes", tier: "1" },
  { pincode: 110051, serviceable: "Yes", tier: "1" },
  { pincode: 110052, serviceable: "Yes", tier: "1" },
  { pincode: 110053, serviceable: "Yes", tier: "1" },
  { pincode: 110054, serviceable: "Yes", tier: "1" },
  { pincode: 110055, serviceable: "Yes", tier: "1" },
  { pincode: 110056, serviceable: "Yes", tier: "1" },
  { pincode: 110057, serviceable: "Yes", tier: "1" },
  { pincode: 110058, serviceable: "Yes", tier: "1" },
  { pincode: 110059, serviceable: "Yes", tier: "1" },
  { pincode: 110060, serviceable: "Yes", tier: "1" },
  { pincode: 110061, serviceable: "Yes", tier: "1" },
  { pincode: 110062, serviceable: "Yes", tier: "1" },
  { pincode: 110063, serviceable: "Yes", tier: "1" },
  { pincode: 110064, serviceable: "Yes", tier: "1" },
  { pincode: 110065, serviceable: "Yes", tier: "1" },
  { pincode: 110066, serviceable: "Yes", tier: "1" },
  { pincode: 110067, serviceable: "Yes", tier: "1" },
  { pincode: 110068, serviceable: "Yes", tier: "1" },
  { pincode: 110069, serviceable: "Yes", tier: "1" },
  { pincode: 110070, serviceable: "Yes", tier: "1" },
  { pincode: 110071, serviceable: "Yes", tier: "1" },
  { pincode: 110072, serviceable: "Yes", tier: "1" },
  { pincode: 110073, serviceable: "Yes", tier: "1" },
  { pincode: 110074, serviceable: "Yes", tier: "1" },
  { pincode: 110075, serviceable: "Yes", tier: "1" },
  { pincode: 110076, serviceable: "Yes", tier: "1" },
  { pincode: 110077, serviceable: "Yes", tier: "1" },
  { pincode: 110078, serviceable: "Yes", tier: "1" },
  { pincode: 110080, serviceable: "Yes", tier: "1" },
  { pincode: 110081, serviceable: "Yes", tier: "1" },
  { pincode: 110082, serviceable: "Yes", tier: "1" },
  { pincode: 110083, serviceable: "Yes", tier: "1" },
  { pincode: 110084, serviceable: "Yes", tier: "1" },
  { pincode: 110085, serviceable: "Yes", tier: "1" },
  { pincode: 110086, serviceable: "Yes", tier: "1" },
  { pincode: 110087, serviceable: "Yes", tier: "1" },
  { pincode: 110088, serviceable: "Yes", tier: "1" },
  { pincode: 110089, serviceable: "Yes", tier: "1" },
  { pincode: 110090, serviceable: "Yes", tier: "1" },
  { pincode: 110091, serviceable: "Yes", tier: "1" },
  { pincode: 110092, serviceable: "Yes", tier: "1" },
  { pincode: 110093, serviceable: "Yes", tier: "1" },
  { pincode: 110094, serviceable: "Yes", tier: "1" },
  { pincode: 110095, serviceable: "Yes", tier: "1" },
  { pincode: 110096, serviceable: "Yes", tier: "1" },
  { pincode: 110097, serviceable: "Yes", tier: "1" },
  { pincode: 110098, serviceable: "Yes", tier: "1" },
  { pincode: 110100, serviceable: "Yes", tier: "1" },
  { pincode: 110101, serviceable: "Yes", tier: "1" },
  { pincode: 110103, serviceable: "Yes", tier: "1" },
  { pincode: 110104, serviceable: "Yes", tier: "1" },
  { pincode: 110105, serviceable: "Yes", tier: "1" },
  { pincode: 110106, serviceable: "Yes", tier: "1" },
  { pincode: 110107, serviceable: "Yes", tier: "1" },
  { pincode: 110108, serviceable: "Yes", tier: "1" },
  { pincode: 110109, serviceable: "Yes", tier: "1" },
  { pincode: 110110, serviceable: "Yes", tier: "1" },
  { pincode: 110112, serviceable: "Yes", tier: "1" },
  { pincode: 110113, serviceable: "Yes", tier: "1" },
  { pincode: 110114, serviceable: "Yes", tier: "1" },
  { pincode: 110115, serviceable: "Yes", tier: "1" },
  { pincode: 110116, serviceable: "Yes", tier: "1" },
  { pincode: 110117, serviceable: "Yes", tier: "1" },
  { pincode: 110118, serviceable: "Yes", tier: "1" },
  { pincode: 110119, serviceable: "Yes", tier: "1" },
  { pincode: 110120, serviceable: "Yes", tier: "1" },
  { pincode: 110122, serviceable: "Yes", tier: "1" },
  { pincode: 110124, serviceable: "Yes", tier: "1" },
  { pincode: 110125, serviceable: "Yes", tier: "1" },
  { pincode: 110301, serviceable: "Yes", tier: "1" },
  { pincode: 110302, serviceable: "Yes", tier: "1" },
  { pincode: 110501, serviceable: "Yes", tier: "1" },
  { pincode: 110502, serviceable: "Yes", tier: "1" },
  { pincode: 110503, serviceable: "Yes", tier: "1" },
  { pincode: 110504, serviceable: "Yes", tier: "1" },
  { pincode: 110505, serviceable: "Yes", tier: "1" },
  { pincode: 110510, serviceable: "Yes", tier: "1" },
  { pincode: 110511, serviceable: "Yes", tier: "1" },
  { pincode: 110512, serviceable: "Yes", tier: "1" },
  { pincode: 110601, serviceable: "Yes", tier: "1" },
  { pincode: 110602, serviceable: "Yes", tier: "1" },
  { pincode: 110603, serviceable: "Yes", tier: "1" },
  { pincode: 110604, serviceable: "Yes", tier: "1" },
  { pincode: 110605, serviceable: "Yes", tier: "1" },
  { pincode: 110606, serviceable: "Yes", tier: "1" },
  { pincode: 110607, serviceable: "Yes", tier: "1" },
  { pincode: 110608, serviceable: "Yes", tier: "1" },
  { pincode: 110609, serviceable: "Yes", tier: "1" },
  { pincode: 111105, serviceable: "Yes", tier: "1" },
  { pincode: 111111, serviceable: "Yes", tier: "1" },
  { pincode: 111112, serviceable: "Yes", tier: "1" },
  { pincode: 111113, serviceable: "Yes", tier: "1" },
  { pincode: 111114, serviceable: "Yes", tier: "1" },
  { pincode: 111115, serviceable: "Yes", tier: "1" },
  { pincode: 111116, serviceable: "Yes", tier: "1" },
  { pincode: 111117, serviceable: "Yes", tier: "1" },
  { pincode: 111118, serviceable: "Yes", tier: "1" },
  { pincode: 111119, serviceable: "Yes", tier: "2" },
  { pincode: 111122, serviceable: "Yes", tier: "2" },
  { pincode: 111123, serviceable: "Yes", tier: "1" },
  { pincode: 114145, serviceable: "Yes", tier: "3" },
  { pincode: 121000, serviceable: "Yes", tier: "1" },
  { pincode: 121001, serviceable: "Yes", tier: "1" },
  { pincode: 121002, serviceable: "Yes", tier: "1" },
  { pincode: 121003, serviceable: "Yes", tier: "1" },
  { pincode: 121004, serviceable: "Yes", tier: "1" },
  { pincode: 121005, serviceable: "Yes", tier: "1" },
  { pincode: 121006, serviceable: "Yes", tier: "1" },
  { pincode: 121007, serviceable: "Yes", tier: "1" },
  { pincode: 121008, serviceable: "Yes", tier: "1" },
  { pincode: 121009, serviceable: "Yes", tier: "1" },
  { pincode: 121010, serviceable: "Yes", tier: "1" },
  { pincode: 121012, serviceable: "Yes", tier: "1" },
  { pincode: 121013, serviceable: "Yes", tier: "1" },
  { pincode: 121014, serviceable: "Yes", tier: "1" },
  { pincode: 121015, serviceable: "Yes", tier: "1" },
  { pincode: 121101, serviceable: "Yes", tier: "1" },
  { pincode: 121102, serviceable: "Yes", tier: "1" },
  { pincode: 121103, serviceable: "Yes", tier: "1" },
  { pincode: 121105, serviceable: "Yes", tier: "1" },
  { pincode: 121106, serviceable: "Yes", tier: "1" },
  { pincode: 121107, serviceable: "Yes", tier: "1" },
  { pincode: 121206, serviceable: "Yes", tier: "1" },
  { pincode: 122001, serviceable: "Yes", tier: "1" },
  { pincode: 122002, serviceable: "Yes", tier: "1" },
  { pincode: 122003, serviceable: "Yes", tier: "1" },
  { pincode: 122004, serviceable: "Yes", tier: "1" },
  { pincode: 122005, serviceable: "Yes", tier: "1" },
  { pincode: 122006, serviceable: "Yes", tier: "1" },
  { pincode: 122007, serviceable: "Yes", tier: "1" },
  { pincode: 122008, serviceable: "Yes", tier: "1" },
  { pincode: 122009, serviceable: "Yes", tier: "1" },
  { pincode: 122010, serviceable: "Yes", tier: "1" },
  { pincode: 122011, serviceable: "Yes", tier: "1" },
  { pincode: 122012, serviceable: "Yes", tier: "1" },
  { pincode: 122015, serviceable: "Yes", tier: "1" },
  { pincode: 122016, serviceable: "Yes", tier: "1" },
  { pincode: 122017, serviceable: "Yes", tier: "1" },
  { pincode: 122018, serviceable: "Yes", tier: "1" },
  { pincode: 122019, serviceable: "Yes", tier: "1" },
  { pincode: 122050, serviceable: "Yes", tier: "1" },
  { pincode: 122051, serviceable: "Yes", tier: "1" },
  { pincode: 122052, serviceable: "Yes", tier: "1" },
  { pincode: 122098, serviceable: "Yes", tier: "1" },
  { pincode: 122100, serviceable: "Yes", tier: "1" },
  { pincode: 122101, serviceable: "Yes", tier: "1" },
  { pincode: 122102, serviceable: "Yes", tier: "1" },
  { pincode: 122103, serviceable: "Yes", tier: "1" },
  { pincode: 122104, serviceable: "Yes", tier: "1" },
  { pincode: 122105, serviceable: "Yes", tier: "1" },
  { pincode: 122106, serviceable: "Yes", tier: "1" },
  { pincode: 122107, serviceable: "Yes", tier: "1" },
  { pincode: 122222, serviceable: "Yes", tier: "1" },
  { pincode: 122413, serviceable: "Yes", tier: "1" },
  { pincode: 122414, serviceable: "Yes", tier: "1" },
  { pincode: 122502, serviceable: "Yes", tier: "1" },
  { pincode: 122503, serviceable: "Yes", tier: "1" },
  { pincode: 122504, serviceable: "Yes", tier: "1" },
  { pincode: 122505, serviceable: "Yes", tier: "1" },
  { pincode: 122506, serviceable: "Yes", tier: "1" },
  { pincode: 123001, serviceable: "Yes", tier: "1" },
  { pincode: 123003, serviceable: "Yes", tier: "1" },
  { pincode: 123021, serviceable: "Yes", tier: "2" },
  { pincode: 123023, serviceable: "Yes", tier: "2" },
  { pincode: 123024, serviceable: "Yes", tier: "2" },
  { pincode: 123027, serviceable: "Yes", tier: "2" },
  { pincode: 123028, serviceable: "Yes", tier: "2" },
  { pincode: 123029, serviceable: "Yes", tier: "2" },
  { pincode: 123034, serviceable: "Yes", tier: "2" },
  { pincode: 123035, serviceable: "Yes", tier: "1" },
  { pincode: 123101, serviceable: "Yes", tier: "1" },
  { pincode: 123102, serviceable: "Yes", tier: "1" },
  { pincode: 123103, serviceable: "Yes", tier: "1" },
  { pincode: 123106, serviceable: "Yes", tier: "1" },
  { pincode: 123110, serviceable: "Yes", tier: "1" },
  { pincode: 123301, serviceable: "Yes", tier: "1" },
  { pincode: 123303, serviceable: "Yes", tier: "2" },
  { pincode: 123401, serviceable: "Yes", tier: "1" },
  { pincode: 123411, serviceable: "Yes", tier: "2" },
  { pincode: 123412, serviceable: "Yes", tier: "1" },
  { pincode: 123413, serviceable: "Yes", tier: "2" },
  { pincode: 123414, serviceable: "Yes", tier: "1" },
  { pincode: 123501, serviceable: "Yes", tier: "1" },
  { pincode: 123504, serviceable: "Yes", tier: "1" },
  { pincode: 123505, serviceable: "Yes", tier: "1" },
  { pincode: 123506, serviceable: "Yes", tier: "1" },
  { pincode: 124001, serviceable: "Yes", tier: "1" },
  { pincode: 124010, serviceable: "Yes", tier: "1" },
  { pincode: 124021, serviceable: "Yes", tier: "1" },
  { pincode: 124102, serviceable: "Yes", tier: "1" },
  { pincode: 124103, serviceable: "Yes", tier: "1" },
  { pincode: 124104, serviceable: "Yes", tier: "1" },
  { pincode: 124105, serviceable: "Yes", tier: "1" },
  { pincode: 124106, serviceable: "Yes", tier: "1" },
  { pincode: 124107, serviceable: "Yes", tier: "1" },
  { pincode: 124108, serviceable: "Yes", tier: "1" },
  { pincode: 124109, serviceable: "Yes", tier: "1" },
  { pincode: 124111, serviceable: "Yes", tier: "2" },
  { pincode: 124112, serviceable: "Yes", tier: "2" },
  { pincode: 124146, serviceable: "Yes", tier: "1" },
  { pincode: 124201, serviceable: "Yes", tier: "1" },
  { pincode: 124303, serviceable: "Yes", tier: "1" },
  { pincode: 124401, serviceable: "Yes", tier: "1" },
  { pincode: 124412, serviceable: "Yes", tier: "1" },
  { pincode: 124501, serviceable: "Yes", tier: "1" },
  { pincode: 124505, serviceable: "Yes", tier: "1" },
  { pincode: 124506, serviceable: "Yes", tier: "1" },
  { pincode: 124507, serviceable: "Yes", tier: "1" },
  { pincode: 124508, serviceable: "Yes", tier: "1" },
  { pincode: 124512, serviceable: "Yes", tier: "1" },
  { pincode: 124514, serviceable: "Yes", tier: "1" },
  { pincode: 124517, serviceable: "Yes", tier: "1" },
  { pincode: 125001, serviceable: "Yes", tier: "2" },
  { pincode: 125002, serviceable: "Yes", tier: "2" },
  { pincode: 125003, serviceable: "Yes", tier: "2" },
  { pincode: 125004, serviceable: "Yes", tier: "2" },
  { pincode: 125005, serviceable: "Yes", tier: "2" },
  { pincode: 125006, serviceable: "Yes", tier: "2" },
  { pincode: 125007, serviceable: "Yes", tier: "2" },
  { pincode: 125011, serviceable: "Yes", tier: "2" },
  { pincode: 125033, serviceable: "Yes", tier: "2" },
  { pincode: 125034, serviceable: "Yes", tier: "2" },
  { pincode: 125039, serviceable: "Yes", tier: "2" },
  { pincode: 125042, serviceable: "Yes", tier: "2" },
  { pincode: 125044, serviceable: "Yes", tier: "2" },
  { pincode: 125047, serviceable: "Yes", tier: "2" },
  { pincode: 125048, serviceable: "Yes", tier: "2" },
  { pincode: 125049, serviceable: "Yes", tier: "2" },
  { pincode: 125050, serviceable: "Yes", tier: "2" },
  { pincode: 125051, serviceable: "Yes", tier: "3" },
  { pincode: 125052, serviceable: "Yes", tier: "2" },
  { pincode: 125055, serviceable: "Yes", tier: "2" },
  { pincode: 125058, serviceable: "Yes", tier: "2" },
  { pincode: 125060, serviceable: "Yes", tier: "2" },
  { pincode: 125075, serviceable: "Yes", tier: "3" },
  { pincode: 125076, serviceable: "Yes", tier: "3" },
  { pincode: 125077, serviceable: "Yes", tier: "3" },
  { pincode: 125101, serviceable: "Yes", tier: "3" },
  { pincode: 125102, serviceable: "Yes", tier: "3" },
  { pincode: 125103, serviceable: "Yes", tier: "3" },
  { pincode: 125104, serviceable: "Yes", tier: "3" },
  { pincode: 125111, serviceable: "Yes", tier: "2" },
  { pincode: 125112, serviceable: "Yes", tier: "2" },
  { pincode: 125113, serviceable: "Yes", tier: "2" },
  { pincode: 125120, serviceable: "Yes", tier: "3" },
  { pincode: 125121, serviceable: "Yes", tier: "2" },
  { pincode: 125122, serviceable: "Yes", tier: "2" },
  { pincode: 125133, serviceable: "Yes", tier: "3" },
  { pincode: 125201, serviceable: "Yes", tier: "3" },
  { pincode: 126001, serviceable: "Yes", tier: "3" },
  { pincode: 126101, serviceable: "Yes", tier: "2" },
  { pincode: 126102, serviceable: "Yes", tier: "2" },
  { pincode: 126110, serviceable: "Yes", tier: "2" },
  { pincode: 126111, serviceable: "Yes", tier: "2" },
  { pincode: 126112, serviceable: "Yes", tier: "3" },
  { pincode: 126113, serviceable: "Yes", tier: "2" },
  { pincode: 126114, serviceable: "Yes", tier: "2" },
  { pincode: 126115, serviceable: "Yes", tier: "2" },
  { pincode: 126116, serviceable: "Yes", tier: "2" },
  { pincode: 126125, serviceable: "Yes", tier: "2" },
  { pincode: 126126, serviceable: "Yes", tier: "2" },
  { pincode: 126127, serviceable: "Yes", tier: "2" },
  { pincode: 126128, serviceable: "Yes", tier: "2" },
  { pincode: 126152, serviceable: "Yes", tier: "2" },
  { pincode: 127020, serviceable: "Yes", tier: "2" },
  { pincode: 127021, serviceable: "Yes", tier: "2" },
  { pincode: 127022, serviceable: "Yes", tier: "2" },
  { pincode: 127025, serviceable: "Yes", tier: "2" },
  { pincode: 127026, serviceable: "Yes", tier: "2" },
  { pincode: 127027, serviceable: "Yes", tier: "2" },
  { pincode: 127031, serviceable: "Yes", tier: "2" },
  { pincode: 127032, serviceable: "Yes", tier: "2" },
  { pincode: 127040, serviceable: "Yes", tier: "2" },
  { pincode: 127041, serviceable: "Yes", tier: "2" },
  { pincode: 127043, serviceable: "Yes", tier: "2" },
  { pincode: 127045, serviceable: "Yes", tier: "3" },
  { pincode: 127046, serviceable: "Yes", tier: "3" },
  { pincode: 127111, serviceable: "Yes", tier: "2" },
  { pincode: 127201, serviceable: "Yes", tier: "2" },
  { pincode: 127306, serviceable: "Yes", tier: "2" },
  { pincode: 127308, serviceable: "Yes", tier: "2" },
  { pincode: 127309, serviceable: "Yes", tier: "2" },
  { pincode: 127310, serviceable: "Yes", tier: "2" },
  { pincode: 131001, serviceable: "Yes", tier: "1" },
  { pincode: 131021, serviceable: "Yes", tier: "1" },
  { pincode: 131027, serviceable: "Yes", tier: "1" },
  { pincode: 131028, serviceable: "Yes", tier: "2" },
  { pincode: 131029, serviceable: "Yes", tier: "2" },
  { pincode: 131030, serviceable: "Yes", tier: "2" },
  { pincode: 131039, serviceable: "Yes", tier: "2" },
  { pincode: 131101, serviceable: "Yes", tier: "2" },
  { pincode: 131102, serviceable: "Yes", tier: "2" },
  { pincode: 131103, serviceable: "Yes", tier: "2" },
  { pincode: 131301, serviceable: "Yes", tier: "2" },
  { pincode: 131305, serviceable: "Yes", tier: "2" },
  { pincode: 132001, serviceable: "Yes", tier: "1" },
  { pincode: 132022, serviceable: "Yes", tier: "1" },
  { pincode: 132037, serviceable: "Yes", tier: "1" },
  { pincode: 132039, serviceable: "Yes", tier: "3" },
  { pincode: 132046, serviceable: "Yes", tier: "3" },
  { pincode: 132054, serviceable: "Yes", tier: "1" },
  { pincode: 132101, serviceable: "Yes", tier: "3" },
  { pincode: 132102, serviceable: "Yes", tier: "3" },
  { pincode: 132103, serviceable: "Yes", tier: "2" },
  { pincode: 132104, serviceable: "Yes", tier: "2" },
  { pincode: 132105, serviceable: "Yes", tier: "2" },
  { pincode: 132106, serviceable: "Yes", tier: "2" },
  { pincode: 132107, serviceable: "Yes", tier: "2" },
  { pincode: 132108, serviceable: "Yes", tier: "2" },
  { pincode: 132110, serviceable: "Yes", tier: "2" },
  { pincode: 132113, serviceable: "Yes", tier: "3" },
  { pincode: 132114, serviceable: "Yes", tier: "1" },
  { pincode: 132115, serviceable: "Yes", tier: "3" },
  { pincode: 132116, serviceable: "Yes", tier: "5" },
  { pincode: 132117, serviceable: "Yes", tier: "5" },
  { pincode: 132122, serviceable: "Yes", tier: "3" },
  { pincode: 132132, serviceable: "Yes", tier: "2" },
  { pincode: 132140, serviceable: "Yes", tier: "3" },
  { pincode: 132145, serviceable: "Yes", tier: "2" },
  { pincode: 132151, serviceable: "Yes", tier: "2" },
  { pincode: 132157, serviceable: "Yes", tier: "2" },
  { pincode: 133001, serviceable: "Yes", tier: "2" },
  { pincode: 133003, serviceable: "Yes", tier: "2" },
  { pincode: 133004, serviceable: "Yes", tier: "2" },
  { pincode: 133005, serviceable: "Yes", tier: "2" },
  { pincode: 133006, serviceable: "Yes", tier: "2" },
  { pincode: 133007, serviceable: "Yes", tier: "2" },
  { pincode: 133008, serviceable: "Yes", tier: "2" },
  { pincode: 133010, serviceable: "Yes", tier: "2" },
  { pincode: 133021, serviceable: "Yes", tier: "2" },
  { pincode: 133101, serviceable: "Yes", tier: "2" },
  { pincode: 133102, serviceable: "Yes", tier: "2" },
  { pincode: 133103, serviceable: "Yes", tier: "2" },
  { pincode: 133104, serviceable: "Yes", tier: "2" },
  { pincode: 133201, serviceable: "Yes", tier: "2" },
  { pincode: 133202, serviceable: "Yes", tier: "2" },
  { pincode: 133203, serviceable: "Yes", tier: "2" },
  { pincode: 133204, serviceable: "Yes", tier: "2" },
  { pincode: 133205, serviceable: "Yes", tier: "2" },
  { pincode: 133206, serviceable: "Yes", tier: "2" },
  { pincode: 133207, serviceable: "Yes", tier: "2" },
  { pincode: 133301, serviceable: "Yes", tier: "2" },
  { pincode: 133302, serviceable: "Yes", tier: "2" },
  { pincode: 134001, serviceable: "Yes", tier: "2" },
  { pincode: 134002, serviceable: "Yes", tier: "2" },
  { pincode: 134003, serviceable: "Yes", tier: "2" },
  { pincode: 134004, serviceable: "Yes", tier: "2" },
  { pincode: 134005, serviceable: "Yes", tier: "2" },
  { pincode: 134006, serviceable: "Yes", tier: "2" },
  { pincode: 134007, serviceable: "Yes", tier: "2" },
  { pincode: 134008, serviceable: "Yes", tier: "2" },
  { pincode: 134101, serviceable: "Yes", tier: "2" },
  { pincode: 134102, serviceable: "Yes", tier: "2" },
  { pincode: 134103, serviceable: "Yes", tier: "2" },
  { pincode: 134104, serviceable: "Yes", tier: "2" },
  { pincode: 134105, serviceable: "Yes", tier: "2" },
  { pincode: 134107, serviceable: "Yes", tier: "2" },
  { pincode: 134108, serviceable: "Yes", tier: "2" },
  { pincode: 134109, serviceable: "Yes", tier: "2" },
  { pincode: 134112, serviceable: "Yes", tier: "2" },
  { pincode: 134113, serviceable: "Yes", tier: "2" },
  { pincode: 134114, serviceable: "Yes", tier: "2" },
  { pincode: 134115, serviceable: "Yes", tier: "2" },
  { pincode: 134116, serviceable: "Yes", tier: "2" },
  { pincode: 134117, serviceable: "Yes", tier: "2" },
  { pincode: 134118, serviceable: "Yes", tier: "2" },
  { pincode: 134201, serviceable: "Yes", tier: "2" },
  { pincode: 134202, serviceable: "Yes", tier: "2" },
  { pincode: 134203, serviceable: "Yes", tier: "2" },
  { pincode: 134204, serviceable: "Yes", tier: "2" },
  { pincode: 134205, serviceable: "Yes", tier: "2" },
  { pincode: 135001, serviceable: "Yes", tier: "2" },
  { pincode: 135002, serviceable: "Yes", tier: "2" },
  { pincode: 135003, serviceable: "Yes", tier: "2" },
  { pincode: 135004, serviceable: "Yes", tier: "2" },
  { pincode: 135021, serviceable: "Yes", tier: "2" },
  { pincode: 135101, serviceable: "Yes", tier: "2" },
  { pincode: 135102, serviceable: "Yes", tier: "2" },
  { pincode: 135103, serviceable: "Yes", tier: "2" },
  { pincode: 135106, serviceable: "Yes", tier: "2" },
  { pincode: 135133, serviceable: "Yes", tier: "2" },
  { pincode: 136020, serviceable: "Yes", tier: "2" },
  { pincode: 136021, serviceable: "Yes", tier: "2" },
  { pincode: 136026, serviceable: "Yes", tier: "2" },
  { pincode: 136027, serviceable: "Yes", tier: "2" },
  { pincode: 136030, serviceable: "Yes", tier: "2" },
  { pincode: 136033, serviceable: "Yes", tier: "2" },
  { pincode: 136034, serviceable: "Yes", tier: "2" },
  { pincode: 136035, serviceable: "Yes", tier: "2" },
  { pincode: 136038, serviceable: "Yes", tier: "2" },
  { pincode: 136042, serviceable: "Yes", tier: "2" },
  { pincode: 136043, serviceable: "Yes", tier: "2" },
  { pincode: 136044, serviceable: "Yes", tier: "2" },
  { pincode: 136118, serviceable: "Yes", tier: "2" },
  { pincode: 136119, serviceable: "Yes", tier: "2" },
  { pincode: 136128, serviceable: "Yes", tier: "2" },
  { pincode: 136129, serviceable: "Yes", tier: "2" },
  { pincode: 136130, serviceable: "Yes", tier: "2" },
  { pincode: 136131, serviceable: "Yes", tier: "2" },
  { pincode: 136132, serviceable: "Yes", tier: "2" },
  { pincode: 136135, serviceable: "Yes", tier: "2" },
  { pincode: 136136, serviceable: "Yes", tier: "2" },
  { pincode: 136156, serviceable: "Yes", tier: "2" },
  { pincode: 140001, serviceable: "Yes", tier: "2" },
  { pincode: 140101, serviceable: "Yes", tier: "2" },
  { pincode: 140102, serviceable: "Yes", tier: "3" },
  { pincode: 140103, serviceable: "Yes", tier: "2" },
  { pincode: 140105, serviceable: "Yes", tier: "2" },
  { pincode: 140108, serviceable: "Yes", tier: "2" },
  { pincode: 140109, serviceable: "Yes", tier: "2" },
  { pincode: 140110, serviceable: "Yes", tier: "2" },
  { pincode: 140111, serviceable: "Yes", tier: "3" },
  { pincode: 140112, serviceable: "Yes", tier: "3" },
  { pincode: 140113, serviceable: "Yes", tier: "2" },
  { pincode: 140114, serviceable: "Yes", tier: "2" },
  { pincode: 140115, serviceable: "Yes", tier: "2" },
  { pincode: 140116, serviceable: "Yes", tier: "2" },
  { pincode: 140117, serviceable: "Yes", tier: "2" },
  { pincode: 140118, serviceable: "Yes", tier: "2" },
  { pincode: 140119, serviceable: "Yes", tier: "2" },
  { pincode: 140123, serviceable: "Yes", tier: "2" },
  { pincode: 140124, serviceable: "Yes", tier: "2" },
  { pincode: 140125, serviceable: "Yes", tier: "2" },
  { pincode: 140126, serviceable: "Yes", tier: "2" },
  { pincode: 140133, serviceable: "Yes", tier: "2" },
  { pincode: 140201, serviceable: "Yes", tier: "2" },
  { pincode: 140301, serviceable: "Yes", tier: "2" },
  { pincode: 140306, serviceable: "Yes", tier: "2" },
  { pincode: 140307, serviceable: "Yes", tier: "2" },
  { pincode: 140308, serviceable: "Yes", tier: "2" },
  { pincode: 140401, serviceable: "Yes", tier: "2" },
  { pincode: 140402, serviceable: "Yes", tier: "2" },
  { pincode: 140406, serviceable: "Yes", tier: "2" },
  { pincode: 140407, serviceable: "Yes", tier: "2" },
  { pincode: 140408, serviceable: "Yes", tier: "2" },
  { pincode: 140412, serviceable: "Yes", tier: "2" },
  { pincode: 140413, serviceable: "Yes", tier: "2" },
  { pincode: 140417, serviceable: "Yes", tier: "2" },
  { pincode: 140501, serviceable: "Yes", tier: "2" },
  { pincode: 140506, serviceable: "Yes", tier: "2" },
  { pincode: 140507, serviceable: "Yes", tier: "2" },
  { pincode: 140601, serviceable: "Yes", tier: "2" },
  { pincode: 140602, serviceable: "Yes", tier: "2" },
  { pincode: 140603, serviceable: "Yes", tier: "2" },
  { pincode: 140604, serviceable: "Yes", tier: "2" },
  { pincode: 140701, serviceable: "Yes", tier: "2" },
  { pincode: 140802, serviceable: "Yes", tier: "2" },
  { pincode: 140901, serviceable: "Yes", tier: "2" },
  { pincode: 141001, serviceable: "Yes", tier: "2" },
  { pincode: 141002, serviceable: "Yes", tier: "2" },
  { pincode: 141003, serviceable: "Yes", tier: "2" },
  { pincode: 141004, serviceable: "Yes", tier: "2" },
  { pincode: 141005, serviceable: "Yes", tier: "2" },
  { pincode: 141006, serviceable: "Yes", tier: "2" },
  { pincode: 141007, serviceable: "Yes", tier: "2" },
  { pincode: 141008, serviceable: "Yes", tier: "2" },
  { pincode: 141009, serviceable: "Yes", tier: "2" },
  { pincode: 141010, serviceable: "Yes", tier: "2" },
  { pincode: 141011, serviceable: "Yes", tier: "2" },
  { pincode: 141012, serviceable: "Yes", tier: "2" },
  { pincode: 141013, serviceable: "Yes", tier: "2" },
  { pincode: 141014, serviceable: "Yes", tier: "2" },
  { pincode: 141015, serviceable: "Yes", tier: "2" },
  { pincode: 141016, serviceable: "Yes", tier: "2" },
  { pincode: 141017, serviceable: "Yes", tier: "2" },
  { pincode: 141020, serviceable: "Yes", tier: "2" },
  { pincode: 141101, serviceable: "Yes", tier: "2" },
  { pincode: 141104, serviceable: "Yes", tier: "2" },
  { pincode: 141106, serviceable: "Yes", tier: "2" },
  { pincode: 141110, serviceable: "Yes", tier: "2" },
  { pincode: 141113, serviceable: "Yes", tier: "2" },
  { pincode: 141114, serviceable: "Yes", tier: "3" },
  { pincode: 141115, serviceable: "Yes", tier: "3" },
  { pincode: 141116, serviceable: "Yes", tier: "2" },
  { pincode: 141117, serviceable: "Yes", tier: "2" },
  { pincode: 141119, serviceable: "Yes", tier: "3" },
  { pincode: 141120, serviceable: "Yes", tier: "2" },
  { pincode: 141121, serviceable: "Yes", tier: "3" },
  { pincode: 141122, serviceable: "Yes", tier: "2" },
  { pincode: 141123, serviceable: "Yes", tier: "2" },
  { pincode: 141304, serviceable: "Yes", tier: "2" },
  { pincode: 141309, serviceable: "Yes", tier: "2" },
  { pincode: 141310, serviceable: "Yes", tier: "3" },
  { pincode: 141401, serviceable: "Yes", tier: "2" },
  { pincode: 141402, serviceable: "Yes", tier: "2" },
  { pincode: 141411, serviceable: "Yes", tier: "2" },
  { pincode: 141415, serviceable: "Yes", tier: "3" },
  { pincode: 141416, serviceable: "Yes", tier: "2" },
  { pincode: 141421, serviceable: "Yes", tier: "2" },
  { pincode: 141422, serviceable: "Yes", tier: "2" },
  { pincode: 141801, serviceable: "Yes", tier: "3" },
  { pincode: 142001, serviceable: "Yes", tier: "3" },
  { pincode: 142003, serviceable: "Yes", tier: "3" },
  { pincode: 142021, serviceable: "Yes", tier: "2" },
  { pincode: 142022, serviceable: "Yes", tier: "2" },
  { pincode: 142026, serviceable: "Yes", tier: "3" },
  { pincode: 142027, serviceable: "Yes", tier: "2" },
  { pincode: 142037, serviceable: "Yes", tier: "3" },
  { pincode: 142038, serviceable: "Yes", tier: "3" },
  { pincode: 142039, serviceable: "Yes", tier: "3" },
  { pincode: 142042, serviceable: "Yes", tier: "3" },
  { pincode: 142043, serviceable: "Yes", tier: "3" },
  { pincode: 142044, serviceable: "Yes", tier: "3" },
  { pincode: 142045, serviceable: "Yes", tier: "3" },
  { pincode: 142047, serviceable: "Yes", tier: "3" },
  { pincode: 142048, serviceable: "Yes", tier: "3" },
  { pincode: 142049, serviceable: "Yes", tier: "3" },
  { pincode: 142050, serviceable: "Yes", tier: "3" },
  { pincode: 142052, serviceable: "Yes", tier: "3" },
  { pincode: 142053, serviceable: "Yes", tier: "3" },
  { pincode: 142055, serviceable: "Yes", tier: "3" },
  { pincode: 142057, serviceable: "Yes", tier: "3" },
  { pincode: 142058, serviceable: "Yes", tier: "3" },
  { pincode: 142060, serviceable: "Yes", tier: "3" },
  { pincode: 143001, serviceable: "Yes", tier: "2" },
  { pincode: 143002, serviceable: "Yes", tier: "2" },
  { pincode: 143003, serviceable: "Yes", tier: "2" },
  { pincode: 143004, serviceable: "Yes", tier: "2" },
  { pincode: 143005, serviceable: "Yes", tier: "2" },
  { pincode: 143006, serviceable: "Yes", tier: "2" },
  { pincode: 143008, serviceable: "Yes", tier: "2" },
  { pincode: 143010, serviceable: "Yes", tier: "2" },
  { pincode: 143021, serviceable: "Yes", tier: "2" },
  { pincode: 143022, serviceable: "Yes", tier: "2" },
  { pincode: 143101, serviceable: "Yes", tier: "2" },
  { pincode: 143102, serviceable: "Yes", tier: "5" },
  { pincode: 143104, serviceable: "Yes", tier: "2" },
  { pincode: 143105, serviceable: "Yes", tier: "2" },
  { pincode: 143106, serviceable: "Yes", tier: "2" },
  { pincode: 143107, serviceable: "Yes", tier: "2" },
  { pincode: 143112, serviceable: "Yes", tier: "3" },
  { pincode: 143115, serviceable: "Yes", tier: "2" },
  { pincode: 143201, serviceable: "Yes", tier: "3" },
  { pincode: 143202, serviceable: "Yes", tier: "3" },
  { pincode: 143204, serviceable: "Yes", tier: "3" },
  { pincode: 143301, serviceable: "Yes", tier: "3" },
  { pincode: 143303, serviceable: "Yes", tier: "3" },
  { pincode: 143305, serviceable: "Yes", tier: "3" },
  { pincode: 143401, serviceable: "Yes", tier: "3" },
  { pincode: 143412, serviceable: "Yes", tier: "3" },
  { pincode: 143416, serviceable: "Yes", tier: "3" },
  { pincode: 143419, serviceable: "Yes", tier: "3" },
  { pincode: 143501, serviceable: "Yes", tier: "2" },
  { pincode: 143505, serviceable: "Yes", tier: "3" },
  { pincode: 143516, serviceable: "Yes", tier: "3" },
  { pincode: 143521, serviceable: "Yes", tier: "3" },
  { pincode: 143531, serviceable: "Yes", tier: "3" },
  { pincode: 143601, serviceable: "Yes", tier: "5" },
  { pincode: 144001, serviceable: "Yes", tier: "2" },
  { pincode: 144002, serviceable: "Yes", tier: "2" },
  { pincode: 144003, serviceable: "Yes", tier: "2" },
  { pincode: 144004, serviceable: "Yes", tier: "2" },
  { pincode: 144005, serviceable: "Yes", tier: "2" },
  { pincode: 144006, serviceable: "Yes", tier: "2" },
  { pincode: 144007, serviceable: "Yes", tier: "2" },
  { pincode: 144008, serviceable: "Yes", tier: "2" },
  { pincode: 144009, serviceable: "Yes", tier: "2" },
  { pincode: 144010, serviceable: "Yes", tier: "2" },
  { pincode: 144011, serviceable: "Yes", tier: "2" },
  { pincode: 144012, serviceable: "Yes", tier: "2" },
  { pincode: 144013, serviceable: "Yes", tier: "2" },
  { pincode: 144014, serviceable: "Yes", tier: "2" },
  { pincode: 144015, serviceable: "Yes", tier: "2" },
  { pincode: 144021, serviceable: "Yes", tier: "2" },
  { pincode: 144022, serviceable: "Yes", tier: "2" },
  { pincode: 144023, serviceable: "Yes", tier: "2" },
  { pincode: 144027, serviceable: "Yes", tier: "2" },
  { pincode: 144032, serviceable: "Yes", tier: "2" },
  { pincode: 144033, serviceable: "Yes", tier: "3" },
  { pincode: 144039, serviceable: "Yes", tier: "3" },
  { pincode: 144040, serviceable: "Yes", tier: "3" },
  { pincode: 144041, serviceable: "Yes", tier: "3" },
  { pincode: 144102, serviceable: "Yes", tier: "2" },
  { pincode: 144201, serviceable: "Yes", tier: "3" },
  { pincode: 144203, serviceable: "Yes", tier: "3" },
  { pincode: 144204, serviceable: "Yes", tier: "3" },
  { pincode: 144205, serviceable: "Yes", tier: "3" },
  { pincode: 144207, serviceable: "Yes", tier: "3" },
  { pincode: 144211, serviceable: "Yes", tier: "3" },
  { pincode: 144216, serviceable: "Yes", tier: "3" },
  { pincode: 144401, serviceable: "Yes", tier: "2" },
  { pincode: 144402, serviceable: "Yes", tier: "2" },
  { pincode: 144403, serviceable: "Yes", tier: "2" },
  { pincode: 144405, serviceable: "Yes", tier: "2" },
  { pincode: 144407, serviceable: "Yes", tier: "2" },
  { pincode: 144408, serviceable: "Yes", tier: "2" },
  { pincode: 144409, serviceable: "Yes", tier: "3" },
  { pincode: 144410, serviceable: "Yes", tier: "3" },
  { pincode: 144411, serviceable: "Yes", tier: "2" },
  { pincode: 144415, serviceable: "Yes", tier: "3" },
  { pincode: 144416, serviceable: "Yes", tier: "3" },
  { pincode: 144417, serviceable: "Yes", tier: "3" },
  { pincode: 144421, serviceable: "Yes", tier: "3" },
  { pincode: 144422, serviceable: "Yes", tier: "3" },
  { pincode: 144501, serviceable: "Yes", tier: "2" },
  { pincode: 144502, serviceable: "Yes", tier: "2" },
  { pincode: 144503, serviceable: "Yes", tier: "2" },
  { pincode: 144504, serviceable: "Yes", tier: "2" },
  { pincode: 144505, serviceable: "Yes", tier: "3" },
  { pincode: 144506, serviceable: "Yes", tier: "3" },
  { pincode: 144507, serviceable: "Yes", tier: "3" },
  { pincode: 144508, serviceable: "Yes", tier: "3" },
  { pincode: 144509, serviceable: "Yes", tier: "3" },
  { pincode: 144510, serviceable: "Yes", tier: "3" },
  { pincode: 144511, serviceable: "Yes", tier: "3" },
  { pincode: 144512, serviceable: "Yes", tier: "3" },
  { pincode: 144513, serviceable: "Yes", tier: "3" },
  { pincode: 144514, serviceable: "Yes", tier: "3" },
  { pincode: 144515, serviceable: "Yes", tier: "3" },
  { pincode: 144516, serviceable: "Yes", tier: "3" },
  { pincode: 144517, serviceable: "Yes", tier: "3" },
  { pincode: 144518, serviceable: "Yes", tier: "3" },
  { pincode: 144521, serviceable: "Yes", tier: "3" },
  { pincode: 144523, serviceable: "Yes", tier: "3" },
  { pincode: 144524, serviceable: "Yes", tier: "3" },
  { pincode: 144525, serviceable: "Yes", tier: "3" },
  { pincode: 144526, serviceable: "Yes", tier: "3" },
  { pincode: 144527, serviceable: "Yes", tier: "3" },
  { pincode: 144528, serviceable: "Yes", tier: "3" },
  { pincode: 144532, serviceable: "Yes", tier: "3" },
  { pincode: 144533, serviceable: "Yes", tier: "2" },
  { pincode: 144601, serviceable: "Yes", tier: "3" },
  { pincode: 144602, serviceable: "Yes", tier: "3" },
  { pincode: 144621, serviceable: "Yes", tier: "2" },
  { pincode: 144624, serviceable: "Yes", tier: "2" },
  { pincode: 144626, serviceable: "Yes", tier: "3" },
  { pincode: 144632, serviceable: "Yes", tier: "2" },
  { pincode: 144633, serviceable: "Yes", tier: "2" },
  { pincode: 144801, serviceable: "Yes", tier: "2" },
  { pincode: 144802, serviceable: "Yes", tier: "3" },
  { pincode: 145001, serviceable: "Yes", tier: "3" },
  { pincode: 145023, serviceable: "Yes", tier: "3" },
  { pincode: 146001, serviceable: "Yes", tier: "2" },
  { pincode: 146021, serviceable: "Yes", tier: "2" },
  { pincode: 146022, serviceable: "Yes", tier: "2" },
  { pincode: 146023, serviceable: "Yes", tier: "2" },
  { pincode: 146024, serviceable: "Yes", tier: "2" },
  { pincode: 146105, serviceable: "Yes", tier: "2" },
  { pincode: 146111, serviceable: "Yes", tier: "2" },
  { pincode: 147001, serviceable: "Yes", tier: "2" },
  { pincode: 147002, serviceable: "Yes", tier: "2" },
  { pincode: 147003, serviceable: "Yes", tier: "2" },
  { pincode: 147004, serviceable: "Yes", tier: "2" },
  { pincode: 147005, serviceable: "Yes", tier: "2" },
  { pincode: 147021, serviceable: "Yes", tier: "2" },
  { pincode: 147101, serviceable: "Yes", tier: "3" },
  { pincode: 147102, serviceable: "Yes", tier: "2" },
  { pincode: 147103, serviceable: "Yes", tier: "2" },
  { pincode: 147105, serviceable: "Yes", tier: "3" },
  { pincode: 147111, serviceable: "Yes", tier: "2" },
  { pincode: 147201, serviceable: "Yes", tier: "2" },
  { pincode: 147202, serviceable: "Yes", tier: "2" },
  { pincode: 147203, serviceable: "Yes", tier: "2" },
  { pincode: 147301, serviceable: "Yes", tier: "2" },
  { pincode: 148001, serviceable: "Yes", tier: "2" },
  { pincode: 148002, serviceable: "Yes", tier: "2" },
  { pincode: 148017, serviceable: "Yes", tier: "2" },
  { pincode: 148019, serviceable: "Yes", tier: "3" },
  { pincode: 148020, serviceable: "Yes", tier: "3" },
  { pincode: 148021, serviceable: "Yes", tier: "3" },
  { pincode: 148022, serviceable: "Yes", tier: "3" },
  { pincode: 148023, serviceable: "Yes", tier: "3" },
  { pincode: 148024, serviceable: "Yes", tier: "2" },
  { pincode: 148025, serviceable: "Yes", tier: "2" },
  { pincode: 148026, serviceable: "Yes", tier: "2" },
  { pincode: 148028, serviceable: "Yes", tier: "5" },
  { pincode: 148029, serviceable: "Yes", tier: "2" },
  { pincode: 148031, serviceable: "Yes", tier: "2" },
  { pincode: 148033, serviceable: "Yes", tier: "3" },
  { pincode: 148034, serviceable: "Yes", tier: "2" },
  { pincode: 148035, serviceable: "Yes", tier: "2" },
  { pincode: 148100, serviceable: "Yes", tier: "2" },
  { pincode: 148101, serviceable: "Yes", tier: "2" },
  { pincode: 148102, serviceable: "Yes", tier: "2" },
  { pincode: 148103, serviceable: "Yes", tier: "2" },
  { pincode: 148104, serviceable: "Yes", tier: "2" },
  { pincode: 148105, serviceable: "Yes", tier: "2" },
  { pincode: 148106, serviceable: "Yes", tier: "2" },
  { pincode: 148107, serviceable: "Yes", tier: "2" },
  { pincode: 148108, serviceable: "Yes", tier: "5" },
  { pincode: 148109, serviceable: "Yes", tier: "5" },
  { pincode: 151001, serviceable: "Yes", tier: "2" },
  { pincode: 151002, serviceable: "Yes", tier: "2" },
  { pincode: 151003, serviceable: "Yes", tier: "2" },
  { pincode: 151004, serviceable: "Yes", tier: "2" },
  { pincode: 151005, serviceable: "Yes", tier: "2" },
  { pincode: 151101, serviceable: "Yes", tier: "2" },
  { pincode: 151102, serviceable: "Yes", tier: "2" },
  { pincode: 151103, serviceable: "Yes", tier: "5" },
  { pincode: 151104, serviceable: "Yes", tier: "5" },
  { pincode: 151105, serviceable: "Yes", tier: "5" },
  { pincode: 151106, serviceable: "Yes", tier: "5" },
  { pincode: 151108, serviceable: "Yes", tier: "5" },
  { pincode: 151111, serviceable: "Yes", tier: "5" },
  { pincode: 151201, serviceable: "Yes", tier: "2" },
  { pincode: 151202, serviceable: "Yes", tier: "3" },
  { pincode: 151203, serviceable: "Yes", tier: "3" },
  { pincode: 151204, serviceable: "Yes", tier: "3" },
  { pincode: 151205, serviceable: "Yes", tier: "3" },
  { pincode: 151206, serviceable: "Yes", tier: "3" },
  { pincode: 151207, serviceable: "Yes", tier: "3" },
  { pincode: 151208, serviceable: "Yes", tier: "3" },
  { pincode: 151209, serviceable: "Yes", tier: "3" },
  { pincode: 151210, serviceable: "Yes", tier: "3" },
  { pincode: 151212, serviceable: "Yes", tier: "3" },
  { pincode: 151301, serviceable: "Yes", tier: "3" },
  { pincode: 151302, serviceable: "Yes", tier: "3" },
  { pincode: 151401, serviceable: "Yes", tier: "2" },
  { pincode: 151501, serviceable: "Yes", tier: "3" },
  { pincode: 151502, serviceable: "Yes", tier: "3" },
  { pincode: 151503, serviceable: "Yes", tier: "3" },
  { pincode: 151504, serviceable: "Yes", tier: "3" },
  { pincode: 151505, serviceable: "Yes", tier: "3" },
  { pincode: 151507, serviceable: "Yes", tier: "3" },
  { pincode: 151508, serviceable: "Yes", tier: "3" },
  { pincode: 151509, serviceable: "Yes", tier: "3" },
  { pincode: 151510, serviceable: "Yes", tier: "2" },
  { pincode: 152001, serviceable: "Yes", tier: "3" },
  { pincode: 152002, serviceable: "Yes", tier: "3" },
  { pincode: 152003, serviceable: "Yes", tier: "3" },
  { pincode: 152004, serviceable: "Yes", tier: "3" },
  { pincode: 152005, serviceable: "Yes", tier: "3" },
  { pincode: 152020, serviceable: "Yes", tier: "3" },
  { pincode: 152021, serviceable: "Yes", tier: "3" },
  { pincode: 152022, serviceable: "Yes", tier: "3" },
  { pincode: 152023, serviceable: "Yes", tier: "3" },
  { pincode: 152024, serviceable: "Yes", tier: "3" },
  { pincode: 152025, serviceable: "Yes", tier: "3" },
  { pincode: 152026, serviceable: "Yes", tier: "3" },
  { pincode: 152031, serviceable: "Yes", tier: "3" },
  { pincode: 152032, serviceable: "Yes", tier: "3" },
  { pincode: 152033, serviceable: "Yes", tier: "3" },
  { pincode: 152101, serviceable: "Yes", tier: "3" },
  { pincode: 152107, serviceable: "Yes", tier: "3" },
  { pincode: 152112, serviceable: "Yes", tier: "3" },
  { pincode: 152113, serviceable: "Yes", tier: "3" },
  { pincode: 152114, serviceable: "Yes", tier: "3" },
  { pincode: 152115, serviceable: "Yes", tier: "3" },
  { pincode: 152116, serviceable: "Yes", tier: "3" },
  { pincode: 152117, serviceable: "Yes", tier: "3" },
  { pincode: 152118, serviceable: "Yes", tier: "3" },
  { pincode: 152121, serviceable: "Yes", tier: "3" },
  { pincode: 152122, serviceable: "Yes", tier: "3" },
  { pincode: 152123, serviceable: "Yes", tier: "3" },
  { pincode: 152124, serviceable: "Yes", tier: "3" },
  { pincode: 152128, serviceable: "Yes", tier: "3" },
  { pincode: 152132, serviceable: "Yes", tier: "3" },
  { pincode: 160001, serviceable: "Yes", tier: "2" },
  { pincode: 160002, serviceable: "Yes", tier: "2" },
  { pincode: 160003, serviceable: "Yes", tier: "2" },
  { pincode: 160004, serviceable: "Yes", tier: "2" },
  { pincode: 160005, serviceable: "Yes", tier: "2" },
  { pincode: 160006, serviceable: "Yes", tier: "2" },
  { pincode: 160007, serviceable: "Yes", tier: "2" },
  { pincode: 160008, serviceable: "Yes", tier: "2" },
  { pincode: 160009, serviceable: "Yes", tier: "2" },
  { pincode: 160010, serviceable: "Yes", tier: "2" },
  { pincode: 160011, serviceable: "Yes", tier: "2" },
  { pincode: 160012, serviceable: "Yes", tier: "2" },
  { pincode: 160013, serviceable: "Yes", tier: "2" },
  { pincode: 160014, serviceable: "Yes", tier: "2" },
  { pincode: 160015, serviceable: "Yes", tier: "2" },
  { pincode: 160016, serviceable: "Yes", tier: "2" },
  { pincode: 160017, serviceable: "Yes", tier: "2" },
  { pincode: 160018, serviceable: "Yes", tier: "2" },
  { pincode: 160019, serviceable: "Yes", tier: "2" },
  { pincode: 160020, serviceable: "Yes", tier: "2" },
  { pincode: 160021, serviceable: "Yes", tier: "2" },
  { pincode: 160022, serviceable: "Yes", tier: "2" },
  { pincode: 160023, serviceable: "Yes", tier: "2" },
  { pincode: 160024, serviceable: "Yes", tier: "2" },
  { pincode: 160025, serviceable: "Yes", tier: "2" },
  { pincode: 160026, serviceable: "Yes", tier: "2" },
  { pincode: 160027, serviceable: "Yes", tier: "2" },
  { pincode: 160028, serviceable: "Yes", tier: "2" },
  { pincode: 160029, serviceable: "Yes", tier: "2" },
  { pincode: 160030, serviceable: "Yes", tier: "2" },
  { pincode: 160031, serviceable: "Yes", tier: "2" },
  { pincode: 160032, serviceable: "Yes", tier: "2" },
  { pincode: 160033, serviceable: "Yes", tier: "2" },
  { pincode: 160034, serviceable: "Yes", tier: "2" },
  { pincode: 160035, serviceable: "Yes", tier: "2" },
  { pincode: 160036, serviceable: "Yes", tier: "2" },
  { pincode: 160037, serviceable: "Yes", tier: "2" },
  { pincode: 160038, serviceable: "Yes", tier: "2" },
  { pincode: 160039, serviceable: "Yes", tier: "2" },
  { pincode: 160040, serviceable: "Yes", tier: "2" },
  { pincode: 160041, serviceable: "Yes", tier: "2" },
  { pincode: 160042, serviceable: "Yes", tier: "2" },
  { pincode: 160043, serviceable: "Yes", tier: "2" },
  { pincode: 160044, serviceable: "Yes", tier: "2" },
  { pincode: 160045, serviceable: "Yes", tier: "2" },
  { pincode: 160046, serviceable: "Yes", tier: "2" },
  { pincode: 160047, serviceable: "Yes", tier: "2" },
  { pincode: 160048, serviceable: "Yes", tier: "2" },
  { pincode: 160049, serviceable: "Yes", tier: "2" },
  { pincode: 160051, serviceable: "Yes", tier: "2" },
  { pincode: 160052, serviceable: "Yes", tier: "2" },
  { pincode: 160053, serviceable: "Yes", tier: "2" },
  { pincode: 160054, serviceable: "Yes", tier: "2" },
  { pincode: 160055, serviceable: "Yes", tier: "2" },
  { pincode: 160056, serviceable: "Yes", tier: "2" },
  { pincode: 160057, serviceable: "Yes", tier: "2" },
  { pincode: 160058, serviceable: "Yes", tier: "2" },
  { pincode: 160059, serviceable: "Yes", tier: "2" },
  { pincode: 160061, serviceable: "Yes", tier: "2" },
  { pincode: 160062, serviceable: "Yes", tier: "2" },
  { pincode: 160071, serviceable: "Yes", tier: "2" },
  { pincode: 160101, serviceable: "Yes", tier: "2" },
  { pincode: 160102, serviceable: "Yes", tier: "2" },
  { pincode: 160103, serviceable: "Yes", tier: "2" },
  { pincode: 160104, serviceable: "Yes", tier: "2" },
  { pincode: 160106, serviceable: "Yes", tier: "2" },
  { pincode: 171001, serviceable: "Yes", tier: "2" },
  { pincode: 171002, serviceable: "Yes", tier: "2" },
  { pincode: 171003, serviceable: "Yes", tier: "2" },
  { pincode: 171004, serviceable: "Yes", tier: "2" },
  { pincode: 171005, serviceable: "Yes", tier: "2" },
  { pincode: 171006, serviceable: "Yes", tier: "2" },
  { pincode: 171008, serviceable: "Yes", tier: "2" },
  { pincode: 171009, serviceable: "Yes", tier: "2" },
  { pincode: 171010, serviceable: "Yes", tier: "2" },
  { pincode: 171011, serviceable: "Yes", tier: "2" },
  { pincode: 171013, serviceable: "Yes", tier: "2" },
  { pincode: 171014, serviceable: "Yes", tier: "2" },
  { pincode: 171015, serviceable: "Yes", tier: "2" },
  { pincode: 171102, serviceable: "Yes", tier: "3" },
  { pincode: 171201, serviceable: "Yes", tier: "3" },
  { pincode: 171209, serviceable: "Yes", tier: "3" },
  { pincode: 171212, serviceable: "Yes", tier: "3" },
  { pincode: 171213, serviceable: "Yes", tier: "3" },
  { pincode: 171220, serviceable: "Yes", tier: "3" },
  { pincode: 171222, serviceable: "Yes", tier: "3" },
  { pincode: 171226, serviceable: "Yes", tier: "3" },
  { pincode: 172001, serviceable: "Yes", tier: "3" },
  { pincode: 172024, serviceable: "Yes", tier: "3" },
  { pincode: 172027, serviceable: "Yes", tier: "3" },
  { pincode: 172029, serviceable: "Yes", tier: "3" },
  { pincode: 172030, serviceable: "Yes", tier: "3" },
  { pincode: 172031, serviceable: "Yes", tier: "3" },
  { pincode: 172105, serviceable: "Yes", tier: "5" },
  { pincode: 172107, serviceable: "Yes", tier: "5" },
  { pincode: 172108, serviceable: "Yes", tier: "5" },
  { pincode: 172116, serviceable: "Yes", tier: "5" },
  { pincode: 172201, serviceable: "Yes", tier: "3" },
  { pincode: 173001, serviceable: "Yes", tier: "2" },
  { pincode: 173021, serviceable: "Yes", tier: "2" },
  { pincode: 173025, serviceable: "Yes", tier: "2" },
  { pincode: 173026, serviceable: "Yes", tier: "2" },
  { pincode: 173029, serviceable: "Yes", tier: "2" },
  { pincode: 173030, serviceable: "Yes", tier: "2" },
  { pincode: 173031, serviceable: "Yes", tier: "2" },
  { pincode: 173101, serviceable: "Yes", tier: "2" },
  { pincode: 173201, serviceable: "Yes", tier: "2" },
  { pincode: 173202, serviceable: "Yes", tier: "2" },
  { pincode: 173204, serviceable: "Yes", tier: "2" },
  { pincode: 173205, serviceable: "Yes", tier: "2" },
  { pincode: 173206, serviceable: "Yes", tier: "2" },
  { pincode: 173207, serviceable: "Yes", tier: "3" },
  { pincode: 173208, serviceable: "Yes", tier: "3" },
  { pincode: 173209, serviceable: "Yes", tier: "2" },
  { pincode: 173210, serviceable: "Yes", tier: "2" },
  { pincode: 173211, serviceable: "Yes", tier: "2" },
  { pincode: 173212, serviceable: "Yes", tier: "2" },
  { pincode: 173213, serviceable: "Yes", tier: "2" },
  { pincode: 173214, serviceable: "Yes", tier: "2" },
  { pincode: 173220, serviceable: "Yes", tier: "2" },
  { pincode: 173222, serviceable: "Yes", tier: "3" },
  { pincode: 173223, serviceable: "Yes", tier: "2" },
  { pincode: 173229, serviceable: "Yes", tier: "2" },
  { pincode: 173230, serviceable: "Yes", tier: "2" },
  { pincode: 173235, serviceable: "Yes", tier: "3" },
  { pincode: 174001, serviceable: "Yes", tier: "2" },
  { pincode: 174002, serviceable: "Yes", tier: "2" },
  { pincode: 174004, serviceable: "Yes", tier: "2" },
  { pincode: 174005, serviceable: "Yes", tier: "2" },
  { pincode: 174011, serviceable: "Yes", tier: "2" },
  { pincode: 174012, serviceable: "Yes", tier: "2" },
  { pincode: 174013, serviceable: "Yes", tier: "2" },
  { pincode: 174015, serviceable: "Yes", tier: "2" },
  { pincode: 174021, serviceable: "Yes", tier: "2" },
  { pincode: 174023, serviceable: "Yes", tier: "2" },
  { pincode: 174024, serviceable: "Yes", tier: "2" },
  { pincode: 174026, serviceable: "Yes", tier: "2" },
  { pincode: 174027, serviceable: "Yes", tier: "2" },
  { pincode: 174028, serviceable: "Yes", tier: "2" },
  { pincode: 174029, serviceable: "Yes", tier: "2" },
  { pincode: 174030, serviceable: "Yes", tier: "2" },
  { pincode: 174031, serviceable: "Yes", tier: "2" },
  { pincode: 174032, serviceable: "Yes", tier: "2" },
  { pincode: 174033, serviceable: "Yes", tier: "2" },
  { pincode: 174034, serviceable: "Yes", tier: "2" },
  { pincode: 174036, serviceable: "Yes", tier: "2" },
  { pincode: 174101, serviceable: "Yes", tier: "2" },
  { pincode: 174103, serviceable: "Yes", tier: "2" },
  { pincode: 174201, serviceable: "Yes", tier: "2" },
  { pincode: 174301, serviceable: "Yes", tier: "2" },
  { pincode: 174302, serviceable: "Yes", tier: "3" },
  { pincode: 174303, serviceable: "Yes", tier: "2" },
  { pincode: 174304, serviceable: "Yes", tier: "3" },
  { pincode: 174305, serviceable: "Yes", tier: "3" },
  { pincode: 174306, serviceable: "Yes", tier: "2" },
  { pincode: 174307, serviceable: "Yes", tier: "3" },
  { pincode: 174308, serviceable: "Yes", tier: "3" },
  { pincode: 174310, serviceable: "Yes", tier: "2" },
  { pincode: 174314, serviceable: "Yes", tier: "3" },
  { pincode: 174315, serviceable: "Yes", tier: "2" },
  { pincode: 174317, serviceable: "Yes", tier: "2" },
  { pincode: 174319, serviceable: "Yes", tier: "3" },
  { pincode: 174507, serviceable: "Yes", tier: "2" },
  { pincode: 175001, serviceable: "Yes", tier: "3" },
  { pincode: 175002, serviceable: "Yes", tier: "3" },
  { pincode: 175003, serviceable: "Yes", tier: "3" },
  { pincode: 175004, serviceable: "Yes", tier: "3" },
  { pincode: 175005, serviceable: "Yes", tier: "3" },
  { pincode: 175006, serviceable: "Yes", tier: "3" },
  { pincode: 175008, serviceable: "Yes", tier: "3" },
  { pincode: 175010, serviceable: "Yes", tier: "3" },
  { pincode: 175011, serviceable: "Yes", tier: "3" },
  { pincode: 175012, serviceable: "Yes", tier: "3" },
  { pincode: 175015, serviceable: "Yes", tier: "3" },
  { pincode: 175017, serviceable: "Yes", tier: "2" },
  { pincode: 175018, serviceable: "Yes", tier: "3" },
  { pincode: 175019, serviceable: "Yes", tier: "3" },
  { pincode: 175021, serviceable: "Yes", tier: "3" },
  { pincode: 175023, serviceable: "Yes", tier: "3" },
  { pincode: 175024, serviceable: "Yes", tier: "3" },
  { pincode: 175025, serviceable: "Yes", tier: "3" },
  { pincode: 175026, serviceable: "Yes", tier: "3" },
  { pincode: 175027, serviceable: "Yes", tier: "3" },
  { pincode: 175028, serviceable: "Yes", tier: "3" },
  { pincode: 175029, serviceable: "Yes", tier: "3" },
  { pincode: 175030, serviceable: "Yes", tier: "2" },
  { pincode: 175032, serviceable: "Yes", tier: "3" },
  { pincode: 175033, serviceable: "Yes", tier: "3" },
  { pincode: 175034, serviceable: "Yes", tier: "3" },
  { pincode: 175036, serviceable: "Yes", tier: "3" },
  { pincode: 175039, serviceable: "Yes", tier: "3" },
  { pincode: 175040, serviceable: "Yes", tier: "3" },
  { pincode: 175042, serviceable: "Yes", tier: "3" },
  { pincode: 175045, serviceable: "Yes", tier: "3" },
  { pincode: 175046, serviceable: "Yes", tier: "3" },
  { pincode: 175049, serviceable: "Yes", tier: "3" },
  { pincode: 175101, serviceable: "Yes", tier: "3" },
  { pincode: 175103, serviceable: "Yes", tier: "3" },
  { pincode: 175104, serviceable: "Yes", tier: "3" },
  { pincode: 175121, serviceable: "Yes", tier: "3" },
  { pincode: 175125, serviceable: "Yes", tier: "3" },
  { pincode: 175126, serviceable: "Yes", tier: "3" },
  { pincode: 175128, serviceable: "Yes", tier: "3" },
  { pincode: 175129, serviceable: "Yes", tier: "3" },
  { pincode: 175130, serviceable: "Yes", tier: "3" },
  { pincode: 175131, serviceable: "Yes", tier: "3" },
  { pincode: 175136, serviceable: "Yes", tier: "3" },
  { pincode: 175138, serviceable: "Yes", tier: "3" },
  { pincode: 175143, serviceable: "Yes", tier: "3" },
  { pincode: 176001, serviceable: "Yes", tier: "3" },
  { pincode: 176002, serviceable: "Yes", tier: "3" },
  { pincode: 176022, serviceable: "Yes", tier: "6" },
  { pincode: 176023, serviceable: "Yes", tier: "6" },
  { pincode: 176026, serviceable: "Yes", tier: "3" },
  { pincode: 176028, serviceable: "Yes", tier: "3" },
  { pincode: 176029, serviceable: "Yes", tier: "3" },
  { pincode: 176031, serviceable: "Yes", tier: "3" },
  { pincode: 176036, serviceable: "Yes", tier: "3" },
  { pincode: 176037, serviceable: "Yes", tier: "3" },
  { pincode: 176038, serviceable: "Yes", tier: "3" },
  { pincode: 176041, serviceable: "Yes", tier: "3" },
  { pincode: 176042, serviceable: "Yes", tier: "2" },
  { pincode: 176043, serviceable: "Yes", tier: "2" },
  { pincode: 176045, serviceable: "Yes", tier: "3" },
  { pincode: 176047, serviceable: "Yes", tier: "3" },
  { pincode: 176048, serviceable: "Yes", tier: "3" },
  { pincode: 176051, serviceable: "Yes", tier: "6" },
  { pincode: 176052, serviceable: "Yes", tier: "3" },
  { pincode: 176053, serviceable: "Yes", tier: "6" },
  { pincode: 176054, serviceable: "Yes", tier: "3" },
  { pincode: 176056, serviceable: "Yes", tier: "3" },
  { pincode: 176057, serviceable: "Yes", tier: "3" },
  { pincode: 176059, serviceable: "Yes", tier: "3" },
  { pincode: 176060, serviceable: "Yes", tier: "3" },
  { pincode: 176061, serviceable: "Yes", tier: "3" },
  { pincode: 176062, serviceable: "Yes", tier: "3" },
  { pincode: 176063, serviceable: "Yes", tier: "3" },
  { pincode: 176064, serviceable: "Yes", tier: "3" },
  { pincode: 176066, serviceable: "Yes", tier: "3" },
  { pincode: 176073, serviceable: "Yes", tier: "3" },
  { pincode: 176075, serviceable: "Yes", tier: "3" },
  { pincode: 176076, serviceable: "Yes", tier: "3" },
  { pincode: 176077, serviceable: "Yes", tier: "3" },
  { pincode: 176081, serviceable: "Yes", tier: "3" },
  { pincode: 176082, serviceable: "Yes", tier: "3" },
  { pincode: 176083, serviceable: "Yes", tier: "3" },
  { pincode: 176084, serviceable: "Yes", tier: "3" },
  { pincode: 176085, serviceable: "Yes", tier: "3" },
  { pincode: 176086, serviceable: "Yes", tier: "3" },
  { pincode: 176087, serviceable: "Yes", tier: "3" },
  { pincode: 176088, serviceable: "Yes", tier: "3" },
  { pincode: 176090, serviceable: "Yes", tier: "3" },
  { pincode: 176091, serviceable: "Yes", tier: "3" },
  { pincode: 176092, serviceable: "Yes", tier: "3" },
  { pincode: 176093, serviceable: "Yes", tier: "3" },
  { pincode: 176095, serviceable: "Yes", tier: "3" },
  { pincode: 176096, serviceable: "Yes", tier: "3" },
  { pincode: 176097, serviceable: "Yes", tier: "3" },
  { pincode: 176098, serviceable: "Yes", tier: "3" },
  { pincode: 176101, serviceable: "Yes", tier: "3" },
  { pincode: 176102, serviceable: "Yes", tier: "3" },
  { pincode: 176103, serviceable: "Yes", tier: "3" },
  { pincode: 176107, serviceable: "Yes", tier: "3" },
  { pincode: 176108, serviceable: "Yes", tier: "3" },
  { pincode: 176109, serviceable: "Yes", tier: "3" },
  { pincode: 176110, serviceable: "Yes", tier: "3" },
  { pincode: 176111, serviceable: "Yes", tier: "3" },
  { pincode: 176115, serviceable: "Yes", tier: "3" },
  { pincode: 176125, serviceable: "Yes", tier: "3" },
  { pincode: 176128, serviceable: "Yes", tier: "3" },
  { pincode: 176201, serviceable: "Yes", tier: "6" },
  { pincode: 176202, serviceable: "Yes", tier: "6" },
  { pincode: 176205, serviceable: "Yes", tier: "3" },
  { pincode: 176206, serviceable: "Yes", tier: "3" },
  { pincode: 176208, serviceable: "Yes", tier: "3" },
  { pincode: 176209, serviceable: "Yes", tier: "3" },
  { pincode: 176213, serviceable: "Yes", tier: "3" },
  { pincode: 176214, serviceable: "Yes", tier: "3" },
  { pincode: 176215, serviceable: "Yes", tier: "3" },
  { pincode: 176216, serviceable: "Yes", tier: "3" },
  { pincode: 176217, serviceable: "Yes", tier: "3" },
  { pincode: 176218, serviceable: "Yes", tier: "3" },
  { pincode: 176219, serviceable: "Yes", tier: "3" },
  { pincode: 176301, serviceable: "Yes", tier: "6" },
  { pincode: 176302, serviceable: "Yes", tier: "6" },
  { pincode: 176303, serviceable: "Yes", tier: "6" },
  { pincode: 176304, serviceable: "Yes", tier: "6" },
  { pincode: 176305, serviceable: "Yes", tier: "6" },
  { pincode: 176306, serviceable: "Yes", tier: "6" },
  { pincode: 176310, serviceable: "Yes", tier: "6" },
  { pincode: 176314, serviceable: "Yes", tier: "6" },
  { pincode: 176318, serviceable: "Yes", tier: "6" },
  { pincode: 176403, serviceable: "Yes", tier: "3" },
  { pincode: 176601, serviceable: "Yes", tier: "2" },
  { pincode: 177001, serviceable: "Yes", tier: "2" },
  { pincode: 177005, serviceable: "Yes", tier: "2" },
  { pincode: 177022, serviceable: "Yes", tier: "3" },
  { pincode: 177023, serviceable: "Yes", tier: "3" },
  { pincode: 177024, serviceable: "Yes", tier: "3" },
  { pincode: 177025, serviceable: "Yes", tier: "3" },
  { pincode: 177026, serviceable: "Yes", tier: "3" },
  { pincode: 177027, serviceable: "Yes", tier: "2" },
  { pincode: 177028, serviceable: "Yes", tier: "3" },
  { pincode: 177029, serviceable: "Yes", tier: "2" },
  { pincode: 177033, serviceable: "Yes", tier: "3" },
  { pincode: 177038, serviceable: "Yes", tier: "3" },
  { pincode: 177040, serviceable: "Yes", tier: "3" },
  { pincode: 177041, serviceable: "Yes", tier: "3" },
  { pincode: 177042, serviceable: "Yes", tier: "3" },
  { pincode: 177043, serviceable: "Yes", tier: "3" },
  { pincode: 177044, serviceable: "Yes", tier: "3" },
  { pincode: 177045, serviceable: "Yes", tier: "3" },
  { pincode: 177048, serviceable: "Yes", tier: "3" },
  { pincode: 177101, serviceable: "Yes", tier: "3" },
  { pincode: 177103, serviceable: "Yes", tier: "3" },
  { pincode: 177104, serviceable: "Yes", tier: "3" },
  { pincode: 177105, serviceable: "Yes", tier: "3" },
  { pincode: 177106, serviceable: "Yes", tier: "3" },
  { pincode: 177107, serviceable: "Yes", tier: "3" },
  { pincode: 177108, serviceable: "Yes", tier: "3" },
  { pincode: 177109, serviceable: "Yes", tier: "3" },
  { pincode: 177110, serviceable: "Yes", tier: "3" },
  { pincode: 177113, serviceable: "Yes", tier: "3" },
  { pincode: 177114, serviceable: "Yes", tier: "3" },
  { pincode: 177117, serviceable: "Yes", tier: "3" },
  { pincode: 177201, serviceable: "Yes", tier: "3" },
  { pincode: 177202, serviceable: "Yes", tier: "3" },
  { pincode: 177203, serviceable: "Yes", tier: "3" },
  { pincode: 177204, serviceable: "Yes", tier: "3" },
  { pincode: 177205, serviceable: "Yes", tier: "3" },
  { pincode: 177206, serviceable: "Yes", tier: "3" },
  { pincode: 177207, serviceable: "Yes", tier: "2" },
  { pincode: 177208, serviceable: "Yes", tier: "3" },
  { pincode: 177209, serviceable: "Yes", tier: "2" },
  { pincode: 177210, serviceable: "Yes", tier: "3" },
  { pincode: 177211, serviceable: "Yes", tier: "3" },
  { pincode: 177212, serviceable: "Yes", tier: "3" },
  { pincode: 177213, serviceable: "Yes", tier: "3" },
  { pincode: 177219, serviceable: "Yes", tier: "3" },
  { pincode: 177220, serviceable: "Yes", tier: "2" },
  { pincode: 177301, serviceable: "Yes", tier: "3" },
  { pincode: 177601, serviceable: "Yes", tier: "3" },
  { pincode: 180001, serviceable: "Yes", tier: "2" },
  { pincode: 180002, serviceable: "Yes", tier: "2" },
  { pincode: 180003, serviceable: "Yes", tier: "3" },
  { pincode: 180004, serviceable: "Yes", tier: "2" },
  { pincode: 180005, serviceable: "Yes", tier: "2" },
  { pincode: 180006, serviceable: "Yes", tier: "2" },
  { pincode: 180007, serviceable: "Yes", tier: "2" },
  { pincode: 180010, serviceable: "Yes", tier: "2" },
  { pincode: 180011, serviceable: "Yes", tier: "2" },
  { pincode: 180012, serviceable: "Yes", tier: "2" },
  { pincode: 180013, serviceable: "Yes", tier: "2" },
  { pincode: 180015, serviceable: "Yes", tier: "2" },
  { pincode: 180016, serviceable: "Yes", tier: "2" },
  { pincode: 180017, serviceable: "Yes", tier: "3" },
  { pincode: 180018, serviceable: "Yes", tier: "2" },
  { pincode: 180019, serviceable: "Yes", tier: "3" },
  { pincode: 180020, serviceable: "Yes", tier: "2" },
  { pincode: 181101, serviceable: "Yes", tier: "3" },
  { pincode: 181102, serviceable: "Yes", tier: "3" },
  { pincode: 181111, serviceable: "Yes", tier: "3" },
  { pincode: 181121, serviceable: "Yes", tier: "2" },
  { pincode: 181122, serviceable: "Yes", tier: "3" },
  { pincode: 181123, serviceable: "Yes", tier: "2" },
  { pincode: 181124, serviceable: "Yes", tier: "2" },
  { pincode: 181132, serviceable: "Yes", tier: "3" },
  { pincode: 181133, serviceable: "Yes", tier: "3" },
  { pincode: 181134, serviceable: "Yes", tier: "3" },
  { pincode: 181141, serviceable: "Yes", tier: "3" },
  { pincode: 181143, serviceable: "Yes", tier: "3" },
  { pincode: 181145, serviceable: "Yes", tier: "3" },
  { pincode: 181152, serviceable: "Yes", tier: "2" },
  { pincode: 181201, serviceable: "Yes", tier: "3" },
  { pincode: 181202, serviceable: "Yes", tier: "3" },
  { pincode: 181205, serviceable: "Yes", tier: "2" },
  { pincode: 181206, serviceable: "Yes", tier: "3" },
  { pincode: 181221, serviceable: "Yes", tier: "3" },
  { pincode: 182101, serviceable: "Yes", tier: "3" },
  { pincode: 182104, serviceable: "Yes", tier: "3" },
  { pincode: 182121, serviceable: "Yes", tier: "3" },
  { pincode: 182122, serviceable: "Yes", tier: "3" },
  { pincode: 182301, serviceable: "Yes", tier: "3" },
  { pincode: 182311, serviceable: "Yes", tier: "3" },
  { pincode: 182320, serviceable: "Yes", tier: "3" },
  { pincode: 184101, serviceable: "Yes", tier: "3" },
  { pincode: 184102, serviceable: "Yes", tier: "3" },
  { pincode: 184104, serviceable: "Yes", tier: "3" },
  { pincode: 184120, serviceable: "Yes", tier: "3" },
  { pincode: 184121, serviceable: "Yes", tier: "3" },
  { pincode: 184141, serviceable: "Yes", tier: "3" },
  { pincode: 184142, serviceable: "Yes", tier: "3" },
  { pincode: 184143, serviceable: "Yes", tier: "3" },
  { pincode: 184144, serviceable: "Yes", tier: "3" },
  { pincode: 184148, serviceable: "Yes", tier: "3" },
  { pincode: 184151, serviceable: "Yes", tier: "3" },
  { pincode: 184152, serviceable: "Yes", tier: "3" },
  { pincode: 190001, serviceable: "Yes", tier: "3" },
  { pincode: 190002, serviceable: "Yes", tier: "3" },
  { pincode: 190003, serviceable: "Yes", tier: "3" },
  { pincode: 190004, serviceable: "Yes", tier: "3" },
  { pincode: 190005, serviceable: "Yes", tier: "3" },
  { pincode: 190006, serviceable: "Yes", tier: "3" },
  { pincode: 190007, serviceable: "Yes", tier: "3" },
  { pincode: 190008, serviceable: "Yes", tier: "3" },
  { pincode: 190009, serviceable: "Yes", tier: "3" },
  { pincode: 190010, serviceable: "Yes", tier: "3" },
  { pincode: 190011, serviceable: "Yes", tier: "3" },
  { pincode: 190012, serviceable: "Yes", tier: "3" },
  { pincode: 190014, serviceable: "Yes", tier: "3" },
  { pincode: 190015, serviceable: "Yes", tier: "3" },
  { pincode: 190017, serviceable: "Yes", tier: "3" },
  { pincode: 190020, serviceable: "Yes", tier: "3" },
  { pincode: 190023, serviceable: "Yes", tier: "3" },
  { pincode: 191101, serviceable: "Yes", tier: "3" },
  { pincode: 191102, serviceable: "Yes", tier: "3" },
  { pincode: 191104, serviceable: "Yes", tier: "3" },
  { pincode: 191115, serviceable: "Yes", tier: "3" },
  { pincode: 191123, serviceable: "Yes", tier: "3" },
  { pincode: 191124, serviceable: "Yes", tier: "3" },
  { pincode: 191201, serviceable: "Yes", tier: "3" },
  { pincode: 192101, serviceable: "Yes", tier: "3" },
  { pincode: 192102, serviceable: "Yes", tier: "3" },
  { pincode: 192121, serviceable: "Yes", tier: "3" },
  { pincode: 192124, serviceable: "Yes", tier: "3" },
  { pincode: 192125, serviceable: "Yes", tier: "3" },
  { pincode: 192210, serviceable: "Yes", tier: "3" },
  { pincode: 192301, serviceable: "Yes", tier: "3" },
  { pincode: 193101, serviceable: "Yes", tier: "3" },
  { pincode: 193103, serviceable: "Yes", tier: "3" },
  { pincode: 193123, serviceable: "Yes", tier: "3" },
  { pincode: 193125, serviceable: "Yes", tier: "3" },
  { pincode: 193201, serviceable: "Yes", tier: "3" },
  { pincode: 193202, serviceable: "Yes", tier: "3" },
  { pincode: 201001, serviceable: "Yes", tier: "1" },
  { pincode: 201002, serviceable: "Yes", tier: "1" },
  { pincode: 201003, serviceable: "Yes", tier: "1" },
  { pincode: 201004, serviceable: "Yes", tier: "1" },
  { pincode: 201005, serviceable: "Yes", tier: "1" },
  { pincode: 201006, serviceable: "Yes", tier: "1" },
  { pincode: 201007, serviceable: "Yes", tier: "1" },
  { pincode: 201008, serviceable: "Yes", tier: "1" },
  { pincode: 201009, serviceable: "Yes", tier: "1" },
  { pincode: 201010, serviceable: "Yes", tier: "1" },
  { pincode: 201011, serviceable: "Yes", tier: "1" },
  { pincode: 201012, serviceable: "Yes", tier: "1" },
  { pincode: 201013, serviceable: "Yes", tier: "1" },
  { pincode: 201014, serviceable: "Yes", tier: "1" },
  { pincode: 201015, serviceable: "Yes", tier: "1" },
  { pincode: 201016, serviceable: "Yes", tier: "1" },
  { pincode: 201017, serviceable: "Yes", tier: "1" },
  { pincode: 201018, serviceable: "Yes", tier: "1" },
  { pincode: 201019, serviceable: "Yes", tier: "1" },
  { pincode: 201020, serviceable: "Yes", tier: "1" },
  { pincode: 201102, serviceable: "Yes", tier: "1" },
  { pincode: 201103, serviceable: "Yes", tier: "1" },
  { pincode: 201111, serviceable: "Yes", tier: "1" },
  { pincode: 201201, serviceable: "Yes", tier: "1" },
  { pincode: 201204, serviceable: "Yes", tier: "1" },
  { pincode: 201206, serviceable: "Yes", tier: "1" },
  { pincode: 201300, serviceable: "Yes", tier: "1" },
  { pincode: 201301, serviceable: "Yes", tier: "1" },
  { pincode: 201303, serviceable: "Yes", tier: "1" },
  { pincode: 201304, serviceable: "Yes", tier: "1" },
  { pincode: 201305, serviceable: "Yes", tier: "1" },
  { pincode: 201306, serviceable: "Yes", tier: "1" },
  { pincode: 201307, serviceable: "Yes", tier: "1" },
  { pincode: 201308, serviceable: "Yes", tier: "1" },
  { pincode: 201309, serviceable: "Yes", tier: "1" },
  { pincode: 201310, serviceable: "Yes", tier: "1" },
  { pincode: 201311, serviceable: "Yes", tier: "1" },
  { pincode: 201312, serviceable: "Yes", tier: "1" },
  { pincode: 201313, serviceable: "Yes", tier: "1" },
  { pincode: 201314, serviceable: "Yes", tier: "1" },
  { pincode: 201315, serviceable: "Yes", tier: "1" },
  { pincode: 201316, serviceable: "Yes", tier: "1" },
  { pincode: 201317, serviceable: "Yes", tier: "1" },
  { pincode: 201318, serviceable: "Yes", tier: "1" },
  { pincode: 202001, serviceable: "Yes", tier: "1" },
  { pincode: 202002, serviceable: "Yes", tier: "1" },
  { pincode: 202124, serviceable: "Yes", tier: "1" },
  { pincode: 202125, serviceable: "Yes", tier: "1" },
  { pincode: 202127, serviceable: "Yes", tier: "1" },
  { pincode: 202130, serviceable: "Yes", tier: "1" },
  { pincode: 202138, serviceable: "Yes", tier: "1" },
  { pincode: 202145, serviceable: "Yes", tier: "1" },
  { pincode: 202280, serviceable: "Yes", tier: "1" },
  { pincode: 203001, serviceable: "Yes", tier: "2" },
  { pincode: 203002, serviceable: "Yes", tier: "2" },
  { pincode: 203131, serviceable: "Yes", tier: "2" },
  { pincode: 203132, serviceable: "Yes", tier: "2" },
  { pincode: 203135, serviceable: "Yes", tier: "1" },
  { pincode: 203150, serviceable: "Yes", tier: "2" },
  { pincode: 203201, serviceable: "Yes", tier: "1" },
  { pincode: 203202, serviceable: "Yes", tier: "1" },
  { pincode: 203203, serviceable: "Yes", tier: "1" },
  { pincode: 203205, serviceable: "Yes", tier: "1" },
  { pincode: 203206, serviceable: "Yes", tier: "1" },
  { pincode: 203207, serviceable: "Yes", tier: "1" },
  { pincode: 203209, serviceable: "Yes", tier: "1" },
  { pincode: 203389, serviceable: "Yes", tier: "2" },
  { pincode: 203390, serviceable: "Yes", tier: "2" },
  { pincode: 203393, serviceable: "Yes", tier: "2" },
  { pincode: 203394, serviceable: "Yes", tier: "2" },
  { pincode: 203395, serviceable: "Yes", tier: "2" },
  { pincode: 203401, serviceable: "Yes", tier: "2" },
  { pincode: 203408, serviceable: "Yes", tier: "1" },
  { pincode: 203411, serviceable: "Yes", tier: "2" },
  { pincode: 203412, serviceable: "Yes", tier: "2" },
  { pincode: 204101, serviceable: "Yes", tier: "2" },
  { pincode: 204213, serviceable: "Yes", tier: "2" },
  { pincode: 204215, serviceable: "Yes", tier: "1" },
  { pincode: 204216, serviceable: "Yes", tier: "2" },
  { pincode: 205001, serviceable: "Yes", tier: "2" },
  { pincode: 205121, serviceable: "Yes", tier: "2" },
  { pincode: 205261, serviceable: "Yes", tier: "2" },
  { pincode: 205262, serviceable: "Yes", tier: "2" },
  { pincode: 205264, serviceable: "Yes", tier: "2" },
  { pincode: 205265, serviceable: "Yes", tier: "2" },
  { pincode: 205301, serviceable: "Yes", tier: "2" },
  { pincode: 205303, serviceable: "Yes", tier: "2" },
  { pincode: 206001, serviceable: "Yes", tier: "2" },
  { pincode: 206002, serviceable: "Yes", tier: "2" },
  { pincode: 206003, serviceable: "Yes", tier: "2" },
  { pincode: 206120, serviceable: "Yes", tier: "2" },
  { pincode: 206121, serviceable: "Yes", tier: "3" },
  { pincode: 206122, serviceable: "Yes", tier: "3" },
  { pincode: 206123, serviceable: "Yes", tier: "2" },
  { pincode: 206124, serviceable: "Yes", tier: "2" },
  { pincode: 206125, serviceable: "Yes", tier: "2" },
  { pincode: 206126, serviceable: "Yes", tier: "2" },
  { pincode: 206127, serviceable: "Yes", tier: "2" },
  { pincode: 206128, serviceable: "Yes", tier: "2" },
  { pincode: 206129, serviceable: "Yes", tier: "3" },
  { pincode: 206130, serviceable: "Yes", tier: "2" },
  { pincode: 206131, serviceable: "Yes", tier: "2" },
  { pincode: 206241, serviceable: "Yes", tier: "3" },
  { pincode: 206242, serviceable: "Yes", tier: "2" },
  { pincode: 206243, serviceable: "Yes", tier: "3" },
  { pincode: 206244, serviceable: "Yes", tier: "3" },
  { pincode: 206245, serviceable: "Yes", tier: "2" },
  { pincode: 206246, serviceable: "Yes", tier: "3" },
  { pincode: 206247, serviceable: "Yes", tier: "3" },
  { pincode: 206249, serviceable: "Yes", tier: "3" },
  { pincode: 206252, serviceable: "Yes", tier: "3" },
  { pincode: 206253, serviceable: "Yes", tier: "2" },
  { pincode: 207001, serviceable: "Yes", tier: "2" },
  { pincode: 208001, serviceable: "Yes", tier: "2" },
  { pincode: 208002, serviceable: "Yes", tier: "2" },
  { pincode: 208003, serviceable: "Yes", tier: "2" },
  { pincode: 208004, serviceable: "Yes", tier: "2" },
  { pincode: 208005, serviceable: "Yes", tier: "2" },
  { pincode: 208006, serviceable: "Yes", tier: "2" },
  { pincode: 208007, serviceable: "Yes", tier: "2" },
  { pincode: 208008, serviceable: "Yes", tier: "2" },
  { pincode: 208009, serviceable: "Yes", tier: "2" },
  { pincode: 208010, serviceable: "Yes", tier: "2" },
  { pincode: 208011, serviceable: "Yes", tier: "2" },
  { pincode: 208012, serviceable: "Yes", tier: "2" },
  { pincode: 208013, serviceable: "Yes", tier: "2" },
  { pincode: 208014, serviceable: "Yes", tier: "2" },
  { pincode: 208015, serviceable: "Yes", tier: "2" },
  { pincode: 208016, serviceable: "Yes", tier: "2" },
  { pincode: 208017, serviceable: "Yes", tier: "2" },
  { pincode: 208018, serviceable: "Yes", tier: "2" },
  { pincode: 208019, serviceable: "Yes", tier: "2" },
  { pincode: 208020, serviceable: "Yes", tier: "2" },
  { pincode: 208021, serviceable: "Yes", tier: "2" },
  { pincode: 208022, serviceable: "Yes", tier: "2" },
  { pincode: 208023, serviceable: "Yes", tier: "2" },
  { pincode: 208024, serviceable: "Yes", tier: "2" },
  { pincode: 208025, serviceable: "Yes", tier: "2" },
  { pincode: 208026, serviceable: "Yes", tier: "2" },
  { pincode: 208027, serviceable: "Yes", tier: "2" },
  { pincode: 209101, serviceable: "Yes", tier: "3" },
  { pincode: 209111, serviceable: "Yes", tier: "3" },
  { pincode: 209112, serviceable: "Yes", tier: "3" },
  { pincode: 209115, serviceable: "Yes", tier: "3" },
  { pincode: 209121, serviceable: "Yes", tier: "3" },
  { pincode: 209125, serviceable: "Yes", tier: "3" },
  { pincode: 209202, serviceable: "Yes", tier: "3" },
  { pincode: 209203, serviceable: "Yes", tier: "2" },
  { pincode: 209204, serviceable: "Yes", tier: "2" },
  { pincode: 209205, serviceable: "Yes", tier: "2" },
  { pincode: 209206, serviceable: "Yes", tier: "2" },
  { pincode: 209214, serviceable: "Yes", tier: "2" },
  { pincode: 209217, serviceable: "Yes", tier: "2" },
  { pincode: 209302, serviceable: "Yes", tier: "3" },
  { pincode: 209303, serviceable: "Yes", tier: "3" },
  { pincode: 209304, serviceable: "Yes", tier: "2" },
  { pincode: 209305, serviceable: "Yes", tier: "2" },
  { pincode: 209306, serviceable: "Yes", tier: "2" },
  { pincode: 209307, serviceable: "Yes", tier: "3" },
  { pincode: 209310, serviceable: "Yes", tier: "3" },
  { pincode: 209311, serviceable: "Yes", tier: "3" },
  { pincode: 209401, serviceable: "Yes", tier: "2" },
  { pincode: 209402, serviceable: "Yes", tier: "2" },
  { pincode: 209501, serviceable: "Yes", tier: "3" },
  { pincode: 209502, serviceable: "Yes", tier: "3" },
  { pincode: 209503, serviceable: "Yes", tier: "3" },
  { pincode: 209601, serviceable: "Yes", tier: "3" },
  { pincode: 209602, serviceable: "Yes", tier: "3" },
  { pincode: 209621, serviceable: "Yes", tier: "3" },
  { pincode: 209622, serviceable: "Yes", tier: "3" },
  { pincode: 209624, serviceable: "Yes", tier: "3" },
  { pincode: 209625, serviceable: "Yes", tier: "3" },
  { pincode: 209651, serviceable: "Yes", tier: "3" },
  { pincode: 209652, serviceable: "Yes", tier: "3" },
  { pincode: 209721, serviceable: "Yes", tier: "3" },
  { pincode: 209722, serviceable: "Yes", tier: "3" },
  { pincode: 209723, serviceable: "Yes", tier: "3" },
  { pincode: 209724, serviceable: "Yes", tier: "3" },
  { pincode: 209725, serviceable: "Yes", tier: "2" },
  { pincode: 209726, serviceable: "Yes", tier: "2" },
  { pincode: 209727, serviceable: "Yes", tier: "2" },
  { pincode: 209728, serviceable: "Yes", tier: "3" },
  { pincode: 209729, serviceable: "Yes", tier: "3" },
  { pincode: 209731, serviceable: "Yes", tier: "3" },
  { pincode: 209732, serviceable: "Yes", tier: "3" },
  { pincode: 209733, serviceable: "Yes", tier: "3" },
  { pincode: 209739, serviceable: "Yes", tier: "3" },
  { pincode: 209743, serviceable: "Yes", tier: "3" },
  { pincode: 209801, serviceable: "Yes", tier: "2" },
  { pincode: 209821, serviceable: "Yes", tier: "2" },
  { pincode: 209825, serviceable: "Yes", tier: "2" },
  { pincode: 209827, serviceable: "Yes", tier: "2" },
  { pincode: 209831, serviceable: "Yes", tier: "2" },
  { pincode: 209841, serviceable: "Yes", tier: "2" },
  { pincode: 209859, serviceable: "Yes", tier: "2" },
  { pincode: 209861, serviceable: "Yes", tier: "2" },
  { pincode: 209862, serviceable: "Yes", tier: "2" },
  { pincode: 209863, serviceable: "Yes", tier: "2" },
  { pincode: 209865, serviceable: "Yes", tier: "2" },
  { pincode: 209866, serviceable: "Yes", tier: "2" },
  { pincode: 209867, serviceable: "Yes", tier: "2" },
  { pincode: 209868, serviceable: "Yes", tier: "2" },
  { pincode: 209871, serviceable: "Yes", tier: "2" },
  { pincode: 210001, serviceable: "Yes", tier: "3" },
  { pincode: 210010, serviceable: "Yes", tier: "2" },
  { pincode: 210129, serviceable: "Yes", tier: "5" },
  { pincode: 210201, serviceable: "Yes", tier: "5" },
  { pincode: 210204, serviceable: "Yes", tier: "5" },
  { pincode: 210205, serviceable: "Yes", tier: "5" },
  { pincode: 210206, serviceable: "Yes", tier: "5" },
  { pincode: 210207, serviceable: "Yes", tier: "5" },
  { pincode: 210208, serviceable: "Yes", tier: "5" },
  { pincode: 210209, serviceable: "Yes", tier: "5" },
  { pincode: 210301, serviceable: "Yes", tier: "3" },
  { pincode: 210341, serviceable: "Yes", tier: "3" },
  { pincode: 210421, serviceable: "Yes", tier: "3" },
  { pincode: 210423, serviceable: "Yes", tier: "3" },
  { pincode: 210424, serviceable: "Yes", tier: "3" },
  { pincode: 210425, serviceable: "Yes", tier: "3" },
  { pincode: 210426, serviceable: "Yes", tier: "3" },
  { pincode: 210427, serviceable: "Yes", tier: "3" },
  { pincode: 210429, serviceable: "Yes", tier: "3" },
  { pincode: 210431, serviceable: "Yes", tier: "3" },
  { pincode: 210501, serviceable: "Yes", tier: "3" },
  { pincode: 210502, serviceable: "Yes", tier: "3" },
  { pincode: 210504, serviceable: "Yes", tier: "3" },
  { pincode: 210505, serviceable: "Yes", tier: "3" },
  { pincode: 210506, serviceable: "Yes", tier: "3" },
  { pincode: 210507, serviceable: "Yes", tier: "3" },
  { pincode: 211001, serviceable: "Yes", tier: "2" },
  { pincode: 211002, serviceable: "Yes", tier: "2" },
  { pincode: 211003, serviceable: "Yes", tier: "2" },
  { pincode: 211004, serviceable: "Yes", tier: "2" },
  { pincode: 211005, serviceable: "Yes", tier: "2" },
  { pincode: 211006, serviceable: "Yes", tier: "2" },
  { pincode: 211007, serviceable: "Yes", tier: "2" },
  { pincode: 211008, serviceable: "Yes", tier: "2" },
  { pincode: 211009, serviceable: "Yes", tier: "2" },
  { pincode: 211010, serviceable: "Yes", tier: "2" },
  { pincode: 211011, serviceable: "Yes", tier: "2" },
  { pincode: 211012, serviceable: "Yes", tier: "2" },
  { pincode: 211013, serviceable: "Yes", tier: "2" },
  { pincode: 211014, serviceable: "Yes", tier: "2" },
  { pincode: 211015, serviceable: "Yes", tier: "2" },
  { pincode: 211016, serviceable: "Yes", tier: "2" },
  { pincode: 211017, serviceable: "Yes", tier: "2" },
  { pincode: 211018, serviceable: "Yes", tier: "2" },
  { pincode: 211019, serviceable: "Yes", tier: "2" },
  { pincode: 212105, serviceable: "Yes", tier: "2" },
  { pincode: 212201, serviceable: "Yes", tier: "3" },
  { pincode: 212202, serviceable: "Yes", tier: "3" },
  { pincode: 212203, serviceable: "Yes", tier: "3" },
  { pincode: 212205, serviceable: "Yes", tier: "3" },
  { pincode: 212206, serviceable: "Yes", tier: "3" },
  { pincode: 212207, serviceable: "Yes", tier: "3" },
  { pincode: 212212, serviceable: "Yes", tier: "2" },
  { pincode: 212213, serviceable: "Yes", tier: "3" },
  { pincode: 212217, serviceable: "Yes", tier: "3" },
  { pincode: 212301, serviceable: "Yes", tier: "2" },
  { pincode: 212405, serviceable: "Yes", tier: "2" },
  { pincode: 212601, serviceable: "Yes", tier: "3" },
  { pincode: 212620, serviceable: "Yes", tier: "3" },
  { pincode: 212622, serviceable: "Yes", tier: "3" },
  { pincode: 212635, serviceable: "Yes", tier: "3" },
  { pincode: 212651, serviceable: "Yes", tier: "3" },
  { pincode: 212652, serviceable: "Yes", tier: "3" },
  { pincode: 212655, serviceable: "Yes", tier: "3" },
  { pincode: 212657, serviceable: "Yes", tier: "3" },
  { pincode: 212663, serviceable: "Yes", tier: "3" },
  { pincode: 212664, serviceable: "Yes", tier: "3" },
  { pincode: 212665, serviceable: "Yes", tier: "3" },
  { pincode: 221001, serviceable: "Yes", tier: "2" },
  { pincode: 221002, serviceable: "Yes", tier: "3" },
  { pincode: 221003, serviceable: "Yes", tier: "3" },
  { pincode: 221004, serviceable: "Yes", tier: "2" },
  { pincode: 221005, serviceable: "Yes", tier: "2" },
  { pincode: 221006, serviceable: "Yes", tier: "3" },
  { pincode: 221007, serviceable: "Yes", tier: "3" },
  { pincode: 221008, serviceable: "Yes", tier: "3" },
  { pincode: 221010, serviceable: "Yes", tier: "2" },
  { pincode: 221011, serviceable: "Yes", tier: "2" },
  { pincode: 221012, serviceable: "Yes", tier: "3" },
  { pincode: 221101, serviceable: "Yes", tier: "3" },
  { pincode: 221103, serviceable: "Yes", tier: "2" },
  { pincode: 221105, serviceable: "Yes", tier: "3" },
  { pincode: 221106, serviceable: "Yes", tier: "2" },
  { pincode: 221107, serviceable: "Yes", tier: "2" },
  { pincode: 221108, serviceable: "Yes", tier: "2" },
  { pincode: 221109, serviceable: "Yes", tier: "2" },
  { pincode: 221301, serviceable: "Yes", tier: "5" },
  { pincode: 221302, serviceable: "Yes", tier: "2" },
  { pincode: 221303, serviceable: "Yes", tier: "5" },
  { pincode: 221304, serviceable: "Yes", tier: "5" },
  { pincode: 221306, serviceable: "Yes", tier: "5" },
  { pincode: 221308, serviceable: "Yes", tier: "5" },
  { pincode: 221310, serviceable: "Yes", tier: "5" },
  { pincode: 221314, serviceable: "Yes", tier: "5" },
  { pincode: 221401, serviceable: "Yes", tier: "5" },
  { pincode: 221402, serviceable: "Yes", tier: "5" },
  { pincode: 221403, serviceable: "Yes", tier: "5" },
  { pincode: 221404, serviceable: "Yes", tier: "5" },
  { pincode: 221406, serviceable: "Yes", tier: "5" },
  { pincode: 221409, serviceable: "Yes", tier: "5" },
  { pincode: 221503, serviceable: "Yes", tier: "2" },
  { pincode: 221505, serviceable: "Yes", tier: "2" },
  { pincode: 221701, serviceable: "Yes", tier: "5" },
  { pincode: 221711, serviceable: "Yes", tier: "5" },
  { pincode: 221712, serviceable: "Yes", tier: "5" },
  { pincode: 221713, serviceable: "Yes", tier: "5" },
  { pincode: 221717, serviceable: "Yes", tier: "5" },
  { pincode: 222001, serviceable: "Yes", tier: "5" },
  { pincode: 222002, serviceable: "Yes", tier: "5" },
  { pincode: 222109, serviceable: "Yes", tier: "5" },
  { pincode: 222125, serviceable: "Yes", tier: "5" },
  { pincode: 222129, serviceable: "Yes", tier: "5" },
  { pincode: 222131, serviceable: "Yes", tier: "5" },
  { pincode: 222132, serviceable: "Yes", tier: "5" },
  { pincode: 222136, serviceable: "Yes", tier: "5" },
  { pincode: 222139, serviceable: "Yes", tier: "5" },
  { pincode: 222142, serviceable: "Yes", tier: "5" },
  { pincode: 222143, serviceable: "Yes", tier: "5" },
  { pincode: 222161, serviceable: "Yes", tier: "5" },
  { pincode: 222170, serviceable: "Yes", tier: "5" },
  { pincode: 222180, serviceable: "Yes", tier: "5" },
  { pincode: 222201, serviceable: "Yes", tier: "5" },
  { pincode: 222203, serviceable: "Yes", tier: "5" },
  { pincode: 222302, serviceable: "Yes", tier: "2" },
  { pincode: 222333, serviceable: "Yes", tier: "1" },
  { pincode: 223101, serviceable: "Yes", tier: "5" },
  { pincode: 223223, serviceable: "Yes", tier: "5" },
  { pincode: 224001, serviceable: "Yes", tier: "5" },
  { pincode: 224120, serviceable: "Yes", tier: "5" },
  { pincode: 224122, serviceable: "Yes", tier: "5" },
  { pincode: 224123, serviceable: "Yes", tier: "5" },
  { pincode: 224127, serviceable: "Yes", tier: "5" },
  { pincode: 224129, serviceable: "Yes", tier: "5" },
  { pincode: 224133, serviceable: "Yes", tier: "5" },
  { pincode: 224135, serviceable: "Yes", tier: "5" },
  { pincode: 224141, serviceable: "Yes", tier: "5" },
  { pincode: 224143, serviceable: "Yes", tier: "5" },
  { pincode: 224145, serviceable: "Yes", tier: "5" },
  { pincode: 224149, serviceable: "Yes", tier: "5" },
  { pincode: 224155, serviceable: "Yes", tier: "5" },
  { pincode: 224158, serviceable: "Yes", tier: "5" },
  { pincode: 224164, serviceable: "Yes", tier: "5" },
  { pincode: 224188, serviceable: "Yes", tier: "5" },
  { pincode: 224190, serviceable: "Yes", tier: "5" },
  { pincode: 224201, serviceable: "Yes", tier: "5" },
  { pincode: 224206, serviceable: "Yes", tier: "5" },
  { pincode: 224207, serviceable: "Yes", tier: "5" },
  { pincode: 224209, serviceable: "Yes", tier: "5" },
  { pincode: 224229, serviceable: "Yes", tier: "5" },
  { pincode: 224238, serviceable: "Yes", tier: "5" },
  { pincode: 225001, serviceable: "Yes", tier: "3" },
  { pincode: 225002, serviceable: "Yes", tier: "3" },
  { pincode: 225003, serviceable: "Yes", tier: "3" },
  { pincode: 225119, serviceable: "Yes", tier: "3" },
  { pincode: 225120, serviceable: "Yes", tier: "3" },
  { pincode: 225121, serviceable: "Yes", tier: "3" },
  { pincode: 225122, serviceable: "Yes", tier: "3" },
  { pincode: 225123, serviceable: "Yes", tier: "3" },
  { pincode: 225124, serviceable: "Yes", tier: "3" },
  { pincode: 225201, serviceable: "Yes", tier: "3" },
  { pincode: 225202, serviceable: "Yes", tier: "3" },
  { pincode: 225203, serviceable: "Yes", tier: "3" },
  { pincode: 225204, serviceable: "Yes", tier: "3" },
  { pincode: 225205, serviceable: "Yes", tier: "3" },
  { pincode: 225206, serviceable: "Yes", tier: "3" },
  { pincode: 225207, serviceable: "Yes", tier: "3" },
  { pincode: 225208, serviceable: "Yes", tier: "3" },
  { pincode: 225301, serviceable: "Yes", tier: "3" },
  { pincode: 225302, serviceable: "Yes", tier: "3" },
  { pincode: 225303, serviceable: "Yes", tier: "3" },
  { pincode: 225304, serviceable: "Yes", tier: "3" },
  { pincode: 225305, serviceable: "Yes", tier: "3" },
  { pincode: 225306, serviceable: "Yes", tier: "3" },
  { pincode: 225403, serviceable: "Yes", tier: "3" },
  { pincode: 225405, serviceable: "Yes", tier: "3" },
  { pincode: 225409, serviceable: "Yes", tier: "3" },
  { pincode: 225412, serviceable: "Yes", tier: "3" },
  { pincode: 225413, serviceable: "Yes", tier: "3" },
  { pincode: 225414, serviceable: "Yes", tier: "3" },
  { pincode: 225415, serviceable: "Yes", tier: "3" },
  { pincode: 226001, serviceable: "Yes", tier: "2" },
  { pincode: 226002, serviceable: "Yes", tier: "2" },
  { pincode: 226003, serviceable: "Yes", tier: "2" },
  { pincode: 226004, serviceable: "Yes", tier: "2" },
  { pincode: 226005, serviceable: "Yes", tier: "2" },
  { pincode: 226006, serviceable: "Yes", tier: "2" },
  { pincode: 226007, serviceable: "Yes", tier: "2" },
  { pincode: 226008, serviceable: "Yes", tier: "2" },
  { pincode: 226009, serviceable: "Yes", tier: "2" },
  { pincode: 226010, serviceable: "Yes", tier: "2" },
  { pincode: 226011, serviceable: "Yes", tier: "2" },
  { pincode: 226012, serviceable: "Yes", tier: "2" },
  { pincode: 226013, serviceable: "Yes", tier: "2" },
  { pincode: 226014, serviceable: "Yes", tier: "2" },
  { pincode: 226015, serviceable: "Yes", tier: "2" },
  { pincode: 226016, serviceable: "Yes", tier: "2" },
  { pincode: 226017, serviceable: "Yes", tier: "2" },
  { pincode: 226018, serviceable: "Yes", tier: "2" },
  { pincode: 226019, serviceable: "Yes", tier: "2" },
  { pincode: 226020, serviceable: "Yes", tier: "2" },
  { pincode: 226021, serviceable: "Yes", tier: "2" },
  { pincode: 226022, serviceable: "Yes", tier: "2" },
  { pincode: 226023, serviceable: "Yes", tier: "2" },
  { pincode: 226024, serviceable: "Yes", tier: "2" },
  { pincode: 226025, serviceable: "Yes", tier: "2" },
  { pincode: 226026, serviceable: "Yes", tier: "2" },
  { pincode: 226027, serviceable: "Yes", tier: "2" },
  { pincode: 226028, serviceable: "Yes", tier: "2" },
  { pincode: 226029, serviceable: "Yes", tier: "2" },
  { pincode: 226030, serviceable: "Yes", tier: "2" },
  { pincode: 226031, serviceable: "Yes", tier: "2" },
  { pincode: 226101, serviceable: "Yes", tier: "2" },
  { pincode: 226102, serviceable: "Yes", tier: "2" },
  { pincode: 226103, serviceable: "Yes", tier: "2" },
  { pincode: 226104, serviceable: "Yes", tier: "2" },
  { pincode: 226201, serviceable: "Yes", tier: "2" },
  { pincode: 226202, serviceable: "Yes", tier: "2" },
  { pincode: 226203, serviceable: "Yes", tier: "2" },
  { pincode: 226301, serviceable: "Yes", tier: "2" },
  { pincode: 226302, serviceable: "Yes", tier: "2" },
  { pincode: 226303, serviceable: "Yes", tier: "2" },
  { pincode: 226401, serviceable: "Yes", tier: "2" },
  { pincode: 226501, serviceable: "Yes", tier: "2" },
  { pincode: 227105, serviceable: "Yes", tier: "2" },
  { pincode: 227405, serviceable: "Yes", tier: "2" },
  { pincode: 227408, serviceable: "Yes", tier: "2" },
  { pincode: 227409, serviceable: "Yes", tier: "2" },
  { pincode: 227411, serviceable: "Yes", tier: "2" },
  { pincode: 227412, serviceable: "Yes", tier: "2" },
  { pincode: 227801, serviceable: "Yes", tier: "2" },
  { pincode: 227805, serviceable: "Yes", tier: "2" },
  { pincode: 227808, serviceable: "Yes", tier: "2" },
  { pincode: 227809, serviceable: "Yes", tier: "2" },
  { pincode: 227812, serviceable: "Yes", tier: "2" },
  { pincode: 227813, serviceable: "Yes", tier: "2" },
  { pincode: 227817, serviceable: "Yes", tier: "2" },
  { pincode: 228001, serviceable: "Yes", tier: "2" },
  { pincode: 228118, serviceable: "Yes", tier: "2" },
  { pincode: 228119, serviceable: "Yes", tier: "2" },
  { pincode: 228125, serviceable: "Yes", tier: "2" },
  { pincode: 228141, serviceable: "Yes", tier: "2" },
  { pincode: 228145, serviceable: "Yes", tier: "2" },
  { pincode: 228155, serviceable: "Yes", tier: "2" },
  { pincode: 229001, serviceable: "Yes", tier: "2" },
  { pincode: 229010, serviceable: "Yes", tier: "2" },
  { pincode: 229120, serviceable: "Yes", tier: "2" },
  { pincode: 229122, serviceable: "Yes", tier: "2" },
  { pincode: 229124, serviceable: "Yes", tier: "2" },
  { pincode: 229126, serviceable: "Yes", tier: "2" },
  { pincode: 229127, serviceable: "Yes", tier: "2" },
  { pincode: 229129, serviceable: "Yes", tier: "2" },
  { pincode: 229206, serviceable: "Yes", tier: "2" },
  { pincode: 229207, serviceable: "Yes", tier: "2" },
  { pincode: 229301, serviceable: "Yes", tier: "2" },
  { pincode: 229302, serviceable: "Yes", tier: "2" },
  { pincode: 229303, serviceable: "Yes", tier: "2" },
  { pincode: 229304, serviceable: "Yes", tier: "2" },
  { pincode: 229305, serviceable: "Yes", tier: "2" },
  { pincode: 229306, serviceable: "Yes", tier: "2" },
  { pincode: 229307, serviceable: "Yes", tier: "2" },
  { pincode: 229309, serviceable: "Yes", tier: "2" },
  { pincode: 229310, serviceable: "Yes", tier: "2" },
  { pincode: 229316, serviceable: "Yes", tier: "2" },
  { pincode: 229401, serviceable: "Yes", tier: "2" },
  { pincode: 229402, serviceable: "Yes", tier: "2" },
  { pincode: 229404, serviceable: "Yes", tier: "2" },
  { pincode: 229405, serviceable: "Yes", tier: "2" },
  { pincode: 229406, serviceable: "Yes", tier: "2" },
  { pincode: 229801, serviceable: "Yes", tier: "2" },
  { pincode: 230001, serviceable: "Yes", tier: "3" },
  { pincode: 230002, serviceable: "Yes", tier: "3" },
  { pincode: 230124, serviceable: "Yes", tier: "3" },
  { pincode: 230132, serviceable: "Yes", tier: "3" },
  { pincode: 230135, serviceable: "Yes", tier: "3" },
  { pincode: 230136, serviceable: "Yes", tier: "3" },
  { pincode: 230301, serviceable: "Yes", tier: "3" },
  { pincode: 230304, serviceable: "Yes", tier: "3" },
  { pincode: 230402, serviceable: "Yes", tier: "3" },
  { pincode: 230403, serviceable: "Yes", tier: "3" },
  { pincode: 230501, serviceable: "Yes", tier: "3" },
  { pincode: 230502, serviceable: "Yes", tier: "3" },
  { pincode: 230503, serviceable: "Yes", tier: "3" },
  { pincode: 231001, serviceable: "Yes", tier: "5" },
  { pincode: 231205, serviceable: "Yes", tier: "5" },
  { pincode: 231206, serviceable: "Yes", tier: "5" },
  { pincode: 231208, serviceable: "Yes", tier: "5" },
  { pincode: 231210, serviceable: "Yes", tier: "5" },
  { pincode: 231213, serviceable: "Yes", tier: "5" },
  { pincode: 231215, serviceable: "Yes", tier: "5" },
  { pincode: 231216, serviceable: "Yes", tier: "5" },
  { pincode: 231217, serviceable: "Yes", tier: "5" },
  { pincode: 231218, serviceable: "Yes", tier: "5" },
  { pincode: 231219, serviceable: "Yes", tier: "5" },
  { pincode: 231220, serviceable: "Yes", tier: "5" },
  { pincode: 231221, serviceable: "Yes", tier: "5" },
  { pincode: 231222, serviceable: "Yes", tier: "5" },
  { pincode: 231223, serviceable: "Yes", tier: "5" },
  { pincode: 231225, serviceable: "Yes", tier: "5" },
  { pincode: 231301, serviceable: "Yes", tier: "5" },
  { pincode: 231304, serviceable: "Yes", tier: "5" },
  { pincode: 231305, serviceable: "Yes", tier: "3" },
  { pincode: 231306, serviceable: "Yes", tier: "5" },
  { pincode: 231307, serviceable: "Yes", tier: "5" },
  { pincode: 231501, serviceable: "Yes", tier: "5" },
  { pincode: 232101, serviceable: "Yes", tier: "3" },
  { pincode: 232104, serviceable: "Yes", tier: "3" },
  { pincode: 232326, serviceable: "Yes", tier: "5" },
  { pincode: 232333, serviceable: "Yes", tier: "5" },
  { pincode: 233001, serviceable: "Yes", tier: "5" },
  { pincode: 233224, serviceable: "Yes", tier: "5" },
  { pincode: 233226, serviceable: "Yes", tier: "5" },
  { pincode: 233228, serviceable: "Yes", tier: "5" },
  { pincode: 233230, serviceable: "Yes", tier: "5" },
  { pincode: 233232, serviceable: "Yes", tier: "5" },
  { pincode: 233300, serviceable: "Yes", tier: "5" },
  { pincode: 233302, serviceable: "Yes", tier: "5" },
  { pincode: 233303, serviceable: "Yes", tier: "5" },
  { pincode: 233304, serviceable: "Yes", tier: "5" },
  { pincode: 233305, serviceable: "Yes", tier: "5" },
  { pincode: 233306, serviceable: "Yes", tier: "5" },
  { pincode: 241001, serviceable: "Yes", tier: "3" },
  { pincode: 242001, serviceable: "Yes", tier: "3" },
  { pincode: 242021, serviceable: "Yes", tier: "1" },
  { pincode: 242042, serviceable: "Yes", tier: "3" },
  { pincode: 242220, serviceable: "Yes", tier: "3" },
  { pincode: 242221, serviceable: "Yes", tier: "3" },
  { pincode: 242223, serviceable: "Yes", tier: "3" },
  { pincode: 242301, serviceable: "Yes", tier: "3" },
  { pincode: 242305, serviceable: "Yes", tier: "3" },
  { pincode: 242306, serviceable: "Yes", tier: "3" },
  { pincode: 242307, serviceable: "Yes", tier: "3" },
  { pincode: 242401, serviceable: "Yes", tier: "3" },
  { pincode: 242405, serviceable: "Yes", tier: "3" },
  { pincode: 242406, serviceable: "Yes", tier: "3" },
  { pincode: 242407, serviceable: "Yes", tier: "3" },
  { pincode: 243001, serviceable: "Yes", tier: "2" },
  { pincode: 243002, serviceable: "Yes", tier: "2" },
  { pincode: 243003, serviceable: "Yes", tier: "2" },
  { pincode: 243004, serviceable: "Yes", tier: "2" },
  { pincode: 243005, serviceable: "Yes", tier: "2" },
  { pincode: 243006, serviceable: "Yes", tier: "2" },
  { pincode: 243122, serviceable: "Yes", tier: "2" },
  { pincode: 243123, serviceable: "Yes", tier: "2" },
  { pincode: 243126, serviceable: "Yes", tier: "2" },
  { pincode: 243201, serviceable: "Yes", tier: "2" },
  { pincode: 243202, serviceable: "Yes", tier: "2" },
  { pincode: 243301, serviceable: "Yes", tier: "3" },
  { pincode: 243302, serviceable: "Yes", tier: "3" },
  { pincode: 243303, serviceable: "Yes", tier: "3" },
  { pincode: 243401, serviceable: "Yes", tier: "3" },
  { pincode: 243403, serviceable: "Yes", tier: "3" },
  { pincode: 243501, serviceable: "Yes", tier: "2" },
  { pincode: 243502, serviceable: "Yes", tier: "2" },
  { pincode: 243503, serviceable: "Yes", tier: "2" },
  { pincode: 243504, serviceable: "Yes", tier: "2" },
  { pincode: 243505, serviceable: "Yes", tier: "2" },
  { pincode: 243601, serviceable: "Yes", tier: "3" },
  { pincode: 243631, serviceable: "Yes", tier: "3" },
  { pincode: 243633, serviceable: "Yes", tier: "3" },
  { pincode: 243634, serviceable: "Yes", tier: "3" },
  { pincode: 243635, serviceable: "Yes", tier: "3" },
  { pincode: 243636, serviceable: "Yes", tier: "3" },
  { pincode: 243637, serviceable: "Yes", tier: "3" },
  { pincode: 243638, serviceable: "Yes", tier: "3" },
  { pincode: 243639, serviceable: "Yes", tier: "3" },
  { pincode: 243641, serviceable: "Yes", tier: "3" },
  { pincode: 243720, serviceable: "Yes", tier: "3" },
  { pincode: 243722, serviceable: "Yes", tier: "2" },
  { pincode: 243723, serviceable: "Yes", tier: "2" },
  { pincode: 243724, serviceable: "Yes", tier: "3" },
  { pincode: 243726, serviceable: "Yes", tier: "3" },
  { pincode: 243727, serviceable: "Yes", tier: "2" },
  { pincode: 244001, serviceable: "Yes", tier: "1" },
  { pincode: 244102, serviceable: "Yes", tier: "1" },
  { pincode: 244103, serviceable: "Yes", tier: "1" },
  { pincode: 244104, serviceable: "Yes", tier: "1" },
  { pincode: 244105, serviceable: "Yes", tier: "1" },
  { pincode: 244221, serviceable: "Yes", tier: "3" },
  { pincode: 244222, serviceable: "Yes", tier: "1" },
  { pincode: 244223, serviceable: "Yes", tier: "2" },
  { pincode: 244225, serviceable: "Yes", tier: "3" },
  { pincode: 244231, serviceable: "Yes", tier: "3" },
  { pincode: 244235, serviceable: "Yes", tier: "2" },
  { pincode: 244236, serviceable: "Yes", tier: "3" },
  { pincode: 244241, serviceable: "Yes", tier: "2" },
  { pincode: 244242, serviceable: "Yes", tier: "2" },
  { pincode: 244251, serviceable: "Yes", tier: "3" },
  { pincode: 244301, serviceable: "Yes", tier: "2" },
  { pincode: 244302, serviceable: "Yes", tier: "2" },
  { pincode: 244303, serviceable: "Yes", tier: "2" },
  { pincode: 244304, serviceable: "Yes", tier: "2" },
  { pincode: 244401, serviceable: "Yes", tier: "2" },
  { pincode: 244402, serviceable: "Yes", tier: "1" },
  { pincode: 244410, serviceable: "Yes", tier: "2" },
  { pincode: 244411, serviceable: "Yes", tier: "2" },
  { pincode: 244412, serviceable: "Yes", tier: "2" },
  { pincode: 244413, serviceable: "Yes", tier: "2" },
  { pincode: 244501, serviceable: "Yes", tier: "1" },
  { pincode: 244601, serviceable: "Yes", tier: "2" },
  { pincode: 244602, serviceable: "Yes", tier: "2" },
  { pincode: 244701, serviceable: "Yes", tier: "2" },
  { pincode: 244712, serviceable: "Yes", tier: "2" },
  { pincode: 244713, serviceable: "Yes", tier: "2" },
  { pincode: 244715, serviceable: "Yes", tier: "2" },
  { pincode: 244901, serviceable: "Yes", tier: "2" },
  { pincode: 244921, serviceable: "Yes", tier: "2" },
  { pincode: 244922, serviceable: "Yes", tier: "2" },
  { pincode: 244923, serviceable: "Yes", tier: "2" },
  { pincode: 244924, serviceable: "Yes", tier: "2" },
  { pincode: 244925, serviceable: "Yes", tier: "2" },
  { pincode: 244927, serviceable: "Yes", tier: "2" },
  { pincode: 244928, serviceable: "Yes", tier: "2" },
  { pincode: 245101, serviceable: "Yes", tier: "1" },
  { pincode: 245201, serviceable: "Yes", tier: "1" },
  { pincode: 245205, serviceable: "Yes", tier: "2" },
  { pincode: 245206, serviceable: "Yes", tier: "1" },
  { pincode: 245207, serviceable: "Yes", tier: "1" },
  { pincode: 245301, serviceable: "Yes", tier: "1" },
  { pincode: 245304, serviceable: "Yes", tier: "1" },
  { pincode: 246001, serviceable: "Yes", tier: "6" },
  { pincode: 246127, serviceable: "Yes", tier: "2" },
  { pincode: 246149, serviceable: "Yes", tier: "2" },
  { pincode: 246171, serviceable: "Yes", tier: "5" },
  { pincode: 246174, serviceable: "Yes", tier: "5" },
  { pincode: 246401, serviceable: "Yes", tier: "6" },
  { pincode: 246421, serviceable: "Yes", tier: "5" },
  { pincode: 246424, serviceable: "Yes", tier: "6" },
  { pincode: 246472, serviceable: "Yes", tier: "6" },
  { pincode: 246475, serviceable: "Yes", tier: "5" },
  { pincode: 246701, serviceable: "Yes", tier: "1" },
  { pincode: 246721, serviceable: "Yes", tier: "1" },
  { pincode: 246722, serviceable: "Yes", tier: "1" },
  { pincode: 246724, serviceable: "Yes", tier: "1" },
  { pincode: 246725, serviceable: "Yes", tier: "1" },
  { pincode: 246726, serviceable: "Yes", tier: "1" },
  { pincode: 246727, serviceable: "Yes", tier: "1" },
  { pincode: 246728, serviceable: "Yes", tier: "1" },
  { pincode: 246731, serviceable: "Yes", tier: "1" },
  { pincode: 246732, serviceable: "Yes", tier: "1" },
  { pincode: 246733, serviceable: "Yes", tier: "1" },
  { pincode: 246734, serviceable: "Yes", tier: "1" },
  { pincode: 246735, serviceable: "Yes", tier: "1" },
  { pincode: 246736, serviceable: "Yes", tier: "1" },
  { pincode: 246746, serviceable: "Yes", tier: "1" },
  { pincode: 246747, serviceable: "Yes", tier: "1" },
  { pincode: 246749, serviceable: "Yes", tier: "1" },
  { pincode: 246761, serviceable: "Yes", tier: "1" },
  { pincode: 246762, serviceable: "Yes", tier: "1" },
  { pincode: 246763, serviceable: "Yes", tier: "1" },
  { pincode: 246764, serviceable: "Yes", tier: "1" },
  { pincode: 247001, serviceable: "Yes", tier: "2" },
  { pincode: 247002, serviceable: "Yes", tier: "2" },
  { pincode: 247120, serviceable: "Yes", tier: "2" },
  { pincode: 247121, serviceable: "Yes", tier: "2" },
  { pincode: 247122, serviceable: "Yes", tier: "2" },
  { pincode: 247129, serviceable: "Yes", tier: "2" },
  { pincode: 247231, serviceable: "Yes", tier: "2" },
  { pincode: 247232, serviceable: "Yes", tier: "2" },
  { pincode: 247340, serviceable: "Yes", tier: "2" },
  { pincode: 247341, serviceable: "Yes", tier: "2" },
  { pincode: 247342, serviceable: "Yes", tier: "2" },
  { pincode: 247451, serviceable: "Yes", tier: "2" },
  { pincode: 247452, serviceable: "Yes", tier: "2" },
  { pincode: 247551, serviceable: "Yes", tier: "2" },
  { pincode: 247554, serviceable: "Yes", tier: "2" },
  { pincode: 247656, serviceable: "Yes", tier: "2" },
  { pincode: 247661, serviceable: "Yes", tier: "2" },
  { pincode: 247662, serviceable: "Yes", tier: "2" },
  { pincode: 247663, serviceable: "Yes", tier: "2" },
  { pincode: 247664, serviceable: "Yes", tier: "2" },
  { pincode: 247665, serviceable: "Yes", tier: "2" },
  { pincode: 247666, serviceable: "Yes", tier: "2" },
  { pincode: 247667, serviceable: "Yes", tier: "2" },
  { pincode: 247668, serviceable: "Yes", tier: "2" },
  { pincode: 247669, serviceable: "Yes", tier: "2" },
  { pincode: 247771, serviceable: "Yes", tier: "3" },
  { pincode: 247772, serviceable: "Yes", tier: "3" },
  { pincode: 247773, serviceable: "Yes", tier: "3" },
  { pincode: 247774, serviceable: "Yes", tier: "3" },
  { pincode: 247775, serviceable: "Yes", tier: "3" },
  { pincode: 247776, serviceable: "Yes", tier: "3" },
  { pincode: 247777, serviceable: "Yes", tier: "3" },
  { pincode: 247778, serviceable: "Yes", tier: "3" },
  { pincode: 248001, serviceable: "Yes", tier: "2" },
  { pincode: 248002, serviceable: "Yes", tier: "2" },
  { pincode: 248003, serviceable: "Yes", tier: "2" },
  { pincode: 248005, serviceable: "Yes", tier: "2" },
  { pincode: 248006, serviceable: "Yes", tier: "2" },
  { pincode: 248007, serviceable: "Yes", tier: "2" },
  { pincode: 248008, serviceable: "Yes", tier: "2" },
  { pincode: 248009, serviceable: "Yes", tier: "2" },
  { pincode: 248010, serviceable: "Yes", tier: "2" },
  { pincode: 248011, serviceable: "Yes", tier: "3" },
  { pincode: 248012, serviceable: "Yes", tier: "2" },
  { pincode: 248013, serviceable: "Yes", tier: "2" },
  { pincode: 248014, serviceable: "Yes", tier: "2" },
  { pincode: 248015, serviceable: "Yes", tier: "2" },
  { pincode: 248016, serviceable: "Yes", tier: "3" },
  { pincode: 248102, serviceable: "Yes", tier: "2" },
  { pincode: 248110, serviceable: "Yes", tier: "2" },
  { pincode: 248115, serviceable: "Yes", tier: "2" },
  { pincode: 248121, serviceable: "Yes", tier: "2" },
  { pincode: 248122, serviceable: "Yes", tier: "2" },
  { pincode: 248125, serviceable: "Yes", tier: "3" },
  { pincode: 248126, serviceable: "Yes", tier: "2" },
  { pincode: 248140, serviceable: "Yes", tier: "3" },
  { pincode: 248141, serviceable: "Yes", tier: "2" },
  { pincode: 248142, serviceable: "Yes", tier: "3" },
  { pincode: 248143, serviceable: "Yes", tier: "3" },
  { pincode: 248145, serviceable: "Yes", tier: "3" },
  { pincode: 248146, serviceable: "Yes", tier: "2" },
  { pincode: 248160, serviceable: "Yes", tier: "2" },
  { pincode: 248161, serviceable: "Yes", tier: "3" },
  { pincode: 248171, serviceable: "Yes", tier: "2" },
  { pincode: 248179, serviceable: "Yes", tier: "3" },
  { pincode: 248195, serviceable: "Yes", tier: "2" },
  { pincode: 248197, serviceable: "Yes", tier: "3" },
  { pincode: 248198, serviceable: "Yes", tier: "3" },
  { pincode: 249137, serviceable: "Yes", tier: "2" },
  { pincode: 249175, serviceable: "Yes", tier: "2" },
  { pincode: 249201, serviceable: "Yes", tier: "2" },
  { pincode: 249202, serviceable: "Yes", tier: "2" },
  { pincode: 249203, serviceable: "Yes", tier: "2" },
  { pincode: 249204, serviceable: "Yes", tier: "2" },
  { pincode: 249205, serviceable: "Yes", tier: "2" },
  { pincode: 249302, serviceable: "Yes", tier: "2" },
  { pincode: 249401, serviceable: "Yes", tier: "2" },
  { pincode: 249402, serviceable: "Yes", tier: "2" },
  { pincode: 249403, serviceable: "Yes", tier: "2" },
  { pincode: 249404, serviceable: "Yes", tier: "2" },
  { pincode: 249405, serviceable: "Yes", tier: "2" },
  { pincode: 249407, serviceable: "Yes", tier: "2" },
  { pincode: 249408, serviceable: "Yes", tier: "2" },
  { pincode: 249409, serviceable: "Yes", tier: "2" },
  { pincode: 249410, serviceable: "Yes", tier: "2" },
  { pincode: 249411, serviceable: "Yes", tier: "2" },
  { pincode: 250001, serviceable: "Yes", tier: "1" },
  { pincode: 250002, serviceable: "Yes", tier: "1" },
  { pincode: 250003, serviceable: "Yes", tier: "1" },
  { pincode: 250004, serviceable: "Yes", tier: "1" },
  { pincode: 250005, serviceable: "Yes", tier: "1" },
  { pincode: 250101, serviceable: "Yes", tier: "2" },
  { pincode: 250103, serviceable: "Yes", tier: "2" },
  { pincode: 250104, serviceable: "Yes", tier: "2" },
  { pincode: 250105, serviceable: "Yes", tier: "1" },
  { pincode: 250106, serviceable: "Yes", tier: "2" },
  { pincode: 250110, serviceable: "Yes", tier: "1" },
  { pincode: 250205, serviceable: "Yes", tier: "2" },
  { pincode: 250221, serviceable: "Yes", tier: "2" },
  { pincode: 250222, serviceable: "Yes", tier: "2" },
  { pincode: 250223, serviceable: "Yes", tier: "2" },
  { pincode: 250341, serviceable: "Yes", tier: "2" },
  { pincode: 250342, serviceable: "Yes", tier: "2" },
  { pincode: 250345, serviceable: "Yes", tier: "2" },
  { pincode: 250401, serviceable: "Yes", tier: "2" },
  { pincode: 250402, serviceable: "Yes", tier: "2" },
  { pincode: 250404, serviceable: "Yes", tier: "2" },
  { pincode: 250406, serviceable: "Yes", tier: "2" },
  { pincode: 250501, serviceable: "Yes", tier: "2" },
  { pincode: 250502, serviceable: "Yes", tier: "2" },
  { pincode: 250601, serviceable: "Yes", tier: "2" },
  { pincode: 250606, serviceable: "Yes", tier: "2" },
  { pincode: 250609, serviceable: "Yes", tier: "2" },
  { pincode: 250611, serviceable: "Yes", tier: "2" },
  { pincode: 250615, serviceable: "Yes", tier: "2" },
  { pincode: 250617, serviceable: "Yes", tier: "2" },
  { pincode: 250619, serviceable: "Yes", tier: "2" },
  { pincode: 250620, serviceable: "Yes", tier: "2" },
  { pincode: 250622, serviceable: "Yes", tier: "2" },
  { pincode: 250625, serviceable: "Yes", tier: "2" },
  { pincode: 251001, serviceable: "Yes", tier: "2" },
  { pincode: 251002, serviceable: "Yes", tier: "2" },
  { pincode: 251003, serviceable: "Yes", tier: "2" },
  { pincode: 251201, serviceable: "Yes", tier: "2" },
  { pincode: 251202, serviceable: "Yes", tier: "2" },
  { pincode: 251203, serviceable: "Yes", tier: "2" },
  { pincode: 251301, serviceable: "Yes", tier: "3" },
  { pincode: 251305, serviceable: "Yes", tier: "3" },
  { pincode: 251306, serviceable: "Yes", tier: "2" },
  { pincode: 251307, serviceable: "Yes", tier: "2" },
  { pincode: 251308, serviceable: "Yes", tier: "2" },
  { pincode: 251309, serviceable: "Yes", tier: "3" },
  { pincode: 251310, serviceable: "Yes", tier: "2" },
  { pincode: 251311, serviceable: "Yes", tier: "2" },
  { pincode: 251314, serviceable: "Yes", tier: "2" },
  { pincode: 251315, serviceable: "Yes", tier: "2" },
  { pincode: 251316, serviceable: "Yes", tier: "2" },
  { pincode: 251318, serviceable: "Yes", tier: "2" },
  { pincode: 251319, serviceable: "Yes", tier: "3" },
  { pincode: 251327, serviceable: "Yes", tier: "2" },
  { pincode: 261001, serviceable: "Yes", tier: "2" },
  { pincode: 261121, serviceable: "Yes", tier: "3" },
  { pincode: 261131, serviceable: "Yes", tier: "3" },
  { pincode: 261135, serviceable: "Yes", tier: "2" },
  { pincode: 261141, serviceable: "Yes", tier: "3" },
  { pincode: 261201, serviceable: "Yes", tier: "3" },
  { pincode: 261202, serviceable: "Yes", tier: "3" },
  { pincode: 261203, serviceable: "Yes", tier: "3" },
  { pincode: 261204, serviceable: "Yes", tier: "3" },
  { pincode: 261205, serviceable: "Yes", tier: "3" },
  { pincode: 261206, serviceable: "Yes", tier: "3" },
  { pincode: 261208, serviceable: "Yes", tier: "3" },
  { pincode: 261301, serviceable: "Yes", tier: "3" },
  { pincode: 261302, serviceable: "Yes", tier: "3" },
  { pincode: 261303, serviceable: "Yes", tier: "3" },
  { pincode: 261401, serviceable: "Yes", tier: "3" },
  { pincode: 261402, serviceable: "Yes", tier: "3" },
  { pincode: 261403, serviceable: "Yes", tier: "3" },
  { pincode: 261405, serviceable: "Yes", tier: "3" },
  { pincode: 261501, serviceable: "Yes", tier: "2" },
  { pincode: 261505, serviceable: "Yes", tier: "3" },
  { pincode: 261506, serviceable: "Yes", tier: "2" },
  { pincode: 262001, serviceable: "Yes", tier: "3" },
  { pincode: 262122, serviceable: "Yes", tier: "3" },
  { pincode: 262201, serviceable: "Yes", tier: "3" },
  { pincode: 262302, serviceable: "Yes", tier: "2" },
  { pincode: 262308, serviceable: "Yes", tier: "3" },
  { pincode: 262401, serviceable: "Yes", tier: "2" },
  { pincode: 262405, serviceable: "Yes", tier: "3" },
  { pincode: 262406, serviceable: "Yes", tier: "2" },
  { pincode: 262501, serviceable: "Yes", tier: "5" },
  { pincode: 262520, serviceable: "Yes", tier: "5" },
  { pincode: 262523, serviceable: "Yes", tier: "5" },
  { pincode: 262524, serviceable: "Yes", tier: "5" },
  { pincode: 262530, serviceable: "Yes", tier: "5" },
  { pincode: 262701, serviceable: "Yes", tier: "2" },
  { pincode: 262702, serviceable: "Yes", tier: "2" },
  { pincode: 262721, serviceable: "Yes", tier: "2" },
  { pincode: 262722, serviceable: "Yes", tier: "2" },
  { pincode: 262724, serviceable: "Yes", tier: "2" },
  { pincode: 262725, serviceable: "Yes", tier: "2" },
  { pincode: 262726, serviceable: "Yes", tier: "2" },
  { pincode: 262728, serviceable: "Yes", tier: "2" },
  { pincode: 262801, serviceable: "Yes", tier: "3" },
  { pincode: 262802, serviceable: "Yes", tier: "3" },
  { pincode: 262803, serviceable: "Yes", tier: "3" },
  { pincode: 262804, serviceable: "Yes", tier: "3" },
  { pincode: 262805, serviceable: "Yes", tier: "3" },
  { pincode: 262901, serviceable: "Yes", tier: "3" },
  { pincode: 262902, serviceable: "Yes", tier: "3" },
  { pincode: 262903, serviceable: "Yes", tier: "2" },
  { pincode: 262907, serviceable: "Yes", tier: "2" },
  { pincode: 263126, serviceable: "Yes", tier: "3" },
  { pincode: 263139, serviceable: "Yes", tier: "3" },
  { pincode: 263141, serviceable: "Yes", tier: "3" },
  { pincode: 263145, serviceable: "Yes", tier: "2" },
  { pincode: 263148, serviceable: "Yes", tier: "2" },
  { pincode: 263152, serviceable: "Yes", tier: "2" },
  { pincode: 263153, serviceable: "Yes", tier: "2" },
  { pincode: 263160, serviceable: "Yes", tier: "2" },
  { pincode: 263601, serviceable: "Yes", tier: "5" },
  { pincode: 263637, serviceable: "Yes", tier: "5" },
  { pincode: 263645, serviceable: "Yes", tier: "3" },
  { pincode: 263653, serviceable: "Yes", tier: "5" },
  { pincode: 263656, serviceable: "Yes", tier: "5" },
  { pincode: 271001, serviceable: "Yes", tier: "5" },
  { pincode: 271002, serviceable: "Yes", tier: "5" },
  { pincode: 271003, serviceable: "Yes", tier: "5" },
  { pincode: 271201, serviceable: "Yes", tier: "5" },
  { pincode: 271205, serviceable: "Yes", tier: "5" },
  { pincode: 271208, serviceable: "Yes", tier: "5" },
  { pincode: 271210, serviceable: "Yes", tier: "5" },
  { pincode: 271302, serviceable: "Yes", tier: "5" },
  { pincode: 271303, serviceable: "Yes", tier: "5" },
  { pincode: 271305, serviceable: "Yes", tier: "5" },
  { pincode: 271306, serviceable: "Yes", tier: "5" },
  { pincode: 271313, serviceable: "Yes", tier: "3" },
  { pincode: 271604, serviceable: "Yes", tier: "5" },
  { pincode: 271607, serviceable: "Yes", tier: "5" },
  { pincode: 271609, serviceable: "Yes", tier: "5" },
  { pincode: 271801, serviceable: "Yes", tier: "3" },
  { pincode: 271803, serviceable: "Yes", tier: "3" },
  { pincode: 271821, serviceable: "Yes", tier: "3" },
  { pincode: 271824, serviceable: "Yes", tier: "3" },
  { pincode: 271831, serviceable: "Yes", tier: "3" },
  { pincode: 271835, serviceable: "Yes", tier: "3" },
  { pincode: 271845, serviceable: "Yes", tier: "5" },
  { pincode: 271851, serviceable: "Yes", tier: "3" },
  { pincode: 271855, serviceable: "Yes", tier: "3" },
  { pincode: 271861, serviceable: "Yes", tier: "5" },
  { pincode: 271865, serviceable: "Yes", tier: "3" },
  { pincode: 271871, serviceable: "Yes", tier: "3" },
  { pincode: 271875, serviceable: "Yes", tier: "3" },
  { pincode: 271882, serviceable: "Yes", tier: "3" },
  { pincode: 271902, serviceable: "Yes", tier: "3" },
  { pincode: 271903, serviceable: "Yes", tier: "3" },
  { pincode: 272001, serviceable: "Yes", tier: "3" },
  { pincode: 272002, serviceable: "Yes", tier: "3" },
  { pincode: 272123, serviceable: "Yes", tier: "3" },
  { pincode: 272124, serviceable: "Yes", tier: "3" },
  { pincode: 272125, serviceable: "Yes", tier: "3" },
  { pincode: 272127, serviceable: "Yes", tier: "3" },
  { pincode: 272131, serviceable: "Yes", tier: "3" },
  { pincode: 272151, serviceable: "Yes", tier: "3" },
  { pincode: 272152, serviceable: "Yes", tier: "5" },
  { pincode: 272153, serviceable: "Yes", tier: "5" },
  { pincode: 272155, serviceable: "Yes", tier: "3" },
  { pincode: 272162, serviceable: "Yes", tier: "3" },
  { pincode: 272163, serviceable: "Yes", tier: "3" },
  { pincode: 272164, serviceable: "Yes", tier: "3" },
  { pincode: 272172, serviceable: "Yes", tier: "3" },
  { pincode: 272173, serviceable: "Yes", tier: "3" },
  { pincode: 272175, serviceable: "Yes", tier: "3" },
  { pincode: 272176, serviceable: "Yes", tier: "3" },
  { pincode: 272178, serviceable: "Yes", tier: "3" },
  { pincode: 272182, serviceable: "Yes", tier: "3" },
  { pincode: 272189, serviceable: "Yes", tier: "5" },
  { pincode: 272190, serviceable: "Yes", tier: "3" },
  { pincode: 272192, serviceable: "Yes", tier: "5" },
  { pincode: 272194, serviceable: "Yes", tier: "3" },
  { pincode: 272199, serviceable: "Yes", tier: "3" },
  { pincode: 272201, serviceable: "Yes", tier: "5" },
  { pincode: 272202, serviceable: "Yes", tier: "5" },
  { pincode: 272203, serviceable: "Yes", tier: "5" },
  { pincode: 272204, serviceable: "Yes", tier: "5" },
  { pincode: 272205, serviceable: "Yes", tier: "5" },
  { pincode: 272206, serviceable: "Yes", tier: "5" },
  { pincode: 272207, serviceable: "Yes", tier: "5" },
  { pincode: 272270, serviceable: "Yes", tier: "3" },
  { pincode: 272271, serviceable: "Yes", tier: "3" },
  { pincode: 272301, serviceable: "Yes", tier: "3" },
  { pincode: 272302, serviceable: "Yes", tier: "3" },
  { pincode: 273001, serviceable: "Yes", tier: "3" },
  { pincode: 273002, serviceable: "Yes", tier: "3" },
  { pincode: 273003, serviceable: "Yes", tier: "3" },
  { pincode: 273004, serviceable: "Yes", tier: "3" },
  { pincode: 273005, serviceable: "Yes", tier: "3" },
  { pincode: 273006, serviceable: "Yes", tier: "3" },
  { pincode: 273007, serviceable: "Yes", tier: "3" },
  { pincode: 273008, serviceable: "Yes", tier: "3" },
  { pincode: 273009, serviceable: "Yes", tier: "3" },
  { pincode: 273010, serviceable: "Yes", tier: "3" },
  { pincode: 273012, serviceable: "Yes", tier: "3" },
  { pincode: 273013, serviceable: "Yes", tier: "3" },
  { pincode: 273014, serviceable: "Yes", tier: "3" },
  { pincode: 273015, serviceable: "Yes", tier: "3" },
  { pincode: 273016, serviceable: "Yes", tier: "3" },
  { pincode: 273017, serviceable: "Yes", tier: "3" },
  { pincode: 273151, serviceable: "Yes", tier: "5" },
  { pincode: 273152, serviceable: "Yes", tier: "3" },
  { pincode: 273155, serviceable: "Yes", tier: "5" },
  { pincode: 273161, serviceable: "Yes", tier: "5" },
  { pincode: 273162, serviceable: "Yes", tier: "5" },
  { pincode: 273163, serviceable: "Yes", tier: "5" },
  { pincode: 273164, serviceable: "Yes", tier: "5" },
  { pincode: 273165, serviceable: "Yes", tier: "3" },
  { pincode: 273201, serviceable: "Yes", tier: "3" },
  { pincode: 273202, serviceable: "Yes", tier: "3" },
  { pincode: 273203, serviceable: "Yes", tier: "3" },
  { pincode: 273207, serviceable: "Yes", tier: "5" },
  { pincode: 273209, serviceable: "Yes", tier: "3" },
  { pincode: 273212, serviceable: "Yes", tier: "5" },
  { pincode: 273213, serviceable: "Yes", tier: "5" },
  { pincode: 273301, serviceable: "Yes", tier: "5" },
  { pincode: 273302, serviceable: "Yes", tier: "5" },
  { pincode: 273303, serviceable: "Yes", tier: "5" },
  { pincode: 273304, serviceable: "Yes", tier: "5" },
  { pincode: 273305, serviceable: "Yes", tier: "5" },
  { pincode: 273308, serviceable: "Yes", tier: "5" },
  { pincode: 273310, serviceable: "Yes", tier: "5" },
  { pincode: 273401, serviceable: "Yes", tier: "5" },
  { pincode: 273402, serviceable: "Yes", tier: "5" },
  { pincode: 273403, serviceable: "Yes", tier: "5" },
  { pincode: 273406, serviceable: "Yes", tier: "5" },
  { pincode: 273408, serviceable: "Yes", tier: "5" },
  { pincode: 273409, serviceable: "Yes", tier: "5" },
  { pincode: 273411, serviceable: "Yes", tier: "5" },
  { pincode: 273412, serviceable: "Yes", tier: "5" },
  { pincode: 273413, serviceable: "Yes", tier: "5" },
  { pincode: 274001, serviceable: "Yes", tier: "5" },
  { pincode: 274202, serviceable: "Yes", tier: "5" },
  { pincode: 274204, serviceable: "Yes", tier: "5" },
  { pincode: 274304, serviceable: "Yes", tier: "5" },
  { pincode: 274401, serviceable: "Yes", tier: "5" },
  { pincode: 274402, serviceable: "Yes", tier: "5" },
  { pincode: 274403, serviceable: "Yes", tier: "5" },
  { pincode: 274404, serviceable: "Yes", tier: "5" },
  { pincode: 274406, serviceable: "Yes", tier: "5" },
  { pincode: 274502, serviceable: "Yes", tier: "5" },
  { pincode: 274509, serviceable: "Yes", tier: "5" },
  { pincode: 274601, serviceable: "Yes", tier: "5" },
  { pincode: 274702, serviceable: "Yes", tier: "5" },
  { pincode: 275101, serviceable: "Yes", tier: "5" },
  { pincode: 275102, serviceable: "Yes", tier: "5" },
  { pincode: 275201, serviceable: "Yes", tier: "5" },
  { pincode: 275301, serviceable: "Yes", tier: "5" },
  { pincode: 275303, serviceable: "Yes", tier: "5" },
  { pincode: 275304, serviceable: "Yes", tier: "5" },
  { pincode: 275305, serviceable: "Yes", tier: "5" },
  { pincode: 275307, serviceable: "Yes", tier: "5" },
  { pincode: 276001, serviceable: "Yes", tier: "5" },
  { pincode: 276121, serviceable: "Yes", tier: "5" },
  { pincode: 276128, serviceable: "Yes", tier: "5" },
  { pincode: 276129, serviceable: "Yes", tier: "5" },
  { pincode: 276141, serviceable: "Yes", tier: "5" },
  { pincode: 276202, serviceable: "Yes", tier: "5" },
  { pincode: 276204, serviceable: "Yes", tier: "5" },
  { pincode: 276206, serviceable: "Yes", tier: "5" },
  { pincode: 276207, serviceable: "Yes", tier: "5" },
  { pincode: 276303, serviceable: "Yes", tier: "5" },
  { pincode: 276304, serviceable: "Yes", tier: "5" },
  { pincode: 276305, serviceable: "Yes", tier: "5" },
  { pincode: 276306, serviceable: "Yes", tier: "5" },
  { pincode: 276402, serviceable: "Yes", tier: "5" },
  { pincode: 276403, serviceable: "Yes", tier: "5" },
  { pincode: 276404, serviceable: "Yes", tier: "5" },
  { pincode: 277001, serviceable: "Yes", tier: "5" },
  { pincode: 277123, serviceable: "Yes", tier: "5" },
  { pincode: 277202, serviceable: "Yes", tier: "5" },
  { pincode: 277209, serviceable: "Yes", tier: "5" },
  { pincode: 277211, serviceable: "Yes", tier: "5" },
  { pincode: 277303, serviceable: "Yes", tier: "5" },
  { pincode: 277304, serviceable: "Yes", tier: "5" },
  { pincode: 277401, serviceable: "Yes", tier: "5" },
  { pincode: 277501, serviceable: "Yes", tier: "5" },
  { pincode: 277503, serviceable: "Yes", tier: "5" },
  { pincode: 281001, serviceable: "Yes", tier: "1" },
  { pincode: 281003, serviceable: "Yes", tier: "1" },
  { pincode: 281004, serviceable: "Yes", tier: "1" },
  { pincode: 281005, serviceable: "Yes", tier: "1" },
  { pincode: 281006, serviceable: "Yes", tier: "1" },
  { pincode: 281121, serviceable: "Yes", tier: "1" },
  { pincode: 281122, serviceable: "Yes", tier: "1" },
  { pincode: 281123, serviceable: "Yes", tier: "1" },
  { pincode: 281201, serviceable: "Yes", tier: "1" },
  { pincode: 281202, serviceable: "Yes", tier: "1" },
  { pincode: 281204, serviceable: "Yes", tier: "1" },
  { pincode: 281301, serviceable: "Yes", tier: "1" },
  { pincode: 281306, serviceable: "Yes", tier: "2" },
  { pincode: 281401, serviceable: "Yes", tier: "1" },
  { pincode: 281403, serviceable: "Yes", tier: "1" },
  { pincode: 281406, serviceable: "Yes", tier: "1" },
  { pincode: 281501, serviceable: "Yes", tier: "1" },
  { pincode: 281502, serviceable: "Yes", tier: "1" },
  { pincode: 282001, serviceable: "Yes", tier: "2" },
  { pincode: 282002, serviceable: "Yes", tier: "2" },
  { pincode: 282003, serviceable: "Yes", tier: "2" },
  { pincode: 282004, serviceable: "Yes", tier: "2" },
  { pincode: 282005, serviceable: "Yes", tier: "2" },
  { pincode: 282006, serviceable: "Yes", tier: "2" },
  { pincode: 282007, serviceable: "Yes", tier: "2" },
  { pincode: 282008, serviceable: "Yes", tier: "2" },
  { pincode: 282009, serviceable: "Yes", tier: "2" },
  { pincode: 282010, serviceable: "Yes", tier: "2" },
  { pincode: 283101, serviceable: "Yes", tier: "2" },
  { pincode: 283102, serviceable: "Yes", tier: "2" },
  { pincode: 283105, serviceable: "Yes", tier: "2" },
  { pincode: 283110, serviceable: "Yes", tier: "2" },
  { pincode: 283111, serviceable: "Yes", tier: "2" },
  { pincode: 283112, serviceable: "Yes", tier: "2" },
  { pincode: 283119, serviceable: "Yes", tier: "2" },
  { pincode: 283121, serviceable: "Yes", tier: "2" },
  { pincode: 283122, serviceable: "Yes", tier: "2" },
  { pincode: 283124, serviceable: "Yes", tier: "2" },
  { pincode: 283125, serviceable: "Yes", tier: "2" },
  { pincode: 283126, serviceable: "Yes", tier: "2" },
  { pincode: 283130, serviceable: "Yes", tier: "2" },
  { pincode: 283135, serviceable: "Yes", tier: "2" },
  { pincode: 283145, serviceable: "Yes", tier: "2" },
  { pincode: 283151, serviceable: "Yes", tier: "2" },
  { pincode: 283152, serviceable: "Yes", tier: "2" },
  { pincode: 283201, serviceable: "Yes", tier: "2" },
  { pincode: 283202, serviceable: "Yes", tier: "2" },
  { pincode: 283203, serviceable: "Yes", tier: "2" },
  { pincode: 283204, serviceable: "Yes", tier: "2" },
  { pincode: 284001, serviceable: "Yes", tier: "3" },
  { pincode: 284002, serviceable: "Yes", tier: "3" },
  { pincode: 284003, serviceable: "Yes", tier: "3" },
  { pincode: 284120, serviceable: "Yes", tier: "3" },
  { pincode: 284121, serviceable: "Yes", tier: "3" },
  { pincode: 284124, serviceable: "Yes", tier: "5" },
  { pincode: 284125, serviceable: "Yes", tier: "5" },
  { pincode: 284126, serviceable: "Yes", tier: "5" },
  { pincode: 284128, serviceable: "Yes", tier: "3" },
  { pincode: 284135, serviceable: "Yes", tier: "3" },
  { pincode: 284201, serviceable: "Yes", tier: "3" },
  { pincode: 284202, serviceable: "Yes", tier: "3" },
  { pincode: 284204, serviceable: "Yes", tier: "3" },
  { pincode: 284205, serviceable: "Yes", tier: "3" },
  { pincode: 284301, serviceable: "Yes", tier: "3" },
  { pincode: 284303, serviceable: "Yes", tier: "3" },
  { pincode: 284305, serviceable: "Yes", tier: "3" },
  { pincode: 284401, serviceable: "Yes", tier: "3" },
  { pincode: 284403, serviceable: "Yes", tier: "5" },
  { pincode: 284404, serviceable: "Yes", tier: "5" },
  { pincode: 284405, serviceable: "Yes", tier: "5" },
  { pincode: 285001, serviceable: "Yes", tier: "2" },
  { pincode: 285122, serviceable: "Yes", tier: "3" },
  { pincode: 285123, serviceable: "Yes", tier: "3" },
  { pincode: 285201, serviceable: "Yes", tier: "3" },
  { pincode: 285202, serviceable: "Yes", tier: "3" },
  { pincode: 285204, serviceable: "Yes", tier: "3" },
  { pincode: 285205, serviceable: "Yes", tier: "3" },
  { pincode: 301001, serviceable: "Yes", tier: "1" },
  { pincode: 301018, serviceable: "Yes", tier: "1" },
  { pincode: 301019, serviceable: "Yes", tier: "1" },
  { pincode: 301020, serviceable: "Yes", tier: "1" },
  { pincode: 301021, serviceable: "Yes", tier: "1" },
  { pincode: 301022, serviceable: "Yes", tier: "2" },
  { pincode: 301024, serviceable: "Yes", tier: "2" },
  { pincode: 301030, serviceable: "Yes", tier: "1" },
  { pincode: 301402, serviceable: "Yes", tier: "2" },
  { pincode: 301404, serviceable: "Yes", tier: "1" },
  { pincode: 301405, serviceable: "Yes", tier: "1" },
  { pincode: 301411, serviceable: "Yes", tier: "1" },
  { pincode: 301427, serviceable: "Yes", tier: "1" },
  { pincode: 301701, serviceable: "Yes", tier: "1" },
  { pincode: 301702, serviceable: "Yes", tier: "1" },
  { pincode: 301703, serviceable: "Yes", tier: "1" },
  { pincode: 301704, serviceable: "Yes", tier: "1" },
  { pincode: 301705, serviceable: "Yes", tier: "1" },
  { pincode: 301706, serviceable: "Yes", tier: "1" },
  { pincode: 301707, serviceable: "Yes", tier: "1" },
  { pincode: 301713, serviceable: "Yes", tier: "1" },
  { pincode: 302001, serviceable: "Yes", tier: "2" },
  { pincode: 302002, serviceable: "Yes", tier: "2" },
  { pincode: 302003, serviceable: "Yes", tier: "2" },
  { pincode: 302004, serviceable: "Yes", tier: "2" },
  { pincode: 302005, serviceable: "Yes", tier: "2" },
  { pincode: 302006, serviceable: "Yes", tier: "2" },
  { pincode: 302007, serviceable: "Yes", tier: "2" },
  { pincode: 302008, serviceable: "Yes", tier: "2" },
  { pincode: 302009, serviceable: "Yes", tier: "2" },
  { pincode: 302010, serviceable: "Yes", tier: "2" },
  { pincode: 302011, serviceable: "Yes", tier: "2" },
  { pincode: 302012, serviceable: "Yes", tier: "2" },
  { pincode: 302013, serviceable: "Yes", tier: "2" },
  { pincode: 302015, serviceable: "Yes", tier: "2" },
  { pincode: 302016, serviceable: "Yes", tier: "2" },
  { pincode: 302017, serviceable: "Yes", tier: "2" },
  { pincode: 302018, serviceable: "Yes", tier: "2" },
  { pincode: 302019, serviceable: "Yes", tier: "2" },
  { pincode: 302020, serviceable: "Yes", tier: "2" },
  { pincode: 302021, serviceable: "Yes", tier: "2" },
  { pincode: 302022, serviceable: "Yes", tier: "2" },
  { pincode: 302023, serviceable: "Yes", tier: "2" },
  { pincode: 302024, serviceable: "Yes", tier: "2" },
  { pincode: 302025, serviceable: "Yes", tier: "2" },
  { pincode: 302026, serviceable: "Yes", tier: "2" },
  { pincode: 302027, serviceable: "Yes", tier: "2" },
  { pincode: 302028, serviceable: "Yes", tier: "2" },
  { pincode: 302029, serviceable: "Yes", tier: "2" },
  { pincode: 302031, serviceable: "Yes", tier: "2" },
  { pincode: 302032, serviceable: "Yes", tier: "2" },
  { pincode: 302033, serviceable: "Yes", tier: "2" },
  { pincode: 302034, serviceable: "Yes", tier: "2" },
  { pincode: 302037, serviceable: "Yes", tier: "2" },
  { pincode: 302039, serviceable: "Yes", tier: "2" },
  { pincode: 302111, serviceable: "Yes", tier: "2" },
  { pincode: 303005, serviceable: "Yes", tier: "2" },
  { pincode: 303007, serviceable: "Yes", tier: "2" },
  { pincode: 303008, serviceable: "Yes", tier: "2" },
  { pincode: 303012, serviceable: "Yes", tier: "2" },
  { pincode: 303101, serviceable: "Yes", tier: "2" },
  { pincode: 303103, serviceable: "Yes", tier: "2" },
  { pincode: 303106, serviceable: "Yes", tier: "2" },
  { pincode: 303108, serviceable: "Yes", tier: "2" },
  { pincode: 303301, serviceable: "Yes", tier: "2" },
  { pincode: 303303, serviceable: "Yes", tier: "2" },
  { pincode: 303305, serviceable: "Yes", tier: "2" },
  { pincode: 303313, serviceable: "Yes", tier: "2" },
  { pincode: 303326, serviceable: "Yes", tier: "2" },
  { pincode: 303338, serviceable: "Yes", tier: "2" },
  { pincode: 303501, serviceable: "Yes", tier: "2" },
  { pincode: 303503, serviceable: "Yes", tier: "2" },
  { pincode: 303504, serviceable: "Yes", tier: "2" },
  { pincode: 303505, serviceable: "Yes", tier: "2" },
  { pincode: 303509, serviceable: "Yes", tier: "2" },
  { pincode: 303510, serviceable: "Yes", tier: "2" },
  { pincode: 303511, serviceable: "Yes", tier: "2" },
  { pincode: 303702, serviceable: "Yes", tier: "2" },
  { pincode: 303704, serviceable: "Yes", tier: "2" },
  { pincode: 303712, serviceable: "Yes", tier: "2" },
  { pincode: 303805, serviceable: "Yes", tier: "2" },
  { pincode: 303806, serviceable: "Yes", tier: "2" },
  { pincode: 303901, serviceable: "Yes", tier: "2" },
  { pincode: 303903, serviceable: "Yes", tier: "2" },
  { pincode: 303904, serviceable: "Yes", tier: "2" },
  { pincode: 303905, serviceable: "Yes", tier: "2" },
  { pincode: 303908, serviceable: "Yes", tier: "2" },
  { pincode: 304021, serviceable: "Yes", tier: "2" },
  { pincode: 304022, serviceable: "Yes", tier: "2" },
  { pincode: 305001, serviceable: "Yes", tier: "2" },
  { pincode: 305002, serviceable: "Yes", tier: "2" },
  { pincode: 305003, serviceable: "Yes", tier: "2" },
  { pincode: 305004, serviceable: "Yes", tier: "2" },
  { pincode: 305005, serviceable: "Yes", tier: "2" },
  { pincode: 305006, serviceable: "Yes", tier: "2" },
  { pincode: 305007, serviceable: "Yes", tier: "2" },
  { pincode: 305008, serviceable: "Yes", tier: "2" },
  { pincode: 305022, serviceable: "Yes", tier: "3" },
  { pincode: 305025, serviceable: "Yes", tier: "3" },
  { pincode: 305401, serviceable: "Yes", tier: "3" },
  { pincode: 305402, serviceable: "Yes", tier: "3" },
  { pincode: 305404, serviceable: "Yes", tier: "2" },
  { pincode: 305601, serviceable: "Yes", tier: "3" },
  { pincode: 305624, serviceable: "Yes", tier: "2" },
  { pincode: 305801, serviceable: "Yes", tier: "2" },
  { pincode: 305802, serviceable: "Yes", tier: "2" },
  { pincode: 305814, serviceable: "Yes", tier: "2" },
  { pincode: 305817, serviceable: "Yes", tier: "2" },
  { pincode: 305901, serviceable: "Yes", tier: "2" },
  { pincode: 306103, serviceable: "Yes", tier: "2" },
  { pincode: 306104, serviceable: "Yes", tier: "2" },
  { pincode: 306115, serviceable: "Yes", tier: "2" },
  { pincode: 306116, serviceable: "Yes", tier: "2" },
  { pincode: 306302, serviceable: "Yes", tier: "3" },
  { pincode: 306401, serviceable: "Yes", tier: "2" },
  { pincode: 306902, serviceable: "Yes", tier: "3" },
  { pincode: 307001, serviceable: "Yes", tier: "2" },
  { pincode: 307019, serviceable: "Yes", tier: "2" },
  { pincode: 307022, serviceable: "Yes", tier: "2" },
  { pincode: 307023, serviceable: "Yes", tier: "2" },
  { pincode: 307026, serviceable: "Yes", tier: "2" },
  { pincode: 307027, serviceable: "Yes", tier: "2" },
  { pincode: 307029, serviceable: "Yes", tier: "3" },
  { pincode: 307510, serviceable: "Yes", tier: "2" },
  { pincode: 307513, serviceable: "Yes", tier: "2" },
  { pincode: 307514, serviceable: "Yes", tier: "2" },
  { pincode: 307801, serviceable: "Yes", tier: "2" },
  { pincode: 311001, serviceable: "Yes", tier: "2" },
  { pincode: 311011, serviceable: "Yes", tier: "2" },
  { pincode: 311021, serviceable: "Yes", tier: "2" },
  { pincode: 311022, serviceable: "Yes", tier: "2" },
  { pincode: 311024, serviceable: "Yes", tier: "2" },
  { pincode: 311025, serviceable: "Yes", tier: "2" },
  { pincode: 311301, serviceable: "Yes", tier: "2" },
  { pincode: 311401, serviceable: "Yes", tier: "2" },
  { pincode: 311402, serviceable: "Yes", tier: "2" },
  { pincode: 311403, serviceable: "Yes", tier: "2" },
  { pincode: 311601, serviceable: "Yes", tier: "2" },
  { pincode: 311603, serviceable: "Yes", tier: "2" },
  { pincode: 311604, serviceable: "Yes", tier: "2" },
  { pincode: 311801, serviceable: "Yes", tier: "2" },
  { pincode: 311802, serviceable: "Yes", tier: "2" },
  { pincode: 312001, serviceable: "Yes", tier: "3" },
  { pincode: 312021, serviceable: "Yes", tier: "3" },
  { pincode: 312022, serviceable: "Yes", tier: "3" },
  { pincode: 312024, serviceable: "Yes", tier: "3" },
  { pincode: 312601, serviceable: "Yes", tier: "3" },
  { pincode: 312605, serviceable: "Yes", tier: "2" },
  { pincode: 312612, serviceable: "Yes", tier: "3" },
  { pincode: 312617, serviceable: "Yes", tier: "3" },
  { pincode: 312901, serviceable: "Yes", tier: "3" },
  { pincode: 313001, serviceable: "Yes", tier: "2" },
  { pincode: 313002, serviceable: "Yes", tier: "2" },
  { pincode: 313003, serviceable: "Yes", tier: "2" },
  { pincode: 313004, serviceable: "Yes", tier: "2" },
  { pincode: 313011, serviceable: "Yes", tier: "2" },
  { pincode: 313022, serviceable: "Yes", tier: "2" },
  { pincode: 313024, serviceable: "Yes", tier: "2" },
  { pincode: 313202, serviceable: "Yes", tier: "2" },
  { pincode: 313203, serviceable: "Yes", tier: "2" },
  { pincode: 313205, serviceable: "Yes", tier: "2" },
  { pincode: 313211, serviceable: "Yes", tier: "2" },
  { pincode: 313301, serviceable: "Yes", tier: "2" },
  { pincode: 313324, serviceable: "Yes", tier: "2" },
  { pincode: 313601, serviceable: "Yes", tier: "2" },
  { pincode: 313602, serviceable: "Yes", tier: "2" },
  { pincode: 313901, serviceable: "Yes", tier: "2" },
  { pincode: 314025, serviceable: "Yes", tier: "2" },
  { pincode: 314026, serviceable: "Yes", tier: "2" },
  { pincode: 321001, serviceable: "Yes", tier: "2" },
  { pincode: 321201, serviceable: "Yes", tier: "2" },
  { pincode: 321202, serviceable: "Yes", tier: "2" },
  { pincode: 321401, serviceable: "Yes", tier: "2" },
  { pincode: 321404, serviceable: "Yes", tier: "2" },
  { pincode: 321602, serviceable: "Yes", tier: "2" },
  { pincode: 322001, serviceable: "Yes", tier: "2" },
  { pincode: 322021, serviceable: "Yes", tier: "2" },
  { pincode: 322024, serviceable: "Yes", tier: "2" },
  { pincode: 322201, serviceable: "Yes", tier: "2" },
  { pincode: 322202, serviceable: "Yes", tier: "2" },
  { pincode: 322220, serviceable: "Yes", tier: "2" },
  { pincode: 322230, serviceable: "Yes", tier: "2" },
  { pincode: 322241, serviceable: "Yes", tier: "2" },
  { pincode: 322702, serviceable: "Yes", tier: "2" },
  { pincode: 323001, serviceable: "Yes", tier: "2" },
  { pincode: 323021, serviceable: "Yes", tier: "2" },
  { pincode: 324001, serviceable: "Yes", tier: "2" },
  { pincode: 324002, serviceable: "Yes", tier: "2" },
  { pincode: 324003, serviceable: "Yes", tier: "2" },
  { pincode: 324004, serviceable: "Yes", tier: "2" },
  { pincode: 324005, serviceable: "Yes", tier: "2" },
  { pincode: 324006, serviceable: "Yes", tier: "2" },
  { pincode: 324007, serviceable: "Yes", tier: "2" },
  { pincode: 324008, serviceable: "Yes", tier: "2" },
  { pincode: 324009, serviceable: "Yes", tier: "2" },
  { pincode: 324010, serviceable: "Yes", tier: "2" },
  { pincode: 325001, serviceable: "Yes", tier: "2" },
  { pincode: 325202, serviceable: "Yes", tier: "2" },
  { pincode: 325601, serviceable: "Yes", tier: "3" },
  { pincode: 326001, serviceable: "Yes", tier: "3" },
  { pincode: 326038, serviceable: "Yes", tier: "3" },
  { pincode: 327001, serviceable: "Yes", tier: "2" },
  { pincode: 327022, serviceable: "Yes", tier: "2" },
  { pincode: 327024, serviceable: "Yes", tier: "2" },
  { pincode: 328001, serviceable: "Yes", tier: "2" },
  { pincode: 328021, serviceable: "Yes", tier: "2" },
  { pincode: 328024, serviceable: "Yes", tier: "2" },
  { pincode: 331001, serviceable: "Yes", tier: "2" },
  { pincode: 331021, serviceable: "Yes", tier: "2" },
  { pincode: 331022, serviceable: "Yes", tier: "2" },
  { pincode: 331023, serviceable: "Yes", tier: "2" },
  { pincode: 331024, serviceable: "Yes", tier: "2" },
  { pincode: 331025, serviceable: "Yes", tier: "2" },
  { pincode: 331027, serviceable: "Yes", tier: "2" },
  { pincode: 331028, serviceable: "Yes", tier: "2" },
  { pincode: 331304, serviceable: "Yes", tier: "2" },
  { pincode: 331305, serviceable: "Yes", tier: "2" },
  { pincode: 331403, serviceable: "Yes", tier: "2" },
  { pincode: 331411, serviceable: "Yes", tier: "2" },
  { pincode: 331506, serviceable: "Yes", tier: "2" },
  { pincode: 331507, serviceable: "Yes", tier: "2" },
  { pincode: 331517, serviceable: "Yes", tier: "2" },
  { pincode: 331802, serviceable: "Yes", tier: "2" },
  { pincode: 331803, serviceable: "Yes", tier: "2" },
  { pincode: 331811, serviceable: "Yes", tier: "2" },
  { pincode: 332001, serviceable: "Yes", tier: "2" },
  { pincode: 332002, serviceable: "Yes", tier: "2" },
  { pincode: 332021, serviceable: "Yes", tier: "2" },
  { pincode: 332023, serviceable: "Yes", tier: "2" },
  { pincode: 332024, serviceable: "Yes", tier: "2" },
  { pincode: 332031, serviceable: "Yes", tier: "2" },
  { pincode: 332041, serviceable: "Yes", tier: "2" },
  { pincode: 332301, serviceable: "Yes", tier: "2" },
  { pincode: 332311, serviceable: "Yes", tier: "2" },
  { pincode: 332402, serviceable: "Yes", tier: "2" },
  { pincode: 332403, serviceable: "Yes", tier: "2" },
  { pincode: 332404, serviceable: "Yes", tier: "2" },
  { pincode: 332405, serviceable: "Yes", tier: "2" },
  { pincode: 332713, serviceable: "Yes", tier: "2" },
  { pincode: 332715, serviceable: "Yes", tier: "2" },
  { pincode: 332718, serviceable: "Yes", tier: "2" },
  { pincode: 333001, serviceable: "Yes", tier: "2" },
  { pincode: 333021, serviceable: "Yes", tier: "2" },
  { pincode: 333022, serviceable: "Yes", tier: "2" },
  { pincode: 333023, serviceable: "Yes", tier: "2" },
  { pincode: 333025, serviceable: "Yes", tier: "2" },
  { pincode: 333026, serviceable: "Yes", tier: "2" },
  { pincode: 333029, serviceable: "Yes", tier: "2" },
  { pincode: 333031, serviceable: "Yes", tier: "2" },
  { pincode: 333035, serviceable: "Yes", tier: "2" },
  { pincode: 333042, serviceable: "Yes", tier: "3" },
  { pincode: 333307, serviceable: "Yes", tier: "3" },
  { pincode: 333333, serviceable: "Yes", tier: "1" },
  { pincode: 333516, serviceable: "Yes", tier: "2" },
  { pincode: 333704, serviceable: "Yes", tier: "2" },
  { pincode: 333705, serviceable: "Yes", tier: "3" },
  { pincode: 334001, serviceable: "Yes", tier: "2" },
  { pincode: 334003, serviceable: "Yes", tier: "2" },
  { pincode: 334004, serviceable: "Yes", tier: "2" },
  { pincode: 334006, serviceable: "Yes", tier: "2" },
  { pincode: 334022, serviceable: "Yes", tier: "2" },
  { pincode: 334401, serviceable: "Yes", tier: "2" },
  { pincode: 334402, serviceable: "Yes", tier: "2" },
  { pincode: 334403, serviceable: "Yes", tier: "2" },
  { pincode: 334603, serviceable: "Yes", tier: "2" },
  { pincode: 334802, serviceable: "Yes", tier: "3" },
  { pincode: 334803, serviceable: "Yes", tier: "3" },
  { pincode: 335001, serviceable: "Yes", tier: "2" },
  { pincode: 335002, serviceable: "Yes", tier: "2" },
  { pincode: 335024, serviceable: "Yes", tier: "2" },
  { pincode: 335027, serviceable: "Yes", tier: "2" },
  { pincode: 335037, serviceable: "Yes", tier: "2" },
  { pincode: 335041, serviceable: "Yes", tier: "2" },
  { pincode: 335051, serviceable: "Yes", tier: "2" },
  { pincode: 335062, serviceable: "Yes", tier: "2" },
  { pincode: 335063, serviceable: "Yes", tier: "2" },
  { pincode: 335073, serviceable: "Yes", tier: "2" },
  { pincode: 335501, serviceable: "Yes", tier: "2" },
  { pincode: 335502, serviceable: "Yes", tier: "2" },
  { pincode: 335504, serviceable: "Yes", tier: "2" },
  { pincode: 335505, serviceable: "Yes", tier: "2" },
  { pincode: 335511, serviceable: "Yes", tier: "2" },
  { pincode: 335512, serviceable: "Yes", tier: "2" },
  { pincode: 335513, serviceable: "Yes", tier: "2" },
  { pincode: 335514, serviceable: "Yes", tier: "2" },
  { pincode: 335523, serviceable: "Yes", tier: "2" },
  { pincode: 335524, serviceable: "Yes", tier: "2" },
  { pincode: 335525, serviceable: "Yes", tier: "3" },
  { pincode: 335526, serviceable: "Yes", tier: "2" },
  { pincode: 335702, serviceable: "Yes", tier: "2" },
  { pincode: 335704, serviceable: "Yes", tier: "2" },
  { pincode: 335801, serviceable: "Yes", tier: "2" },
  { pincode: 335802, serviceable: "Yes", tier: "2" },
  { pincode: 335803, serviceable: "Yes", tier: "2" },
  { pincode: 335804, serviceable: "Yes", tier: "2" },
  { pincode: 335805, serviceable: "Yes", tier: "2" },
  { pincode: 341001, serviceable: "Yes", tier: "2" },
  { pincode: 341021, serviceable: "Yes", tier: "2" },
  { pincode: 341024, serviceable: "Yes", tier: "2" },
  { pincode: 341026, serviceable: "Yes", tier: "2" },
  { pincode: 341028, serviceable: "Yes", tier: "2" },
  { pincode: 341302, serviceable: "Yes", tier: "2" },
  { pincode: 341303, serviceable: "Yes", tier: "2" },
  { pincode: 341304, serviceable: "Yes", tier: "2" },
  { pincode: 341306, serviceable: "Yes", tier: "2" },
  { pincode: 341316, serviceable: "Yes", tier: "2" },
  { pincode: 341502, serviceable: "Yes", tier: "2" },
  { pincode: 341505, serviceable: "Yes", tier: "2" },
  { pincode: 341506, serviceable: "Yes", tier: "2" },
  { pincode: 341508, serviceable: "Yes", tier: "2" },
  { pincode: 341509, serviceable: "Yes", tier: "2" },
  { pincode: 341512, serviceable: "Yes", tier: "2" },
  { pincode: 342001, serviceable: "Yes", tier: "2" },
  { pincode: 342002, serviceable: "Yes", tier: "2" },
  { pincode: 342003, serviceable: "Yes", tier: "2" },
  { pincode: 342004, serviceable: "Yes", tier: "2" },
  { pincode: 342005, serviceable: "Yes", tier: "2" },
  { pincode: 342006, serviceable: "Yes", tier: "2" },
  { pincode: 342007, serviceable: "Yes", tier: "2" },
  { pincode: 342008, serviceable: "Yes", tier: "2" },
  { pincode: 342009, serviceable: "Yes", tier: "2" },
  { pincode: 342010, serviceable: "Yes", tier: "2" },
  { pincode: 342011, serviceable: "Yes", tier: "2" },
  { pincode: 342012, serviceable: "Yes", tier: "2" },
  { pincode: 342013, serviceable: "Yes", tier: "2" },
  { pincode: 342014, serviceable: "Yes", tier: "2" },
  { pincode: 342015, serviceable: "Yes", tier: "2" },
  { pincode: 342024, serviceable: "Yes", tier: "2" },
  { pincode: 342026, serviceable: "Yes", tier: "2" },
  { pincode: 342027, serviceable: "Yes", tier: "2" },
  { pincode: 342037, serviceable: "Yes", tier: "2" },
  { pincode: 342301, serviceable: "Yes", tier: "3" },
  { pincode: 342304, serviceable: "Yes", tier: "2" },
  { pincode: 342305, serviceable: "Yes", tier: "2" },
  { pincode: 342307, serviceable: "Yes", tier: "3" },
  { pincode: 342601, serviceable: "Yes", tier: "3" },
  { pincode: 342602, serviceable: "Yes", tier: "3" },
  { pincode: 342801, serviceable: "Yes", tier: "2" },
  { pincode: 343001, serviceable: "Yes", tier: "3" },
  { pincode: 343022, serviceable: "Yes", tier: "3" },
  { pincode: 343029, serviceable: "Yes", tier: "3" },
  { pincode: 344001, serviceable: "Yes", tier: "3" },
  { pincode: 344011, serviceable: "Yes", tier: "3" },
  { pincode: 344022, serviceable: "Yes", tier: "3" },
  { pincode: 344024, serviceable: "Yes", tier: "3" },
  { pincode: 344032, serviceable: "Yes", tier: "3" },
  { pincode: 344033, serviceable: "Yes", tier: "3" },
  { pincode: 344034, serviceable: "Yes", tier: "3" },
  { pincode: 344035, serviceable: "Yes", tier: "3" },
  { pincode: 344701, serviceable: "Yes", tier: "3" },
  { pincode: 344702, serviceable: "Yes", tier: "3" },
  { pincode: 345001, serviceable: "Yes", tier: "3" },
  { pincode: 345021, serviceable: "Yes", tier: "3" },
  { pincode: 360001, serviceable: "Yes", tier: "2" },
  { pincode: 360002, serviceable: "Yes", tier: "2" },
  { pincode: 360003, serviceable: "Yes", tier: "2" },
  { pincode: 360004, serviceable: "Yes", tier: "2" },
  { pincode: 360005, serviceable: "Yes", tier: "2" },
  { pincode: 360006, serviceable: "Yes", tier: "2" },
  { pincode: 360007, serviceable: "Yes", tier: "2" },
  { pincode: 360008, serviceable: "Yes", tier: "2" },
  { pincode: 360009, serviceable: "Yes", tier: "2" },
  { pincode: 360020, serviceable: "Yes", tier: "1" },
  { pincode: 360021, serviceable: "Yes", tier: "2" },
  { pincode: 360023, serviceable: "Yes", tier: "2" },
  { pincode: 360024, serviceable: "Yes", tier: "2" },
  { pincode: 360040, serviceable: "Yes", tier: "2" },
  { pincode: 360050, serviceable: "Yes", tier: "2" },
  { pincode: 360055, serviceable: "Yes", tier: "2" },
  { pincode: 360060, serviceable: "Yes", tier: "2" },
  { pincode: 360070, serviceable: "Yes", tier: "2" },
  { pincode: 360110, serviceable: "Yes", tier: "1" },
  { pincode: 360311, serviceable: "Yes", tier: "2" },
  { pincode: 360320, serviceable: "Yes", tier: "2" },
  { pincode: 360360, serviceable: "Yes", tier: "2" },
  { pincode: 360370, serviceable: "Yes", tier: "2" },
  { pincode: 360375, serviceable: "Yes", tier: "2" },
  { pincode: 360405, serviceable: "Yes", tier: "2" },
  { pincode: 360410, serviceable: "Yes", tier: "2" },
  { pincode: 360421, serviceable: "Yes", tier: "2" },
  { pincode: 360430, serviceable: "Yes", tier: "2" },
  { pincode: 360440, serviceable: "Yes", tier: "2" },
  { pincode: 360450, serviceable: "Yes", tier: "2" },
  { pincode: 360452, serviceable: "Yes", tier: "2" },
  { pincode: 360460, serviceable: "Yes", tier: "2" },
  { pincode: 360470, serviceable: "Yes", tier: "2" },
  { pincode: 360480, serviceable: "Yes", tier: "2" },
  { pincode: 360490, serviceable: "Yes", tier: "2" },
  { pincode: 360510, serviceable: "Yes", tier: "2" },
  { pincode: 360530, serviceable: "Yes", tier: "2" },
  { pincode: 360545, serviceable: "Yes", tier: "2" },
  { pincode: 360550, serviceable: "Yes", tier: "2" },
  { pincode: 360560, serviceable: "Yes", tier: "2" },
  { pincode: 360570, serviceable: "Yes", tier: "2" },
  { pincode: 360575, serviceable: "Yes", tier: "2" },
  { pincode: 360576, serviceable: "Yes", tier: "2" },
  { pincode: 360577, serviceable: "Yes", tier: "2" },
  { pincode: 360578, serviceable: "Yes", tier: "2" },
  { pincode: 360579, serviceable: "Yes", tier: "2" },
  { pincode: 360590, serviceable: "Yes", tier: "2" },
  { pincode: 361001, serviceable: "Yes", tier: "2" },
  { pincode: 361002, serviceable: "Yes", tier: "2" },
  { pincode: 361003, serviceable: "Yes", tier: "2" },
  { pincode: 361004, serviceable: "Yes", tier: "2" },
  { pincode: 361005, serviceable: "Yes", tier: "2" },
  { pincode: 361006, serviceable: "Yes", tier: "2" },
  { pincode: 361007, serviceable: "Yes", tier: "2" },
  { pincode: 361008, serviceable: "Yes", tier: "2" },
  { pincode: 361009, serviceable: "Yes", tier: "2" },
  { pincode: 361010, serviceable: "Yes", tier: "2" },
  { pincode: 361110, serviceable: "Yes", tier: "2" },
  { pincode: 361120, serviceable: "Yes", tier: "2" },
  { pincode: 361140, serviceable: "Yes", tier: "2" },
  { pincode: 361141, serviceable: "Yes", tier: "2" },
  { pincode: 361142, serviceable: "Yes", tier: "2" },
  { pincode: 361150, serviceable: "Yes", tier: "2" },
  { pincode: 361170, serviceable: "Yes", tier: "2" },
  { pincode: 361210, serviceable: "Yes", tier: "2" },
  { pincode: 361280, serviceable: "Yes", tier: "2" },
  { pincode: 361305, serviceable: "Yes", tier: "2" },
  { pincode: 361306, serviceable: "Yes", tier: "2" },
  { pincode: 361310, serviceable: "Yes", tier: "2" },
  { pincode: 361315, serviceable: "Yes", tier: "2" },
  { pincode: 361330, serviceable: "Yes", tier: "2" },
  { pincode: 361335, serviceable: "Yes", tier: "2" },
  { pincode: 361345, serviceable: "Yes", tier: "2" },
  { pincode: 361347, serviceable: "Yes", tier: "2" },
  { pincode: 361350, serviceable: "Yes", tier: "2" },
  { pincode: 362001, serviceable: "Yes", tier: "2" },
  { pincode: 362002, serviceable: "Yes", tier: "2" },
  { pincode: 362003, serviceable: "Yes", tier: "2" },
  { pincode: 362004, serviceable: "Yes", tier: "2" },
  { pincode: 362011, serviceable: "Yes", tier: "2" },
  { pincode: 362015, serviceable: "Yes", tier: "2" },
  { pincode: 362020, serviceable: "Yes", tier: "2" },
  { pincode: 362030, serviceable: "Yes", tier: "2" },
  { pincode: 362037, serviceable: "Yes", tier: "2" },
  { pincode: 362110, serviceable: "Yes", tier: "2" },
  { pincode: 362120, serviceable: "Yes", tier: "2" },
  { pincode: 362135, serviceable: "Yes", tier: "2" },
  { pincode: 362140, serviceable: "Yes", tier: "2" },
  { pincode: 362150, serviceable: "Yes", tier: "2" },
  { pincode: 362205, serviceable: "Yes", tier: "2" },
  { pincode: 362215, serviceable: "Yes", tier: "2" },
  { pincode: 362220, serviceable: "Yes", tier: "2" },
  { pincode: 362222, serviceable: "Yes", tier: "2" },
  { pincode: 362225, serviceable: "Yes", tier: "2" },
  { pincode: 362226, serviceable: "Yes", tier: "2" },
  { pincode: 362227, serviceable: "Yes", tier: "2" },
  { pincode: 362229, serviceable: "Yes", tier: "2" },
  { pincode: 362230, serviceable: "Yes", tier: "2" },
  { pincode: 362235, serviceable: "Yes", tier: "2" },
  { pincode: 362240, serviceable: "Yes", tier: "2" },
  { pincode: 362245, serviceable: "Yes", tier: "2" },
  { pincode: 362250, serviceable: "Yes", tier: "2" },
  { pincode: 362255, serviceable: "Yes", tier: "2" },
  { pincode: 362260, serviceable: "Yes", tier: "2" },
  { pincode: 362265, serviceable: "Yes", tier: "2" },
  { pincode: 362266, serviceable: "Yes", tier: "2" },
  { pincode: 362267, serviceable: "Yes", tier: "2" },
  { pincode: 362268, serviceable: "Yes", tier: "2" },
  { pincode: 362269, serviceable: "Yes", tier: "2" },
  { pincode: 362275, serviceable: "Yes", tier: "2" },
  { pincode: 362310, serviceable: "Yes", tier: "2" },
  { pincode: 362315, serviceable: "Yes", tier: "2" },
  { pincode: 362520, serviceable: "Yes", tier: "2" },
  { pincode: 362540, serviceable: "Yes", tier: "2" },
  { pincode: 362560, serviceable: "Yes", tier: "2" },
  { pincode: 362610, serviceable: "Yes", tier: "2" },
  { pincode: 362620, serviceable: "Yes", tier: "2" },
  { pincode: 362625, serviceable: "Yes", tier: "2" },
  { pincode: 362630, serviceable: "Yes", tier: "2" },
  { pincode: 362640, serviceable: "Yes", tier: "2" },
  { pincode: 362650, serviceable: "Yes", tier: "2" },
  { pincode: 362715, serviceable: "Yes", tier: "2" },
  { pincode: 362720, serviceable: "Yes", tier: "2" },
  { pincode: 362725, serviceable: "Yes", tier: "2" },
  { pincode: 363001, serviceable: "Yes", tier: "2" },
  { pincode: 363002, serviceable: "Yes", tier: "2" },
  { pincode: 363020, serviceable: "Yes", tier: "2" },
  { pincode: 363030, serviceable: "Yes", tier: "2" },
  { pincode: 363035, serviceable: "Yes", tier: "2" },
  { pincode: 363040, serviceable: "Yes", tier: "2" },
  { pincode: 363110, serviceable: "Yes", tier: "2" },
  { pincode: 363115, serviceable: "Yes", tier: "2" },
  { pincode: 363310, serviceable: "Yes", tier: "1" },
  { pincode: 363320, serviceable: "Yes", tier: "1" },
  { pincode: 363330, serviceable: "Yes", tier: "2" },
  { pincode: 363415, serviceable: "Yes", tier: "2" },
  { pincode: 363421, serviceable: "Yes", tier: "2" },
  { pincode: 363427, serviceable: "Yes", tier: "2" },
  { pincode: 363430, serviceable: "Yes", tier: "2" },
  { pincode: 363435, serviceable: "Yes", tier: "2" },
  { pincode: 363510, serviceable: "Yes", tier: "2" },
  { pincode: 363520, serviceable: "Yes", tier: "2" },
  { pincode: 363530, serviceable: "Yes", tier: "2" },
  { pincode: 363621, serviceable: "Yes", tier: "2" },
  { pincode: 363641, serviceable: "Yes", tier: "2" },
  { pincode: 363642, serviceable: "Yes", tier: "2" },
  { pincode: 363643, serviceable: "Yes", tier: "2" },
  { pincode: 363650, serviceable: "Yes", tier: "2" },
  { pincode: 363660, serviceable: "Yes", tier: "2" },
  { pincode: 364001, serviceable: "Yes", tier: "1" },
  { pincode: 364002, serviceable: "Yes", tier: "1" },
  { pincode: 364003, serviceable: "Yes", tier: "1" },
  { pincode: 364004, serviceable: "Yes", tier: "1" },
  { pincode: 364005, serviceable: "Yes", tier: "1" },
  { pincode: 364006, serviceable: "Yes", tier: "1" },
  { pincode: 364050, serviceable: "Yes", tier: "1" },
  { pincode: 364055, serviceable: "Yes", tier: "1" },
  { pincode: 364060, serviceable: "Yes", tier: "2" },
  { pincode: 364110, serviceable: "Yes", tier: "1" },
  { pincode: 364140, serviceable: "Yes", tier: "2" },
  { pincode: 364150, serviceable: "Yes", tier: "1" },
  { pincode: 364230, serviceable: "Yes", tier: "2" },
  { pincode: 364240, serviceable: "Yes", tier: "2" },
  { pincode: 364250, serviceable: "Yes", tier: "2" },
  { pincode: 364265, serviceable: "Yes", tier: "2" },
  { pincode: 364270, serviceable: "Yes", tier: "2" },
  { pincode: 364290, serviceable: "Yes", tier: "2" },
  { pincode: 364295, serviceable: "Yes", tier: "2" },
  { pincode: 364310, serviceable: "Yes", tier: "1" },
  { pincode: 364421, serviceable: "Yes", tier: "2" },
  { pincode: 364490, serviceable: "Yes", tier: "2" },
  { pincode: 364505, serviceable: "Yes", tier: "2" },
  { pincode: 364515, serviceable: "Yes", tier: "2" },
  { pincode: 364521, serviceable: "Yes", tier: "2" },
  { pincode: 364522, serviceable: "Yes", tier: "2" },
  { pincode: 364525, serviceable: "Yes", tier: "2" },
  { pincode: 364540, serviceable: "Yes", tier: "2" },
  { pincode: 364630, serviceable: "Yes", tier: "2" },
  { pincode: 364710, serviceable: "Yes", tier: "2" },
  { pincode: 364720, serviceable: "Yes", tier: "2" },
  { pincode: 364750, serviceable: "Yes", tier: "2" },
  { pincode: 364765, serviceable: "Yes", tier: "2" },
  { pincode: 365220, serviceable: "Yes", tier: "2" },
  { pincode: 365410, serviceable: "Yes", tier: "2" },
  { pincode: 365421, serviceable: "Yes", tier: "2" },
  { pincode: 365435, serviceable: "Yes", tier: "2" },
  { pincode: 365440, serviceable: "Yes", tier: "2" },
  { pincode: 365455, serviceable: "Yes", tier: "2" },
  { pincode: 365456, serviceable: "Yes", tier: "2" },
  { pincode: 365460, serviceable: "Yes", tier: "2" },
  { pincode: 365535, serviceable: "Yes", tier: "2" },
  { pincode: 365540, serviceable: "Yes", tier: "2" },
  { pincode: 365541, serviceable: "Yes", tier: "2" },
  { pincode: 365545, serviceable: "Yes", tier: "2" },
  { pincode: 365550, serviceable: "Yes", tier: "2" },
  { pincode: 365560, serviceable: "Yes", tier: "2" },
  { pincode: 365565, serviceable: "Yes", tier: "2" },
  { pincode: 365601, serviceable: "Yes", tier: "2" },
  { pincode: 365610, serviceable: "Yes", tier: "2" },
  { pincode: 365620, serviceable: "Yes", tier: "2" },
  { pincode: 365630, serviceable: "Yes", tier: "2" },
  { pincode: 365635, serviceable: "Yes", tier: "2" },
  { pincode: 370001, serviceable: "Yes", tier: "2" },
  { pincode: 370015, serviceable: "Yes", tier: "2" },
  { pincode: 370020, serviceable: "Yes", tier: "2" },
  { pincode: 370030, serviceable: "Yes", tier: "2" },
  { pincode: 370105, serviceable: "Yes", tier: "2" },
  { pincode: 370110, serviceable: "Yes", tier: "2" },
  { pincode: 370130, serviceable: "Yes", tier: "2" },
  { pincode: 370140, serviceable: "Yes", tier: "2" },
  { pincode: 370150, serviceable: "Yes", tier: "2" },
  { pincode: 370165, serviceable: "Yes", tier: "2" },
  { pincode: 370201, serviceable: "Yes", tier: "2" },
  { pincode: 370203, serviceable: "Yes", tier: "2" },
  { pincode: 370205, serviceable: "Yes", tier: "2" },
  { pincode: 370210, serviceable: "Yes", tier: "2" },
  { pincode: 370230, serviceable: "Yes", tier: "2" },
  { pincode: 370240, serviceable: "Yes", tier: "2" },
  { pincode: 370405, serviceable: "Yes", tier: "2" },
  { pincode: 370415, serviceable: "Yes", tier: "2" },
  { pincode: 370421, serviceable: "Yes", tier: "2" },
  { pincode: 370429, serviceable: "Yes", tier: "2" },
  { pincode: 370430, serviceable: "Yes", tier: "2" },
  { pincode: 370435, serviceable: "Yes", tier: "2" },
  { pincode: 370445, serviceable: "Yes", tier: "2" },
  { pincode: 370450, serviceable: "Yes", tier: "2" },
  { pincode: 370455, serviceable: "Yes", tier: "2" },
  { pincode: 370460, serviceable: "Yes", tier: "2" },
  { pincode: 370465, serviceable: "Yes", tier: "2" },
  { pincode: 370475, serviceable: "Yes", tier: "2" },
  { pincode: 370511, serviceable: "Yes", tier: "2" },
  { pincode: 370601, serviceable: "Yes", tier: "2" },
  { pincode: 370605, serviceable: "Yes", tier: "2" },
  { pincode: 370610, serviceable: "Yes", tier: "2" },
  { pincode: 370615, serviceable: "Yes", tier: "2" },
  { pincode: 370645, serviceable: "Yes", tier: "2" },
  { pincode: 370655, serviceable: "Yes", tier: "2" },
  { pincode: 370665, serviceable: "Yes", tier: "2" },
  { pincode: 370670, serviceable: "Yes", tier: "2" },
  { pincode: 370675, serviceable: "Yes", tier: "2" },
  { pincode: 380001, serviceable: "Yes", tier: "1" },
  { pincode: 380002, serviceable: "Yes", tier: "1" },
  { pincode: 380003, serviceable: "Yes", tier: "1" },
  { pincode: 380004, serviceable: "Yes", tier: "1" },
  { pincode: 380005, serviceable: "Yes", tier: "1" },
  { pincode: 380006, serviceable: "Yes", tier: "1" },
  { pincode: 380007, serviceable: "Yes", tier: "1" },
  { pincode: 380008, serviceable: "Yes", tier: "1" },
  { pincode: 380009, serviceable: "Yes", tier: "1" },
  { pincode: 380012, serviceable: "Yes", tier: "1" },
  { pincode: 380013, serviceable: "Yes", tier: "1" },
  { pincode: 380014, serviceable: "Yes", tier: "1" },
  { pincode: 380015, serviceable: "Yes", tier: "1" },
  { pincode: 380016, serviceable: "Yes", tier: "1" },
  { pincode: 380018, serviceable: "Yes", tier: "1" },
  { pincode: 380019, serviceable: "Yes", tier: "1" },
  { pincode: 380021, serviceable: "Yes", tier: "1" },
  { pincode: 380022, serviceable: "Yes", tier: "1" },
  { pincode: 380023, serviceable: "Yes", tier: "1" },
  { pincode: 380024, serviceable: "Yes", tier: "1" },
  { pincode: 380025, serviceable: "Yes", tier: "1" },
  { pincode: 380026, serviceable: "Yes", tier: "1" },
  { pincode: 380027, serviceable: "Yes", tier: "1" },
  { pincode: 380028, serviceable: "Yes", tier: "1" },
  { pincode: 380050, serviceable: "Yes", tier: "1" },
  { pincode: 380051, serviceable: "Yes", tier: "1" },
  { pincode: 380052, serviceable: "Yes", tier: "1" },
  { pincode: 380053, serviceable: "Yes", tier: "1" },
  { pincode: 380054, serviceable: "Yes", tier: "1" },
  { pincode: 380055, serviceable: "Yes", tier: "1" },
  { pincode: 380058, serviceable: "Yes", tier: "1" },
  { pincode: 380059, serviceable: "Yes", tier: "1" },
  { pincode: 380060, serviceable: "Yes", tier: "1" },
  { pincode: 380061, serviceable: "Yes", tier: "1" },
  { pincode: 380063, serviceable: "Yes", tier: "1" },
  { pincode: 381111, serviceable: "Yes", tier: "1" },
  { pincode: 382001, serviceable: "Yes", tier: "1" },
  { pincode: 382002, serviceable: "Yes", tier: "1" },
  { pincode: 382003, serviceable: "Yes", tier: "1" },
  { pincode: 382004, serviceable: "Yes", tier: "1" },
  { pincode: 382005, serviceable: "Yes", tier: "1" },
  { pincode: 382006, serviceable: "Yes", tier: "1" },
  { pincode: 382007, serviceable: "Yes", tier: "1" },
  { pincode: 382008, serviceable: "Yes", tier: "1" },
  { pincode: 382009, serviceable: "Yes", tier: "1" },
  { pincode: 382010, serviceable: "Yes", tier: "1" },
  { pincode: 382011, serviceable: "Yes", tier: "1" },
  { pincode: 382012, serviceable: "Yes", tier: "1" },
  { pincode: 382013, serviceable: "Yes", tier: "1" },
  { pincode: 382014, serviceable: "Yes", tier: "1" },
  { pincode: 382015, serviceable: "Yes", tier: "1" },
  { pincode: 382016, serviceable: "Yes", tier: "1" },
  { pincode: 382017, serviceable: "Yes", tier: "1" },
  { pincode: 382018, serviceable: "Yes", tier: "1" },
  { pincode: 382019, serviceable: "Yes", tier: "1" },
  { pincode: 382020, serviceable: "Yes", tier: "1" },
  { pincode: 382021, serviceable: "Yes", tier: "1" },
  { pincode: 382022, serviceable: "Yes", tier: "1" },
  { pincode: 382023, serviceable: "Yes", tier: "1" },
  { pincode: 382024, serviceable: "Yes", tier: "1" },
  { pincode: 382025, serviceable: "Yes", tier: "1" },
  { pincode: 382026, serviceable: "Yes", tier: "1" },
  { pincode: 382027, serviceable: "Yes", tier: "1" },
  { pincode: 382028, serviceable: "Yes", tier: "1" },
  { pincode: 382029, serviceable: "Yes", tier: "1" },
  { pincode: 382030, serviceable: "Yes", tier: "1" },
  { pincode: 382041, serviceable: "Yes", tier: "1" },
  { pincode: 382042, serviceable: "Yes", tier: "1" },
  { pincode: 382044, serviceable: "Yes", tier: "1" },
  { pincode: 382051, serviceable: "Yes", tier: "1" },
  { pincode: 382110, serviceable: "Yes", tier: "1" },
  { pincode: 382115, serviceable: "Yes", tier: "1" },
  { pincode: 382120, serviceable: "Yes", tier: "1" },
  { pincode: 382150, serviceable: "Yes", tier: "1" },
  { pincode: 382170, serviceable: "Yes", tier: "1" },
  { pincode: 382210, serviceable: "Yes", tier: "1" },
  { pincode: 382213, serviceable: "Yes", tier: "1" },
  { pincode: 382220, serviceable: "Yes", tier: "1" },
  { pincode: 382225, serviceable: "Yes", tier: "1" },
  { pincode: 382240, serviceable: "Yes", tier: "1" },
  { pincode: 382245, serviceable: "Yes", tier: "2" },
  { pincode: 382255, serviceable: "Yes", tier: "2" },
  { pincode: 382260, serviceable: "Yes", tier: "1" },
  { pincode: 382305, serviceable: "Yes", tier: "1" },
  { pincode: 382308, serviceable: "Yes", tier: "1" },
  { pincode: 382315, serviceable: "Yes", tier: "1" },
  { pincode: 382325, serviceable: "Yes", tier: "1" },
  { pincode: 382330, serviceable: "Yes", tier: "1" },
  { pincode: 382340, serviceable: "Yes", tier: "1" },
  { pincode: 382345, serviceable: "Yes", tier: "1" },
  { pincode: 382346, serviceable: "Yes", tier: "1" },
  { pincode: 382350, serviceable: "Yes", tier: "1" },
  { pincode: 382352, serviceable: "Yes", tier: "1" },
  { pincode: 382355, serviceable: "Yes", tier: "1" },
  { pincode: 382405, serviceable: "Yes", tier: "1" },
  { pincode: 382410, serviceable: "Yes", tier: "1" },
  { pincode: 382415, serviceable: "Yes", tier: "1" },
  { pincode: 382418, serviceable: "Yes", tier: "1" },
  { pincode: 382420, serviceable: "Yes", tier: "1" },
  { pincode: 382421, serviceable: "Yes", tier: "1" },
  { pincode: 382422, serviceable: "Yes", tier: "1" },
  { pincode: 382424, serviceable: "Yes", tier: "1" },
  { pincode: 382425, serviceable: "Yes", tier: "1" },
  { pincode: 382426, serviceable: "Yes", tier: "1" },
  { pincode: 382427, serviceable: "Yes", tier: "1" },
  { pincode: 382428, serviceable: "Yes", tier: "1" },
  { pincode: 382430, serviceable: "Yes", tier: "1" },
  { pincode: 382440, serviceable: "Yes", tier: "1" },
  { pincode: 382442, serviceable: "Yes", tier: "1" },
  { pincode: 382443, serviceable: "Yes", tier: "1" },
  { pincode: 382445, serviceable: "Yes", tier: "1" },
  { pincode: 382449, serviceable: "Yes", tier: "1" },
  { pincode: 382450, serviceable: "Yes", tier: "2" },
  { pincode: 382455, serviceable: "Yes", tier: "1" },
  { pincode: 382460, serviceable: "Yes", tier: "1" },
  { pincode: 382463, serviceable: "Yes", tier: "1" },
  { pincode: 382465, serviceable: "Yes", tier: "1" },
  { pincode: 382470, serviceable: "Yes", tier: "1" },
  { pincode: 382475, serviceable: "Yes", tier: "1" },
  { pincode: 382480, serviceable: "Yes", tier: "1" },
  { pincode: 382481, serviceable: "Yes", tier: "1" },
  { pincode: 382610, serviceable: "Yes", tier: "1" },
  { pincode: 382620, serviceable: "Yes", tier: "1" },
  { pincode: 382625, serviceable: "Yes", tier: "1" },
  { pincode: 382644, serviceable: "Yes", tier: "1" },
  { pincode: 382655, serviceable: "Yes", tier: "1" },
  { pincode: 382705, serviceable: "Yes", tier: "1" },
  { pincode: 382715, serviceable: "Yes", tier: "1" },
  { pincode: 382721, serviceable: "Yes", tier: "1" },
  { pincode: 382725, serviceable: "Yes", tier: "1" },
  { pincode: 382729, serviceable: "Yes", tier: "1" },
  { pincode: 382732, serviceable: "Yes", tier: "1" },
  { pincode: 382735, serviceable: "Yes", tier: "1" },
  { pincode: 382740, serviceable: "Yes", tier: "1" },
  { pincode: 382775, serviceable: "Yes", tier: "2" },
  { pincode: 382845, serviceable: "Yes", tier: "1" },
  { pincode: 382870, serviceable: "Yes", tier: "1" },
  { pincode: 383001, serviceable: "Yes", tier: "1" },
  { pincode: 383006, serviceable: "Yes", tier: "1" },
  { pincode: 383110, serviceable: "Yes", tier: "1" },
  { pincode: 383205, serviceable: "Yes", tier: "1" },
  { pincode: 383215, serviceable: "Yes", tier: "1" },
  { pincode: 383235, serviceable: "Yes", tier: "1" },
  { pincode: 383245, serviceable: "Yes", tier: "1" },
  { pincode: 383255, serviceable: "Yes", tier: "1" },
  { pincode: 383305, serviceable: "Yes", tier: "1" },
  { pincode: 383307, serviceable: "Yes", tier: "2" },
  { pincode: 383310, serviceable: "Yes", tier: "1" },
  { pincode: 383315, serviceable: "Yes", tier: "1" },
  { pincode: 383325, serviceable: "Yes", tier: "1" },
  { pincode: 383350, serviceable: "Yes", tier: "2" },
  { pincode: 383410, serviceable: "Yes", tier: "1" },
  { pincode: 383430, serviceable: "Yes", tier: "1" },
  { pincode: 383460, serviceable: "Yes", tier: "1" },
  { pincode: 384001, serviceable: "Yes", tier: "1" },
  { pincode: 384002, serviceable: "Yes", tier: "1" },
  { pincode: 384003, serviceable: "Yes", tier: "1" },
  { pincode: 384120, serviceable: "Yes", tier: "1" },
  { pincode: 384151, serviceable: "Yes", tier: "1" },
  { pincode: 384160, serviceable: "Yes", tier: "1" },
  { pincode: 384170, serviceable: "Yes", tier: "1" },
  { pincode: 384205, serviceable: "Yes", tier: "1" },
  { pincode: 384206, serviceable: "Yes", tier: "1" },
  { pincode: 384210, serviceable: "Yes", tier: "1" },
  { pincode: 384240, serviceable: "Yes", tier: "2" },
  { pincode: 384245, serviceable: "Yes", tier: "2" },
  { pincode: 384265, serviceable: "Yes", tier: "2" },
  { pincode: 384315, serviceable: "Yes", tier: "1" },
  { pincode: 384325, serviceable: "Yes", tier: "1" },
  { pincode: 384330, serviceable: "Yes", tier: "1" },
  { pincode: 384355, serviceable: "Yes", tier: "1" },
  { pincode: 385001, serviceable: "Yes", tier: "1" },
  { pincode: 385010, serviceable: "Yes", tier: "1" },
  { pincode: 385135, serviceable: "Yes", tier: "1" },
  { pincode: 385210, serviceable: "Yes", tier: "1" },
  { pincode: 385310, serviceable: "Yes", tier: "2" },
  { pincode: 385320, serviceable: "Yes", tier: "2" },
  { pincode: 385330, serviceable: "Yes", tier: "2" },
  { pincode: 385340, serviceable: "Yes", tier: "2" },
  { pincode: 385360, serviceable: "Yes", tier: "2" },
  { pincode: 385410, serviceable: "Yes", tier: "1" },
  { pincode: 385421, serviceable: "Yes", tier: "1" },
  { pincode: 385505, serviceable: "Yes", tier: "1" },
  { pincode: 385510, serviceable: "Yes", tier: "1" },
  { pincode: 385515, serviceable: "Yes", tier: "1" },
  { pincode: 385520, serviceable: "Yes", tier: "1" },
  { pincode: 385530, serviceable: "Yes", tier: "2" },
  { pincode: 385535, serviceable: "Yes", tier: "2" },
  { pincode: 385555, serviceable: "Yes", tier: "2" },
  { pincode: 385565, serviceable: "Yes", tier: "2" },
  { pincode: 385566, serviceable: "Yes", tier: "2" },
  { pincode: 385570, serviceable: "Yes", tier: "2" },
  { pincode: 385575, serviceable: "Yes", tier: "2" },
  { pincode: 387001, serviceable: "Yes", tier: "1" },
  { pincode: 387002, serviceable: "Yes", tier: "1" },
  { pincode: 387003, serviceable: "Yes", tier: "1" },
  { pincode: 387110, serviceable: "Yes", tier: "1" },
  { pincode: 387115, serviceable: "Yes", tier: "1" },
  { pincode: 387120, serviceable: "Yes", tier: "1" },
  { pincode: 387130, serviceable: "Yes", tier: "1" },
  { pincode: 387210, serviceable: "Yes", tier: "1" },
  { pincode: 387230, serviceable: "Yes", tier: "1" },
  { pincode: 387240, serviceable: "Yes", tier: "1" },
  { pincode: 387310, serviceable: "Yes", tier: "1" },
  { pincode: 387315, serviceable: "Yes", tier: "1" },
  { pincode: 387320, serviceable: "Yes", tier: "1" },
  { pincode: 387325, serviceable: "Yes", tier: "1" },
  { pincode: 387330, serviceable: "Yes", tier: "1" },
  { pincode: 387335, serviceable: "Yes", tier: "1" },
  { pincode: 387350, serviceable: "Yes", tier: "1" },
  { pincode: 387355, serviceable: "Yes", tier: "1" },
  { pincode: 387365, serviceable: "Yes", tier: "2" },
  { pincode: 387370, serviceable: "Yes", tier: "1" },
  { pincode: 387380, serviceable: "Yes", tier: "1" },
  { pincode: 387411, serviceable: "Yes", tier: "1" },
  { pincode: 387430, serviceable: "Yes", tier: "1" },
  { pincode: 387520, serviceable: "Yes", tier: "1" },
  { pincode: 387530, serviceable: "Yes", tier: "1" },
  { pincode: 387540, serviceable: "Yes", tier: "1" },
  { pincode: 387560, serviceable: "Yes", tier: "1" },
  { pincode: 387570, serviceable: "Yes", tier: "1" },
  { pincode: 387610, serviceable: "Yes", tier: "2" },
  { pincode: 387620, serviceable: "Yes", tier: "2" },
  { pincode: 387630, serviceable: "Yes", tier: "2" },
  { pincode: 387635, serviceable: "Yes", tier: "2" },
  { pincode: 387650, serviceable: "Yes", tier: "2" },
  { pincode: 388001, serviceable: "Yes", tier: "1" },
  { pincode: 388110, serviceable: "Yes", tier: "1" },
  { pincode: 388120, serviceable: "Yes", tier: "1" },
  { pincode: 388121, serviceable: "Yes", tier: "1" },
  { pincode: 388130, serviceable: "Yes", tier: "1" },
  { pincode: 388140, serviceable: "Yes", tier: "1" },
  { pincode: 388150, serviceable: "Yes", tier: "1" },
  { pincode: 388160, serviceable: "Yes", tier: "1" },
  { pincode: 388180, serviceable: "Yes", tier: "1" },
  { pincode: 388205, serviceable: "Yes", tier: "1" },
  { pincode: 388210, serviceable: "Yes", tier: "1" },
  { pincode: 388215, serviceable: "Yes", tier: "1" },
  { pincode: 388220, serviceable: "Yes", tier: "1" },
  { pincode: 388225, serviceable: "Yes", tier: "1" },
  { pincode: 388235, serviceable: "Yes", tier: "2" },
  { pincode: 388239, serviceable: "Yes", tier: "2" },
  { pincode: 388245, serviceable: "Yes", tier: "2" },
  { pincode: 388250, serviceable: "Yes", tier: "1" },
  { pincode: 388255, serviceable: "Yes", tier: "2" },
  { pincode: 388260, serviceable: "Yes", tier: "2" },
  { pincode: 388265, serviceable: "Yes", tier: "2" },
  { pincode: 388305, serviceable: "Yes", tier: "1" },
  { pincode: 388306, serviceable: "Yes", tier: "1" },
  { pincode: 388307, serviceable: "Yes", tier: "1" },
  { pincode: 388315, serviceable: "Yes", tier: "1" },
  { pincode: 388320, serviceable: "Yes", tier: "1" },
  { pincode: 388325, serviceable: "Yes", tier: "1" },
  { pincode: 388340, serviceable: "Yes", tier: "1" },
  { pincode: 388345, serviceable: "Yes", tier: "1" },
  { pincode: 388350, serviceable: "Yes", tier: "1" },
  { pincode: 388365, serviceable: "Yes", tier: "1" },
  { pincode: 388370, serviceable: "Yes", tier: "1" },
  { pincode: 388421, serviceable: "Yes", tier: "1" },
  { pincode: 388430, serviceable: "Yes", tier: "1" },
  { pincode: 388440, serviceable: "Yes", tier: "1" },
  { pincode: 388450, serviceable: "Yes", tier: "1" },
  { pincode: 388460, serviceable: "Yes", tier: "1" },
  { pincode: 388465, serviceable: "Yes", tier: "1" },
  { pincode: 388470, serviceable: "Yes", tier: "1" },
  { pincode: 388480, serviceable: "Yes", tier: "1" },
  { pincode: 388510, serviceable: "Yes", tier: "1" },
  { pincode: 388520, serviceable: "Yes", tier: "1" },
  { pincode: 388530, serviceable: "Yes", tier: "1" },
  { pincode: 388540, serviceable: "Yes", tier: "1" },
  { pincode: 388545, serviceable: "Yes", tier: "1" },
  { pincode: 388550, serviceable: "Yes", tier: "1" },
  { pincode: 388560, serviceable: "Yes", tier: "1" },
  { pincode: 388570, serviceable: "Yes", tier: "1" },
  { pincode: 388580, serviceable: "Yes", tier: "1" },
  { pincode: 388590, serviceable: "Yes", tier: "1" },
  { pincode: 388610, serviceable: "Yes", tier: "1" },
  { pincode: 388620, serviceable: "Yes", tier: "2" },
  { pincode: 388625, serviceable: "Yes", tier: "2" },
  { pincode: 388630, serviceable: "Yes", tier: "2" },
  { pincode: 388640, serviceable: "Yes", tier: "2" },
  { pincode: 388710, serviceable: "Yes", tier: "2" },
  { pincode: 388713, serviceable: "Yes", tier: "2" },
  { pincode: 389001, serviceable: "Yes", tier: "2" },
  { pincode: 389002, serviceable: "Yes", tier: "2" },
  { pincode: 389115, serviceable: "Yes", tier: "2" },
  { pincode: 389120, serviceable: "Yes", tier: "2" },
  { pincode: 389130, serviceable: "Yes", tier: "2" },
  { pincode: 389140, serviceable: "Yes", tier: "2" },
  { pincode: 389151, serviceable: "Yes", tier: "2" },
  { pincode: 389152, serviceable: "Yes", tier: "2" },
  { pincode: 389155, serviceable: "Yes", tier: "2" },
  { pincode: 389160, serviceable: "Yes", tier: "2" },
  { pincode: 389210, serviceable: "Yes", tier: "2" },
  { pincode: 389220, serviceable: "Yes", tier: "2" },
  { pincode: 389230, serviceable: "Yes", tier: "2" },
  { pincode: 389260, serviceable: "Yes", tier: "2" },
  { pincode: 389320, serviceable: "Yes", tier: "1" },
  { pincode: 389330, serviceable: "Yes", tier: "1" },
  { pincode: 389340, serviceable: "Yes", tier: "2" },
  { pincode: 389341, serviceable: "Yes", tier: "1" },
  { pincode: 389345, serviceable: "Yes", tier: "1" },
  { pincode: 389350, serviceable: "Yes", tier: "1" },
  { pincode: 389351, serviceable: "Yes", tier: "1" },
  { pincode: 389352, serviceable: "Yes", tier: "1" },
  { pincode: 389360, serviceable: "Yes", tier: "1" },
  { pincode: 389365, serviceable: "Yes", tier: "1" },
  { pincode: 389380, serviceable: "Yes", tier: "2" },
  { pincode: 389390, serviceable: "Yes", tier: "1" },
  { pincode: 390001, serviceable: "Yes", tier: "1" },
  { pincode: 390002, serviceable: "Yes", tier: "1" },
  { pincode: 390003, serviceable: "Yes", tier: "1" },
  { pincode: 390004, serviceable: "Yes", tier: "1" },
  { pincode: 390005, serviceable: "Yes", tier: "1" },
  { pincode: 390006, serviceable: "Yes", tier: "1" },
  { pincode: 390007, serviceable: "Yes", tier: "1" },
  { pincode: 390008, serviceable: "Yes", tier: "1" },
  { pincode: 390009, serviceable: "Yes", tier: "1" },
  { pincode: 390010, serviceable: "Yes", tier: "1" },
  { pincode: 390011, serviceable: "Yes", tier: "1" },
  { pincode: 390012, serviceable: "Yes", tier: "1" },
  { pincode: 390013, serviceable: "Yes", tier: "1" },
  { pincode: 390014, serviceable: "Yes", tier: "1" },
  { pincode: 390015, serviceable: "Yes", tier: "1" },
  { pincode: 390016, serviceable: "Yes", tier: "1" },
  { pincode: 390017, serviceable: "Yes", tier: "1" },
  { pincode: 390018, serviceable: "Yes", tier: "1" },
  { pincode: 390019, serviceable: "Yes", tier: "1" },
  { pincode: 390020, serviceable: "Yes", tier: "1" },
  { pincode: 390021, serviceable: "Yes", tier: "1" },
  { pincode: 390022, serviceable: "Yes", tier: "1" },
  { pincode: 390023, serviceable: "Yes", tier: "1" },
  { pincode: 390024, serviceable: "Yes", tier: "1" },
  { pincode: 390025, serviceable: "Yes", tier: "1" },
  { pincode: 391101, serviceable: "Yes", tier: "1" },
  { pincode: 391105, serviceable: "Yes", tier: "2" },
  { pincode: 391110, serviceable: "Yes", tier: "2" },
  { pincode: 391115, serviceable: "Yes", tier: "2" },
  { pincode: 391135, serviceable: "Yes", tier: "2" },
  { pincode: 391145, serviceable: "Yes", tier: "2" },
  { pincode: 391150, serviceable: "Yes", tier: "2" },
  { pincode: 391160, serviceable: "Yes", tier: "2" },
  { pincode: 391165, serviceable: "Yes", tier: "2" },
  { pincode: 391170, serviceable: "Yes", tier: "2" },
  { pincode: 391210, serviceable: "Yes", tier: "2" },
  { pincode: 391240, serviceable: "Yes", tier: "2" },
  { pincode: 391243, serviceable: "Yes", tier: "1" },
  { pincode: 391244, serviceable: "Yes", tier: "2" },
  { pincode: 391250, serviceable: "Yes", tier: "2" },
  { pincode: 391310, serviceable: "Yes", tier: "1" },
  { pincode: 391320, serviceable: "Yes", tier: "1" },
  { pincode: 391330, serviceable: "Yes", tier: "1" },
  { pincode: 391340, serviceable: "Yes", tier: "1" },
  { pincode: 391345, serviceable: "Yes", tier: "1" },
  { pincode: 391346, serviceable: "Yes", tier: "1" },
  { pincode: 391347, serviceable: "Yes", tier: "1" },
  { pincode: 391350, serviceable: "Yes", tier: "1" },
  { pincode: 391410, serviceable: "Yes", tier: "1" },
  { pincode: 391430, serviceable: "Yes", tier: "1" },
  { pincode: 391440, serviceable: "Yes", tier: "1" },
  { pincode: 391447, serviceable: "Yes", tier: "1" },
  { pincode: 391450, serviceable: "Yes", tier: "1" },
  { pincode: 391510, serviceable: "Yes", tier: "1" },
  { pincode: 391520, serviceable: "Yes", tier: "1" },
  { pincode: 391740, serviceable: "Yes", tier: "1" },
  { pincode: 391742, serviceable: "Yes", tier: "1" },
  { pincode: 391745, serviceable: "Yes", tier: "1" },
  { pincode: 391750, serviceable: "Yes", tier: "1" },
  { pincode: 391760, serviceable: "Yes", tier: "1" },
  { pincode: 391770, serviceable: "Yes", tier: "1" },
  { pincode: 391775, serviceable: "Yes", tier: "1" },
  { pincode: 391780, serviceable: "Yes", tier: "1" },
  { pincode: 392001, serviceable: "Yes", tier: "2" },
  { pincode: 392002, serviceable: "Yes", tier: "2" },
  { pincode: 392011, serviceable: "Yes", tier: "2" },
  { pincode: 392012, serviceable: "Yes", tier: "2" },
  { pincode: 392015, serviceable: "Yes", tier: "2" },
  { pincode: 392020, serviceable: "Yes", tier: "2" },
  { pincode: 392025, serviceable: "Yes", tier: "2" },
  { pincode: 392110, serviceable: "Yes", tier: "2" },
  { pincode: 392130, serviceable: "Yes", tier: "2" },
  { pincode: 392140, serviceable: "Yes", tier: "2" },
  { pincode: 392150, serviceable: "Yes", tier: "2" },
  { pincode: 392210, serviceable: "Yes", tier: "2" },
  { pincode: 392215, serviceable: "Yes", tier: "2" },
  { pincode: 392220, serviceable: "Yes", tier: "2" },
  { pincode: 392240, serviceable: "Yes", tier: "2" },
  { pincode: 392310, serviceable: "Yes", tier: "2" },
  { pincode: 393001, serviceable: "Yes", tier: "1" },
  { pincode: 393002, serviceable: "Yes", tier: "1" },
  { pincode: 393010, serviceable: "Yes", tier: "1" },
  { pincode: 393017, serviceable: "Yes", tier: "1" },
  { pincode: 393030, serviceable: "Yes", tier: "1" },
  { pincode: 393110, serviceable: "Yes", tier: "2" },
  { pincode: 393115, serviceable: "Yes", tier: "1" },
  { pincode: 393120, serviceable: "Yes", tier: "2" },
  { pincode: 393125, serviceable: "Yes", tier: "2" },
  { pincode: 393130, serviceable: "Yes", tier: "1" },
  { pincode: 393135, serviceable: "Yes", tier: "1" },
  { pincode: 393140, serviceable: "Yes", tier: "2" },
  { pincode: 393145, serviceable: "Yes", tier: "2" },
  { pincode: 393151, serviceable: "Yes", tier: "2" },
  { pincode: 394101, serviceable: "Yes", tier: "1" },
  { pincode: 394105, serviceable: "Yes", tier: "1" },
  { pincode: 394107, serviceable: "Yes", tier: "1" },
  { pincode: 394110, serviceable: "Yes", tier: "2" },
  { pincode: 394111, serviceable: "Yes", tier: "2" },
  { pincode: 394115, serviceable: "Yes", tier: "1" },
  { pincode: 394116, serviceable: "Yes", tier: "1" },
  { pincode: 394120, serviceable: "Yes", tier: "2" },
  { pincode: 394125, serviceable: "Yes", tier: "1" },
  { pincode: 394130, serviceable: "Yes", tier: "2" },
  { pincode: 394140, serviceable: "Yes", tier: "2" },
  { pincode: 394150, serviceable: "Yes", tier: "2" },
  { pincode: 394155, serviceable: "Yes", tier: "2" },
  { pincode: 394160, serviceable: "Yes", tier: "2" },
  { pincode: 394170, serviceable: "Yes", tier: "2" },
  { pincode: 394180, serviceable: "Yes", tier: "2" },
  { pincode: 394185, serviceable: "Yes", tier: "2" },
  { pincode: 394190, serviceable: "Yes", tier: "2" },
  { pincode: 394210, serviceable: "Yes", tier: "1" },
  { pincode: 394220, serviceable: "Yes", tier: "1" },
  { pincode: 394221, serviceable: "Yes", tier: "1" },
  { pincode: 394230, serviceable: "Yes", tier: "1" },
  { pincode: 394235, serviceable: "Yes", tier: "2" },
  { pincode: 394240, serviceable: "Yes", tier: "2" },
  { pincode: 394245, serviceable: "Yes", tier: "2" },
  { pincode: 394246, serviceable: "Yes", tier: "2" },
  { pincode: 394248, serviceable: "Yes", tier: "2" },
  { pincode: 394250, serviceable: "Yes", tier: "2" },
  { pincode: 394270, serviceable: "Yes", tier: "1" },
  { pincode: 394305, serviceable: "Yes", tier: "2" },
  { pincode: 394310, serviceable: "Yes", tier: "2" },
  { pincode: 394315, serviceable: "Yes", tier: "2" },
  { pincode: 394317, serviceable: "Yes", tier: "2" },
  { pincode: 394320, serviceable: "Yes", tier: "2" },
  { pincode: 394325, serviceable: "Yes", tier: "2" },
  { pincode: 394326, serviceable: "Yes", tier: "2" },
  { pincode: 394327, serviceable: "Yes", tier: "2" },
  { pincode: 394330, serviceable: "Yes", tier: "2" },
  { pincode: 394335, serviceable: "Yes", tier: "2" },
  { pincode: 394340, serviceable: "Yes", tier: "2" },
  { pincode: 394345, serviceable: "Yes", tier: "2" },
  { pincode: 394350, serviceable: "Yes", tier: "2" },
  { pincode: 394352, serviceable: "Yes", tier: "2" },
  { pincode: 394355, serviceable: "Yes", tier: "2" },
  { pincode: 394360, serviceable: "Yes", tier: "2" },
  { pincode: 394375, serviceable: "Yes", tier: "2" },
  { pincode: 394410, serviceable: "Yes", tier: "1" },
  { pincode: 394421, serviceable: "Yes", tier: "2" },
  { pincode: 394430, serviceable: "Yes", tier: "2" },
  { pincode: 394444, serviceable: "Yes", tier: "2" },
  { pincode: 394510, serviceable: "Yes", tier: "1" },
  { pincode: 394515, serviceable: "Yes", tier: "1" },
  { pincode: 394516, serviceable: "Yes", tier: "1" },
  { pincode: 394518, serviceable: "Yes", tier: "1" },
  { pincode: 394520, serviceable: "Yes", tier: "1" },
  { pincode: 394540, serviceable: "Yes", tier: "2" },
  { pincode: 394601, serviceable: "Yes", tier: "2" },
  { pincode: 394602, serviceable: "Yes", tier: "2" },
  { pincode: 394620, serviceable: "Yes", tier: "2" },
  { pincode: 394630, serviceable: "Yes", tier: "2" },
  { pincode: 394633, serviceable: "Yes", tier: "2" },
  { pincode: 394635, serviceable: "Yes", tier: "2" },
  { pincode: 394640, serviceable: "Yes", tier: "2" },
  { pincode: 394641, serviceable: "Yes", tier: "2" },
  { pincode: 394650, serviceable: "Yes", tier: "2" },
  { pincode: 394651, serviceable: "Yes", tier: "2" },
  { pincode: 394652, serviceable: "Yes", tier: "2" },
  { pincode: 394655, serviceable: "Yes", tier: "2" },
  { pincode: 394660, serviceable: "Yes", tier: "2" },
  { pincode: 394670, serviceable: "Yes", tier: "2" },
  { pincode: 394680, serviceable: "Yes", tier: "2" },
  { pincode: 394690, serviceable: "Yes", tier: "2" },
  { pincode: 394710, serviceable: "Yes", tier: "2" },
  { pincode: 394810, serviceable: "Yes", tier: "1" },
  { pincode: 395001, serviceable: "Yes", tier: "1" },
  { pincode: 395002, serviceable: "Yes", tier: "1" },
  { pincode: 395003, serviceable: "Yes", tier: "1" },
  { pincode: 395004, serviceable: "Yes", tier: "1" },
  { pincode: 395005, serviceable: "Yes", tier: "1" },
  { pincode: 395006, serviceable: "Yes", tier: "1" },
  { pincode: 395007, serviceable: "Yes", tier: "1" },
  { pincode: 395008, serviceable: "Yes", tier: "1" },
  { pincode: 395009, serviceable: "Yes", tier: "1" },
  { pincode: 395010, serviceable: "Yes", tier: "1" },
  { pincode: 395011, serviceable: "Yes", tier: "1" },
  { pincode: 395012, serviceable: "Yes", tier: "1" },
  { pincode: 395013, serviceable: "Yes", tier: "1" },
  { pincode: 395017, serviceable: "Yes", tier: "1" },
  { pincode: 395023, serviceable: "Yes", tier: "1" },
  { pincode: 396001, serviceable: "Yes", tier: "2" },
  { pincode: 396002, serviceable: "Yes", tier: "2" },
  { pincode: 396007, serviceable: "Yes", tier: "2" },
  { pincode: 396020, serviceable: "Yes", tier: "2" },
  { pincode: 396030, serviceable: "Yes", tier: "2" },
  { pincode: 396035, serviceable: "Yes", tier: "2" },
  { pincode: 396040, serviceable: "Yes", tier: "2" },
  { pincode: 396045, serviceable: "Yes", tier: "2" },
  { pincode: 396050, serviceable: "Yes", tier: "2" },
  { pincode: 396055, serviceable: "Yes", tier: "2" },
  { pincode: 396060, serviceable: "Yes", tier: "2" },
  { pincode: 396065, serviceable: "Yes", tier: "2" },
  { pincode: 396105, serviceable: "Yes", tier: "2" },
  { pincode: 396115, serviceable: "Yes", tier: "2" },
  { pincode: 396120, serviceable: "Yes", tier: "2" },
  { pincode: 396125, serviceable: "Yes", tier: "2" },
  { pincode: 396130, serviceable: "Yes", tier: "2" },
  { pincode: 396135, serviceable: "Yes", tier: "2" },
  { pincode: 396150, serviceable: "Yes", tier: "2" },
  { pincode: 396155, serviceable: "Yes", tier: "2" },
  { pincode: 396165, serviceable: "Yes", tier: "2" },
  { pincode: 396170, serviceable: "Yes", tier: "2" },
  { pincode: 396171, serviceable: "Yes", tier: "2" },
  { pincode: 396175, serviceable: "Yes", tier: "2" },
  { pincode: 396180, serviceable: "Yes", tier: "2" },
  { pincode: 396185, serviceable: "Yes", tier: "2" },
  { pincode: 396191, serviceable: "Yes", tier: "2" },
  { pincode: 396193, serviceable: "Yes", tier: "2" },
  { pincode: 396195, serviceable: "Yes", tier: "2" },
  { pincode: 396210, serviceable: "Yes", tier: "2" },
  { pincode: 396215, serviceable: "Yes", tier: "2" },
  { pincode: 396220, serviceable: "Yes", tier: "2" },
  { pincode: 396230, serviceable: "Yes", tier: "2" },
  { pincode: 396235, serviceable: "Yes", tier: "2" },
  { pincode: 396240, serviceable: "Yes", tier: "2" },
  { pincode: 396310, serviceable: "Yes", tier: "2" },
  { pincode: 396321, serviceable: "Yes", tier: "2" },
  { pincode: 396325, serviceable: "Yes", tier: "2" },
  { pincode: 396350, serviceable: "Yes", tier: "2" },
  { pincode: 396360, serviceable: "Yes", tier: "2" },
  { pincode: 396370, serviceable: "Yes", tier: "2" },
  { pincode: 396375, serviceable: "Yes", tier: "2" },
  { pincode: 396380, serviceable: "Yes", tier: "2" },
  { pincode: 396409, serviceable: "Yes", tier: "2" },
  { pincode: 396415, serviceable: "Yes", tier: "2" },
  { pincode: 396421, serviceable: "Yes", tier: "2" },
  { pincode: 396424, serviceable: "Yes", tier: "2" },
  { pincode: 396427, serviceable: "Yes", tier: "2" },
  { pincode: 396430, serviceable: "Yes", tier: "2" },
  { pincode: 396436, serviceable: "Yes", tier: "2" },
  { pincode: 396439, serviceable: "Yes", tier: "2" },
  { pincode: 396445, serviceable: "Yes", tier: "2" },
  { pincode: 396450, serviceable: "Yes", tier: "2" },
  { pincode: 396463, serviceable: "Yes", tier: "2" },
  { pincode: 396475, serviceable: "Yes", tier: "2" },
  { pincode: 396521, serviceable: "Yes", tier: "2" },
  { pincode: 396530, serviceable: "Yes", tier: "2" },
  { pincode: 396560, serviceable: "Yes", tier: "2" },
  { pincode: 396580, serviceable: "Yes", tier: "2" },
  { pincode: 396590, serviceable: "Yes", tier: "2" },
  { pincode: 400000, serviceable: "Yes", tier: "1" },
  { pincode: 400001, serviceable: "Yes", tier: "1" },
  { pincode: 400002, serviceable: "Yes", tier: "1" },
  { pincode: 400003, serviceable: "Yes", tier: "1" },
  { pincode: 400004, serviceable: "Yes", tier: "1" },
  { pincode: 400005, serviceable: "Yes", tier: "1" },
  { pincode: 400006, serviceable: "Yes", tier: "1" },
  { pincode: 400007, serviceable: "Yes", tier: "1" },
  { pincode: 400008, serviceable: "Yes", tier: "1" },
  { pincode: 400009, serviceable: "Yes", tier: "1" },
  { pincode: 400010, serviceable: "Yes", tier: "1" },
  { pincode: 400011, serviceable: "Yes", tier: "1" },
  { pincode: 400012, serviceable: "Yes", tier: "1" },
  { pincode: 400013, serviceable: "Yes", tier: "1" },
  { pincode: 400014, serviceable: "Yes", tier: "1" },
  { pincode: 400015, serviceable: "Yes", tier: "1" },
  { pincode: 400016, serviceable: "Yes", tier: "1" },
  { pincode: 400017, serviceable: "Yes", tier: "1" },
  { pincode: 400018, serviceable: "Yes", tier: "1" },
  { pincode: 400019, serviceable: "Yes", tier: "1" },
  { pincode: 400020, serviceable: "Yes", tier: "1" },
  { pincode: 400021, serviceable: "Yes", tier: "1" },
  { pincode: 400022, serviceable: "Yes", tier: "1" },
  { pincode: 400023, serviceable: "Yes", tier: "1" },
  { pincode: 400024, serviceable: "Yes", tier: "1" },
  { pincode: 400025, serviceable: "Yes", tier: "1" },
  { pincode: 400026, serviceable: "Yes", tier: "1" },
  { pincode: 400027, serviceable: "Yes", tier: "1" },
  { pincode: 400028, serviceable: "Yes", tier: "1" },
  { pincode: 400029, serviceable: "Yes", tier: "1" },
  { pincode: 400030, serviceable: "Yes", tier: "1" },
  { pincode: 400031, serviceable: "Yes", tier: "1" },
  { pincode: 400032, serviceable: "Yes", tier: "1" },
  { pincode: 400033, serviceable: "Yes", tier: "1" },
  { pincode: 400034, serviceable: "Yes", tier: "1" },
  { pincode: 400035, serviceable: "Yes", tier: "1" },
  { pincode: 400036, serviceable: "Yes", tier: "1" },
  { pincode: 400037, serviceable: "Yes", tier: "1" },
  { pincode: 400038, serviceable: "Yes", tier: "1" },
  { pincode: 400039, serviceable: "Yes", tier: "1" },
  { pincode: 400042, serviceable: "Yes", tier: "1" },
  { pincode: 400043, serviceable: "Yes", tier: "1" },
  { pincode: 400049, serviceable: "Yes", tier: "1" },
  { pincode: 400050, serviceable: "Yes", tier: "1" },
  { pincode: 400051, serviceable: "Yes", tier: "1" },
  { pincode: 400052, serviceable: "Yes", tier: "1" },
  { pincode: 400053, serviceable: "Yes", tier: "1" },
  { pincode: 400054, serviceable: "Yes", tier: "1" },
  { pincode: 400055, serviceable: "Yes", tier: "1" },
  { pincode: 400056, serviceable: "Yes", tier: "1" },
  { pincode: 400057, serviceable: "Yes", tier: "1" },
  { pincode: 400058, serviceable: "Yes", tier: "1" },
  { pincode: 400059, serviceable: "Yes", tier: "1" },
  { pincode: 400060, serviceable: "Yes", tier: "1" },
  { pincode: 400061, serviceable: "Yes", tier: "1" },
  { pincode: 400062, serviceable: "Yes", tier: "1" },
  { pincode: 400063, serviceable: "Yes", tier: "1" },
  { pincode: 400064, serviceable: "Yes", tier: "1" },
  { pincode: 400065, serviceable: "Yes", tier: "1" },
  { pincode: 400066, serviceable: "Yes", tier: "1" },
  { pincode: 400067, serviceable: "Yes", tier: "1" },
  { pincode: 400068, serviceable: "Yes", tier: "1" },
  { pincode: 400069, serviceable: "Yes", tier: "1" },
  { pincode: 400070, serviceable: "Yes", tier: "1" },
  { pincode: 400071, serviceable: "Yes", tier: "1" },
  { pincode: 400072, serviceable: "Yes", tier: "1" },
  { pincode: 400074, serviceable: "Yes", tier: "1" },
  { pincode: 400075, serviceable: "Yes", tier: "1" },
  { pincode: 400076, serviceable: "Yes", tier: "1" },
  { pincode: 400077, serviceable: "Yes", tier: "1" },
  { pincode: 400078, serviceable: "Yes", tier: "1" },
  { pincode: 400079, serviceable: "Yes", tier: "1" },
  { pincode: 400080, serviceable: "Yes", tier: "1" },
  { pincode: 400081, serviceable: "Yes", tier: "1" },
  { pincode: 400082, serviceable: "Yes", tier: "1" },
  { pincode: 400083, serviceable: "Yes", tier: "1" },
  { pincode: 400084, serviceable: "Yes", tier: "1" },
  { pincode: 400085, serviceable: "Yes", tier: "1" },
  { pincode: 400086, serviceable: "Yes", tier: "1" },
  { pincode: 400087, serviceable: "Yes", tier: "1" },
  { pincode: 400088, serviceable: "Yes", tier: "1" },
  { pincode: 400089, serviceable: "Yes", tier: "1" },
  { pincode: 400090, serviceable: "Yes", tier: "1" },
  { pincode: 400091, serviceable: "Yes", tier: "1" },
  { pincode: 400092, serviceable: "Yes", tier: "1" },
  { pincode: 400093, serviceable: "Yes", tier: "1" },
  { pincode: 400094, serviceable: "Yes", tier: "1" },
  { pincode: 400095, serviceable: "Yes", tier: "1" },
  { pincode: 400096, serviceable: "Yes", tier: "1" },
  { pincode: 400097, serviceable: "Yes", tier: "1" },
  { pincode: 400098, serviceable: "Yes", tier: "1" },
  { pincode: 400099, serviceable: "Yes", tier: "1" },
  { pincode: 400101, serviceable: "Yes", tier: "1" },
  { pincode: 400102, serviceable: "Yes", tier: "1" },
  { pincode: 400103, serviceable: "Yes", tier: "1" },
  { pincode: 400104, serviceable: "Yes", tier: "1" },
  { pincode: 400601, serviceable: "Yes", tier: "1" },
  { pincode: 400602, serviceable: "Yes", tier: "1" },
  { pincode: 400603, serviceable: "Yes", tier: "1" },
  { pincode: 400604, serviceable: "Yes", tier: "1" },
  { pincode: 400605, serviceable: "Yes", tier: "1" },
  { pincode: 400606, serviceable: "Yes", tier: "1" },
  { pincode: 400607, serviceable: "Yes", tier: "1" },
  { pincode: 400608, serviceable: "Yes", tier: "1" },
  { pincode: 400609, serviceable: "Yes", tier: "1" },
  { pincode: 400610, serviceable: "Yes", tier: "1" },
  { pincode: 400611, serviceable: "Yes", tier: "1" },
  { pincode: 400612, serviceable: "Yes", tier: "1" },
  { pincode: 400614, serviceable: "Yes", tier: "1" },
  { pincode: 400615, serviceable: "Yes", tier: "1" },
  { pincode: 400701, serviceable: "Yes", tier: "1" },
  { pincode: 400702, serviceable: "Yes", tier: "2" },
  { pincode: 400703, serviceable: "Yes", tier: "1" },
  { pincode: 400704, serviceable: "Yes", tier: "2" },
  { pincode: 400705, serviceable: "Yes", tier: "1" },
  { pincode: 400706, serviceable: "Yes", tier: "1" },
  { pincode: 400707, serviceable: "Yes", tier: "2" },
  { pincode: 400708, serviceable: "Yes", tier: "1" },
  { pincode: 400709, serviceable: "Yes", tier: "1" },
  { pincode: 400710, serviceable: "Yes", tier: "1" },
  { pincode: 401101, serviceable: "Yes", tier: "1" },
  { pincode: 401102, serviceable: "Yes", tier: "1" },
  { pincode: 401103, serviceable: "Yes", tier: "1" },
  { pincode: 401104, serviceable: "Yes", tier: "1" },
  { pincode: 401105, serviceable: "Yes", tier: "1" },
  { pincode: 401106, serviceable: "Yes", tier: "1" },
  { pincode: 401107, serviceable: "Yes", tier: "1" },
  { pincode: 401201, serviceable: "Yes", tier: "1" },
  { pincode: 401202, serviceable: "Yes", tier: "1" },
  { pincode: 401203, serviceable: "Yes", tier: "1" },
  { pincode: 401205, serviceable: "Yes", tier: "1" },
  { pincode: 401207, serviceable: "Yes", tier: "1" },
  { pincode: 401208, serviceable: "Yes", tier: "1" },
  { pincode: 401209, serviceable: "Yes", tier: "1" },
  { pincode: 401210, serviceable: "Yes", tier: "1" },
  { pincode: 401301, serviceable: "Yes", tier: "1" },
  { pincode: 401302, serviceable: "Yes", tier: "1" },
  { pincode: 401303, serviceable: "Yes", tier: "1" },
  { pincode: 401304, serviceable: "Yes", tier: "1" },
  { pincode: 401305, serviceable: "Yes", tier: "1" },
  { pincode: 401401, serviceable: "Yes", tier: "1" },
  { pincode: 401402, serviceable: "Yes", tier: "1" },
  { pincode: 401403, serviceable: "Yes", tier: "1" },
  { pincode: 401404, serviceable: "Yes", tier: "1" },
  { pincode: 401405, serviceable: "Yes", tier: "1" },
  { pincode: 401407, serviceable: "Yes", tier: "1" },
  { pincode: 401501, serviceable: "Yes", tier: "1" },
  { pincode: 401502, serviceable: "Yes", tier: "1" },
  { pincode: 401503, serviceable: "Yes", tier: "1" },
  { pincode: 401504, serviceable: "Yes", tier: "1" },
  { pincode: 401506, serviceable: "Yes", tier: "1" },
  { pincode: 401601, serviceable: "Yes", tier: "1" },
  { pincode: 401602, serviceable: "Yes", tier: "1" },
  { pincode: 401607, serviceable: "Yes", tier: "1" },
  { pincode: 401608, serviceable: "Yes", tier: "1" },
  { pincode: 401701, serviceable: "Yes", tier: "1" },
  { pincode: 401702, serviceable: "Yes", tier: "1" },
  { pincode: 402101, serviceable: "Yes", tier: "3" },
  { pincode: 402103, serviceable: "Yes", tier: "3" },
  { pincode: 402104, serviceable: "Yes", tier: "3" },
  { pincode: 402105, serviceable: "Yes", tier: "3" },
  { pincode: 402106, serviceable: "Yes", tier: "3" },
  { pincode: 402107, serviceable: "Yes", tier: "3" },
  { pincode: 402109, serviceable: "Yes", tier: "3" },
  { pincode: 402110, serviceable: "Yes", tier: "3" },
  { pincode: 402111, serviceable: "Yes", tier: "3" },
  { pincode: 402112, serviceable: "Yes", tier: "3" },
  { pincode: 402113, serviceable: "Yes", tier: "3" },
  { pincode: 402114, serviceable: "Yes", tier: "3" },
  { pincode: 402115, serviceable: "Yes", tier: "3" },
  { pincode: 402116, serviceable: "Yes", tier: "3" },
  { pincode: 402117, serviceable: "Yes", tier: "3" },
  { pincode: 402120, serviceable: "Yes", tier: "3" },
  { pincode: 402125, serviceable: "Yes", tier: "3" },
  { pincode: 402126, serviceable: "Yes", tier: "3" },
  { pincode: 402201, serviceable: "Yes", tier: "3" },
  { pincode: 402202, serviceable: "Yes", tier: "3" },
  { pincode: 402203, serviceable: "Yes", tier: "3" },
  { pincode: 402207, serviceable: "Yes", tier: "3" },
  { pincode: 402208, serviceable: "Yes", tier: "3" },
  { pincode: 402209, serviceable: "Yes", tier: "3" },
  { pincode: 402301, serviceable: "Yes", tier: "3" },
  { pincode: 402302, serviceable: "Yes", tier: "3" },
  { pincode: 402303, serviceable: "Yes", tier: "3" },
  { pincode: 402304, serviceable: "Yes", tier: "3" },
  { pincode: 402305, serviceable: "Yes", tier: "3" },
  { pincode: 402306, serviceable: "Yes", tier: "3" },
  { pincode: 402307, serviceable: "Yes", tier: "3" },
  { pincode: 402308, serviceable: "Yes", tier: "3" },
  { pincode: 402309, serviceable: "Yes", tier: "3" },
  { pincode: 402401, serviceable: "Yes", tier: "3" },
  { pincode: 402403, serviceable: "Yes", tier: "3" },
  { pincode: 402404, serviceable: "Yes", tier: "3" },
  { pincode: 403001, serviceable: "Yes", tier: "1" },
  { pincode: 403002, serviceable: "Yes", tier: "1" },
  { pincode: 403003, serviceable: "Yes", tier: "1" },
  { pincode: 403004, serviceable: "Yes", tier: "1" },
  { pincode: 403005, serviceable: "Yes", tier: "1" },
  { pincode: 403006, serviceable: "Yes", tier: "1" },
  { pincode: 403101, serviceable: "Yes", tier: "1" },
  { pincode: 403104, serviceable: "Yes", tier: "1" },
  { pincode: 403105, serviceable: "Yes", tier: "2" },
  { pincode: 403106, serviceable: "Yes", tier: "1" },
  { pincode: 403107, serviceable: "Yes", tier: "1" },
  { pincode: 403108, serviceable: "Yes", tier: "1" },
  { pincode: 403109, serviceable: "Yes", tier: "1" },
  { pincode: 403110, serviceable: "Yes", tier: "1" },
  { pincode: 403114, serviceable: "Yes", tier: "1" },
  { pincode: 403115, serviceable: "Yes", tier: "1" },
  { pincode: 403201, serviceable: "Yes", tier: "1" },
  { pincode: 403202, serviceable: "Yes", tier: "1" },
  { pincode: 403203, serviceable: "Yes", tier: "1" },
  { pincode: 403204, serviceable: "Yes", tier: "1" },
  { pincode: 403206, serviceable: "Yes", tier: "1" },
  { pincode: 403401, serviceable: "Yes", tier: "2" },
  { pincode: 403402, serviceable: "Yes", tier: "1" },
  { pincode: 403404, serviceable: "Yes", tier: "1" },
  { pincode: 403405, serviceable: "Yes", tier: "2" },
  { pincode: 403406, serviceable: "Yes", tier: "2" },
  { pincode: 403409, serviceable: "Yes", tier: "2" },
  { pincode: 403501, serviceable: "Yes", tier: "1" },
  { pincode: 403502, serviceable: "Yes", tier: "1" },
  { pincode: 403503, serviceable: "Yes", tier: "2" },
  { pincode: 403504, serviceable: "Yes", tier: "2" },
  { pincode: 403505, serviceable: "Yes", tier: "2" },
  { pincode: 403506, serviceable: "Yes", tier: "2" },
  { pincode: 403507, serviceable: "Yes", tier: "1" },
  { pincode: 403508, serviceable: "Yes", tier: "1" },
  { pincode: 403509, serviceable: "Yes", tier: "1" },
  { pincode: 403510, serviceable: "Yes", tier: "1" },
  { pincode: 403511, serviceable: "Yes", tier: "1" },
  { pincode: 403512, serviceable: "Yes", tier: "2" },
  { pincode: 403513, serviceable: "Yes", tier: "2" },
  { pincode: 403514, serviceable: "Yes", tier: "1" },
  { pincode: 403515, serviceable: "Yes", tier: "1" },
  { pincode: 403516, serviceable: "Yes", tier: "1" },
  { pincode: 403517, serviceable: "Yes", tier: "1" },
  { pincode: 403518, serviceable: "Yes", tier: "1" },
  { pincode: 403519, serviceable: "Yes", tier: "1" },
  { pincode: 403521, serviceable: "Yes", tier: "1" },
  { pincode: 403523, serviceable: "Yes", tier: "1" },
  { pincode: 403524, serviceable: "Yes", tier: "2" },
  { pincode: 403526, serviceable: "Yes", tier: "1" },
  { pincode: 403527, serviceable: "Yes", tier: "2" },
  { pincode: 403529, serviceable: "Yes", tier: "2" },
  { pincode: 403530, serviceable: "Yes", tier: "2" },
  { pincode: 403601, serviceable: "Yes", tier: "1" },
  { pincode: 403602, serviceable: "Yes", tier: "1" },
  { pincode: 403604, serviceable: "Yes", tier: "1" },
  { pincode: 403701, serviceable: "Yes", tier: "1" },
  { pincode: 403703, serviceable: "Yes", tier: "1" },
  { pincode: 403704, serviceable: "Yes", tier: "1" },
  { pincode: 403705, serviceable: "Yes", tier: "1" },
  { pincode: 403706, serviceable: "Yes", tier: "1" },
  { pincode: 403707, serviceable: "Yes", tier: "1" },
  { pincode: 403708, serviceable: "Yes", tier: "1" },
  { pincode: 403709, serviceable: "Yes", tier: "1" },
  { pincode: 403710, serviceable: "Yes", tier: "1" },
  { pincode: 403711, serviceable: "Yes", tier: "1" },
  { pincode: 403712, serviceable: "Yes", tier: "1" },
  { pincode: 403713, serviceable: "Yes", tier: "1" },
  { pincode: 403714, serviceable: "Yes", tier: "1" },
  { pincode: 403715, serviceable: "Yes", tier: "1" },
  { pincode: 403716, serviceable: "Yes", tier: "1" },
  { pincode: 403717, serviceable: "Yes", tier: "1" },
  { pincode: 403718, serviceable: "Yes", tier: "1" },
  { pincode: 403719, serviceable: "Yes", tier: "1" },
  { pincode: 403720, serviceable: "Yes", tier: "1" },
  { pincode: 403721, serviceable: "Yes", tier: "1" },
  { pincode: 403722, serviceable: "Yes", tier: "1" },
  { pincode: 403723, serviceable: "Yes", tier: "1" },
  { pincode: 403724, serviceable: "Yes", tier: "1" },
  { pincode: 403725, serviceable: "Yes", tier: "1" },
  { pincode: 403726, serviceable: "Yes", tier: "1" },
  { pincode: 403729, serviceable: "Yes", tier: "1" },
  { pincode: 403731, serviceable: "Yes", tier: "1" },
  { pincode: 403801, serviceable: "Yes", tier: "1" },
  { pincode: 403802, serviceable: "Yes", tier: "1" },
  { pincode: 403803, serviceable: "Yes", tier: "1" },
  { pincode: 403804, serviceable: "Yes", tier: "1" },
  { pincode: 403806, serviceable: "Yes", tier: "1" },
  { pincode: 410000, serviceable: "Yes", tier: "1" },
  { pincode: 410101, serviceable: "Yes", tier: "3" },
  { pincode: 410201, serviceable: "Yes", tier: "3" },
  { pincode: 410202, serviceable: "Yes", tier: "2" },
  { pincode: 410203, serviceable: "Yes", tier: "2" },
  { pincode: 410204, serviceable: "Yes", tier: "2" },
  { pincode: 410205, serviceable: "Yes", tier: "3" },
  { pincode: 410206, serviceable: "Yes", tier: "1" },
  { pincode: 410207, serviceable: "Yes", tier: "2" },
  { pincode: 410208, serviceable: "Yes", tier: "1" },
  { pincode: 410209, serviceable: "Yes", tier: "1" },
  { pincode: 410210, serviceable: "Yes", tier: "1" },
  { pincode: 410216, serviceable: "Yes", tier: "2" },
  { pincode: 410217, serviceable: "Yes", tier: "1" },
  { pincode: 410218, serviceable: "Yes", tier: "1" },
  { pincode: 410220, serviceable: "Yes", tier: "2" },
  { pincode: 410221, serviceable: "Yes", tier: "1" },
  { pincode: 410222, serviceable: "Yes", tier: "2" },
  { pincode: 410301, serviceable: "Yes", tier: "2" },
  { pincode: 410302, serviceable: "Yes", tier: "2" },
  { pincode: 410401, serviceable: "Yes", tier: "2" },
  { pincode: 410402, serviceable: "Yes", tier: "2" },
  { pincode: 410403, serviceable: "Yes", tier: "2" },
  { pincode: 410405, serviceable: "Yes", tier: "2" },
  { pincode: 410501, serviceable: "Yes", tier: "2" },
  { pincode: 410502, serviceable: "Yes", tier: "2" },
  { pincode: 410503, serviceable: "Yes", tier: "2" },
  { pincode: 410504, serviceable: "Yes", tier: "2" },
  { pincode: 410505, serviceable: "Yes", tier: "2" },
  { pincode: 410506, serviceable: "Yes", tier: "1" },
  { pincode: 410507, serviceable: "Yes", tier: "1" },
  { pincode: 410508, serviceable: "Yes", tier: "2" },
  { pincode: 410509, serviceable: "Yes", tier: "2" },
  { pincode: 410510, serviceable: "Yes", tier: "2" },
  { pincode: 410511, serviceable: "Yes", tier: "2" },
  { pincode: 410512, serviceable: "Yes", tier: "2" },
  { pincode: 410513, serviceable: "Yes", tier: "2" },
  { pincode: 410515, serviceable: "Yes", tier: "2" },
  { pincode: 410516, serviceable: "Yes", tier: "2" },
  { pincode: 410613, serviceable: "Yes", tier: "1" },
  { pincode: 411001, serviceable: "Yes", tier: "1" },
  { pincode: 411002, serviceable: "Yes", tier: "1" },
  { pincode: 411003, serviceable: "Yes", tier: "1" },
  { pincode: 411004, serviceable: "Yes", tier: "1" },
  { pincode: 411005, serviceable: "Yes", tier: "1" },
  { pincode: 411006, serviceable: "Yes", tier: "1" },
  { pincode: 411007, serviceable: "Yes", tier: "1" },
  { pincode: 411008, serviceable: "Yes", tier: "1" },
  { pincode: 411009, serviceable: "Yes", tier: "1" },
  { pincode: 411010, serviceable: "Yes", tier: "1" },
  { pincode: 411011, serviceable: "Yes", tier: "1" },
  { pincode: 411012, serviceable: "Yes", tier: "1" },
  { pincode: 411013, serviceable: "Yes", tier: "1" },
  { pincode: 411014, serviceable: "Yes", tier: "1" },
  { pincode: 411015, serviceable: "Yes", tier: "1" },
  { pincode: 411016, serviceable: "Yes", tier: "1" },
  { pincode: 411017, serviceable: "Yes", tier: "1" },
  { pincode: 411018, serviceable: "Yes", tier: "1" },
  { pincode: 411019, serviceable: "Yes", tier: "1" },
  { pincode: 411020, serviceable: "Yes", tier: "1" },
  { pincode: 411021, serviceable: "Yes", tier: "1" },
  { pincode: 411022, serviceable: "Yes", tier: "1" },
  { pincode: 411023, serviceable: "Yes", tier: "1" },
  { pincode: 411024, serviceable: "Yes", tier: "1" },
  { pincode: 411025, serviceable: "Yes", tier: "1" },
  { pincode: 411026, serviceable: "Yes", tier: "1" },
  { pincode: 411027, serviceable: "Yes", tier: "1" },
  { pincode: 411028, serviceable: "Yes", tier: "1" },
  { pincode: 411029, serviceable: "Yes", tier: "1" },
  { pincode: 411030, serviceable: "Yes", tier: "1" },
  { pincode: 411031, serviceable: "Yes", tier: "1" },
  { pincode: 411032, serviceable: "Yes", tier: "1" },
  { pincode: 411033, serviceable: "Yes", tier: "1" },
  { pincode: 411034, serviceable: "Yes", tier: "1" },
  { pincode: 411035, serviceable: "Yes", tier: "1" },
  { pincode: 411036, serviceable: "Yes", tier: "1" },
  { pincode: 411037, serviceable: "Yes", tier: "1" },
  { pincode: 411038, serviceable: "Yes", tier: "1" },
  { pincode: 411039, serviceable: "Yes", tier: "1" },
  { pincode: 411040, serviceable: "Yes", tier: "1" },
  { pincode: 411041, serviceable: "Yes", tier: "1" },
  { pincode: 411042, serviceable: "Yes", tier: "1" },
  { pincode: 411043, serviceable: "Yes", tier: "1" },
  { pincode: 411044, serviceable: "Yes", tier: "1" },
  { pincode: 411045, serviceable: "Yes", tier: "1" },
  { pincode: 411046, serviceable: "Yes", tier: "1" },
  { pincode: 411047, serviceable: "Yes", tier: "1" },
  { pincode: 411048, serviceable: "Yes", tier: "1" },
  { pincode: 411051, serviceable: "Yes", tier: "1" },
  { pincode: 411052, serviceable: "Yes", tier: "1" },
  { pincode: 411053, serviceable: "Yes", tier: "1" },
  { pincode: 411057, serviceable: "Yes", tier: "1" },
  { pincode: 411058, serviceable: "Yes", tier: "1" },
  { pincode: 411060, serviceable: "Yes", tier: "1" },
  { pincode: 411061, serviceable: "Yes", tier: "1" },
  { pincode: 411062, serviceable: "Yes", tier: "2" },
  { pincode: 411067, serviceable: "Yes", tier: "1" },
  { pincode: 411068, serviceable: "Yes", tier: "1" },
  { pincode: 411111, serviceable: "Yes", tier: "1" },
  { pincode: 411201, serviceable: "Yes", tier: "1" },
  { pincode: 412101, serviceable: "Yes", tier: "1" },
  { pincode: 412102, serviceable: "Yes", tier: "2" },
  { pincode: 412103, serviceable: "Yes", tier: "2" },
  { pincode: 412105, serviceable: "Yes", tier: "2" },
  { pincode: 412106, serviceable: "Yes", tier: "1" },
  { pincode: 412108, serviceable: "Yes", tier: "2" },
  { pincode: 412109, serviceable: "Yes", tier: "1" },
  { pincode: 412111, serviceable: "Yes", tier: "2" },
  { pincode: 412112, serviceable: "Yes", tier: "2" },
  { pincode: 412113, serviceable: "Yes", tier: "1" },
  { pincode: 412115, serviceable: "Yes", tier: "2" },
  { pincode: 412201, serviceable: "Yes", tier: "2" },
  { pincode: 412202, serviceable: "Yes", tier: "2" },
  { pincode: 412205, serviceable: "Yes", tier: "2" },
  { pincode: 412207, serviceable: "Yes", tier: "2" },
  { pincode: 412208, serviceable: "Yes", tier: "2" },
  { pincode: 412209, serviceable: "Yes", tier: "2" },
  { pincode: 412210, serviceable: "Yes", tier: "2" },
  { pincode: 412213, serviceable: "Yes", tier: "2" },
  { pincode: 412215, serviceable: "Yes", tier: "2" },
  { pincode: 412216, serviceable: "Yes", tier: "2" },
  { pincode: 412218, serviceable: "Yes", tier: "2" },
  { pincode: 412219, serviceable: "Yes", tier: "2" },
  { pincode: 412220, serviceable: "Yes", tier: "2" },
  { pincode: 412301, serviceable: "Yes", tier: "2" },
  { pincode: 412303, serviceable: "Yes", tier: "2" },
  { pincode: 412306, serviceable: "Yes", tier: "2" },
  { pincode: 412307, serviceable: "Yes", tier: "2" },
  { pincode: 412308, serviceable: "Yes", tier: "1" },
  { pincode: 412401, serviceable: "Yes", tier: "2" },
  { pincode: 412402, serviceable: "Yes", tier: "2" },
  { pincode: 412403, serviceable: "Yes", tier: "2" },
  { pincode: 412404, serviceable: "Yes", tier: "2" },
  { pincode: 412405, serviceable: "Yes", tier: "2" },
  { pincode: 412406, serviceable: "Yes", tier: "2" },
  { pincode: 412408, serviceable: "Yes", tier: "2" },
  { pincode: 412409, serviceable: "Yes", tier: "2" },
  { pincode: 412410, serviceable: "Yes", tier: "2" },
  { pincode: 412411, serviceable: "Yes", tier: "2" },
  { pincode: 412412, serviceable: "Yes", tier: "2" },
  { pincode: 412801, serviceable: "Yes", tier: "2" },
  { pincode: 412802, serviceable: "Yes", tier: "2" },
  { pincode: 412803, serviceable: "Yes", tier: "3" },
  { pincode: 412804, serviceable: "Yes", tier: "3" },
  { pincode: 412805, serviceable: "Yes", tier: "3" },
  { pincode: 412806, serviceable: "Yes", tier: "3" },
  { pincode: 413001, serviceable: "Yes", tier: "2" },
  { pincode: 413002, serviceable: "Yes", tier: "2" },
  { pincode: 413003, serviceable: "Yes", tier: "2" },
  { pincode: 413004, serviceable: "Yes", tier: "2" },
  { pincode: 413005, serviceable: "Yes", tier: "2" },
  { pincode: 413006, serviceable: "Yes", tier: "2" },
  { pincode: 413007, serviceable: "Yes", tier: "2" },
  { pincode: 413008, serviceable: "Yes", tier: "2" },
  { pincode: 413101, serviceable: "Yes", tier: "2" },
  { pincode: 413102, serviceable: "Yes", tier: "2" },
  { pincode: 413103, serviceable: "Yes", tier: "2" },
  { pincode: 413105, serviceable: "Yes", tier: "2" },
  { pincode: 413106, serviceable: "Yes", tier: "2" },
  { pincode: 413107, serviceable: "Yes", tier: "2" },
  { pincode: 413108, serviceable: "Yes", tier: "2" },
  { pincode: 413109, serviceable: "Yes", tier: "2" },
  { pincode: 413110, serviceable: "Yes", tier: "2" },
  { pincode: 413111, serviceable: "Yes", tier: "2" },
  { pincode: 413112, serviceable: "Yes", tier: "2" },
  { pincode: 413113, serviceable: "Yes", tier: "2" },
  { pincode: 413115, serviceable: "Yes", tier: "2" },
  { pincode: 413116, serviceable: "Yes", tier: "2" },
  { pincode: 413118, serviceable: "Yes", tier: "2" },
  { pincode: 413120, serviceable: "Yes", tier: "2" },
  { pincode: 413130, serviceable: "Yes", tier: "2" },
  { pincode: 413132, serviceable: "Yes", tier: "2" },
  { pincode: 413133, serviceable: "Yes", tier: "2" },
  { pincode: 413208, serviceable: "Yes", tier: "2" },
  { pincode: 413209, serviceable: "Yes", tier: "2" },
  { pincode: 413213, serviceable: "Yes", tier: "2" },
  { pincode: 413215, serviceable: "Yes", tier: "2" },
  { pincode: 413216, serviceable: "Yes", tier: "2" },
  { pincode: 413222, serviceable: "Yes", tier: "2" },
  { pincode: 413224, serviceable: "Yes", tier: "2" },
  { pincode: 413228, serviceable: "Yes", tier: "2" },
  { pincode: 413250, serviceable: "Yes", tier: "2" },
  { pincode: 413255, serviceable: "Yes", tier: "2" },
  { pincode: 413310, serviceable: "Yes", tier: "2" },
  { pincode: 413401, serviceable: "Yes", tier: "2" },
  { pincode: 413402, serviceable: "Yes", tier: "2" },
  { pincode: 413403, serviceable: "Yes", tier: "2" },
  { pincode: 413405, serviceable: "Yes", tier: "2" },
  { pincode: 413409, serviceable: "Yes", tier: "2" },
  { pincode: 413410, serviceable: "Yes", tier: "2" },
  { pincode: 413411, serviceable: "Yes", tier: "2" },
  { pincode: 413432, serviceable: "Yes", tier: "3" },
  { pincode: 413501, serviceable: "Yes", tier: "2" },
  { pincode: 413502, serviceable: "Yes", tier: "2" },
  { pincode: 413503, serviceable: "Yes", tier: "2" },
  { pincode: 413504, serviceable: "Yes", tier: "2" },
  { pincode: 413506, serviceable: "Yes", tier: "2" },
  { pincode: 413507, serviceable: "Yes", tier: "2" },
  { pincode: 413509, serviceable: "Yes", tier: "2" },
  { pincode: 413512, serviceable: "Yes", tier: "2" },
  { pincode: 413517, serviceable: "Yes", tier: "3" },
  { pincode: 413518, serviceable: "Yes", tier: "3" },
  { pincode: 413519, serviceable: "Yes", tier: "3" },
  { pincode: 413520, serviceable: "Yes", tier: "2" },
  { pincode: 413527, serviceable: "Yes", tier: "2" },
  { pincode: 413531, serviceable: "Yes", tier: "2" },
  { pincode: 413532, serviceable: "Yes", tier: "3" },
  { pincode: 413544, serviceable: "Yes", tier: "2" },
  { pincode: 413580, serviceable: "Yes", tier: "2" },
  { pincode: 413582, serviceable: "Yes", tier: "2" },
  { pincode: 413601, serviceable: "Yes", tier: "2" },
  { pincode: 413604, serviceable: "Yes", tier: "2" },
  { pincode: 413605, serviceable: "Yes", tier: "2" },
  { pincode: 413606, serviceable: "Yes", tier: "2" },
  { pincode: 413701, serviceable: "Yes", tier: "2" },
  { pincode: 413702, serviceable: "Yes", tier: "2" },
  { pincode: 413703, serviceable: "Yes", tier: "2" },
  { pincode: 413704, serviceable: "Yes", tier: "2" },
  { pincode: 413705, serviceable: "Yes", tier: "2" },
  { pincode: 413706, serviceable: "Yes", tier: "2" },
  { pincode: 413707, serviceable: "Yes", tier: "2" },
  { pincode: 413709, serviceable: "Yes", tier: "2" },
  { pincode: 413710, serviceable: "Yes", tier: "2" },
  { pincode: 413711, serviceable: "Yes", tier: "2" },
  { pincode: 413712, serviceable: "Yes", tier: "2" },
  { pincode: 413713, serviceable: "Yes", tier: "2" },
  { pincode: 413714, serviceable: "Yes", tier: "2" },
  { pincode: 413715, serviceable: "Yes", tier: "2" },
  { pincode: 413716, serviceable: "Yes", tier: "2" },
  { pincode: 413717, serviceable: "Yes", tier: "2" },
  { pincode: 413718, serviceable: "Yes", tier: "2" },
  { pincode: 413720, serviceable: "Yes", tier: "2" },
  { pincode: 413721, serviceable: "Yes", tier: "2" },
  { pincode: 413723, serviceable: "Yes", tier: "2" },
  { pincode: 413726, serviceable: "Yes", tier: "2" },
  { pincode: 413728, serviceable: "Yes", tier: "2" },
  { pincode: 413736, serviceable: "Yes", tier: "2" },
  { pincode: 413737, serviceable: "Yes", tier: "2" },
  { pincode: 413738, serviceable: "Yes", tier: "2" },
  { pincode: 413739, serviceable: "Yes", tier: "2" },
  { pincode: 413801, serviceable: "Yes", tier: "2" },
  { pincode: 413802, serviceable: "Yes", tier: "2" },
  { pincode: 414001, serviceable: "Yes", tier: "2" },
  { pincode: 414002, serviceable: "Yes", tier: "2" },
  { pincode: 414003, serviceable: "Yes", tier: "2" },
  { pincode: 414005, serviceable: "Yes", tier: "2" },
  { pincode: 414006, serviceable: "Yes", tier: "2" },
  { pincode: 414102, serviceable: "Yes", tier: "2" },
  { pincode: 414105, serviceable: "Yes", tier: "2" },
  { pincode: 414106, serviceable: "Yes", tier: "2" },
  { pincode: 414110, serviceable: "Yes", tier: "2" },
  { pincode: 414111, serviceable: "Yes", tier: "2" },
  { pincode: 414141, serviceable: "Yes", tier: "2" },
  { pincode: 414201, serviceable: "Yes", tier: "2" },
  { pincode: 414301, serviceable: "Yes", tier: "2" },
  { pincode: 414303, serviceable: "Yes", tier: "2" },
  { pincode: 414306, serviceable: "Yes", tier: "2" },
  { pincode: 414401, serviceable: "Yes", tier: "2" },
  { pincode: 414402, serviceable: "Yes", tier: "2" },
  { pincode: 414403, serviceable: "Yes", tier: "2" },
  { pincode: 414501, serviceable: "Yes", tier: "2" },
  { pincode: 414502, serviceable: "Yes", tier: "2" },
  { pincode: 414503, serviceable: "Yes", tier: "2" },
  { pincode: 414504, serviceable: "Yes", tier: "2" },
  { pincode: 414505, serviceable: "Yes", tier: "2" },
  { pincode: 414601, serviceable: "Yes", tier: "2" },
  { pincode: 414602, serviceable: "Yes", tier: "2" },
  { pincode: 414603, serviceable: "Yes", tier: "2" },
  { pincode: 414604, serviceable: "Yes", tier: "2" },
  { pincode: 414605, serviceable: "Yes", tier: "2" },
  { pincode: 414607, serviceable: "Yes", tier: "2" },
  { pincode: 414609, serviceable: "Yes", tier: "2" },
  { pincode: 414701, serviceable: "Yes", tier: "2" },
  { pincode: 415001, serviceable: "Yes", tier: "2" },
  { pincode: 415002, serviceable: "Yes", tier: "2" },
  { pincode: 415003, serviceable: "Yes", tier: "2" },
  { pincode: 415004, serviceable: "Yes", tier: "2" },
  { pincode: 415010, serviceable: "Yes", tier: "2" },
  { pincode: 415011, serviceable: "Yes", tier: "2" },
  { pincode: 415015, serviceable: "Yes", tier: "2" },
  { pincode: 415019, serviceable: "Yes", tier: "2" },
  { pincode: 415101, serviceable: "Yes", tier: "2" },
  { pincode: 415103, serviceable: "Yes", tier: "2" },
  { pincode: 415104, serviceable: "Yes", tier: "2" },
  { pincode: 415105, serviceable: "Yes", tier: "2" },
  { pincode: 415106, serviceable: "Yes", tier: "2" },
  { pincode: 415107, serviceable: "Yes", tier: "2" },
  { pincode: 415108, serviceable: "Yes", tier: "2" },
  { pincode: 415109, serviceable: "Yes", tier: "2" },
  { pincode: 415110, serviceable: "Yes", tier: "2" },
  { pincode: 415111, serviceable: "Yes", tier: "2" },
  { pincode: 415114, serviceable: "Yes", tier: "2" },
  { pincode: 415115, serviceable: "Yes", tier: "2" },
  { pincode: 415122, serviceable: "Yes", tier: "2" },
  { pincode: 415124, serviceable: "Yes", tier: "2" },
  { pincode: 415203, serviceable: "Yes", tier: "3" },
  { pincode: 415205, serviceable: "Yes", tier: "2" },
  { pincode: 415206, serviceable: "Yes", tier: "2" },
  { pincode: 415209, serviceable: "Yes", tier: "2" },
  { pincode: 415212, serviceable: "Yes", tier: "2" },
  { pincode: 415213, serviceable: "Yes", tier: "3" },
  { pincode: 415409, serviceable: "Yes", tier: "2" },
  { pincode: 415414, serviceable: "Yes", tier: "2" },
  { pincode: 415501, serviceable: "Yes", tier: "2" },
  { pincode: 415508, serviceable: "Yes", tier: "2" },
  { pincode: 415511, serviceable: "Yes", tier: "2" },
  { pincode: 415513, serviceable: "Yes", tier: "3" },
  { pincode: 415514, serviceable: "Yes", tier: "3" },
  { pincode: 415515, serviceable: "Yes", tier: "3" },
  { pincode: 415516, serviceable: "Yes", tier: "3" },
  { pincode: 415517, serviceable: "Yes", tier: "3" },
  { pincode: 415518, serviceable: "Yes", tier: "2" },
  { pincode: 415519, serviceable: "Yes", tier: "2" },
  { pincode: 415521, serviceable: "Yes", tier: "2" },
  { pincode: 415522, serviceable: "Yes", tier: "2" },
  { pincode: 415523, serviceable: "Yes", tier: "2" },
  { pincode: 415524, serviceable: "Yes", tier: "2" },
  { pincode: 415528, serviceable: "Yes", tier: "2" },
  { pincode: 415530, serviceable: "Yes", tier: "3" },
  { pincode: 415536, serviceable: "Yes", tier: "3" },
  { pincode: 415537, serviceable: "Yes", tier: "2" },
  { pincode: 415539, serviceable: "Yes", tier: "2" },
  { pincode: 415601, serviceable: "Yes", tier: "3" },
  { pincode: 415602, serviceable: "Yes", tier: "3" },
  { pincode: 415603, serviceable: "Yes", tier: "3" },
  { pincode: 415605, serviceable: "Yes", tier: "3" },
  { pincode: 415606, serviceable: "Yes", tier: "3" },
  { pincode: 415608, serviceable: "Yes", tier: "3" },
  { pincode: 415609, serviceable: "Yes", tier: "5" },
  { pincode: 415610, serviceable: "Yes", tier: "5" },
  { pincode: 415611, serviceable: "Yes", tier: "5" },
  { pincode: 415612, serviceable: "Yes", tier: "3" },
  { pincode: 415613, serviceable: "Yes", tier: "5" },
  { pincode: 415614, serviceable: "Yes", tier: "3" },
  { pincode: 415615, serviceable: "Yes", tier: "3" },
  { pincode: 415616, serviceable: "Yes", tier: "3" },
  { pincode: 415617, serviceable: "Yes", tier: "3" },
  { pincode: 415619, serviceable: "Yes", tier: "3" },
  { pincode: 415620, serviceable: "Yes", tier: "3" },
  { pincode: 415621, serviceable: "Yes", tier: "3" },
  { pincode: 415626, serviceable: "Yes", tier: "3" },
  { pincode: 415628, serviceable: "Yes", tier: "5" },
  { pincode: 415629, serviceable: "Yes", tier: "3" },
  { pincode: 415634, serviceable: "Yes", tier: "5" },
  { pincode: 415639, serviceable: "Yes", tier: "3" },
  { pincode: 415643, serviceable: "Yes", tier: "3" },
  { pincode: 415702, serviceable: "Yes", tier: "5" },
  { pincode: 415703, serviceable: "Yes", tier: "5" },
  { pincode: 415705, serviceable: "Yes", tier: "5" },
  { pincode: 415706, serviceable: "Yes", tier: "3" },
  { pincode: 415709, serviceable: "Yes", tier: "3" },
  { pincode: 415711, serviceable: "Yes", tier: "3" },
  { pincode: 415712, serviceable: "Yes", tier: "3" },
  { pincode: 415713, serviceable: "Yes", tier: "3" },
  { pincode: 415714, serviceable: "Yes", tier: "3" },
  { pincode: 415716, serviceable: "Yes", tier: "3" },
  { pincode: 415717, serviceable: "Yes", tier: "3" },
  { pincode: 415719, serviceable: "Yes", tier: "5" },
  { pincode: 415720, serviceable: "Yes", tier: "3" },
  { pincode: 415722, serviceable: "Yes", tier: "3" },
  { pincode: 415724, serviceable: "Yes", tier: "5" },
  { pincode: 415726, serviceable: "Yes", tier: "5" },
  { pincode: 415728, serviceable: "Yes", tier: "5" },
  { pincode: 415729, serviceable: "Yes", tier: "5" },
  { pincode: 415730, serviceable: "Yes", tier: "3" },
  { pincode: 415801, serviceable: "Yes", tier: "5" },
  { pincode: 415802, serviceable: "Yes", tier: "5" },
  { pincode: 415803, serviceable: "Yes", tier: "3" },
  { pincode: 415804, serviceable: "Yes", tier: "5" },
  { pincode: 415805, serviceable: "Yes", tier: "3" },
  { pincode: 415806, serviceable: "Yes", tier: "3" },
  { pincode: 415807, serviceable: "Yes", tier: "3" },
  { pincode: 416001, serviceable: "Yes", tier: "2" },
  { pincode: 416002, serviceable: "Yes", tier: "2" },
  { pincode: 416003, serviceable: "Yes", tier: "2" },
  { pincode: 416004, serviceable: "Yes", tier: "2" },
  { pincode: 416005, serviceable: "Yes", tier: "2" },
  { pincode: 416006, serviceable: "Yes", tier: "2" },
  { pincode: 416007, serviceable: "Yes", tier: "2" },
  { pincode: 416008, serviceable: "Yes", tier: "2" },
  { pincode: 416009, serviceable: "Yes", tier: "2" },
  { pincode: 416010, serviceable: "Yes", tier: "2" },
  { pincode: 416011, serviceable: "Yes", tier: "2" },
  { pincode: 416012, serviceable: "Yes", tier: "2" },
  { pincode: 416013, serviceable: "Yes", tier: "2" },
  { pincode: 416101, serviceable: "Yes", tier: "2" },
  { pincode: 416107, serviceable: "Yes", tier: "2" },
  { pincode: 416108, serviceable: "Yes", tier: "2" },
  { pincode: 416109, serviceable: "Yes", tier: "2" },
  { pincode: 416110, serviceable: "Yes", tier: "2" },
  { pincode: 416112, serviceable: "Yes", tier: "2" },
  { pincode: 416113, serviceable: "Yes", tier: "2" },
  { pincode: 416114, serviceable: "Yes", tier: "2" },
  { pincode: 416115, serviceable: "Yes", tier: "2" },
  { pincode: 416116, serviceable: "Yes", tier: "2" },
  { pincode: 416117, serviceable: "Yes", tier: "2" },
  { pincode: 416118, serviceable: "Yes", tier: "2" },
  { pincode: 416119, serviceable: "Yes", tier: "2" },
  { pincode: 416121, serviceable: "Yes", tier: "2" },
  { pincode: 416122, serviceable: "Yes", tier: "2" },
  { pincode: 416129, serviceable: "Yes", tier: "2" },
  { pincode: 416138, serviceable: "Yes", tier: "2" },
  { pincode: 416143, serviceable: "Yes", tier: "2" },
  { pincode: 416144, serviceable: "Yes", tier: "2" },
  { pincode: 416146, serviceable: "Yes", tier: "2" },
  { pincode: 416203, serviceable: "Yes", tier: "2" },
  { pincode: 416205, serviceable: "Yes", tier: "2" },
  { pincode: 416207, serviceable: "Yes", tier: "2" },
  { pincode: 416213, serviceable: "Yes", tier: "2" },
  { pincode: 416216, serviceable: "Yes", tier: "2" },
  { pincode: 416219, serviceable: "Yes", tier: "2" },
  { pincode: 416221, serviceable: "Yes", tier: "2" },
  { pincode: 416230, serviceable: "Yes", tier: "2" },
  { pincode: 416232, serviceable: "Yes", tier: "2" },
  { pincode: 416234, serviceable: "Yes", tier: "2" },
  { pincode: 416235, serviceable: "Yes", tier: "2" },
  { pincode: 416236, serviceable: "Yes", tier: "2" },
  { pincode: 416301, serviceable: "Yes", tier: "2" },
  { pincode: 416302, serviceable: "Yes", tier: "2" },
  { pincode: 416303, serviceable: "Yes", tier: "2" },
  { pincode: 416307, serviceable: "Yes", tier: "2" },
  { pincode: 416308, serviceable: "Yes", tier: "2" },
  { pincode: 416309, serviceable: "Yes", tier: "2" },
  { pincode: 416310, serviceable: "Yes", tier: "2" },
  { pincode: 416311, serviceable: "Yes", tier: "2" },
  { pincode: 416312, serviceable: "Yes", tier: "2" },
  { pincode: 416314, serviceable: "Yes", tier: "2" },
  { pincode: 416406, serviceable: "Yes", tier: "2" },
  { pincode: 416408, serviceable: "Yes", tier: "2" },
  { pincode: 416410, serviceable: "Yes", tier: "2" },
  { pincode: 416415, serviceable: "Yes", tier: "2" },
  { pincode: 416416, serviceable: "Yes", tier: "2" },
  { pincode: 416419, serviceable: "Yes", tier: "2" },
  { pincode: 416436, serviceable: "Yes", tier: "2" },
  { pincode: 416502, serviceable: "Yes", tier: "2" },
  { pincode: 416505, serviceable: "Yes", tier: "2" },
  { pincode: 416509, serviceable: "Yes", tier: "2" },
  { pincode: 416510, serviceable: "Yes", tier: "2" },
  { pincode: 416511, serviceable: "Yes", tier: "2" },
  { pincode: 416512, serviceable: "Yes", tier: "2" },
  { pincode: 416516, serviceable: "Yes", tier: "2" },
  { pincode: 416518, serviceable: "Yes", tier: "2" },
  { pincode: 416520, serviceable: "Yes", tier: "2" },
  { pincode: 416528, serviceable: "Yes", tier: "2" },
  { pincode: 416541, serviceable: "Yes", tier: "2" },
  { pincode: 416550, serviceable: "Yes", tier: "2" },
  { pincode: 416601, serviceable: "Yes", tier: "2" },
  { pincode: 416602, serviceable: "Yes", tier: "2" },
  { pincode: 416603, serviceable: "Yes", tier: "2" },
  { pincode: 416606, serviceable: "Yes", tier: "2" },
  { pincode: 416609, serviceable: "Yes", tier: "2" },
  { pincode: 416610, serviceable: "Yes", tier: "2" },
  { pincode: 416611, serviceable: "Yes", tier: "2" },
  { pincode: 416613, serviceable: "Yes", tier: "2" },
  { pincode: 416614, serviceable: "Yes", tier: "2" },
  { pincode: 416616, serviceable: "Yes", tier: "2" },
  { pincode: 416628, serviceable: "Yes", tier: "2" },
  { pincode: 416701, serviceable: "Yes", tier: "3" },
  { pincode: 416702, serviceable: "Yes", tier: "3" },
  { pincode: 416704, serviceable: "Yes", tier: "3" },
  { pincode: 416705, serviceable: "Yes", tier: "3" },
  { pincode: 416707, serviceable: "Yes", tier: "3" },
  { pincode: 416709, serviceable: "Yes", tier: "3" },
  { pincode: 416712, serviceable: "Yes", tier: "3" },
  { pincode: 416713, serviceable: "Yes", tier: "3" },
  { pincode: 416801, serviceable: "Yes", tier: "2" },
  { pincode: 416810, serviceable: "Yes", tier: "2" },
  { pincode: 416812, serviceable: "Yes", tier: "2" },
  { pincode: 421001, serviceable: "Yes", tier: "1" },
  { pincode: 421002, serviceable: "Yes", tier: "1" },
  { pincode: 421003, serviceable: "Yes", tier: "1" },
  { pincode: 421004, serviceable: "Yes", tier: "1" },
  { pincode: 421005, serviceable: "Yes", tier: "1" },
  { pincode: 421101, serviceable: "Yes", tier: "2" },
  { pincode: 421102, serviceable: "Yes", tier: "1" },
  { pincode: 421103, serviceable: "Yes", tier: "1" },
  { pincode: 421111, serviceable: "Yes", tier: "1" },
  { pincode: 421201, serviceable: "Yes", tier: "2" },
  { pincode: 421202, serviceable: "Yes", tier: "2" },
  { pincode: 421203, serviceable: "Yes", tier: "2" },
  { pincode: 421204, serviceable: "Yes", tier: "2" },
  { pincode: 421300, serviceable: "Yes", tier: "1" },
  { pincode: 421301, serviceable: "Yes", tier: "1" },
  { pincode: 421302, serviceable: "Yes", tier: "1" },
  { pincode: 421303, serviceable: "Yes", tier: "1" },
  { pincode: 421304, serviceable: "Yes", tier: "1" },
  { pincode: 421305, serviceable: "Yes", tier: "1" },
  { pincode: 421306, serviceable: "Yes", tier: "1" },
  { pincode: 421308, serviceable: "Yes", tier: "1" },
  { pincode: 421311, serviceable: "Yes", tier: "1" },
  { pincode: 421312, serviceable: "Yes", tier: "1" },
  { pincode: 421501, serviceable: "Yes", tier: "1" },
  { pincode: 421502, serviceable: "Yes", tier: "1" },
  { pincode: 421503, serviceable: "Yes", tier: "1" },
  { pincode: 421504, serviceable: "Yes", tier: "1" },
  { pincode: 421505, serviceable: "Yes", tier: "1" },
  { pincode: 421506, serviceable: "Yes", tier: "1" },
  { pincode: 421601, serviceable: "Yes", tier: "2" },
  { pincode: 421605, serviceable: "Yes", tier: "1" },
  { pincode: 422001, serviceable: "Yes", tier: "1" },
  { pincode: 422002, serviceable: "Yes", tier: "1" },
  { pincode: 422003, serviceable: "Yes", tier: "1" },
  { pincode: 422004, serviceable: "Yes", tier: "1" },
  { pincode: 422005, serviceable: "Yes", tier: "1" },
  { pincode: 422006, serviceable: "Yes", tier: "1" },
  { pincode: 422007, serviceable: "Yes", tier: "1" },
  { pincode: 422008, serviceable: "Yes", tier: "1" },
  { pincode: 422009, serviceable: "Yes", tier: "1" },
  { pincode: 422010, serviceable: "Yes", tier: "1" },
  { pincode: 422011, serviceable: "Yes", tier: "1" },
  { pincode: 422012, serviceable: "Yes", tier: "1" },
  { pincode: 422013, serviceable: "Yes", tier: "1" },
  { pincode: 422101, serviceable: "Yes", tier: "1" },
  { pincode: 422102, serviceable: "Yes", tier: "1" },
  { pincode: 422103, serviceable: "Yes", tier: "1" },
  { pincode: 422105, serviceable: "Yes", tier: "1" },
  { pincode: 422112, serviceable: "Yes", tier: "1" },
  { pincode: 422113, serviceable: "Yes", tier: "1" },
  { pincode: 422203, serviceable: "Yes", tier: "1" },
  { pincode: 422206, serviceable: "Yes", tier: "2" },
  { pincode: 422207, serviceable: "Yes", tier: "2" },
  { pincode: 422209, serviceable: "Yes", tier: "2" },
  { pincode: 422303, serviceable: "Yes", tier: "2" },
  { pincode: 422305, serviceable: "Yes", tier: "2" },
  { pincode: 422306, serviceable: "Yes", tier: "2" },
  { pincode: 422308, serviceable: "Yes", tier: "2" },
  { pincode: 422401, serviceable: "Yes", tier: "1" },
  { pincode: 422403, serviceable: "Yes", tier: "1" },
  { pincode: 422601, serviceable: "Yes", tier: "2" },
  { pincode: 422602, serviceable: "Yes", tier: "2" },
  { pincode: 422603, serviceable: "Yes", tier: "2" },
  { pincode: 422604, serviceable: "Yes", tier: "2" },
  { pincode: 422605, serviceable: "Yes", tier: "2" },
  { pincode: 422608, serviceable: "Yes", tier: "2" },
  { pincode: 422610, serviceable: "Yes", tier: "2" },
  { pincode: 422611, serviceable: "Yes", tier: "2" },
  { pincode: 422615, serviceable: "Yes", tier: "2" },
  { pincode: 422620, serviceable: "Yes", tier: "2" },
  { pincode: 422622, serviceable: "Yes", tier: "2" },
  { pincode: 423101, serviceable: "Yes", tier: "2" },
  { pincode: 423102, serviceable: "Yes", tier: "2" },
  { pincode: 423104, serviceable: "Yes", tier: "2" },
  { pincode: 423105, serviceable: "Yes", tier: "2" },
  { pincode: 423106, serviceable: "Yes", tier: "2" },
  { pincode: 423107, serviceable: "Yes", tier: "2" },
  { pincode: 423109, serviceable: "Yes", tier: "2" },
  { pincode: 423201, serviceable: "Yes", tier: "2" },
  { pincode: 423202, serviceable: "Yes", tier: "2" },
  { pincode: 423203, serviceable: "Yes", tier: "2" },
  { pincode: 423401, serviceable: "Yes", tier: "2" },
  { pincode: 423402, serviceable: "Yes", tier: "2" },
  { pincode: 423403, serviceable: "Yes", tier: "2" },
  { pincode: 423601, serviceable: "Yes", tier: "2" },
  { pincode: 423602, serviceable: "Yes", tier: "2" },
  { pincode: 423603, serviceable: "Yes", tier: "2" },
  { pincode: 423701, serviceable: "Yes", tier: "2" },
  { pincode: 423702, serviceable: "Yes", tier: "2" },
  { pincode: 423703, serviceable: "Yes", tier: "2" },
  { pincode: 424001, serviceable: "Yes", tier: "2" },
  { pincode: 424002, serviceable: "Yes", tier: "2" },
  { pincode: 424003, serviceable: "Yes", tier: "2" },
  { pincode: 424004, serviceable: "Yes", tier: "2" },
  { pincode: 424005, serviceable: "Yes", tier: "2" },
  { pincode: 424006, serviceable: "Yes", tier: "2" },
  { pincode: 424101, serviceable: "Yes", tier: "2" },
  { pincode: 424102, serviceable: "Yes", tier: "2" },
  { pincode: 424103, serviceable: "Yes", tier: "2" },
  { pincode: 424104, serviceable: "Yes", tier: "2" },
  { pincode: 424105, serviceable: "Yes", tier: "2" },
  { pincode: 424106, serviceable: "Yes", tier: "2" },
  { pincode: 424107, serviceable: "Yes", tier: "2" },
  { pincode: 424108, serviceable: "Yes", tier: "2" },
  { pincode: 424116, serviceable: "Yes", tier: "2" },
  { pincode: 424119, serviceable: "Yes", tier: "2" },
  { pincode: 424201, serviceable: "Yes", tier: "2" },
  { pincode: 424202, serviceable: "Yes", tier: "2" },
  { pincode: 424203, serviceable: "Yes", tier: "2" },
  { pincode: 424204, serviceable: "Yes", tier: "2" },
  { pincode: 424205, serviceable: "Yes", tier: "2" },
  { pincode: 424206, serviceable: "Yes", tier: "2" },
  { pincode: 424207, serviceable: "Yes", tier: "2" },
  { pincode: 424301, serviceable: "Yes", tier: "2" },
  { pincode: 424302, serviceable: "Yes", tier: "2" },
  { pincode: 424303, serviceable: "Yes", tier: "2" },
  { pincode: 424304, serviceable: "Yes", tier: "2" },
  { pincode: 424305, serviceable: "Yes", tier: "2" },
  { pincode: 424306, serviceable: "Yes", tier: "2" },
  { pincode: 424307, serviceable: "Yes", tier: "2" },
  { pincode: 424308, serviceable: "Yes", tier: "2" },
  { pincode: 424309, serviceable: "Yes", tier: "2" },
  { pincode: 424311, serviceable: "Yes", tier: "2" },
  { pincode: 424318, serviceable: "Yes", tier: "2" },
  { pincode: 425001, serviceable: "Yes", tier: "2" },
  { pincode: 425002, serviceable: "Yes", tier: "2" },
  { pincode: 425003, serviceable: "Yes", tier: "2" },
  { pincode: 425004, serviceable: "Yes", tier: "2" },
  { pincode: 425101, serviceable: "Yes", tier: "2" },
  { pincode: 425102, serviceable: "Yes", tier: "2" },
  { pincode: 425103, serviceable: "Yes", tier: "2" },
  { pincode: 425104, serviceable: "Yes", tier: "2" },
  { pincode: 425105, serviceable: "Yes", tier: "2" },
  { pincode: 425106, serviceable: "Yes", tier: "2" },
  { pincode: 425108, serviceable: "Yes", tier: "2" },
  { pincode: 425109, serviceable: "Yes", tier: "2" },
  { pincode: 425110, serviceable: "Yes", tier: "2" },
  { pincode: 425111, serviceable: "Yes", tier: "2" },
  { pincode: 425112, serviceable: "Yes", tier: "2" },
  { pincode: 425113, serviceable: "Yes", tier: "2" },
  { pincode: 425114, serviceable: "Yes", tier: "2" },
  { pincode: 425115, serviceable: "Yes", tier: "2" },
  { pincode: 425116, serviceable: "Yes", tier: "2" },
  { pincode: 425117, serviceable: "Yes", tier: "2" },
  { pincode: 425201, serviceable: "Yes", tier: "2" },
  { pincode: 425203, serviceable: "Yes", tier: "2" },
  { pincode: 425301, serviceable: "Yes", tier: "2" },
  { pincode: 425302, serviceable: "Yes", tier: "2" },
  { pincode: 425304, serviceable: "Yes", tier: "2" },
  { pincode: 425305, serviceable: "Yes", tier: "2" },
  { pincode: 425306, serviceable: "Yes", tier: "2" },
  { pincode: 425307, serviceable: "Yes", tier: "2" },
  { pincode: 425308, serviceable: "Yes", tier: "2" },
  { pincode: 425309, serviceable: "Yes", tier: "2" },
  { pincode: 425310, serviceable: "Yes", tier: "2" },
  { pincode: 425311, serviceable: "Yes", tier: "2" },
  { pincode: 425401, serviceable: "Yes", tier: "2" },
  { pincode: 425407, serviceable: "Yes", tier: "2" },
  { pincode: 425408, serviceable: "Yes", tier: "2" },
  { pincode: 425411, serviceable: "Yes", tier: "2" },
  { pincode: 425412, serviceable: "Yes", tier: "2" },
  { pincode: 425413, serviceable: "Yes", tier: "2" },
  { pincode: 425415, serviceable: "Yes", tier: "2" },
  { pincode: 425416, serviceable: "Yes", tier: "2" },
  { pincode: 425422, serviceable: "Yes", tier: "2" },
  { pincode: 425423, serviceable: "Yes", tier: "2" },
  { pincode: 425501, serviceable: "Yes", tier: "2" },
  { pincode: 425502, serviceable: "Yes", tier: "2" },
  { pincode: 425503, serviceable: "Yes", tier: "2" },
  { pincode: 425504, serviceable: "Yes", tier: "2" },
  { pincode: 425505, serviceable: "Yes", tier: "2" },
  { pincode: 425506, serviceable: "Yes", tier: "2" },
  { pincode: 425507, serviceable: "Yes", tier: "2" },
  { pincode: 425508, serviceable: "Yes", tier: "2" },
  { pincode: 425519, serviceable: "Yes", tier: "2" },
  { pincode: 425523, serviceable: "Yes", tier: "2" },
  { pincode: 425524, serviceable: "Yes", tier: "2" },
  { pincode: 431001, serviceable: "Yes", tier: "2" },
  { pincode: 431002, serviceable: "Yes", tier: "2" },
  { pincode: 431003, serviceable: "Yes", tier: "2" },
  { pincode: 431004, serviceable: "Yes", tier: "2" },
  { pincode: 431005, serviceable: "Yes", tier: "2" },
  { pincode: 431006, serviceable: "Yes", tier: "2" },
  { pincode: 431007, serviceable: "Yes", tier: "2" },
  { pincode: 431009, serviceable: "Yes", tier: "2" },
  { pincode: 431010, serviceable: "Yes", tier: "2" },
  { pincode: 431101, serviceable: "Yes", tier: "2" },
  { pincode: 431102, serviceable: "Yes", tier: "2" },
  { pincode: 431103, serviceable: "Yes", tier: "2" },
  { pincode: 431104, serviceable: "Yes", tier: "2" },
  { pincode: 431105, serviceable: "Yes", tier: "2" },
  { pincode: 431107, serviceable: "Yes", tier: "2" },
  { pincode: 431109, serviceable: "Yes", tier: "2" },
  { pincode: 431112, serviceable: "Yes", tier: "2" },
  { pincode: 431113, serviceable: "Yes", tier: "2" },
  { pincode: 431114, serviceable: "Yes", tier: "2" },
  { pincode: 431115, serviceable: "Yes", tier: "2" },
  { pincode: 431116, serviceable: "Yes", tier: "2" },
  { pincode: 431117, serviceable: "Yes", tier: "2" },
  { pincode: 431118, serviceable: "Yes", tier: "2" },
  { pincode: 431122, serviceable: "Yes", tier: "2" },
  { pincode: 431123, serviceable: "Yes", tier: "2" },
  { pincode: 431124, serviceable: "Yes", tier: "2" },
  { pincode: 431127, serviceable: "Yes", tier: "2" },
  { pincode: 431128, serviceable: "Yes", tier: "2" },
  { pincode: 431132, serviceable: "Yes", tier: "2" },
  { pincode: 431133, serviceable: "Yes", tier: "2" },
  { pincode: 431134, serviceable: "Yes", tier: "2" },
  { pincode: 431135, serviceable: "Yes", tier: "2" },
  { pincode: 431136, serviceable: "Yes", tier: "2" },
  { pincode: 431143, serviceable: "Yes", tier: "2" },
  { pincode: 431147, serviceable: "Yes", tier: "2" },
  { pincode: 431150, serviceable: "Yes", tier: "2" },
  { pincode: 431151, serviceable: "Yes", tier: "2" },
  { pincode: 431154, serviceable: "Yes", tier: "2" },
  { pincode: 431202, serviceable: "Yes", tier: "3" },
  { pincode: 431203, serviceable: "Yes", tier: "3" },
  { pincode: 431204, serviceable: "Yes", tier: "3" },
  { pincode: 431210, serviceable: "Yes", tier: "2" },
  { pincode: 431213, serviceable: "Yes", tier: "3" },
  { pincode: 431401, serviceable: "Yes", tier: "2" },
  { pincode: 431402, serviceable: "Yes", tier: "2" },
  { pincode: 431503, serviceable: "Yes", tier: "2" },
  { pincode: 431505, serviceable: "Yes", tier: "2" },
  { pincode: 431506, serviceable: "Yes", tier: "2" },
  { pincode: 431508, serviceable: "Yes", tier: "2" },
  { pincode: 431509, serviceable: "Yes", tier: "2" },
  { pincode: 431511, serviceable: "Yes", tier: "2" },
  { pincode: 431512, serviceable: "Yes", tier: "2" },
  { pincode: 431513, serviceable: "Yes", tier: "3" },
  { pincode: 431514, serviceable: "Yes", tier: "2" },
  { pincode: 431515, serviceable: "Yes", tier: "2" },
  { pincode: 431516, serviceable: "Yes", tier: "2" },
  { pincode: 431517, serviceable: "Yes", tier: "2" },
  { pincode: 431519, serviceable: "Yes", tier: "2" },
  { pincode: 431520, serviceable: "Yes", tier: "2" },
  { pincode: 431521, serviceable: "Yes", tier: "2" },
  { pincode: 431523, serviceable: "Yes", tier: "2" },
  { pincode: 431530, serviceable: "Yes", tier: "2" },
  { pincode: 431537, serviceable: "Yes", tier: "2" },
  { pincode: 431540, serviceable: "Yes", tier: "2" },
  { pincode: 431542, serviceable: "Yes", tier: "3" },
  { pincode: 431601, serviceable: "Yes", tier: "2" },
  { pincode: 431602, serviceable: "Yes", tier: "2" },
  { pincode: 431603, serviceable: "Yes", tier: "2" },
  { pincode: 431604, serviceable: "Yes", tier: "2" },
  { pincode: 431605, serviceable: "Yes", tier: "2" },
  { pincode: 431606, serviceable: "Yes", tier: "2" },
  { pincode: 431701, serviceable: "Yes", tier: "3" },
  { pincode: 431702, serviceable: "Yes", tier: "3" },
  { pincode: 431705, serviceable: "Yes", tier: "3" },
  { pincode: 431708, serviceable: "Yes", tier: "2" },
  { pincode: 431709, serviceable: "Yes", tier: "2" },
  { pincode: 431714, serviceable: "Yes", tier: "2" },
  { pincode: 431716, serviceable: "Yes", tier: "3" },
  { pincode: 440001, serviceable: "Yes", tier: "2" },
  { pincode: 440002, serviceable: "Yes", tier: "2" },
  { pincode: 440003, serviceable: "Yes", tier: "2" },
  { pincode: 440004, serviceable: "Yes", tier: "2" },
  { pincode: 440005, serviceable: "Yes", tier: "2" },
  { pincode: 440006, serviceable: "Yes", tier: "2" },
  { pincode: 440007, serviceable: "Yes", tier: "2" },
  { pincode: 440008, serviceable: "Yes", tier: "2" },
  { pincode: 440009, serviceable: "Yes", tier: "2" },
  { pincode: 440010, serviceable: "Yes", tier: "2" },
  { pincode: 440011, serviceable: "Yes", tier: "2" },
  { pincode: 440012, serviceable: "Yes", tier: "2" },
  { pincode: 440013, serviceable: "Yes", tier: "2" },
  { pincode: 440014, serviceable: "Yes", tier: "2" },
  { pincode: 440015, serviceable: "Yes", tier: "2" },
  { pincode: 440016, serviceable: "Yes", tier: "2" },
  { pincode: 440017, serviceable: "Yes", tier: "2" },
  { pincode: 440018, serviceable: "Yes", tier: "2" },
  { pincode: 440019, serviceable: "Yes", tier: "2" },
  { pincode: 440020, serviceable: "Yes", tier: "2" },
  { pincode: 440021, serviceable: "Yes", tier: "3" },
  { pincode: 440022, serviceable: "Yes", tier: "2" },
  { pincode: 440023, serviceable: "Yes", tier: "2" },
  { pincode: 440024, serviceable: "Yes", tier: "2" },
  { pincode: 440025, serviceable: "Yes", tier: "2" },
  { pincode: 440026, serviceable: "Yes", tier: "2" },
  { pincode: 440027, serviceable: "Yes", tier: "2" },
  { pincode: 440028, serviceable: "Yes", tier: "2" },
  { pincode: 440029, serviceable: "Yes", tier: "2" },
  { pincode: 440030, serviceable: "Yes", tier: "2" },
  { pincode: 440032, serviceable: "Yes", tier: "2" },
  { pincode: 440033, serviceable: "Yes", tier: "2" },
  { pincode: 440034, serviceable: "Yes", tier: "3" },
  { pincode: 440035, serviceable: "Yes", tier: "3" },
  { pincode: 440036, serviceable: "Yes", tier: "3" },
  { pincode: 440037, serviceable: "Yes", tier: "3" },
  { pincode: 441001, serviceable: "Yes", tier: "3" },
  { pincode: 441002, serviceable: "Yes", tier: "3" },
  { pincode: 441102, serviceable: "Yes", tier: "3" },
  { pincode: 441104, serviceable: "Yes", tier: "3" },
  { pincode: 441105, serviceable: "Yes", tier: "3" },
  { pincode: 441106, serviceable: "Yes", tier: "3" },
  { pincode: 441107, serviceable: "Yes", tier: "3" },
  { pincode: 441108, serviceable: "Yes", tier: "3" },
  { pincode: 441109, serviceable: "Yes", tier: "3" },
  { pincode: 441110, serviceable: "Yes", tier: "3" },
  { pincode: 441111, serviceable: "Yes", tier: "3" },
  { pincode: 441113, serviceable: "Yes", tier: "3" },
  { pincode: 441122, serviceable: "Yes", tier: "3" },
  { pincode: 441203, serviceable: "Yes", tier: "3" },
  { pincode: 441204, serviceable: "Yes", tier: "3" },
  { pincode: 441301, serviceable: "Yes", tier: "5" },
  { pincode: 441302, serviceable: "Yes", tier: "5" },
  { pincode: 441304, serviceable: "Yes", tier: "5" },
  { pincode: 441305, serviceable: "Yes", tier: "5" },
  { pincode: 441401, serviceable: "Yes", tier: "3" },
  { pincode: 441404, serviceable: "Yes", tier: "3" },
  { pincode: 441501, serviceable: "Yes", tier: "3" },
  { pincode: 441502, serviceable: "Yes", tier: "3" },
  { pincode: 441601, serviceable: "Yes", tier: "3" },
  { pincode: 441612, serviceable: "Yes", tier: "3" },
  { pincode: 441614, serviceable: "Yes", tier: "3" },
  { pincode: 441801, serviceable: "Yes", tier: "3" },
  { pincode: 441807, serviceable: "Yes", tier: "3" },
  { pincode: 441904, serviceable: "Yes", tier: "3" },
  { pincode: 441906, serviceable: "Yes", tier: "3" },
  { pincode: 441911, serviceable: "Yes", tier: "3" },
  { pincode: 441916, serviceable: "Yes", tier: "3" },
  { pincode: 442001, serviceable: "Yes", tier: "3" },
  { pincode: 442006, serviceable: "Yes", tier: "3" },
  { pincode: 442102, serviceable: "Yes", tier: "3" },
  { pincode: 442301, serviceable: "Yes", tier: "3" },
  { pincode: 442304, serviceable: "Yes", tier: "3" },
  { pincode: 442305, serviceable: "Yes", tier: "3" },
  { pincode: 442307, serviceable: "Yes", tier: "3" },
  { pincode: 442401, serviceable: "Yes", tier: "3" },
  { pincode: 442402, serviceable: "Yes", tier: "3" },
  { pincode: 442403, serviceable: "Yes", tier: "3" },
  { pincode: 442404, serviceable: "Yes", tier: "3" },
  { pincode: 442501, serviceable: "Yes", tier: "5" },
  { pincode: 442605, serviceable: "Yes", tier: "5" },
  { pincode: 442701, serviceable: "Yes", tier: "3" },
  { pincode: 442901, serviceable: "Yes", tier: "3" },
  { pincode: 442902, serviceable: "Yes", tier: "5" },
  { pincode: 442905, serviceable: "Yes", tier: "3" },
  { pincode: 442907, serviceable: "Yes", tier: "5" },
  { pincode: 443101, serviceable: "Yes", tier: "5" },
  { pincode: 443103, serviceable: "Yes", tier: "5" },
  { pincode: 443112, serviceable: "Yes", tier: "2" },
  { pincode: 443204, serviceable: "Yes", tier: "3" },
  { pincode: 443404, serviceable: "Yes", tier: "5" },
  { pincode: 443405, serviceable: "Yes", tier: "5" },
  { pincode: 444001, serviceable: "Yes", tier: "3" },
  { pincode: 444002, serviceable: "Yes", tier: "3" },
  { pincode: 444003, serviceable: "Yes", tier: "3" },
  { pincode: 444004, serviceable: "Yes", tier: "3" },
  { pincode: 444005, serviceable: "Yes", tier: "3" },
  { pincode: 444006, serviceable: "Yes", tier: "3" },
  { pincode: 444104, serviceable: "Yes", tier: "3" },
  { pincode: 444105, serviceable: "Yes", tier: "5" },
  { pincode: 444107, serviceable: "Yes", tier: "5" },
  { pincode: 444302, serviceable: "Yes", tier: "3" },
  { pincode: 444303, serviceable: "Yes", tier: "5" },
  { pincode: 444312, serviceable: "Yes", tier: "5" },
  { pincode: 444402, serviceable: "Yes", tier: "5" },
  { pincode: 444403, serviceable: "Yes", tier: "5" },
  { pincode: 444503, serviceable: "Yes", tier: "5" },
  { pincode: 444504, serviceable: "Yes", tier: "5" },
  { pincode: 444505, serviceable: "Yes", tier: "5" },
  { pincode: 444506, serviceable: "Yes", tier: "5" },
  { pincode: 444507, serviceable: "Yes", tier: "5" },
  { pincode: 444601, serviceable: "Yes", tier: "3" },
  { pincode: 444602, serviceable: "Yes", tier: "3" },
  { pincode: 444603, serviceable: "Yes", tier: "3" },
  { pincode: 444604, serviceable: "Yes", tier: "3" },
  { pincode: 444605, serviceable: "Yes", tier: "3" },
  { pincode: 444606, serviceable: "Yes", tier: "3" },
  { pincode: 444607, serviceable: "Yes", tier: "3" },
  { pincode: 444701, serviceable: "Yes", tier: "3" },
  { pincode: 444704, serviceable: "Yes", tier: "5" },
  { pincode: 444705, serviceable: "Yes", tier: "5" },
  { pincode: 444708, serviceable: "Yes", tier: "3" },
  { pincode: 444709, serviceable: "Yes", tier: "3" },
  { pincode: 444717, serviceable: "Yes", tier: "5" },
  { pincode: 444801, serviceable: "Yes", tier: "3" },
  { pincode: 444803, serviceable: "Yes", tier: "3" },
  { pincode: 444805, serviceable: "Yes", tier: "5" },
  { pincode: 444806, serviceable: "Yes", tier: "5" },
  { pincode: 444807, serviceable: "Yes", tier: "5" },
  { pincode: 444901, serviceable: "Yes", tier: "3" },
  { pincode: 444904, serviceable: "Yes", tier: "3" },
  { pincode: 444905, serviceable: "Yes", tier: "5" },
  { pincode: 444906, serviceable: "Yes", tier: "5" },
  { pincode: 445001, serviceable: "Yes", tier: "3" },
  { pincode: 445002, serviceable: "Yes", tier: "3" },
  { pincode: 445103, serviceable: "Yes", tier: "5" },
  { pincode: 445105, serviceable: "Yes", tier: "5" },
  { pincode: 445106, serviceable: "Yes", tier: "5" },
  { pincode: 445204, serviceable: "Yes", tier: "5" },
  { pincode: 445208, serviceable: "Yes", tier: "3" },
  { pincode: 445215, serviceable: "Yes", tier: "5" },
  { pincode: 450001, serviceable: "Yes", tier: "2" },
  { pincode: 450051, serviceable: "Yes", tier: "2" },
  { pincode: 450110, serviceable: "Yes", tier: "2" },
  { pincode: 450112, serviceable: "Yes", tier: "2" },
  { pincode: 450113, serviceable: "Yes", tier: "2" },
  { pincode: 450116, serviceable: "Yes", tier: "2" },
  { pincode: 450117, serviceable: "Yes", tier: "2" },
  { pincode: 450331, serviceable: "Yes", tier: "2" },
  { pincode: 450445, serviceable: "Yes", tier: "2" },
  { pincode: 451001, serviceable: "Yes", tier: "2" },
  { pincode: 451111, serviceable: "Yes", tier: "2" },
  { pincode: 451113, serviceable: "Yes", tier: "2" },
  { pincode: 451115, serviceable: "Yes", tier: "2" },
  { pincode: 451220, serviceable: "Yes", tier: "2" },
  { pincode: 451221, serviceable: "Yes", tier: "2" },
  { pincode: 451224, serviceable: "Yes", tier: "2" },
  { pincode: 451225, serviceable: "Yes", tier: "2" },
  { pincode: 451228, serviceable: "Yes", tier: "2" },
  { pincode: 451331, serviceable: "Yes", tier: "2" },
  { pincode: 451332, serviceable: "Yes", tier: "2" },
  { pincode: 451335, serviceable: "Yes", tier: "2" },
  { pincode: 451440, serviceable: "Yes", tier: "2" },
  { pincode: 451442, serviceable: "Yes", tier: "2" },
  { pincode: 451447, serviceable: "Yes", tier: "2" },
  { pincode: 451449, serviceable: "Yes", tier: "2" },
  { pincode: 451551, serviceable: "Yes", tier: "2" },
  { pincode: 451556, serviceable: "Yes", tier: "2" },
  { pincode: 451660, serviceable: "Yes", tier: "2" },
  { pincode: 451666, serviceable: "Yes", tier: "2" },
  { pincode: 451770, serviceable: "Yes", tier: "2" },
  { pincode: 452001, serviceable: "Yes", tier: "2" },
  { pincode: 452002, serviceable: "Yes", tier: "2" },
  { pincode: 452003, serviceable: "Yes", tier: "2" },
  { pincode: 452004, serviceable: "Yes", tier: "2" },
  { pincode: 452005, serviceable: "Yes", tier: "2" },
  { pincode: 452006, serviceable: "Yes", tier: "2" },
  { pincode: 452007, serviceable: "Yes", tier: "2" },
  { pincode: 452008, serviceable: "Yes", tier: "2" },
  { pincode: 452009, serviceable: "Yes", tier: "2" },
  { pincode: 452010, serviceable: "Yes", tier: "2" },
  { pincode: 452011, serviceable: "Yes", tier: "2" },
  { pincode: 452012, serviceable: "Yes", tier: "2" },
  { pincode: 452013, serviceable: "Yes", tier: "2" },
  { pincode: 452014, serviceable: "Yes", tier: "2" },
  { pincode: 452015, serviceable: "Yes", tier: "2" },
  { pincode: 452016, serviceable: "Yes", tier: "2" },
  { pincode: 452017, serviceable: "Yes", tier: "2" },
  { pincode: 452018, serviceable: "Yes", tier: "2" },
  { pincode: 452019, serviceable: "Yes", tier: "2" },
  { pincode: 452020, serviceable: "Yes", tier: "2" },
  { pincode: 453001, serviceable: "Yes", tier: "2" },
  { pincode: 453111, serviceable: "Yes", tier: "2" },
  { pincode: 453112, serviceable: "Yes", tier: "2" },
  { pincode: 453115, serviceable: "Yes", tier: "2" },
  { pincode: 453220, serviceable: "Yes", tier: "2" },
  { pincode: 453331, serviceable: "Yes", tier: "2" },
  { pincode: 453441, serviceable: "Yes", tier: "2" },
  { pincode: 453551, serviceable: "Yes", tier: "2" },
  { pincode: 453555, serviceable: "Yes", tier: "2" },
  { pincode: 453556, serviceable: "Yes", tier: "2" },
  { pincode: 453771, serviceable: "Yes", tier: "2" },
  { pincode: 454001, serviceable: "Yes", tier: "2" },
  { pincode: 454111, serviceable: "Yes", tier: "2" },
  { pincode: 454116, serviceable: "Yes", tier: "2" },
  { pincode: 454331, serviceable: "Yes", tier: "2" },
  { pincode: 454335, serviceable: "Yes", tier: "2" },
  { pincode: 454441, serviceable: "Yes", tier: "2" },
  { pincode: 454446, serviceable: "Yes", tier: "2" },
  { pincode: 454449, serviceable: "Yes", tier: "2" },
  { pincode: 454552, serviceable: "Yes", tier: "2" },
  { pincode: 454660, serviceable: "Yes", tier: "2" },
  { pincode: 454665, serviceable: "Yes", tier: "2" },
  { pincode: 454772, serviceable: "Yes", tier: "2" },
  { pincode: 454773, serviceable: "Yes", tier: "2" },
  { pincode: 454774, serviceable: "Yes", tier: "2" },
  { pincode: 454775, serviceable: "Yes", tier: "2" },
  { pincode: 455001, serviceable: "Yes", tier: "2" },
  { pincode: 455003, serviceable: "Yes", tier: "2" },
  { pincode: 455111, serviceable: "Yes", tier: "2" },
  { pincode: 455115, serviceable: "Yes", tier: "2" },
  { pincode: 455116, serviceable: "Yes", tier: "2" },
  { pincode: 455118, serviceable: "Yes", tier: "2" },
  { pincode: 455223, serviceable: "Yes", tier: "2" },
  { pincode: 455227, serviceable: "Yes", tier: "2" },
  { pincode: 455332, serviceable: "Yes", tier: "2" },
  { pincode: 455336, serviceable: "Yes", tier: "2" },
  { pincode: 456001, serviceable: "Yes", tier: "2" },
  { pincode: 456003, serviceable: "Yes", tier: "2" },
  { pincode: 456006, serviceable: "Yes", tier: "2" },
  { pincode: 456010, serviceable: "Yes", tier: "2" },
  { pincode: 456221, serviceable: "Yes", tier: "2" },
  { pincode: 456224, serviceable: "Yes", tier: "2" },
  { pincode: 456313, serviceable: "Yes", tier: "2" },
  { pincode: 456331, serviceable: "Yes", tier: "2" },
  { pincode: 456335, serviceable: "Yes", tier: "2" },
  { pincode: 456440, serviceable: "Yes", tier: "2" },
  { pincode: 456443, serviceable: "Yes", tier: "2" },
  { pincode: 456665, serviceable: "Yes", tier: "2" },
  { pincode: 456770, serviceable: "Yes", tier: "2" },
  { pincode: 456771, serviceable: "Yes", tier: "2" },
  { pincode: 457001, serviceable: "Yes", tier: "2" },
  { pincode: 457112, serviceable: "Yes", tier: "2" },
  { pincode: 457114, serviceable: "Yes", tier: "2" },
  { pincode: 457226, serviceable: "Yes", tier: "2" },
  { pincode: 457661, serviceable: "Yes", tier: "2" },
  { pincode: 457773, serviceable: "Yes", tier: "2" },
  { pincode: 457775, serviceable: "Yes", tier: "2" },
  { pincode: 457777, serviceable: "Yes", tier: "2" },
  { pincode: 457779, serviceable: "Yes", tier: "2" },
  { pincode: 457882, serviceable: "Yes", tier: "2" },
  { pincode: 457887, serviceable: "Yes", tier: "2" },
  { pincode: 457888, serviceable: "Yes", tier: "2" },
  { pincode: 457990, serviceable: "Yes", tier: "2" },
  { pincode: 457993, serviceable: "Yes", tier: "2" },
  { pincode: 458001, serviceable: "Yes", tier: "2" },
  { pincode: 458002, serviceable: "Yes", tier: "2" },
  { pincode: 458110, serviceable: "Yes", tier: "2" },
  { pincode: 458118, serviceable: "Yes", tier: "2" },
  { pincode: 458330, serviceable: "Yes", tier: "2" },
  { pincode: 458441, serviceable: "Yes", tier: "2" },
  { pincode: 458468, serviceable: "Yes", tier: "2" },
  { pincode: 458470, serviceable: "Yes", tier: "2" },
  { pincode: 458556, serviceable: "Yes", tier: "2" },
  { pincode: 458664, serviceable: "Yes", tier: "2" },
  { pincode: 458667, serviceable: "Yes", tier: "2" },
  { pincode: 460001, serviceable: "Yes", tier: "2" },
  { pincode: 460002, serviceable: "Yes", tier: "2" },
  { pincode: 460004, serviceable: "Yes", tier: "2" },
  { pincode: 460005, serviceable: "Yes", tier: "2" },
  { pincode: 460110, serviceable: "Yes", tier: "2" },
  { pincode: 460225, serviceable: "Yes", tier: "2" },
  { pincode: 460330, serviceable: "Yes", tier: "2" },
  { pincode: 460440, serviceable: "Yes", tier: "2" },
  { pincode: 460443, serviceable: "Yes", tier: "2" },
  { pincode: 460447, serviceable: "Yes", tier: "2" },
  { pincode: 460449, serviceable: "Yes", tier: "2" },
  { pincode: 460551, serviceable: "Yes", tier: "3" },
  { pincode: 460553, serviceable: "Yes", tier: "3" },
  { pincode: 460661, serviceable: "Yes", tier: "3" },
  { pincode: 460668, serviceable: "Yes", tier: "3" },
  { pincode: 461001, serviceable: "Yes", tier: "5" },
  { pincode: 461005, serviceable: "Yes", tier: "5" },
  { pincode: 461110, serviceable: "Yes", tier: "5" },
  { pincode: 461111, serviceable: "Yes", tier: "5" },
  { pincode: 461114, serviceable: "Yes", tier: "5" },
  { pincode: 461115, serviceable: "Yes", tier: "5" },
  { pincode: 461116, serviceable: "Yes", tier: "5" },
  { pincode: 461122, serviceable: "Yes", tier: "5" },
  { pincode: 461221, serviceable: "Yes", tier: "5" },
  { pincode: 461223, serviceable: "Yes", tier: "5" },
  { pincode: 461331, serviceable: "Yes", tier: "2" },
  { pincode: 461441, serviceable: "Yes", tier: "2" },
  { pincode: 461446, serviceable: "Yes", tier: "5" },
  { pincode: 461551, serviceable: "Yes", tier: "5" },
  { pincode: 461661, serviceable: "Yes", tier: "5" },
  { pincode: 461771, serviceable: "Yes", tier: "2" },
  { pincode: 461775, serviceable: "Yes", tier: "2" },
  { pincode: 461881, serviceable: "Yes", tier: "2" },
  { pincode: 461990, serviceable: "Yes", tier: "2" },
  { pincode: 462001, serviceable: "Yes", tier: "2" },
  { pincode: 462002, serviceable: "Yes", tier: "2" },
  { pincode: 462003, serviceable: "Yes", tier: "2" },
  { pincode: 462004, serviceable: "Yes", tier: "2" },
  { pincode: 462007, serviceable: "Yes", tier: "2" },
  { pincode: 462008, serviceable: "Yes", tier: "2" },
  { pincode: 462010, serviceable: "Yes", tier: "2" },
  { pincode: 462011, serviceable: "Yes", tier: "2" },
  { pincode: 462012, serviceable: "Yes", tier: "2" },
  { pincode: 462013, serviceable: "Yes", tier: "2" },
  { pincode: 462016, serviceable: "Yes", tier: "2" },
  { pincode: 462018, serviceable: "Yes", tier: "2" },
  { pincode: 462020, serviceable: "Yes", tier: "2" },
  { pincode: 462021, serviceable: "Yes", tier: "2" },
  { pincode: 462022, serviceable: "Yes", tier: "2" },
  { pincode: 462023, serviceable: "Yes", tier: "2" },
  { pincode: 462024, serviceable: "Yes", tier: "2" },
  { pincode: 462026, serviceable: "Yes", tier: "2" },
  { pincode: 462027, serviceable: "Yes", tier: "2" },
  { pincode: 462030, serviceable: "Yes", tier: "2" },
  { pincode: 462031, serviceable: "Yes", tier: "2" },
  { pincode: 462032, serviceable: "Yes", tier: "2" },
  { pincode: 462033, serviceable: "Yes", tier: "2" },
  { pincode: 462036, serviceable: "Yes", tier: "2" },
  { pincode: 462037, serviceable: "Yes", tier: "2" },
  { pincode: 462038, serviceable: "Yes", tier: "2" },
  { pincode: 462039, serviceable: "Yes", tier: "2" },
  { pincode: 462040, serviceable: "Yes", tier: "2" },
  { pincode: 462041, serviceable: "Yes", tier: "2" },
  { pincode: 462042, serviceable: "Yes", tier: "2" },
  { pincode: 462043, serviceable: "Yes", tier: "2" },
  { pincode: 462044, serviceable: "Yes", tier: "2" },
  { pincode: 462045, serviceable: "Yes", tier: "2" },
  { pincode: 462046, serviceable: "Yes", tier: "2" },
  { pincode: 462047, serviceable: "Yes", tier: "2" },
  { pincode: 462066, serviceable: "Yes", tier: "2" },
  { pincode: 462100, serviceable: "Yes", tier: "2" },
  { pincode: 462101, serviceable: "Yes", tier: "2" },
  { pincode: 463106, serviceable: "Yes", tier: "2" },
  { pincode: 464001, serviceable: "Yes", tier: "3" },
  { pincode: 464002, serviceable: "Yes", tier: "3" },
  { pincode: 464221, serviceable: "Yes", tier: "5" },
  { pincode: 464224, serviceable: "Yes", tier: "3" },
  { pincode: 464226, serviceable: "Yes", tier: "3" },
  { pincode: 464228, serviceable: "Yes", tier: "5" },
  { pincode: 464331, serviceable: "Yes", tier: "3" },
  { pincode: 464334, serviceable: "Yes", tier: "3" },
  { pincode: 464337, serviceable: "Yes", tier: "3" },
  { pincode: 464551, serviceable: "Yes", tier: "3" },
  { pincode: 464570, serviceable: "Yes", tier: "3" },
  { pincode: 464661, serviceable: "Yes", tier: "3" },
  { pincode: 464884, serviceable: "Yes", tier: "3" },
  { pincode: 464986, serviceable: "Yes", tier: "3" },
  { pincode: 464990, serviceable: "Yes", tier: "2" },
  { pincode: 464993, serviceable: "Yes", tier: "2" },
  { pincode: 465001, serviceable: "Yes", tier: "2" },
  { pincode: 465106, serviceable: "Yes", tier: "2" },
  { pincode: 465110, serviceable: "Yes", tier: "2" },
  { pincode: 465223, serviceable: "Yes", tier: "2" },
  { pincode: 465333, serviceable: "Yes", tier: "2" },
  { pincode: 465337, serviceable: "Yes", tier: "2" },
  { pincode: 465339, serviceable: "Yes", tier: "2" },
  { pincode: 465441, serviceable: "Yes", tier: "2" },
  { pincode: 465445, serviceable: "Yes", tier: "2" },
  { pincode: 465447, serviceable: "Yes", tier: "2" },
  { pincode: 465550, serviceable: "Yes", tier: "2" },
  { pincode: 465661, serviceable: "Yes", tier: "2" },
  { pincode: 465667, serviceable: "Yes", tier: "2" },
  { pincode: 465669, serviceable: "Yes", tier: "2" },
  { pincode: 465674, serviceable: "Yes", tier: "2" },
  { pincode: 465677, serviceable: "Yes", tier: "2" },
  { pincode: 465679, serviceable: "Yes", tier: "2" },
  { pincode: 465683, serviceable: "Yes", tier: "2" },
  { pincode: 465685, serviceable: "Yes", tier: "2" },
  { pincode: 465697, serviceable: "Yes", tier: "2" },
  { pincode: 466001, serviceable: "Yes", tier: "2" },
  { pincode: 466114, serviceable: "Yes", tier: "2" },
  { pincode: 466115, serviceable: "Yes", tier: "2" },
  { pincode: 466116, serviceable: "Yes", tier: "2" },
  { pincode: 466331, serviceable: "Yes", tier: "2" },
  { pincode: 466445, serviceable: "Yes", tier: "5" },
  { pincode: 466446, serviceable: "Yes", tier: "5" },
  { pincode: 466651, serviceable: "Yes", tier: "2" },
  { pincode: 466661, serviceable: "Yes", tier: "2" },
  { pincode: 466666, serviceable: "Yes", tier: "1" },
  { pincode: 470001, serviceable: "Yes", tier: "2" },
  { pincode: 470002, serviceable: "Yes", tier: "2" },
  { pincode: 470003, serviceable: "Yes", tier: "2" },
  { pincode: 470004, serviceable: "Yes", tier: "2" },
  { pincode: 470005, serviceable: "Yes", tier: "2" },
  { pincode: 470021, serviceable: "Yes", tier: "2" },
  { pincode: 470051, serviceable: "Yes", tier: "2" },
  { pincode: 470113, serviceable: "Yes", tier: "3" },
  { pincode: 470115, serviceable: "Yes", tier: "3" },
  { pincode: 470117, serviceable: "Yes", tier: "3" },
  { pincode: 470120, serviceable: "Yes", tier: "2" },
  { pincode: 470124, serviceable: "Yes", tier: "3" },
  { pincode: 470221, serviceable: "Yes", tier: "2" },
  { pincode: 470223, serviceable: "Yes", tier: "2" },
  { pincode: 470226, serviceable: "Yes", tier: "2" },
  { pincode: 470227, serviceable: "Yes", tier: "2" },
  { pincode: 470228, serviceable: "Yes", tier: "2" },
  { pincode: 470229, serviceable: "Yes", tier: "2" },
  { pincode: 470335, serviceable: "Yes", tier: "2" },
  { pincode: 470337, serviceable: "Yes", tier: "2" },
  { pincode: 470339, serviceable: "Yes", tier: "2" },
  { pincode: 470442, serviceable: "Yes", tier: "2" },
  { pincode: 470661, serviceable: "Yes", tier: "2" },
  { pincode: 470666, serviceable: "Yes", tier: "2" },
  { pincode: 470672, serviceable: "Yes", tier: "2" },
  { pincode: 470675, serviceable: "Yes", tier: "2" },
  { pincode: 470775, serviceable: "Yes", tier: "2" },
  { pincode: 471001, serviceable: "Yes", tier: "2" },
  { pincode: 471111, serviceable: "Yes", tier: "2" },
  { pincode: 471201, serviceable: "Yes", tier: "2" },
  { pincode: 471301, serviceable: "Yes", tier: "2" },
  { pincode: 471311, serviceable: "Yes", tier: "2" },
  { pincode: 471405, serviceable: "Yes", tier: "2" },
  { pincode: 471501, serviceable: "Yes", tier: "2" },
  { pincode: 471515, serviceable: "Yes", tier: "3" },
  { pincode: 471525, serviceable: "Yes", tier: "3" },
  { pincode: 471606, serviceable: "Yes", tier: "3" },
  { pincode: 471625, serviceable: "Yes", tier: "3" },
  { pincode: 472001, serviceable: "Yes", tier: "3" },
  { pincode: 472115, serviceable: "Yes", tier: "3" },
  { pincode: 472118, serviceable: "Yes", tier: "3" },
  { pincode: 472221, serviceable: "Yes", tier: "3" },
  { pincode: 472246, serviceable: "Yes", tier: "3" },
  { pincode: 472336, serviceable: "Yes", tier: "3" },
  { pincode: 472442, serviceable: "Yes", tier: "3" },
  { pincode: 473001, serviceable: "Yes", tier: "3" },
  { pincode: 473002, serviceable: "Yes", tier: "3" },
  { pincode: 473101, serviceable: "Yes", tier: "3" },
  { pincode: 473110, serviceable: "Yes", tier: "3" },
  { pincode: 473111, serviceable: "Yes", tier: "3" },
  { pincode: 473112, serviceable: "Yes", tier: "3" },
  { pincode: 473115, serviceable: "Yes", tier: "2" },
  { pincode: 473222, serviceable: "Yes", tier: "3" },
  { pincode: 473226, serviceable: "Yes", tier: "3" },
  { pincode: 473331, serviceable: "Yes", tier: "3" },
  { pincode: 473335, serviceable: "Yes", tier: "3" },
  { pincode: 473443, serviceable: "Yes", tier: "3" },
  { pincode: 473446, serviceable: "Yes", tier: "3" },
  { pincode: 473551, serviceable: "Yes", tier: "3" },
  { pincode: 473638, serviceable: "Yes", tier: "3" },
  { pincode: 473660, serviceable: "Yes", tier: "3" },
  { pincode: 473885, serviceable: "Yes", tier: "3" },
  { pincode: 473995, serviceable: "Yes", tier: "3" },
  { pincode: 474001, serviceable: "Yes", tier: "2" },
  { pincode: 474002, serviceable: "Yes", tier: "2" },
  { pincode: 474003, serviceable: "Yes", tier: "2" },
  { pincode: 474004, serviceable: "Yes", tier: "2" },
  { pincode: 474005, serviceable: "Yes", tier: "2" },
  { pincode: 474006, serviceable: "Yes", tier: "2" },
  { pincode: 474007, serviceable: "Yes", tier: "2" },
  { pincode: 474008, serviceable: "Yes", tier: "2" },
  { pincode: 474009, serviceable: "Yes", tier: "2" },
  { pincode: 474010, serviceable: "Yes", tier: "2" },
  { pincode: 474011, serviceable: "Yes", tier: "2" },
  { pincode: 474012, serviceable: "Yes", tier: "2" },
  { pincode: 474015, serviceable: "Yes", tier: "2" },
  { pincode: 474020, serviceable: "Yes", tier: "2" },
  { pincode: 475005, serviceable: "Yes", tier: "3" },
  { pincode: 475110, serviceable: "Yes", tier: "3" },
  { pincode: 475115, serviceable: "Yes", tier: "3" },
  { pincode: 475335, serviceable: "Yes", tier: "3" },
  { pincode: 475661, serviceable: "Yes", tier: "3" },
  { pincode: 476001, serviceable: "Yes", tier: "3" },
  { pincode: 476111, serviceable: "Yes", tier: "3" },
  { pincode: 476115, serviceable: "Yes", tier: "3" },
  { pincode: 476221, serviceable: "Yes", tier: "3" },
  { pincode: 476224, serviceable: "Yes", tier: "3" },
  { pincode: 476229, serviceable: "Yes", tier: "3" },
  { pincode: 476337, serviceable: "Yes", tier: "3" },
  { pincode: 477001, serviceable: "Yes", tier: "3" },
  { pincode: 477116, serviceable: "Yes", tier: "2" },
  { pincode: 477117, serviceable: "Yes", tier: "2" },
  { pincode: 477441, serviceable: "Yes", tier: "3" },
  { pincode: 477445, serviceable: "Yes", tier: "3" },
  { pincode: 477660, serviceable: "Yes", tier: "3" },
  { pincode: 480001, serviceable: "Yes", tier: "2" },
  { pincode: 480002, serviceable: "Yes", tier: "2" },
  { pincode: 480105, serviceable: "Yes", tier: "3" },
  { pincode: 480106, serviceable: "Yes", tier: "3" },
  { pincode: 480107, serviceable: "Yes", tier: "2" },
  { pincode: 480108, serviceable: "Yes", tier: "3" },
  { pincode: 480112, serviceable: "Yes", tier: "2" },
  { pincode: 480115, serviceable: "Yes", tier: "2" },
  { pincode: 480334, serviceable: "Yes", tier: "3" },
  { pincode: 480337, serviceable: "Yes", tier: "3" },
  { pincode: 480441, serviceable: "Yes", tier: "2" },
  { pincode: 480551, serviceable: "Yes", tier: "2" },
  { pincode: 480661, serviceable: "Yes", tier: "3" },
  { pincode: 480667, serviceable: "Yes", tier: "3" },
  { pincode: 480880, serviceable: "Yes", tier: "3" },
  { pincode: 480882, serviceable: "Yes", tier: "3" },
  { pincode: 480884, serviceable: "Yes", tier: "3" },
  { pincode: 480886, serviceable: "Yes", tier: "3" },
  { pincode: 480888, serviceable: "Yes", tier: "3" },
  { pincode: 480990, serviceable: "Yes", tier: "3" },
  { pincode: 480991, serviceable: "Yes", tier: "3" },
  { pincode: 480994, serviceable: "Yes", tier: "3" },
  { pincode: 480997, serviceable: "Yes", tier: "3" },
  { pincode: 481001, serviceable: "Yes", tier: "3" },
  { pincode: 481102, serviceable: "Yes", tier: "3" },
  { pincode: 481115, serviceable: "Yes", tier: "3" },
  { pincode: 481224, serviceable: "Yes", tier: "3" },
  { pincode: 481226, serviceable: "Yes", tier: "3" },
  { pincode: 481331, serviceable: "Yes", tier: "3" },
  { pincode: 481332, serviceable: "Yes", tier: "3" },
  { pincode: 481335, serviceable: "Yes", tier: "3" },
  { pincode: 481337, serviceable: "Yes", tier: "3" },
  { pincode: 481441, serviceable: "Yes", tier: "3" },
  { pincode: 481661, serviceable: "Yes", tier: "3" },
  { pincode: 481879, serviceable: "Yes", tier: "5" },
  { pincode: 481880, serviceable: "Yes", tier: "5" },
  { pincode: 481882, serviceable: "Yes", tier: "5" },
  { pincode: 481883, serviceable: "Yes", tier: "5" },
  { pincode: 481884, serviceable: "Yes", tier: "5" },
  { pincode: 481990, serviceable: "Yes", tier: "5" },
  { pincode: 482001, serviceable: "Yes", tier: "3" },
  { pincode: 482002, serviceable: "Yes", tier: "3" },
  { pincode: 482003, serviceable: "Yes", tier: "3" },
  { pincode: 482004, serviceable: "Yes", tier: "3" },
  { pincode: 482005, serviceable: "Yes", tier: "3" },
  { pincode: 482006, serviceable: "Yes", tier: "3" },
  { pincode: 482007, serviceable: "Yes", tier: "3" },
  { pincode: 482008, serviceable: "Yes", tier: "3" },
  { pincode: 482009, serviceable: "Yes", tier: "3" },
  { pincode: 482010, serviceable: "Yes", tier: "3" },
  { pincode: 482011, serviceable: "Yes", tier: "3" },
  { pincode: 482020, serviceable: "Yes", tier: "3" },
  { pincode: 482021, serviceable: "Yes", tier: "3" },
  { pincode: 482051, serviceable: "Yes", tier: "3" },
  { pincode: 482056, serviceable: "Yes", tier: "3" },
  { pincode: 483053, serviceable: "Yes", tier: "3" },
  { pincode: 483119, serviceable: "Yes", tier: "3" },
  { pincode: 483220, serviceable: "Yes", tier: "3" },
  { pincode: 483222, serviceable: "Yes", tier: "3" },
  { pincode: 483225, serviceable: "Yes", tier: "3" },
  { pincode: 483334, serviceable: "Yes", tier: "3" },
  { pincode: 483336, serviceable: "Yes", tier: "3" },
  { pincode: 483501, serviceable: "Yes", tier: "3" },
  { pincode: 483503, serviceable: "Yes", tier: "3" },
  { pincode: 483504, serviceable: "Yes", tier: "3" },
  { pincode: 483770, serviceable: "Yes", tier: "3" },
  { pincode: 483775, serviceable: "Yes", tier: "3" },
  { pincode: 483880, serviceable: "Yes", tier: "3" },
  { pincode: 484001, serviceable: "Yes", tier: "3" },
  { pincode: 484110, serviceable: "Yes", tier: "3" },
  { pincode: 484114, serviceable: "Yes", tier: "3" },
  { pincode: 484116, serviceable: "Yes", tier: "3" },
  { pincode: 484117, serviceable: "Yes", tier: "3" },
  { pincode: 484120, serviceable: "Yes", tier: "3" },
  { pincode: 484220, serviceable: "Yes", tier: "3" },
  { pincode: 484224, serviceable: "Yes", tier: "3" },
  { pincode: 484330, serviceable: "Yes", tier: "3" },
  { pincode: 484334, serviceable: "Yes", tier: "3" },
  { pincode: 484336, serviceable: "Yes", tier: "3" },
  { pincode: 484440, serviceable: "Yes", tier: "3" },
  { pincode: 484444, serviceable: "Yes", tier: "3" },
  { pincode: 484551, serviceable: "Yes", tier: "3" },
  { pincode: 484555, serviceable: "Yes", tier: "3" },
  { pincode: 484661, serviceable: "Yes", tier: "3" },
  { pincode: 484771, serviceable: "Yes", tier: "5" },
  { pincode: 484774, serviceable: "Yes", tier: "5" },
  { pincode: 484776, serviceable: "Yes", tier: "5" },
  { pincode: 485001, serviceable: "Yes", tier: "3" },
  { pincode: 485002, serviceable: "Yes", tier: "3" },
  { pincode: 485003, serviceable: "Yes", tier: "3" },
  { pincode: 485004, serviceable: "Yes", tier: "3" },
  { pincode: 485005, serviceable: "Yes", tier: "3" },
  { pincode: 485111, serviceable: "Yes", tier: "3" },
  { pincode: 485112, serviceable: "Yes", tier: "3" },
  { pincode: 485113, serviceable: "Yes", tier: "3" },
  { pincode: 485114, serviceable: "Yes", tier: "3" },
  { pincode: 485221, serviceable: "Yes", tier: "3" },
  { pincode: 485226, serviceable: "Yes", tier: "3" },
  { pincode: 485441, serviceable: "Yes", tier: "3" },
  { pincode: 485446, serviceable: "Yes", tier: "3" },
  { pincode: 485661, serviceable: "Yes", tier: "3" },
  { pincode: 485666, serviceable: "Yes", tier: "3" },
  { pincode: 485771, serviceable: "Yes", tier: "3" },
  { pincode: 485772, serviceable: "Yes", tier: "3" },
  { pincode: 485773, serviceable: "Yes", tier: "3" },
  { pincode: 485774, serviceable: "Yes", tier: "3" },
  { pincode: 485775, serviceable: "Yes", tier: "3" },
  { pincode: 486001, serviceable: "Yes", tier: "3" },
  { pincode: 486002, serviceable: "Yes", tier: "3" },
  { pincode: 486003, serviceable: "Yes", tier: "3" },
  { pincode: 486005, serviceable: "Yes", tier: "3" },
  { pincode: 486006, serviceable: "Yes", tier: "3" },
  { pincode: 486111, serviceable: "Yes", tier: "3" },
  { pincode: 486335, serviceable: "Yes", tier: "5" },
  { pincode: 486338, serviceable: "Yes", tier: "3" },
  { pincode: 486341, serviceable: "Yes", tier: "3" },
  { pincode: 486440, serviceable: "Yes", tier: "3" },
  { pincode: 486441, serviceable: "Yes", tier: "3" },
  { pincode: 486446, serviceable: "Yes", tier: "3" },
  { pincode: 486450, serviceable: "Yes", tier: "3" },
  { pincode: 486550, serviceable: "Yes", tier: "3" },
  { pincode: 486661, serviceable: "Yes", tier: "5" },
  { pincode: 486669, serviceable: "Yes", tier: "5" },
  { pincode: 486670, serviceable: "Yes", tier: "5" },
  { pincode: 486675, serviceable: "Yes", tier: "5" },
  { pincode: 486771, serviceable: "Yes", tier: "5" },
  { pincode: 486775, serviceable: "Yes", tier: "5" },
  { pincode: 486884, serviceable: "Yes", tier: "5" },
  { pincode: 486885, serviceable: "Yes", tier: "5" },
  { pincode: 486886, serviceable: "Yes", tier: "5" },
  { pincode: 486887, serviceable: "Yes", tier: "5" },
  { pincode: 486888, serviceable: "Yes", tier: "5" },
  { pincode: 486889, serviceable: "Yes", tier: "5" },
  { pincode: 486890, serviceable: "Yes", tier: "5" },
  { pincode: 486892, serviceable: "Yes", tier: "5" },
  { pincode: 487001, serviceable: "Yes", tier: "3" },
  { pincode: 487110, serviceable: "Yes", tier: "3" },
  { pincode: 487114, serviceable: "Yes", tier: "3" },
  { pincode: 487118, serviceable: "Yes", tier: "3" },
  { pincode: 487221, serviceable: "Yes", tier: "3" },
  { pincode: 487330, serviceable: "Yes", tier: "3" },
  { pincode: 487334, serviceable: "Yes", tier: "3" },
  { pincode: 487337, serviceable: "Yes", tier: "3" },
  { pincode: 487551, serviceable: "Yes", tier: "3" },
  { pincode: 487555, serviceable: "Yes", tier: "3" },
  { pincode: 487661, serviceable: "Yes", tier: "3" },
  { pincode: 487770, serviceable: "Yes", tier: "3" },
  { pincode: 487881, serviceable: "Yes", tier: "3" },
  { pincode: 488001, serviceable: "Yes", tier: "3" },
  { pincode: 488333, serviceable: "Yes", tier: "3" },
  { pincode: 488888, serviceable: "Yes", tier: "1" },
  { pincode: 490001, serviceable: "Yes", tier: "2" },
  { pincode: 490006, serviceable: "Yes", tier: "2" },
  { pincode: 490009, serviceable: "Yes", tier: "2" },
  { pincode: 490011, serviceable: "Yes", tier: "2" },
  { pincode: 490012, serviceable: "Yes", tier: "2" },
  { pincode: 490013, serviceable: "Yes", tier: "2" },
  { pincode: 490020, serviceable: "Yes", tier: "2" },
  { pincode: 490021, serviceable: "Yes", tier: "2" },
  { pincode: 490022, serviceable: "Yes", tier: "2" },
  { pincode: 490023, serviceable: "Yes", tier: "2" },
  { pincode: 490024, serviceable: "Yes", tier: "2" },
  { pincode: 490025, serviceable: "Yes", tier: "2" },
  { pincode: 490026, serviceable: "Yes", tier: "2" },
  { pincode: 490027, serviceable: "Yes", tier: "2" },
  { pincode: 490036, serviceable: "Yes", tier: "2" },
  { pincode: 490042, serviceable: "Yes", tier: "2" },
  { pincode: 491001, serviceable: "Yes", tier: "2" },
  { pincode: 491002, serviceable: "Yes", tier: "2" },
  { pincode: 491107, serviceable: "Yes", tier: "2" },
  { pincode: 491227, serviceable: "Yes", tier: "2" },
  { pincode: 491331, serviceable: "Yes", tier: "2" },
  { pincode: 491441, serviceable: "Yes", tier: "2" },
  { pincode: 492001, serviceable: "Yes", tier: "2" },
  { pincode: 492002, serviceable: "Yes", tier: "2" },
  { pincode: 492003, serviceable: "Yes", tier: "2" },
  { pincode: 492004, serviceable: "Yes", tier: "2" },
  { pincode: 492005, serviceable: "Yes", tier: "2" },
  { pincode: 492006, serviceable: "Yes", tier: "2" },
  { pincode: 492007, serviceable: "Yes", tier: "2" },
  { pincode: 492008, serviceable: "Yes", tier: "2" },
  { pincode: 492009, serviceable: "Yes", tier: "2" },
  { pincode: 492010, serviceable: "Yes", tier: "2" },
  { pincode: 492012, serviceable: "Yes", tier: "2" },
  { pincode: 492013, serviceable: "Yes", tier: "2" },
  { pincode: 492014, serviceable: "Yes", tier: "2" },
  { pincode: 492015, serviceable: "Yes", tier: "2" },
  { pincode: 492099, serviceable: "Yes", tier: "2" },
  { pincode: 493114, serviceable: "Yes", tier: "2" },
  { pincode: 493118, serviceable: "Yes", tier: "3" },
  { pincode: 493221, serviceable: "Yes", tier: "2" },
  { pincode: 493770, serviceable: "Yes", tier: "2" },
  { pincode: 493773, serviceable: "Yes", tier: "2" },
  { pincode: 493776, serviceable: "Yes", tier: "2" },
  { pincode: 494001, serviceable: "Yes", tier: "2" },
  { pincode: 495001, serviceable: "Yes", tier: "2" },
  { pincode: 495004, serviceable: "Yes", tier: "2" },
  { pincode: 495005, serviceable: "Yes", tier: "2" },
  { pincode: 495006, serviceable: "Yes", tier: "2" },
  { pincode: 495009, serviceable: "Yes", tier: "2" },
  { pincode: 495220, serviceable: "Yes", tier: "2" },
  { pincode: 495223, serviceable: "Yes", tier: "2" },
  { pincode: 495450, serviceable: "Yes", tier: "2" },
  { pincode: 495454, serviceable: "Yes", tier: "2" },
  { pincode: 495551, serviceable: "Yes", tier: "2" },
  { pincode: 495557, serviceable: "Yes", tier: "2" },
  { pincode: 495671, serviceable: "Yes", tier: "2" },
  { pincode: 495677, serviceable: "Yes", tier: "2" },
  { pincode: 495678, serviceable: "Yes", tier: "2" },
  { pincode: 495684, serviceable: "Yes", tier: "2" },
  { pincode: 495689, serviceable: "Yes", tier: "2" },
  { pincode: 495690, serviceable: "Yes", tier: "2" },
  { pincode: 496001, serviceable: "Yes", tier: "2" },
  { pincode: 496005, serviceable: "Yes", tier: "2" },
  { pincode: 497001, serviceable: "Yes", tier: "3" },
  { pincode: 497101, serviceable: "Yes", tier: "3" },
  { pincode: 497226, serviceable: "Yes", tier: "3" },
  { pincode: 499999, serviceable: "Yes", tier: "1" },
  { pincode: 500000, serviceable: "Yes", tier: "1" },
  { pincode: 500001, serviceable: "Yes", tier: "1" },
  { pincode: 500002, serviceable: "Yes", tier: "1" },
  { pincode: 500003, serviceable: "Yes", tier: "1" },
  { pincode: 500004, serviceable: "Yes", tier: "1" },
  { pincode: 500005, serviceable: "Yes", tier: "1" },
  { pincode: 500006, serviceable: "Yes", tier: "1" },
  { pincode: 500007, serviceable: "Yes", tier: "1" },
  { pincode: 500008, serviceable: "Yes", tier: "1" },
  { pincode: 500009, serviceable: "Yes", tier: "1" },
  { pincode: 500010, serviceable: "Yes", tier: "1" },
  { pincode: 500011, serviceable: "Yes", tier: "1" },
  { pincode: 500012, serviceable: "Yes", tier: "1" },
  { pincode: 500013, serviceable: "Yes", tier: "1" },
  { pincode: 500014, serviceable: "Yes", tier: "1" },
  { pincode: 500015, serviceable: "Yes", tier: "1" },
  { pincode: 500016, serviceable: "Yes", tier: "1" },
  { pincode: 500017, serviceable: "Yes", tier: "1" },
  { pincode: 500018, serviceable: "Yes", tier: "1" },
  { pincode: 500019, serviceable: "Yes", tier: "1" },
  { pincode: 500020, serviceable: "Yes", tier: "1" },
  { pincode: 500021, serviceable: "Yes", tier: "1" },
  { pincode: 500022, serviceable: "Yes", tier: "1" },
  { pincode: 500023, serviceable: "Yes", tier: "1" },
  { pincode: 500024, serviceable: "Yes", tier: "1" },
  { pincode: 500025, serviceable: "Yes", tier: "1" },
  { pincode: 500026, serviceable: "Yes", tier: "1" },
  { pincode: 500027, serviceable: "Yes", tier: "1" },
  { pincode: 500028, serviceable: "Yes", tier: "1" },
  { pincode: 500029, serviceable: "Yes", tier: "1" },
  { pincode: 500030, serviceable: "Yes", tier: "1" },
  { pincode: 500031, serviceable: "Yes", tier: "1" },
  { pincode: 500032, serviceable: "Yes", tier: "1" },
  { pincode: 500033, serviceable: "Yes", tier: "1" },
  { pincode: 500034, serviceable: "Yes", tier: "1" },
  { pincode: 500035, serviceable: "Yes", tier: "1" },
  { pincode: 500036, serviceable: "Yes", tier: "1" },
  { pincode: 500037, serviceable: "Yes", tier: "1" },
  { pincode: 500038, serviceable: "Yes", tier: "1" },
  { pincode: 500039, serviceable: "Yes", tier: "1" },
  { pincode: 500040, serviceable: "Yes", tier: "1" },
  { pincode: 500041, serviceable: "Yes", tier: "1" },
  { pincode: 500042, serviceable: "Yes", tier: "1" },
  { pincode: 500043, serviceable: "Yes", tier: "1" },
  { pincode: 500044, serviceable: "Yes", tier: "1" },
  { pincode: 500045, serviceable: "Yes", tier: "1" },
  { pincode: 500046, serviceable: "Yes", tier: "1" },
  { pincode: 500047, serviceable: "Yes", tier: "1" },
  { pincode: 500048, serviceable: "Yes", tier: "1" },
  { pincode: 500049, serviceable: "Yes", tier: "1" },
  { pincode: 500050, serviceable: "Yes", tier: "1" },
  { pincode: 500051, serviceable: "Yes", tier: "1" },
  { pincode: 500052, serviceable: "Yes", tier: "1" },
  { pincode: 500053, serviceable: "Yes", tier: "1" },
  { pincode: 500054, serviceable: "Yes", tier: "1" },
  { pincode: 500055, serviceable: "Yes", tier: "1" },
  { pincode: 500056, serviceable: "Yes", tier: "1" },
  { pincode: 500057, serviceable: "Yes", tier: "1" },
  { pincode: 500058, serviceable: "Yes", tier: "1" },
  { pincode: 500059, serviceable: "Yes", tier: "1" },
  { pincode: 500060, serviceable: "Yes", tier: "1" },
  { pincode: 500061, serviceable: "Yes", tier: "1" },
  { pincode: 500062, serviceable: "Yes", tier: "1" },
  { pincode: 500063, serviceable: "Yes", tier: "1" },
  { pincode: 500064, serviceable: "Yes", tier: "1" },
  { pincode: 500065, serviceable: "Yes", tier: "1" },
  { pincode: 500066, serviceable: "Yes", tier: "1" },
  { pincode: 500067, serviceable: "Yes", tier: "1" },
  { pincode: 500068, serviceable: "Yes", tier: "1" },
  { pincode: 500069, serviceable: "Yes", tier: "1" },
  { pincode: 500070, serviceable: "Yes", tier: "1" },
  { pincode: 500071, serviceable: "Yes", tier: "1" },
  { pincode: 500072, serviceable: "Yes", tier: "1" },
  { pincode: 500073, serviceable: "Yes", tier: "1" },
  { pincode: 500074, serviceable: "Yes", tier: "1" },
  { pincode: 500075, serviceable: "Yes", tier: "1" },
  { pincode: 500076, serviceable: "Yes", tier: "1" },
  { pincode: 500077, serviceable: "Yes", tier: "1" },
  { pincode: 500078, serviceable: "Yes", tier: "1" },
  { pincode: 500079, serviceable: "Yes", tier: "1" },
  { pincode: 500080, serviceable: "Yes", tier: "1" },
  { pincode: 500081, serviceable: "Yes", tier: "1" },
  { pincode: 500082, serviceable: "Yes", tier: "1" },
  { pincode: 500083, serviceable: "Yes", tier: "1" },
  { pincode: 500084, serviceable: "Yes", tier: "1" },
  { pincode: 500085, serviceable: "Yes", tier: "1" },
  { pincode: 500086, serviceable: "Yes", tier: "1" },
  { pincode: 500087, serviceable: "Yes", tier: "1" },
  { pincode: 500088, serviceable: "Yes", tier: "1" },
  { pincode: 500089, serviceable: "Yes", tier: "1" },
  { pincode: 500090, serviceable: "Yes", tier: "1" },
  { pincode: 500091, serviceable: "Yes", tier: "1" },
  { pincode: 500092, serviceable: "Yes", tier: "1" },
  { pincode: 500093, serviceable: "Yes", tier: "1" },
  { pincode: 500094, serviceable: "Yes", tier: "1" },
  { pincode: 500095, serviceable: "Yes", tier: "1" },
  { pincode: 500096, serviceable: "Yes", tier: "1" },
  { pincode: 500097, serviceable: "Yes", tier: "1" },
  { pincode: 500098, serviceable: "Yes", tier: "1" },
  { pincode: 500100, serviceable: "Yes", tier: "1" },
  { pincode: 500101, serviceable: "Yes", tier: "1" },
  { pincode: 500102, serviceable: "Yes", tier: "1" },
  { pincode: 500103, serviceable: "Yes", tier: "1" },
  { pincode: 500104, serviceable: "Yes", tier: "1" },
  { pincode: 500105, serviceable: "Yes", tier: "1" },
  { pincode: 500107, serviceable: "Yes", tier: "1" },
  { pincode: 500108, serviceable: "Yes", tier: "1" },
  { pincode: 500110, serviceable: "Yes", tier: "1" },
  { pincode: 500111, serviceable: "Yes", tier: "1" },
  { pincode: 500123, serviceable: "Yes", tier: "1" },
  { pincode: 500146, serviceable: "Yes", tier: "1" },
  { pincode: 500170, serviceable: "Yes", tier: "1" },
  { pincode: 500177, serviceable: "Yes", tier: "1" },
  { pincode: 500178, serviceable: "Yes", tier: "1" },
  { pincode: 500195, serviceable: "Yes", tier: "1" },
  { pincode: 500409, serviceable: "Yes", tier: "1" },
  { pincode: 500472, serviceable: "Yes", tier: "1" },
  { pincode: 500475, serviceable: "Yes", tier: "1" },
  { pincode: 500476, serviceable: "Yes", tier: "1" },
  { pincode: 500484, serviceable: "Yes", tier: "1" },
  { pincode: 500486, serviceable: "Yes", tier: "1" },
  { pincode: 500488, serviceable: "Yes", tier: "1" },
  { pincode: 500605, serviceable: "Yes", tier: "1" },
  { pincode: 500768, serviceable: "Yes", tier: "1" },
  { pincode: 500789, serviceable: "Yes", tier: "1" },
  { pincode: 500890, serviceable: "Yes", tier: "1" },
  { pincode: 500960, serviceable: "Yes", tier: "1" },
  { pincode: 500991, serviceable: "Yes", tier: "1" },
  { pincode: 501101, serviceable: "Yes", tier: "2" },
  { pincode: 501102, serviceable: "Yes", tier: "2" },
  { pincode: 501218, serviceable: "Yes", tier: "1" },
  { pincode: 501301, serviceable: "Yes", tier: "1" },
  { pincode: 501359, serviceable: "Yes", tier: "1" },
  { pincode: 501401, serviceable: "Yes", tier: "1" },
  { pincode: 501503, serviceable: "Yes", tier: "2" },
  { pincode: 501505, serviceable: "Yes", tier: "1" },
  { pincode: 501506, serviceable: "Yes", tier: "1" },
  { pincode: 501507, serviceable: "Yes", tier: "1" },
  { pincode: 501508, serviceable: "Yes", tier: "1" },
  { pincode: 501510, serviceable: "Yes", tier: "1" },
  { pincode: 501511, serviceable: "Yes", tier: "1" },
  { pincode: 501512, serviceable: "Yes", tier: "1" },
  { pincode: 502001, serviceable: "Yes", tier: "2" },
  { pincode: 502032, serviceable: "Yes", tier: "1" },
  { pincode: 502103, serviceable: "Yes", tier: "2" },
  { pincode: 502110, serviceable: "Yes", tier: "5" },
  { pincode: 502205, serviceable: "Yes", tier: "1" },
  { pincode: 502220, serviceable: "Yes", tier: "3" },
  { pincode: 502248, serviceable: "Yes", tier: "5" },
  { pincode: 502269, serviceable: "Yes", tier: "5" },
  { pincode: 502270, serviceable: "Yes", tier: "5" },
  { pincode: 502278, serviceable: "Yes", tier: "3" },
  { pincode: 502285, serviceable: "Yes", tier: "1" },
  { pincode: 502286, serviceable: "Yes", tier: "5" },
  { pincode: 502290, serviceable: "Yes", tier: "5" },
  { pincode: 502291, serviceable: "Yes", tier: "3" },
  { pincode: 502300, serviceable: "Yes", tier: "1" },
  { pincode: 502305, serviceable: "Yes", tier: "1" },
  { pincode: 502307, serviceable: "Yes", tier: "1" },
  { pincode: 502312, serviceable: "Yes", tier: "3" },
  { pincode: 502319, serviceable: "Yes", tier: "1" },
  { pincode: 502324, serviceable: "Yes", tier: "1" },
  { pincode: 502325, serviceable: "Yes", tier: "1" },
  { pincode: 502329, serviceable: "Yes", tier: "1" },
  { pincode: 503001, serviceable: "Yes", tier: "5" },
  { pincode: 503002, serviceable: "Yes", tier: "5" },
  { pincode: 503003, serviceable: "Yes", tier: "5" },
  { pincode: 503165, serviceable: "Yes", tier: "2" },
  { pincode: 503174, serviceable: "Yes", tier: "5" },
  { pincode: 503175, serviceable: "Yes", tier: "5" },
  { pincode: 503180, serviceable: "Yes", tier: "5" },
  { pincode: 503185, serviceable: "Yes", tier: "5" },
  { pincode: 503186, serviceable: "Yes", tier: "5" },
  { pincode: 503217, serviceable: "Yes", tier: "5" },
  { pincode: 503224, serviceable: "Yes", tier: "5" },
  { pincode: 503230, serviceable: "Yes", tier: "5" },
  { pincode: 503307, serviceable: "Yes", tier: "2" },
  { pincode: 503311, serviceable: "Yes", tier: "2" },
  { pincode: 504106, serviceable: "Yes", tier: "5" },
  { pincode: 504208, serviceable: "Yes", tier: "2" },
  { pincode: 504218, serviceable: "Yes", tier: "3" },
  { pincode: 504220, serviceable: "Yes", tier: "3" },
  { pincode: 504231, serviceable: "Yes", tier: "3" },
  { pincode: 504251, serviceable: "Yes", tier: "3" },
  { pincode: 504272, serviceable: "Yes", tier: "3" },
  { pincode: 504302, serviceable: "Yes", tier: "3" },
  { pincode: 504307, serviceable: "Yes", tier: "5" },
  { pincode: 505001, serviceable: "Yes", tier: "2" },
  { pincode: 505002, serviceable: "Yes", tier: "2" },
  { pincode: 505122, serviceable: "Yes", tier: "2" },
  { pincode: 505172, serviceable: "Yes", tier: "2" },
  { pincode: 505186, serviceable: "Yes", tier: "2" },
  { pincode: 505187, serviceable: "Yes", tier: "2" },
  { pincode: 505208, serviceable: "Yes", tier: "2" },
  { pincode: 505209, serviceable: "Yes", tier: "2" },
  { pincode: 505210, serviceable: "Yes", tier: "2" },
  { pincode: 505211, serviceable: "Yes", tier: "2" },
  { pincode: 505215, serviceable: "Yes", tier: "2" },
  { pincode: 505301, serviceable: "Yes", tier: "2" },
  { pincode: 505302, serviceable: "Yes", tier: "2" },
  { pincode: 505305, serviceable: "Yes", tier: "2" },
  { pincode: 505307, serviceable: "Yes", tier: "2" },
  { pincode: 505325, serviceable: "Yes", tier: "2" },
  { pincode: 505326, serviceable: "Yes", tier: "2" },
  { pincode: 505327, serviceable: "Yes", tier: "2" },
  { pincode: 505330, serviceable: "Yes", tier: "2" },
  { pincode: 505401, serviceable: "Yes", tier: "2" },
  { pincode: 505402, serviceable: "Yes", tier: "2" },
  { pincode: 505403, serviceable: "Yes", tier: "2" },
  { pincode: 505404, serviceable: "Yes", tier: "2" },
  { pincode: 505405, serviceable: "Yes", tier: "2" },
  { pincode: 505415, serviceable: "Yes", tier: "2" },
  { pincode: 505450, serviceable: "Yes", tier: "2" },
  { pincode: 505460, serviceable: "Yes", tier: "2" },
  { pincode: 505467, serviceable: "Yes", tier: "2" },
  { pincode: 505468, serviceable: "Yes", tier: "2" },
  { pincode: 505470, serviceable: "Yes", tier: "2" },
  { pincode: 505490, serviceable: "Yes", tier: "2" },
  { pincode: 505524, serviceable: "Yes", tier: "2" },
  { pincode: 506001, serviceable: "Yes", tier: "2" },
  { pincode: 506002, serviceable: "Yes", tier: "2" },
  { pincode: 506003, serviceable: "Yes", tier: "2" },
  { pincode: 506004, serviceable: "Yes", tier: "2" },
  { pincode: 506005, serviceable: "Yes", tier: "2" },
  { pincode: 506006, serviceable: "Yes", tier: "2" },
  { pincode: 506007, serviceable: "Yes", tier: "2" },
  { pincode: 506008, serviceable: "Yes", tier: "2" },
  { pincode: 506009, serviceable: "Yes", tier: "2" },
  { pincode: 506010, serviceable: "Yes", tier: "2" },
  { pincode: 506011, serviceable: "Yes", tier: "2" },
  { pincode: 506012, serviceable: "Yes", tier: "2" },
  { pincode: 506013, serviceable: "Yes", tier: "2" },
  { pincode: 506015, serviceable: "Yes", tier: "2" },
  { pincode: 506101, serviceable: "Yes", tier: "3" },
  { pincode: 506132, serviceable: "Yes", tier: "2" },
  { pincode: 506142, serviceable: "Yes", tier: "2" },
  { pincode: 506163, serviceable: "Yes", tier: "2" },
  { pincode: 506164, serviceable: "Yes", tier: "2" },
  { pincode: 506166, serviceable: "Yes", tier: "2" },
  { pincode: 506167, serviceable: "Yes", tier: "2" },
  { pincode: 506168, serviceable: "Yes", tier: "2" },
  { pincode: 506169, serviceable: "Yes", tier: "2" },
  { pincode: 506172, serviceable: "Yes", tier: "2" },
  { pincode: 506315, serviceable: "Yes", tier: "2" },
  { pincode: 506319, serviceable: "Yes", tier: "2" },
  { pincode: 506370, serviceable: "Yes", tier: "2" },
  { pincode: 506371, serviceable: "Yes", tier: "2" },
  { pincode: 506381, serviceable: "Yes", tier: "3" },
  { pincode: 507001, serviceable: "Yes", tier: "2" },
  { pincode: 507002, serviceable: "Yes", tier: "2" },
  { pincode: 507003, serviceable: "Yes", tier: "2" },
  { pincode: 507004, serviceable: "Yes", tier: "2" },
  { pincode: 507101, serviceable: "Yes", tier: "2" },
  { pincode: 507111, serviceable: "Yes", tier: "3" },
  { pincode: 507113, serviceable: "Yes", tier: "3" },
  { pincode: 507115, serviceable: "Yes", tier: "2" },
  { pincode: 507121, serviceable: "Yes", tier: "3" },
  { pincode: 507123, serviceable: "Yes", tier: "3" },
  { pincode: 507128, serviceable: "Yes", tier: "3" },
  { pincode: 507129, serviceable: "Yes", tier: "3" },
  { pincode: 507130, serviceable: "Yes", tier: "3" },
  { pincode: 507133, serviceable: "Yes", tier: "3" },
  { pincode: 507134, serviceable: "Yes", tier: "3" },
  { pincode: 507137, serviceable: "Yes", tier: "3" },
  { pincode: 507140, serviceable: "Yes", tier: "3" },
  { pincode: 507168, serviceable: "Yes", tier: "2" },
  { pincode: 507203, serviceable: "Yes", tier: "2" },
  { pincode: 507303, serviceable: "Yes", tier: "3" },
  { pincode: 507318, serviceable: "Yes", tier: "2" },
  { pincode: 508001, serviceable: "Yes", tier: "2" },
  { pincode: 508116, serviceable: "Yes", tier: "2" },
  { pincode: 508126, serviceable: "Yes", tier: "1" },
  { pincode: 508204, serviceable: "Yes", tier: "2" },
  { pincode: 508206, serviceable: "Yes", tier: "2" },
  { pincode: 508207, serviceable: "Yes", tier: "2" },
  { pincode: 508213, serviceable: "Yes", tier: "2" },
  { pincode: 508233, serviceable: "Yes", tier: "2" },
  { pincode: 508234, serviceable: "Yes", tier: "2" },
  { pincode: 508238, serviceable: "Yes", tier: "2" },
  { pincode: 508252, serviceable: "Yes", tier: "2" },
  { pincode: 509001, serviceable: "Yes", tier: "2" },
  { pincode: 509002, serviceable: "Yes", tier: "2" },
  { pincode: 509102, serviceable: "Yes", tier: "2" },
  { pincode: 509103, serviceable: "Yes", tier: "3" },
  { pincode: 509104, serviceable: "Yes", tier: "2" },
  { pincode: 509106, serviceable: "Yes", tier: "2" },
  { pincode: 509110, serviceable: "Yes", tier: "2" },
  { pincode: 509120, serviceable: "Yes", tier: "2" },
  { pincode: 509125, serviceable: "Yes", tier: "2" },
  { pincode: 509131, serviceable: "Yes", tier: "2" },
  { pincode: 509202, serviceable: "Yes", tier: "2" },
  { pincode: 509206, serviceable: "Yes", tier: "2" },
  { pincode: 509208, serviceable: "Yes", tier: "2" },
  { pincode: 509209, serviceable: "Yes", tier: "3" },
  { pincode: 509210, serviceable: "Yes", tier: "2" },
  { pincode: 509215, serviceable: "Yes", tier: "3" },
  { pincode: 509216, serviceable: "Yes", tier: "2" },
  { pincode: 509219, serviceable: "Yes", tier: "2" },
  { pincode: 509228, serviceable: "Yes", tier: "2" },
  { pincode: 509301, serviceable: "Yes", tier: "2" },
  { pincode: 509302, serviceable: "Yes", tier: "2" },
  { pincode: 509351, serviceable: "Yes", tier: "2" },
  { pincode: 509381, serviceable: "Yes", tier: "2" },
  { pincode: 509407, serviceable: "Yes", tier: "2" },
  { pincode: 509412, serviceable: "Yes", tier: "2" },
  { pincode: 511111, serviceable: "Yes", tier: "1" },
  { pincode: 515001, serviceable: "Yes", tier: "2" },
  { pincode: 515002, serviceable: "Yes", tier: "2" },
  { pincode: 515003, serviceable: "Yes", tier: "2" },
  { pincode: 515004, serviceable: "Yes", tier: "2" },
  { pincode: 515005, serviceable: "Yes", tier: "2" },
  { pincode: 515101, serviceable: "Yes", tier: "2" },
  { pincode: 515102, serviceable: "Yes", tier: "2" },
  { pincode: 515110, serviceable: "Yes", tier: "2" },
  { pincode: 515122, serviceable: "Yes", tier: "2" },
  { pincode: 515133, serviceable: "Yes", tier: "2" },
  { pincode: 515134, serviceable: "Yes", tier: "2" },
  { pincode: 515144, serviceable: "Yes", tier: "2" },
  { pincode: 515164, serviceable: "Yes", tier: "2" },
  { pincode: 515201, serviceable: "Yes", tier: "2" },
  { pincode: 515202, serviceable: "Yes", tier: "2" },
  { pincode: 515211, serviceable: "Yes", tier: "2" },
  { pincode: 515212, serviceable: "Yes", tier: "2" },
  { pincode: 515213, serviceable: "Yes", tier: "2" },
  { pincode: 515231, serviceable: "Yes", tier: "2" },
  { pincode: 515241, serviceable: "Yes", tier: "2" },
  { pincode: 515261, serviceable: "Yes", tier: "2" },
  { pincode: 515271, serviceable: "Yes", tier: "2" },
  { pincode: 515291, serviceable: "Yes", tier: "2" },
  { pincode: 515301, serviceable: "Yes", tier: "2" },
  { pincode: 515303, serviceable: "Yes", tier: "2" },
  { pincode: 515331, serviceable: "Yes", tier: "2" },
  { pincode: 515401, serviceable: "Yes", tier: "2" },
  { pincode: 515402, serviceable: "Yes", tier: "2" },
  { pincode: 515404, serviceable: "Yes", tier: "2" },
  { pincode: 515405, serviceable: "Yes", tier: "2" },
  { pincode: 515411, serviceable: "Yes", tier: "2" },
  { pincode: 515413, serviceable: "Yes", tier: "2" },
  { pincode: 515415, serviceable: "Yes", tier: "2" },
  { pincode: 515425, serviceable: "Yes", tier: "2" },
  { pincode: 515427, serviceable: "Yes", tier: "2" },
  { pincode: 515445, serviceable: "Yes", tier: "2" },
  { pincode: 515446, serviceable: "Yes", tier: "2" },
  { pincode: 515501, serviceable: "Yes", tier: "2" },
  { pincode: 515502, serviceable: "Yes", tier: "2" },
  { pincode: 515541, serviceable: "Yes", tier: "2" },
  { pincode: 515551, serviceable: "Yes", tier: "2" },
  { pincode: 515561, serviceable: "Yes", tier: "2" },
  { pincode: 515591, serviceable: "Yes", tier: "2" },
  { pincode: 515631, serviceable: "Yes", tier: "2" },
  { pincode: 515651, serviceable: "Yes", tier: "2" },
  { pincode: 515671, serviceable: "Yes", tier: "2" },
  { pincode: 515701, serviceable: "Yes", tier: "2" },
  { pincode: 515722, serviceable: "Yes", tier: "2" },
  { pincode: 515741, serviceable: "Yes", tier: "2" },
  { pincode: 515761, serviceable: "Yes", tier: "2" },
  { pincode: 515763, serviceable: "Yes", tier: "2" },
  { pincode: 515767, serviceable: "Yes", tier: "2" },
  { pincode: 515801, serviceable: "Yes", tier: "2" },
  { pincode: 515803, serviceable: "Yes", tier: "2" },
  { pincode: 515832, serviceable: "Yes", tier: "2" },
  { pincode: 515834, serviceable: "Yes", tier: "2" },
  { pincode: 515842, serviceable: "Yes", tier: "2" },
  { pincode: 515843, serviceable: "Yes", tier: "2" },
  { pincode: 515865, serviceable: "Yes", tier: "2" },
  { pincode: 515867, serviceable: "Yes", tier: "2" },
  { pincode: 516001, serviceable: "Yes", tier: "2" },
  { pincode: 516002, serviceable: "Yes", tier: "2" },
  { pincode: 516003, serviceable: "Yes", tier: "2" },
  { pincode: 516004, serviceable: "Yes", tier: "2" },
  { pincode: 516005, serviceable: "Yes", tier: "2" },
  { pincode: 516104, serviceable: "Yes", tier: "2" },
  { pincode: 516107, serviceable: "Yes", tier: "2" },
  { pincode: 516115, serviceable: "Yes", tier: "2" },
  { pincode: 516126, serviceable: "Yes", tier: "2" },
  { pincode: 516127, serviceable: "Yes", tier: "2" },
  { pincode: 516128, serviceable: "Yes", tier: "2" },
  { pincode: 516130, serviceable: "Yes", tier: "2" },
  { pincode: 516150, serviceable: "Yes", tier: "2" },
  { pincode: 516151, serviceable: "Yes", tier: "2" },
  { pincode: 516152, serviceable: "Yes", tier: "2" },
  { pincode: 516162, serviceable: "Yes", tier: "2" },
  { pincode: 516163, serviceable: "Yes", tier: "2" },
  { pincode: 516172, serviceable: "Yes", tier: "2" },
  { pincode: 516193, serviceable: "Yes", tier: "2" },
  { pincode: 516203, serviceable: "Yes", tier: "2" },
  { pincode: 516213, serviceable: "Yes", tier: "2" },
  { pincode: 516214, serviceable: "Yes", tier: "2" },
  { pincode: 516215, serviceable: "Yes", tier: "2" },
  { pincode: 516216, serviceable: "Yes", tier: "2" },
  { pincode: 516218, serviceable: "Yes", tier: "2" },
  { pincode: 516227, serviceable: "Yes", tier: "2" },
  { pincode: 516228, serviceable: "Yes", tier: "2" },
  { pincode: 516233, serviceable: "Yes", tier: "2" },
  { pincode: 516237, serviceable: "Yes", tier: "2" },
  { pincode: 516247, serviceable: "Yes", tier: "2" },
  { pincode: 516257, serviceable: "Yes", tier: "2" },
  { pincode: 516267, serviceable: "Yes", tier: "2" },
  { pincode: 516268, serviceable: "Yes", tier: "2" },
  { pincode: 516269, serviceable: "Yes", tier: "2" },
  { pincode: 516270, serviceable: "Yes", tier: "2" },
  { pincode: 516289, serviceable: "Yes", tier: "2" },
  { pincode: 516293, serviceable: "Yes", tier: "2" },
  { pincode: 516309, serviceable: "Yes", tier: "2" },
  { pincode: 516310, serviceable: "Yes", tier: "2" },
  { pincode: 516311, serviceable: "Yes", tier: "2" },
  { pincode: 516312, serviceable: "Yes", tier: "2" },
  { pincode: 516321, serviceable: "Yes", tier: "2" },
  { pincode: 516329, serviceable: "Yes", tier: "2" },
  { pincode: 516339, serviceable: "Yes", tier: "2" },
  { pincode: 516349, serviceable: "Yes", tier: "2" },
  { pincode: 516350, serviceable: "Yes", tier: "2" },
  { pincode: 516355, serviceable: "Yes", tier: "2" },
  { pincode: 516359, serviceable: "Yes", tier: "2" },
  { pincode: 516360, serviceable: "Yes", tier: "2" },
  { pincode: 516361, serviceable: "Yes", tier: "2" },
  { pincode: 516362, serviceable: "Yes", tier: "2" },
  { pincode: 516366, serviceable: "Yes", tier: "2" },
  { pincode: 516390, serviceable: "Yes", tier: "2" },
  { pincode: 516391, serviceable: "Yes", tier: "2" },
  { pincode: 516396, serviceable: "Yes", tier: "2" },
  { pincode: 516401, serviceable: "Yes", tier: "2" },
  { pincode: 516421, serviceable: "Yes", tier: "2" },
  { pincode: 516434, serviceable: "Yes", tier: "2" },
  { pincode: 516454, serviceable: "Yes", tier: "2" },
  { pincode: 516501, serviceable: "Yes", tier: "2" },
  { pincode: 516502, serviceable: "Yes", tier: "2" },
  { pincode: 516504, serviceable: "Yes", tier: "2" },
  { pincode: 516505, serviceable: "Yes", tier: "2" },
  { pincode: 517001, serviceable: "Yes", tier: "2" },
  { pincode: 517002, serviceable: "Yes", tier: "2" },
  { pincode: 517003, serviceable: "Yes", tier: "2" },
  { pincode: 517004, serviceable: "Yes", tier: "2" },
  { pincode: 517101, serviceable: "Yes", tier: "2" },
  { pincode: 517102, serviceable: "Yes", tier: "2" },
  { pincode: 517112, serviceable: "Yes", tier: "2" },
  { pincode: 517113, serviceable: "Yes", tier: "3" },
  { pincode: 517123, serviceable: "Yes", tier: "3" },
  { pincode: 517124, serviceable: "Yes", tier: "2" },
  { pincode: 517125, serviceable: "Yes", tier: "2" },
  { pincode: 517126, serviceable: "Yes", tier: "2" },
  { pincode: 517127, serviceable: "Yes", tier: "2" },
  { pincode: 517128, serviceable: "Yes", tier: "2" },
  { pincode: 517129, serviceable: "Yes", tier: "3" },
  { pincode: 517130, serviceable: "Yes", tier: "2" },
  { pincode: 517131, serviceable: "Yes", tier: "2" },
  { pincode: 517132, serviceable: "Yes", tier: "2" },
  { pincode: 517143, serviceable: "Yes", tier: "2" },
  { pincode: 517152, serviceable: "Yes", tier: "3" },
  { pincode: 517167, serviceable: "Yes", tier: "2" },
  { pincode: 517192, serviceable: "Yes", tier: "3" },
  { pincode: 517193, serviceable: "Yes", tier: "3" },
  { pincode: 517214, serviceable: "Yes", tier: "3" },
  { pincode: 517234, serviceable: "Yes", tier: "3" },
  { pincode: 517247, serviceable: "Yes", tier: "3" },
  { pincode: 517305, serviceable: "Yes", tier: "2" },
  { pincode: 517403, serviceable: "Yes", tier: "2" },
  { pincode: 517408, serviceable: "Yes", tier: "3" },
  { pincode: 517415, serviceable: "Yes", tier: "3" },
  { pincode: 517416, serviceable: "Yes", tier: "3" },
  { pincode: 517419, serviceable: "Yes", tier: "2" },
  { pincode: 517421, serviceable: "Yes", tier: "2" },
  { pincode: 517422, serviceable: "Yes", tier: "2" },
  { pincode: 517429, serviceable: "Yes", tier: "3" },
  { pincode: 517501, serviceable: "Yes", tier: "2" },
  { pincode: 517502, serviceable: "Yes", tier: "2" },
  { pincode: 517503, serviceable: "Yes", tier: "2" },
  { pincode: 517504, serviceable: "Yes", tier: "2" },
  { pincode: 517505, serviceable: "Yes", tier: "2" },
  { pincode: 517506, serviceable: "Yes", tier: "2" },
  { pincode: 517507, serviceable: "Yes", tier: "2" },
  { pincode: 517520, serviceable: "Yes", tier: "2" },
  { pincode: 517526, serviceable: "Yes", tier: "2" },
  { pincode: 517536, serviceable: "Yes", tier: "2" },
  { pincode: 517541, serviceable: "Yes", tier: "2" },
  { pincode: 517551, serviceable: "Yes", tier: "2" },
  { pincode: 517561, serviceable: "Yes", tier: "2" },
  { pincode: 517569, serviceable: "Yes", tier: "2" },
  { pincode: 517571, serviceable: "Yes", tier: "2" },
  { pincode: 517581, serviceable: "Yes", tier: "2" },
  { pincode: 517582, serviceable: "Yes", tier: "2" },
  { pincode: 517583, serviceable: "Yes", tier: "2" },
  { pincode: 517584, serviceable: "Yes", tier: "2" },
  { pincode: 517586, serviceable: "Yes", tier: "2" },
  { pincode: 517587, serviceable: "Yes", tier: "2" },
  { pincode: 517588, serviceable: "Yes", tier: "2" },
  { pincode: 517589, serviceable: "Yes", tier: "2" },
  { pincode: 517590, serviceable: "Yes", tier: "2" },
  { pincode: 517591, serviceable: "Yes", tier: "2" },
  { pincode: 517592, serviceable: "Yes", tier: "2" },
  { pincode: 517599, serviceable: "Yes", tier: "3" },
  { pincode: 517620, serviceable: "Yes", tier: "2" },
  { pincode: 517640, serviceable: "Yes", tier: "2" },
  { pincode: 517641, serviceable: "Yes", tier: "2" },
  { pincode: 517643, serviceable: "Yes", tier: "2" },
  { pincode: 517644, serviceable: "Yes", tier: "2" },
  { pincode: 517645, serviceable: "Yes", tier: "2" },
  { pincode: 517646, serviceable: "Yes", tier: "2" },
  { pincode: 518001, serviceable: "Yes", tier: "2" },
  { pincode: 518002, serviceable: "Yes", tier: "2" },
  { pincode: 518003, serviceable: "Yes", tier: "2" },
  { pincode: 518004, serviceable: "Yes", tier: "2" },
  { pincode: 518005, serviceable: "Yes", tier: "2" },
  { pincode: 518006, serviceable: "Yes", tier: "2" },
  { pincode: 518007, serviceable: "Yes", tier: "2" },
  { pincode: 518010, serviceable: "Yes", tier: "2" },
  { pincode: 518124, serviceable: "Yes", tier: "2" },
  { pincode: 518186, serviceable: "Yes", tier: "2" },
  { pincode: 518222, serviceable: "Yes", tier: "2" },
  { pincode: 518301, serviceable: "Yes", tier: "2" },
  { pincode: 518360, serviceable: "Yes", tier: "2" },
  { pincode: 518422, serviceable: "Yes", tier: "2" },
  { pincode: 518452, serviceable: "Yes", tier: "2" },
  { pincode: 520001, serviceable: "Yes", tier: "2" },
  { pincode: 520002, serviceable: "Yes", tier: "2" },
  { pincode: 520003, serviceable: "Yes", tier: "2" },
  { pincode: 520004, serviceable: "Yes", tier: "2" },
  { pincode: 520005, serviceable: "Yes", tier: "2" },
  { pincode: 520006, serviceable: "Yes", tier: "2" },
  { pincode: 520007, serviceable: "Yes", tier: "2" },
  { pincode: 520008, serviceable: "Yes", tier: "2" },
  { pincode: 520009, serviceable: "Yes", tier: "2" },
  { pincode: 520010, serviceable: "Yes", tier: "2" },
  { pincode: 520011, serviceable: "Yes", tier: "2" },
  { pincode: 520012, serviceable: "Yes", tier: "2" },
  { pincode: 520013, serviceable: "Yes", tier: "2" },
  { pincode: 520014, serviceable: "Yes", tier: "2" },
  { pincode: 520015, serviceable: "Yes", tier: "2" },
  { pincode: 521001, serviceable: "Yes", tier: "2" },
  { pincode: 521002, serviceable: "Yes", tier: "2" },
  { pincode: 521101, serviceable: "Yes", tier: "2" },
  { pincode: 521102, serviceable: "Yes", tier: "2" },
  { pincode: 521104, serviceable: "Yes", tier: "2" },
  { pincode: 521105, serviceable: "Yes", tier: "2" },
  { pincode: 521106, serviceable: "Yes", tier: "2" },
  { pincode: 521107, serviceable: "Yes", tier: "2" },
  { pincode: 521108, serviceable: "Yes", tier: "2" },
  { pincode: 521109, serviceable: "Yes", tier: "2" },
  { pincode: 521110, serviceable: "Yes", tier: "2" },
  { pincode: 521111, serviceable: "Yes", tier: "2" },
  { pincode: 521113, serviceable: "Yes", tier: "2" },
  { pincode: 521114, serviceable: "Yes", tier: "2" },
  { pincode: 521121, serviceable: "Yes", tier: "2" },
  { pincode: 521125, serviceable: "Yes", tier: "2" },
  { pincode: 521126, serviceable: "Yes", tier: "2" },
  { pincode: 521137, serviceable: "Yes", tier: "2" },
  { pincode: 521139, serviceable: "Yes", tier: "2" },
  { pincode: 521148, serviceable: "Yes", tier: "2" },
  { pincode: 521151, serviceable: "Yes", tier: "2" },
  { pincode: 521158, serviceable: "Yes", tier: "2" },
  { pincode: 521165, serviceable: "Yes", tier: "2" },
  { pincode: 521175, serviceable: "Yes", tier: "2" },
  { pincode: 521185, serviceable: "Yes", tier: "2" },
  { pincode: 521201, serviceable: "Yes", tier: "2" },
  { pincode: 521202, serviceable: "Yes", tier: "2" },
  { pincode: 521212, serviceable: "Yes", tier: "2" },
  { pincode: 521215, serviceable: "Yes", tier: "2" },
  { pincode: 521225, serviceable: "Yes", tier: "2" },
  { pincode: 521230, serviceable: "Yes", tier: "2" },
  { pincode: 521263, serviceable: "Yes", tier: "2" },
  { pincode: 521286, serviceable: "Yes", tier: "2" },
  { pincode: 521301, serviceable: "Yes", tier: "2" },
  { pincode: 521311, serviceable: "Yes", tier: "2" },
  { pincode: 521312, serviceable: "Yes", tier: "2" },
  { pincode: 521321, serviceable: "Yes", tier: "2" },
  { pincode: 521322, serviceable: "Yes", tier: "2" },
  { pincode: 521323, serviceable: "Yes", tier: "2" },
  { pincode: 521325, serviceable: "Yes", tier: "2" },
  { pincode: 521326, serviceable: "Yes", tier: "2" },
  { pincode: 521327, serviceable: "Yes", tier: "2" },
  { pincode: 521330, serviceable: "Yes", tier: "2" },
  { pincode: 521331, serviceable: "Yes", tier: "2" },
  { pincode: 521343, serviceable: "Yes", tier: "2" },
  { pincode: 521345, serviceable: "Yes", tier: "2" },
  { pincode: 521356, serviceable: "Yes", tier: "2" },
  { pincode: 521358, serviceable: "Yes", tier: "2" },
  { pincode: 521444, serviceable: "Yes", tier: "2" },
  { pincode: 521456, serviceable: "Yes", tier: "2" },
  { pincode: 522001, serviceable: "Yes", tier: "2" },
  { pincode: 522002, serviceable: "Yes", tier: "2" },
  { pincode: 522003, serviceable: "Yes", tier: "2" },
  { pincode: 522004, serviceable: "Yes", tier: "2" },
  { pincode: 522005, serviceable: "Yes", tier: "2" },
  { pincode: 522006, serviceable: "Yes", tier: "2" },
  { pincode: 522007, serviceable: "Yes", tier: "2" },
  { pincode: 522009, serviceable: "Yes", tier: "2" },
  { pincode: 522022, serviceable: "Yes", tier: "2" },
  { pincode: 522034, serviceable: "Yes", tier: "2" },
  { pincode: 522101, serviceable: "Yes", tier: "2" },
  { pincode: 522102, serviceable: "Yes", tier: "2" },
  { pincode: 522124, serviceable: "Yes", tier: "2" },
  { pincode: 522201, serviceable: "Yes", tier: "2" },
  { pincode: 522202, serviceable: "Yes", tier: "2" },
  { pincode: 522212, serviceable: "Yes", tier: "2" },
  { pincode: 522222, serviceable: "Yes", tier: "1" },
  { pincode: 522262, serviceable: "Yes", tier: "2" },
  { pincode: 522263, serviceable: "Yes", tier: "2" },
  { pincode: 522265, serviceable: "Yes", tier: "2" },
  { pincode: 522314, serviceable: "Yes", tier: "2" },
  { pincode: 522315, serviceable: "Yes", tier: "2" },
  { pincode: 522329, serviceable: "Yes", tier: "2" },
  { pincode: 522403, serviceable: "Yes", tier: "3" },
  { pincode: 522413, serviceable: "Yes", tier: "3" },
  { pincode: 522501, serviceable: "Yes", tier: "2" },
  { pincode: 522502, serviceable: "Yes", tier: "2" },
  { pincode: 522503, serviceable: "Yes", tier: "2" },
  { pincode: 522508, serviceable: "Yes", tier: "2" },
  { pincode: 522509, serviceable: "Yes", tier: "2" },
  { pincode: 522510, serviceable: "Yes", tier: "2" },
  { pincode: 522601, serviceable: "Yes", tier: "2" },
  { pincode: 522614, serviceable: "Yes", tier: "3" },
  { pincode: 522616, serviceable: "Yes", tier: "2" },
  { pincode: 523115, serviceable: "Yes", tier: "3" },
  { pincode: 523155, serviceable: "Yes", tier: "2" },
  { pincode: 523157, serviceable: "Yes", tier: "2" },
  { pincode: 523201, serviceable: "Yes", tier: "2" },
  { pincode: 523211, serviceable: "Yes", tier: "2" },
  { pincode: 523212, serviceable: "Yes", tier: "2" },
  { pincode: 523247, serviceable: "Yes", tier: "2" },
  { pincode: 523262, serviceable: "Yes", tier: "2" },
  { pincode: 523274, serviceable: "Yes", tier: "2" },
  { pincode: 523301, serviceable: "Yes", tier: "2" },
  { pincode: 523316, serviceable: "Yes", tier: "2" },
  { pincode: 523333, serviceable: "Yes", tier: "2" },
  { pincode: 523334, serviceable: "Yes", tier: "2" },
  { pincode: 523357, serviceable: "Yes", tier: "2" },
  { pincode: 524001, serviceable: "Yes", tier: "2" },
  { pincode: 524002, serviceable: "Yes", tier: "2" },
  { pincode: 524003, serviceable: "Yes", tier: "2" },
  { pincode: 524004, serviceable: "Yes", tier: "2" },
  { pincode: 524005, serviceable: "Yes", tier: "2" },
  { pincode: 524101, serviceable: "Yes", tier: "2" },
  { pincode: 524121, serviceable: "Yes", tier: "2" },
  { pincode: 524126, serviceable: "Yes", tier: "2" },
  { pincode: 524129, serviceable: "Yes", tier: "2" },
  { pincode: 524132, serviceable: "Yes", tier: "2" },
  { pincode: 524137, serviceable: "Yes", tier: "2" },
  { pincode: 524142, serviceable: "Yes", tier: "3" },
  { pincode: 524152, serviceable: "Yes", tier: "3" },
  { pincode: 524201, serviceable: "Yes", tier: "3" },
  { pincode: 524202, serviceable: "Yes", tier: "3" },
  { pincode: 524203, serviceable: "Yes", tier: "3" },
  { pincode: 524221, serviceable: "Yes", tier: "3" },
  { pincode: 524222, serviceable: "Yes", tier: "3" },
  { pincode: 524223, serviceable: "Yes", tier: "3" },
  { pincode: 524224, serviceable: "Yes", tier: "3" },
  { pincode: 524227, serviceable: "Yes", tier: "3" },
  { pincode: 524228, serviceable: "Yes", tier: "3" },
  { pincode: 524230, serviceable: "Yes", tier: "3" },
  { pincode: 524234, serviceable: "Yes", tier: "3" },
  { pincode: 524239, serviceable: "Yes", tier: "3" },
  { pincode: 524240, serviceable: "Yes", tier: "2" },
  { pincode: 524301, serviceable: "Yes", tier: "3" },
  { pincode: 524303, serviceable: "Yes", tier: "3" },
  { pincode: 524304, serviceable: "Yes", tier: "3" },
  { pincode: 524305, serviceable: "Yes", tier: "2" },
  { pincode: 524307, serviceable: "Yes", tier: "3" },
  { pincode: 524308, serviceable: "Yes", tier: "3" },
  { pincode: 524309, serviceable: "Yes", tier: "3" },
  { pincode: 524311, serviceable: "Yes", tier: "2" },
  { pincode: 524313, serviceable: "Yes", tier: "2" },
  { pincode: 524315, serviceable: "Yes", tier: "2" },
  { pincode: 524316, serviceable: "Yes", tier: "2" },
  { pincode: 524317, serviceable: "Yes", tier: "2" },
  { pincode: 524318, serviceable: "Yes", tier: "2" },
  { pincode: 524319, serviceable: "Yes", tier: "2" },
  { pincode: 524320, serviceable: "Yes", tier: "2" },
  { pincode: 524322, serviceable: "Yes", tier: "3" },
  { pincode: 524341, serviceable: "Yes", tier: "3" },
  { pincode: 524344, serviceable: "Yes", tier: "2" },
  { pincode: 524346, serviceable: "Yes", tier: "2" },
  { pincode: 524366, serviceable: "Yes", tier: "2" },
  { pincode: 524401, serviceable: "Yes", tier: "2" },
  { pincode: 524405, serviceable: "Yes", tier: "2" },
  { pincode: 524410, serviceable: "Yes", tier: "2" },
  { pincode: 524411, serviceable: "Yes", tier: "2" },
  { pincode: 524412, serviceable: "Yes", tier: "2" },
  { pincode: 524413, serviceable: "Yes", tier: "2" },
  { pincode: 524415, serviceable: "Yes", tier: "2" },
  { pincode: 524421, serviceable: "Yes", tier: "2" },
  { pincode: 528101, serviceable: "Yes", tier: "2" },
  { pincode: 530001, serviceable: "Yes", tier: "2" },
  { pincode: 530002, serviceable: "Yes", tier: "2" },
  { pincode: 530003, serviceable: "Yes", tier: "2" },
  { pincode: 530004, serviceable: "Yes", tier: "2" },
  { pincode: 530005, serviceable: "Yes", tier: "1" },
  { pincode: 530006, serviceable: "Yes", tier: "2" },
  { pincode: 530007, serviceable: "Yes", tier: "2" },
  { pincode: 530008, serviceable: "Yes", tier: "2" },
  { pincode: 530009, serviceable: "Yes", tier: "2" },
  { pincode: 530010, serviceable: "Yes", tier: "2" },
  { pincode: 530011, serviceable: "Yes", tier: "1" },
  { pincode: 530012, serviceable: "Yes", tier: "1" },
  { pincode: 530013, serviceable: "Yes", tier: "2" },
  { pincode: 530014, serviceable: "Yes", tier: "1" },
  { pincode: 530015, serviceable: "Yes", tier: "1" },
  { pincode: 530016, serviceable: "Yes", tier: "2" },
  { pincode: 530017, serviceable: "Yes", tier: "2" },
  { pincode: 530018, serviceable: "Yes", tier: "2" },
  { pincode: 530020, serviceable: "Yes", tier: "2" },
  { pincode: 530021, serviceable: "Yes", tier: "2" },
  { pincode: 530022, serviceable: "Yes", tier: "2" },
  { pincode: 530023, serviceable: "Yes", tier: "2" },
  { pincode: 530024, serviceable: "Yes", tier: "2" },
  { pincode: 530025, serviceable: "Yes", tier: "1" },
  { pincode: 530026, serviceable: "Yes", tier: "1" },
  { pincode: 530027, serviceable: "Yes", tier: "2" },
  { pincode: 530028, serviceable: "Yes", tier: "2" },
  { pincode: 530029, serviceable: "Yes", tier: "2" },
  { pincode: 530032, serviceable: "Yes", tier: "2" },
  { pincode: 530035, serviceable: "Yes", tier: "2" },
  { pincode: 530037, serviceable: "Yes", tier: "2" },
  { pincode: 530040, serviceable: "Yes", tier: "2" },
  { pincode: 530041, serviceable: "Yes", tier: "2" },
  { pincode: 530042, serviceable: "Yes", tier: "2" },
  { pincode: 530043, serviceable: "Yes", tier: "2" },
  { pincode: 530044, serviceable: "Yes", tier: "1" },
  { pincode: 530045, serviceable: "Yes", tier: "2" },
  { pincode: 530046, serviceable: "Yes", tier: "2" },
  { pincode: 530047, serviceable: "Yes", tier: "2" },
  { pincode: 530048, serviceable: "Yes", tier: "2" },
  { pincode: 530049, serviceable: "Yes", tier: "2" },
  { pincode: 530051, serviceable: "Yes", tier: "2" },
  { pincode: 530052, serviceable: "Yes", tier: "2" },
  { pincode: 530053, serviceable: "Yes", tier: "2" },
  { pincode: 531001, serviceable: "Yes", tier: "2" },
  { pincode: 531011, serviceable: "Yes", tier: "2" },
  { pincode: 531019, serviceable: "Yes", tier: "2" },
  { pincode: 531020, serviceable: "Yes", tier: "2" },
  { pincode: 531021, serviceable: "Yes", tier: "2" },
  { pincode: 531033, serviceable: "Yes", tier: "2" },
  { pincode: 531061, serviceable: "Yes", tier: "2" },
  { pincode: 531114, serviceable: "Yes", tier: "2" },
  { pincode: 531116, serviceable: "Yes", tier: "2" },
  { pincode: 531118, serviceable: "Yes", tier: "2" },
  { pincode: 531126, serviceable: "Yes", tier: "2" },
  { pincode: 531162, serviceable: "Yes", tier: "2" },
  { pincode: 531163, serviceable: "Yes", tier: "2" },
  { pincode: 531173, serviceable: "Yes", tier: "2" },
  { pincode: 532001, serviceable: "Yes", tier: "2" },
  { pincode: 532005, serviceable: "Yes", tier: "2" },
  { pincode: 532127, serviceable: "Yes", tier: "3" },
  { pincode: 532185, serviceable: "Yes", tier: "3" },
  { pincode: 532186, serviceable: "Yes", tier: "3" },
  { pincode: 532195, serviceable: "Yes", tier: "3" },
  { pincode: 532201, serviceable: "Yes", tier: "3" },
  { pincode: 532203, serviceable: "Yes", tier: "3" },
  { pincode: 532211, serviceable: "Yes", tier: "3" },
  { pincode: 532212, serviceable: "Yes", tier: "3" },
  { pincode: 532221, serviceable: "Yes", tier: "3" },
  { pincode: 532222, serviceable: "Yes", tier: "3" },
  { pincode: 532405, serviceable: "Yes", tier: "3" },
  { pincode: 532406, serviceable: "Yes", tier: "3" },
  { pincode: 532409, serviceable: "Yes", tier: "2" },
  { pincode: 532421, serviceable: "Yes", tier: "3" },
  { pincode: 532430, serviceable: "Yes", tier: "3" },
  { pincode: 532464, serviceable: "Yes", tier: "2" },
  { pincode: 532484, serviceable: "Yes", tier: "3" },
  { pincode: 533001, serviceable: "Yes", tier: "2" },
  { pincode: 533002, serviceable: "Yes", tier: "2" },
  { pincode: 533003, serviceable: "Yes", tier: "2" },
  { pincode: 533004, serviceable: "Yes", tier: "2" },
  { pincode: 533005, serviceable: "Yes", tier: "2" },
  { pincode: 533006, serviceable: "Yes", tier: "2" },
  { pincode: 533007, serviceable: "Yes", tier: "2" },
  { pincode: 533008, serviceable: "Yes", tier: "2" },
  { pincode: 533016, serviceable: "Yes", tier: "2" },
  { pincode: 533101, serviceable: "Yes", tier: "2" },
  { pincode: 533102, serviceable: "Yes", tier: "2" },
  { pincode: 533103, serviceable: "Yes", tier: "2" },
  { pincode: 533104, serviceable: "Yes", tier: "2" },
  { pincode: 533105, serviceable: "Yes", tier: "2" },
  { pincode: 533106, serviceable: "Yes", tier: "2" },
  { pincode: 533107, serviceable: "Yes", tier: "2" },
  { pincode: 533125, serviceable: "Yes", tier: "2" },
  { pincode: 533126, serviceable: "Yes", tier: "2" },
  { pincode: 533201, serviceable: "Yes", tier: "2" },
  { pincode: 533211, serviceable: "Yes", tier: "2" },
  { pincode: 533216, serviceable: "Yes", tier: "2" },
  { pincode: 533223, serviceable: "Yes", tier: "2" },
  { pincode: 533242, serviceable: "Yes", tier: "2" },
  { pincode: 533244, serviceable: "Yes", tier: "2" },
  { pincode: 533250, serviceable: "Yes", tier: "2" },
  { pincode: 533251, serviceable: "Yes", tier: "2" },
  { pincode: 533253, serviceable: "Yes", tier: "2" },
  { pincode: 533254, serviceable: "Yes", tier: "2" },
  { pincode: 533291, serviceable: "Yes", tier: "2" },
  { pincode: 533294, serviceable: "Yes", tier: "2" },
  { pincode: 533296, serviceable: "Yes", tier: "2" },
  { pincode: 533342, serviceable: "Yes", tier: "2" },
  { pincode: 533345, serviceable: "Yes", tier: "2" },
  { pincode: 533346, serviceable: "Yes", tier: "2" },
  { pincode: 533349, serviceable: "Yes", tier: "2" },
  { pincode: 533350, serviceable: "Yes", tier: "2" },
  { pincode: 533351, serviceable: "Yes", tier: "2" },
  { pincode: 533401, serviceable: "Yes", tier: "2" },
  { pincode: 533406, serviceable: "Yes", tier: "2" },
  { pincode: 533444, serviceable: "Yes", tier: "2" },
  { pincode: 533445, serviceable: "Yes", tier: "2" },
  { pincode: 533447, serviceable: "Yes", tier: "2" },
  { pincode: 533450, serviceable: "Yes", tier: "2" },
  { pincode: 533463, serviceable: "Yes", tier: "2" },
  { pincode: 533464, serviceable: "Yes", tier: "2" },
  { pincode: 534001, serviceable: "Yes", tier: "2" },
  { pincode: 534002, serviceable: "Yes", tier: "2" },
  { pincode: 534003, serviceable: "Yes", tier: "2" },
  { pincode: 534004, serviceable: "Yes", tier: "2" },
  { pincode: 534005, serviceable: "Yes", tier: "2" },
  { pincode: 534006, serviceable: "Yes", tier: "2" },
  { pincode: 534007, serviceable: "Yes", tier: "2" },
  { pincode: 534101, serviceable: "Yes", tier: "2" },
  { pincode: 534102, serviceable: "Yes", tier: "2" },
  { pincode: 534111, serviceable: "Yes", tier: "2" },
  { pincode: 534112, serviceable: "Yes", tier: "2" },
  { pincode: 534145, serviceable: "Yes", tier: "2" },
  { pincode: 534146, serviceable: "Yes", tier: "2" },
  { pincode: 534165, serviceable: "Yes", tier: "2" },
  { pincode: 534166, serviceable: "Yes", tier: "2" },
  { pincode: 534195, serviceable: "Yes", tier: "2" },
  { pincode: 534196, serviceable: "Yes", tier: "2" },
  { pincode: 534197, serviceable: "Yes", tier: "2" },
  { pincode: 534201, serviceable: "Yes", tier: "2" },
  { pincode: 534202, serviceable: "Yes", tier: "2" },
  { pincode: 534203, serviceable: "Yes", tier: "2" },
  { pincode: 534204, serviceable: "Yes", tier: "2" },
  { pincode: 534211, serviceable: "Yes", tier: "2" },
  { pincode: 534247, serviceable: "Yes", tier: "2" },
  { pincode: 534250, serviceable: "Yes", tier: "2" },
  { pincode: 534251, serviceable: "Yes", tier: "2" },
  { pincode: 534260, serviceable: "Yes", tier: "2" },
  { pincode: 534265, serviceable: "Yes", tier: "2" },
  { pincode: 534266, serviceable: "Yes", tier: "2" },
  { pincode: 534268, serviceable: "Yes", tier: "2" },
  { pincode: 534275, serviceable: "Yes", tier: "3" },
  { pincode: 534281, serviceable: "Yes", tier: "2" },
  { pincode: 534301, serviceable: "Yes", tier: "2" },
  { pincode: 534305, serviceable: "Yes", tier: "2" },
  { pincode: 534313, serviceable: "Yes", tier: "2" },
  { pincode: 534327, serviceable: "Yes", tier: "2" },
  { pincode: 534338, serviceable: "Yes", tier: "2" },
  { pincode: 534350, serviceable: "Yes", tier: "2" },
  { pincode: 534401, serviceable: "Yes", tier: "2" },
  { pincode: 534406, serviceable: "Yes", tier: "2" },
  { pincode: 534411, serviceable: "Yes", tier: "2" },
  { pincode: 534416, serviceable: "Yes", tier: "2" },
  { pincode: 534425, serviceable: "Yes", tier: "2" },
  { pincode: 534435, serviceable: "Yes", tier: "2" },
  { pincode: 534437, serviceable: "Yes", tier: "2" },
  { pincode: 534442, serviceable: "Yes", tier: "2" },
  { pincode: 534444, serviceable: "Yes", tier: "2" },
  { pincode: 534460, serviceable: "Yes", tier: "3" },
  { pincode: 534467, serviceable: "Yes", tier: "2" },
  { pincode: 534475, serviceable: "Yes", tier: "2" },
  { pincode: 535001, serviceable: "Yes", tier: "2" },
  { pincode: 535002, serviceable: "Yes", tier: "2" },
  { pincode: 535101, serviceable: "Yes", tier: "3" },
  { pincode: 535117, serviceable: "Yes", tier: "2" },
  { pincode: 535128, serviceable: "Yes", tier: "3" },
  { pincode: 535204, serviceable: "Yes", tier: "2" },
  { pincode: 535217, serviceable: "Yes", tier: "3" },
  { pincode: 535501, serviceable: "Yes", tier: "3" },
  { pincode: 535502, serviceable: "Yes", tier: "3" },
  { pincode: 535522, serviceable: "Yes", tier: "3" },
  { pincode: 535527, serviceable: "Yes", tier: "3" },
  { pincode: 536201, serviceable: "Yes", tier: "1" },
  { pincode: 544444, serviceable: "Yes", tier: "1" },
  { pincode: 555555, serviceable: "Yes", tier: "1" },
  { pincode: 560000, serviceable: "Yes", tier: "1" },
  { pincode: 560001, serviceable: "Yes", tier: "1" },
  { pincode: 560002, serviceable: "Yes", tier: "1" },
  { pincode: 560003, serviceable: "Yes", tier: "1" },
  { pincode: 560004, serviceable: "Yes", tier: "1" },
  { pincode: 560005, serviceable: "Yes", tier: "1" },
  { pincode: 560006, serviceable: "Yes", tier: "1" },
  { pincode: 560007, serviceable: "Yes", tier: "1" },
  { pincode: 560008, serviceable: "Yes", tier: "1" },
  { pincode: 560009, serviceable: "Yes", tier: "1" },
  { pincode: 560010, serviceable: "Yes", tier: "1" },
  { pincode: 560011, serviceable: "Yes", tier: "1" },
  { pincode: 560012, serviceable: "Yes", tier: "1" },
  { pincode: 560013, serviceable: "Yes", tier: "1" },
  { pincode: 560014, serviceable: "Yes", tier: "1" },
  { pincode: 560015, serviceable: "Yes", tier: "1" },
  { pincode: 560016, serviceable: "Yes", tier: "1" },
  { pincode: 560017, serviceable: "Yes", tier: "1" },
  { pincode: 560018, serviceable: "Yes", tier: "1" },
  { pincode: 560019, serviceable: "Yes", tier: "1" },
  { pincode: 560020, serviceable: "Yes", tier: "1" },
  { pincode: 560021, serviceable: "Yes", tier: "1" },
  { pincode: 560022, serviceable: "Yes", tier: "1" },
  { pincode: 560023, serviceable: "Yes", tier: "1" },
  { pincode: 560024, serviceable: "Yes", tier: "1" },
  { pincode: 560025, serviceable: "Yes", tier: "1" },
  { pincode: 560026, serviceable: "Yes", tier: "1" },
  { pincode: 560027, serviceable: "Yes", tier: "1" },
  { pincode: 560028, serviceable: "Yes", tier: "1" },
  { pincode: 560029, serviceable: "Yes", tier: "1" },
  { pincode: 560030, serviceable: "Yes", tier: "1" },
  { pincode: 560031, serviceable: "Yes", tier: "1" },
  { pincode: 560032, serviceable: "Yes", tier: "1" },
  { pincode: 560033, serviceable: "Yes", tier: "1" },
  { pincode: 560034, serviceable: "Yes", tier: "1" },
  { pincode: 560035, serviceable: "Yes", tier: "1" },
  { pincode: 560036, serviceable: "Yes", tier: "1" },
  { pincode: 560037, serviceable: "Yes", tier: "1" },
  { pincode: 560038, serviceable: "Yes", tier: "1" },
  { pincode: 560039, serviceable: "Yes", tier: "1" },
  { pincode: 560040, serviceable: "Yes", tier: "1" },
  { pincode: 560041, serviceable: "Yes", tier: "1" },
  { pincode: 560042, serviceable: "Yes", tier: "1" },
  { pincode: 560043, serviceable: "Yes", tier: "1" },
  { pincode: 560044, serviceable: "Yes", tier: "1" },
  { pincode: 560045, serviceable: "Yes", tier: "1" },
  { pincode: 560046, serviceable: "Yes", tier: "1" },
  { pincode: 560047, serviceable: "Yes", tier: "1" },
  { pincode: 560048, serviceable: "Yes", tier: "1" },
  { pincode: 560049, serviceable: "Yes", tier: "1" },
  { pincode: 560050, serviceable: "Yes", tier: "1" },
  { pincode: 560051, serviceable: "Yes", tier: "1" },
  { pincode: 560052, serviceable: "Yes", tier: "1" },
  { pincode: 560053, serviceable: "Yes", tier: "1" },
  { pincode: 560054, serviceable: "Yes", tier: "1" },
  { pincode: 560055, serviceable: "Yes", tier: "1" },
  { pincode: 560056, serviceable: "Yes", tier: "1" },
  { pincode: 560057, serviceable: "Yes", tier: "1" },
  { pincode: 560058, serviceable: "Yes", tier: "1" },
  { pincode: 560059, serviceable: "Yes", tier: "1" },
  { pincode: 560060, serviceable: "Yes", tier: "1" },
  { pincode: 560061, serviceable: "Yes", tier: "1" },
  { pincode: 560062, serviceable: "Yes", tier: "1" },
  { pincode: 560063, serviceable: "Yes", tier: "1" },
  { pincode: 560064, serviceable: "Yes", tier: "1" },
  { pincode: 560065, serviceable: "Yes", tier: "1" },
  { pincode: 560066, serviceable: "Yes", tier: "1" },
  { pincode: 560067, serviceable: "Yes", tier: "1" },
  { pincode: 560068, serviceable: "Yes", tier: "1" },
  { pincode: 560069, serviceable: "Yes", tier: "1" },
  { pincode: 560070, serviceable: "Yes", tier: "1" },
  { pincode: 560071, serviceable: "Yes", tier: "1" },
  { pincode: 560072, serviceable: "Yes", tier: "1" },
  { pincode: 560073, serviceable: "Yes", tier: "1" },
  { pincode: 560074, serviceable: "Yes", tier: "1" },
  { pincode: 560075, serviceable: "Yes", tier: "1" },
  { pincode: 560076, serviceable: "Yes", tier: "1" },
  { pincode: 560077, serviceable: "Yes", tier: "1" },
  { pincode: 560078, serviceable: "Yes", tier: "1" },
  { pincode: 560079, serviceable: "Yes", tier: "1" },
  { pincode: 560080, serviceable: "Yes", tier: "1" },
  { pincode: 560081, serviceable: "Yes", tier: "1" },
  { pincode: 560082, serviceable: "Yes", tier: "1" },
  { pincode: 560083, serviceable: "Yes", tier: "1" },
  { pincode: 560084, serviceable: "Yes", tier: "1" },
  { pincode: 560085, serviceable: "Yes", tier: "1" },
  { pincode: 560086, serviceable: "Yes", tier: "1" },
  { pincode: 560087, serviceable: "Yes", tier: "1" },
  { pincode: 560088, serviceable: "Yes", tier: "1" },
  { pincode: 560089, serviceable: "Yes", tier: "1" },
  { pincode: 560090, serviceable: "Yes", tier: "1" },
  { pincode: 560091, serviceable: "Yes", tier: "1" },
  { pincode: 560092, serviceable: "Yes", tier: "1" },
  { pincode: 560093, serviceable: "Yes", tier: "1" },
  { pincode: 560094, serviceable: "Yes", tier: "1" },
  { pincode: 560095, serviceable: "Yes", tier: "1" },
  { pincode: 560096, serviceable: "Yes", tier: "1" },
  { pincode: 560097, serviceable: "Yes", tier: "1" },
  { pincode: 560098, serviceable: "Yes", tier: "1" },
  { pincode: 560099, serviceable: "Yes", tier: "1" },
  { pincode: 560100, serviceable: "Yes", tier: "1" },
  { pincode: 560102, serviceable: "Yes", tier: "1" },
  { pincode: 560103, serviceable: "Yes", tier: "1" },
  { pincode: 560104, serviceable: "Yes", tier: "1" },
  { pincode: 560105, serviceable: "Yes", tier: "1" },
  { pincode: 560106, serviceable: "Yes", tier: "1" },
  { pincode: 560107, serviceable: "Yes", tier: "1" },
  { pincode: 560108, serviceable: "Yes", tier: "1" },
  { pincode: 560109, serviceable: "Yes", tier: "1" },
  { pincode: 560110, serviceable: "Yes", tier: "1" },
  { pincode: 560111, serviceable: "Yes", tier: "1" },
  { pincode: 560112, serviceable: "Yes", tier: "1" },
  { pincode: 560300, serviceable: "Yes", tier: "1" },
  { pincode: 560500, serviceable: "Yes", tier: "1" },
  { pincode: 561201, serviceable: "Yes", tier: "1" },
  { pincode: 561202, serviceable: "Yes", tier: "2" },
  { pincode: 561203, serviceable: "Yes", tier: "1" },
  { pincode: 561205, serviceable: "Yes", tier: "1" },
  { pincode: 561206, serviceable: "Yes", tier: "2" },
  { pincode: 561207, serviceable: "Yes", tier: "2" },
  { pincode: 561208, serviceable: "Yes", tier: "2" },
  { pincode: 561210, serviceable: "Yes", tier: "2" },
  { pincode: 561211, serviceable: "Yes", tier: "2" },
  { pincode: 561212, serviceable: "Yes", tier: "2" },
  { pincode: 561213, serviceable: "Yes", tier: "2" },
  { pincode: 562101, serviceable: "Yes", tier: "1" },
  { pincode: 562103, serviceable: "Yes", tier: "1" },
  { pincode: 562105, serviceable: "Yes", tier: "1" },
  { pincode: 562106, serviceable: "Yes", tier: "1" },
  { pincode: 562107, serviceable: "Yes", tier: "1" },
  { pincode: 562109, serviceable: "Yes", tier: "1" },
  { pincode: 562110, serviceable: "Yes", tier: "1" },
  { pincode: 562111, serviceable: "Yes", tier: "2" },
  { pincode: 562112, serviceable: "Yes", tier: "2" },
  { pincode: 562114, serviceable: "Yes", tier: "1" },
  { pincode: 562115, serviceable: "Yes", tier: "1" },
  { pincode: 562116, serviceable: "Yes", tier: "1" },
  { pincode: 562120, serviceable: "Yes", tier: "2" },
  { pincode: 562122, serviceable: "Yes", tier: "1" },
  { pincode: 562123, serviceable: "Yes", tier: "1" },
  { pincode: 562125, serviceable: "Yes", tier: "1" },
  { pincode: 562127, serviceable: "Yes", tier: "2" },
  { pincode: 562129, serviceable: "Yes", tier: "1" },
  { pincode: 562130, serviceable: "Yes", tier: "2" },
  { pincode: 562132, serviceable: "Yes", tier: "1" },
  { pincode: 562137, serviceable: "Yes", tier: "2" },
  { pincode: 562149, serviceable: "Yes", tier: "1" },
  { pincode: 562151, serviceable: "Yes", tier: "2" },
  { pincode: 562152, serviceable: "Yes", tier: "1" },
  { pincode: 562157, serviceable: "Yes", tier: "1" },
  { pincode: 562159, serviceable: "Yes", tier: "2" },
  { pincode: 562160, serviceable: "Yes", tier: "2" },
  { pincode: 562161, serviceable: "Yes", tier: "2" },
  { pincode: 562162, serviceable: "Yes", tier: "1" },
  { pincode: 562163, serviceable: "Yes", tier: "1" },
  { pincode: 563101, serviceable: "Yes", tier: "1" },
  { pincode: 563102, serviceable: "Yes", tier: "1" },
  { pincode: 563103, serviceable: "Yes", tier: "1" },
  { pincode: 563109, serviceable: "Yes", tier: "1" },
  { pincode: 563113, serviceable: "Yes", tier: "1" },
  { pincode: 563115, serviceable: "Yes", tier: "1" },
  { pincode: 563116, serviceable: "Yes", tier: "1" },
  { pincode: 563117, serviceable: "Yes", tier: "1" },
  { pincode: 563118, serviceable: "Yes", tier: "1" },
  { pincode: 563119, serviceable: "Yes", tier: "1" },
  { pincode: 563120, serviceable: "Yes", tier: "1" },
  { pincode: 563121, serviceable: "Yes", tier: "1" },
  { pincode: 563122, serviceable: "Yes", tier: "1" },
  { pincode: 563125, serviceable: "Yes", tier: "1" },
  { pincode: 563128, serviceable: "Yes", tier: "1" },
  { pincode: 563130, serviceable: "Yes", tier: "1" },
  { pincode: 563131, serviceable: "Yes", tier: "1" },
  { pincode: 563133, serviceable: "Yes", tier: "1" },
  { pincode: 563333, serviceable: "Yes", tier: "1" },
  { pincode: 564545, serviceable: "Yes", tier: "1" },
  { pincode: 566105, serviceable: "Yes", tier: "1" },
  { pincode: 566666, serviceable: "Yes", tier: "1" },
  { pincode: 566667, serviceable: "Yes", tier: "1" },
  { pincode: 567233, serviceable: "Yes", tier: "1" },
  { pincode: 567777, serviceable: "Yes", tier: "1" },
  { pincode: 569999, serviceable: "Yes", tier: "1" },
  { pincode: 570001, serviceable: "Yes", tier: "1" },
  { pincode: 570002, serviceable: "Yes", tier: "1" },
  { pincode: 570003, serviceable: "Yes", tier: "1" },
  { pincode: 570004, serviceable: "Yes", tier: "1" },
  { pincode: 570005, serviceable: "Yes", tier: "1" },
  { pincode: 570006, serviceable: "Yes", tier: "1" },
  { pincode: 570007, serviceable: "Yes", tier: "1" },
  { pincode: 570008, serviceable: "Yes", tier: "1" },
  { pincode: 570009, serviceable: "Yes", tier: "1" },
  { pincode: 570010, serviceable: "Yes", tier: "1" },
  { pincode: 570011, serviceable: "Yes", tier: "1" },
  { pincode: 570012, serviceable: "Yes", tier: "1" },
  { pincode: 570013, serviceable: "Yes", tier: "1" },
  { pincode: 570014, serviceable: "Yes", tier: "1" },
  { pincode: 570015, serviceable: "Yes", tier: "1" },
  { pincode: 570016, serviceable: "Yes", tier: "1" },
  { pincode: 570017, serviceable: "Yes", tier: "1" },
  { pincode: 570018, serviceable: "Yes", tier: "1" },
  { pincode: 570019, serviceable: "Yes", tier: "1" },
  { pincode: 570020, serviceable: "Yes", tier: "1" },
  { pincode: 570021, serviceable: "Yes", tier: "1" },
  { pincode: 570022, serviceable: "Yes", tier: "1" },
  { pincode: 570023, serviceable: "Yes", tier: "1" },
  { pincode: 570024, serviceable: "Yes", tier: "1" },
  { pincode: 570025, serviceable: "Yes", tier: "1" },
  { pincode: 570026, serviceable: "Yes", tier: "1" },
  { pincode: 570027, serviceable: "Yes", tier: "1" },
  { pincode: 570028, serviceable: "Yes", tier: "1" },
  { pincode: 570029, serviceable: "Yes", tier: "1" },
  { pincode: 570030, serviceable: "Yes", tier: "1" },
  { pincode: 570031, serviceable: "Yes", tier: "1" },
  { pincode: 570041, serviceable: "Yes", tier: "2" },
  { pincode: 570301, serviceable: "Yes", tier: "2" },
  { pincode: 571101, serviceable: "Yes", tier: "2" },
  { pincode: 571103, serviceable: "Yes", tier: "2" },
  { pincode: 571104, serviceable: "Yes", tier: "2" },
  { pincode: 571105, serviceable: "Yes", tier: "2" },
  { pincode: 571106, serviceable: "Yes", tier: "2" },
  { pincode: 571107, serviceable: "Yes", tier: "2" },
  { pincode: 571109, serviceable: "Yes", tier: "2" },
  { pincode: 571110, serviceable: "Yes", tier: "2" },
  { pincode: 571111, serviceable: "Yes", tier: "2" },
  { pincode: 571114, serviceable: "Yes", tier: "2" },
  { pincode: 571115, serviceable: "Yes", tier: "2" },
  { pincode: 571116, serviceable: "Yes", tier: "2" },
  { pincode: 571117, serviceable: "Yes", tier: "2" },
  { pincode: 571118, serviceable: "Yes", tier: "2" },
  { pincode: 571119, serviceable: "Yes", tier: "2" },
  { pincode: 571120, serviceable: "Yes", tier: "2" },
  { pincode: 571121, serviceable: "Yes", tier: "2" },
  { pincode: 571122, serviceable: "Yes", tier: "2" },
  { pincode: 571123, serviceable: "Yes", tier: "2" },
  { pincode: 571124, serviceable: "Yes", tier: "2" },
  { pincode: 571127, serviceable: "Yes", tier: "2" },
  { pincode: 571128, serviceable: "Yes", tier: "2" },
  { pincode: 571129, serviceable: "Yes", tier: "2" },
  { pincode: 571130, serviceable: "Yes", tier: "1" },
  { pincode: 571139, serviceable: "Yes", tier: "2" },
  { pincode: 571156, serviceable: "Yes", tier: "2" },
  { pincode: 571159, serviceable: "Yes", tier: "2" },
  { pincode: 571166, serviceable: "Yes", tier: "2" },
  { pincode: 571186, serviceable: "Yes", tier: "1" },
  { pincode: 571189, serviceable: "Yes", tier: "2" },
  { pincode: 571201, serviceable: "Yes", tier: "2" },
  { pincode: 571213, serviceable: "Yes", tier: "2" },
  { pincode: 571214, serviceable: "Yes", tier: "2" },
  { pincode: 571215, serviceable: "Yes", tier: "2" },
  { pincode: 571216, serviceable: "Yes", tier: "2" },
  { pincode: 571217, serviceable: "Yes", tier: "2" },
  { pincode: 571218, serviceable: "Yes", tier: "2" },
  { pincode: 571219, serviceable: "Yes", tier: "2" },
  { pincode: 571221, serviceable: "Yes", tier: "2" },
  { pincode: 571231, serviceable: "Yes", tier: "2" },
  { pincode: 571232, serviceable: "Yes", tier: "2" },
  { pincode: 571233, serviceable: "Yes", tier: "2" },
  { pincode: 571234, serviceable: "Yes", tier: "2" },
  { pincode: 571235, serviceable: "Yes", tier: "2" },
  { pincode: 571236, serviceable: "Yes", tier: "2" },
  { pincode: 571237, serviceable: "Yes", tier: "2" },
  { pincode: 571248, serviceable: "Yes", tier: "2" },
  { pincode: 571251, serviceable: "Yes", tier: "2" },
  { pincode: 571301, serviceable: "Yes", tier: "2" },
  { pincode: 571302, serviceable: "Yes", tier: "2" },
  { pincode: 571304, serviceable: "Yes", tier: "2" },
  { pincode: 571311, serviceable: "Yes", tier: "2" },
  { pincode: 571312, serviceable: "Yes", tier: "2" },
  { pincode: 571313, serviceable: "Yes", tier: "2" },
  { pincode: 571314, serviceable: "Yes", tier: "2" },
  { pincode: 571315, serviceable: "Yes", tier: "2" },
  { pincode: 571319, serviceable: "Yes", tier: "2" },
  { pincode: 571320, serviceable: "Yes", tier: "2" },
  { pincode: 571321, serviceable: "Yes", tier: "2" },
  { pincode: 571322, serviceable: "Yes", tier: "1" },
  { pincode: 571325, serviceable: "Yes", tier: "2" },
  { pincode: 571329, serviceable: "Yes", tier: "2" },
  { pincode: 571331, serviceable: "Yes", tier: "2" },
  { pincode: 571337, serviceable: "Yes", tier: "2" },
  { pincode: 571342, serviceable: "Yes", tier: "2" },
  { pincode: 571401, serviceable: "Yes", tier: "2" },
  { pincode: 571402, serviceable: "Yes", tier: "2" },
  { pincode: 571403, serviceable: "Yes", tier: "2" },
  { pincode: 571404, serviceable: "Yes", tier: "2" },
  { pincode: 571405, serviceable: "Yes", tier: "2" },
  { pincode: 571415, serviceable: "Yes", tier: "2" },
  { pincode: 571416, serviceable: "Yes", tier: "2" },
  { pincode: 571418, serviceable: "Yes", tier: "2" },
  { pincode: 571419, serviceable: "Yes", tier: "2" },
  { pincode: 571422, serviceable: "Yes", tier: "2" },
  { pincode: 571423, serviceable: "Yes", tier: "2" },
  { pincode: 571425, serviceable: "Yes", tier: "2" },
  { pincode: 571426, serviceable: "Yes", tier: "2" },
  { pincode: 571427, serviceable: "Yes", tier: "2" },
  { pincode: 571428, serviceable: "Yes", tier: "2" },
  { pincode: 571429, serviceable: "Yes", tier: "2" },
  { pincode: 571430, serviceable: "Yes", tier: "2" },
  { pincode: 571431, serviceable: "Yes", tier: "2" },
  { pincode: 571432, serviceable: "Yes", tier: "2" },
  { pincode: 571433, serviceable: "Yes", tier: "2" },
  { pincode: 571434, serviceable: "Yes", tier: "2" },
  { pincode: 571435, serviceable: "Yes", tier: "2" },
  { pincode: 571436, serviceable: "Yes", tier: "2" },
  { pincode: 571437, serviceable: "Yes", tier: "2" },
  { pincode: 571438, serviceable: "Yes", tier: "2" },
  { pincode: 571439, serviceable: "Yes", tier: "2" },
  { pincode: 571440, serviceable: "Yes", tier: "2" },
  { pincode: 571441, serviceable: "Yes", tier: "2" },
  { pincode: 571442, serviceable: "Yes", tier: "2" },
  { pincode: 571443, serviceable: "Yes", tier: "2" },
  { pincode: 571445, serviceable: "Yes", tier: "2" },
  { pincode: 571446, serviceable: "Yes", tier: "2" },
  { pincode: 571448, serviceable: "Yes", tier: "2" },
  { pincode: 571450, serviceable: "Yes", tier: "2" },
  { pincode: 571454, serviceable: "Yes", tier: "2" },
  { pincode: 571455, serviceable: "Yes", tier: "2" },
  { pincode: 571457, serviceable: "Yes", tier: "2" },
  { pincode: 571463, serviceable: "Yes", tier: "2" },
  { pincode: 571476, serviceable: "Yes", tier: "2" },
  { pincode: 571477, serviceable: "Yes", tier: "2" },
  { pincode: 571478, serviceable: "Yes", tier: "2" },
  { pincode: 571480, serviceable: "Yes", tier: "2" },
  { pincode: 571483, serviceable: "Yes", tier: "2" },
  { pincode: 571501, serviceable: "Yes", tier: "2" },
  { pincode: 571502, serviceable: "Yes", tier: "2" },
  { pincode: 571511, serviceable: "Yes", tier: "2" },
  { pincode: 571602, serviceable: "Yes", tier: "2" },
  { pincode: 571603, serviceable: "Yes", tier: "2" },
  { pincode: 571604, serviceable: "Yes", tier: "2" },
  { pincode: 571605, serviceable: "Yes", tier: "2" },
  { pincode: 571606, serviceable: "Yes", tier: "2" },
  { pincode: 571607, serviceable: "Yes", tier: "2" },
  { pincode: 571610, serviceable: "Yes", tier: "2" },
  { pincode: 571617, serviceable: "Yes", tier: "2" },
  { pincode: 571802, serviceable: "Yes", tier: "2" },
  { pincode: 571810, serviceable: "Yes", tier: "2" },
  { pincode: 571811, serviceable: "Yes", tier: "2" },
  { pincode: 571812, serviceable: "Yes", tier: "2" },
  { pincode: 572101, serviceable: "Yes", tier: "2" },
  { pincode: 572102, serviceable: "Yes", tier: "2" },
  { pincode: 572103, serviceable: "Yes", tier: "2" },
  { pincode: 572104, serviceable: "Yes", tier: "2" },
  { pincode: 572105, serviceable: "Yes", tier: "2" },
  { pincode: 572106, serviceable: "Yes", tier: "2" },
  { pincode: 572107, serviceable: "Yes", tier: "2" },
  { pincode: 572108, serviceable: "Yes", tier: "2" },
  { pincode: 572111, serviceable: "Yes", tier: "2" },
  { pincode: 572112, serviceable: "Yes", tier: "2" },
  { pincode: 572114, serviceable: "Yes", tier: "2" },
  { pincode: 572118, serviceable: "Yes", tier: "2" },
  { pincode: 572122, serviceable: "Yes", tier: "2" },
  { pincode: 572128, serviceable: "Yes", tier: "2" },
  { pincode: 572130, serviceable: "Yes", tier: "2" },
  { pincode: 572137, serviceable: "Yes", tier: "2" },
  { pincode: 572138, serviceable: "Yes", tier: "2" },
  { pincode: 572140, serviceable: "Yes", tier: "2" },
  { pincode: 572143, serviceable: "Yes", tier: "2" },
  { pincode: 572144, serviceable: "Yes", tier: "2" },
  { pincode: 572145, serviceable: "Yes", tier: "2" },
  { pincode: 572151, serviceable: "Yes", tier: "2" },
  { pincode: 572168, serviceable: "Yes", tier: "2" },
  { pincode: 572201, serviceable: "Yes", tier: "2" },
  { pincode: 572202, serviceable: "Yes", tier: "2" },
  { pincode: 572441, serviceable: "Yes", tier: "2" },
  { pincode: 573101, serviceable: "Yes", tier: "1" },
  { pincode: 573102, serviceable: "Yes", tier: "2" },
  { pincode: 573103, serviceable: "Yes", tier: "2" },
  { pincode: 573111, serviceable: "Yes", tier: "2" },
  { pincode: 573112, serviceable: "Yes", tier: "2" },
  { pincode: 573115, serviceable: "Yes", tier: "1" },
  { pincode: 573116, serviceable: "Yes", tier: "2" },
  { pincode: 573118, serviceable: "Yes", tier: "1" },
  { pincode: 573120, serviceable: "Yes", tier: "1" },
  { pincode: 573121, serviceable: "Yes", tier: "1" },
  { pincode: 573124, serviceable: "Yes", tier: "2" },
  { pincode: 573128, serviceable: "Yes", tier: "1" },
  { pincode: 573130, serviceable: "Yes", tier: "2" },
  { pincode: 573131, serviceable: "Yes", tier: "2" },
  { pincode: 573133, serviceable: "Yes", tier: "2" },
  { pincode: 573134, serviceable: "Yes", tier: "2" },
  { pincode: 573135, serviceable: "Yes", tier: "2" },
  { pincode: 573143, serviceable: "Yes", tier: "1" },
  { pincode: 573145, serviceable: "Yes", tier: "2" },
  { pincode: 573147, serviceable: "Yes", tier: "2" },
  { pincode: 573150, serviceable: "Yes", tier: "2" },
  { pincode: 573160, serviceable: "Yes", tier: "2" },
  { pincode: 573165, serviceable: "Yes", tier: "2" },
  { pincode: 573201, serviceable: "Yes", tier: "1" },
  { pincode: 573202, serviceable: "Yes", tier: "1" },
  { pincode: 573210, serviceable: "Yes", tier: "2" },
  { pincode: 573211, serviceable: "Yes", tier: "2" },
  { pincode: 573212, serviceable: "Yes", tier: "1" },
  { pincode: 573215, serviceable: "Yes", tier: "1" },
  { pincode: 573216, serviceable: "Yes", tier: "1" },
  { pincode: 573217, serviceable: "Yes", tier: "1" },
  { pincode: 573219, serviceable: "Yes", tier: "1" },
  { pincode: 573220, serviceable: "Yes", tier: "1" },
  { pincode: 573225, serviceable: "Yes", tier: "1" },
  { pincode: 573226, serviceable: "Yes", tier: "1" },
  { pincode: 573228, serviceable: "Yes", tier: "1" },
  { pincode: 573425, serviceable: "Yes", tier: "2" },
  { pincode: 573445, serviceable: "Yes", tier: "2" },
  { pincode: 573628, serviceable: "Yes", tier: "1" },
  { pincode: 574101, serviceable: "Yes", tier: "1" },
  { pincode: 574103, serviceable: "Yes", tier: "1" },
  { pincode: 574104, serviceable: "Yes", tier: "1" },
  { pincode: 574105, serviceable: "Yes", tier: "1" },
  { pincode: 574106, serviceable: "Yes", tier: "1" },
  { pincode: 574108, serviceable: "Yes", tier: "1" },
  { pincode: 574110, serviceable: "Yes", tier: "1" },
  { pincode: 574111, serviceable: "Yes", tier: "1" },
  { pincode: 574112, serviceable: "Yes", tier: "1" },
  { pincode: 574113, serviceable: "Yes", tier: "1" },
  { pincode: 574116, serviceable: "Yes", tier: "1" },
  { pincode: 574117, serviceable: "Yes", tier: "1" },
  { pincode: 574118, serviceable: "Yes", tier: "1" },
  { pincode: 574119, serviceable: "Yes", tier: "1" },
  { pincode: 574120, serviceable: "Yes", tier: "1" },
  { pincode: 574122, serviceable: "Yes", tier: "1" },
  { pincode: 574123, serviceable: "Yes", tier: "1" },
  { pincode: 574126, serviceable: "Yes", tier: "1" },
  { pincode: 574130, serviceable: "Yes", tier: "1" },
  { pincode: 574131, serviceable: "Yes", tier: "1" },
  { pincode: 574134, serviceable: "Yes", tier: "1" },
  { pincode: 574138, serviceable: "Yes", tier: "1" },
  { pincode: 574139, serviceable: "Yes", tier: "1" },
  { pincode: 574140, serviceable: "Yes", tier: "1" },
  { pincode: 574141, serviceable: "Yes", tier: "1" },
  { pincode: 574143, serviceable: "Yes", tier: "2" },
  { pincode: 574144, serviceable: "Yes", tier: "1" },
  { pincode: 574146, serviceable: "Yes", tier: "1" },
  { pincode: 574150, serviceable: "Yes", tier: "1" },
  { pincode: 574151, serviceable: "Yes", tier: "1" },
  { pincode: 574152, serviceable: "Yes", tier: "1" },
  { pincode: 574153, serviceable: "Yes", tier: "1" },
  { pincode: 574154, serviceable: "Yes", tier: "1" },
  { pincode: 574157, serviceable: "Yes", tier: "1" },
  { pincode: 574159, serviceable: "Yes", tier: "1" },
  { pincode: 574160, serviceable: "Yes", tier: "1" },
  { pincode: 574161, serviceable: "Yes", tier: "1" },
  { pincode: 574162, serviceable: "Yes", tier: "1" },
  { pincode: 574163, serviceable: "Yes", tier: "1" },
  { pincode: 574164, serviceable: "Yes", tier: "1" },
  { pincode: 574165, serviceable: "Yes", tier: "1" },
  { pincode: 574166, serviceable: "Yes", tier: "1" },
  { pincode: 574167, serviceable: "Yes", tier: "1" },
  { pincode: 574168, serviceable: "Yes", tier: "1" },
  { pincode: 574169, serviceable: "Yes", tier: "2" },
  { pincode: 574171, serviceable: "Yes", tier: "1" },
  { pincode: 574172, serviceable: "Yes", tier: "1" },
  { pincode: 574173, serviceable: "Yes", tier: "1" },
  { pincode: 574179, serviceable: "Yes", tier: "1" },
  { pincode: 574180, serviceable: "Yes", tier: "1" },
  { pincode: 574181, serviceable: "Yes", tier: "1" },
  { pincode: 574182, serviceable: "Yes", tier: "1" },
  { pincode: 574183, serviceable: "Yes", tier: "1" },
  { pincode: 574184, serviceable: "Yes", tier: "1" },
  { pincode: 574187, serviceable: "Yes", tier: "2" },
  { pincode: 574188, serviceable: "Yes", tier: "2" },
  { pincode: 574189, serviceable: "Yes", tier: "1" },
  { pincode: 574194, serviceable: "Yes", tier: "1" },
  { pincode: 574197, serviceable: "Yes", tier: "1" },
  { pincode: 574198, serviceable: "Yes", tier: "2" },
  { pincode: 574199, serviceable: "Yes", tier: "1" },
  { pincode: 574201, serviceable: "Yes", tier: "2" },
  { pincode: 574202, serviceable: "Yes", tier: "2" },
  { pincode: 574203, serviceable: "Yes", tier: "2" },
  { pincode: 574210, serviceable: "Yes", tier: "2" },
  { pincode: 574211, serviceable: "Yes", tier: "2" },
  { pincode: 574212, serviceable: "Yes", tier: "2" },
  { pincode: 574213, serviceable: "Yes", tier: "1" },
  { pincode: 574214, serviceable: "Yes", tier: "2" },
  { pincode: 574216, serviceable: "Yes", tier: "2" },
  { pincode: 574217, serviceable: "Yes", tier: "2" },
  { pincode: 574218, serviceable: "Yes", tier: "2" },
  { pincode: 574219, serviceable: "Yes", tier: "2" },
  { pincode: 574220, serviceable: "Yes", tier: "2" },
  { pincode: 574221, serviceable: "Yes", tier: "2" },
  { pincode: 574222, serviceable: "Yes", tier: "2" },
  { pincode: 574223, serviceable: "Yes", tier: "2" },
  { pincode: 574224, serviceable: "Yes", tier: "2" },
  { pincode: 574225, serviceable: "Yes", tier: "1" },
  { pincode: 574226, serviceable: "Yes", tier: "1" },
  { pincode: 574227, serviceable: "Yes", tier: "1" },
  { pincode: 574228, serviceable: "Yes", tier: "2" },
  { pincode: 574229, serviceable: "Yes", tier: "2" },
  { pincode: 574230, serviceable: "Yes", tier: "2" },
  { pincode: 574231, serviceable: "Yes", tier: "2" },
  { pincode: 574232, serviceable: "Yes", tier: "2" },
  { pincode: 574233, serviceable: "Yes", tier: "2" },
  { pincode: 574237, serviceable: "Yes", tier: "1" },
  { pincode: 574238, serviceable: "Yes", tier: "2" },
  { pincode: 574239, serviceable: "Yes", tier: "2" },
  { pincode: 574240, serviceable: "Yes", tier: "2" },
  { pincode: 574241, serviceable: "Yes", tier: "2" },
  { pincode: 574242, serviceable: "Yes", tier: "2" },
  { pincode: 574243, serviceable: "Yes", tier: "2" },
  { pincode: 574245, serviceable: "Yes", tier: "2" },
  { pincode: 574248, serviceable: "Yes", tier: "2" },
  { pincode: 574250, serviceable: "Yes", tier: "2" },
  { pincode: 574251, serviceable: "Yes", tier: "2" },
  { pincode: 574253, serviceable: "Yes", tier: "2" },
  { pincode: 574258, serviceable: "Yes", tier: "2" },
  { pincode: 574259, serviceable: "Yes", tier: "2" },
  { pincode: 574261, serviceable: "Yes", tier: "2" },
  { pincode: 574262, serviceable: "Yes", tier: "2" },
  { pincode: 574263, serviceable: "Yes", tier: "2" },
  { pincode: 574264, serviceable: "Yes", tier: "2" },
  { pincode: 574265, serviceable: "Yes", tier: "2" },
  { pincode: 574266, serviceable: "Yes", tier: "1" },
  { pincode: 574267, serviceable: "Yes", tier: "1" },
  { pincode: 574269, serviceable: "Yes", tier: "2" },
  { pincode: 574272, serviceable: "Yes", tier: "1" },
  { pincode: 574274, serviceable: "Yes", tier: "1" },
  { pincode: 574275, serviceable: "Yes", tier: "1" },
  { pincode: 574276, serviceable: "Yes", tier: "2" },
  { pincode: 574277, serviceable: "Yes", tier: "1" },
  { pincode: 574282, serviceable: "Yes", tier: "2" },
  { pincode: 574284, serviceable: "Yes", tier: "2" },
  { pincode: 574285, serviceable: "Yes", tier: "2" },
  { pincode: 574287, serviceable: "Yes", tier: "2" },
  { pincode: 574289, serviceable: "Yes", tier: "2" },
  { pincode: 574291, serviceable: "Yes", tier: "2" },
  { pincode: 574294, serviceable: "Yes", tier: "2" },
  { pincode: 574296, serviceable: "Yes", tier: "2" },
  { pincode: 574297, serviceable: "Yes", tier: "2" },
  { pincode: 574299, serviceable: "Yes", tier: "2" },
  { pincode: 574309, serviceable: "Yes", tier: "2" },
  { pincode: 574310, serviceable: "Yes", tier: "2" },
  { pincode: 574311, serviceable: "Yes", tier: "2" },
  { pincode: 574312, serviceable: "Yes", tier: "2" },
  { pincode: 574313, serviceable: "Yes", tier: "2" },
  { pincode: 574314, serviceable: "Yes", tier: "2" },
  { pincode: 574315, serviceable: "Yes", tier: "2" },
  { pincode: 574317, serviceable: "Yes", tier: "1" },
  { pincode: 574318, serviceable: "Yes", tier: "2" },
  { pincode: 574319, serviceable: "Yes", tier: "2" },
  { pincode: 574324, serviceable: "Yes", tier: "2" },
  { pincode: 574325, serviceable: "Yes", tier: "2" },
  { pincode: 574326, serviceable: "Yes", tier: "2" },
  { pincode: 574327, serviceable: "Yes", tier: "2" },
  { pincode: 574335, serviceable: "Yes", tier: "2" },
  { pincode: 574337, serviceable: "Yes", tier: "2" },
  { pincode: 574504, serviceable: "Yes", tier: "1" },
  { pincode: 574561, serviceable: "Yes", tier: "1" },
  { pincode: 575001, serviceable: "Yes", tier: "1" },
  { pincode: 575002, serviceable: "Yes", tier: "1" },
  { pincode: 575003, serviceable: "Yes", tier: "1" },
  { pincode: 575004, serviceable: "Yes", tier: "1" },
  { pincode: 575005, serviceable: "Yes", tier: "1" },
  { pincode: 575006, serviceable: "Yes", tier: "1" },
  { pincode: 575007, serviceable: "Yes", tier: "1" },
  { pincode: 575008, serviceable: "Yes", tier: "1" },
  { pincode: 575009, serviceable: "Yes", tier: "1" },
  { pincode: 575010, serviceable: "Yes", tier: "1" },
  { pincode: 575011, serviceable: "Yes", tier: "1" },
  { pincode: 575012, serviceable: "Yes", tier: "1" },
  { pincode: 575013, serviceable: "Yes", tier: "1" },
  { pincode: 575014, serviceable: "Yes", tier: "1" },
  { pincode: 575015, serviceable: "Yes", tier: "1" },
  { pincode: 575016, serviceable: "Yes", tier: "1" },
  { pincode: 575017, serviceable: "Yes", tier: "1" },
  { pincode: 575018, serviceable: "Yes", tier: "1" },
  { pincode: 575019, serviceable: "Yes", tier: "1" },
  { pincode: 575020, serviceable: "Yes", tier: "1" },
  { pincode: 575021, serviceable: "Yes", tier: "1" },
  { pincode: 575022, serviceable: "Yes", tier: "1" },
  { pincode: 575023, serviceable: "Yes", tier: "1" },
  { pincode: 575025, serviceable: "Yes", tier: "1" },
  { pincode: 575026, serviceable: "Yes", tier: "1" },
  { pincode: 575027, serviceable: "Yes", tier: "1" },
  { pincode: 575028, serviceable: "Yes", tier: "1" },
  { pincode: 575029, serviceable: "Yes", tier: "1" },
  { pincode: 575030, serviceable: "Yes", tier: "1" },
  { pincode: 575130, serviceable: "Yes", tier: "2" },
  { pincode: 575220, serviceable: "Yes", tier: "1" },
  { pincode: 575221, serviceable: "Yes", tier: "1" },
  { pincode: 575253, serviceable: "Yes", tier: "2" },
  { pincode: 575551, serviceable: "Yes", tier: "1" },
  { pincode: 575889, serviceable: "Yes", tier: "1" },
  { pincode: 576001, serviceable: "Yes", tier: "1" },
  { pincode: 576003, serviceable: "Yes", tier: "1" },
  { pincode: 576101, serviceable: "Yes", tier: "1" },
  { pincode: 576102, serviceable: "Yes", tier: "1" },
  { pincode: 576103, serviceable: "Yes", tier: "1" },
  { pincode: 576104, serviceable: "Yes", tier: "1" },
  { pincode: 576105, serviceable: "Yes", tier: "1" },
  { pincode: 576106, serviceable: "Yes", tier: "1" },
  { pincode: 576107, serviceable: "Yes", tier: "1" },
  { pincode: 576108, serviceable: "Yes", tier: "1" },
  { pincode: 576111, serviceable: "Yes", tier: "1" },
  { pincode: 576112, serviceable: "Yes", tier: "1" },
  { pincode: 576113, serviceable: "Yes", tier: "1" },
  { pincode: 576114, serviceable: "Yes", tier: "1" },
  { pincode: 576115, serviceable: "Yes", tier: "1" },
  { pincode: 576116, serviceable: "Yes", tier: "1" },
  { pincode: 576118, serviceable: "Yes", tier: "1" },
  { pincode: 576119, serviceable: "Yes", tier: "1" },
  { pincode: 576121, serviceable: "Yes", tier: "1" },
  { pincode: 576122, serviceable: "Yes", tier: "1" },
  { pincode: 576125, serviceable: "Yes", tier: "1" },
  { pincode: 576126, serviceable: "Yes", tier: "1" },
  { pincode: 576127, serviceable: "Yes", tier: "1" },
  { pincode: 576128, serviceable: "Yes", tier: "1" },
  { pincode: 576129, serviceable: "Yes", tier: "1" },
  { pincode: 576131, serviceable: "Yes", tier: "1" },
  { pincode: 576135, serviceable: "Yes", tier: "1" },
  { pincode: 576136, serviceable: "Yes", tier: "1" },
  { pincode: 576145, serviceable: "Yes", tier: "1" },
  { pincode: 576201, serviceable: "Yes", tier: "1" },
  { pincode: 576210, serviceable: "Yes", tier: "1" },
  { pincode: 576211, serviceable: "Yes", tier: "1" },
  { pincode: 576212, serviceable: "Yes", tier: "1" },
  { pincode: 576213, serviceable: "Yes", tier: "1" },
  { pincode: 576214, serviceable: "Yes", tier: "2" },
  { pincode: 576216, serviceable: "Yes", tier: "1" },
  { pincode: 576217, serviceable: "Yes", tier: "1" },
  { pincode: 576218, serviceable: "Yes", tier: "1" },
  { pincode: 576221, serviceable: "Yes", tier: "1" },
  { pincode: 576222, serviceable: "Yes", tier: "1" },
  { pincode: 576223, serviceable: "Yes", tier: "1" },
  { pincode: 576224, serviceable: "Yes", tier: "1" },
  { pincode: 576225, serviceable: "Yes", tier: "1" },
  { pincode: 576226, serviceable: "Yes", tier: "1" },
  { pincode: 576228, serviceable: "Yes", tier: "2" },
  { pincode: 576229, serviceable: "Yes", tier: "1" },
  { pincode: 576230, serviceable: "Yes", tier: "1" },
  { pincode: 576231, serviceable: "Yes", tier: "1" },
  { pincode: 576232, serviceable: "Yes", tier: "2" },
  { pincode: 576233, serviceable: "Yes", tier: "1" },
  { pincode: 576234, serviceable: "Yes", tier: "1" },
  { pincode: 576235, serviceable: "Yes", tier: "1" },
  { pincode: 576238, serviceable: "Yes", tier: "1" },
  { pincode: 576241, serviceable: "Yes", tier: "1" },
  { pincode: 576243, serviceable: "Yes", tier: "1" },
  { pincode: 576244, serviceable: "Yes", tier: "2" },
  { pincode: 576247, serviceable: "Yes", tier: "1" },
  { pincode: 576249, serviceable: "Yes", tier: "1" },
  { pincode: 576252, serviceable: "Yes", tier: "1" },
  { pincode: 576254, serviceable: "Yes", tier: "1" },
  { pincode: 576257, serviceable: "Yes", tier: "1" },
  { pincode: 576262, serviceable: "Yes", tier: "1" },
  { pincode: 576266, serviceable: "Yes", tier: "1" },
  { pincode: 576282, serviceable: "Yes", tier: "1" },
  { pincode: 576283, serviceable: "Yes", tier: "1" },
  { pincode: 576425, serviceable: "Yes", tier: "1" },
  { pincode: 576445, serviceable: "Yes", tier: "2" },
  { pincode: 577001, serviceable: "Yes", tier: "1" },
  { pincode: 577002, serviceable: "Yes", tier: "1" },
  { pincode: 577003, serviceable: "Yes", tier: "1" },
  { pincode: 577004, serviceable: "Yes", tier: "1" },
  { pincode: 577005, serviceable: "Yes", tier: "1" },
  { pincode: 577006, serviceable: "Yes", tier: "1" },
  { pincode: 577101, serviceable: "Yes", tier: "1" },
  { pincode: 577102, serviceable: "Yes", tier: "1" },
  { pincode: 577111, serviceable: "Yes", tier: "2" },
  { pincode: 577113, serviceable: "Yes", tier: "2" },
  { pincode: 577115, serviceable: "Yes", tier: "1" },
  { pincode: 577116, serviceable: "Yes", tier: "2" },
  { pincode: 577119, serviceable: "Yes", tier: "2" },
  { pincode: 577132, serviceable: "Yes", tier: "2" },
  { pincode: 577133, serviceable: "Yes", tier: "1" },
  { pincode: 577135, serviceable: "Yes", tier: "2" },
  { pincode: 577147, serviceable: "Yes", tier: "2" },
  { pincode: 577149, serviceable: "Yes", tier: "1" },
  { pincode: 577156, serviceable: "Yes", tier: "1" },
  { pincode: 577168, serviceable: "Yes", tier: "1" },
  { pincode: 577175, serviceable: "Yes", tier: "2" },
  { pincode: 577201, serviceable: "Yes", tier: "1" },
  { pincode: 577202, serviceable: "Yes", tier: "1" },
  { pincode: 577203, serviceable: "Yes", tier: "1" },
  { pincode: 577204, serviceable: "Yes", tier: "1" },
  { pincode: 577205, serviceable: "Yes", tier: "1" },
  { pincode: 577213, serviceable: "Yes", tier: "1" },
  { pincode: 577214, serviceable: "Yes", tier: "1" },
  { pincode: 577222, serviceable: "Yes", tier: "1" },
  { pincode: 577229, serviceable: "Yes", tier: "1" },
  { pincode: 577232, serviceable: "Yes", tier: "1" },
  { pincode: 577234, serviceable: "Yes", tier: "1" },
  { pincode: 577235, serviceable: "Yes", tier: "1" },
  { pincode: 577236, serviceable: "Yes", tier: "1" },
  { pincode: 577245, serviceable: "Yes", tier: "1" },
  { pincode: 577301, serviceable: "Yes", tier: "1" },
  { pincode: 577302, serviceable: "Yes", tier: "1" },
  { pincode: 577303, serviceable: "Yes", tier: "1" },
  { pincode: 577401, serviceable: "Yes", tier: "1" },
  { pincode: 577411, serviceable: "Yes", tier: "1" },
  { pincode: 577412, serviceable: "Yes", tier: "1" },
  { pincode: 577413, serviceable: "Yes", tier: "1" },
  { pincode: 577414, serviceable: "Yes", tier: "1" },
  { pincode: 577415, serviceable: "Yes", tier: "1" },
  { pincode: 577416, serviceable: "Yes", tier: "1" },
  { pincode: 577417, serviceable: "Yes", tier: "1" },
  { pincode: 577422, serviceable: "Yes", tier: "1" },
  { pincode: 577424, serviceable: "Yes", tier: "1" },
  { pincode: 577427, serviceable: "Yes", tier: "1" },
  { pincode: 577429, serviceable: "Yes", tier: "1" },
  { pincode: 577430, serviceable: "Yes", tier: "1" },
  { pincode: 577432, serviceable: "Yes", tier: "1" },
  { pincode: 577434, serviceable: "Yes", tier: "1" },
  { pincode: 577435, serviceable: "Yes", tier: "1" },
  { pincode: 577439, serviceable: "Yes", tier: "1" },
  { pincode: 577443, serviceable: "Yes", tier: "1" },
  { pincode: 577501, serviceable: "Yes", tier: "2" },
  { pincode: 577502, serviceable: "Yes", tier: "2" },
  { pincode: 577511, serviceable: "Yes", tier: "2" },
  { pincode: 577516, serviceable: "Yes", tier: "1" },
  { pincode: 577517, serviceable: "Yes", tier: "2" },
  { pincode: 577520, serviceable: "Yes", tier: "2" },
  { pincode: 577521, serviceable: "Yes", tier: "2" },
  { pincode: 577522, serviceable: "Yes", tier: "2" },
  { pincode: 577524, serviceable: "Yes", tier: "2" },
  { pincode: 577526, serviceable: "Yes", tier: "1" },
  { pincode: 577527, serviceable: "Yes", tier: "1" },
  { pincode: 577532, serviceable: "Yes", tier: "2" },
  { pincode: 577536, serviceable: "Yes", tier: "2" },
  { pincode: 577537, serviceable: "Yes", tier: "2" },
  { pincode: 577538, serviceable: "Yes", tier: "2" },
  { pincode: 577541, serviceable: "Yes", tier: "2" },
  { pincode: 577543, serviceable: "Yes", tier: "2" },
  { pincode: 577544, serviceable: "Yes", tier: "1" },
  { pincode: 577545, serviceable: "Yes", tier: "2" },
  { pincode: 577548, serviceable: "Yes", tier: "2" },
  { pincode: 577551, serviceable: "Yes", tier: "1" },
  { pincode: 577555, serviceable: "Yes", tier: "2" },
  { pincode: 577556, serviceable: "Yes", tier: "1" },
  { pincode: 577558, serviceable: "Yes", tier: "2" },
  { pincode: 577566, serviceable: "Yes", tier: "1" },
  { pincode: 577583, serviceable: "Yes", tier: "1" },
  { pincode: 577598, serviceable: "Yes", tier: "2" },
  { pincode: 577599, serviceable: "Yes", tier: "2" },
  { pincode: 577601, serviceable: "Yes", tier: "1" },
  { pincode: 577602, serviceable: "Yes", tier: "1" },
  { pincode: 580001, serviceable: "Yes", tier: "1" },
  { pincode: 580002, serviceable: "Yes", tier: "1" },
  { pincode: 580003, serviceable: "Yes", tier: "1" },
  { pincode: 580004, serviceable: "Yes", tier: "1" },
  { pincode: 580005, serviceable: "Yes", tier: "1" },
  { pincode: 580006, serviceable: "Yes", tier: "1" },
  { pincode: 580007, serviceable: "Yes", tier: "1" },
  { pincode: 580008, serviceable: "Yes", tier: "1" },
  { pincode: 580009, serviceable: "Yes", tier: "1" },
  { pincode: 580010, serviceable: "Yes", tier: "1" },
  { pincode: 580011, serviceable: "Yes", tier: "1" },
  { pincode: 580020, serviceable: "Yes", tier: "1" },
  { pincode: 580021, serviceable: "Yes", tier: "1" },
  { pincode: 580022, serviceable: "Yes", tier: "1" },
  { pincode: 580023, serviceable: "Yes", tier: "1" },
  { pincode: 580024, serviceable: "Yes", tier: "1" },
  { pincode: 580025, serviceable: "Yes", tier: "1" },
  { pincode: 580026, serviceable: "Yes", tier: "1" },
  { pincode: 580028, serviceable: "Yes", tier: "1" },
  { pincode: 580029, serviceable: "Yes", tier: "1" },
  { pincode: 580030, serviceable: "Yes", tier: "1" },
  { pincode: 580031, serviceable: "Yes", tier: "1" },
  { pincode: 580032, serviceable: "Yes", tier: "1" },
  { pincode: 580112, serviceable: "Yes", tier: "1" },
  { pincode: 580114, serviceable: "Yes", tier: "1" },
  { pincode: 580116, serviceable: "Yes", tier: "1" },
  { pincode: 580118, serviceable: "Yes", tier: "1" },
  { pincode: 580212, serviceable: "Yes", tier: "1" },
  { pincode: 580213, serviceable: "Yes", tier: "1" },
  { pincode: 580214, serviceable: "Yes", tier: "1" },
  { pincode: 581047, serviceable: "Yes", tier: "1" },
  { pincode: 581101, serviceable: "Yes", tier: "1" },
  { pincode: 581102, serviceable: "Yes", tier: "1" },
  { pincode: 581103, serviceable: "Yes", tier: "1" },
  { pincode: 581104, serviceable: "Yes", tier: "1" },
  { pincode: 581105, serviceable: "Yes", tier: "1" },
  { pincode: 581106, serviceable: "Yes", tier: "1" },
  { pincode: 581108, serviceable: "Yes", tier: "1" },
  { pincode: 581109, serviceable: "Yes", tier: "1" },
  { pincode: 581110, serviceable: "Yes", tier: "1" },
  { pincode: 581111, serviceable: "Yes", tier: "1" },
  { pincode: 581112, serviceable: "Yes", tier: "1" },
  { pincode: 581115, serviceable: "Yes", tier: "1" },
  { pincode: 581116, serviceable: "Yes", tier: "1" },
  { pincode: 581118, serviceable: "Yes", tier: "1" },
  { pincode: 581119, serviceable: "Yes", tier: "1" },
  { pincode: 581120, serviceable: "Yes", tier: "1" },
  { pincode: 581123, serviceable: "Yes", tier: "1" },
  { pincode: 581124, serviceable: "Yes", tier: "1" },
  { pincode: 581125, serviceable: "Yes", tier: "1" },
  { pincode: 581126, serviceable: "Yes", tier: "1" },
  { pincode: 581127, serviceable: "Yes", tier: "1" },
  { pincode: 581128, serviceable: "Yes", tier: "1" },
  { pincode: 581131, serviceable: "Yes", tier: "1" },
  { pincode: 581132, serviceable: "Yes", tier: "1" },
  { pincode: 581134, serviceable: "Yes", tier: "1" },
  { pincode: 581138, serviceable: "Yes", tier: "1" },
  { pincode: 581139, serviceable: "Yes", tier: "1" },
  { pincode: 581140, serviceable: "Yes", tier: "1" },
  { pincode: 581145, serviceable: "Yes", tier: "1" },
  { pincode: 581147, serviceable: "Yes", tier: "1" },
  { pincode: 581148, serviceable: "Yes", tier: "1" },
  { pincode: 581149, serviceable: "Yes", tier: "1" },
  { pincode: 581150, serviceable: "Yes", tier: "1" },
  { pincode: 581153, serviceable: "Yes", tier: "1" },
  { pincode: 581154, serviceable: "Yes", tier: "1" },
  { pincode: 581155, serviceable: "Yes", tier: "1" },
  { pincode: 581157, serviceable: "Yes", tier: "2" },
  { pincode: 581158, serviceable: "Yes", tier: "2" },
  { pincode: 581160, serviceable: "Yes", tier: "1" },
  { pincode: 581163, serviceable: "Yes", tier: "1" },
  { pincode: 581164, serviceable: "Yes", tier: "1" },
  { pincode: 581167, serviceable: "Yes", tier: "1" },
  { pincode: 581168, serviceable: "Yes", tier: "2" },
  { pincode: 581169, serviceable: "Yes", tier: "1" },
  { pincode: 581170, serviceable: "Yes", tier: "1" },
  { pincode: 581177, serviceable: "Yes", tier: "2" },
  { pincode: 581181, serviceable: "Yes", tier: "1" },
  { pincode: 581182, serviceable: "Yes", tier: "1" },
  { pincode: 581183, serviceable: "Yes", tier: "1" },
  { pincode: 581185, serviceable: "Yes", tier: "2" },
  { pincode: 581189, serviceable: "Yes", tier: "1" },
  { pincode: 581191, serviceable: "Yes", tier: "3" },
  { pincode: 581193, serviceable: "Yes", tier: "3" },
  { pincode: 581197, serviceable: "Yes", tier: "3" },
  { pincode: 581198, serviceable: "Yes", tier: "1" },
  { pincode: 581199, serviceable: "Yes", tier: "1" },
  { pincode: 581201, serviceable: "Yes", tier: "1" },
  { pincode: 581202, serviceable: "Yes", tier: "3" },
  { pincode: 581203, serviceable: "Yes", tier: "1" },
  { pincode: 581206, serviceable: "Yes", tier: "1" },
  { pincode: 581208, serviceable: "Yes", tier: "1" },
  { pincode: 581210, serviceable: "Yes", tier: "1" },
  { pincode: 581211, serviceable: "Yes", tier: "1" },
  { pincode: 581212, serviceable: "Yes", tier: "3" },
  { pincode: 581213, serviceable: "Yes", tier: "1" },
  { pincode: 581214, serviceable: "Yes", tier: "3" },
  { pincode: 581225, serviceable: "Yes", tier: "1" },
  { pincode: 581228, serviceable: "Yes", tier: "3" },
  { pincode: 581301, serviceable: "Yes", tier: "2" },
  { pincode: 581302, serviceable: "Yes", tier: "2" },
  { pincode: 581303, serviceable: "Yes", tier: "2" },
  { pincode: 581304, serviceable: "Yes", tier: "2" },
  { pincode: 581305, serviceable: "Yes", tier: "2" },
  { pincode: 581306, serviceable: "Yes", tier: "2" },
  { pincode: 581307, serviceable: "Yes", tier: "2" },
  { pincode: 581308, serviceable: "Yes", tier: "2" },
  { pincode: 581314, serviceable: "Yes", tier: "2" },
  { pincode: 581316, serviceable: "Yes", tier: "2" },
  { pincode: 581320, serviceable: "Yes", tier: "2" },
  { pincode: 581321, serviceable: "Yes", tier: "2" },
  { pincode: 581323, serviceable: "Yes", tier: "2" },
  { pincode: 581324, serviceable: "Yes", tier: "2" },
  { pincode: 581325, serviceable: "Yes", tier: "1" },
  { pincode: 581327, serviceable: "Yes", tier: "2" },
  { pincode: 581329, serviceable: "Yes", tier: "1" },
  { pincode: 581330, serviceable: "Yes", tier: "2" },
  { pincode: 581332, serviceable: "Yes", tier: "2" },
  { pincode: 581334, serviceable: "Yes", tier: "2" },
  { pincode: 581335, serviceable: "Yes", tier: "2" },
  { pincode: 581341, serviceable: "Yes", tier: "2" },
  { pincode: 581342, serviceable: "Yes", tier: "2" },
  { pincode: 581343, serviceable: "Yes", tier: "2" },
  { pincode: 581345, serviceable: "Yes", tier: "2" },
  { pincode: 581348, serviceable: "Yes", tier: "2" },
  { pincode: 581349, serviceable: "Yes", tier: "3" },
  { pincode: 581350, serviceable: "Yes", tier: "2" },
  { pincode: 581351, serviceable: "Yes", tier: "2" },
  { pincode: 581352, serviceable: "Yes", tier: "2" },
  { pincode: 581353, serviceable: "Yes", tier: "2" },
  { pincode: 581354, serviceable: "Yes", tier: "2" },
  { pincode: 581357, serviceable: "Yes", tier: "2" },
  { pincode: 581360, serviceable: "Yes", tier: "2" },
  { pincode: 581361, serviceable: "Yes", tier: "2" },
  { pincode: 581362, serviceable: "Yes", tier: "2" },
  { pincode: 581396, serviceable: "Yes", tier: "2" },
  { pincode: 581400, serviceable: "Yes", tier: "2" },
  { pincode: 581401, serviceable: "Yes", tier: "3" },
  { pincode: 581402, serviceable: "Yes", tier: "3" },
  { pincode: 581405, serviceable: "Yes", tier: "3" },
  { pincode: 581411, serviceable: "Yes", tier: "3" },
  { pincode: 581421, serviceable: "Yes", tier: "2" },
  { pincode: 582101, serviceable: "Yes", tier: "2" },
  { pincode: 582102, serviceable: "Yes", tier: "2" },
  { pincode: 582103, serviceable: "Yes", tier: "2" },
  { pincode: 582121, serviceable: "Yes", tier: "2" },
  { pincode: 582122, serviceable: "Yes", tier: "1" },
  { pincode: 582123, serviceable: "Yes", tier: "2" },
  { pincode: 582201, serviceable: "Yes", tier: "2" },
  { pincode: 582205, serviceable: "Yes", tier: "2" },
  { pincode: 582214, serviceable: "Yes", tier: "2" },
  { pincode: 582218, serviceable: "Yes", tier: "1" },
  { pincode: 582225, serviceable: "Yes", tier: "2" },
  { pincode: 582227, serviceable: "Yes", tier: "1" },
  { pincode: 582231, serviceable: "Yes", tier: "2" },
  { pincode: 582234, serviceable: "Yes", tier: "2" },
  { pincode: 582243, serviceable: "Yes", tier: "3" },
  { pincode: 583101, serviceable: "Yes", tier: "2" },
  { pincode: 583102, serviceable: "Yes", tier: "2" },
  { pincode: 583103, serviceable: "Yes", tier: "2" },
  { pincode: 583104, serviceable: "Yes", tier: "2" },
  { pincode: 583105, serviceable: "Yes", tier: "2" },
  { pincode: 583111, serviceable: "Yes", tier: "2" },
  { pincode: 583113, serviceable: "Yes", tier: "2" },
  { pincode: 583114, serviceable: "Yes", tier: "2" },
  { pincode: 583115, serviceable: "Yes", tier: "2" },
  { pincode: 583116, serviceable: "Yes", tier: "2" },
  { pincode: 583117, serviceable: "Yes", tier: "2" },
  { pincode: 583120, serviceable: "Yes", tier: "2" },
  { pincode: 583121, serviceable: "Yes", tier: "2" },
  { pincode: 583122, serviceable: "Yes", tier: "2" },
  { pincode: 583123, serviceable: "Yes", tier: "2" },
  { pincode: 583129, serviceable: "Yes", tier: "2" },
  { pincode: 583132, serviceable: "Yes", tier: "2" },
  { pincode: 583138, serviceable: "Yes", tier: "2" },
  { pincode: 583144, serviceable: "Yes", tier: "2" },
  { pincode: 583147, serviceable: "Yes", tier: "2" },
  { pincode: 583152, serviceable: "Yes", tier: "2" },
  { pincode: 583201, serviceable: "Yes", tier: "2" },
  { pincode: 583202, serviceable: "Yes", tier: "2" },
  { pincode: 583203, serviceable: "Yes", tier: "2" },
  { pincode: 583204, serviceable: "Yes", tier: "2" },
  { pincode: 583211, serviceable: "Yes", tier: "2" },
  { pincode: 583215, serviceable: "Yes", tier: "2" },
  { pincode: 583221, serviceable: "Yes", tier: "2" },
  { pincode: 583222, serviceable: "Yes", tier: "2" },
  { pincode: 583223, serviceable: "Yes", tier: "2" },
  { pincode: 583225, serviceable: "Yes", tier: "2" },
  { pincode: 583227, serviceable: "Yes", tier: "2" },
  { pincode: 583228, serviceable: "Yes", tier: "2" },
  { pincode: 583229, serviceable: "Yes", tier: "2" },
  { pincode: 583230, serviceable: "Yes", tier: "2" },
  { pincode: 583231, serviceable: "Yes", tier: "2" },
  { pincode: 583233, serviceable: "Yes", tier: "2" },
  { pincode: 583234, serviceable: "Yes", tier: "2" },
  { pincode: 583238, serviceable: "Yes", tier: "2" },
  { pincode: 583239, serviceable: "Yes", tier: "2" },
  { pincode: 583245, serviceable: "Yes", tier: "2" },
  { pincode: 583250, serviceable: "Yes", tier: "2" },
  { pincode: 583253, serviceable: "Yes", tier: "2" },
  { pincode: 583255, serviceable: "Yes", tier: "2" },
  { pincode: 583263, serviceable: "Yes", tier: "2" },
  { pincode: 583268, serviceable: "Yes", tier: "2" },
  { pincode: 583271, serviceable: "Yes", tier: "2" },
  { pincode: 583272, serviceable: "Yes", tier: "2" },
  { pincode: 583273, serviceable: "Yes", tier: "2" },
  { pincode: 583275, serviceable: "Yes", tier: "2" },
  { pincode: 583276, serviceable: "Yes", tier: "2" },
  { pincode: 583286, serviceable: "Yes", tier: "2" },
  { pincode: 584101, serviceable: "Yes", tier: "2" },
  { pincode: 584102, serviceable: "Yes", tier: "2" },
  { pincode: 584103, serviceable: "Yes", tier: "2" },
  { pincode: 584104, serviceable: "Yes", tier: "2" },
  { pincode: 584115, serviceable: "Yes", tier: "2" },
  { pincode: 584118, serviceable: "Yes", tier: "2" },
  { pincode: 584122, serviceable: "Yes", tier: "2" },
  { pincode: 584123, serviceable: "Yes", tier: "2" },
  { pincode: 584124, serviceable: "Yes", tier: "2" },
  { pincode: 584125, serviceable: "Yes", tier: "2" },
  { pincode: 584128, serviceable: "Yes", tier: "2" },
  { pincode: 584129, serviceable: "Yes", tier: "2" },
  { pincode: 584131, serviceable: "Yes", tier: "2" },
  { pincode: 584132, serviceable: "Yes", tier: "2" },
  { pincode: 584134, serviceable: "Yes", tier: "2" },
  { pincode: 584135, serviceable: "Yes", tier: "2" },
  { pincode: 584138, serviceable: "Yes", tier: "2" },
  { pincode: 584142, serviceable: "Yes", tier: "2" },
  { pincode: 584143, serviceable: "Yes", tier: "2" },
  { pincode: 584167, serviceable: "Yes", tier: "2" },
  { pincode: 584170, serviceable: "Yes", tier: "2" },
  { pincode: 584202, serviceable: "Yes", tier: "2" },
  { pincode: 585101, serviceable: "Yes", tier: "2" },
  { pincode: 585102, serviceable: "Yes", tier: "2" },
  { pincode: 585103, serviceable: "Yes", tier: "2" },
  { pincode: 585104, serviceable: "Yes", tier: "2" },
  { pincode: 585105, serviceable: "Yes", tier: "2" },
  { pincode: 585201, serviceable: "Yes", tier: "2" },
  { pincode: 585202, serviceable: "Yes", tier: "2" },
  { pincode: 585211, serviceable: "Yes", tier: "2" },
  { pincode: 585221, serviceable: "Yes", tier: "2" },
  { pincode: 585222, serviceable: "Yes", tier: "2" },
  { pincode: 585223, serviceable: "Yes", tier: "2" },
  { pincode: 585225, serviceable: "Yes", tier: "2" },
  { pincode: 585287, serviceable: "Yes", tier: "2" },
  { pincode: 585292, serviceable: "Yes", tier: "2" },
  { pincode: 585306, serviceable: "Yes", tier: "2" },
  { pincode: 585313, serviceable: "Yes", tier: "3" },
  { pincode: 585327, serviceable: "Yes", tier: "3" },
  { pincode: 585330, serviceable: "Yes", tier: "3" },
  { pincode: 585401, serviceable: "Yes", tier: "3" },
  { pincode: 585402, serviceable: "Yes", tier: "3" },
  { pincode: 585403, serviceable: "Yes", tier: "3" },
  { pincode: 586101, serviceable: "Yes", tier: "2" },
  { pincode: 586102, serviceable: "Yes", tier: "2" },
  { pincode: 586103, serviceable: "Yes", tier: "2" },
  { pincode: 586104, serviceable: "Yes", tier: "2" },
  { pincode: 586105, serviceable: "Yes", tier: "2" },
  { pincode: 586106, serviceable: "Yes", tier: "2" },
  { pincode: 586107, serviceable: "Yes", tier: "2" },
  { pincode: 586108, serviceable: "Yes", tier: "2" },
  { pincode: 586109, serviceable: "Yes", tier: "2" },
  { pincode: 586126, serviceable: "Yes", tier: "3" },
  { pincode: 586128, serviceable: "Yes", tier: "2" },
  { pincode: 586130, serviceable: "Yes", tier: "2" },
  { pincode: 586144, serviceable: "Yes", tier: "2" },
  { pincode: 586148, serviceable: "Yes", tier: "2" },
  { pincode: 586149, serviceable: "Yes", tier: "2" },
  { pincode: 586169, serviceable: "Yes", tier: "2" },
  { pincode: 586202, serviceable: "Yes", tier: "2" },
  { pincode: 586209, serviceable: "Yes", tier: "3" },
  { pincode: 586212, serviceable: "Yes", tier: "2" },
  { pincode: 586245, serviceable: "Yes", tier: "2" },
  { pincode: 587101, serviceable: "Yes", tier: "2" },
  { pincode: 587102, serviceable: "Yes", tier: "2" },
  { pincode: 587103, serviceable: "Yes", tier: "2" },
  { pincode: 587104, serviceable: "Yes", tier: "2" },
  { pincode: 587111, serviceable: "Yes", tier: "2" },
  { pincode: 587113, serviceable: "Yes", tier: "3" },
  { pincode: 587114, serviceable: "Yes", tier: "2" },
  { pincode: 587116, serviceable: "Yes", tier: "2" },
  { pincode: 587118, serviceable: "Yes", tier: "2" },
  { pincode: 587119, serviceable: "Yes", tier: "3" },
  { pincode: 587122, serviceable: "Yes", tier: "3" },
  { pincode: 587124, serviceable: "Yes", tier: "2" },
  { pincode: 587125, serviceable: "Yes", tier: "2" },
  { pincode: 587126, serviceable: "Yes", tier: "2" },
  { pincode: 587143, serviceable: "Yes", tier: "1" },
  { pincode: 587145, serviceable: "Yes", tier: "2" },
  { pincode: 587154, serviceable: "Yes", tier: "2" },
  { pincode: 587201, serviceable: "Yes", tier: "2" },
  { pincode: 587203, serviceable: "Yes", tier: "2" },
  { pincode: 587204, serviceable: "Yes", tier: "2" },
  { pincode: 587205, serviceable: "Yes", tier: "2" },
  { pincode: 587212, serviceable: "Yes", tier: "3" },
  { pincode: 587213, serviceable: "Yes", tier: "2" },
  { pincode: 587301, serviceable: "Yes", tier: "3" },
  { pincode: 587302, serviceable: "Yes", tier: "3" },
  { pincode: 587311, serviceable: "Yes", tier: "3" },
  { pincode: 587312, serviceable: "Yes", tier: "3" },
  { pincode: 587313, serviceable: "Yes", tier: "3" },
  { pincode: 587314, serviceable: "Yes", tier: "3" },
  { pincode: 587315, serviceable: "Yes", tier: "3" },
  { pincode: 587316, serviceable: "Yes", tier: "3" },
  { pincode: 587320, serviceable: "Yes", tier: "3" },
  { pincode: 587322, serviceable: "Yes", tier: "3" },
  { pincode: 590001, serviceable: "Yes", tier: "1" },
  { pincode: 590002, serviceable: "Yes", tier: "1" },
  { pincode: 590003, serviceable: "Yes", tier: "1" },
  { pincode: 590004, serviceable: "Yes", tier: "1" },
  { pincode: 590005, serviceable: "Yes", tier: "1" },
  { pincode: 590006, serviceable: "Yes", tier: "1" },
  { pincode: 590007, serviceable: "Yes", tier: "1" },
  { pincode: 590008, serviceable: "Yes", tier: "1" },
  { pincode: 590009, serviceable: "Yes", tier: "1" },
  { pincode: 590010, serviceable: "Yes", tier: "1" },
  { pincode: 590011, serviceable: "Yes", tier: "1" },
  { pincode: 590012, serviceable: "Yes", tier: "1" },
  { pincode: 590013, serviceable: "Yes", tier: "1" },
  { pincode: 590014, serviceable: "Yes", tier: "1" },
  { pincode: 590015, serviceable: "Yes", tier: "1" },
  { pincode: 590016, serviceable: "Yes", tier: "1" },
  { pincode: 590017, serviceable: "Yes", tier: "1" },
  { pincode: 590018, serviceable: "Yes", tier: "1" },
  { pincode: 590019, serviceable: "Yes", tier: "1" },
  { pincode: 590543, serviceable: "Yes", tier: "1" },
  { pincode: 591102, serviceable: "Yes", tier: "2" },
  { pincode: 591104, serviceable: "Yes", tier: "2" },
  { pincode: 591107, serviceable: "Yes", tier: "2" },
  { pincode: 591108, serviceable: "Yes", tier: "1" },
  { pincode: 591112, serviceable: "Yes", tier: "2" },
  { pincode: 591113, serviceable: "Yes", tier: "1" },
  { pincode: 591115, serviceable: "Yes", tier: "2" },
  { pincode: 591118, serviceable: "Yes", tier: "2" },
  { pincode: 591121, serviceable: "Yes", tier: "2" },
  { pincode: 591124, serviceable: "Yes", tier: "1" },
  { pincode: 591125, serviceable: "Yes", tier: "2" },
  { pincode: 591126, serviceable: "Yes", tier: "2" },
  { pincode: 591153, serviceable: "Yes", tier: "2" },
  { pincode: 591181, serviceable: "Yes", tier: "1" },
  { pincode: 591201, serviceable: "Yes", tier: "2" },
  { pincode: 591211, serviceable: "Yes", tier: "2" },
  { pincode: 591212, serviceable: "Yes", tier: "3" },
  { pincode: 591214, serviceable: "Yes", tier: "2" },
  { pincode: 591218, serviceable: "Yes", tier: "2" },
  { pincode: 591219, serviceable: "Yes", tier: "2" },
  { pincode: 591220, serviceable: "Yes", tier: "3" },
  { pincode: 591224, serviceable: "Yes", tier: "2" },
  { pincode: 591227, serviceable: "Yes", tier: "2" },
  { pincode: 591229, serviceable: "Yes", tier: "2" },
  { pincode: 591230, serviceable: "Yes", tier: "3" },
  { pincode: 591232, serviceable: "Yes", tier: "3" },
  { pincode: 591233, serviceable: "Yes", tier: "2" },
  { pincode: 591237, serviceable: "Yes", tier: "2" },
  { pincode: 591239, serviceable: "Yes", tier: "2" },
  { pincode: 591241, serviceable: "Yes", tier: "2" },
  { pincode: 591242, serviceable: "Yes", tier: "2" },
  { pincode: 591244, serviceable: "Yes", tier: "2" },
  { pincode: 591247, serviceable: "Yes", tier: "2" },
  { pincode: 591261, serviceable: "Yes", tier: "3" },
  { pincode: 591263, serviceable: "Yes", tier: "2" },
  { pincode: 591304, serviceable: "Yes", tier: "3" },
  { pincode: 591306, serviceable: "Yes", tier: "2" },
  { pincode: 591307, serviceable: "Yes", tier: "2" },
  { pincode: 591308, serviceable: "Yes", tier: "2" },
  { pincode: 591312, serviceable: "Yes", tier: "2" },
  { pincode: 591344, serviceable: "Yes", tier: "2" },
  { pincode: 591513, serviceable: "Yes", tier: "2" },
  { pincode: 599991, serviceable: "Yes", tier: "1" },
  { pincode: 600000, serviceable: "Yes", tier: "1" },
  { pincode: 600001, serviceable: "Yes", tier: "1" },
  { pincode: 600002, serviceable: "Yes", tier: "1" },
  { pincode: 600003, serviceable: "Yes", tier: "1" },
  { pincode: 600004, serviceable: "Yes", tier: "1" },
  { pincode: 600005, serviceable: "Yes", tier: "1" },
  { pincode: 600006, serviceable: "Yes", tier: "1" },
  { pincode: 600007, serviceable: "Yes", tier: "1" },
  { pincode: 600008, serviceable: "Yes", tier: "1" },
  { pincode: 600009, serviceable: "Yes", tier: "1" },
  { pincode: 600010, serviceable: "Yes", tier: "1" },
  { pincode: 600011, serviceable: "Yes", tier: "1" },
  { pincode: 600012, serviceable: "Yes", tier: "1" },
  { pincode: 600013, serviceable: "Yes", tier: "1" },
  { pincode: 600014, serviceable: "Yes", tier: "1" },
  { pincode: 600015, serviceable: "Yes", tier: "1" },
  { pincode: 600016, serviceable: "Yes", tier: "1" },
  { pincode: 600017, serviceable: "Yes", tier: "1" },
  { pincode: 600018, serviceable: "Yes", tier: "1" },
  { pincode: 600019, serviceable: "Yes", tier: "1" },
  { pincode: 600020, serviceable: "Yes", tier: "1" },
  { pincode: 600021, serviceable: "Yes", tier: "1" },
  { pincode: 600022, serviceable: "Yes", tier: "1" },
  { pincode: 600023, serviceable: "Yes", tier: "1" },
  { pincode: 600024, serviceable: "Yes", tier: "1" },
  { pincode: 600025, serviceable: "Yes", tier: "1" },
  { pincode: 600026, serviceable: "Yes", tier: "1" },
  { pincode: 600027, serviceable: "Yes", tier: "1" },
  { pincode: 600028, serviceable: "Yes", tier: "1" },
  { pincode: 600029, serviceable: "Yes", tier: "1" },
  { pincode: 600030, serviceable: "Yes", tier: "1" },
  { pincode: 600031, serviceable: "Yes", tier: "1" },
  { pincode: 600032, serviceable: "Yes", tier: "1" },
  { pincode: 600033, serviceable: "Yes", tier: "1" },
  { pincode: 600034, serviceable: "Yes", tier: "1" },
  { pincode: 600035, serviceable: "Yes", tier: "1" },
  { pincode: 600036, serviceable: "Yes", tier: "1" },
  { pincode: 600037, serviceable: "Yes", tier: "1" },
  { pincode: 600038, serviceable: "Yes", tier: "1" },
  { pincode: 600039, serviceable: "Yes", tier: "1" },
  { pincode: 600040, serviceable: "Yes", tier: "1" },
  { pincode: 600041, serviceable: "Yes", tier: "1" },
  { pincode: 600042, serviceable: "Yes", tier: "1" },
  { pincode: 600043, serviceable: "Yes", tier: "1" },
  { pincode: 600044, serviceable: "Yes", tier: "1" },
  { pincode: 600045, serviceable: "Yes", tier: "1" },
  { pincode: 600046, serviceable: "Yes", tier: "1" },
  { pincode: 600047, serviceable: "Yes", tier: "1" },
  { pincode: 600048, serviceable: "Yes", tier: "1" },
  { pincode: 600049, serviceable: "Yes", tier: "1" },
  { pincode: 600050, serviceable: "Yes", tier: "1" },
  { pincode: 600051, serviceable: "Yes", tier: "1" },
  { pincode: 600052, serviceable: "Yes", tier: "2" },
  { pincode: 600053, serviceable: "Yes", tier: "1" },
  { pincode: 600054, serviceable: "Yes", tier: "1" },
  { pincode: 600055, serviceable: "Yes", tier: "1" },
  { pincode: 600056, serviceable: "Yes", tier: "1" },
  { pincode: 600057, serviceable: "Yes", tier: "1" },
  { pincode: 600058, serviceable: "Yes", tier: "1" },
  { pincode: 600059, serviceable: "Yes", tier: "1" },
  { pincode: 600060, serviceable: "Yes", tier: "1" },
  { pincode: 600061, serviceable: "Yes", tier: "1" },
  { pincode: 600062, serviceable: "Yes", tier: "1" },
  { pincode: 600063, serviceable: "Yes", tier: "1" },
  { pincode: 600064, serviceable: "Yes", tier: "1" },
  { pincode: 600065, serviceable: "Yes", tier: "1" },
  { pincode: 600066, serviceable: "Yes", tier: "1" },
  { pincode: 600067, serviceable: "Yes", tier: "2" },
  { pincode: 600068, serviceable: "Yes", tier: "1" },
  { pincode: 600069, serviceable: "Yes", tier: "2" },
  { pincode: 600070, serviceable: "Yes", tier: "1" },
  { pincode: 600071, serviceable: "Yes", tier: "1" },
  { pincode: 600072, serviceable: "Yes", tier: "2" },
  { pincode: 600073, serviceable: "Yes", tier: "1" },
  { pincode: 600074, serviceable: "Yes", tier: "1" },
  { pincode: 600075, serviceable: "Yes", tier: "1" },
  { pincode: 600076, serviceable: "Yes", tier: "1" },
  { pincode: 600077, serviceable: "Yes", tier: "1" },
  { pincode: 600078, serviceable: "Yes", tier: "1" },
  { pincode: 600079, serviceable: "Yes", tier: "1" },
  { pincode: 600080, serviceable: "Yes", tier: "1" },
  { pincode: 600081, serviceable: "Yes", tier: "1" },
  { pincode: 600082, serviceable: "Yes", tier: "1" },
  { pincode: 600083, serviceable: "Yes", tier: "1" },
  { pincode: 600084, serviceable: "Yes", tier: "1" },
  { pincode: 600085, serviceable: "Yes", tier: "1" },
  { pincode: 600086, serviceable: "Yes", tier: "1" },
  { pincode: 600087, serviceable: "Yes", tier: "1" },
  { pincode: 600088, serviceable: "Yes", tier: "1" },
  { pincode: 600089, serviceable: "Yes", tier: "1" },
  { pincode: 600090, serviceable: "Yes", tier: "1" },
  { pincode: 600091, serviceable: "Yes", tier: "1" },
  { pincode: 600092, serviceable: "Yes", tier: "1" },
  { pincode: 600093, serviceable: "Yes", tier: "1" },
  { pincode: 600094, serviceable: "Yes", tier: "1" },
  { pincode: 600095, serviceable: "Yes", tier: "1" },
  { pincode: 600096, serviceable: "Yes", tier: "1" },
  { pincode: 600097, serviceable: "Yes", tier: "1" },
  { pincode: 600098, serviceable: "Yes", tier: "1" },
  { pincode: 600099, serviceable: "Yes", tier: "1" },
  { pincode: 600100, serviceable: "Yes", tier: "1" },
  { pincode: 600101, serviceable: "Yes", tier: "1" },
  { pincode: 600102, serviceable: "Yes", tier: "1" },
  { pincode: 600103, serviceable: "Yes", tier: "1" },
  { pincode: 600104, serviceable: "Yes", tier: "1" },
  { pincode: 600105, serviceable: "Yes", tier: "1" },
  { pincode: 600106, serviceable: "Yes", tier: "1" },
  { pincode: 600107, serviceable: "Yes", tier: "1" },
  { pincode: 600108, serviceable: "Yes", tier: "1" },
  { pincode: 600109, serviceable: "Yes", tier: "1" },
  { pincode: 600110, serviceable: "Yes", tier: "1" },
  { pincode: 600111, serviceable: "Yes", tier: "1" },
  { pincode: 600112, serviceable: "Yes", tier: "1" },
  { pincode: 600113, serviceable: "Yes", tier: "1" },
  { pincode: 600114, serviceable: "Yes", tier: "1" },
  { pincode: 600115, serviceable: "Yes", tier: "1" },
  { pincode: 600116, serviceable: "Yes", tier: "1" },
  { pincode: 600117, serviceable: "Yes", tier: "1" },
  { pincode: 600118, serviceable: "Yes", tier: "1" },
  { pincode: 600119, serviceable: "Yes", tier: "1" },
  { pincode: 600120, serviceable: "Yes", tier: "2" },
  { pincode: 600122, serviceable: "Yes", tier: "2" },
  { pincode: 600123, serviceable: "Yes", tier: "2" },
  { pincode: 600124, serviceable: "Yes", tier: "2" },
  { pincode: 600125, serviceable: "Yes", tier: "1" },
  { pincode: 600126, serviceable: "Yes", tier: "1" },
  { pincode: 600127, serviceable: "Yes", tier: "1" },
  { pincode: 600128, serviceable: "Yes", tier: "2" },
  { pincode: 600129, serviceable: "Yes", tier: "1" },
  { pincode: 600130, serviceable: "Yes", tier: "1" },
  { pincode: 600132, serviceable: "Yes", tier: "1" },
  { pincode: 600222, serviceable: "Yes", tier: "1" },
  { pincode: 600704, serviceable: "Yes", tier: "1" },
  { pincode: 601101, serviceable: "Yes", tier: "2" },
  { pincode: 601102, serviceable: "Yes", tier: "2" },
  { pincode: 601103, serviceable: "Yes", tier: "2" },
  { pincode: 601201, serviceable: "Yes", tier: "1" },
  { pincode: 601202, serviceable: "Yes", tier: "2" },
  { pincode: 601203, serviceable: "Yes", tier: "2" },
  { pincode: 601204, serviceable: "Yes", tier: "2" },
  { pincode: 601205, serviceable: "Yes", tier: "2" },
  { pincode: 601206, serviceable: "Yes", tier: "2" },
  { pincode: 601301, serviceable: "Yes", tier: "2" },
  { pincode: 602000, serviceable: "Yes", tier: "1" },
  { pincode: 602001, serviceable: "Yes", tier: "2" },
  { pincode: 602002, serviceable: "Yes", tier: "2" },
  { pincode: 602003, serviceable: "Yes", tier: "2" },
  { pincode: 602004, serviceable: "Yes", tier: "2" },
  { pincode: 602010, serviceable: "Yes", tier: "1" },
  { pincode: 602017, serviceable: "Yes", tier: "1" },
  { pincode: 602021, serviceable: "Yes", tier: "2" },
  { pincode: 602023, serviceable: "Yes", tier: "2" },
  { pincode: 602024, serviceable: "Yes", tier: "2" },
  { pincode: 602025, serviceable: "Yes", tier: "2" },
  { pincode: 602026, serviceable: "Yes", tier: "2" },
  { pincode: 602105, serviceable: "Yes", tier: "1" },
  { pincode: 602106, serviceable: "Yes", tier: "1" },
  { pincode: 602108, serviceable: "Yes", tier: "2" },
  { pincode: 602117, serviceable: "Yes", tier: "1" },
  { pincode: 602204, serviceable: "Yes", tier: "1" },
  { pincode: 602205, serviceable: "Yes", tier: "1" },
  { pincode: 603001, serviceable: "Yes", tier: "2" },
  { pincode: 603002, serviceable: "Yes", tier: "2" },
  { pincode: 603003, serviceable: "Yes", tier: "2" },
  { pincode: 603004, serviceable: "Yes", tier: "1" },
  { pincode: 603101, serviceable: "Yes", tier: "2" },
  { pincode: 603103, serviceable: "Yes", tier: "1" },
  { pincode: 603104, serviceable: "Yes", tier: "2" },
  { pincode: 603105, serviceable: "Yes", tier: "2" },
  { pincode: 603109, serviceable: "Yes", tier: "2" },
  { pincode: 603110, serviceable: "Yes", tier: "1" },
  { pincode: 603111, serviceable: "Yes", tier: "2" },
  { pincode: 603112, serviceable: "Yes", tier: "2" },
  { pincode: 603127, serviceable: "Yes", tier: "2" },
  { pincode: 603201, serviceable: "Yes", tier: "2" },
  { pincode: 603202, serviceable: "Yes", tier: "1" },
  { pincode: 603203, serviceable: "Yes", tier: "1" },
  { pincode: 603204, serviceable: "Yes", tier: "1" },
  { pincode: 603209, serviceable: "Yes", tier: "1" },
  { pincode: 603210, serviceable: "Yes", tier: "2" },
  { pincode: 603211, serviceable: "Yes", tier: "2" },
  { pincode: 603301, serviceable: "Yes", tier: "2" },
  { pincode: 603302, serviceable: "Yes", tier: "2" },
  { pincode: 603303, serviceable: "Yes", tier: "2" },
  { pincode: 603304, serviceable: "Yes", tier: "2" },
  { pincode: 603306, serviceable: "Yes", tier: "2" },
  { pincode: 603309, serviceable: "Yes", tier: "2" },
  { pincode: 603310, serviceable: "Yes", tier: "2" },
  { pincode: 603311, serviceable: "Yes", tier: "2" },
  { pincode: 603313, serviceable: "Yes", tier: "2" },
  { pincode: 603319, serviceable: "Yes", tier: "2" },
  { pincode: 603401, serviceable: "Yes", tier: "2" },
  { pincode: 604001, serviceable: "Yes", tier: "2" },
  { pincode: 604002, serviceable: "Yes", tier: "2" },
  { pincode: 604151, serviceable: "Yes", tier: "3" },
  { pincode: 604152, serviceable: "Yes", tier: "3" },
  { pincode: 604153, serviceable: "Yes", tier: "3" },
  { pincode: 604201, serviceable: "Yes", tier: "3" },
  { pincode: 604202, serviceable: "Yes", tier: "3" },
  { pincode: 604204, serviceable: "Yes", tier: "3" },
  { pincode: 604205, serviceable: "Yes", tier: "3" },
  { pincode: 604210, serviceable: "Yes", tier: "3" },
  { pincode: 604303, serviceable: "Yes", tier: "2" },
  { pincode: 604503, serviceable: "Yes", tier: "2" },
  { pincode: 604504, serviceable: "Yes", tier: "2" },
  { pincode: 604601, serviceable: "Yes", tier: "3" },
  { pincode: 605001, serviceable: "Yes", tier: "2" },
  { pincode: 605002, serviceable: "Yes", tier: "2" },
  { pincode: 605003, serviceable: "Yes", tier: "2" },
  { pincode: 605004, serviceable: "Yes", tier: "2" },
  { pincode: 605005, serviceable: "Yes", tier: "2" },
  { pincode: 605006, serviceable: "Yes", tier: "2" },
  { pincode: 605007, serviceable: "Yes", tier: "2" },
  { pincode: 605008, serviceable: "Yes", tier: "2" },
  { pincode: 605009, serviceable: "Yes", tier: "2" },
  { pincode: 605010, serviceable: "Yes", tier: "2" },
  { pincode: 605011, serviceable: "Yes", tier: "2" },
  { pincode: 605012, serviceable: "Yes", tier: "2" },
  { pincode: 605013, serviceable: "Yes", tier: "2" },
  { pincode: 605014, serviceable: "Yes", tier: "2" },
  { pincode: 605101, serviceable: "Yes", tier: "2" },
  { pincode: 605102, serviceable: "Yes", tier: "2" },
  { pincode: 605104, serviceable: "Yes", tier: "2" },
  { pincode: 605105, serviceable: "Yes", tier: "2" },
  { pincode: 605106, serviceable: "Yes", tier: "2" },
  { pincode: 605107, serviceable: "Yes", tier: "2" },
  { pincode: 605108, serviceable: "Yes", tier: "2" },
  { pincode: 605109, serviceable: "Yes", tier: "2" },
  { pincode: 605110, serviceable: "Yes", tier: "2" },
  { pincode: 605111, serviceable: "Yes", tier: "2" },
  { pincode: 605201, serviceable: "Yes", tier: "3" },
  { pincode: 605401, serviceable: "Yes", tier: "2" },
  { pincode: 605501, serviceable: "Yes", tier: "2" },
  { pincode: 605502, serviceable: "Yes", tier: "2" },
  { pincode: 605602, serviceable: "Yes", tier: "2" },
  { pincode: 605604, serviceable: "Yes", tier: "2" },
  { pincode: 605606, serviceable: "Yes", tier: "2" },
  { pincode: 605701, serviceable: "Yes", tier: "2" },
  { pincode: 605751, serviceable: "Yes", tier: "2" },
  { pincode: 605752, serviceable: "Yes", tier: "2" },
  { pincode: 605754, serviceable: "Yes", tier: "2" },
  { pincode: 605755, serviceable: "Yes", tier: "2" },
  { pincode: 605756, serviceable: "Yes", tier: "2" },
  { pincode: 605757, serviceable: "Yes", tier: "2" },
  { pincode: 605758, serviceable: "Yes", tier: "2" },
  { pincode: 605759, serviceable: "Yes", tier: "2" },
  { pincode: 605766, serviceable: "Yes", tier: "2" },
  { pincode: 605802, serviceable: "Yes", tier: "2" },
  { pincode: 605803, serviceable: "Yes", tier: "2" },
  { pincode: 606001, serviceable: "Yes", tier: "2" },
  { pincode: 606003, serviceable: "Yes", tier: "2" },
  { pincode: 606102, serviceable: "Yes", tier: "2" },
  { pincode: 606103, serviceable: "Yes", tier: "2" },
  { pincode: 606104, serviceable: "Yes", tier: "2" },
  { pincode: 606105, serviceable: "Yes", tier: "2" },
  { pincode: 606106, serviceable: "Yes", tier: "2" },
  { pincode: 606107, serviceable: "Yes", tier: "2" },
  { pincode: 606108, serviceable: "Yes", tier: "2" },
  { pincode: 606109, serviceable: "Yes", tier: "1" },
  { pincode: 606110, serviceable: "Yes", tier: "2" },
  { pincode: 606111, serviceable: "Yes", tier: "2" },
  { pincode: 606115, serviceable: "Yes", tier: "2" },
  { pincode: 606202, serviceable: "Yes", tier: "2" },
  { pincode: 606207, serviceable: "Yes", tier: "1" },
  { pincode: 606301, serviceable: "Yes", tier: "1" },
  { pincode: 606302, serviceable: "Yes", tier: "2" },
  { pincode: 606304, serviceable: "Yes", tier: "2" },
  { pincode: 606601, serviceable: "Yes", tier: "2" },
  { pincode: 606602, serviceable: "Yes", tier: "2" },
  { pincode: 606603, serviceable: "Yes", tier: "2" },
  { pincode: 606604, serviceable: "Yes", tier: "2" },
  { pincode: 606611, serviceable: "Yes", tier: "3" },
  { pincode: 606701, serviceable: "Yes", tier: "2" },
  { pincode: 606702, serviceable: "Yes", tier: "2" },
  { pincode: 606703, serviceable: "Yes", tier: "2" },
  { pincode: 606704, serviceable: "Yes", tier: "2" },
  { pincode: 606705, serviceable: "Yes", tier: "2" },
  { pincode: 606706, serviceable: "Yes", tier: "2" },
  { pincode: 606709, serviceable: "Yes", tier: "2" },
  { pincode: 606710, serviceable: "Yes", tier: "2" },
  { pincode: 606752, serviceable: "Yes", tier: "3" },
  { pincode: 606801, serviceable: "Yes", tier: "2" },
  { pincode: 606804, serviceable: "Yes", tier: "2" },
  { pincode: 606806, serviceable: "Yes", tier: "2" },
  { pincode: 606808, serviceable: "Yes", tier: "3" },
  { pincode: 606811, serviceable: "Yes", tier: "2" },
  { pincode: 606902, serviceable: "Yes", tier: "2" },
  { pincode: 606903, serviceable: "Yes", tier: "2" },
  { pincode: 606905, serviceable: "Yes", tier: "2" },
  { pincode: 606907, serviceable: "Yes", tier: "2" },
  { pincode: 606908, serviceable: "Yes", tier: "2" },
  { pincode: 607001, serviceable: "Yes", tier: "2" },
  { pincode: 607002, serviceable: "Yes", tier: "2" },
  { pincode: 607003, serviceable: "Yes", tier: "2" },
  { pincode: 607004, serviceable: "Yes", tier: "2" },
  { pincode: 607005, serviceable: "Yes", tier: "2" },
  { pincode: 607006, serviceable: "Yes", tier: "2" },
  { pincode: 607102, serviceable: "Yes", tier: "2" },
  { pincode: 607103, serviceable: "Yes", tier: "2" },
  { pincode: 607104, serviceable: "Yes", tier: "2" },
  { pincode: 607105, serviceable: "Yes", tier: "2" },
  { pincode: 607106, serviceable: "Yes", tier: "2" },
  { pincode: 607108, serviceable: "Yes", tier: "2" },
  { pincode: 607109, serviceable: "Yes", tier: "2" },
  { pincode: 607112, serviceable: "Yes", tier: "2" },
  { pincode: 607201, serviceable: "Yes", tier: "2" },
  { pincode: 607202, serviceable: "Yes", tier: "2" },
  { pincode: 607204, serviceable: "Yes", tier: "2" },
  { pincode: 607301, serviceable: "Yes", tier: "2" },
  { pincode: 607302, serviceable: "Yes", tier: "2" },
  { pincode: 607303, serviceable: "Yes", tier: "2" },
  { pincode: 607308, serviceable: "Yes", tier: "2" },
  { pincode: 607401, serviceable: "Yes", tier: "2" },
  { pincode: 607402, serviceable: "Yes", tier: "2" },
  { pincode: 607403, serviceable: "Yes", tier: "2" },
  { pincode: 607801, serviceable: "Yes", tier: "2" },
  { pincode: 607802, serviceable: "Yes", tier: "2" },
  { pincode: 607803, serviceable: "Yes", tier: "2" },
  { pincode: 607804, serviceable: "Yes", tier: "2" },
  { pincode: 607805, serviceable: "Yes", tier: "2" },
  { pincode: 607807, serviceable: "Yes", tier: "2" },
  { pincode: 608001, serviceable: "Yes", tier: "2" },
  { pincode: 608002, serviceable: "Yes", tier: "2" },
  { pincode: 608102, serviceable: "Yes", tier: "2" },
  { pincode: 608201, serviceable: "Yes", tier: "2" },
  { pincode: 608301, serviceable: "Yes", tier: "2" },
  { pincode: 608302, serviceable: "Yes", tier: "2" },
  { pincode: 608303, serviceable: "Yes", tier: "2" },
  { pincode: 608305, serviceable: "Yes", tier: "2" },
  { pincode: 608401, serviceable: "Yes", tier: "2" },
  { pincode: 608501, serviceable: "Yes", tier: "2" },
  { pincode: 608502, serviceable: "Yes", tier: "2" },
  { pincode: 608601, serviceable: "Yes", tier: "2" },
  { pincode: 608602, serviceable: "Yes", tier: "2" },
  { pincode: 608701, serviceable: "Yes", tier: "2" },
  { pincode: 608702, serviceable: "Yes", tier: "2" },
  { pincode: 608704, serviceable: "Yes", tier: "2" },
  { pincode: 609001, serviceable: "Yes", tier: "2" },
  { pincode: 609002, serviceable: "Yes", tier: "2" },
  { pincode: 609003, serviceable: "Yes", tier: "2" },
  { pincode: 609101, serviceable: "Yes", tier: "2" },
  { pincode: 609102, serviceable: "Yes", tier: "2" },
  { pincode: 609104, serviceable: "Yes", tier: "2" },
  { pincode: 609105, serviceable: "Yes", tier: "2" },
  { pincode: 609106, serviceable: "Yes", tier: "2" },
  { pincode: 609107, serviceable: "Yes", tier: "2" },
  { pincode: 609108, serviceable: "Yes", tier: "2" },
  { pincode: 609109, serviceable: "Yes", tier: "2" },
  { pincode: 609110, serviceable: "Yes", tier: "2" },
  { pincode: 609111, serviceable: "Yes", tier: "2" },
  { pincode: 609112, serviceable: "Yes", tier: "2" },
  { pincode: 609113, serviceable: "Yes", tier: "2" },
  { pincode: 609115, serviceable: "Yes", tier: "2" },
  { pincode: 609116, serviceable: "Yes", tier: "2" },
  { pincode: 609301, serviceable: "Yes", tier: "2" },
  { pincode: 609302, serviceable: "Yes", tier: "2" },
  { pincode: 609303, serviceable: "Yes", tier: "2" },
  { pincode: 609304, serviceable: "Yes", tier: "2" },
  { pincode: 609306, serviceable: "Yes", tier: "2" },
  { pincode: 609307, serviceable: "Yes", tier: "2" },
  { pincode: 609309, serviceable: "Yes", tier: "2" },
  { pincode: 609310, serviceable: "Yes", tier: "2" },
  { pincode: 609311, serviceable: "Yes", tier: "2" },
  { pincode: 609312, serviceable: "Yes", tier: "2" },
  { pincode: 609313, serviceable: "Yes", tier: "2" },
  { pincode: 609314, serviceable: "Yes", tier: "2" },
  { pincode: 609402, serviceable: "Yes", tier: "2" },
  { pincode: 609503, serviceable: "Yes", tier: "3" },
  { pincode: 609601, serviceable: "Yes", tier: "2" },
  { pincode: 609602, serviceable: "Yes", tier: "2" },
  { pincode: 609603, serviceable: "Yes", tier: "2" },
  { pincode: 609604, serviceable: "Yes", tier: "2" },
  { pincode: 609605, serviceable: "Yes", tier: "2" },
  { pincode: 609606, serviceable: "Yes", tier: "2" },
  { pincode: 609607, serviceable: "Yes", tier: "2" },
  { pincode: 609609, serviceable: "Yes", tier: "2" },
  { pincode: 609701, serviceable: "Yes", tier: "2" },
  { pincode: 609702, serviceable: "Yes", tier: "2" },
  { pincode: 609703, serviceable: "Yes", tier: "2" },
  { pincode: 609704, serviceable: "Yes", tier: "2" },
  { pincode: 610001, serviceable: "Yes", tier: "3" },
  { pincode: 610002, serviceable: "Yes", tier: "3" },
  { pincode: 610003, serviceable: "Yes", tier: "3" },
  { pincode: 610004, serviceable: "Yes", tier: "3" },
  { pincode: 610005, serviceable: "Yes", tier: "3" },
  { pincode: 610051, serviceable: "Yes", tier: "3" },
  { pincode: 610101, serviceable: "Yes", tier: "3" },
  { pincode: 610103, serviceable: "Yes", tier: "3" },
  { pincode: 610105, serviceable: "Yes", tier: "3" },
  { pincode: 610106, serviceable: "Yes", tier: "3" },
  { pincode: 610109, serviceable: "Yes", tier: "3" },
  { pincode: 610202, serviceable: "Yes", tier: "3" },
  { pincode: 610203, serviceable: "Yes", tier: "3" },
  { pincode: 610207, serviceable: "Yes", tier: "3" },
  { pincode: 610210, serviceable: "Yes", tier: "3" },
  { pincode: 610211, serviceable: "Yes", tier: "3" },
  { pincode: 611001, serviceable: "Yes", tier: "2" },
  { pincode: 611002, serviceable: "Yes", tier: "2" },
  { pincode: 611003, serviceable: "Yes", tier: "2" },
  { pincode: 611006, serviceable: "Yes", tier: "2" },
  { pincode: 611101, serviceable: "Yes", tier: "3" },
  { pincode: 611105, serviceable: "Yes", tier: "3" },
  { pincode: 611106, serviceable: "Yes", tier: "2" },
  { pincode: 611108, serviceable: "Yes", tier: "2" },
  { pincode: 611109, serviceable: "Yes", tier: "2" },
  { pincode: 611111, serviceable: "Yes", tier: "2" },
  { pincode: 611112, serviceable: "Yes", tier: "3" },
  { pincode: 612001, serviceable: "Yes", tier: "2" },
  { pincode: 612002, serviceable: "Yes", tier: "2" },
  { pincode: 612101, serviceable: "Yes", tier: "2" },
  { pincode: 612103, serviceable: "Yes", tier: "2" },
  { pincode: 612104, serviceable: "Yes", tier: "2" },
  { pincode: 612105, serviceable: "Yes", tier: "2" },
  { pincode: 612107, serviceable: "Yes", tier: "2" },
  { pincode: 612108, serviceable: "Yes", tier: "2" },
  { pincode: 612204, serviceable: "Yes", tier: "2" },
  { pincode: 612206, serviceable: "Yes", tier: "2" },
  { pincode: 612301, serviceable: "Yes", tier: "2" },
  { pincode: 612303, serviceable: "Yes", tier: "2" },
  { pincode: 612602, serviceable: "Yes", tier: "2" },
  { pincode: 612702, serviceable: "Yes", tier: "2" },
  { pincode: 612703, serviceable: "Yes", tier: "2" },
  { pincode: 612803, serviceable: "Yes", tier: "2" },
  { pincode: 612804, serviceable: "Yes", tier: "2" },
  { pincode: 612901, serviceable: "Yes", tier: "2" },
  { pincode: 612902, serviceable: "Yes", tier: "2" },
  { pincode: 612903, serviceable: "Yes", tier: "2" },
  { pincode: 613001, serviceable: "Yes", tier: "2" },
  { pincode: 613002, serviceable: "Yes", tier: "2" },
  { pincode: 613003, serviceable: "Yes", tier: "2" },
  { pincode: 613004, serviceable: "Yes", tier: "2" },
  { pincode: 613005, serviceable: "Yes", tier: "2" },
  { pincode: 613006, serviceable: "Yes", tier: "2" },
  { pincode: 613007, serviceable: "Yes", tier: "2" },
  { pincode: 613008, serviceable: "Yes", tier: "2" },
  { pincode: 613009, serviceable: "Yes", tier: "2" },
  { pincode: 613010, serviceable: "Yes", tier: "2" },
  { pincode: 613101, serviceable: "Yes", tier: "2" },
  { pincode: 613104, serviceable: "Yes", tier: "2" },
  { pincode: 613205, serviceable: "Yes", tier: "2" },
  { pincode: 613303, serviceable: "Yes", tier: "2" },
  { pincode: 613401, serviceable: "Yes", tier: "2" },
  { pincode: 613403, serviceable: "Yes", tier: "2" },
  { pincode: 613601, serviceable: "Yes", tier: "2" },
  { pincode: 613704, serviceable: "Yes", tier: "3" },
  { pincode: 614001, serviceable: "Yes", tier: "2" },
  { pincode: 614010, serviceable: "Yes", tier: "2" },
  { pincode: 614013, serviceable: "Yes", tier: "2" },
  { pincode: 614014, serviceable: "Yes", tier: "2" },
  { pincode: 614015, serviceable: "Yes", tier: "2" },
  { pincode: 614016, serviceable: "Yes", tier: "2" },
  { pincode: 614017, serviceable: "Yes", tier: "2" },
  { pincode: 614018, serviceable: "Yes", tier: "2" },
  { pincode: 614020, serviceable: "Yes", tier: "2" },
  { pincode: 614024, serviceable: "Yes", tier: "2" },
  { pincode: 614028, serviceable: "Yes", tier: "2" },
  { pincode: 614101, serviceable: "Yes", tier: "2" },
  { pincode: 614201, serviceable: "Yes", tier: "2" },
  { pincode: 614202, serviceable: "Yes", tier: "2" },
  { pincode: 614203, serviceable: "Yes", tier: "2" },
  { pincode: 614205, serviceable: "Yes", tier: "2" },
  { pincode: 614206, serviceable: "Yes", tier: "2" },
  { pincode: 614207, serviceable: "Yes", tier: "2" },
  { pincode: 614208, serviceable: "Yes", tier: "2" },
  { pincode: 614209, serviceable: "Yes", tier: "2" },
  { pincode: 614302, serviceable: "Yes", tier: "2" },
  { pincode: 614303, serviceable: "Yes", tier: "2" },
  { pincode: 614403, serviceable: "Yes", tier: "2" },
  { pincode: 614404, serviceable: "Yes", tier: "2" },
  { pincode: 614601, serviceable: "Yes", tier: "2" },
  { pincode: 614602, serviceable: "Yes", tier: "2" },
  { pincode: 614615, serviceable: "Yes", tier: "2" },
  { pincode: 614616, serviceable: "Yes", tier: "1" },
  { pincode: 614623, serviceable: "Yes", tier: "1" },
  { pincode: 614624, serviceable: "Yes", tier: "1" },
  { pincode: 614701, serviceable: "Yes", tier: "2" },
  { pincode: 614704, serviceable: "Yes", tier: "2" },
  { pincode: 614708, serviceable: "Yes", tier: "3" },
  { pincode: 614713, serviceable: "Yes", tier: "3" },
  { pincode: 614714, serviceable: "Yes", tier: "3" },
  { pincode: 614717, serviceable: "Yes", tier: "2" },
  { pincode: 614722, serviceable: "Yes", tier: "2" },
  { pincode: 614804, serviceable: "Yes", tier: "2" },
  { pincode: 614901, serviceable: "Yes", tier: "2" },
  { pincode: 614906, serviceable: "Yes", tier: "2" },
  { pincode: 620001, serviceable: "Yes", tier: "1" },
  { pincode: 620002, serviceable: "Yes", tier: "3" },
  { pincode: 620003, serviceable: "Yes", tier: "3" },
  { pincode: 620004, serviceable: "Yes", tier: "1" },
  { pincode: 620005, serviceable: "Yes", tier: "3" },
  { pincode: 620006, serviceable: "Yes", tier: "3" },
  { pincode: 620007, serviceable: "Yes", tier: "1" },
  { pincode: 620008, serviceable: "Yes", tier: "3" },
  { pincode: 620009, serviceable: "Yes", tier: "1" },
  { pincode: 620010, serviceable: "Yes", tier: "3" },
  { pincode: 620011, serviceable: "Yes", tier: "3" },
  { pincode: 620012, serviceable: "Yes", tier: "1" },
  { pincode: 620013, serviceable: "Yes", tier: "1" },
  { pincode: 620014, serviceable: "Yes", tier: "1" },
  { pincode: 620015, serviceable: "Yes", tier: "1" },
  { pincode: 620016, serviceable: "Yes", tier: "1" },
  { pincode: 620017, serviceable: "Yes", tier: "3" },
  { pincode: 620018, serviceable: "Yes", tier: "3" },
  { pincode: 620019, serviceable: "Yes", tier: "1" },
  { pincode: 620020, serviceable: "Yes", tier: "1" },
  { pincode: 620021, serviceable: "Yes", tier: "1" },
  { pincode: 620022, serviceable: "Yes", tier: "1" },
  { pincode: 620023, serviceable: "Yes", tier: "1" },
  { pincode: 620024, serviceable: "Yes", tier: "1" },
  { pincode: 620025, serviceable: "Yes", tier: "1" },
  { pincode: 620026, serviceable: "Yes", tier: "1" },
  { pincode: 620052, serviceable: "Yes", tier: "1" },
  { pincode: 620101, serviceable: "Yes", tier: "3" },
  { pincode: 620102, serviceable: "Yes", tier: "3" },
  { pincode: 620114, serviceable: "Yes", tier: "1" },
  { pincode: 621005, serviceable: "Yes", tier: "1" },
  { pincode: 621008, serviceable: "Yes", tier: "2" },
  { pincode: 621010, serviceable: "Yes", tier: "2" },
  { pincode: 621012, serviceable: "Yes", tier: "2" },
  { pincode: 621014, serviceable: "Yes", tier: "2" },
  { pincode: 621016, serviceable: "Yes", tier: "2" },
  { pincode: 621018, serviceable: "Yes", tier: "2" },
  { pincode: 621022, serviceable: "Yes", tier: "2" },
  { pincode: 621103, serviceable: "Yes", tier: "2" },
  { pincode: 621104, serviceable: "Yes", tier: "2" },
  { pincode: 621105, serviceable: "Yes", tier: "1" },
  { pincode: 621108, serviceable: "Yes", tier: "2" },
  { pincode: 621110, serviceable: "Yes", tier: "1" },
  { pincode: 621112, serviceable: "Yes", tier: "1" },
  { pincode: 621113, serviceable: "Yes", tier: "2" },
  { pincode: 621115, serviceable: "Yes", tier: "2" },
  { pincode: 621117, serviceable: "Yes", tier: "2" },
  { pincode: 621126, serviceable: "Yes", tier: "2" },
  { pincode: 621127, serviceable: "Yes", tier: "2" },
  { pincode: 621132, serviceable: "Yes", tier: "1" },
  { pincode: 621201, serviceable: "Yes", tier: "2" },
  { pincode: 621202, serviceable: "Yes", tier: "2" },
  { pincode: 621203, serviceable: "Yes", tier: "2" },
  { pincode: 621206, serviceable: "Yes", tier: "2" },
  { pincode: 621207, serviceable: "Yes", tier: "2" },
  { pincode: 621209, serviceable: "Yes", tier: "2" },
  { pincode: 621211, serviceable: "Yes", tier: "2" },
  { pincode: 621212, serviceable: "Yes", tier: "2" },
  { pincode: 621213, serviceable: "Yes", tier: "1" },
  { pincode: 621214, serviceable: "Yes", tier: "2" },
  { pincode: 621215, serviceable: "Yes", tier: "2" },
  { pincode: 621216, serviceable: "Yes", tier: "1" },
  { pincode: 621218, serviceable: "Yes", tier: "1" },
  { pincode: 621219, serviceable: "Yes", tier: "2" },
  { pincode: 621220, serviceable: "Yes", tier: "2" },
  { pincode: 621221, serviceable: "Yes", tier: "2" },
  { pincode: 621229, serviceable: "Yes", tier: "2" },
  { pincode: 621306, serviceable: "Yes", tier: "1" },
  { pincode: 621307, serviceable: "Yes", tier: "1" },
  { pincode: 621312, serviceable: "Yes", tier: "1" },
  { pincode: 621314, serviceable: "Yes", tier: "1" },
  { pincode: 621316, serviceable: "Yes", tier: "1" },
  { pincode: 621516, serviceable: "Yes", tier: "2" },
  { pincode: 621591, serviceable: "Yes", tier: "2" },
  { pincode: 621601, serviceable: "Yes", tier: "1" },
  { pincode: 621651, serviceable: "Yes", tier: "2" },
  { pincode: 621704, serviceable: "Yes", tier: "2" },
  { pincode: 621707, serviceable: "Yes", tier: "2" },
  { pincode: 621710, serviceable: "Yes", tier: "2" },
  { pincode: 621713, serviceable: "Yes", tier: "2" },
  { pincode: 621801, serviceable: "Yes", tier: "2" },
  { pincode: 621802, serviceable: "Yes", tier: "2" },
  { pincode: 621803, serviceable: "Yes", tier: "2" },
  { pincode: 621804, serviceable: "Yes", tier: "2" },
  { pincode: 621806, serviceable: "Yes", tier: "2" },
  { pincode: 622001, serviceable: "Yes", tier: "1" },
  { pincode: 622002, serviceable: "Yes", tier: "1" },
  { pincode: 622003, serviceable: "Yes", tier: "1" },
  { pincode: 622054, serviceable: "Yes", tier: "1" },
  { pincode: 622301, serviceable: "Yes", tier: "1" },
  { pincode: 622302, serviceable: "Yes", tier: "2" },
  { pincode: 622515, serviceable: "Yes", tier: "1" },
  { pincode: 623115, serviceable: "Yes", tier: "2" },
  { pincode: 623135, serviceable: "Yes", tier: "2" },
  { pincode: 623215, serviceable: "Yes", tier: "2" },
  { pincode: 623309, serviceable: "Yes", tier: "2" },
  { pincode: 623315, serviceable: "Yes", tier: "2" },
  { pincode: 623402, serviceable: "Yes", tier: "2" },
  { pincode: 623403, serviceable: "Yes", tier: "2" },
  { pincode: 623404, serviceable: "Yes", tier: "2" },
  { pincode: 623406, serviceable: "Yes", tier: "2" },
  { pincode: 623407, serviceable: "Yes", tier: "2" },
  { pincode: 623409, serviceable: "Yes", tier: "2" },
  { pincode: 623501, serviceable: "Yes", tier: "2" },
  { pincode: 623503, serviceable: "Yes", tier: "2" },
  { pincode: 623504, serviceable: "Yes", tier: "2" },
  { pincode: 623513, serviceable: "Yes", tier: "2" },
  { pincode: 623514, serviceable: "Yes", tier: "2" },
  { pincode: 623515, serviceable: "Yes", tier: "2" },
  { pincode: 623517, serviceable: "Yes", tier: "2" },
  { pincode: 623518, serviceable: "Yes", tier: "2" },
  { pincode: 623519, serviceable: "Yes", tier: "2" },
  { pincode: 623520, serviceable: "Yes", tier: "2" },
  { pincode: 623521, serviceable: "Yes", tier: "2" },
  { pincode: 623522, serviceable: "Yes", tier: "2" },
  { pincode: 623523, serviceable: "Yes", tier: "2" },
  { pincode: 623525, serviceable: "Yes", tier: "2" },
  { pincode: 623526, serviceable: "Yes", tier: "2" },
  { pincode: 623529, serviceable: "Yes", tier: "2" },
  { pincode: 623530, serviceable: "Yes", tier: "2" },
  { pincode: 623532, serviceable: "Yes", tier: "2" },
  { pincode: 623533, serviceable: "Yes", tier: "2" },
  { pincode: 623534, serviceable: "Yes", tier: "2" },
  { pincode: 623536, serviceable: "Yes", tier: "2" },
  { pincode: 623538, serviceable: "Yes", tier: "2" },
  { pincode: 623539, serviceable: "Yes", tier: "2" },
  { pincode: 623544, serviceable: "Yes", tier: "2" },
  { pincode: 623566, serviceable: "Yes", tier: "2" },
  { pincode: 623603, serviceable: "Yes", tier: "2" },
  { pincode: 623604, serviceable: "Yes", tier: "2" },
  { pincode: 623605, serviceable: "Yes", tier: "2" },
  { pincode: 623701, serviceable: "Yes", tier: "2" },
  { pincode: 623704, serviceable: "Yes", tier: "2" },
  { pincode: 623705, serviceable: "Yes", tier: "2" },
  { pincode: 623707, serviceable: "Yes", tier: "2" },
  { pincode: 623708, serviceable: "Yes", tier: "2" },
  { pincode: 623711, serviceable: "Yes", tier: "2" },
  { pincode: 623712, serviceable: "Yes", tier: "2" },
  { pincode: 623719, serviceable: "Yes", tier: "2" },
  { pincode: 623801, serviceable: "Yes", tier: "2" },
  { pincode: 623802, serviceable: "Yes", tier: "2" },
  { pincode: 623804, serviceable: "Yes", tier: "2" },
  { pincode: 623806, serviceable: "Yes", tier: "2" },
  { pincode: 623807, serviceable: "Yes", tier: "2" },
  { pincode: 623808, serviceable: "Yes", tier: "2" },
  { pincode: 624001, serviceable: "Yes", tier: "2" },
  { pincode: 624002, serviceable: "Yes", tier: "2" },
  { pincode: 624003, serviceable: "Yes", tier: "2" },
  { pincode: 624004, serviceable: "Yes", tier: "2" },
  { pincode: 624005, serviceable: "Yes", tier: "2" },
  { pincode: 624006, serviceable: "Yes", tier: "2" },
  { pincode: 624007, serviceable: "Yes", tier: "2" },
  { pincode: 624008, serviceable: "Yes", tier: "2" },
  { pincode: 624009, serviceable: "Yes", tier: "2" },
  { pincode: 624010, serviceable: "Yes", tier: "2" },
  { pincode: 624054, serviceable: "Yes", tier: "2" },
  { pincode: 624101, serviceable: "Yes", tier: "3" },
  { pincode: 624102, serviceable: "Yes", tier: "3" },
  { pincode: 624103, serviceable: "Yes", tier: "3" },
  { pincode: 624201, serviceable: "Yes", tier: "2" },
  { pincode: 624202, serviceable: "Yes", tier: "2" },
  { pincode: 624204, serviceable: "Yes", tier: "2" },
  { pincode: 624206, serviceable: "Yes", tier: "2" },
  { pincode: 624208, serviceable: "Yes", tier: "2" },
  { pincode: 624211, serviceable: "Yes", tier: "2" },
  { pincode: 624212, serviceable: "Yes", tier: "2" },
  { pincode: 624213, serviceable: "Yes", tier: "2" },
  { pincode: 624215, serviceable: "Yes", tier: "2" },
  { pincode: 624216, serviceable: "Yes", tier: "2" },
  { pincode: 624219, serviceable: "Yes", tier: "2" },
  { pincode: 624220, serviceable: "Yes", tier: "2" },
  { pincode: 624224, serviceable: "Yes", tier: "2" },
  { pincode: 624228, serviceable: "Yes", tier: "2" },
  { pincode: 624301, serviceable: "Yes", tier: "2" },
  { pincode: 624302, serviceable: "Yes", tier: "2" },
  { pincode: 624304, serviceable: "Yes", tier: "2" },
  { pincode: 624306, serviceable: "Yes", tier: "2" },
  { pincode: 624307, serviceable: "Yes", tier: "2" },
  { pincode: 624308, serviceable: "Yes", tier: "2" },
  { pincode: 624312, serviceable: "Yes", tier: "2" },
  { pincode: 624314, serviceable: "Yes", tier: "2" },
  { pincode: 624316, serviceable: "Yes", tier: "2" },
  { pincode: 624401, serviceable: "Yes", tier: "2" },
  { pincode: 624402, serviceable: "Yes", tier: "2" },
  { pincode: 624403, serviceable: "Yes", tier: "2" },
  { pincode: 624404, serviceable: "Yes", tier: "2" },
  { pincode: 624601, serviceable: "Yes", tier: "2" },
  { pincode: 624610, serviceable: "Yes", tier: "2" },
  { pincode: 624612, serviceable: "Yes", tier: "2" },
  { pincode: 624614, serviceable: "Yes", tier: "2" },
  { pincode: 624615, serviceable: "Yes", tier: "2" },
  { pincode: 624616, serviceable: "Yes", tier: "2" },
  { pincode: 624619, serviceable: "Yes", tier: "2" },
  { pincode: 624620, serviceable: "Yes", tier: "2" },
  { pincode: 624622, serviceable: "Yes", tier: "2" },
  { pincode: 624624, serviceable: "Yes", tier: "2" },
  { pincode: 624701, serviceable: "Yes", tier: "2" },
  { pincode: 624702, serviceable: "Yes", tier: "2" },
  { pincode: 624703, serviceable: "Yes", tier: "2" },
  { pincode: 624704, serviceable: "Yes", tier: "2" },
  { pincode: 624705, serviceable: "Yes", tier: "2" },
  { pincode: 624706, serviceable: "Yes", tier: "2" },
  { pincode: 624707, serviceable: "Yes", tier: "2" },
  { pincode: 624708, serviceable: "Yes", tier: "2" },
  { pincode: 624709, serviceable: "Yes", tier: "2" },
  { pincode: 624710, serviceable: "Yes", tier: "2" },
  { pincode: 624711, serviceable: "Yes", tier: "2" },
  { pincode: 624712, serviceable: "Yes", tier: "2" },
  { pincode: 624714, serviceable: "Yes", tier: "2" },
  { pincode: 624771, serviceable: "Yes", tier: "2" },
  { pincode: 624801, serviceable: "Yes", tier: "2" },
  { pincode: 624802, serviceable: "Yes", tier: "2" },
  { pincode: 624803, serviceable: "Yes", tier: "2" },
  { pincode: 624881, serviceable: "Yes", tier: "2" },
  { pincode: 624885, serviceable: "Yes", tier: "2" },
  { pincode: 624890, serviceable: "Yes", tier: "2" },
  { pincode: 625001, serviceable: "Yes", tier: "1" },
  { pincode: 625002, serviceable: "Yes", tier: "1" },
  { pincode: 625003, serviceable: "Yes", tier: "1" },
  { pincode: 625004, serviceable: "Yes", tier: "1" },
  { pincode: 625005, serviceable: "Yes", tier: "1" },
  { pincode: 625006, serviceable: "Yes", tier: "1" },
  { pincode: 625007, serviceable: "Yes", tier: "1" },
  { pincode: 625008, serviceable: "Yes", tier: "1" },
  { pincode: 625009, serviceable: "Yes", tier: "1" },
  { pincode: 625010, serviceable: "Yes", tier: "1" },
  { pincode: 625011, serviceable: "Yes", tier: "1" },
  { pincode: 625012, serviceable: "Yes", tier: "1" },
  { pincode: 625013, serviceable: "Yes", tier: "1" },
  { pincode: 625014, serviceable: "Yes", tier: "1" },
  { pincode: 625015, serviceable: "Yes", tier: "1" },
  { pincode: 625016, serviceable: "Yes", tier: "1" },
  { pincode: 625017, serviceable: "Yes", tier: "1" },
  { pincode: 625018, serviceable: "Yes", tier: "1" },
  { pincode: 625019, serviceable: "Yes", tier: "1" },
  { pincode: 625020, serviceable: "Yes", tier: "1" },
  { pincode: 625021, serviceable: "Yes", tier: "1" },
  { pincode: 625022, serviceable: "Yes", tier: "1" },
  { pincode: 625023, serviceable: "Yes", tier: "1" },
  { pincode: 625104, serviceable: "Yes", tier: "1" },
  { pincode: 625106, serviceable: "Yes", tier: "2" },
  { pincode: 625107, serviceable: "Yes", tier: "1" },
  { pincode: 625122, serviceable: "Yes", tier: "2" },
  { pincode: 625209, serviceable: "Yes", tier: "2" },
  { pincode: 625217, serviceable: "Yes", tier: "2" },
  { pincode: 625218, serviceable: "Yes", tier: "2" },
  { pincode: 625221, serviceable: "Yes", tier: "2" },
  { pincode: 625234, serviceable: "Yes", tier: "2" },
  { pincode: 625301, serviceable: "Yes", tier: "1" },
  { pincode: 625401, serviceable: "Yes", tier: "1" },
  { pincode: 625402, serviceable: "Yes", tier: "1" },
  { pincode: 625501, serviceable: "Yes", tier: "2" },
  { pincode: 625502, serviceable: "Yes", tier: "2" },
  { pincode: 625503, serviceable: "Yes", tier: "2" },
  { pincode: 625512, serviceable: "Yes", tier: "2" },
  { pincode: 625513, serviceable: "Yes", tier: "2" },
  { pincode: 625514, serviceable: "Yes", tier: "2" },
  { pincode: 625515, serviceable: "Yes", tier: "2" },
  { pincode: 625516, serviceable: "Yes", tier: "2" },
  { pincode: 625518, serviceable: "Yes", tier: "2" },
  { pincode: 625521, serviceable: "Yes", tier: "2" },
  { pincode: 625522, serviceable: "Yes", tier: "2" },
  { pincode: 625524, serviceable: "Yes", tier: "2" },
  { pincode: 625525, serviceable: "Yes", tier: "2" },
  { pincode: 625526, serviceable: "Yes", tier: "2" },
  { pincode: 625528, serviceable: "Yes", tier: "2" },
  { pincode: 625529, serviceable: "Yes", tier: "2" },
  { pincode: 625530, serviceable: "Yes", tier: "2" },
  { pincode: 625531, serviceable: "Yes", tier: "2" },
  { pincode: 625532, serviceable: "Yes", tier: "2" },
  { pincode: 625533, serviceable: "Yes", tier: "2" },
  { pincode: 625534, serviceable: "Yes", tier: "2" },
  { pincode: 625535, serviceable: "Yes", tier: "2" },
  { pincode: 625536, serviceable: "Yes", tier: "2" },
  { pincode: 625537, serviceable: "Yes", tier: "2" },
  { pincode: 625547, serviceable: "Yes", tier: "2" },
  { pincode: 625552, serviceable: "Yes", tier: "2" },
  { pincode: 625556, serviceable: "Yes", tier: "2" },
  { pincode: 625566, serviceable: "Yes", tier: "2" },
  { pincode: 625572, serviceable: "Yes", tier: "2" },
  { pincode: 625589, serviceable: "Yes", tier: "2" },
  { pincode: 625621, serviceable: "Yes", tier: "2" },
  { pincode: 625701, serviceable: "Yes", tier: "2" },
  { pincode: 625702, serviceable: "Yes", tier: "2" },
  { pincode: 625703, serviceable: "Yes", tier: "2" },
  { pincode: 625704, serviceable: "Yes", tier: "2" },
  { pincode: 625705, serviceable: "Yes", tier: "2" },
  { pincode: 625706, serviceable: "Yes", tier: "2" },
  { pincode: 625707, serviceable: "Yes", tier: "2" },
  { pincode: 625708, serviceable: "Yes", tier: "2" },
  { pincode: 626001, serviceable: "Yes", tier: "2" },
  { pincode: 626002, serviceable: "Yes", tier: "2" },
  { pincode: 626003, serviceable: "Yes", tier: "2" },
  { pincode: 626004, serviceable: "Yes", tier: "2" },
  { pincode: 626005, serviceable: "Yes", tier: "2" },
  { pincode: 626008, serviceable: "Yes", tier: "2" },
  { pincode: 626053, serviceable: "Yes", tier: "2" },
  { pincode: 626100, serviceable: "Yes", tier: "2" },
  { pincode: 626101, serviceable: "Yes", tier: "2" },
  { pincode: 626102, serviceable: "Yes", tier: "2" },
  { pincode: 626103, serviceable: "Yes", tier: "2" },
  { pincode: 626105, serviceable: "Yes", tier: "2" },
  { pincode: 626107, serviceable: "Yes", tier: "2" },
  { pincode: 626109, serviceable: "Yes", tier: "2" },
  { pincode: 626110, serviceable: "Yes", tier: "2" },
  { pincode: 626112, serviceable: "Yes", tier: "2" },
  { pincode: 626114, serviceable: "Yes", tier: "2" },
  { pincode: 626116, serviceable: "Yes", tier: "2" },
  { pincode: 626117, serviceable: "Yes", tier: "2" },
  { pincode: 626119, serviceable: "Yes", tier: "2" },
  { pincode: 626123, serviceable: "Yes", tier: "2" },
  { pincode: 626124, serviceable: "Yes", tier: "2" },
  { pincode: 626125, serviceable: "Yes", tier: "2" },
  { pincode: 626126, serviceable: "Yes", tier: "2" },
  { pincode: 626128, serviceable: "Yes", tier: "2" },
  { pincode: 626130, serviceable: "Yes", tier: "2" },
  { pincode: 626132, serviceable: "Yes", tier: "2" },
  { pincode: 626135, serviceable: "Yes", tier: "2" },
  { pincode: 626138, serviceable: "Yes", tier: "2" },
  { pincode: 626141, serviceable: "Yes", tier: "2" },
  { pincode: 626143, serviceable: "Yes", tier: "2" },
  { pincode: 626149, serviceable: "Yes", tier: "2" },
  { pincode: 626150, serviceable: "Yes", tier: "2" },
  { pincode: 626154, serviceable: "Yes", tier: "2" },
  { pincode: 626159, serviceable: "Yes", tier: "2" },
  { pincode: 626169, serviceable: "Yes", tier: "2" },
  { pincode: 626188, serviceable: "Yes", tier: "2" },
  { pincode: 626189, serviceable: "Yes", tier: "2" },
  { pincode: 626190, serviceable: "Yes", tier: "2" },
  { pincode: 626202, serviceable: "Yes", tier: "2" },
  { pincode: 626203, serviceable: "Yes", tier: "2" },
  { pincode: 626204, serviceable: "Yes", tier: "2" },
  { pincode: 626881, serviceable: "Yes", tier: "2" },
  { pincode: 627001, serviceable: "Yes", tier: "2" },
  { pincode: 627002, serviceable: "Yes", tier: "2" },
  { pincode: 627003, serviceable: "Yes", tier: "2" },
  { pincode: 627004, serviceable: "Yes", tier: "2" },
  { pincode: 627005, serviceable: "Yes", tier: "2" },
  { pincode: 627006, serviceable: "Yes", tier: "2" },
  { pincode: 627007, serviceable: "Yes", tier: "2" },
  { pincode: 627008, serviceable: "Yes", tier: "2" },
  { pincode: 627009, serviceable: "Yes", tier: "2" },
  { pincode: 627010, serviceable: "Yes", tier: "2" },
  { pincode: 627011, serviceable: "Yes", tier: "2" },
  { pincode: 627012, serviceable: "Yes", tier: "2" },
  { pincode: 627051, serviceable: "Yes", tier: "2" },
  { pincode: 627105, serviceable: "Yes", tier: "2" },
  { pincode: 627109, serviceable: "Yes", tier: "2" },
  { pincode: 627116, serviceable: "Yes", tier: "2" },
  { pincode: 627117, serviceable: "Yes", tier: "2" },
  { pincode: 627131, serviceable: "Yes", tier: "2" },
  { pincode: 627151, serviceable: "Yes", tier: "2" },
  { pincode: 627152, serviceable: "Yes", tier: "2" },
  { pincode: 627201, serviceable: "Yes", tier: "2" },
  { pincode: 627252, serviceable: "Yes", tier: "2" },
  { pincode: 627351, serviceable: "Yes", tier: "2" },
  { pincode: 627352, serviceable: "Yes", tier: "2" },
  { pincode: 627353, serviceable: "Yes", tier: "2" },
  { pincode: 627356, serviceable: "Yes", tier: "2" },
  { pincode: 627357, serviceable: "Yes", tier: "2" },
  { pincode: 627358, serviceable: "Yes", tier: "2" },
  { pincode: 627359, serviceable: "Yes", tier: "2" },
  { pincode: 627361, serviceable: "Yes", tier: "2" },
  { pincode: 627401, serviceable: "Yes", tier: "2" },
  { pincode: 627412, serviceable: "Yes", tier: "2" },
  { pincode: 627413, serviceable: "Yes", tier: "2" },
  { pincode: 627414, serviceable: "Yes", tier: "2" },
  { pincode: 627415, serviceable: "Yes", tier: "2" },
  { pincode: 627416, serviceable: "Yes", tier: "2" },
  { pincode: 627417, serviceable: "Yes", tier: "2" },
  { pincode: 627418, serviceable: "Yes", tier: "2" },
  { pincode: 627420, serviceable: "Yes", tier: "2" },
  { pincode: 627421, serviceable: "Yes", tier: "2" },
  { pincode: 627422, serviceable: "Yes", tier: "2" },
  { pincode: 627423, serviceable: "Yes", tier: "2" },
  { pincode: 627424, serviceable: "Yes", tier: "2" },
  { pincode: 627425, serviceable: "Yes", tier: "2" },
  { pincode: 627426, serviceable: "Yes", tier: "2" },
  { pincode: 627427, serviceable: "Yes", tier: "2" },
  { pincode: 627428, serviceable: "Yes", tier: "2" },
  { pincode: 627431, serviceable: "Yes", tier: "2" },
  { pincode: 627435, serviceable: "Yes", tier: "2" },
  { pincode: 627436, serviceable: "Yes", tier: "2" },
  { pincode: 627451, serviceable: "Yes", tier: "2" },
  { pincode: 627452, serviceable: "Yes", tier: "2" },
  { pincode: 627453, serviceable: "Yes", tier: "2" },
  { pincode: 627551, serviceable: "Yes", tier: "2" },
  { pincode: 627601, serviceable: "Yes", tier: "2" },
  { pincode: 627602, serviceable: "Yes", tier: "2" },
  { pincode: 627603, serviceable: "Yes", tier: "2" },
  { pincode: 627604, serviceable: "Yes", tier: "2" },
  { pincode: 627659, serviceable: "Yes", tier: "2" },
  { pincode: 627719, serviceable: "Yes", tier: "2" },
  { pincode: 627724, serviceable: "Yes", tier: "2" },
  { pincode: 627751, serviceable: "Yes", tier: "2" },
  { pincode: 627753, serviceable: "Yes", tier: "2" },
  { pincode: 627754, serviceable: "Yes", tier: "2" },
  { pincode: 627755, serviceable: "Yes", tier: "2" },
  { pincode: 627756, serviceable: "Yes", tier: "2" },
  { pincode: 627758, serviceable: "Yes", tier: "2" },
  { pincode: 627759, serviceable: "Yes", tier: "2" },
  { pincode: 627760, serviceable: "Yes", tier: "2" },
  { pincode: 627761, serviceable: "Yes", tier: "2" },
  { pincode: 627764, serviceable: "Yes", tier: "2" },
  { pincode: 627765, serviceable: "Yes", tier: "2" },
  { pincode: 627773, serviceable: "Yes", tier: "2" },
  { pincode: 627778, serviceable: "Yes", tier: "2" },
  { pincode: 627802, serviceable: "Yes", tier: "2" },
  { pincode: 627803, serviceable: "Yes", tier: "2" },
  { pincode: 627804, serviceable: "Yes", tier: "2" },
  { pincode: 627805, serviceable: "Yes", tier: "2" },
  { pincode: 627806, serviceable: "Yes", tier: "2" },
  { pincode: 627807, serviceable: "Yes", tier: "2" },
  { pincode: 627808, serviceable: "Yes", tier: "2" },
  { pincode: 627809, serviceable: "Yes", tier: "2" },
  { pincode: 627810, serviceable: "Yes", tier: "2" },
  { pincode: 627811, serviceable: "Yes", tier: "2" },
  { pincode: 627812, serviceable: "Yes", tier: "2" },
  { pincode: 627813, serviceable: "Yes", tier: "2" },
  { pincode: 627814, serviceable: "Yes", tier: "2" },
  { pincode: 627817, serviceable: "Yes", tier: "2" },
  { pincode: 627818, serviceable: "Yes", tier: "2" },
  { pincode: 627821, serviceable: "Yes", tier: "2" },
  { pincode: 627851, serviceable: "Yes", tier: "2" },
  { pincode: 627852, serviceable: "Yes", tier: "2" },
  { pincode: 627855, serviceable: "Yes", tier: "2" },
  { pincode: 627856, serviceable: "Yes", tier: "2" },
  { pincode: 627858, serviceable: "Yes", tier: "2" },
  { pincode: 627859, serviceable: "Yes", tier: "2" },
  { pincode: 627862, serviceable: "Yes", tier: "2" },
  { pincode: 627907, serviceable: "Yes", tier: "2" },
  { pincode: 627909, serviceable: "Yes", tier: "2" },
  { pincode: 627953, serviceable: "Yes", tier: "2" },
  { pincode: 627956, serviceable: "Yes", tier: "2" },
  { pincode: 628001, serviceable: "Yes", tier: "2" },
  { pincode: 628002, serviceable: "Yes", tier: "2" },
  { pincode: 628003, serviceable: "Yes", tier: "2" },
  { pincode: 628004, serviceable: "Yes", tier: "2" },
  { pincode: 628005, serviceable: "Yes", tier: "2" },
  { pincode: 628006, serviceable: "Yes", tier: "2" },
  { pincode: 628007, serviceable: "Yes", tier: "2" },
  { pincode: 628008, serviceable: "Yes", tier: "2" },
  { pincode: 628101, serviceable: "Yes", tier: "2" },
  { pincode: 628102, serviceable: "Yes", tier: "2" },
  { pincode: 628103, serviceable: "Yes", tier: "2" },
  { pincode: 628105, serviceable: "Yes", tier: "2" },
  { pincode: 628151, serviceable: "Yes", tier: "2" },
  { pincode: 628152, serviceable: "Yes", tier: "2" },
  { pincode: 628155, serviceable: "Yes", tier: "2" },
  { pincode: 628202, serviceable: "Yes", tier: "2" },
  { pincode: 628203, serviceable: "Yes", tier: "2" },
  { pincode: 628204, serviceable: "Yes", tier: "2" },
  { pincode: 628215, serviceable: "Yes", tier: "2" },
  { pincode: 628223, serviceable: "Yes", tier: "2" },
  { pincode: 628251, serviceable: "Yes", tier: "2" },
  { pincode: 628252, serviceable: "Yes", tier: "2" },
  { pincode: 628253, serviceable: "Yes", tier: "2" },
  { pincode: 628303, serviceable: "Yes", tier: "2" },
  { pincode: 628304, serviceable: "Yes", tier: "2" },
  { pincode: 628313, serviceable: "Yes", tier: "2" },
  { pincode: 628501, serviceable: "Yes", tier: "2" },
  { pincode: 628502, serviceable: "Yes", tier: "2" },
  { pincode: 628552, serviceable: "Yes", tier: "2" },
  { pincode: 628616, serviceable: "Yes", tier: "2" },
  { pincode: 628617, serviceable: "Yes", tier: "2" },
  { pincode: 628722, serviceable: "Yes", tier: "2" },
  { pincode: 628801, serviceable: "Yes", tier: "2" },
  { pincode: 628809, serviceable: "Yes", tier: "2" },
  { pincode: 628851, serviceable: "Yes", tier: "2" },
  { pincode: 628907, serviceable: "Yes", tier: "2" },
  { pincode: 629001, serviceable: "Yes", tier: "3" },
  { pincode: 629002, serviceable: "Yes", tier: "3" },
  { pincode: 629003, serviceable: "Yes", tier: "3" },
  { pincode: 629004, serviceable: "Yes", tier: "3" },
  { pincode: 629051, serviceable: "Yes", tier: "3" },
  { pincode: 629058, serviceable: "Yes", tier: "2" },
  { pincode: 629151, serviceable: "Yes", tier: "2" },
  { pincode: 629153, serviceable: "Yes", tier: "2" },
  { pincode: 629154, serviceable: "Yes", tier: "3" },
  { pincode: 629157, serviceable: "Yes", tier: "2" },
  { pincode: 629160, serviceable: "Yes", tier: "3" },
  { pincode: 629163, serviceable: "Yes", tier: "2" },
  { pincode: 629165, serviceable: "Yes", tier: "2" },
  { pincode: 629167, serviceable: "Yes", tier: "5" },
  { pincode: 629171, serviceable: "Yes", tier: "3" },
  { pincode: 629172, serviceable: "Yes", tier: "3" },
  { pincode: 629174, serviceable: "Yes", tier: "5" },
  { pincode: 629175, serviceable: "Yes", tier: "5" },
  { pincode: 629176, serviceable: "Yes", tier: "3" },
  { pincode: 629177, serviceable: "Yes", tier: "2" },
  { pincode: 629180, serviceable: "Yes", tier: "5" },
  { pincode: 629187, serviceable: "Yes", tier: "2" },
  { pincode: 629190, serviceable: "Yes", tier: "2" },
  { pincode: 629191, serviceable: "Yes", tier: "2" },
  { pincode: 629194, serviceable: "Yes", tier: "2" },
  { pincode: 629195, serviceable: "Yes", tier: "2" },
  { pincode: 629251, serviceable: "Yes", tier: "5" },
  { pincode: 629252, serviceable: "Yes", tier: "5" },
  { pincode: 629302, serviceable: "Yes", tier: "3" },
  { pincode: 629303, serviceable: "Yes", tier: "3" },
  { pincode: 629305, serviceable: "Yes", tier: "3" },
  { pincode: 629401, serviceable: "Yes", tier: "3" },
  { pincode: 629402, serviceable: "Yes", tier: "3" },
  { pincode: 629403, serviceable: "Yes", tier: "3" },
  { pincode: 629501, serviceable: "Yes", tier: "3" },
  { pincode: 629502, serviceable: "Yes", tier: "3" },
  { pincode: 629504, serviceable: "Yes", tier: "3" },
  { pincode: 629551, serviceable: "Yes", tier: "3" },
  { pincode: 629601, serviceable: "Yes", tier: "3" },
  { pincode: 629602, serviceable: "Yes", tier: "3" },
  { pincode: 629603, serviceable: "Yes", tier: "3" },
  { pincode: 629701, serviceable: "Yes", tier: "3" },
  { pincode: 629702, serviceable: "Yes", tier: "3" },
  { pincode: 629703, serviceable: "Yes", tier: "3" },
  { pincode: 629708, serviceable: "Yes", tier: "3" },
  { pincode: 629801, serviceable: "Yes", tier: "3" },
  { pincode: 629802, serviceable: "Yes", tier: "5" },
  { pincode: 629805, serviceable: "Yes", tier: "5" },
  { pincode: 629806, serviceable: "Yes", tier: "3" },
  { pincode: 629807, serviceable: "Yes", tier: "3" },
  { pincode: 629852, serviceable: "Yes", tier: "3" },
  { pincode: 629854, serviceable: "Yes", tier: "3" },
  { pincode: 629901, serviceable: "Yes", tier: "3" },
  { pincode: 629902, serviceable: "Yes", tier: "3" },
  { pincode: 630001, serviceable: "Yes", tier: "2" },
  { pincode: 630002, serviceable: "Yes", tier: "2" },
  { pincode: 630003, serviceable: "Yes", tier: "2" },
  { pincode: 630004, serviceable: "Yes", tier: "2" },
  { pincode: 630005, serviceable: "Yes", tier: "2" },
  { pincode: 630006, serviceable: "Yes", tier: "2" },
  { pincode: 630010, serviceable: "Yes", tier: "2" },
  { pincode: 630101, serviceable: "Yes", tier: "2" },
  { pincode: 630102, serviceable: "Yes", tier: "2" },
  { pincode: 630103, serviceable: "Yes", tier: "2" },
  { pincode: 630104, serviceable: "Yes", tier: "2" },
  { pincode: 630106, serviceable: "Yes", tier: "2" },
  { pincode: 630107, serviceable: "Yes", tier: "2" },
  { pincode: 630108, serviceable: "Yes", tier: "2" },
  { pincode: 630202, serviceable: "Yes", tier: "2" },
  { pincode: 630206, serviceable: "Yes", tier: "2" },
  { pincode: 630207, serviceable: "Yes", tier: "2" },
  { pincode: 630208, serviceable: "Yes", tier: "2" },
  { pincode: 630211, serviceable: "Yes", tier: "2" },
  { pincode: 630214, serviceable: "Yes", tier: "2" },
  { pincode: 630301, serviceable: "Yes", tier: "2" },
  { pincode: 630302, serviceable: "Yes", tier: "2" },
  { pincode: 630303, serviceable: "Yes", tier: "2" },
  { pincode: 630306, serviceable: "Yes", tier: "2" },
  { pincode: 630307, serviceable: "Yes", tier: "2" },
  { pincode: 630311, serviceable: "Yes", tier: "2" },
  { pincode: 630312, serviceable: "Yes", tier: "2" },
  { pincode: 630314, serviceable: "Yes", tier: "2" },
  { pincode: 630317, serviceable: "Yes", tier: "2" },
  { pincode: 630318, serviceable: "Yes", tier: "2" },
  { pincode: 630407, serviceable: "Yes", tier: "2" },
  { pincode: 630409, serviceable: "Yes", tier: "2" },
  { pincode: 630411, serviceable: "Yes", tier: "2" },
  { pincode: 630551, serviceable: "Yes", tier: "2" },
  { pincode: 630552, serviceable: "Yes", tier: "2" },
  { pincode: 630555, serviceable: "Yes", tier: "2" },
  { pincode: 630556, serviceable: "Yes", tier: "2" },
  { pincode: 630557, serviceable: "Yes", tier: "2" },
  { pincode: 630558, serviceable: "Yes", tier: "2" },
  { pincode: 630560, serviceable: "Yes", tier: "2" },
  { pincode: 630561, serviceable: "Yes", tier: "2" },
  { pincode: 630562, serviceable: "Yes", tier: "2" },
  { pincode: 630605, serviceable: "Yes", tier: "2" },
  { pincode: 630606, serviceable: "Yes", tier: "2" },
  { pincode: 630611, serviceable: "Yes", tier: "2" },
  { pincode: 630702, serviceable: "Yes", tier: "2" },
  { pincode: 630709, serviceable: "Yes", tier: "2" },
  { pincode: 631001, serviceable: "Yes", tier: "2" },
  { pincode: 631002, serviceable: "Yes", tier: "2" },
  { pincode: 631003, serviceable: "Yes", tier: "2" },
  { pincode: 631005, serviceable: "Yes", tier: "2" },
  { pincode: 631006, serviceable: "Yes", tier: "2" },
  { pincode: 631051, serviceable: "Yes", tier: "2" },
  { pincode: 631102, serviceable: "Yes", tier: "3" },
  { pincode: 631122, serviceable: "Yes", tier: "1" },
  { pincode: 631151, serviceable: "Yes", tier: "2" },
  { pincode: 631202, serviceable: "Yes", tier: "2" },
  { pincode: 631203, serviceable: "Yes", tier: "2" },
  { pincode: 631207, serviceable: "Yes", tier: "2" },
  { pincode: 631208, serviceable: "Yes", tier: "2" },
  { pincode: 631209, serviceable: "Yes", tier: "2" },
  { pincode: 631301, serviceable: "Yes", tier: "3" },
  { pincode: 631302, serviceable: "Yes", tier: "3" },
  { pincode: 631303, serviceable: "Yes", tier: "3" },
  { pincode: 631402, serviceable: "Yes", tier: "2" },
  { pincode: 631501, serviceable: "Yes", tier: "1" },
  { pincode: 631502, serviceable: "Yes", tier: "1" },
  { pincode: 631503, serviceable: "Yes", tier: "1" },
  { pincode: 631561, serviceable: "Yes", tier: "2" },
  { pincode: 631601, serviceable: "Yes", tier: "2" },
  { pincode: 631604, serviceable: "Yes", tier: "1" },
  { pincode: 631605, serviceable: "Yes", tier: "2" },
  { pincode: 631701, serviceable: "Yes", tier: "2" },
  { pincode: 632001, serviceable: "Yes", tier: "2" },
  { pincode: 632002, serviceable: "Yes", tier: "2" },
  { pincode: 632003, serviceable: "Yes", tier: "2" },
  { pincode: 632004, serviceable: "Yes", tier: "2" },
  { pincode: 632005, serviceable: "Yes", tier: "2" },
  { pincode: 632006, serviceable: "Yes", tier: "2" },
  { pincode: 632007, serviceable: "Yes", tier: "2" },
  { pincode: 632008, serviceable: "Yes", tier: "2" },
  { pincode: 632009, serviceable: "Yes", tier: "2" },
  { pincode: 632010, serviceable: "Yes", tier: "2" },
  { pincode: 632011, serviceable: "Yes", tier: "2" },
  { pincode: 632012, serviceable: "Yes", tier: "2" },
  { pincode: 632013, serviceable: "Yes", tier: "2" },
  { pincode: 632014, serviceable: "Yes", tier: "2" },
  { pincode: 632055, serviceable: "Yes", tier: "2" },
  { pincode: 632057, serviceable: "Yes", tier: "2" },
  { pincode: 632058, serviceable: "Yes", tier: "2" },
  { pincode: 632059, serviceable: "Yes", tier: "2" },
  { pincode: 632101, serviceable: "Yes", tier: "2" },
  { pincode: 632102, serviceable: "Yes", tier: "2" },
  { pincode: 632104, serviceable: "Yes", tier: "2" },
  { pincode: 632105, serviceable: "Yes", tier: "2" },
  { pincode: 632106, serviceable: "Yes", tier: "2" },
  { pincode: 632107, serviceable: "Yes", tier: "3" },
  { pincode: 632113, serviceable: "Yes", tier: "2" },
  { pincode: 632114, serviceable: "Yes", tier: "2" },
  { pincode: 632115, serviceable: "Yes", tier: "2" },
  { pincode: 632116, serviceable: "Yes", tier: "2" },
  { pincode: 632201, serviceable: "Yes", tier: "2" },
  { pincode: 632202, serviceable: "Yes", tier: "2" },
  { pincode: 632203, serviceable: "Yes", tier: "2" },
  { pincode: 632204, serviceable: "Yes", tier: "2" },
  { pincode: 632209, serviceable: "Yes", tier: "3" },
  { pincode: 632301, serviceable: "Yes", tier: "2" },
  { pincode: 632311, serviceable: "Yes", tier: "2" },
  { pincode: 632312, serviceable: "Yes", tier: "2" },
  { pincode: 632314, serviceable: "Yes", tier: "2" },
  { pincode: 632315, serviceable: "Yes", tier: "2" },
  { pincode: 632316, serviceable: "Yes", tier: "2" },
  { pincode: 632317, serviceable: "Yes", tier: "2" },
  { pincode: 632318, serviceable: "Yes", tier: "2" },
  { pincode: 632319, serviceable: "Yes", tier: "2" },
  { pincode: 632320, serviceable: "Yes", tier: "2" },
  { pincode: 632326, serviceable: "Yes", tier: "2" },
  { pincode: 632401, serviceable: "Yes", tier: "2" },
  { pincode: 632402, serviceable: "Yes", tier: "2" },
  { pincode: 632403, serviceable: "Yes", tier: "2" },
  { pincode: 632404, serviceable: "Yes", tier: "2" },
  { pincode: 632405, serviceable: "Yes", tier: "2" },
  { pincode: 632406, serviceable: "Yes", tier: "2" },
  { pincode: 632408, serviceable: "Yes", tier: "2" },
  { pincode: 632416, serviceable: "Yes", tier: "2" },
  { pincode: 632442, serviceable: "Yes", tier: "2" },
  { pincode: 632501, serviceable: "Yes", tier: "2" },
  { pincode: 632503, serviceable: "Yes", tier: "2" },
  { pincode: 632504, serviceable: "Yes", tier: "2" },
  { pincode: 632505, serviceable: "Yes", tier: "3" },
  { pincode: 632506, serviceable: "Yes", tier: "2" },
  { pincode: 632507, serviceable: "Yes", tier: "2" },
  { pincode: 632508, serviceable: "Yes", tier: "2" },
  { pincode: 632509, serviceable: "Yes", tier: "2" },
  { pincode: 632512, serviceable: "Yes", tier: "2" },
  { pincode: 632513, serviceable: "Yes", tier: "2" },
  { pincode: 632514, serviceable: "Yes", tier: "2" },
  { pincode: 632515, serviceable: "Yes", tier: "2" },
  { pincode: 632516, serviceable: "Yes", tier: "2" },
  { pincode: 632517, serviceable: "Yes", tier: "2" },
  { pincode: 632519, serviceable: "Yes", tier: "2" },
  { pincode: 632520, serviceable: "Yes", tier: "2" },
  { pincode: 632521, serviceable: "Yes", tier: "2" },
  { pincode: 632524, serviceable: "Yes", tier: "2" },
  { pincode: 632601, serviceable: "Yes", tier: "3" },
  { pincode: 632602, serviceable: "Yes", tier: "2" },
  { pincode: 632603, serviceable: "Yes", tier: "3" },
  { pincode: 632604, serviceable: "Yes", tier: "3" },
  { pincode: 632605, serviceable: "Yes", tier: "2" },
  { pincode: 635001, serviceable: "Yes", tier: "2" },
  { pincode: 635002, serviceable: "Yes", tier: "2" },
  { pincode: 635101, serviceable: "Yes", tier: "2" },
  { pincode: 635103, serviceable: "Yes", tier: "1" },
  { pincode: 635104, serviceable: "Yes", tier: "2" },
  { pincode: 635108, serviceable: "Yes", tier: "2" },
  { pincode: 635109, serviceable: "Yes", tier: "1" },
  { pincode: 635110, serviceable: "Yes", tier: "1" },
  { pincode: 635111, serviceable: "Yes", tier: "2" },
  { pincode: 635112, serviceable: "Yes", tier: "2" },
  { pincode: 635113, serviceable: "Yes", tier: "2" },
  { pincode: 635114, serviceable: "Yes", tier: "1" },
  { pincode: 635115, serviceable: "Yes", tier: "2" },
  { pincode: 635117, serviceable: "Yes", tier: "2" },
  { pincode: 635119, serviceable: "Yes", tier: "2" },
  { pincode: 635120, serviceable: "Yes", tier: "2" },
  { pincode: 635123, serviceable: "Yes", tier: "2" },
  { pincode: 635124, serviceable: "Yes", tier: "2" },
  { pincode: 635125, serviceable: "Yes", tier: "1" },
  { pincode: 635126, serviceable: "Yes", tier: "1" },
  { pincode: 635201, serviceable: "Yes", tier: "2" },
  { pincode: 635202, serviceable: "Yes", tier: "2" },
  { pincode: 635203, serviceable: "Yes", tier: "2" },
  { pincode: 635204, serviceable: "Yes", tier: "2" },
  { pincode: 635206, serviceable: "Yes", tier: "2" },
  { pincode: 635208, serviceable: "Yes", tier: "2" },
  { pincode: 635301, serviceable: "Yes", tier: "1" },
  { pincode: 635302, serviceable: "Yes", tier: "1" },
  { pincode: 635303, serviceable: "Yes", tier: "1" },
  { pincode: 635304, serviceable: "Yes", tier: "2" },
  { pincode: 635305, serviceable: "Yes", tier: "1" },
  { pincode: 635313, serviceable: "Yes", tier: "1" },
  { pincode: 635601, serviceable: "Yes", tier: "3" },
  { pincode: 635602, serviceable: "Yes", tier: "3" },
  { pincode: 635701, serviceable: "Yes", tier: "3" },
  { pincode: 635702, serviceable: "Yes", tier: "3" },
  { pincode: 635710, serviceable: "Yes", tier: "3" },
  { pincode: 635751, serviceable: "Yes", tier: "2" },
  { pincode: 635752, serviceable: "Yes", tier: "3" },
  { pincode: 635754, serviceable: "Yes", tier: "3" },
  { pincode: 635801, serviceable: "Yes", tier: "3" },
  { pincode: 635802, serviceable: "Yes", tier: "2" },
  { pincode: 635803, serviceable: "Yes", tier: "2" },
  { pincode: 635804, serviceable: "Yes", tier: "3" },
  { pincode: 635805, serviceable: "Yes", tier: "2" },
  { pincode: 635806, serviceable: "Yes", tier: "3" },
  { pincode: 635807, serviceable: "Yes", tier: "3" },
  { pincode: 635808, serviceable: "Yes", tier: "2" },
  { pincode: 635809, serviceable: "Yes", tier: "3" },
  { pincode: 635810, serviceable: "Yes", tier: "2" },
  { pincode: 635811, serviceable: "Yes", tier: "2" },
  { pincode: 635813, serviceable: "Yes", tier: "3" },
  { pincode: 635814, serviceable: "Yes", tier: "2" },
  { pincode: 635815, serviceable: "Yes", tier: "3" },
  { pincode: 635851, serviceable: "Yes", tier: "3" },
  { pincode: 635852, serviceable: "Yes", tier: "3" },
  { pincode: 636001, serviceable: "Yes", tier: "1" },
  { pincode: 636002, serviceable: "Yes", tier: "1" },
  { pincode: 636003, serviceable: "Yes", tier: "1" },
  { pincode: 636004, serviceable: "Yes", tier: "1" },
  { pincode: 636005, serviceable: "Yes", tier: "1" },
  { pincode: 636006, serviceable: "Yes", tier: "1" },
  { pincode: 636007, serviceable: "Yes", tier: "1" },
  { pincode: 636008, serviceable: "Yes", tier: "1" },
  { pincode: 636009, serviceable: "Yes", tier: "1" },
  { pincode: 636010, serviceable: "Yes", tier: "1" },
  { pincode: 636011, serviceable: "Yes", tier: "1" },
  { pincode: 636012, serviceable: "Yes", tier: "1" },
  { pincode: 636013, serviceable: "Yes", tier: "1" },
  { pincode: 636014, serviceable: "Yes", tier: "1" },
  { pincode: 636015, serviceable: "Yes", tier: "1" },
  { pincode: 636016, serviceable: "Yes", tier: "1" },
  { pincode: 636017, serviceable: "Yes", tier: "1" },
  { pincode: 636030, serviceable: "Yes", tier: "1" },
  { pincode: 636101, serviceable: "Yes", tier: "1" },
  { pincode: 636102, serviceable: "Yes", tier: "1" },
  { pincode: 636103, serviceable: "Yes", tier: "1" },
  { pincode: 636104, serviceable: "Yes", tier: "1" },
  { pincode: 636105, serviceable: "Yes", tier: "1" },
  { pincode: 636106, serviceable: "Yes", tier: "1" },
  { pincode: 636107, serviceable: "Yes", tier: "1" },
  { pincode: 636108, serviceable: "Yes", tier: "1" },
  { pincode: 636109, serviceable: "Yes", tier: "1" },
  { pincode: 636110, serviceable: "Yes", tier: "1" },
  { pincode: 636111, serviceable: "Yes", tier: "1" },
  { pincode: 636112, serviceable: "Yes", tier: "1" },
  { pincode: 636113, serviceable: "Yes", tier: "1" },
  { pincode: 636114, serviceable: "Yes", tier: "1" },
  { pincode: 636115, serviceable: "Yes", tier: "1" },
  { pincode: 636116, serviceable: "Yes", tier: "1" },
  { pincode: 636117, serviceable: "Yes", tier: "1" },
  { pincode: 636118, serviceable: "Yes", tier: "1" },
  { pincode: 636119, serviceable: "Yes", tier: "1" },
  { pincode: 636121, serviceable: "Yes", tier: "1" },
  { pincode: 636122, serviceable: "Yes", tier: "1" },
  { pincode: 636124, serviceable: "Yes", tier: "1" },
  { pincode: 636130, serviceable: "Yes", tier: "1" },
  { pincode: 636138, serviceable: "Yes", tier: "1" },
  { pincode: 636139, serviceable: "Yes", tier: "1" },
  { pincode: 636140, serviceable: "Yes", tier: "1" },
  { pincode: 636141, serviceable: "Yes", tier: "1" },
  { pincode: 636142, serviceable: "Yes", tier: "1" },
  { pincode: 636201, serviceable: "Yes", tier: "1" },
  { pincode: 636202, serviceable: "Yes", tier: "1" },
  { pincode: 636203, serviceable: "Yes", tier: "1" },
  { pincode: 636204, serviceable: "Yes", tier: "1" },
  { pincode: 636301, serviceable: "Yes", tier: "1" },
  { pincode: 636302, serviceable: "Yes", tier: "1" },
  { pincode: 636304, serviceable: "Yes", tier: "1" },
  { pincode: 636307, serviceable: "Yes", tier: "1" },
  { pincode: 636308, serviceable: "Yes", tier: "1" },
  { pincode: 636309, serviceable: "Yes", tier: "1" },
  { pincode: 636354, serviceable: "Yes", tier: "1" },
  { pincode: 636400, serviceable: "Yes", tier: "1" },
  { pincode: 636401, serviceable: "Yes", tier: "1" },
  { pincode: 636402, serviceable: "Yes", tier: "1" },
  { pincode: 636403, serviceable: "Yes", tier: "1" },
  { pincode: 636404, serviceable: "Yes", tier: "1" },
  { pincode: 636407, serviceable: "Yes", tier: "1" },
  { pincode: 636453, serviceable: "Yes", tier: "1" },
  { pincode: 636455, serviceable: "Yes", tier: "1" },
  { pincode: 636502, serviceable: "Yes", tier: "1" },
  { pincode: 636601, serviceable: "Yes", tier: "1" },
  { pincode: 636602, serviceable: "Yes", tier: "1" },
  { pincode: 636604, serviceable: "Yes", tier: "1" },
  { pincode: 636701, serviceable: "Yes", tier: "2" },
  { pincode: 636702, serviceable: "Yes", tier: "2" },
  { pincode: 636703, serviceable: "Yes", tier: "2" },
  { pincode: 636704, serviceable: "Yes", tier: "2" },
  { pincode: 636705, serviceable: "Yes", tier: "2" },
  { pincode: 636801, serviceable: "Yes", tier: "2" },
  { pincode: 636802, serviceable: "Yes", tier: "2" },
  { pincode: 636803, serviceable: "Yes", tier: "2" },
  { pincode: 636805, serviceable: "Yes", tier: "2" },
  { pincode: 636806, serviceable: "Yes", tier: "2" },
  { pincode: 636808, serviceable: "Yes", tier: "2" },
  { pincode: 636809, serviceable: "Yes", tier: "2" },
  { pincode: 636810, serviceable: "Yes", tier: "2" },
  { pincode: 636813, serviceable: "Yes", tier: "2" },
  { pincode: 636905, serviceable: "Yes", tier: "1" },
  { pincode: 637001, serviceable: "Yes", tier: "1" },
  { pincode: 637002, serviceable: "Yes", tier: "1" },
  { pincode: 637003, serviceable: "Yes", tier: "1" },
  { pincode: 637013, serviceable: "Yes", tier: "1" },
  { pincode: 637014, serviceable: "Yes", tier: "1" },
  { pincode: 637018, serviceable: "Yes", tier: "1" },
  { pincode: 637101, serviceable: "Yes", tier: "2" },
  { pincode: 637102, serviceable: "Yes", tier: "1" },
  { pincode: 637103, serviceable: "Yes", tier: "1" },
  { pincode: 637104, serviceable: "Yes", tier: "2" },
  { pincode: 637105, serviceable: "Yes", tier: "2" },
  { pincode: 637209, serviceable: "Yes", tier: "2" },
  { pincode: 637211, serviceable: "Yes", tier: "2" },
  { pincode: 637215, serviceable: "Yes", tier: "2" },
  { pincode: 637301, serviceable: "Yes", tier: "2" },
  { pincode: 637302, serviceable: "Yes", tier: "2" },
  { pincode: 637303, serviceable: "Yes", tier: "2" },
  { pincode: 637401, serviceable: "Yes", tier: "1" },
  { pincode: 637402, serviceable: "Yes", tier: "1" },
  { pincode: 637403, serviceable: "Yes", tier: "1" },
  { pincode: 637406, serviceable: "Yes", tier: "1" },
  { pincode: 637407, serviceable: "Yes", tier: "1" },
  { pincode: 637408, serviceable: "Yes", tier: "1" },
  { pincode: 637410, serviceable: "Yes", tier: "1" },
  { pincode: 637411, serviceable: "Yes", tier: "1" },
  { pincode: 637412, serviceable: "Yes", tier: "1" },
  { pincode: 637501, serviceable: "Yes", tier: "1" },
  { pincode: 637502, serviceable: "Yes", tier: "1" },
  { pincode: 637503, serviceable: "Yes", tier: "1" },
  { pincode: 637504, serviceable: "Yes", tier: "1" },
  { pincode: 637505, serviceable: "Yes", tier: "1" },
  { pincode: 638001, serviceable: "Yes", tier: "2" },
  { pincode: 638002, serviceable: "Yes", tier: "2" },
  { pincode: 638003, serviceable: "Yes", tier: "2" },
  { pincode: 638004, serviceable: "Yes", tier: "2" },
  { pincode: 638005, serviceable: "Yes", tier: "2" },
  { pincode: 638006, serviceable: "Yes", tier: "2" },
  { pincode: 638007, serviceable: "Yes", tier: "2" },
  { pincode: 638008, serviceable: "Yes", tier: "2" },
  { pincode: 638009, serviceable: "Yes", tier: "2" },
  { pincode: 638010, serviceable: "Yes", tier: "2" },
  { pincode: 638011, serviceable: "Yes", tier: "2" },
  { pincode: 638012, serviceable: "Yes", tier: "2" },
  { pincode: 638051, serviceable: "Yes", tier: "2" },
  { pincode: 638052, serviceable: "Yes", tier: "2" },
  { pincode: 638053, serviceable: "Yes", tier: "2" },
  { pincode: 638054, serviceable: "Yes", tier: "2" },
  { pincode: 638056, serviceable: "Yes", tier: "2" },
  { pincode: 638058, serviceable: "Yes", tier: "2" },
  { pincode: 638101, serviceable: "Yes", tier: "2" },
  { pincode: 638102, serviceable: "Yes", tier: "2" },
  { pincode: 638103, serviceable: "Yes", tier: "2" },
  { pincode: 638104, serviceable: "Yes", tier: "2" },
  { pincode: 638105, serviceable: "Yes", tier: "2" },
  { pincode: 638106, serviceable: "Yes", tier: "2" },
  { pincode: 638107, serviceable: "Yes", tier: "2" },
  { pincode: 638108, serviceable: "Yes", tier: "2" },
  { pincode: 638111, serviceable: "Yes", tier: "2" },
  { pincode: 638112, serviceable: "Yes", tier: "2" },
  { pincode: 638115, serviceable: "Yes", tier: "2" },
  { pincode: 638153, serviceable: "Yes", tier: "2" },
  { pincode: 638154, serviceable: "Yes", tier: "2" },
  { pincode: 638182, serviceable: "Yes", tier: "2" },
  { pincode: 638183, serviceable: "Yes", tier: "2" },
  { pincode: 638201, serviceable: "Yes", tier: "2" },
  { pincode: 638301, serviceable: "Yes", tier: "2" },
  { pincode: 638302, serviceable: "Yes", tier: "2" },
  { pincode: 638307, serviceable: "Yes", tier: "2" },
  { pincode: 638308, serviceable: "Yes", tier: "2" },
  { pincode: 638311, serviceable: "Yes", tier: "2" },
  { pincode: 638312, serviceable: "Yes", tier: "2" },
  { pincode: 638314, serviceable: "Yes", tier: "2" },
  { pincode: 638315, serviceable: "Yes", tier: "2" },
  { pincode: 638316, serviceable: "Yes", tier: "2" },
  { pincode: 638327, serviceable: "Yes", tier: "2" },
  { pincode: 638401, serviceable: "Yes", tier: "3" },
  { pincode: 638402, serviceable: "Yes", tier: "3" },
  { pincode: 638451, serviceable: "Yes", tier: "3" },
  { pincode: 638452, serviceable: "Yes", tier: "2" },
  { pincode: 638455, serviceable: "Yes", tier: "2" },
  { pincode: 638458, serviceable: "Yes", tier: "2" },
  { pincode: 638476, serviceable: "Yes", tier: "2" },
  { pincode: 638501, serviceable: "Yes", tier: "2" },
  { pincode: 638502, serviceable: "Yes", tier: "2" },
  { pincode: 638503, serviceable: "Yes", tier: "3" },
  { pincode: 638504, serviceable: "Yes", tier: "2" },
  { pincode: 638649, serviceable: "Yes", tier: "2" },
  { pincode: 638653, serviceable: "Yes", tier: "2" },
  { pincode: 638656, serviceable: "Yes", tier: "2" },
  { pincode: 638657, serviceable: "Yes", tier: "2" },
  { pincode: 638660, serviceable: "Yes", tier: "2" },
  { pincode: 638661, serviceable: "Yes", tier: "2" },
  { pincode: 638672, serviceable: "Yes", tier: "2" },
  { pincode: 638673, serviceable: "Yes", tier: "2" },
  { pincode: 638697, serviceable: "Yes", tier: "2" },
  { pincode: 638701, serviceable: "Yes", tier: "2" },
  { pincode: 638702, serviceable: "Yes", tier: "2" },
  { pincode: 638703, serviceable: "Yes", tier: "2" },
  { pincode: 638706, serviceable: "Yes", tier: "2" },
  { pincode: 639001, serviceable: "Yes", tier: "2" },
  { pincode: 639002, serviceable: "Yes", tier: "2" },
  { pincode: 639003, serviceable: "Yes", tier: "2" },
  { pincode: 639004, serviceable: "Yes", tier: "2" },
  { pincode: 639005, serviceable: "Yes", tier: "2" },
  { pincode: 639006, serviceable: "Yes", tier: "2" },
  { pincode: 639007, serviceable: "Yes", tier: "2" },
  { pincode: 639008, serviceable: "Yes", tier: "2" },
  { pincode: 639101, serviceable: "Yes", tier: "3" },
  { pincode: 639103, serviceable: "Yes", tier: "2" },
  { pincode: 639104, serviceable: "Yes", tier: "2" },
  { pincode: 639105, serviceable: "Yes", tier: "2" },
  { pincode: 639107, serviceable: "Yes", tier: "2" },
  { pincode: 639109, serviceable: "Yes", tier: "2" },
  { pincode: 639110, serviceable: "Yes", tier: "2" },
  { pincode: 639111, serviceable: "Yes", tier: "2" },
  { pincode: 639112, serviceable: "Yes", tier: "2" },
  { pincode: 639114, serviceable: "Yes", tier: "2" },
  { pincode: 639117, serviceable: "Yes", tier: "2" },
  { pincode: 639118, serviceable: "Yes", tier: "2" },
  { pincode: 639136, serviceable: "Yes", tier: "2" },
  { pincode: 639201, serviceable: "Yes", tier: "2" },
  { pincode: 639202, serviceable: "Yes", tier: "2" },
  { pincode: 639203, serviceable: "Yes", tier: "2" },
  { pincode: 639204, serviceable: "Yes", tier: "2" },
  { pincode: 639205, serviceable: "Yes", tier: "2" },
  { pincode: 639207, serviceable: "Yes", tier: "2" },
  { pincode: 641001, serviceable: "Yes", tier: "1" },
  { pincode: 641002, serviceable: "Yes", tier: "1" },
  { pincode: 641003, serviceable: "Yes", tier: "1" },
  { pincode: 641004, serviceable: "Yes", tier: "1" },
  { pincode: 641005, serviceable: "Yes", tier: "1" },
  { pincode: 641006, serviceable: "Yes", tier: "1" },
  { pincode: 641007, serviceable: "Yes", tier: "1" },
  { pincode: 641008, serviceable: "Yes", tier: "1" },
  { pincode: 641009, serviceable: "Yes", tier: "1" },
  { pincode: 641010, serviceable: "Yes", tier: "1" },
  { pincode: 641011, serviceable: "Yes", tier: "1" },
  { pincode: 641012, serviceable: "Yes", tier: "1" },
  { pincode: 641013, serviceable: "Yes", tier: "1" },
  { pincode: 641014, serviceable: "Yes", tier: "1" },
  { pincode: 641015, serviceable: "Yes", tier: "1" },
  { pincode: 641016, serviceable: "Yes", tier: "1" },
  { pincode: 641017, serviceable: "Yes", tier: "1" },
  { pincode: 641018, serviceable: "Yes", tier: "1" },
  { pincode: 641019, serviceable: "Yes", tier: "2" },
  { pincode: 641020, serviceable: "Yes", tier: "2" },
  { pincode: 641021, serviceable: "Yes", tier: "1" },
  { pincode: 641022, serviceable: "Yes", tier: "1" },
  { pincode: 641023, serviceable: "Yes", tier: "1" },
  { pincode: 641024, serviceable: "Yes", tier: "1" },
  { pincode: 641025, serviceable: "Yes", tier: "1" },
  { pincode: 641026, serviceable: "Yes", tier: "1" },
  { pincode: 641027, serviceable: "Yes", tier: "1" },
  { pincode: 641028, serviceable: "Yes", tier: "1" },
  { pincode: 641029, serviceable: "Yes", tier: "1" },
  { pincode: 641030, serviceable: "Yes", tier: "1" },
  { pincode: 641031, serviceable: "Yes", tier: "2" },
  { pincode: 641032, serviceable: "Yes", tier: "2" },
  { pincode: 641033, serviceable: "Yes", tier: "1" },
  { pincode: 641034, serviceable: "Yes", tier: "1" },
  { pincode: 641035, serviceable: "Yes", tier: "2" },
  { pincode: 641036, serviceable: "Yes", tier: "1" },
  { pincode: 641037, serviceable: "Yes", tier: "1" },
  { pincode: 641038, serviceable: "Yes", tier: "1" },
  { pincode: 641039, serviceable: "Yes", tier: "1" },
  { pincode: 641040, serviceable: "Yes", tier: "1" },
  { pincode: 641041, serviceable: "Yes", tier: "1" },
  { pincode: 641042, serviceable: "Yes", tier: "1" },
  { pincode: 641043, serviceable: "Yes", tier: "1" },
  { pincode: 641044, serviceable: "Yes", tier: "1" },
  { pincode: 641045, serviceable: "Yes", tier: "1" },
  { pincode: 641046, serviceable: "Yes", tier: "1" },
  { pincode: 641047, serviceable: "Yes", tier: "2" },
  { pincode: 641048, serviceable: "Yes", tier: "1" },
  { pincode: 641049, serviceable: "Yes", tier: "2" },
  { pincode: 641050, serviceable: "Yes", tier: "1" },
  { pincode: 641062, serviceable: "Yes", tier: "1" },
  { pincode: 641065, serviceable: "Yes", tier: "1" },
  { pincode: 641101, serviceable: "Yes", tier: "1" },
  { pincode: 641103, serviceable: "Yes", tier: "1" },
  { pincode: 641104, serviceable: "Yes", tier: "2" },
  { pincode: 641105, serviceable: "Yes", tier: "1" },
  { pincode: 641106, serviceable: "Yes", tier: "2" },
  { pincode: 641107, serviceable: "Yes", tier: "2" },
  { pincode: 641108, serviceable: "Yes", tier: "1" },
  { pincode: 641109, serviceable: "Yes", tier: "1" },
  { pincode: 641110, serviceable: "Yes", tier: "2" },
  { pincode: 641111, serviceable: "Yes", tier: "1" },
  { pincode: 641112, serviceable: "Yes", tier: "1" },
  { pincode: 641113, serviceable: "Yes", tier: "2" },
  { pincode: 641114, serviceable: "Yes", tier: "1" },
  { pincode: 641201, serviceable: "Yes", tier: "2" },
  { pincode: 641202, serviceable: "Yes", tier: "2" },
  { pincode: 641221, serviceable: "Yes", tier: "2" },
  { pincode: 641301, serviceable: "Yes", tier: "2" },
  { pincode: 641305, serviceable: "Yes", tier: "2" },
  { pincode: 641401, serviceable: "Yes", tier: "2" },
  { pincode: 641402, serviceable: "Yes", tier: "2" },
  { pincode: 641404, serviceable: "Yes", tier: "2" },
  { pincode: 641406, serviceable: "Yes", tier: "1" },
  { pincode: 641407, serviceable: "Yes", tier: "1" },
  { pincode: 641601, serviceable: "Yes", tier: "1" },
  { pincode: 641602, serviceable: "Yes", tier: "1" },
  { pincode: 641603, serviceable: "Yes", tier: "1" },
  { pincode: 641604, serviceable: "Yes", tier: "1" },
  { pincode: 641605, serviceable: "Yes", tier: "2" },
  { pincode: 641606, serviceable: "Yes", tier: "1" },
  { pincode: 641607, serviceable: "Yes", tier: "1" },
  { pincode: 641608, serviceable: "Yes", tier: "1" },
  { pincode: 641652, serviceable: "Yes", tier: "1" },
  { pincode: 641653, serviceable: "Yes", tier: "2" },
  { pincode: 641654, serviceable: "Yes", tier: "2" },
  { pincode: 641655, serviceable: "Yes", tier: "2" },
  { pincode: 641659, serviceable: "Yes", tier: "2" },
  { pincode: 641662, serviceable: "Yes", tier: "2" },
  { pincode: 641663, serviceable: "Yes", tier: "2" },
  { pincode: 641664, serviceable: "Yes", tier: "2" },
  { pincode: 641665, serviceable: "Yes", tier: "2" },
  { pincode: 641666, serviceable: "Yes", tier: "1" },
  { pincode: 641667, serviceable: "Yes", tier: "2" },
  { pincode: 641668, serviceable: "Yes", tier: "2" },
  { pincode: 641670, serviceable: "Yes", tier: "2" },
  { pincode: 641671, serviceable: "Yes", tier: "2" },
  { pincode: 641687, serviceable: "Yes", tier: "1" },
  { pincode: 642001, serviceable: "Yes", tier: "2" },
  { pincode: 642002, serviceable: "Yes", tier: "2" },
  { pincode: 642003, serviceable: "Yes", tier: "2" },
  { pincode: 642004, serviceable: "Yes", tier: "2" },
  { pincode: 642005, serviceable: "Yes", tier: "2" },
  { pincode: 642006, serviceable: "Yes", tier: "2" },
  { pincode: 642007, serviceable: "Yes", tier: "2" },
  { pincode: 642054, serviceable: "Yes", tier: "2" },
  { pincode: 642101, serviceable: "Yes", tier: "2" },
  { pincode: 642103, serviceable: "Yes", tier: "2" },
  { pincode: 642104, serviceable: "Yes", tier: "2" },
  { pincode: 642105, serviceable: "Yes", tier: "2" },
  { pincode: 642106, serviceable: "Yes", tier: "2" },
  { pincode: 642107, serviceable: "Yes", tier: "2" },
  { pincode: 642108, serviceable: "Yes", tier: "2" },
  { pincode: 642109, serviceable: "Yes", tier: "2" },
  { pincode: 642110, serviceable: "Yes", tier: "2" },
  { pincode: 642114, serviceable: "Yes", tier: "2" },
  { pincode: 642117, serviceable: "Yes", tier: "2" },
  { pincode: 642120, serviceable: "Yes", tier: "2" },
  { pincode: 642123, serviceable: "Yes", tier: "2" },
  { pincode: 642126, serviceable: "Yes", tier: "2" },
  { pincode: 642127, serviceable: "Yes", tier: "2" },
  { pincode: 642129, serviceable: "Yes", tier: "2" },
  { pincode: 642130, serviceable: "Yes", tier: "2" },
  { pincode: 642133, serviceable: "Yes", tier: "2" },
  { pincode: 642134, serviceable: "Yes", tier: "2" },
  { pincode: 642140, serviceable: "Yes", tier: "2" },
  { pincode: 642142, serviceable: "Yes", tier: "2" },
  { pincode: 642143, serviceable: "Yes", tier: "2" },
  { pincode: 642144, serviceable: "Yes", tier: "2" },
  { pincode: 642145, serviceable: "Yes", tier: "2" },
  { pincode: 642147, serviceable: "Yes", tier: "2" },
  { pincode: 642148, serviceable: "Yes", tier: "2" },
  { pincode: 642149, serviceable: "Yes", tier: "2" },
  { pincode: 642154, serviceable: "Yes", tier: "2" },
  { pincode: 642202, serviceable: "Yes", tier: "2" },
  { pincode: 642207, serviceable: "Yes", tier: "2" },
  { pincode: 643001, serviceable: "Yes", tier: "2" },
  { pincode: 643002, serviceable: "Yes", tier: "2" },
  { pincode: 643003, serviceable: "Yes", tier: "2" },
  { pincode: 643004, serviceable: "Yes", tier: "2" },
  { pincode: 643053, serviceable: "Yes", tier: "2" },
  { pincode: 643054, serviceable: "Yes", tier: "2" },
  { pincode: 643101, serviceable: "Yes", tier: "2" },
  { pincode: 643102, serviceable: "Yes", tier: "2" },
  { pincode: 643103, serviceable: "Yes", tier: "2" },
  { pincode: 643104, serviceable: "Yes", tier: "2" },
  { pincode: 643105, serviceable: "Yes", tier: "2" },
  { pincode: 643106, serviceable: "Yes", tier: "2" },
  { pincode: 643201, serviceable: "Yes", tier: "2" },
  { pincode: 643202, serviceable: "Yes", tier: "2" },
  { pincode: 643204, serviceable: "Yes", tier: "2" },
  { pincode: 643207, serviceable: "Yes", tier: "3" },
  { pincode: 643211, serviceable: "Yes", tier: "3" },
  { pincode: 643212, serviceable: "Yes", tier: "3" },
  { pincode: 643213, serviceable: "Yes", tier: "2" },
  { pincode: 643214, serviceable: "Yes", tier: "2" },
  { pincode: 643216, serviceable: "Yes", tier: "2" },
  { pincode: 643217, serviceable: "Yes", tier: "2" },
  { pincode: 643218, serviceable: "Yes", tier: "2" },
  { pincode: 643231, serviceable: "Yes", tier: "2" },
  { pincode: 643232, serviceable: "Yes", tier: "2" },
  { pincode: 643234, serviceable: "Yes", tier: "2" },
  { pincode: 643242, serviceable: "Yes", tier: "2" },
  { pincode: 643244, serviceable: "Yes", tier: "2" },
  { pincode: 643245, serviceable: "Yes", tier: "2" },
  { pincode: 643249, serviceable: "Yes", tier: "2" },
  { pincode: 643251, serviceable: "Yes", tier: "3" },
  { pincode: 643257, serviceable: "Yes", tier: "2" },
  { pincode: 643260, serviceable: "Yes", tier: "2" },
  { pincode: 643264, serviceable: "Yes", tier: "2" },
  { pincode: 643266, serviceable: "Yes", tier: "2" },
  { pincode: 643267, serviceable: "Yes", tier: "3" },
  { pincode: 643270, serviceable: "Yes", tier: "3" },
  { pincode: 643271, serviceable: "Yes", tier: "2" },
  { pincode: 643277, serviceable: "Yes", tier: "2" },
  { pincode: 643278, serviceable: "Yes", tier: "2" },
  { pincode: 666664, serviceable: "Yes", tier: "1" },
  { pincode: 666666, serviceable: "Yes", tier: "1" },
  { pincode: 666677, serviceable: "Yes", tier: "1" },
  { pincode: 666688, serviceable: "Yes", tier: "1" },
  { pincode: 666699, serviceable: "Yes", tier: "1" },
  { pincode: 666777, serviceable: "Yes", tier: "1" },
  { pincode: 670001, serviceable: "Yes", tier: "2" },
  { pincode: 670002, serviceable: "Yes", tier: "2" },
  { pincode: 670003, serviceable: "Yes", tier: "2" },
  { pincode: 670004, serviceable: "Yes", tier: "2" },
  { pincode: 670005, serviceable: "Yes", tier: "2" },
  { pincode: 670006, serviceable: "Yes", tier: "2" },
  { pincode: 670007, serviceable: "Yes", tier: "2" },
  { pincode: 670008, serviceable: "Yes", tier: "2" },
  { pincode: 670010, serviceable: "Yes", tier: "2" },
  { pincode: 670011, serviceable: "Yes", tier: "2" },
  { pincode: 670012, serviceable: "Yes", tier: "2" },
  { pincode: 670013, serviceable: "Yes", tier: "2" },
  { pincode: 670014, serviceable: "Yes", tier: "2" },
  { pincode: 670015, serviceable: "Yes", tier: "2" },
  { pincode: 670016, serviceable: "Yes", tier: "2" },
  { pincode: 670017, serviceable: "Yes", tier: "2" },
  { pincode: 670018, serviceable: "Yes", tier: "2" },
  { pincode: 670101, serviceable: "Yes", tier: "2" },
  { pincode: 670102, serviceable: "Yes", tier: "2" },
  { pincode: 670104, serviceable: "Yes", tier: "2" },
  { pincode: 670105, serviceable: "Yes", tier: "2" },
  { pincode: 670106, serviceable: "Yes", tier: "2" },
  { pincode: 670141, serviceable: "Yes", tier: "2" },
  { pincode: 670301, serviceable: "Yes", tier: "2" },
  { pincode: 670307, serviceable: "Yes", tier: "2" },
  { pincode: 670501, serviceable: "Yes", tier: "2" },
  { pincode: 670561, serviceable: "Yes", tier: "2" },
  { pincode: 670565, serviceable: "Yes", tier: "2" },
  { pincode: 670566, serviceable: "Yes", tier: "2" },
  { pincode: 670567, serviceable: "Yes", tier: "2" },
  { pincode: 670591, serviceable: "Yes", tier: "2" },
  { pincode: 670592, serviceable: "Yes", tier: "2" },
  { pincode: 670594, serviceable: "Yes", tier: "2" },
  { pincode: 670597, serviceable: "Yes", tier: "2" },
  { pincode: 670642, serviceable: "Yes", tier: "3" },
  { pincode: 670643, serviceable: "Yes", tier: "3" },
  { pincode: 670691, serviceable: "Yes", tier: "3" },
  { pincode: 670694, serviceable: "Yes", tier: "2" },
  { pincode: 670701, serviceable: "Yes", tier: "3" },
  { pincode: 670741, serviceable: "Yes", tier: "3" },
  { pincode: 671121, serviceable: "Yes", tier: "3" },
  { pincode: 671122, serviceable: "Yes", tier: "3" },
  { pincode: 671123, serviceable: "Yes", tier: "3" },
  { pincode: 671315, serviceable: "Yes", tier: "3" },
  { pincode: 671317, serviceable: "Yes", tier: "3" },
  { pincode: 671319, serviceable: "Yes", tier: "3" },
  { pincode: 671531, serviceable: "Yes", tier: "3" },
  { pincode: 673001, serviceable: "Yes", tier: "2" },
  { pincode: 673002, serviceable: "Yes", tier: "2" },
  { pincode: 673003, serviceable: "Yes", tier: "2" },
  { pincode: 673004, serviceable: "Yes", tier: "2" },
  { pincode: 673005, serviceable: "Yes", tier: "2" },
  { pincode: 673006, serviceable: "Yes", tier: "2" },
  { pincode: 673007, serviceable: "Yes", tier: "2" },
  { pincode: 673008, serviceable: "Yes", tier: "2" },
  { pincode: 673009, serviceable: "Yes", tier: "2" },
  { pincode: 673010, serviceable: "Yes", tier: "2" },
  { pincode: 673011, serviceable: "Yes", tier: "2" },
  { pincode: 673012, serviceable: "Yes", tier: "2" },
  { pincode: 673013, serviceable: "Yes", tier: "2" },
  { pincode: 673014, serviceable: "Yes", tier: "2" },
  { pincode: 673015, serviceable: "Yes", tier: "2" },
  { pincode: 673016, serviceable: "Yes", tier: "2" },
  { pincode: 673017, serviceable: "Yes", tier: "2" },
  { pincode: 673018, serviceable: "Yes", tier: "2" },
  { pincode: 673019, serviceable: "Yes", tier: "2" },
  { pincode: 673020, serviceable: "Yes", tier: "2" },
  { pincode: 673021, serviceable: "Yes", tier: "2" },
  { pincode: 673024, serviceable: "Yes", tier: "2" },
  { pincode: 673025, serviceable: "Yes", tier: "2" },
  { pincode: 673026, serviceable: "Yes", tier: "2" },
  { pincode: 673027, serviceable: "Yes", tier: "2" },
  { pincode: 673028, serviceable: "Yes", tier: "2" },
  { pincode: 673029, serviceable: "Yes", tier: "2" },
  { pincode: 673031, serviceable: "Yes", tier: "2" },
  { pincode: 673032, serviceable: "Yes", tier: "2" },
  { pincode: 673037, serviceable: "Yes", tier: "2" },
  { pincode: 673101, serviceable: "Yes", tier: "2" },
  { pincode: 673103, serviceable: "Yes", tier: "2" },
  { pincode: 673104, serviceable: "Yes", tier: "2" },
  { pincode: 673106, serviceable: "Yes", tier: "2" },
  { pincode: 673121, serviceable: "Yes", tier: "3" },
  { pincode: 673122, serviceable: "Yes", tier: "3" },
  { pincode: 673303, serviceable: "Yes", tier: "2" },
  { pincode: 673304, serviceable: "Yes", tier: "2" },
  { pincode: 673305, serviceable: "Yes", tier: "2" },
  { pincode: 673306, serviceable: "Yes", tier: "2" },
  { pincode: 673315, serviceable: "Yes", tier: "2" },
  { pincode: 673317, serviceable: "Yes", tier: "2" },
  { pincode: 673323, serviceable: "Yes", tier: "2" },
  { pincode: 673507, serviceable: "Yes", tier: "2" },
  { pincode: 673508, serviceable: "Yes", tier: "2" },
  { pincode: 673570, serviceable: "Yes", tier: "2" },
  { pincode: 673571, serviceable: "Yes", tier: "2" },
  { pincode: 673573, serviceable: "Yes", tier: "2" },
  { pincode: 673576, serviceable: "Yes", tier: "3" },
  { pincode: 673577, serviceable: "Yes", tier: "3" },
  { pincode: 673585, serviceable: "Yes", tier: "2" },
  { pincode: 673591, serviceable: "Yes", tier: "5" },
  { pincode: 673592, serviceable: "Yes", tier: "5" },
  { pincode: 673593, serviceable: "Yes", tier: "5" },
  { pincode: 673595, serviceable: "Yes", tier: "5" },
  { pincode: 673601, serviceable: "Yes", tier: "2" },
  { pincode: 673602, serviceable: "Yes", tier: "3" },
  { pincode: 673611, serviceable: "Yes", tier: "2" },
  { pincode: 673613, serviceable: "Yes", tier: "2" },
  { pincode: 673614, serviceable: "Yes", tier: "2" },
  { pincode: 673616, serviceable: "Yes", tier: "2" },
  { pincode: 673620, serviceable: "Yes", tier: "2" },
  { pincode: 673632, serviceable: "Yes", tier: "2" },
  { pincode: 673633, serviceable: "Yes", tier: "2" },
  { pincode: 673634, serviceable: "Yes", tier: "2" },
  { pincode: 673635, serviceable: "Yes", tier: "2" },
  { pincode: 673639, serviceable: "Yes", tier: "3" },
  { pincode: 673640, serviceable: "Yes", tier: "3" },
  { pincode: 673641, serviceable: "Yes", tier: "3" },
  { pincode: 673645, serviceable: "Yes", tier: "3" },
  { pincode: 676101, serviceable: "Yes", tier: "2" },
  { pincode: 676102, serviceable: "Yes", tier: "2" },
  { pincode: 676103, serviceable: "Yes", tier: "2" },
  { pincode: 676104, serviceable: "Yes", tier: "2" },
  { pincode: 676105, serviceable: "Yes", tier: "2" },
  { pincode: 676107, serviceable: "Yes", tier: "2" },
  { pincode: 676108, serviceable: "Yes", tier: "2" },
  { pincode: 676109, serviceable: "Yes", tier: "2" },
  { pincode: 676121, serviceable: "Yes", tier: "3" },
  { pincode: 676301, serviceable: "Yes", tier: "3" },
  { pincode: 676502, serviceable: "Yes", tier: "2" },
  { pincode: 676503, serviceable: "Yes", tier: "2" },
  { pincode: 676505, serviceable: "Yes", tier: "3" },
  { pincode: 676519, serviceable: "Yes", tier: "3" },
  { pincode: 676541, serviceable: "Yes", tier: "3" },
  { pincode: 676551, serviceable: "Yes", tier: "3" },
  { pincode: 676552, serviceable: "Yes", tier: "3" },
  { pincode: 676561, serviceable: "Yes", tier: "2" },
  { pincode: 676562, serviceable: "Yes", tier: "2" },
  { pincode: 678001, serviceable: "Yes", tier: "2" },
  { pincode: 678002, serviceable: "Yes", tier: "2" },
  { pincode: 678003, serviceable: "Yes", tier: "2" },
  { pincode: 678004, serviceable: "Yes", tier: "2" },
  { pincode: 678005, serviceable: "Yes", tier: "2" },
  { pincode: 678006, serviceable: "Yes", tier: "2" },
  { pincode: 678007, serviceable: "Yes", tier: "2" },
  { pincode: 678008, serviceable: "Yes", tier: "2" },
  { pincode: 678009, serviceable: "Yes", tier: "2" },
  { pincode: 678010, serviceable: "Yes", tier: "2" },
  { pincode: 678011, serviceable: "Yes", tier: "2" },
  { pincode: 678012, serviceable: "Yes", tier: "2" },
  { pincode: 678013, serviceable: "Yes", tier: "2" },
  { pincode: 678014, serviceable: "Yes", tier: "2" },
  { pincode: 678015, serviceable: "Yes", tier: "2" },
  { pincode: 678017, serviceable: "Yes", tier: "2" },
  { pincode: 678018, serviceable: "Yes", tier: "2" },
  { pincode: 678019, serviceable: "Yes", tier: "2" },
  { pincode: 678020, serviceable: "Yes", tier: "2" },
  { pincode: 678101, serviceable: "Yes", tier: "3" },
  { pincode: 678102, serviceable: "Yes", tier: "3" },
  { pincode: 678103, serviceable: "Yes", tier: "3" },
  { pincode: 678104, serviceable: "Yes", tier: "3" },
  { pincode: 678501, serviceable: "Yes", tier: "3" },
  { pincode: 678503, serviceable: "Yes", tier: "3" },
  { pincode: 678504, serviceable: "Yes", tier: "3" },
  { pincode: 678506, serviceable: "Yes", tier: "3" },
  { pincode: 678531, serviceable: "Yes", tier: "3" },
  { pincode: 678532, serviceable: "Yes", tier: "3" },
  { pincode: 678541, serviceable: "Yes", tier: "3" },
  { pincode: 678542, serviceable: "Yes", tier: "3" },
  { pincode: 678543, serviceable: "Yes", tier: "3" },
  { pincode: 678545, serviceable: "Yes", tier: "3" },
  { pincode: 678546, serviceable: "Yes", tier: "3" },
  { pincode: 678551, serviceable: "Yes", tier: "2" },
  { pincode: 678552, serviceable: "Yes", tier: "3" },
  { pincode: 678553, serviceable: "Yes", tier: "3" },
  { pincode: 678554, serviceable: "Yes", tier: "3" },
  { pincode: 678557, serviceable: "Yes", tier: "2" },
  { pincode: 678559, serviceable: "Yes", tier: "2" },
  { pincode: 678582, serviceable: "Yes", tier: "3" },
  { pincode: 678583, serviceable: "Yes", tier: "3" },
  { pincode: 678593, serviceable: "Yes", tier: "3" },
  { pincode: 678595, serviceable: "Yes", tier: "3" },
  { pincode: 678596, serviceable: "Yes", tier: "3" },
  { pincode: 678597, serviceable: "Yes", tier: "3" },
  { pincode: 678598, serviceable: "Yes", tier: "3" },
  { pincode: 678613, serviceable: "Yes", tier: "3" },
  { pincode: 678621, serviceable: "Yes", tier: "2" },
  { pincode: 678623, serviceable: "Yes", tier: "2" },
  { pincode: 678633, serviceable: "Yes", tier: "3" },
  { pincode: 678642, serviceable: "Yes", tier: "3" },
  { pincode: 678681, serviceable: "Yes", tier: "3" },
  { pincode: 678701, serviceable: "Yes", tier: "2" },
  { pincode: 678731, serviceable: "Yes", tier: "2" },
  { pincode: 678762, serviceable: "Yes", tier: "3" },
  { pincode: 679101, serviceable: "Yes", tier: "3" },
  { pincode: 679102, serviceable: "Yes", tier: "3" },
  { pincode: 679103, serviceable: "Yes", tier: "3" },
  { pincode: 679104, serviceable: "Yes", tier: "3" },
  { pincode: 679105, serviceable: "Yes", tier: "3" },
  { pincode: 679106, serviceable: "Yes", tier: "3" },
  { pincode: 679121, serviceable: "Yes", tier: "3" },
  { pincode: 679122, serviceable: "Yes", tier: "3" },
  { pincode: 679123, serviceable: "Yes", tier: "3" },
  { pincode: 679301, serviceable: "Yes", tier: "3" },
  { pincode: 679302, serviceable: "Yes", tier: "3" },
  { pincode: 679304, serviceable: "Yes", tier: "3" },
  { pincode: 679306, serviceable: "Yes", tier: "3" },
  { pincode: 679308, serviceable: "Yes", tier: "3" },
  { pincode: 679313, serviceable: "Yes", tier: "3" },
  { pincode: 679321, serviceable: "Yes", tier: "2" },
  { pincode: 679322, serviceable: "Yes", tier: "2" },
  { pincode: 679328, serviceable: "Yes", tier: "3" },
  { pincode: 679329, serviceable: "Yes", tier: "3" },
  { pincode: 679335, serviceable: "Yes", tier: "3" },
  { pincode: 679340, serviceable: "Yes", tier: "2" },
  { pincode: 679357, serviceable: "Yes", tier: "2" },
  { pincode: 679501, serviceable: "Yes", tier: "3" },
  { pincode: 679502, serviceable: "Yes", tier: "3" },
  { pincode: 679503, serviceable: "Yes", tier: "3" },
  { pincode: 679504, serviceable: "Yes", tier: "3" },
  { pincode: 679505, serviceable: "Yes", tier: "3" },
  { pincode: 679506, serviceable: "Yes", tier: "3" },
  { pincode: 679511, serviceable: "Yes", tier: "3" },
  { pincode: 679512, serviceable: "Yes", tier: "3" },
  { pincode: 679513, serviceable: "Yes", tier: "3" },
  { pincode: 679514, serviceable: "Yes", tier: "3" },
  { pincode: 679515, serviceable: "Yes", tier: "3" },
  { pincode: 679516, serviceable: "Yes", tier: "3" },
  { pincode: 679521, serviceable: "Yes", tier: "3" },
  { pincode: 679522, serviceable: "Yes", tier: "3" },
  { pincode: 679523, serviceable: "Yes", tier: "3" },
  { pincode: 679531, serviceable: "Yes", tier: "3" },
  { pincode: 679551, serviceable: "Yes", tier: "3" },
  { pincode: 679552, serviceable: "Yes", tier: "3" },
  { pincode: 679553, serviceable: "Yes", tier: "3" },
  { pincode: 679554, serviceable: "Yes", tier: "3" },
  { pincode: 679564, serviceable: "Yes", tier: "3" },
  { pincode: 679571, serviceable: "Yes", tier: "3" },
  { pincode: 679572, serviceable: "Yes", tier: "3" },
  { pincode: 679574, serviceable: "Yes", tier: "3" },
  { pincode: 679576, serviceable: "Yes", tier: "3" },
  { pincode: 679577, serviceable: "Yes", tier: "3" },
  { pincode: 679578, serviceable: "Yes", tier: "3" },
  { pincode: 679582, serviceable: "Yes", tier: "3" },
  { pincode: 679583, serviceable: "Yes", tier: "3" },
  { pincode: 679585, serviceable: "Yes", tier: "3" },
  { pincode: 679586, serviceable: "Yes", tier: "3" },
  { pincode: 680001, serviceable: "Yes", tier: "2" },
  { pincode: 680002, serviceable: "Yes", tier: "2" },
  { pincode: 680003, serviceable: "Yes", tier: "2" },
  { pincode: 680004, serviceable: "Yes", tier: "2" },
  { pincode: 680005, serviceable: "Yes", tier: "2" },
  { pincode: 680006, serviceable: "Yes", tier: "2" },
  { pincode: 680007, serviceable: "Yes", tier: "3" },
  { pincode: 680008, serviceable: "Yes", tier: "2" },
  { pincode: 680009, serviceable: "Yes", tier: "2" },
  { pincode: 680010, serviceable: "Yes", tier: "2" },
  { pincode: 680011, serviceable: "Yes", tier: "2" },
  { pincode: 680012, serviceable: "Yes", tier: "2" },
  { pincode: 680013, serviceable: "Yes", tier: "3" },
  { pincode: 680014, serviceable: "Yes", tier: "3" },
  { pincode: 680015, serviceable: "Yes", tier: "3" },
  { pincode: 680018, serviceable: "Yes", tier: "2" },
  { pincode: 680020, serviceable: "Yes", tier: "2" },
  { pincode: 680021, serviceable: "Yes", tier: "2" },
  { pincode: 680022, serviceable: "Yes", tier: "2" },
  { pincode: 680026, serviceable: "Yes", tier: "3" },
  { pincode: 680027, serviceable: "Yes", tier: "3" },
  { pincode: 680101, serviceable: "Yes", tier: "3" },
  { pincode: 680121, serviceable: "Yes", tier: "3" },
  { pincode: 680125, serviceable: "Yes", tier: "3" },
  { pincode: 680301, serviceable: "Yes", tier: "2" },
  { pincode: 680302, serviceable: "Yes", tier: "2" },
  { pincode: 680303, serviceable: "Yes", tier: "2" },
  { pincode: 680305, serviceable: "Yes", tier: "2" },
  { pincode: 680306, serviceable: "Yes", tier: "2" },
  { pincode: 680307, serviceable: "Yes", tier: "2" },
  { pincode: 680308, serviceable: "Yes", tier: "2" },
  { pincode: 680309, serviceable: "Yes", tier: "2" },
  { pincode: 680310, serviceable: "Yes", tier: "3" },
  { pincode: 680311, serviceable: "Yes", tier: "2" },
  { pincode: 680313, serviceable: "Yes", tier: "2" },
  { pincode: 680314, serviceable: "Yes", tier: "2" },
  { pincode: 680322, serviceable: "Yes", tier: "2" },
  { pincode: 680501, serviceable: "Yes", tier: "3" },
  { pincode: 680506, serviceable: "Yes", tier: "3" },
  { pincode: 680507, serviceable: "Yes", tier: "3" },
  { pincode: 680516, serviceable: "Yes", tier: "3" },
  { pincode: 680518, serviceable: "Yes", tier: "3" },
  { pincode: 680522, serviceable: "Yes", tier: "3" },
  { pincode: 680541, serviceable: "Yes", tier: "3" },
  { pincode: 680545, serviceable: "Yes", tier: "3" },
  { pincode: 680546, serviceable: "Yes", tier: "3" },
  { pincode: 680551, serviceable: "Yes", tier: "3" },
  { pincode: 680552, serviceable: "Yes", tier: "3" },
  { pincode: 680553, serviceable: "Yes", tier: "2" },
  { pincode: 680555, serviceable: "Yes", tier: "3" },
  { pincode: 680562, serviceable: "Yes", tier: "3" },
  { pincode: 680563, serviceable: "Yes", tier: "3" },
  { pincode: 680566, serviceable: "Yes", tier: "3" },
  { pincode: 680567, serviceable: "Yes", tier: "3" },
  { pincode: 680568, serviceable: "Yes", tier: "3" },
  { pincode: 680569, serviceable: "Yes", tier: "3" },
  { pincode: 680581, serviceable: "Yes", tier: "3" },
  { pincode: 680588, serviceable: "Yes", tier: "3" },
  { pincode: 680594, serviceable: "Yes", tier: "3" },
  { pincode: 680611, serviceable: "Yes", tier: "2" },
  { pincode: 680618, serviceable: "Yes", tier: "2" },
  { pincode: 680620, serviceable: "Yes", tier: "2" },
  { pincode: 680631, serviceable: "Yes", tier: "2" },
  { pincode: 680641, serviceable: "Yes", tier: "3" },
  { pincode: 680663, serviceable: "Yes", tier: "2" },
  { pincode: 680664, serviceable: "Yes", tier: "2" },
  { pincode: 680666, serviceable: "Yes", tier: "2" },
  { pincode: 680667, serviceable: "Yes", tier: "2" },
  { pincode: 680669, serviceable: "Yes", tier: "2" },
  { pincode: 680670, serviceable: "Yes", tier: "2" },
  { pincode: 680671, serviceable: "Yes", tier: "2" },
  { pincode: 680682, serviceable: "Yes", tier: "2" },
  { pincode: 680683, serviceable: "Yes", tier: "2" },
  { pincode: 680689, serviceable: "Yes", tier: "2" },
  { pincode: 680697, serviceable: "Yes", tier: "2" },
  { pincode: 680699, serviceable: "Yes", tier: "2" },
  { pincode: 680711, serviceable: "Yes", tier: "3" },
  { pincode: 680712, serviceable: "Yes", tier: "3" },
  { pincode: 680731, serviceable: "Yes", tier: "2" },
  { pincode: 680732, serviceable: "Yes", tier: "2" },
  { pincode: 680733, serviceable: "Yes", tier: "2" },
  { pincode: 680734, serviceable: "Yes", tier: "2" },
  { pincode: 680741, serviceable: "Yes", tier: "2" },
  { pincode: 682000, serviceable: "Yes", tier: "2" },
  { pincode: 682001, serviceable: "Yes", tier: "2" },
  { pincode: 682002, serviceable: "Yes", tier: "2" },
  { pincode: 682003, serviceable: "Yes", tier: "2" },
  { pincode: 682005, serviceable: "Yes", tier: "2" },
  { pincode: 682006, serviceable: "Yes", tier: "2" },
  { pincode: 682007, serviceable: "Yes", tier: "2" },
  { pincode: 682008, serviceable: "Yes", tier: "2" },
  { pincode: 682009, serviceable: "Yes", tier: "2" },
  { pincode: 682010, serviceable: "Yes", tier: "2" },
  { pincode: 682011, serviceable: "Yes", tier: "2" },
  { pincode: 682012, serviceable: "Yes", tier: "2" },
  { pincode: 682013, serviceable: "Yes", tier: "2" },
  { pincode: 682014, serviceable: "Yes", tier: "2" },
  { pincode: 682015, serviceable: "Yes", tier: "2" },
  { pincode: 682016, serviceable: "Yes", tier: "2" },
  { pincode: 682017, serviceable: "Yes", tier: "2" },
  { pincode: 682018, serviceable: "Yes", tier: "2" },
  { pincode: 682019, serviceable: "Yes", tier: "2" },
  { pincode: 682020, serviceable: "Yes", tier: "2" },
  { pincode: 682021, serviceable: "Yes", tier: "2" },
  { pincode: 682022, serviceable: "Yes", tier: "2" },
  { pincode: 682023, serviceable: "Yes", tier: "2" },
  { pincode: 682024, serviceable: "Yes", tier: "2" },
  { pincode: 682025, serviceable: "Yes", tier: "2" },
  { pincode: 682026, serviceable: "Yes", tier: "2" },
  { pincode: 682027, serviceable: "Yes", tier: "2" },
  { pincode: 682028, serviceable: "Yes", tier: "2" },
  { pincode: 682029, serviceable: "Yes", tier: "2" },
  { pincode: 682030, serviceable: "Yes", tier: "2" },
  { pincode: 682031, serviceable: "Yes", tier: "2" },
  { pincode: 682032, serviceable: "Yes", tier: "2" },
  { pincode: 682033, serviceable: "Yes", tier: "2" },
  { pincode: 682034, serviceable: "Yes", tier: "2" },
  { pincode: 682035, serviceable: "Yes", tier: "2" },
  { pincode: 682036, serviceable: "Yes", tier: "2" },
  { pincode: 682037, serviceable: "Yes", tier: "2" },
  { pincode: 682038, serviceable: "Yes", tier: "3" },
  { pincode: 682039, serviceable: "Yes", tier: "2" },
  { pincode: 682040, serviceable: "Yes", tier: "2" },
  { pincode: 682041, serviceable: "Yes", tier: "2" },
  { pincode: 682042, serviceable: "Yes", tier: "2" },
  { pincode: 682222, serviceable: "Yes", tier: "2" },
  { pincode: 682301, serviceable: "Yes", tier: "2" },
  { pincode: 682302, serviceable: "Yes", tier: "2" },
  { pincode: 682303, serviceable: "Yes", tier: "2" },
  { pincode: 682304, serviceable: "Yes", tier: "3" },
  { pincode: 682305, serviceable: "Yes", tier: "2" },
  { pincode: 682306, serviceable: "Yes", tier: "2" },
  { pincode: 682307, serviceable: "Yes", tier: "2" },
  { pincode: 682308, serviceable: "Yes", tier: "2" },
  { pincode: 682309, serviceable: "Yes", tier: "2" },
  { pincode: 682310, serviceable: "Yes", tier: "2" },
  { pincode: 682311, serviceable: "Yes", tier: "2" },
  { pincode: 682312, serviceable: "Yes", tier: "2" },
  { pincode: 682313, serviceable: "Yes", tier: "2" },
  { pincode: 682314, serviceable: "Yes", tier: "2" },
  { pincode: 682315, serviceable: "Yes", tier: "2" },
  { pincode: 682316, serviceable: "Yes", tier: "3" },
  { pincode: 682319, serviceable: "Yes", tier: "2" },
  { pincode: 682501, serviceable: "Yes", tier: "2" },
  { pincode: 682502, serviceable: "Yes", tier: "2" },
  { pincode: 682503, serviceable: "Yes", tier: "2" },
  { pincode: 682504, serviceable: "Yes", tier: "2" },
  { pincode: 682505, serviceable: "Yes", tier: "2" },
  { pincode: 682506, serviceable: "Yes", tier: "2" },
  { pincode: 682507, serviceable: "Yes", tier: "2" },
  { pincode: 682508, serviceable: "Yes", tier: "2" },
  { pincode: 682509, serviceable: "Yes", tier: "2" },
  { pincode: 682511, serviceable: "Yes", tier: "2" },
  { pincode: 683101, serviceable: "Yes", tier: "2" },
  { pincode: 683102, serviceable: "Yes", tier: "2" },
  { pincode: 683103, serviceable: "Yes", tier: "2" },
  { pincode: 683104, serviceable: "Yes", tier: "2" },
  { pincode: 683105, serviceable: "Yes", tier: "2" },
  { pincode: 683106, serviceable: "Yes", tier: "2" },
  { pincode: 683108, serviceable: "Yes", tier: "2" },
  { pincode: 683109, serviceable: "Yes", tier: "2" },
  { pincode: 683110, serviceable: "Yes", tier: "2" },
  { pincode: 683111, serviceable: "Yes", tier: "2" },
  { pincode: 683112, serviceable: "Yes", tier: "2" },
  { pincode: 683501, serviceable: "Yes", tier: "2" },
  { pincode: 683502, serviceable: "Yes", tier: "2" },
  { pincode: 683511, serviceable: "Yes", tier: "2" },
  { pincode: 683512, serviceable: "Yes", tier: "2" },
  { pincode: 683513, serviceable: "Yes", tier: "2" },
  { pincode: 683517, serviceable: "Yes", tier: "2" },
  { pincode: 683518, serviceable: "Yes", tier: "2" },
  { pincode: 683519, serviceable: "Yes", tier: "2" },
  { pincode: 683520, serviceable: "Yes", tier: "2" },
  { pincode: 683541, serviceable: "Yes", tier: "2" },
  { pincode: 683542, serviceable: "Yes", tier: "2" },
  { pincode: 683543, serviceable: "Yes", tier: "2" },
  { pincode: 683544, serviceable: "Yes", tier: "2" },
  { pincode: 683556, serviceable: "Yes", tier: "2" },
  { pincode: 683561, serviceable: "Yes", tier: "2" },
  { pincode: 683562, serviceable: "Yes", tier: "2" },
  { pincode: 683563, serviceable: "Yes", tier: "2" },
  { pincode: 683564, serviceable: "Yes", tier: "2" },
  { pincode: 683572, serviceable: "Yes", tier: "2" },
  { pincode: 683573, serviceable: "Yes", tier: "2" },
  { pincode: 683574, serviceable: "Yes", tier: "2" },
  { pincode: 683576, serviceable: "Yes", tier: "2" },
  { pincode: 683577, serviceable: "Yes", tier: "2" },
  { pincode: 683578, serviceable: "Yes", tier: "2" },
  { pincode: 683579, serviceable: "Yes", tier: "2" },
  { pincode: 683582, serviceable: "Yes", tier: "2" },
  { pincode: 683584, serviceable: "Yes", tier: "2" },
  { pincode: 683585, serviceable: "Yes", tier: "2" },
  { pincode: 683586, serviceable: "Yes", tier: "2" },
  { pincode: 683587, serviceable: "Yes", tier: "2" },
  { pincode: 683589, serviceable: "Yes", tier: "2" },
  { pincode: 683591, serviceable: "Yes", tier: "2" },
  { pincode: 683592, serviceable: "Yes", tier: "2" },
  { pincode: 683594, serviceable: "Yes", tier: "2" },
  { pincode: 685584, serviceable: "Yes", tier: "3" },
  { pincode: 685585, serviceable: "Yes", tier: "3" },
  { pincode: 685587, serviceable: "Yes", tier: "3" },
  { pincode: 685605, serviceable: "Yes", tier: "3" },
  { pincode: 685608, serviceable: "Yes", tier: "3" },
  { pincode: 686001, serviceable: "Yes", tier: "2" },
  { pincode: 686002, serviceable: "Yes", tier: "2" },
  { pincode: 686003, serviceable: "Yes", tier: "2" },
  { pincode: 686004, serviceable: "Yes", tier: "2" },
  { pincode: 686005, serviceable: "Yes", tier: "2" },
  { pincode: 686006, serviceable: "Yes", tier: "2" },
  { pincode: 686007, serviceable: "Yes", tier: "2" },
  { pincode: 686008, serviceable: "Yes", tier: "2" },
  { pincode: 686009, serviceable: "Yes", tier: "2" },
  { pincode: 686010, serviceable: "Yes", tier: "2" },
  { pincode: 686011, serviceable: "Yes", tier: "2" },
  { pincode: 686012, serviceable: "Yes", tier: "2" },
  { pincode: 686013, serviceable: "Yes", tier: "2" },
  { pincode: 686014, serviceable: "Yes", tier: "2" },
  { pincode: 686015, serviceable: "Yes", tier: "2" },
  { pincode: 686016, serviceable: "Yes", tier: "2" },
  { pincode: 686017, serviceable: "Yes", tier: "2" },
  { pincode: 686018, serviceable: "Yes", tier: "2" },
  { pincode: 686019, serviceable: "Yes", tier: "2" },
  { pincode: 686020, serviceable: "Yes", tier: "2" },
  { pincode: 686021, serviceable: "Yes", tier: "3" },
  { pincode: 686022, serviceable: "Yes", tier: "2" },
  { pincode: 686023, serviceable: "Yes", tier: "2" },
  { pincode: 686024, serviceable: "Yes", tier: "2" },
  { pincode: 686025, serviceable: "Yes", tier: "2" },
  { pincode: 686026, serviceable: "Yes", tier: "2" },
  { pincode: 686029, serviceable: "Yes", tier: "2" },
  { pincode: 686030, serviceable: "Yes", tier: "2" },
  { pincode: 686032, serviceable: "Yes", tier: "2" },
  { pincode: 686033, serviceable: "Yes", tier: "2" },
  { pincode: 686035, serviceable: "Yes", tier: "2" },
  { pincode: 686036, serviceable: "Yes", tier: "2" },
  { pincode: 686037, serviceable: "Yes", tier: "2" },
  { pincode: 686038, serviceable: "Yes", tier: "2" },
  { pincode: 686039, serviceable: "Yes", tier: "2" },
  { pincode: 686041, serviceable: "Yes", tier: "2" },
  { pincode: 686101, serviceable: "Yes", tier: "3" },
  { pincode: 686102, serviceable: "Yes", tier: "3" },
  { pincode: 686103, serviceable: "Yes", tier: "3" },
  { pincode: 686104, serviceable: "Yes", tier: "3" },
  { pincode: 686105, serviceable: "Yes", tier: "3" },
  { pincode: 686106, serviceable: "Yes", tier: "3" },
  { pincode: 686107, serviceable: "Yes", tier: "3" },
  { pincode: 686121, serviceable: "Yes", tier: "2" },
  { pincode: 686141, serviceable: "Yes", tier: "3" },
  { pincode: 686501, serviceable: "Yes", tier: "2" },
  { pincode: 686503, serviceable: "Yes", tier: "2" },
  { pincode: 686504, serviceable: "Yes", tier: "2" },
  { pincode: 686505, serviceable: "Yes", tier: "2" },
  { pincode: 686506, serviceable: "Yes", tier: "2" },
  { pincode: 686507, serviceable: "Yes", tier: "2" },
  { pincode: 686508, serviceable: "Yes", tier: "2" },
  { pincode: 686509, serviceable: "Yes", tier: "2" },
  { pincode: 686512, serviceable: "Yes", tier: "2" },
  { pincode: 686515, serviceable: "Yes", tier: "2" },
  { pincode: 686517, serviceable: "Yes", tier: "2" },
  { pincode: 686518, serviceable: "Yes", tier: "2" },
  { pincode: 686519, serviceable: "Yes", tier: "2" },
  { pincode: 686521, serviceable: "Yes", tier: "3" },
  { pincode: 686522, serviceable: "Yes", tier: "2" },
  { pincode: 686531, serviceable: "Yes", tier: "2" },
  { pincode: 686536, serviceable: "Yes", tier: "3" },
  { pincode: 686539, serviceable: "Yes", tier: "3" },
  { pincode: 686540, serviceable: "Yes", tier: "3" },
  { pincode: 686541, serviceable: "Yes", tier: "3" },
  { pincode: 686542, serviceable: "Yes", tier: "3" },
  { pincode: 686545, serviceable: "Yes", tier: "3" },
  { pincode: 686546, serviceable: "Yes", tier: "3" },
  { pincode: 686552, serviceable: "Yes", tier: "2" },
  { pincode: 686560, serviceable: "Yes", tier: "2" },
  { pincode: 686561, serviceable: "Yes", tier: "2" },
  { pincode: 686562, serviceable: "Yes", tier: "3" },
  { pincode: 686572, serviceable: "Yes", tier: "3" },
  { pincode: 686573, serviceable: "Yes", tier: "2" },
  { pincode: 686574, serviceable: "Yes", tier: "2" },
  { pincode: 686575, serviceable: "Yes", tier: "2" },
  { pincode: 686576, serviceable: "Yes", tier: "2" },
  { pincode: 686578, serviceable: "Yes", tier: "2" },
  { pincode: 686583, serviceable: "Yes", tier: "3" },
  { pincode: 686585, serviceable: "Yes", tier: "2" },
  { pincode: 686587, serviceable: "Yes", tier: "3" },
  { pincode: 686601, serviceable: "Yes", tier: "3" },
  { pincode: 686602, serviceable: "Yes", tier: "3" },
  { pincode: 686603, serviceable: "Yes", tier: "3" },
  { pincode: 686604, serviceable: "Yes", tier: "3" },
  { pincode: 686605, serviceable: "Yes", tier: "3" },
  { pincode: 686609, serviceable: "Yes", tier: "3" },
  { pincode: 686610, serviceable: "Yes", tier: "3" },
  { pincode: 686611, serviceable: "Yes", tier: "3" },
  { pincode: 686612, serviceable: "Yes", tier: "3" },
  { pincode: 686613, serviceable: "Yes", tier: "3" },
  { pincode: 686616, serviceable: "Yes", tier: "3" },
  { pincode: 686619, serviceable: "Yes", tier: "2" },
  { pincode: 686630, serviceable: "Yes", tier: "3" },
  { pincode: 686631, serviceable: "Yes", tier: "3" },
  { pincode: 686632, serviceable: "Yes", tier: "3" },
  { pincode: 686633, serviceable: "Yes", tier: "3" },
  { pincode: 686634, serviceable: "Yes", tier: "2" },
  { pincode: 686636, serviceable: "Yes", tier: "2" },
  { pincode: 686637, serviceable: "Yes", tier: "3" },
  { pincode: 686661, serviceable: "Yes", tier: "3" },
  { pincode: 686662, serviceable: "Yes", tier: "2" },
  { pincode: 686663, serviceable: "Yes", tier: "2" },
  { pincode: 686664, serviceable: "Yes", tier: "2" },
  { pincode: 686665, serviceable: "Yes", tier: "2" },
  { pincode: 686666, serviceable: "Yes", tier: "3" },
  { pincode: 686667, serviceable: "Yes", tier: "2" },
  { pincode: 686669, serviceable: "Yes", tier: "3" },
  { pincode: 686674, serviceable: "Yes", tier: "3" },
  { pincode: 686676, serviceable: "Yes", tier: "3" },
  { pincode: 686677, serviceable: "Yes", tier: "3" },
  { pincode: 686680, serviceable: "Yes", tier: "2" },
  { pincode: 686689, serviceable: "Yes", tier: "3" },
  { pincode: 688001, serviceable: "Yes", tier: "2" },
  { pincode: 688002, serviceable: "Yes", tier: "2" },
  { pincode: 688003, serviceable: "Yes", tier: "2" },
  { pincode: 688004, serviceable: "Yes", tier: "2" },
  { pincode: 688005, serviceable: "Yes", tier: "2" },
  { pincode: 688006, serviceable: "Yes", tier: "2" },
  { pincode: 688007, serviceable: "Yes", tier: "2" },
  { pincode: 688008, serviceable: "Yes", tier: "2" },
  { pincode: 688009, serviceable: "Yes", tier: "2" },
  { pincode: 688010, serviceable: "Yes", tier: "2" },
  { pincode: 688011, serviceable: "Yes", tier: "2" },
  { pincode: 688012, serviceable: "Yes", tier: "2" },
  { pincode: 688013, serviceable: "Yes", tier: "2" },
  { pincode: 688014, serviceable: "Yes", tier: "2" },
  { pincode: 688501, serviceable: "Yes", tier: "2" },
  { pincode: 688502, serviceable: "Yes", tier: "2" },
  { pincode: 688503, serviceable: "Yes", tier: "2" },
  { pincode: 688505, serviceable: "Yes", tier: "2" },
  { pincode: 688521, serviceable: "Yes", tier: "2" },
  { pincode: 688522, serviceable: "Yes", tier: "2" },
  { pincode: 688523, serviceable: "Yes", tier: "2" },
  { pincode: 688524, serviceable: "Yes", tier: "2" },
  { pincode: 688525, serviceable: "Yes", tier: "2" },
  { pincode: 688526, serviceable: "Yes", tier: "2" },
  { pincode: 688527, serviceable: "Yes", tier: "2" },
  { pincode: 688528, serviceable: "Yes", tier: "2" },
  { pincode: 688529, serviceable: "Yes", tier: "2" },
  { pincode: 688530, serviceable: "Yes", tier: "2" },
  { pincode: 688531, serviceable: "Yes", tier: "2" },
  { pincode: 688532, serviceable: "Yes", tier: "2" },
  { pincode: 688533, serviceable: "Yes", tier: "2" },
  { pincode: 688534, serviceable: "Yes", tier: "2" },
  { pincode: 688535, serviceable: "Yes", tier: "2" },
  { pincode: 688536, serviceable: "Yes", tier: "2" },
  { pincode: 688537, serviceable: "Yes", tier: "2" },
  { pincode: 688538, serviceable: "Yes", tier: "2" },
  { pincode: 688539, serviceable: "Yes", tier: "2" },
  { pincode: 688540, serviceable: "Yes", tier: "2" },
  { pincode: 688541, serviceable: "Yes", tier: "2" },
  { pincode: 688542, serviceable: "Yes", tier: "2" },
  { pincode: 688543, serviceable: "Yes", tier: "2" },
  { pincode: 688544, serviceable: "Yes", tier: "2" },
  { pincode: 688545, serviceable: "Yes", tier: "2" },
  { pincode: 688546, serviceable: "Yes", tier: "2" },
  { pincode: 688549, serviceable: "Yes", tier: "2" },
  { pincode: 688554, serviceable: "Yes", tier: "2" },
  { pincode: 688555, serviceable: "Yes", tier: "2" },
  { pincode: 688561, serviceable: "Yes", tier: "2" },
  { pincode: 688562, serviceable: "Yes", tier: "2" },
  { pincode: 688564, serviceable: "Yes", tier: "2" },
  { pincode: 688565, serviceable: "Yes", tier: "2" },
  { pincode: 688582, serviceable: "Yes", tier: "2" },
  { pincode: 688583, serviceable: "Yes", tier: "2" },
  { pincode: 689101, serviceable: "Yes", tier: "3" },
  { pincode: 689102, serviceable: "Yes", tier: "3" },
  { pincode: 689103, serviceable: "Yes", tier: "3" },
  { pincode: 689104, serviceable: "Yes", tier: "3" },
  { pincode: 689105, serviceable: "Yes", tier: "3" },
  { pincode: 689106, serviceable: "Yes", tier: "3" },
  { pincode: 689107, serviceable: "Yes", tier: "3" },
  { pincode: 689108, serviceable: "Yes", tier: "3" },
  { pincode: 689109, serviceable: "Yes", tier: "3" },
  { pincode: 689110, serviceable: "Yes", tier: "3" },
  { pincode: 689111, serviceable: "Yes", tier: "3" },
  { pincode: 689112, serviceable: "Yes", tier: "3" },
  { pincode: 689113, serviceable: "Yes", tier: "3" },
  { pincode: 689115, serviceable: "Yes", tier: "3" },
  { pincode: 689121, serviceable: "Yes", tier: "3" },
  { pincode: 689122, serviceable: "Yes", tier: "3" },
  { pincode: 689123, serviceable: "Yes", tier: "3" },
  { pincode: 689124, serviceable: "Yes", tier: "3" },
  { pincode: 689126, serviceable: "Yes", tier: "3" },
  { pincode: 689501, serviceable: "Yes", tier: "3" },
  { pincode: 689502, serviceable: "Yes", tier: "3" },
  { pincode: 689504, serviceable: "Yes", tier: "3" },
  { pincode: 689505, serviceable: "Yes", tier: "3" },
  { pincode: 689506, serviceable: "Yes", tier: "3" },
  { pincode: 689508, serviceable: "Yes", tier: "3" },
  { pincode: 689509, serviceable: "Yes", tier: "3" },
  { pincode: 689510, serviceable: "Yes", tier: "3" },
  { pincode: 689511, serviceable: "Yes", tier: "2" },
  { pincode: 689512, serviceable: "Yes", tier: "3" },
  { pincode: 689513, serviceable: "Yes", tier: "3" },
  { pincode: 689520, serviceable: "Yes", tier: "3" },
  { pincode: 689542, serviceable: "Yes", tier: "3" },
  { pincode: 689543, serviceable: "Yes", tier: "3" },
  { pincode: 689544, serviceable: "Yes", tier: "3" },
  { pincode: 689546, serviceable: "Yes", tier: "3" },
  { pincode: 689547, serviceable: "Yes", tier: "3" },
  { pincode: 689549, serviceable: "Yes", tier: "3" },
  { pincode: 689550, serviceable: "Yes", tier: "3" },
  { pincode: 689551, serviceable: "Yes", tier: "3" },
  { pincode: 689572, serviceable: "Yes", tier: "2" },
  { pincode: 689573, serviceable: "Yes", tier: "2" },
  { pincode: 689584, serviceable: "Yes", tier: "3" },
  { pincode: 689585, serviceable: "Yes", tier: "3" },
  { pincode: 689586, serviceable: "Yes", tier: "3" },
  { pincode: 689587, serviceable: "Yes", tier: "3" },
  { pincode: 689589, serviceable: "Yes", tier: "3" },
  { pincode: 689591, serviceable: "Yes", tier: "3" },
  { pincode: 689595, serviceable: "Yes", tier: "2" },
  { pincode: 689597, serviceable: "Yes", tier: "3" },
  { pincode: 689602, serviceable: "Yes", tier: "3" },
  { pincode: 689621, serviceable: "Yes", tier: "3" },
  { pincode: 689622, serviceable: "Yes", tier: "2" },
  { pincode: 689624, serviceable: "Yes", tier: "2" },
  { pincode: 689626, serviceable: "Yes", tier: "3" },
  { pincode: 689641, serviceable: "Yes", tier: "3" },
  { pincode: 689644, serviceable: "Yes", tier: "3" },
  { pincode: 689645, serviceable: "Yes", tier: "3" },
  { pincode: 689647, serviceable: "Yes", tier: "3" },
  { pincode: 689648, serviceable: "Yes", tier: "3" },
  { pincode: 689652, serviceable: "Yes", tier: "3" },
  { pincode: 689653, serviceable: "Yes", tier: "3" },
  { pincode: 689654, serviceable: "Yes", tier: "3" },
  { pincode: 689661, serviceable: "Yes", tier: "3" },
  { pincode: 689666, serviceable: "Yes", tier: "3" },
  { pincode: 689668, serviceable: "Yes", tier: "3" },
  { pincode: 689671, serviceable: "Yes", tier: "3" },
  { pincode: 689678, serviceable: "Yes", tier: "3" },
  { pincode: 690101, serviceable: "Yes", tier: "2" },
  { pincode: 690102, serviceable: "Yes", tier: "2" },
  { pincode: 690103, serviceable: "Yes", tier: "2" },
  { pincode: 690104, serviceable: "Yes", tier: "2" },
  { pincode: 690105, serviceable: "Yes", tier: "2" },
  { pincode: 690106, serviceable: "Yes", tier: "2" },
  { pincode: 690107, serviceable: "Yes", tier: "2" },
  { pincode: 690108, serviceable: "Yes", tier: "2" },
  { pincode: 690110, serviceable: "Yes", tier: "2" },
  { pincode: 690502, serviceable: "Yes", tier: "2" },
  { pincode: 690503, serviceable: "Yes", tier: "2" },
  { pincode: 690506, serviceable: "Yes", tier: "2" },
  { pincode: 690507, serviceable: "Yes", tier: "2" },
  { pincode: 690510, serviceable: "Yes", tier: "2" },
  { pincode: 690513, serviceable: "Yes", tier: "2" },
  { pincode: 690514, serviceable: "Yes", tier: "2" },
  { pincode: 690515, serviceable: "Yes", tier: "2" },
  { pincode: 690516, serviceable: "Yes", tier: "2" },
  { pincode: 690518, serviceable: "Yes", tier: "3" },
  { pincode: 690519, serviceable: "Yes", tier: "3" },
  { pincode: 690523, serviceable: "Yes", tier: "3" },
  { pincode: 690524, serviceable: "Yes", tier: "3" },
  { pincode: 690525, serviceable: "Yes", tier: "3" },
  { pincode: 690526, serviceable: "Yes", tier: "3" },
  { pincode: 690528, serviceable: "Yes", tier: "3" },
  { pincode: 690531, serviceable: "Yes", tier: "2" },
  { pincode: 690532, serviceable: "Yes", tier: "2" },
  { pincode: 690533, serviceable: "Yes", tier: "2" },
  { pincode: 690535, serviceable: "Yes", tier: "2" },
  { pincode: 690536, serviceable: "Yes", tier: "3" },
  { pincode: 690539, serviceable: "Yes", tier: "3" },
  { pincode: 690542, serviceable: "Yes", tier: "3" },
  { pincode: 690544, serviceable: "Yes", tier: "3" },
  { pincode: 690546, serviceable: "Yes", tier: "3" },
  { pincode: 690547, serviceable: "Yes", tier: "3" },
  { pincode: 690552, serviceable: "Yes", tier: "2" },
  { pincode: 690558, serviceable: "Yes", tier: "2" },
  { pincode: 690570, serviceable: "Yes", tier: "2" },
  { pincode: 690571, serviceable: "Yes", tier: "2" },
  { pincode: 690572, serviceable: "Yes", tier: "2" },
  { pincode: 690573, serviceable: "Yes", tier: "3" },
  { pincode: 691001, serviceable: "Yes", tier: "2" },
  { pincode: 691002, serviceable: "Yes", tier: "2" },
  { pincode: 691003, serviceable: "Yes", tier: "3" },
  { pincode: 691004, serviceable: "Yes", tier: "2" },
  { pincode: 691005, serviceable: "Yes", tier: "2" },
  { pincode: 691006, serviceable: "Yes", tier: "2" },
  { pincode: 691007, serviceable: "Yes", tier: "3" },
  { pincode: 691008, serviceable: "Yes", tier: "2" },
  { pincode: 691009, serviceable: "Yes", tier: "2" },
  { pincode: 691010, serviceable: "Yes", tier: "2" },
  { pincode: 691011, serviceable: "Yes", tier: "2" },
  { pincode: 691012, serviceable: "Yes", tier: "3" },
  { pincode: 691013, serviceable: "Yes", tier: "3" },
  { pincode: 691014, serviceable: "Yes", tier: "2" },
  { pincode: 691015, serviceable: "Yes", tier: "2" },
  { pincode: 691016, serviceable: "Yes", tier: "2" },
  { pincode: 691017, serviceable: "Yes", tier: "2" },
  { pincode: 691018, serviceable: "Yes", tier: "2" },
  { pincode: 691019, serviceable: "Yes", tier: "2" },
  { pincode: 691020, serviceable: "Yes", tier: "2" },
  { pincode: 691021, serviceable: "Yes", tier: "2" },
  { pincode: 691301, serviceable: "Yes", tier: "3" },
  { pincode: 691302, serviceable: "Yes", tier: "3" },
  { pincode: 691305, serviceable: "Yes", tier: "3" },
  { pincode: 691306, serviceable: "Yes", tier: "3" },
  { pincode: 691315, serviceable: "Yes", tier: "3" },
  { pincode: 691318, serviceable: "Yes", tier: "3" },
  { pincode: 691319, serviceable: "Yes", tier: "3" },
  { pincode: 691320, serviceable: "Yes", tier: "3" },
  { pincode: 691321, serviceable: "Yes", tier: "3" },
  { pincode: 691324, serviceable: "Yes", tier: "3" },
  { pincode: 691325, serviceable: "Yes", tier: "3" },
  { pincode: 691331, serviceable: "Yes", tier: "3" },
  { pincode: 691333, serviceable: "Yes", tier: "3" },
  { pincode: 691378, serviceable: "Yes", tier: "3" },
  { pincode: 691501, serviceable: "Yes", tier: "3" },
  { pincode: 691504, serviceable: "Yes", tier: "3" },
  { pincode: 691505, serviceable: "Yes", tier: "3" },
  { pincode: 691506, serviceable: "Yes", tier: "3" },
  { pincode: 691507, serviceable: "Yes", tier: "3" },
  { pincode: 691511, serviceable: "Yes", tier: "3" },
  { pincode: 691512, serviceable: "Yes", tier: "3" },
  { pincode: 691523, serviceable: "Yes", tier: "3" },
  { pincode: 691530, serviceable: "Yes", tier: "3" },
  { pincode: 691531, serviceable: "Yes", tier: "3" },
  { pincode: 691532, serviceable: "Yes", tier: "3" },
  { pincode: 691533, serviceable: "Yes", tier: "3" },
  { pincode: 691536, serviceable: "Yes", tier: "3" },
  { pincode: 691538, serviceable: "Yes", tier: "3" },
  { pincode: 691542, serviceable: "Yes", tier: "3" },
  { pincode: 691557, serviceable: "Yes", tier: "3" },
  { pincode: 691560, serviceable: "Yes", tier: "3" },
  { pincode: 691566, serviceable: "Yes", tier: "3" },
  { pincode: 691571, serviceable: "Yes", tier: "2" },
  { pincode: 691574, serviceable: "Yes", tier: "3" },
  { pincode: 691577, serviceable: "Yes", tier: "2" },
  { pincode: 691581, serviceable: "Yes", tier: "3" },
  { pincode: 691582, serviceable: "Yes", tier: "3" },
  { pincode: 691583, serviceable: "Yes", tier: "3" },
  { pincode: 691584, serviceable: "Yes", tier: "3" },
  { pincode: 691588, serviceable: "Yes", tier: "3" },
  { pincode: 691589, serviceable: "Yes", tier: "2" },
  { pincode: 691590, serviceable: "Yes", tier: "3" },
  { pincode: 691601, serviceable: "Yes", tier: "3" },
  { pincode: 691602, serviceable: "Yes", tier: "3" },
  { pincode: 691604, serviceable: "Yes", tier: "3" },
  { pincode: 691605, serviceable: "Yes", tier: "3" },
  { pincode: 694582, serviceable: "Yes", tier: "3" },
  { pincode: 695001, serviceable: "Yes", tier: "3" },
  { pincode: 695002, serviceable: "Yes", tier: "3" },
  { pincode: 695003, serviceable: "Yes", tier: "2" },
  { pincode: 695004, serviceable: "Yes", tier: "2" },
  { pincode: 695005, serviceable: "Yes", tier: "2" },
  { pincode: 695006, serviceable: "Yes", tier: "3" },
  { pincode: 695007, serviceable: "Yes", tier: "2" },
  { pincode: 695008, serviceable: "Yes", tier: "3" },
  { pincode: 695009, serviceable: "Yes", tier: "3" },
  { pincode: 695010, serviceable: "Yes", tier: "3" },
  { pincode: 695011, serviceable: "Yes", tier: "2" },
  { pincode: 695012, serviceable: "Yes", tier: "3" },
  { pincode: 695013, serviceable: "Yes", tier: "3" },
  { pincode: 695014, serviceable: "Yes", tier: "3" },
  { pincode: 695015, serviceable: "Yes", tier: "2" },
  { pincode: 695016, serviceable: "Yes", tier: "2" },
  { pincode: 695017, serviceable: "Yes", tier: "2" },
  { pincode: 695018, serviceable: "Yes", tier: "3" },
  { pincode: 695019, serviceable: "Yes", tier: "3" },
  { pincode: 695020, serviceable: "Yes", tier: "3" },
  { pincode: 695021, serviceable: "Yes", tier: "2" },
  { pincode: 695022, serviceable: "Yes", tier: "2" },
  { pincode: 695023, serviceable: "Yes", tier: "3" },
  { pincode: 695024, serviceable: "Yes", tier: "2" },
  { pincode: 695025, serviceable: "Yes", tier: "2" },
  { pincode: 695026, serviceable: "Yes", tier: "3" },
  { pincode: 695027, serviceable: "Yes", tier: "3" },
  { pincode: 695028, serviceable: "Yes", tier: "3" },
  { pincode: 695029, serviceable: "Yes", tier: "2" },
  { pincode: 695030, serviceable: "Yes", tier: "3" },
  { pincode: 695031, serviceable: "Yes", tier: "2" },
  { pincode: 695032, serviceable: "Yes", tier: "3" },
  { pincode: 695033, serviceable: "Yes", tier: "3" },
  { pincode: 695034, serviceable: "Yes", tier: "3" },
  { pincode: 695035, serviceable: "Yes", tier: "3" },
  { pincode: 695036, serviceable: "Yes", tier: "3" },
  { pincode: 695037, serviceable: "Yes", tier: "2" },
  { pincode: 695038, serviceable: "Yes", tier: "3" },
  { pincode: 695039, serviceable: "Yes", tier: "3" },
  { pincode: 695040, serviceable: "Yes", tier: "3" },
  { pincode: 695041, serviceable: "Yes", tier: "3" },
  { pincode: 695042, serviceable: "Yes", tier: "3" },
  { pincode: 695043, serviceable: "Yes", tier: "2" },
  { pincode: 695044, serviceable: "Yes", tier: "2" },
  { pincode: 695049, serviceable: "Yes", tier: "3" },
  { pincode: 695099, serviceable: "Yes", tier: "2" },
  { pincode: 695101, serviceable: "Yes", tier: "3" },
  { pincode: 695102, serviceable: "Yes", tier: "3" },
  { pincode: 695103, serviceable: "Yes", tier: "3" },
  { pincode: 695104, serviceable: "Yes", tier: "3" },
  { pincode: 695121, serviceable: "Yes", tier: "3" },
  { pincode: 695122, serviceable: "Yes", tier: "3" },
  { pincode: 695123, serviceable: "Yes", tier: "3" },
  { pincode: 695124, serviceable: "Yes", tier: "3" },
  { pincode: 695125, serviceable: "Yes", tier: "3" },
  { pincode: 695126, serviceable: "Yes", tier: "3" },
  { pincode: 695132, serviceable: "Yes", tier: "3" },
  { pincode: 695133, serviceable: "Yes", tier: "3" },
  { pincode: 695134, serviceable: "Yes", tier: "3" },
  { pincode: 695141, serviceable: "Yes", tier: "3" },
  { pincode: 695142, serviceable: "Yes", tier: "3" },
  { pincode: 695143, serviceable: "Yes", tier: "3" },
  { pincode: 695144, serviceable: "Yes", tier: "3" },
  { pincode: 695145, serviceable: "Yes", tier: "3" },
  { pincode: 695301, serviceable: "Yes", tier: "3" },
  { pincode: 695302, serviceable: "Yes", tier: "3" },
  { pincode: 695303, serviceable: "Yes", tier: "3" },
  { pincode: 695304, serviceable: "Yes", tier: "3" },
  { pincode: 695305, serviceable: "Yes", tier: "3" },
  { pincode: 695306, serviceable: "Yes", tier: "3" },
  { pincode: 695308, serviceable: "Yes", tier: "3" },
  { pincode: 695311, serviceable: "Yes", tier: "3" },
  { pincode: 695312, serviceable: "Yes", tier: "3" },
  { pincode: 695316, serviceable: "Yes", tier: "3" },
  { pincode: 695317, serviceable: "Yes", tier: "3" },
  { pincode: 695318, serviceable: "Yes", tier: "3" },
  { pincode: 695501, serviceable: "Yes", tier: "3" },
  { pincode: 695502, serviceable: "Yes", tier: "3" },
  { pincode: 695503, serviceable: "Yes", tier: "3" },
  { pincode: 695504, serviceable: "Yes", tier: "3" },
  { pincode: 695505, serviceable: "Yes", tier: "3" },
  { pincode: 695506, serviceable: "Yes", tier: "3" },
  { pincode: 695507, serviceable: "Yes", tier: "3" },
  { pincode: 695508, serviceable: "Yes", tier: "3" },
  { pincode: 695512, serviceable: "Yes", tier: "3" },
  { pincode: 695513, serviceable: "Yes", tier: "3" },
  { pincode: 695521, serviceable: "Yes", tier: "3" },
  { pincode: 695522, serviceable: "Yes", tier: "3" },
  { pincode: 695523, serviceable: "Yes", tier: "3" },
  { pincode: 695525, serviceable: "Yes", tier: "3" },
  { pincode: 695526, serviceable: "Yes", tier: "3" },
  { pincode: 695527, serviceable: "Yes", tier: "3" },
  { pincode: 695541, serviceable: "Yes", tier: "3" },
  { pincode: 695543, serviceable: "Yes", tier: "3" },
  { pincode: 695547, serviceable: "Yes", tier: "3" },
  { pincode: 695561, serviceable: "Yes", tier: "3" },
  { pincode: 695562, serviceable: "Yes", tier: "3" },
  { pincode: 695564, serviceable: "Yes", tier: "3" },
  { pincode: 695568, serviceable: "Yes", tier: "3" },
  { pincode: 695571, serviceable: "Yes", tier: "3" },
  { pincode: 695573, serviceable: "Yes", tier: "3" },
  { pincode: 695575, serviceable: "Yes", tier: "3" },
  { pincode: 695581, serviceable: "Yes", tier: "2" },
  { pincode: 695582, serviceable: "Yes", tier: "2" },
  { pincode: 695583, serviceable: "Yes", tier: "2" },
  { pincode: 695584, serviceable: "Yes", tier: "3" },
  { pincode: 695585, serviceable: "Yes", tier: "3" },
  { pincode: 695586, serviceable: "Yes", tier: "3" },
  { pincode: 695587, serviceable: "Yes", tier: "3" },
  { pincode: 695588, serviceable: "Yes", tier: "3" },
  { pincode: 695589, serviceable: "Yes", tier: "3" },
  { pincode: 695601, serviceable: "Yes", tier: "3" },
  { pincode: 695603, serviceable: "Yes", tier: "3" },
  { pincode: 695606, serviceable: "Yes", tier: "3" },
  { pincode: 695607, serviceable: "Yes", tier: "3" },
  { pincode: 695608, serviceable: "Yes", tier: "3" },
  { pincode: 695611, serviceable: "Yes", tier: "3" },
  { pincode: 695612, serviceable: "Yes", tier: "3" },
  { pincode: 695614, serviceable: "Yes", tier: "3" },
  { pincode: 695615, serviceable: "Yes", tier: "3" },
  { pincode: 700000, serviceable: "Yes", tier: "1" },
  { pincode: 700001, serviceable: "Yes", tier: "1" },
  { pincode: 700002, serviceable: "Yes", tier: "1" },
  { pincode: 700003, serviceable: "Yes", tier: "1" },
  { pincode: 700004, serviceable: "Yes", tier: "1" },
  { pincode: 700005, serviceable: "Yes", tier: "1" },
  { pincode: 700006, serviceable: "Yes", tier: "1" },
  { pincode: 700007, serviceable: "Yes", tier: "1" },
  { pincode: 700008, serviceable: "Yes", tier: "1" },
  { pincode: 700009, serviceable: "Yes", tier: "1" },
  { pincode: 700010, serviceable: "Yes", tier: "1" },
  { pincode: 700011, serviceable: "Yes", tier: "1" },
  { pincode: 700012, serviceable: "Yes", tier: "1" },
  { pincode: 700013, serviceable: "Yes", tier: "1" },
  { pincode: 700014, serviceable: "Yes", tier: "1" },
  { pincode: 700015, serviceable: "Yes", tier: "1" },
  { pincode: 700016, serviceable: "Yes", tier: "1" },
  { pincode: 700017, serviceable: "Yes", tier: "1" },
  { pincode: 700018, serviceable: "Yes", tier: "1" },
  { pincode: 700019, serviceable: "Yes", tier: "1" },
  { pincode: 700020, serviceable: "Yes", tier: "1" },
  { pincode: 700021, serviceable: "Yes", tier: "1" },
  { pincode: 700022, serviceable: "Yes", tier: "1" },
  { pincode: 700023, serviceable: "Yes", tier: "1" },
  { pincode: 700024, serviceable: "Yes", tier: "1" },
  { pincode: 700025, serviceable: "Yes", tier: "1" },
  { pincode: 700026, serviceable: "Yes", tier: "1" },
  { pincode: 700027, serviceable: "Yes", tier: "1" },
  { pincode: 700028, serviceable: "Yes", tier: "1" },
  { pincode: 700029, serviceable: "Yes", tier: "1" },
  { pincode: 700030, serviceable: "Yes", tier: "1" },
  { pincode: 700031, serviceable: "Yes", tier: "1" },
  { pincode: 700032, serviceable: "Yes", tier: "1" },
  { pincode: 700033, serviceable: "Yes", tier: "1" },
  { pincode: 700034, serviceable: "Yes", tier: "1" },
  { pincode: 700035, serviceable: "Yes", tier: "1" },
  { pincode: 700036, serviceable: "Yes", tier: "1" },
  { pincode: 700037, serviceable: "Yes", tier: "1" },
  { pincode: 700038, serviceable: "Yes", tier: "1" },
  { pincode: 700039, serviceable: "Yes", tier: "2" },
  { pincode: 700040, serviceable: "Yes", tier: "1" },
  { pincode: 700041, serviceable: "Yes", tier: "1" },
  { pincode: 700042, serviceable: "Yes", tier: "2" },
  { pincode: 700043, serviceable: "Yes", tier: "1" },
  { pincode: 700044, serviceable: "Yes", tier: "1" },
  { pincode: 700045, serviceable: "Yes", tier: "1" },
  { pincode: 700046, serviceable: "Yes", tier: "1" },
  { pincode: 700047, serviceable: "Yes", tier: "1" },
  { pincode: 700048, serviceable: "Yes", tier: "1" },
  { pincode: 700049, serviceable: "Yes", tier: "1" },
  { pincode: 700050, serviceable: "Yes", tier: "1" },
  { pincode: 700051, serviceable: "Yes", tier: "1" },
  { pincode: 700052, serviceable: "Yes", tier: "1" },
  { pincode: 700053, serviceable: "Yes", tier: "1" },
  { pincode: 700054, serviceable: "Yes", tier: "1" },
  { pincode: 700055, serviceable: "Yes", tier: "1" },
  { pincode: 700056, serviceable: "Yes", tier: "1" },
  { pincode: 700057, serviceable: "Yes", tier: "1" },
  { pincode: 700058, serviceable: "Yes", tier: "1" },
  { pincode: 700059, serviceable: "Yes", tier: "1" },
  { pincode: 700060, serviceable: "Yes", tier: "1" },
  { pincode: 700061, serviceable: "Yes", tier: "1" },
  { pincode: 700062, serviceable: "Yes", tier: "1" },
  { pincode: 700063, serviceable: "Yes", tier: "1" },
  { pincode: 700064, serviceable: "Yes", tier: "1" },
  { pincode: 700065, serviceable: "Yes", tier: "1" },
  { pincode: 700066, serviceable: "Yes", tier: "1" },
  { pincode: 700067, serviceable: "Yes", tier: "1" },
  { pincode: 700068, serviceable: "Yes", tier: "1" },
  { pincode: 700069, serviceable: "Yes", tier: "1" },
  { pincode: 700070, serviceable: "Yes", tier: "1" },
  { pincode: 700071, serviceable: "Yes", tier: "1" },
  { pincode: 700072, serviceable: "Yes", tier: "1" },
  { pincode: 700073, serviceable: "Yes", tier: "1" },
  { pincode: 700074, serviceable: "Yes", tier: "1" },
  { pincode: 700075, serviceable: "Yes", tier: "1" },
  { pincode: 700076, serviceable: "Yes", tier: "1" },
  { pincode: 700077, serviceable: "Yes", tier: "1" },
  { pincode: 700078, serviceable: "Yes", tier: "2" },
  { pincode: 700079, serviceable: "Yes", tier: "1" },
  { pincode: 700080, serviceable: "Yes", tier: "1" },
  { pincode: 700081, serviceable: "Yes", tier: "1" },
  { pincode: 700082, serviceable: "Yes", tier: "1" },
  { pincode: 700083, serviceable: "Yes", tier: "1" },
  { pincode: 700084, serviceable: "Yes", tier: "1" },
  { pincode: 700085, serviceable: "Yes", tier: "1" },
  { pincode: 700086, serviceable: "Yes", tier: "1" },
  { pincode: 700087, serviceable: "Yes", tier: "1" },
  { pincode: 700088, serviceable: "Yes", tier: "1" },
  { pincode: 700089, serviceable: "Yes", tier: "1" },
  { pincode: 700090, serviceable: "Yes", tier: "1" },
  { pincode: 700091, serviceable: "Yes", tier: "1" },
  { pincode: 700092, serviceable: "Yes", tier: "1" },
  { pincode: 700093, serviceable: "Yes", tier: "1" },
  { pincode: 700094, serviceable: "Yes", tier: "1" },
  { pincode: 700095, serviceable: "Yes", tier: "1" },
  { pincode: 700096, serviceable: "Yes", tier: "1" },
  { pincode: 700097, serviceable: "Yes", tier: "1" },
  { pincode: 700098, serviceable: "Yes", tier: "1" },
  { pincode: 700099, serviceable: "Yes", tier: "2" },
  { pincode: 700100, serviceable: "Yes", tier: "2" },
  { pincode: 700101, serviceable: "Yes", tier: "1" },
  { pincode: 700102, serviceable: "Yes", tier: "1" },
  { pincode: 700103, serviceable: "Yes", tier: "1" },
  { pincode: 700104, serviceable: "Yes", tier: "2" },
  { pincode: 700105, serviceable: "Yes", tier: "1" },
  { pincode: 700106, serviceable: "Yes", tier: "1" },
  { pincode: 700107, serviceable: "Yes", tier: "2" },
  { pincode: 700108, serviceable: "Yes", tier: "1" },
  { pincode: 700109, serviceable: "Yes", tier: "2" },
  { pincode: 700110, serviceable: "Yes", tier: "2" },
  { pincode: 700111, serviceable: "Yes", tier: "2" },
  { pincode: 700112, serviceable: "Yes", tier: "2" },
  { pincode: 700113, serviceable: "Yes", tier: "2" },
  { pincode: 700114, serviceable: "Yes", tier: "2" },
  { pincode: 700115, serviceable: "Yes", tier: "2" },
  { pincode: 700116, serviceable: "Yes", tier: "2" },
  { pincode: 700117, serviceable: "Yes", tier: "2" },
  { pincode: 700118, serviceable: "Yes", tier: "2" },
  { pincode: 700119, serviceable: "Yes", tier: "2" },
  { pincode: 700120, serviceable: "Yes", tier: "2" },
  { pincode: 700121, serviceable: "Yes", tier: "2" },
  { pincode: 700122, serviceable: "Yes", tier: "2" },
  { pincode: 700123, serviceable: "Yes", tier: "2" },
  { pincode: 700124, serviceable: "Yes", tier: "1" },
  { pincode: 700125, serviceable: "Yes", tier: "1" },
  { pincode: 700126, serviceable: "Yes", tier: "1" },
  { pincode: 700127, serviceable: "Yes", tier: "1" },
  { pincode: 700128, serviceable: "Yes", tier: "1" },
  { pincode: 700129, serviceable: "Yes", tier: "1" },
  { pincode: 700130, serviceable: "Yes", tier: "1" },
  { pincode: 700131, serviceable: "Yes", tier: "1" },
  { pincode: 700132, serviceable: "Yes", tier: "1" },
  { pincode: 700133, serviceable: "Yes", tier: "1" },
  { pincode: 700134, serviceable: "Yes", tier: "1" },
  { pincode: 700135, serviceable: "Yes", tier: "2" },
  { pincode: 700136, serviceable: "Yes", tier: "1" },
  { pincode: 700137, serviceable: "Yes", tier: "1" },
  { pincode: 700138, serviceable: "Yes", tier: "1" },
  { pincode: 700139, serviceable: "Yes", tier: "1" },
  { pincode: 700140, serviceable: "Yes", tier: "1" },
  { pincode: 700141, serviceable: "Yes", tier: "1" },
  { pincode: 700142, serviceable: "Yes", tier: "1" },
  { pincode: 700143, serviceable: "Yes", tier: "1" },
  { pincode: 700144, serviceable: "Yes", tier: "1" },
  { pincode: 700145, serviceable: "Yes", tier: "1" },
  { pincode: 700146, serviceable: "Yes", tier: "1" },
  { pincode: 700147, serviceable: "Yes", tier: "1" },
  { pincode: 700148, serviceable: "Yes", tier: "1" },
  { pincode: 700149, serviceable: "Yes", tier: "1" },
  { pincode: 700150, serviceable: "Yes", tier: "1" },
  { pincode: 700151, serviceable: "Yes", tier: "1" },
  { pincode: 700152, serviceable: "Yes", tier: "1" },
  { pincode: 700153, serviceable: "Yes", tier: "1" },
  { pincode: 700154, serviceable: "Yes", tier: "1" },
  { pincode: 700155, serviceable: "Yes", tier: "1" },
  { pincode: 700156, serviceable: "Yes", tier: "2" },
  { pincode: 700157, serviceable: "Yes", tier: "1" },
  { pincode: 700158, serviceable: "Yes", tier: "1" },
  { pincode: 700159, serviceable: "Yes", tier: "1" },
  { pincode: 700160, serviceable: "Yes", tier: "2" },
  { pincode: 700161, serviceable: "Yes", tier: "1" },
  { pincode: 700162, serviceable: "Yes", tier: "1" },
  { pincode: 701111, serviceable: "Yes", tier: "1" },
  { pincode: 711101, serviceable: "Yes", tier: "1" },
  { pincode: 711102, serviceable: "Yes", tier: "1" },
  { pincode: 711103, serviceable: "Yes", tier: "1" },
  { pincode: 711104, serviceable: "Yes", tier: "1" },
  { pincode: 711105, serviceable: "Yes", tier: "1" },
  { pincode: 711106, serviceable: "Yes", tier: "1" },
  { pincode: 711107, serviceable: "Yes", tier: "1" },
  { pincode: 711108, serviceable: "Yes", tier: "1" },
  { pincode: 711109, serviceable: "Yes", tier: "1" },
  { pincode: 711110, serviceable: "Yes", tier: "1" },
  { pincode: 711111, serviceable: "Yes", tier: "1" },
  { pincode: 711112, serviceable: "Yes", tier: "1" },
  { pincode: 711113, serviceable: "Yes", tier: "1" },
  { pincode: 711114, serviceable: "Yes", tier: "1" },
  { pincode: 711115, serviceable: "Yes", tier: "1" },
  { pincode: 711201, serviceable: "Yes", tier: "1" },
  { pincode: 711202, serviceable: "Yes", tier: "1" },
  { pincode: 711203, serviceable: "Yes", tier: "1" },
  { pincode: 711204, serviceable: "Yes", tier: "1" },
  { pincode: 711205, serviceable: "Yes", tier: "1" },
  { pincode: 711206, serviceable: "Yes", tier: "1" },
  { pincode: 711225, serviceable: "Yes", tier: "2" },
  { pincode: 711226, serviceable: "Yes", tier: "2" },
  { pincode: 711227, serviceable: "Yes", tier: "1" },
  { pincode: 711301, serviceable: "Yes", tier: "2" },
  { pincode: 711302, serviceable: "Yes", tier: "1" },
  { pincode: 711303, serviceable: "Yes", tier: "2" },
  { pincode: 711304, serviceable: "Yes", tier: "1" },
  { pincode: 711305, serviceable: "Yes", tier: "2" },
  { pincode: 711306, serviceable: "Yes", tier: "2" },
  { pincode: 711307, serviceable: "Yes", tier: "2" },
  { pincode: 711308, serviceable: "Yes", tier: "2" },
  { pincode: 711309, serviceable: "Yes", tier: "1" },
  { pincode: 711310, serviceable: "Yes", tier: "2" },
  { pincode: 711312, serviceable: "Yes", tier: "2" },
  { pincode: 711313, serviceable: "Yes", tier: "1" },
  { pincode: 711314, serviceable: "Yes", tier: "2" },
  { pincode: 711315, serviceable: "Yes", tier: "2" },
  { pincode: 711316, serviceable: "Yes", tier: "2" },
  { pincode: 711317, serviceable: "Yes", tier: "1" },
  { pincode: 711320, serviceable: "Yes", tier: "1" },
  { pincode: 711322, serviceable: "Yes", tier: "2" },
  { pincode: 711401, serviceable: "Yes", tier: "2" },
  { pincode: 711403, serviceable: "Yes", tier: "1" },
  { pincode: 711404, serviceable: "Yes", tier: "2" },
  { pincode: 711405, serviceable: "Yes", tier: "1" },
  { pincode: 711408, serviceable: "Yes", tier: "2" },
  { pincode: 711409, serviceable: "Yes", tier: "1" },
  { pincode: 711410, serviceable: "Yes", tier: "2" },
  { pincode: 711411, serviceable: "Yes", tier: "1" },
  { pincode: 711412, serviceable: "Yes", tier: "2" },
  { pincode: 711413, serviceable: "Yes", tier: "2" },
  { pincode: 711414, serviceable: "Yes", tier: "2" },
  { pincode: 712101, serviceable: "Yes", tier: "2" },
  { pincode: 712102, serviceable: "Yes", tier: "2" },
  { pincode: 712103, serviceable: "Yes", tier: "2" },
  { pincode: 712104, serviceable: "Yes", tier: "2" },
  { pincode: 712105, serviceable: "Yes", tier: "2" },
  { pincode: 712121, serviceable: "Yes", tier: "2" },
  { pincode: 712122, serviceable: "Yes", tier: "2" },
  { pincode: 712123, serviceable: "Yes", tier: "2" },
  { pincode: 712124, serviceable: "Yes", tier: "2" },
  { pincode: 712125, serviceable: "Yes", tier: "2" },
  { pincode: 712134, serviceable: "Yes", tier: "2" },
  { pincode: 712135, serviceable: "Yes", tier: "2" },
  { pincode: 712136, serviceable: "Yes", tier: "2" },
  { pincode: 712137, serviceable: "Yes", tier: "2" },
  { pincode: 712138, serviceable: "Yes", tier: "2" },
  { pincode: 712139, serviceable: "Yes", tier: "2" },
  { pincode: 712147, serviceable: "Yes", tier: "2" },
  { pincode: 712148, serviceable: "Yes", tier: "2" },
  { pincode: 712149, serviceable: "Yes", tier: "2" },
  { pincode: 712152, serviceable: "Yes", tier: "2" },
  { pincode: 712201, serviceable: "Yes", tier: "2" },
  { pincode: 712202, serviceable: "Yes", tier: "2" },
  { pincode: 712203, serviceable: "Yes", tier: "2" },
  { pincode: 712204, serviceable: "Yes", tier: "2" },
  { pincode: 712221, serviceable: "Yes", tier: "2" },
  { pincode: 712222, serviceable: "Yes", tier: "2" },
  { pincode: 712223, serviceable: "Yes", tier: "2" },
  { pincode: 712232, serviceable: "Yes", tier: "1" },
  { pincode: 712233, serviceable: "Yes", tier: "1" },
  { pincode: 712234, serviceable: "Yes", tier: "1" },
  { pincode: 712235, serviceable: "Yes", tier: "1" },
  { pincode: 712245, serviceable: "Yes", tier: "1" },
  { pincode: 712246, serviceable: "Yes", tier: "1" },
  { pincode: 712247, serviceable: "Yes", tier: "1" },
  { pincode: 712248, serviceable: "Yes", tier: "2" },
  { pincode: 712249, serviceable: "Yes", tier: "2" },
  { pincode: 712250, serviceable: "Yes", tier: "2" },
  { pincode: 712258, serviceable: "Yes", tier: "1" },
  { pincode: 712301, serviceable: "Yes", tier: "2" },
  { pincode: 712302, serviceable: "Yes", tier: "2" },
  { pincode: 712303, serviceable: "Yes", tier: "2" },
  { pincode: 712304, serviceable: "Yes", tier: "2" },
  { pincode: 712305, serviceable: "Yes", tier: "2" },
  { pincode: 712306, serviceable: "Yes", tier: "2" },
  { pincode: 712308, serviceable: "Yes", tier: "2" },
  { pincode: 712310, serviceable: "Yes", tier: "1" },
  { pincode: 712311, serviceable: "Yes", tier: "1" },
  { pincode: 712344, serviceable: "Yes", tier: "1" },
  { pincode: 712401, serviceable: "Yes", tier: "2" },
  { pincode: 712402, serviceable: "Yes", tier: "2" },
  { pincode: 712403, serviceable: "Yes", tier: "2" },
  { pincode: 712404, serviceable: "Yes", tier: "2" },
  { pincode: 712405, serviceable: "Yes", tier: "2" },
  { pincode: 712406, serviceable: "Yes", tier: "2" },
  { pincode: 712407, serviceable: "Yes", tier: "2" },
  { pincode: 712409, serviceable: "Yes", tier: "2" },
  { pincode: 712410, serviceable: "Yes", tier: "2" },
  { pincode: 712412, serviceable: "Yes", tier: "2" },
  { pincode: 712413, serviceable: "Yes", tier: "2" },
  { pincode: 712414, serviceable: "Yes", tier: "2" },
  { pincode: 712415, serviceable: "Yes", tier: "2" },
  { pincode: 712416, serviceable: "Yes", tier: "2" },
  { pincode: 712417, serviceable: "Yes", tier: "2" },
  { pincode: 712502, serviceable: "Yes", tier: "2" },
  { pincode: 712503, serviceable: "Yes", tier: "2" },
  { pincode: 712504, serviceable: "Yes", tier: "2" },
  { pincode: 712513, serviceable: "Yes", tier: "2" },
  { pincode: 712514, serviceable: "Yes", tier: "2" },
  { pincode: 712515, serviceable: "Yes", tier: "2" },
  { pincode: 712601, serviceable: "Yes", tier: "2" },
  { pincode: 712602, serviceable: "Yes", tier: "2" },
  { pincode: 712611, serviceable: "Yes", tier: "2" },
  { pincode: 712612, serviceable: "Yes", tier: "2" },
  { pincode: 712613, serviceable: "Yes", tier: "2" },
  { pincode: 712614, serviceable: "Yes", tier: "2" },
  { pincode: 712615, serviceable: "Yes", tier: "2" },
  { pincode: 712616, serviceable: "Yes", tier: "2" },
  { pincode: 712617, serviceable: "Yes", tier: "2" },
  { pincode: 712701, serviceable: "Yes", tier: "1" },
  { pincode: 712702, serviceable: "Yes", tier: "1" },
  { pincode: 712704, serviceable: "Yes", tier: "1" },
  { pincode: 712706, serviceable: "Yes", tier: "1" },
  { pincode: 713101, serviceable: "Yes", tier: "2" },
  { pincode: 713102, serviceable: "Yes", tier: "2" },
  { pincode: 713103, serviceable: "Yes", tier: "2" },
  { pincode: 713104, serviceable: "Yes", tier: "2" },
  { pincode: 713122, serviceable: "Yes", tier: "2" },
  { pincode: 713123, serviceable: "Yes", tier: "2" },
  { pincode: 713124, serviceable: "Yes", tier: "2" },
  { pincode: 713125, serviceable: "Yes", tier: "2" },
  { pincode: 713126, serviceable: "Yes", tier: "2" },
  { pincode: 713127, serviceable: "Yes", tier: "2" },
  { pincode: 713128, serviceable: "Yes", tier: "2" },
  { pincode: 713129, serviceable: "Yes", tier: "2" },
  { pincode: 713130, serviceable: "Yes", tier: "2" },
  { pincode: 713131, serviceable: "Yes", tier: "2" },
  { pincode: 713140, serviceable: "Yes", tier: "2" },
  { pincode: 713141, serviceable: "Yes", tier: "2" },
  { pincode: 713142, serviceable: "Yes", tier: "2" },
  { pincode: 713143, serviceable: "Yes", tier: "2" },
  { pincode: 713145, serviceable: "Yes", tier: "2" },
  { pincode: 713146, serviceable: "Yes", tier: "2" },
  { pincode: 713147, serviceable: "Yes", tier: "2" },
  { pincode: 713148, serviceable: "Yes", tier: "2" },
  { pincode: 713149, serviceable: "Yes", tier: "2" },
  { pincode: 713150, serviceable: "Yes", tier: "2" },
  { pincode: 713151, serviceable: "Yes", tier: "2" },
  { pincode: 713154, serviceable: "Yes", tier: "2" },
  { pincode: 713156, serviceable: "Yes", tier: "2" },
  { pincode: 713158, serviceable: "Yes", tier: "2" },
  { pincode: 713165, serviceable: "Yes", tier: "2" },
  { pincode: 713166, serviceable: "Yes", tier: "2" },
  { pincode: 713168, serviceable: "Yes", tier: "2" },
  { pincode: 713173, serviceable: "Yes", tier: "2" },
  { pincode: 713201, serviceable: "Yes", tier: "2" },
  { pincode: 713202, serviceable: "Yes", tier: "2" },
  { pincode: 713203, serviceable: "Yes", tier: "2" },
  { pincode: 713204, serviceable: "Yes", tier: "2" },
  { pincode: 713205, serviceable: "Yes", tier: "2" },
  { pincode: 713206, serviceable: "Yes", tier: "2" },
  { pincode: 713207, serviceable: "Yes", tier: "2" },
  { pincode: 713208, serviceable: "Yes", tier: "2" },
  { pincode: 713209, serviceable: "Yes", tier: "2" },
  { pincode: 713210, serviceable: "Yes", tier: "2" },
  { pincode: 713211, serviceable: "Yes", tier: "2" },
  { pincode: 713212, serviceable: "Yes", tier: "2" },
  { pincode: 713213, serviceable: "Yes", tier: "2" },
  { pincode: 713214, serviceable: "Yes", tier: "2" },
  { pincode: 713215, serviceable: "Yes", tier: "2" },
  { pincode: 713216, serviceable: "Yes", tier: "2" },
  { pincode: 713217, serviceable: "Yes", tier: "2" },
  { pincode: 713218, serviceable: "Yes", tier: "2" },
  { pincode: 713219, serviceable: "Yes", tier: "2" },
  { pincode: 713301, serviceable: "Yes", tier: "2" },
  { pincode: 713302, serviceable: "Yes", tier: "2" },
  { pincode: 713303, serviceable: "Yes", tier: "2" },
  { pincode: 713304, serviceable: "Yes", tier: "2" },
  { pincode: 713305, serviceable: "Yes", tier: "3" },
  { pincode: 713315, serviceable: "Yes", tier: "2" },
  { pincode: 713321, serviceable: "Yes", tier: "2" },
  { pincode: 713322, serviceable: "Yes", tier: "2" },
  { pincode: 713323, serviceable: "Yes", tier: "2" },
  { pincode: 713324, serviceable: "Yes", tier: "2" },
  { pincode: 713325, serviceable: "Yes", tier: "2" },
  { pincode: 713326, serviceable: "Yes", tier: "2" },
  { pincode: 713330, serviceable: "Yes", tier: "2" },
  { pincode: 713331, serviceable: "Yes", tier: "2" },
  { pincode: 713332, serviceable: "Yes", tier: "2" },
  { pincode: 713333, serviceable: "Yes", tier: "2" },
  { pincode: 713334, serviceable: "Yes", tier: "2" },
  { pincode: 713335, serviceable: "Yes", tier: "2" },
  { pincode: 713336, serviceable: "Yes", tier: "2" },
  { pincode: 713337, serviceable: "Yes", tier: "2" },
  { pincode: 713338, serviceable: "Yes", tier: "2" },
  { pincode: 713339, serviceable: "Yes", tier: "2" },
  { pincode: 713340, serviceable: "Yes", tier: "2" },
  { pincode: 713341, serviceable: "Yes", tier: "2" },
  { pincode: 713342, serviceable: "Yes", tier: "2" },
  { pincode: 713343, serviceable: "Yes", tier: "2" },
  { pincode: 713347, serviceable: "Yes", tier: "2" },
  { pincode: 713357, serviceable: "Yes", tier: "2" },
  { pincode: 713358, serviceable: "Yes", tier: "2" },
  { pincode: 713359, serviceable: "Yes", tier: "2" },
  { pincode: 713360, serviceable: "Yes", tier: "2" },
  { pincode: 713361, serviceable: "Yes", tier: "2" },
  { pincode: 713362, serviceable: "Yes", tier: "2" },
  { pincode: 713363, serviceable: "Yes", tier: "2" },
  { pincode: 713365, serviceable: "Yes", tier: "2" },
  { pincode: 713369, serviceable: "Yes", tier: "2" },
  { pincode: 713371, serviceable: "Yes", tier: "2" },
  { pincode: 713372, serviceable: "Yes", tier: "2" },
  { pincode: 713373, serviceable: "Yes", tier: "2" },
  { pincode: 713376, serviceable: "Yes", tier: "2" },
  { pincode: 713378, serviceable: "Yes", tier: "2" },
  { pincode: 713380, serviceable: "Yes", tier: "2" },
  { pincode: 713384, serviceable: "Yes", tier: "2" },
  { pincode: 713386, serviceable: "Yes", tier: "2" },
  { pincode: 713401, serviceable: "Yes", tier: "2" },
  { pincode: 713402, serviceable: "Yes", tier: "2" },
  { pincode: 713403, serviceable: "Yes", tier: "2" },
  { pincode: 713404, serviceable: "Yes", tier: "2" },
  { pincode: 713405, serviceable: "Yes", tier: "2" },
  { pincode: 713406, serviceable: "Yes", tier: "2" },
  { pincode: 713407, serviceable: "Yes", tier: "2" },
  { pincode: 713408, serviceable: "Yes", tier: "2" },
  { pincode: 713409, serviceable: "Yes", tier: "2" },
  { pincode: 713420, serviceable: "Yes", tier: "2" },
  { pincode: 713422, serviceable: "Yes", tier: "2" },
  { pincode: 713425, serviceable: "Yes", tier: "2" },
  { pincode: 713426, serviceable: "Yes", tier: "2" },
  { pincode: 713428, serviceable: "Yes", tier: "2" },
  { pincode: 713429, serviceable: "Yes", tier: "2" },
  { pincode: 713433, serviceable: "Yes", tier: "2" },
  { pincode: 713502, serviceable: "Yes", tier: "2" },
  { pincode: 713512, serviceable: "Yes", tier: "2" },
  { pincode: 713513, serviceable: "Yes", tier: "2" },
  { pincode: 713514, serviceable: "Yes", tier: "2" },
  { pincode: 713515, serviceable: "Yes", tier: "2" },
  { pincode: 713516, serviceable: "Yes", tier: "2" },
  { pincode: 713517, serviceable: "Yes", tier: "2" },
  { pincode: 713519, serviceable: "Yes", tier: "2" },
  { pincode: 713520, serviceable: "Yes", tier: "2" },
  { pincode: 721101, serviceable: "Yes", tier: "2" },
  { pincode: 721121, serviceable: "Yes", tier: "2" },
  { pincode: 721124, serviceable: "Yes", tier: "2" },
  { pincode: 721126, serviceable: "Yes", tier: "2" },
  { pincode: 721127, serviceable: "Yes", tier: "2" },
  { pincode: 721128, serviceable: "Yes", tier: "2" },
  { pincode: 721129, serviceable: "Yes", tier: "2" },
  { pincode: 721130, serviceable: "Yes", tier: "2" },
  { pincode: 721131, serviceable: "Yes", tier: "2" },
  { pincode: 721132, serviceable: "Yes", tier: "2" },
  { pincode: 721133, serviceable: "Yes", tier: "2" },
  { pincode: 721134, serviceable: "Yes", tier: "2" },
  { pincode: 721135, serviceable: "Yes", tier: "2" },
  { pincode: 721136, serviceable: "Yes", tier: "2" },
  { pincode: 721137, serviceable: "Yes", tier: "2" },
  { pincode: 721139, serviceable: "Yes", tier: "2" },
  { pincode: 721140, serviceable: "Yes", tier: "2" },
  { pincode: 721144, serviceable: "Yes", tier: "2" },
  { pincode: 721145, serviceable: "Yes", tier: "2" },
  { pincode: 721146, serviceable: "Yes", tier: "2" },
  { pincode: 721147, serviceable: "Yes", tier: "2" },
  { pincode: 721148, serviceable: "Yes", tier: "2" },
  { pincode: 721149, serviceable: "Yes", tier: "2" },
  { pincode: 721150, serviceable: "Yes", tier: "2" },
  { pincode: 721151, serviceable: "Yes", tier: "2" },
  { pincode: 721152, serviceable: "Yes", tier: "2" },
  { pincode: 721153, serviceable: "Yes", tier: "2" },
  { pincode: 721154, serviceable: "Yes", tier: "2" },
  { pincode: 721156, serviceable: "Yes", tier: "2" },
  { pincode: 721157, serviceable: "Yes", tier: "2" },
  { pincode: 721158, serviceable: "Yes", tier: "2" },
  { pincode: 721159, serviceable: "Yes", tier: "2" },
  { pincode: 721160, serviceable: "Yes", tier: "2" },
  { pincode: 721166, serviceable: "Yes", tier: "2" },
  { pincode: 721167, serviceable: "Yes", tier: "2" },
  { pincode: 721168, serviceable: "Yes", tier: "2" },
  { pincode: 721171, serviceable: "Yes", tier: "2" },
  { pincode: 721172, serviceable: "Yes", tier: "2" },
  { pincode: 721201, serviceable: "Yes", tier: "2" },
  { pincode: 721211, serviceable: "Yes", tier: "2" },
  { pincode: 721212, serviceable: "Yes", tier: "2" },
  { pincode: 721222, serviceable: "Yes", tier: "2" },
  { pincode: 721232, serviceable: "Yes", tier: "2" },
  { pincode: 721253, serviceable: "Yes", tier: "2" },
  { pincode: 721260, serviceable: "Yes", tier: "2" },
  { pincode: 721301, serviceable: "Yes", tier: "2" },
  { pincode: 721302, serviceable: "Yes", tier: "2" },
  { pincode: 721303, serviceable: "Yes", tier: "2" },
  { pincode: 721304, serviceable: "Yes", tier: "2" },
  { pincode: 721305, serviceable: "Yes", tier: "2" },
  { pincode: 721306, serviceable: "Yes", tier: "2" },
  { pincode: 721401, serviceable: "Yes", tier: "2" },
  { pincode: 721420, serviceable: "Yes", tier: "2" },
  { pincode: 721422, serviceable: "Yes", tier: "2" },
  { pincode: 721423, serviceable: "Yes", tier: "2" },
  { pincode: 721424, serviceable: "Yes", tier: "2" },
  { pincode: 721425, serviceable: "Yes", tier: "2" },
  { pincode: 721426, serviceable: "Yes", tier: "2" },
  { pincode: 721428, serviceable: "Yes", tier: "2" },
  { pincode: 721429, serviceable: "Yes", tier: "2" },
  { pincode: 721430, serviceable: "Yes", tier: "2" },
  { pincode: 721431, serviceable: "Yes", tier: "2" },
  { pincode: 721432, serviceable: "Yes", tier: "2" },
  { pincode: 721433, serviceable: "Yes", tier: "2" },
  { pincode: 721434, serviceable: "Yes", tier: "2" },
  { pincode: 721435, serviceable: "Yes", tier: "2" },
  { pincode: 721436, serviceable: "Yes", tier: "2" },
  { pincode: 721437, serviceable: "Yes", tier: "2" },
  { pincode: 721438, serviceable: "Yes", tier: "2" },
  { pincode: 721439, serviceable: "Yes", tier: "2" },
  { pincode: 721440, serviceable: "Yes", tier: "2" },
  { pincode: 721441, serviceable: "Yes", tier: "2" },
  { pincode: 721442, serviceable: "Yes", tier: "2" },
  { pincode: 721443, serviceable: "Yes", tier: "2" },
  { pincode: 721444, serviceable: "Yes", tier: "2" },
  { pincode: 721445, serviceable: "Yes", tier: "2" },
  { pincode: 721446, serviceable: "Yes", tier: "2" },
  { pincode: 721449, serviceable: "Yes", tier: "2" },
  { pincode: 721450, serviceable: "Yes", tier: "2" },
  { pincode: 721451, serviceable: "Yes", tier: "2" },
  { pincode: 721452, serviceable: "Yes", tier: "2" },
  { pincode: 721454, serviceable: "Yes", tier: "2" },
  { pincode: 721455, serviceable: "Yes", tier: "2" },
  { pincode: 721457, serviceable: "Yes", tier: "2" },
  { pincode: 721463, serviceable: "Yes", tier: "2" },
  { pincode: 721467, serviceable: "Yes", tier: "2" },
  { pincode: 721503, serviceable: "Yes", tier: "2" },
  { pincode: 721504, serviceable: "Yes", tier: "2" },
  { pincode: 721505, serviceable: "Yes", tier: "2" },
  { pincode: 721507, serviceable: "Yes", tier: "2" },
  { pincode: 721513, serviceable: "Yes", tier: "2" },
  { pincode: 721514, serviceable: "Yes", tier: "2" },
  { pincode: 721515, serviceable: "Yes", tier: "2" },
  { pincode: 721517, serviceable: "Yes", tier: "2" },
  { pincode: 721602, serviceable: "Yes", tier: "2" },
  { pincode: 721603, serviceable: "Yes", tier: "2" },
  { pincode: 721604, serviceable: "Yes", tier: "2" },
  { pincode: 721605, serviceable: "Yes", tier: "2" },
  { pincode: 721606, serviceable: "Yes", tier: "2" },
  { pincode: 721607, serviceable: "Yes", tier: "2" },
  { pincode: 721625, serviceable: "Yes", tier: "2" },
  { pincode: 721627, serviceable: "Yes", tier: "2" },
  { pincode: 721628, serviceable: "Yes", tier: "2" },
  { pincode: 721629, serviceable: "Yes", tier: "2" },
  { pincode: 721632, serviceable: "Yes", tier: "2" },
  { pincode: 721633, serviceable: "Yes", tier: "2" },
  { pincode: 721634, serviceable: "Yes", tier: "2" },
  { pincode: 721635, serviceable: "Yes", tier: "2" },
  { pincode: 721636, serviceable: "Yes", tier: "2" },
  { pincode: 721641, serviceable: "Yes", tier: "2" },
  { pincode: 721642, serviceable: "Yes", tier: "2" },
  { pincode: 721643, serviceable: "Yes", tier: "2" },
  { pincode: 721644, serviceable: "Yes", tier: "2" },
  { pincode: 721645, serviceable: "Yes", tier: "2" },
  { pincode: 721646, serviceable: "Yes", tier: "2" },
  { pincode: 721647, serviceable: "Yes", tier: "2" },
  { pincode: 721648, serviceable: "Yes", tier: "2" },
  { pincode: 721649, serviceable: "Yes", tier: "2" },
  { pincode: 721652, serviceable: "Yes", tier: "2" },
  { pincode: 721653, serviceable: "Yes", tier: "2" },
  { pincode: 721654, serviceable: "Yes", tier: "2" },
  { pincode: 721657, serviceable: "Yes", tier: "2" },
  { pincode: 721664, serviceable: "Yes", tier: "2" },
  { pincode: 722101, serviceable: "Yes", tier: "2" },
  { pincode: 722102, serviceable: "Yes", tier: "2" },
  { pincode: 722107, serviceable: "Yes", tier: "2" },
  { pincode: 722110, serviceable: "Yes", tier: "2" },
  { pincode: 722111, serviceable: "Yes", tier: "2" },
  { pincode: 722112, serviceable: "Yes", tier: "2" },
  { pincode: 722121, serviceable: "Yes", tier: "2" },
  { pincode: 722122, serviceable: "Yes", tier: "2" },
  { pincode: 722132, serviceable: "Yes", tier: "2" },
  { pincode: 722133, serviceable: "Yes", tier: "2" },
  { pincode: 722135, serviceable: "Yes", tier: "2" },
  { pincode: 722136, serviceable: "Yes", tier: "2" },
  { pincode: 722137, serviceable: "Yes", tier: "2" },
  { pincode: 722138, serviceable: "Yes", tier: "2" },
  { pincode: 722139, serviceable: "Yes", tier: "2" },
  { pincode: 722140, serviceable: "Yes", tier: "2" },
  { pincode: 722144, serviceable: "Yes", tier: "2" },
  { pincode: 722145, serviceable: "Yes", tier: "2" },
  { pincode: 722146, serviceable: "Yes", tier: "2" },
  { pincode: 722147, serviceable: "Yes", tier: "2" },
  { pincode: 722148, serviceable: "Yes", tier: "2" },
  { pincode: 722149, serviceable: "Yes", tier: "2" },
  { pincode: 722151, serviceable: "Yes", tier: "2" },
  { pincode: 722152, serviceable: "Yes", tier: "2" },
  { pincode: 722154, serviceable: "Yes", tier: "2" },
  { pincode: 722155, serviceable: "Yes", tier: "2" },
  { pincode: 722156, serviceable: "Yes", tier: "2" },
  { pincode: 722157, serviceable: "Yes", tier: "2" },
  { pincode: 722158, serviceable: "Yes", tier: "2" },
  { pincode: 722160, serviceable: "Yes", tier: "2" },
  { pincode: 722162, serviceable: "Yes", tier: "2" },
  { pincode: 722163, serviceable: "Yes", tier: "2" },
  { pincode: 722164, serviceable: "Yes", tier: "2" },
  { pincode: 722165, serviceable: "Yes", tier: "2" },
  { pincode: 722169, serviceable: "Yes", tier: "2" },
  { pincode: 722170, serviceable: "Yes", tier: "2" },
  { pincode: 722171, serviceable: "Yes", tier: "2" },
  { pincode: 722172, serviceable: "Yes", tier: "2" },
  { pincode: 722173, serviceable: "Yes", tier: "2" },
  { pincode: 722174, serviceable: "Yes", tier: "2" },
  { pincode: 722175, serviceable: "Yes", tier: "2" },
  { pincode: 722176, serviceable: "Yes", tier: "2" },
  { pincode: 722178, serviceable: "Yes", tier: "2" },
  { pincode: 722179, serviceable: "Yes", tier: "2" },
  { pincode: 722180, serviceable: "Yes", tier: "2" },
  { pincode: 722181, serviceable: "Yes", tier: "2" },
  { pincode: 722182, serviceable: "Yes", tier: "2" },
  { pincode: 722183, serviceable: "Yes", tier: "2" },
  { pincode: 722203, serviceable: "Yes", tier: "2" },
  { pincode: 722204, serviceable: "Yes", tier: "2" },
  { pincode: 722206, serviceable: "Yes", tier: "2" },
  { pincode: 722207, serviceable: "Yes", tier: "2" },
  { pincode: 722208, serviceable: "Yes", tier: "2" },
  { pincode: 722209, serviceable: "Yes", tier: "2" },
  { pincode: 723101, serviceable: "Yes", tier: "2" },
  { pincode: 723102, serviceable: "Yes", tier: "2" },
  { pincode: 723103, serviceable: "Yes", tier: "2" },
  { pincode: 723104, serviceable: "Yes", tier: "2" },
  { pincode: 723121, serviceable: "Yes", tier: "2" },
  { pincode: 723126, serviceable: "Yes", tier: "2" },
  { pincode: 723127, serviceable: "Yes", tier: "2" },
  { pincode: 723129, serviceable: "Yes", tier: "2" },
  { pincode: 723130, serviceable: "Yes", tier: "2" },
  { pincode: 723131, serviceable: "Yes", tier: "2" },
  { pincode: 723132, serviceable: "Yes", tier: "2" },
  { pincode: 723133, serviceable: "Yes", tier: "2" },
  { pincode: 723142, serviceable: "Yes", tier: "2" },
  { pincode: 723143, serviceable: "Yes", tier: "2" },
  { pincode: 723145, serviceable: "Yes", tier: "2" },
  { pincode: 723146, serviceable: "Yes", tier: "2" },
  { pincode: 723147, serviceable: "Yes", tier: "2" },
  { pincode: 723148, serviceable: "Yes", tier: "2" },
  { pincode: 723149, serviceable: "Yes", tier: "2" },
  { pincode: 723151, serviceable: "Yes", tier: "2" },
  { pincode: 723153, serviceable: "Yes", tier: "2" },
  { pincode: 723155, serviceable: "Yes", tier: "2" },
  { pincode: 723156, serviceable: "Yes", tier: "2" },
  { pincode: 723158, serviceable: "Yes", tier: "2" },
  { pincode: 723161, serviceable: "Yes", tier: "2" },
  { pincode: 723162, serviceable: "Yes", tier: "2" },
  { pincode: 723168, serviceable: "Yes", tier: "2" },
  { pincode: 723201, serviceable: "Yes", tier: "2" },
  { pincode: 727120, serviceable: "Yes", tier: "2" },
  { pincode: 731101, serviceable: "Yes", tier: "2" },
  { pincode: 731102, serviceable: "Yes", tier: "2" },
  { pincode: 731103, serviceable: "Yes", tier: "2" },
  { pincode: 731104, serviceable: "Yes", tier: "2" },
  { pincode: 731121, serviceable: "Yes", tier: "2" },
  { pincode: 731123, serviceable: "Yes", tier: "2" },
  { pincode: 731126, serviceable: "Yes", tier: "2" },
  { pincode: 731127, serviceable: "Yes", tier: "2" },
  { pincode: 731129, serviceable: "Yes", tier: "2" },
  { pincode: 731130, serviceable: "Yes", tier: "2" },
  { pincode: 731132, serviceable: "Yes", tier: "2" },
  { pincode: 731201, serviceable: "Yes", tier: "2" },
  { pincode: 731202, serviceable: "Yes", tier: "2" },
  { pincode: 731204, serviceable: "Yes", tier: "2" },
  { pincode: 731215, serviceable: "Yes", tier: "2" },
  { pincode: 731216, serviceable: "Yes", tier: "2" },
  { pincode: 731219, serviceable: "Yes", tier: "2" },
  { pincode: 731220, serviceable: "Yes", tier: "2" },
  { pincode: 731223, serviceable: "Yes", tier: "2" },
  { pincode: 731224, serviceable: "Yes", tier: "2" },
  { pincode: 731233, serviceable: "Yes", tier: "2" },
  { pincode: 731234, serviceable: "Yes", tier: "2" },
  { pincode: 731235, serviceable: "Yes", tier: "2" },
  { pincode: 731236, serviceable: "Yes", tier: "2" },
  { pincode: 731237, serviceable: "Yes", tier: "2" },
  { pincode: 731238, serviceable: "Yes", tier: "2" },
  { pincode: 731240, serviceable: "Yes", tier: "2" },
  { pincode: 731241, serviceable: "Yes", tier: "2" },
  { pincode: 731242, serviceable: "Yes", tier: "2" },
  { pincode: 731243, serviceable: "Yes", tier: "2" },
  { pincode: 731244, serviceable: "Yes", tier: "2" },
  { pincode: 731245, serviceable: "Yes", tier: "2" },
  { pincode: 731301, serviceable: "Yes", tier: "2" },
  { pincode: 731302, serviceable: "Yes", tier: "2" },
  { pincode: 731303, serviceable: "Yes", tier: "2" },
  { pincode: 731304, serviceable: "Yes", tier: "2" },
  { pincode: 732101, serviceable: "Yes", tier: "2" },
  { pincode: 732102, serviceable: "Yes", tier: "2" },
  { pincode: 732103, serviceable: "Yes", tier: "2" },
  { pincode: 732121, serviceable: "Yes", tier: "2" },
  { pincode: 732122, serviceable: "Yes", tier: "2" },
  { pincode: 732123, serviceable: "Yes", tier: "3" },
  { pincode: 732124, serviceable: "Yes", tier: "3" },
  { pincode: 732125, serviceable: "Yes", tier: "3" },
  { pincode: 732126, serviceable: "Yes", tier: "3" },
  { pincode: 732127, serviceable: "Yes", tier: "3" },
  { pincode: 732128, serviceable: "Yes", tier: "2" },
  { pincode: 732138, serviceable: "Yes", tier: "3" },
  { pincode: 732139, serviceable: "Yes", tier: "3" },
  { pincode: 732140, serviceable: "Yes", tier: "3" },
  { pincode: 732141, serviceable: "Yes", tier: "2" },
  { pincode: 732142, serviceable: "Yes", tier: "2" },
  { pincode: 732143, serviceable: "Yes", tier: "2" },
  { pincode: 732144, serviceable: "Yes", tier: "2" },
  { pincode: 732147, serviceable: "Yes", tier: "3" },
  { pincode: 732150, serviceable: "Yes", tier: "3" },
  { pincode: 732201, serviceable: "Yes", tier: "2" },
  { pincode: 732202, serviceable: "Yes", tier: "2" },
  { pincode: 732203, serviceable: "Yes", tier: "2" },
  { pincode: 732204, serviceable: "Yes", tier: "3" },
  { pincode: 732205, serviceable: "Yes", tier: "3" },
  { pincode: 732206, serviceable: "Yes", tier: "2" },
  { pincode: 732207, serviceable: "Yes", tier: "2" },
  { pincode: 732208, serviceable: "Yes", tier: "2" },
  { pincode: 732209, serviceable: "Yes", tier: "2" },
  { pincode: 732210, serviceable: "Yes", tier: "3" },
  { pincode: 732211, serviceable: "Yes", tier: "2" },
  { pincode: 732212, serviceable: "Yes", tier: "2" },
  { pincode: 732213, serviceable: "Yes", tier: "3" },
  { pincode: 732214, serviceable: "Yes", tier: "3" },
  { pincode: 732215, serviceable: "Yes", tier: "3" },
  { pincode: 732216, serviceable: "Yes", tier: "2" },
  { pincode: 733101, serviceable: "Yes", tier: "3" },
  { pincode: 733102, serviceable: "Yes", tier: "3" },
  { pincode: 733103, serviceable: "Yes", tier: "3" },
  { pincode: 733121, serviceable: "Yes", tier: "3" },
  { pincode: 733123, serviceable: "Yes", tier: "3" },
  { pincode: 733124, serviceable: "Yes", tier: "3" },
  { pincode: 733125, serviceable: "Yes", tier: "3" },
  { pincode: 733126, serviceable: "Yes", tier: "3" },
  { pincode: 733127, serviceable: "Yes", tier: "3" },
  { pincode: 733128, serviceable: "Yes", tier: "3" },
  { pincode: 733129, serviceable: "Yes", tier: "3" },
  { pincode: 733130, serviceable: "Yes", tier: "3" },
  { pincode: 733131, serviceable: "Yes", tier: "3" },
  { pincode: 733132, serviceable: "Yes", tier: "3" },
  { pincode: 733133, serviceable: "Yes", tier: "3" },
  { pincode: 733134, serviceable: "Yes", tier: "3" },
  { pincode: 733140, serviceable: "Yes", tier: "3" },
  { pincode: 733141, serviceable: "Yes", tier: "3" },
  { pincode: 733142, serviceable: "Yes", tier: "3" },
  { pincode: 733143, serviceable: "Yes", tier: "3" },
  { pincode: 733145, serviceable: "Yes", tier: "3" },
  { pincode: 733151, serviceable: "Yes", tier: "3" },
  { pincode: 733153, serviceable: "Yes", tier: "3" },
  { pincode: 733155, serviceable: "Yes", tier: "3" },
  { pincode: 733156, serviceable: "Yes", tier: "3" },
  { pincode: 733158, serviceable: "Yes", tier: "3" },
  { pincode: 733201, serviceable: "Yes", tier: "3" },
  { pincode: 733202, serviceable: "Yes", tier: "3" },
  { pincode: 733207, serviceable: "Yes", tier: "3" },
  { pincode: 733208, serviceable: "Yes", tier: "3" },
  { pincode: 733209, serviceable: "Yes", tier: "3" },
  { pincode: 733210, serviceable: "Yes", tier: "3" },
  { pincode: 733214, serviceable: "Yes", tier: "3" },
  { pincode: 733215, serviceable: "Yes", tier: "3" },
  { pincode: 733216, serviceable: "Yes", tier: "3" },
  { pincode: 734001, serviceable: "Yes", tier: "3" },
  { pincode: 734002, serviceable: "Yes", tier: "3" },
  { pincode: 734003, serviceable: "Yes", tier: "3" },
  { pincode: 734004, serviceable: "Yes", tier: "3" },
  { pincode: 734005, serviceable: "Yes", tier: "3" },
  { pincode: 734006, serviceable: "Yes", tier: "3" },
  { pincode: 734007, serviceable: "Yes", tier: "3" },
  { pincode: 734008, serviceable: "Yes", tier: "3" },
  { pincode: 734009, serviceable: "Yes", tier: "3" },
  { pincode: 734010, serviceable: "Yes", tier: "3" },
  { pincode: 734011, serviceable: "Yes", tier: "3" },
  { pincode: 734012, serviceable: "Yes", tier: "3" },
  { pincode: 734013, serviceable: "Yes", tier: "3" },
  { pincode: 734014, serviceable: "Yes", tier: "3" },
  { pincode: 734015, serviceable: "Yes", tier: "3" },
  { pincode: 734101, serviceable: "Yes", tier: "3" },
  { pincode: 734121, serviceable: "Yes", tier: "3" },
  { pincode: 734124, serviceable: "Yes", tier: "3" },
  { pincode: 734201, serviceable: "Yes", tier: "3" },
  { pincode: 734203, serviceable: "Yes", tier: "5" },
  { pincode: 734216, serviceable: "Yes", tier: "3" },
  { pincode: 734219, serviceable: "Yes", tier: "3" },
  { pincode: 734301, serviceable: "Yes", tier: "3" },
  { pincode: 734333, serviceable: "Yes", tier: "3" },
  { pincode: 734401, serviceable: "Yes", tier: "3" },
  { pincode: 734403, serviceable: "Yes", tier: "3" },
  { pincode: 734404, serviceable: "Yes", tier: "3" },
  { pincode: 734405, serviceable: "Yes", tier: "3" },
  { pincode: 734421, serviceable: "Yes", tier: "3" },
  { pincode: 734422, serviceable: "Yes", tier: "3" },
  { pincode: 734423, serviceable: "Yes", tier: "3" },
  { pincode: 734424, serviceable: "Yes", tier: "3" },
  { pincode: 734426, serviceable: "Yes", tier: "3" },
  { pincode: 734427, serviceable: "Yes", tier: "3" },
  { pincode: 734429, serviceable: "Yes", tier: "3" },
  { pincode: 734431, serviceable: "Yes", tier: "3" },
  { pincode: 734434, serviceable: "Yes", tier: "3" },
  { pincode: 734436, serviceable: "Yes", tier: "3" },
  { pincode: 734501, serviceable: "Yes", tier: "3" },
  { pincode: 735101, serviceable: "Yes", tier: "3" },
  { pincode: 735102, serviceable: "Yes", tier: "3" },
  { pincode: 735121, serviceable: "Yes", tier: "3" },
  { pincode: 735122, serviceable: "Yes", tier: "3" },
  { pincode: 735132, serviceable: "Yes", tier: "3" },
  { pincode: 735133, serviceable: "Yes", tier: "3" },
  { pincode: 735134, serviceable: "Yes", tier: "3" },
  { pincode: 735135, serviceable: "Yes", tier: "3" },
  { pincode: 735139, serviceable: "Yes", tier: "3" },
  { pincode: 735140, serviceable: "Yes", tier: "3" },
  { pincode: 735202, serviceable: "Yes", tier: "3" },
  { pincode: 735203, serviceable: "Yes", tier: "3" },
  { pincode: 735204, serviceable: "Yes", tier: "5" },
  { pincode: 735205, serviceable: "Yes", tier: "3" },
  { pincode: 735206, serviceable: "Yes", tier: "3" },
  { pincode: 735207, serviceable: "Yes", tier: "3" },
  { pincode: 735208, serviceable: "Yes", tier: "5" },
  { pincode: 735209, serviceable: "Yes", tier: "3" },
  { pincode: 735210, serviceable: "Yes", tier: "3" },
  { pincode: 735211, serviceable: "Yes", tier: "3" },
  { pincode: 735212, serviceable: "Yes", tier: "3" },
  { pincode: 735213, serviceable: "Yes", tier: "3" },
  { pincode: 735214, serviceable: "Yes", tier: "3" },
  { pincode: 735215, serviceable: "Yes", tier: "3" },
  { pincode: 735216, serviceable: "Yes", tier: "3" },
  { pincode: 735217, serviceable: "Yes", tier: "3" },
  { pincode: 735218, serviceable: "Yes", tier: "3" },
  { pincode: 735219, serviceable: "Yes", tier: "3" },
  { pincode: 735220, serviceable: "Yes", tier: "3" },
  { pincode: 735221, serviceable: "Yes", tier: "3" },
  { pincode: 735222, serviceable: "Yes", tier: "3" },
  { pincode: 735223, serviceable: "Yes", tier: "3" },
  { pincode: 735224, serviceable: "Yes", tier: "3" },
  { pincode: 735225, serviceable: "Yes", tier: "3" },
  { pincode: 735226, serviceable: "Yes", tier: "3" },
  { pincode: 735227, serviceable: "Yes", tier: "3" },
  { pincode: 735228, serviceable: "Yes", tier: "3" },
  { pincode: 735229, serviceable: "Yes", tier: "3" },
  { pincode: 735230, serviceable: "Yes", tier: "3" },
  { pincode: 735232, serviceable: "Yes", tier: "3" },
  { pincode: 735233, serviceable: "Yes", tier: "3" },
  { pincode: 735234, serviceable: "Yes", tier: "3" },
  { pincode: 735301, serviceable: "Yes", tier: "3" },
  { pincode: 735302, serviceable: "Yes", tier: "3" },
  { pincode: 735304, serviceable: "Yes", tier: "3" },
  { pincode: 735305, serviceable: "Yes", tier: "3" },
  { pincode: 736101, serviceable: "Yes", tier: "5" },
  { pincode: 736121, serviceable: "Yes", tier: "3" },
  { pincode: 736122, serviceable: "Yes", tier: "3" },
  { pincode: 736123, serviceable: "Yes", tier: "3" },
  { pincode: 736133, serviceable: "Yes", tier: "3" },
  { pincode: 736134, serviceable: "Yes", tier: "3" },
  { pincode: 736135, serviceable: "Yes", tier: "5" },
  { pincode: 736145, serviceable: "Yes", tier: "3" },
  { pincode: 736146, serviceable: "Yes", tier: "3" },
  { pincode: 736156, serviceable: "Yes", tier: "5" },
  { pincode: 736157, serviceable: "Yes", tier: "3" },
  { pincode: 736158, serviceable: "Yes", tier: "3" },
  { pincode: 736159, serviceable: "Yes", tier: "3" },
  { pincode: 736160, serviceable: "Yes", tier: "3" },
  { pincode: 736169, serviceable: "Yes", tier: "3" },
  { pincode: 736170, serviceable: "Yes", tier: "3" },
  { pincode: 736171, serviceable: "Yes", tier: "3" },
  { pincode: 736172, serviceable: "Yes", tier: "3" },
  { pincode: 736179, serviceable: "Yes", tier: "5" },
  { pincode: 736182, serviceable: "Yes", tier: "5" },
  { pincode: 736206, serviceable: "Yes", tier: "3" },
  { pincode: 736208, serviceable: "Yes", tier: "3" },
  { pincode: 737101, serviceable: "Yes", tier: "5" },
  { pincode: 737102, serviceable: "Yes", tier: "5" },
  { pincode: 737103, serviceable: "Yes", tier: "5" },
  { pincode: 737121, serviceable: "Yes", tier: "3" },
  { pincode: 737132, serviceable: "Yes", tier: "3" },
  { pincode: 737134, serviceable: "Yes", tier: "3" },
  { pincode: 737135, serviceable: "Yes", tier: "5" },
  { pincode: 737136, serviceable: "Yes", tier: "3" },
  { pincode: 741101, serviceable: "Yes", tier: "2" },
  { pincode: 741102, serviceable: "Yes", tier: "2" },
  { pincode: 741103, serviceable: "Yes", tier: "2" },
  { pincode: 741121, serviceable: "Yes", tier: "2" },
  { pincode: 741122, serviceable: "Yes", tier: "2" },
  { pincode: 741123, serviceable: "Yes", tier: "2" },
  { pincode: 741124, serviceable: "Yes", tier: "2" },
  { pincode: 741125, serviceable: "Yes", tier: "2" },
  { pincode: 741126, serviceable: "Yes", tier: "2" },
  { pincode: 741127, serviceable: "Yes", tier: "2" },
  { pincode: 741137, serviceable: "Yes", tier: "2" },
  { pincode: 741138, serviceable: "Yes", tier: "2" },
  { pincode: 741139, serviceable: "Yes", tier: "2" },
  { pincode: 741140, serviceable: "Yes", tier: "2" },
  { pincode: 741150, serviceable: "Yes", tier: "2" },
  { pincode: 741151, serviceable: "Yes", tier: "2" },
  { pincode: 741152, serviceable: "Yes", tier: "2" },
  { pincode: 741153, serviceable: "Yes", tier: "2" },
  { pincode: 741154, serviceable: "Yes", tier: "2" },
  { pincode: 741155, serviceable: "Yes", tier: "2" },
  { pincode: 741156, serviceable: "Yes", tier: "2" },
  { pincode: 741157, serviceable: "Yes", tier: "2" },
  { pincode: 741159, serviceable: "Yes", tier: "2" },
  { pincode: 741160, serviceable: "Yes", tier: "2" },
  { pincode: 741161, serviceable: "Yes", tier: "2" },
  { pincode: 741162, serviceable: "Yes", tier: "2" },
  { pincode: 741163, serviceable: "Yes", tier: "2" },
  { pincode: 741164, serviceable: "Yes", tier: "2" },
  { pincode: 741165, serviceable: "Yes", tier: "2" },
  { pincode: 741166, serviceable: "Yes", tier: "2" },
  { pincode: 741181, serviceable: "Yes", tier: "2" },
  { pincode: 741201, serviceable: "Yes", tier: "2" },
  { pincode: 741202, serviceable: "Yes", tier: "2" },
  { pincode: 741221, serviceable: "Yes", tier: "2" },
  { pincode: 741222, serviceable: "Yes", tier: "2" },
  { pincode: 741223, serviceable: "Yes", tier: "2" },
  { pincode: 741225, serviceable: "Yes", tier: "2" },
  { pincode: 741232, serviceable: "Yes", tier: "2" },
  { pincode: 741234, serviceable: "Yes", tier: "2" },
  { pincode: 741235, serviceable: "Yes", tier: "2" },
  { pincode: 741238, serviceable: "Yes", tier: "2" },
  { pincode: 741245, serviceable: "Yes", tier: "2" },
  { pincode: 741246, serviceable: "Yes", tier: "2" },
  { pincode: 741247, serviceable: "Yes", tier: "2" },
  { pincode: 741248, serviceable: "Yes", tier: "2" },
  { pincode: 741249, serviceable: "Yes", tier: "2" },
  { pincode: 741250, serviceable: "Yes", tier: "2" },
  { pincode: 741251, serviceable: "Yes", tier: "2" },
  { pincode: 741252, serviceable: "Yes", tier: "2" },
  { pincode: 741253, serviceable: "Yes", tier: "2" },
  { pincode: 741254, serviceable: "Yes", tier: "2" },
  { pincode: 741255, serviceable: "Yes", tier: "2" },
  { pincode: 741256, serviceable: "Yes", tier: "2" },
  { pincode: 741257, serviceable: "Yes", tier: "2" },
  { pincode: 741301, serviceable: "Yes", tier: "2" },
  { pincode: 741302, serviceable: "Yes", tier: "2" },
  { pincode: 741313, serviceable: "Yes", tier: "2" },
  { pincode: 741315, serviceable: "Yes", tier: "2" },
  { pincode: 741317, serviceable: "Yes", tier: "2" },
  { pincode: 741319, serviceable: "Yes", tier: "2" },
  { pincode: 741401, serviceable: "Yes", tier: "2" },
  { pincode: 741402, serviceable: "Yes", tier: "2" },
  { pincode: 741404, serviceable: "Yes", tier: "2" },
  { pincode: 741501, serviceable: "Yes", tier: "2" },
  { pincode: 741502, serviceable: "Yes", tier: "2" },
  { pincode: 741504, serviceable: "Yes", tier: "2" },
  { pincode: 741506, serviceable: "Yes", tier: "2" },
  { pincode: 741507, serviceable: "Yes", tier: "2" },
  { pincode: 741508, serviceable: "Yes", tier: "2" },
  { pincode: 741509, serviceable: "Yes", tier: "2" },
  { pincode: 742101, serviceable: "Yes", tier: "2" },
  { pincode: 742102, serviceable: "Yes", tier: "2" },
  { pincode: 742103, serviceable: "Yes", tier: "2" },
  { pincode: 742104, serviceable: "Yes", tier: "2" },
  { pincode: 742113, serviceable: "Yes", tier: "2" },
  { pincode: 742122, serviceable: "Yes", tier: "2" },
  { pincode: 742123, serviceable: "Yes", tier: "2" },
  { pincode: 742132, serviceable: "Yes", tier: "2" },
  { pincode: 742133, serviceable: "Yes", tier: "2" },
  { pincode: 742134, serviceable: "Yes", tier: "2" },
  { pincode: 742136, serviceable: "Yes", tier: "2" },
  { pincode: 742137, serviceable: "Yes", tier: "2" },
  { pincode: 742138, serviceable: "Yes", tier: "2" },
  { pincode: 742140, serviceable: "Yes", tier: "2" },
  { pincode: 742147, serviceable: "Yes", tier: "2" },
  { pincode: 742148, serviceable: "Yes", tier: "2" },
  { pincode: 742149, serviceable: "Yes", tier: "2" },
  { pincode: 742151, serviceable: "Yes", tier: "2" },
  { pincode: 742159, serviceable: "Yes", tier: "2" },
  { pincode: 742160, serviceable: "Yes", tier: "2" },
  { pincode: 742161, serviceable: "Yes", tier: "2" },
  { pincode: 742163, serviceable: "Yes", tier: "2" },
  { pincode: 742164, serviceable: "Yes", tier: "2" },
  { pincode: 742165, serviceable: "Yes", tier: "2" },
  { pincode: 742166, serviceable: "Yes", tier: "2" },
  { pincode: 742168, serviceable: "Yes", tier: "2" },
  { pincode: 742174, serviceable: "Yes", tier: "2" },
  { pincode: 742175, serviceable: "Yes", tier: "2" },
  { pincode: 742187, serviceable: "Yes", tier: "2" },
  { pincode: 742201, serviceable: "Yes", tier: "2" },
  { pincode: 742202, serviceable: "Yes", tier: "2" },
  { pincode: 742212, serviceable: "Yes", tier: "3" },
  { pincode: 742213, serviceable: "Yes", tier: "2" },
  { pincode: 742223, serviceable: "Yes", tier: "2" },
  { pincode: 742224, serviceable: "Yes", tier: "2" },
  { pincode: 742225, serviceable: "Yes", tier: "2" },
  { pincode: 742226, serviceable: "Yes", tier: "2" },
  { pincode: 742227, serviceable: "Yes", tier: "2" },
  { pincode: 742229, serviceable: "Yes", tier: "2" },
  { pincode: 742235, serviceable: "Yes", tier: "2" },
  { pincode: 742236, serviceable: "Yes", tier: "3" },
  { pincode: 742237, serviceable: "Yes", tier: "2" },
  { pincode: 742238, serviceable: "Yes", tier: "2" },
  { pincode: 742301, serviceable: "Yes", tier: "2" },
  { pincode: 742302, serviceable: "Yes", tier: "2" },
  { pincode: 742303, serviceable: "Yes", tier: "2" },
  { pincode: 742304, serviceable: "Yes", tier: "2" },
  { pincode: 742305, serviceable: "Yes", tier: "2" },
  { pincode: 742306, serviceable: "Yes", tier: "2" },
  { pincode: 742308, serviceable: "Yes", tier: "2" },
  { pincode: 742401, serviceable: "Yes", tier: "2" },
  { pincode: 742402, serviceable: "Yes", tier: "2" },
  { pincode: 742404, serviceable: "Yes", tier: "2" },
  { pincode: 742405, serviceable: "Yes", tier: "2" },
  { pincode: 742406, serviceable: "Yes", tier: "2" },
  { pincode: 742407, serviceable: "Yes", tier: "2" },
  { pincode: 742408, serviceable: "Yes", tier: "2" },
  { pincode: 742409, serviceable: "Yes", tier: "2" },
  { pincode: 743101, serviceable: "Yes", tier: "2" },
  { pincode: 743102, serviceable: "Yes", tier: "2" },
  { pincode: 743120, serviceable: "Yes", tier: "2" },
  { pincode: 743121, serviceable: "Yes", tier: "2" },
  { pincode: 743122, serviceable: "Yes", tier: "2" },
  { pincode: 743123, serviceable: "Yes", tier: "2" },
  { pincode: 743125, serviceable: "Yes", tier: "2" },
  { pincode: 743126, serviceable: "Yes", tier: "2" },
  { pincode: 743127, serviceable: "Yes", tier: "2" },
  { pincode: 743128, serviceable: "Yes", tier: "2" },
  { pincode: 743129, serviceable: "Yes", tier: "2" },
  { pincode: 743133, serviceable: "Yes", tier: "2" },
  { pincode: 743134, serviceable: "Yes", tier: "2" },
  { pincode: 743135, serviceable: "Yes", tier: "2" },
  { pincode: 743136, serviceable: "Yes", tier: "2" },
  { pincode: 743144, serviceable: "Yes", tier: "2" },
  { pincode: 743145, serviceable: "Yes", tier: "2" },
  { pincode: 743155, serviceable: "Yes", tier: "2" },
  { pincode: 743165, serviceable: "Yes", tier: "2" },
  { pincode: 743166, serviceable: "Yes", tier: "2" },
  { pincode: 743170, serviceable: "Yes", tier: "2" },
  { pincode: 743175, serviceable: "Yes", tier: "2" },
  { pincode: 743176, serviceable: "Yes", tier: "2" },
  { pincode: 743177, serviceable: "Yes", tier: "2" },
  { pincode: 743178, serviceable: "Yes", tier: "2" },
  { pincode: 743179, serviceable: "Yes", tier: "2" },
  { pincode: 743180, serviceable: "Yes", tier: "2" },
  { pincode: 743186, serviceable: "Yes", tier: "2" },
  { pincode: 743187, serviceable: "Yes", tier: "2" },
  { pincode: 743188, serviceable: "Yes", tier: "2" },
  { pincode: 743193, serviceable: "Yes", tier: "2" },
  { pincode: 743194, serviceable: "Yes", tier: "2" },
  { pincode: 743195, serviceable: "Yes", tier: "2" },
  { pincode: 743221, serviceable: "Yes", tier: "1" },
  { pincode: 743222, serviceable: "Yes", tier: "2" },
  { pincode: 743223, serviceable: "Yes", tier: "2" },
  { pincode: 743232, serviceable: "Yes", tier: "2" },
  { pincode: 743233, serviceable: "Yes", tier: "2" },
  { pincode: 743234, serviceable: "Yes", tier: "2" },
  { pincode: 743235, serviceable: "Yes", tier: "2" },
  { pincode: 743245, serviceable: "Yes", tier: "2" },
  { pincode: 743247, serviceable: "Yes", tier: "2" },
  { pincode: 743248, serviceable: "Yes", tier: "1" },
  { pincode: 743249, serviceable: "Yes", tier: "2" },
  { pincode: 743251, serviceable: "Yes", tier: "2" },
  { pincode: 743252, serviceable: "Yes", tier: "2" },
  { pincode: 743262, serviceable: "Yes", tier: "2" },
  { pincode: 743263, serviceable: "Yes", tier: "2" },
  { pincode: 743268, serviceable: "Yes", tier: "2" },
  { pincode: 743269, serviceable: "Yes", tier: "2" },
  { pincode: 743270, serviceable: "Yes", tier: "2" },
  { pincode: 743271, serviceable: "Yes", tier: "2" },
  { pincode: 743272, serviceable: "Yes", tier: "2" },
  { pincode: 743273, serviceable: "Yes", tier: "2" },
  { pincode: 743286, serviceable: "Yes", tier: "2" },
  { pincode: 743287, serviceable: "Yes", tier: "2" },
  { pincode: 743289, serviceable: "Yes", tier: "2" },
  { pincode: 743290, serviceable: "Yes", tier: "2" },
  { pincode: 743291, serviceable: "Yes", tier: "2" },
  { pincode: 743292, serviceable: "Yes", tier: "2" },
  { pincode: 743293, serviceable: "Yes", tier: "2" },
  { pincode: 743294, serviceable: "Yes", tier: "1" },
  { pincode: 743297, serviceable: "Yes", tier: "2" },
  { pincode: 743313, serviceable: "Yes", tier: "1" },
  { pincode: 743318, serviceable: "Yes", tier: "2" },
  { pincode: 743329, serviceable: "Yes", tier: "3" },
  { pincode: 743330, serviceable: "Yes", tier: "2" },
  { pincode: 743331, serviceable: "Yes", tier: "2" },
  { pincode: 743332, serviceable: "Yes", tier: "5" },
  { pincode: 743336, serviceable: "Yes", tier: "5" },
  { pincode: 743337, serviceable: "Yes", tier: "5" },
  { pincode: 743338, serviceable: "Yes", tier: "5" },
  { pincode: 743345, serviceable: "Yes", tier: "5" },
  { pincode: 743348, serviceable: "Yes", tier: "3" },
  { pincode: 743351, serviceable: "Yes", tier: "5" },
  { pincode: 743354, serviceable: "Yes", tier: "5" },
  { pincode: 743355, serviceable: "Yes", tier: "5" },
  { pincode: 743368, serviceable: "Yes", tier: "2" },
  { pincode: 743372, serviceable: "Yes", tier: "5" },
  { pincode: 743375, serviceable: "Yes", tier: "5" },
  { pincode: 743376, serviceable: "Yes", tier: "3" },
  { pincode: 743377, serviceable: "Yes", tier: "2" },
  { pincode: 743385, serviceable: "Yes", tier: "5" },
  { pincode: 743387, serviceable: "Yes", tier: "5" },
  { pincode: 743391, serviceable: "Yes", tier: "5" },
  { pincode: 743395, serviceable: "Yes", tier: "5" },
  { pincode: 743396, serviceable: "Yes", tier: "5" },
  { pincode: 743398, serviceable: "Yes", tier: "2" },
  { pincode: 743401, serviceable: "Yes", tier: "2" },
  { pincode: 743405, serviceable: "Yes", tier: "2" },
  { pincode: 743411, serviceable: "Yes", tier: "2" },
  { pincode: 743412, serviceable: "Yes", tier: "2" },
  { pincode: 743422, serviceable: "Yes", tier: "2" },
  { pincode: 743423, serviceable: "Yes", tier: "1" },
  { pincode: 743424, serviceable: "Yes", tier: "2" },
  { pincode: 743425, serviceable: "Yes", tier: "2" },
  { pincode: 743426, serviceable: "Yes", tier: "2" },
  { pincode: 743427, serviceable: "Yes", tier: "2" },
  { pincode: 743428, serviceable: "Yes", tier: "2" },
  { pincode: 743429, serviceable: "Yes", tier: "2" },
  { pincode: 743437, serviceable: "Yes", tier: "2" },
  { pincode: 743438, serviceable: "Yes", tier: "2" },
  { pincode: 743445, serviceable: "Yes", tier: "2" },
  { pincode: 743456, serviceable: "Yes", tier: "2" },
  { pincode: 743502, serviceable: "Yes", tier: "2" },
  { pincode: 743503, serviceable: "Yes", tier: "2" },
  { pincode: 743504, serviceable: "Yes", tier: "2" },
  { pincode: 743507, serviceable: "Yes", tier: "2" },
  { pincode: 743513, serviceable: "Yes", tier: "2" },
  { pincode: 743601, serviceable: "Yes", tier: "5" },
  { pincode: 743609, serviceable: "Yes", tier: "5" },
  { pincode: 743610, serviceable: "Yes", tier: "5" },
  { pincode: 743613, serviceable: "Yes", tier: "5" },
  { pincode: 743701, serviceable: "Yes", tier: "2" },
  { pincode: 743702, serviceable: "Yes", tier: "2" },
  { pincode: 743704, serviceable: "Yes", tier: "2" },
  { pincode: 743710, serviceable: "Yes", tier: "2" },
  { pincode: 743711, serviceable: "Yes", tier: "2" },
  { pincode: 744101, serviceable: "Yes", tier: "5" },
  { pincode: 744102, serviceable: "Yes", tier: "5" },
  { pincode: 744103, serviceable: "Yes", tier: "5" },
  { pincode: 744104, serviceable: "Yes", tier: "5" },
  { pincode: 744106, serviceable: "Yes", tier: "5" },
  { pincode: 744112, serviceable: "Yes", tier: "5" },
  { pincode: 751001, serviceable: "Yes", tier: "2" },
  { pincode: 751002, serviceable: "Yes", tier: "2" },
  { pincode: 751003, serviceable: "Yes", tier: "2" },
  { pincode: 751004, serviceable: "Yes", tier: "2" },
  { pincode: 751005, serviceable: "Yes", tier: "2" },
  { pincode: 751006, serviceable: "Yes", tier: "2" },
  { pincode: 751007, serviceable: "Yes", tier: "2" },
  { pincode: 751008, serviceable: "Yes", tier: "2" },
  { pincode: 751009, serviceable: "Yes", tier: "2" },
  { pincode: 751010, serviceable: "Yes", tier: "2" },
  { pincode: 751011, serviceable: "Yes", tier: "2" },
  { pincode: 751012, serviceable: "Yes", tier: "2" },
  { pincode: 751013, serviceable: "Yes", tier: "2" },
  { pincode: 751014, serviceable: "Yes", tier: "2" },
  { pincode: 751015, serviceable: "Yes", tier: "2" },
  { pincode: 751016, serviceable: "Yes", tier: "2" },
  { pincode: 751017, serviceable: "Yes", tier: "2" },
  { pincode: 751018, serviceable: "Yes", tier: "2" },
  { pincode: 751019, serviceable: "Yes", tier: "2" },
  { pincode: 751020, serviceable: "Yes", tier: "2" },
  { pincode: 751021, serviceable: "Yes", tier: "2" },
  { pincode: 751022, serviceable: "Yes", tier: "2" },
  { pincode: 751023, serviceable: "Yes", tier: "2" },
  { pincode: 751024, serviceable: "Yes", tier: "2" },
  { pincode: 751025, serviceable: "Yes", tier: "2" },
  { pincode: 751026, serviceable: "Yes", tier: "2" },
  { pincode: 751027, serviceable: "Yes", tier: "2" },
  { pincode: 751029, serviceable: "Yes", tier: "2" },
  { pincode: 751030, serviceable: "Yes", tier: "2" },
  { pincode: 751031, serviceable: "Yes", tier: "2" },
  { pincode: 751062, serviceable: "Yes", tier: "2" },
  { pincode: 752001, serviceable: "Yes", tier: "2" },
  { pincode: 752002, serviceable: "Yes", tier: "2" },
  { pincode: 752003, serviceable: "Yes", tier: "2" },
  { pincode: 752010, serviceable: "Yes", tier: "2" },
  { pincode: 752011, serviceable: "Yes", tier: "2" },
  { pincode: 752012, serviceable: "Yes", tier: "2" },
  { pincode: 752013, serviceable: "Yes", tier: "2" },
  { pincode: 752014, serviceable: "Yes", tier: "2" },
  { pincode: 752015, serviceable: "Yes", tier: "2" },
  { pincode: 752017, serviceable: "Yes", tier: "2" },
  { pincode: 752018, serviceable: "Yes", tier: "2" },
  { pincode: 752019, serviceable: "Yes", tier: "2" },
  { pincode: 752020, serviceable: "Yes", tier: "2" },
  { pincode: 752021, serviceable: "Yes", tier: "2" },
  { pincode: 752022, serviceable: "Yes", tier: "2" },
  { pincode: 752023, serviceable: "Yes", tier: "2" },
  { pincode: 752024, serviceable: "Yes", tier: "2" },
  { pincode: 752025, serviceable: "Yes", tier: "2" },
  { pincode: 752026, serviceable: "Yes", tier: "2" },
  { pincode: 752030, serviceable: "Yes", tier: "2" },
  { pincode: 752031, serviceable: "Yes", tier: "2" },
  { pincode: 752034, serviceable: "Yes", tier: "2" },
  { pincode: 752035, serviceable: "Yes", tier: "2" },
  { pincode: 752037, serviceable: "Yes", tier: "2" },
  { pincode: 752038, serviceable: "Yes", tier: "2" },
  { pincode: 752045, serviceable: "Yes", tier: "2" },
  { pincode: 752050, serviceable: "Yes", tier: "2" },
  { pincode: 752054, serviceable: "Yes", tier: "2" },
  { pincode: 752055, serviceable: "Yes", tier: "2" },
  { pincode: 752056, serviceable: "Yes", tier: "2" },
  { pincode: 752057, serviceable: "Yes", tier: "2" },
  { pincode: 752060, serviceable: "Yes", tier: "2" },
  { pincode: 752061, serviceable: "Yes", tier: "2" },
  { pincode: 752062, serviceable: "Yes", tier: "2" },
  { pincode: 752063, serviceable: "Yes", tier: "2" },
  { pincode: 752064, serviceable: "Yes", tier: "2" },
  { pincode: 752065, serviceable: "Yes", tier: "2" },
  { pincode: 752066, serviceable: "Yes", tier: "2" },
  { pincode: 752068, serviceable: "Yes", tier: "2" },
  { pincode: 752069, serviceable: "Yes", tier: "2" },
  { pincode: 752070, serviceable: "Yes", tier: "2" },
  { pincode: 752077, serviceable: "Yes", tier: "2" },
  { pincode: 752078, serviceable: "Yes", tier: "2" },
  { pincode: 752079, serviceable: "Yes", tier: "2" },
  { pincode: 752080, serviceable: "Yes", tier: "2" },
  { pincode: 752081, serviceable: "Yes", tier: "2" },
  { pincode: 752092, serviceable: "Yes", tier: "2" },
  { pincode: 752094, serviceable: "Yes", tier: "2" },
  { pincode: 752100, serviceable: "Yes", tier: "2" },
  { pincode: 752101, serviceable: "Yes", tier: "2" },
  { pincode: 752104, serviceable: "Yes", tier: "2" },
  { pincode: 752105, serviceable: "Yes", tier: "2" },
  { pincode: 752106, serviceable: "Yes", tier: "2" },
  { pincode: 752108, serviceable: "Yes", tier: "2" },
  { pincode: 752109, serviceable: "Yes", tier: "2" },
  { pincode: 752110, serviceable: "Yes", tier: "2" },
  { pincode: 752111, serviceable: "Yes", tier: "2" },
  { pincode: 752114, serviceable: "Yes", tier: "2" },
  { pincode: 753001, serviceable: "Yes", tier: "2" },
  { pincode: 753002, serviceable: "Yes", tier: "2" },
  { pincode: 753003, serviceable: "Yes", tier: "2" },
  { pincode: 753004, serviceable: "Yes", tier: "2" },
  { pincode: 753005, serviceable: "Yes", tier: "2" },
  { pincode: 753006, serviceable: "Yes", tier: "2" },
  { pincode: 753007, serviceable: "Yes", tier: "2" },
  { pincode: 753008, serviceable: "Yes", tier: "2" },
  { pincode: 753009, serviceable: "Yes", tier: "2" },
  { pincode: 753010, serviceable: "Yes", tier: "2" },
  { pincode: 753011, serviceable: "Yes", tier: "2" },
  { pincode: 753012, serviceable: "Yes", tier: "2" },
  { pincode: 753013, serviceable: "Yes", tier: "2" },
  { pincode: 753014, serviceable: "Yes", tier: "2" },
  { pincode: 753015, serviceable: "Yes", tier: "2" },
  { pincode: 753051, serviceable: "Yes", tier: "2" },
  { pincode: 754001, serviceable: "Yes", tier: "2" },
  { pincode: 754004, serviceable: "Yes", tier: "2" },
  { pincode: 754005, serviceable: "Yes", tier: "2" },
  { pincode: 754006, serviceable: "Yes", tier: "2" },
  { pincode: 754008, serviceable: "Yes", tier: "2" },
  { pincode: 754011, serviceable: "Yes", tier: "2" },
  { pincode: 754018, serviceable: "Yes", tier: "2" },
  { pincode: 754021, serviceable: "Yes", tier: "2" },
  { pincode: 754022, serviceable: "Yes", tier: "2" },
  { pincode: 754023, serviceable: "Yes", tier: "2" },
  { pincode: 754024, serviceable: "Yes", tier: "2" },
  { pincode: 754025, serviceable: "Yes", tier: "2" },
  { pincode: 754027, serviceable: "Yes", tier: "2" },
  { pincode: 754028, serviceable: "Yes", tier: "2" },
  { pincode: 754029, serviceable: "Yes", tier: "2" },
  { pincode: 754030, serviceable: "Yes", tier: "2" },
  { pincode: 754031, serviceable: "Yes", tier: "2" },
  { pincode: 754032, serviceable: "Yes", tier: "2" },
  { pincode: 754037, serviceable: "Yes", tier: "2" },
  { pincode: 754071, serviceable: "Yes", tier: "2" },
  { pincode: 754082, serviceable: "Yes", tier: "2" },
  { pincode: 754102, serviceable: "Yes", tier: "2" },
  { pincode: 754103, serviceable: "Yes", tier: "2" },
  { pincode: 754104, serviceable: "Yes", tier: "2" },
  { pincode: 754106, serviceable: "Yes", tier: "2" },
  { pincode: 754107, serviceable: "Yes", tier: "2" },
  { pincode: 754108, serviceable: "Yes", tier: "2" },
  { pincode: 754109, serviceable: "Yes", tier: "2" },
  { pincode: 754110, serviceable: "Yes", tier: "2" },
  { pincode: 754111, serviceable: "Yes", tier: "2" },
  { pincode: 754113, serviceable: "Yes", tier: "2" },
  { pincode: 754114, serviceable: "Yes", tier: "2" },
  { pincode: 754119, serviceable: "Yes", tier: "2" },
  { pincode: 754120, serviceable: "Yes", tier: "2" },
  { pincode: 754130, serviceable: "Yes", tier: "2" },
  { pincode: 754131, serviceable: "Yes", tier: "2" },
  { pincode: 754132, serviceable: "Yes", tier: "2" },
  { pincode: 754133, serviceable: "Yes", tier: "2" },
  { pincode: 754134, serviceable: "Yes", tier: "2" },
  { pincode: 754136, serviceable: "Yes", tier: "2" },
  { pincode: 754137, serviceable: "Yes", tier: "2" },
  { pincode: 754140, serviceable: "Yes", tier: "2" },
  { pincode: 754141, serviceable: "Yes", tier: "2" },
  { pincode: 754142, serviceable: "Yes", tier: "2" },
  { pincode: 754143, serviceable: "Yes", tier: "2" },
  { pincode: 754145, serviceable: "Yes", tier: "2" },
  { pincode: 754153, serviceable: "Yes", tier: "2" },
  { pincode: 754160, serviceable: "Yes", tier: "2" },
  { pincode: 754162, serviceable: "Yes", tier: "2" },
  { pincode: 754200, serviceable: "Yes", tier: "2" },
  { pincode: 754201, serviceable: "Yes", tier: "2" },
  { pincode: 754202, serviceable: "Yes", tier: "2" },
  { pincode: 754203, serviceable: "Yes", tier: "2" },
  { pincode: 754204, serviceable: "Yes", tier: "2" },
  { pincode: 754205, serviceable: "Yes", tier: "2" },
  { pincode: 754210, serviceable: "Yes", tier: "2" },
  { pincode: 754211, serviceable: "Yes", tier: "2" },
  { pincode: 754212, serviceable: "Yes", tier: "2" },
  { pincode: 754213, serviceable: "Yes", tier: "2" },
  { pincode: 754214, serviceable: "Yes", tier: "2" },
  { pincode: 754215, serviceable: "Yes", tier: "2" },
  { pincode: 754216, serviceable: "Yes", tier: "2" },
  { pincode: 754217, serviceable: "Yes", tier: "2" },
  { pincode: 754218, serviceable: "Yes", tier: "2" },
  { pincode: 754219, serviceable: "Yes", tier: "2" },
  { pincode: 754220, serviceable: "Yes", tier: "2" },
  { pincode: 754222, serviceable: "Yes", tier: "2" },
  { pincode: 754223, serviceable: "Yes", tier: "2" },
  { pincode: 754224, serviceable: "Yes", tier: "2" },
  { pincode: 754228, serviceable: "Yes", tier: "2" },
  { pincode: 754231, serviceable: "Yes", tier: "2" },
  { pincode: 754239, serviceable: "Yes", tier: "2" },
  { pincode: 754240, serviceable: "Yes", tier: "2" },
  { pincode: 754244, serviceable: "Yes", tier: "2" },
  { pincode: 754245, serviceable: "Yes", tier: "2" },
  { pincode: 754246, serviceable: "Yes", tier: "2" },
  { pincode: 754250, serviceable: "Yes", tier: "2" },
  { pincode: 754253, serviceable: "Yes", tier: "2" },
  { pincode: 754289, serviceable: "Yes", tier: "2" },
  { pincode: 754292, serviceable: "Yes", tier: "2" },
  { pincode: 754295, serviceable: "Yes", tier: "2" },
  { pincode: 754296, serviceable: "Yes", tier: "2" },
  { pincode: 755001, serviceable: "Yes", tier: "2" },
  { pincode: 755003, serviceable: "Yes", tier: "2" },
  { pincode: 755004, serviceable: "Yes", tier: "2" },
  { pincode: 755005, serviceable: "Yes", tier: "2" },
  { pincode: 755006, serviceable: "Yes", tier: "2" },
  { pincode: 755007, serviceable: "Yes", tier: "2" },
  { pincode: 755008, serviceable: "Yes", tier: "2" },
  { pincode: 755009, serviceable: "Yes", tier: "2" },
  { pincode: 755010, serviceable: "Yes", tier: "2" },
  { pincode: 755011, serviceable: "Yes", tier: "2" },
  { pincode: 755012, serviceable: "Yes", tier: "2" },
  { pincode: 755013, serviceable: "Yes", tier: "2" },
  { pincode: 755014, serviceable: "Yes", tier: "2" },
  { pincode: 755015, serviceable: "Yes", tier: "2" },
  { pincode: 755016, serviceable: "Yes", tier: "2" },
  { pincode: 755017, serviceable: "Yes", tier: "2" },
  { pincode: 755019, serviceable: "Yes", tier: "2" },
  { pincode: 755020, serviceable: "Yes", tier: "2" },
  { pincode: 755022, serviceable: "Yes", tier: "2" },
  { pincode: 755023, serviceable: "Yes", tier: "2" },
  { pincode: 755024, serviceable: "Yes", tier: "2" },
  { pincode: 755026, serviceable: "Yes", tier: "2" },
  { pincode: 755027, serviceable: "Yes", tier: "2" },
  { pincode: 755036, serviceable: "Yes", tier: "2" },
  { pincode: 755040, serviceable: "Yes", tier: "2" },
  { pincode: 755043, serviceable: "Yes", tier: "2" },
  { pincode: 755044, serviceable: "Yes", tier: "2" },
  { pincode: 755049, serviceable: "Yes", tier: "2" },
  { pincode: 755050, serviceable: "Yes", tier: "2" },
  { pincode: 755061, serviceable: "Yes", tier: "2" },
  { pincode: 755062, serviceable: "Yes", tier: "2" },
  { pincode: 756001, serviceable: "Yes", tier: "2" },
  { pincode: 756002, serviceable: "Yes", tier: "2" },
  { pincode: 756003, serviceable: "Yes", tier: "2" },
  { pincode: 756019, serviceable: "Yes", tier: "2" },
  { pincode: 756020, serviceable: "Yes", tier: "2" },
  { pincode: 756023, serviceable: "Yes", tier: "2" },
  { pincode: 756024, serviceable: "Yes", tier: "2" },
  { pincode: 756025, serviceable: "Yes", tier: "2" },
  { pincode: 756026, serviceable: "Yes", tier: "2" },
  { pincode: 756027, serviceable: "Yes", tier: "2" },
  { pincode: 756029, serviceable: "Yes", tier: "2" },
  { pincode: 756030, serviceable: "Yes", tier: "2" },
  { pincode: 756032, serviceable: "Yes", tier: "2" },
  { pincode: 756034, serviceable: "Yes", tier: "2" },
  { pincode: 756035, serviceable: "Yes", tier: "2" },
  { pincode: 756036, serviceable: "Yes", tier: "2" },
  { pincode: 756038, serviceable: "Yes", tier: "2" },
  { pincode: 756039, serviceable: "Yes", tier: "2" },
  { pincode: 756040, serviceable: "Yes", tier: "2" },
  { pincode: 756042, serviceable: "Yes", tier: "2" },
  { pincode: 756043, serviceable: "Yes", tier: "2" },
  { pincode: 756045, serviceable: "Yes", tier: "2" },
  { pincode: 756046, serviceable: "Yes", tier: "2" },
  { pincode: 756056, serviceable: "Yes", tier: "2" },
  { pincode: 756058, serviceable: "Yes", tier: "2" },
  { pincode: 756060, serviceable: "Yes", tier: "2" },
  { pincode: 756079, serviceable: "Yes", tier: "2" },
  { pincode: 756080, serviceable: "Yes", tier: "2" },
  { pincode: 756081, serviceable: "Yes", tier: "2" },
  { pincode: 756083, serviceable: "Yes", tier: "2" },
  { pincode: 756084, serviceable: "Yes", tier: "2" },
  { pincode: 756085, serviceable: "Yes", tier: "2" },
  { pincode: 756086, serviceable: "Yes", tier: "2" },
  { pincode: 756087, serviceable: "Yes", tier: "2" },
  { pincode: 756100, serviceable: "Yes", tier: "2" },
  { pincode: 756101, serviceable: "Yes", tier: "2" },
  { pincode: 756111, serviceable: "Yes", tier: "2" },
  { pincode: 756112, serviceable: "Yes", tier: "2" },
  { pincode: 756113, serviceable: "Yes", tier: "2" },
  { pincode: 756116, serviceable: "Yes", tier: "2" },
  { pincode: 756118, serviceable: "Yes", tier: "2" },
  { pincode: 756119, serviceable: "Yes", tier: "2" },
  { pincode: 756124, serviceable: "Yes", tier: "2" },
  { pincode: 756125, serviceable: "Yes", tier: "2" },
  { pincode: 756127, serviceable: "Yes", tier: "2" },
  { pincode: 756128, serviceable: "Yes", tier: "2" },
  { pincode: 756129, serviceable: "Yes", tier: "2" },
  { pincode: 756130, serviceable: "Yes", tier: "2" },
  { pincode: 756131, serviceable: "Yes", tier: "2" },
  { pincode: 756132, serviceable: "Yes", tier: "2" },
  { pincode: 756133, serviceable: "Yes", tier: "2" },
  { pincode: 756139, serviceable: "Yes", tier: "2" },
  { pincode: 756163, serviceable: "Yes", tier: "2" },
  { pincode: 756164, serviceable: "Yes", tier: "2" },
  { pincode: 756165, serviceable: "Yes", tier: "2" },
  { pincode: 756181, serviceable: "Yes", tier: "2" },
  { pincode: 757001, serviceable: "Yes", tier: "2" },
  { pincode: 757002, serviceable: "Yes", tier: "2" },
  { pincode: 757003, serviceable: "Yes", tier: "2" },
  { pincode: 757017, serviceable: "Yes", tier: "2" },
  { pincode: 757019, serviceable: "Yes", tier: "2" },
  { pincode: 757020, serviceable: "Yes", tier: "2" },
  { pincode: 757021, serviceable: "Yes", tier: "2" },
  { pincode: 757022, serviceable: "Yes", tier: "2" },
  { pincode: 757023, serviceable: "Yes", tier: "2" },
  { pincode: 757024, serviceable: "Yes", tier: "2" },
  { pincode: 757025, serviceable: "Yes", tier: "2" },
  { pincode: 757026, serviceable: "Yes", tier: "2" },
  { pincode: 757027, serviceable: "Yes", tier: "2" },
  { pincode: 757029, serviceable: "Yes", tier: "2" },
  { pincode: 757030, serviceable: "Yes", tier: "2" },
  { pincode: 757040, serviceable: "Yes", tier: "2" },
  { pincode: 757041, serviceable: "Yes", tier: "2" },
  { pincode: 757049, serviceable: "Yes", tier: "2" },
  { pincode: 757075, serviceable: "Yes", tier: "2" },
  { pincode: 757077, serviceable: "Yes", tier: "2" },
  { pincode: 757079, serviceable: "Yes", tier: "2" },
  { pincode: 757084, serviceable: "Yes", tier: "2" },
  { pincode: 757085, serviceable: "Yes", tier: "2" },
  { pincode: 757087, serviceable: "Yes", tier: "2" },
  { pincode: 757101, serviceable: "Yes", tier: "2" },
  { pincode: 757103, serviceable: "Yes", tier: "2" },
  { pincode: 757104, serviceable: "Yes", tier: "2" },
  { pincode: 757105, serviceable: "Yes", tier: "2" },
  { pincode: 757107, serviceable: "Yes", tier: "2" },
  { pincode: 758001, serviceable: "Yes", tier: "2" },
  { pincode: 758002, serviceable: "Yes", tier: "2" },
  { pincode: 758013, serviceable: "Yes", tier: "2" },
  { pincode: 758014, serviceable: "Yes", tier: "2" },
  { pincode: 758018, serviceable: "Yes", tier: "2" },
  { pincode: 758031, serviceable: "Yes", tier: "2" },
  { pincode: 758034, serviceable: "Yes", tier: "2" },
  { pincode: 758035, serviceable: "Yes", tier: "2" },
  { pincode: 758037, serviceable: "Yes", tier: "2" },
  { pincode: 758038, serviceable: "Yes", tier: "2" },
  { pincode: 758041, serviceable: "Yes", tier: "2" },
  { pincode: 758046, serviceable: "Yes", tier: "2" },
  { pincode: 758079, serviceable: "Yes", tier: "2" },
  { pincode: 758087, serviceable: "Yes", tier: "2" },
  { pincode: 759001, serviceable: "Yes", tier: "2" },
  { pincode: 759013, serviceable: "Yes", tier: "2" },
  { pincode: 759015, serviceable: "Yes", tier: "2" },
  { pincode: 759024, serviceable: "Yes", tier: "2" },
  { pincode: 759025, serviceable: "Yes", tier: "2" },
  { pincode: 759027, serviceable: "Yes", tier: "2" },
  { pincode: 759037, serviceable: "Yes", tier: "2" },
  { pincode: 759100, serviceable: "Yes", tier: "2" },
  { pincode: 759101, serviceable: "Yes", tier: "2" },
  { pincode: 759102, serviceable: "Yes", tier: "2" },
  { pincode: 759104, serviceable: "Yes", tier: "2" },
  { pincode: 759106, serviceable: "Yes", tier: "2" },
  { pincode: 759107, serviceable: "Yes", tier: "2" },
  { pincode: 759111, serviceable: "Yes", tier: "2" },
  { pincode: 759116, serviceable: "Yes", tier: "2" },
  { pincode: 759121, serviceable: "Yes", tier: "2" },
  { pincode: 759122, serviceable: "Yes", tier: "2" },
  { pincode: 759123, serviceable: "Yes", tier: "2" },
  { pincode: 759124, serviceable: "Yes", tier: "2" },
  { pincode: 759125, serviceable: "Yes", tier: "2" },
  { pincode: 759126, serviceable: "Yes", tier: "2" },
  { pincode: 759128, serviceable: "Yes", tier: "2" },
  { pincode: 759130, serviceable: "Yes", tier: "2" },
  { pincode: 759143, serviceable: "Yes", tier: "2" },
  { pincode: 759145, serviceable: "Yes", tier: "2" },
  { pincode: 759146, serviceable: "Yes", tier: "2" },
  { pincode: 760001, serviceable: "Yes", tier: "2" },
  { pincode: 760002, serviceable: "Yes", tier: "2" },
  { pincode: 760003, serviceable: "Yes", tier: "2" },
  { pincode: 760004, serviceable: "Yes", tier: "2" },
  { pincode: 760005, serviceable: "Yes", tier: "2" },
  { pincode: 760006, serviceable: "Yes", tier: "2" },
  { pincode: 760007, serviceable: "Yes", tier: "2" },
  { pincode: 760008, serviceable: "Yes", tier: "2" },
  { pincode: 760009, serviceable: "Yes", tier: "2" },
  { pincode: 760010, serviceable: "Yes", tier: "2" },
  { pincode: 760011, serviceable: "Yes", tier: "2" },
  { pincode: 761001, serviceable: "Yes", tier: "2" },
  { pincode: 761002, serviceable: "Yes", tier: "2" },
  { pincode: 761003, serviceable: "Yes", tier: "2" },
  { pincode: 761004, serviceable: "Yes", tier: "2" },
  { pincode: 761008, serviceable: "Yes", tier: "2" },
  { pincode: 761009, serviceable: "Yes", tier: "2" },
  { pincode: 761010, serviceable: "Yes", tier: "2" },
  { pincode: 761020, serviceable: "Yes", tier: "2" },
  { pincode: 761025, serviceable: "Yes", tier: "2" },
  { pincode: 761032, serviceable: "Yes", tier: "2" },
  { pincode: 761041, serviceable: "Yes", tier: "2" },
  { pincode: 761045, serviceable: "Yes", tier: "2" },
  { pincode: 761052, serviceable: "Yes", tier: "2" },
  { pincode: 761100, serviceable: "Yes", tier: "2" },
  { pincode: 761101, serviceable: "Yes", tier: "2" },
  { pincode: 761102, serviceable: "Yes", tier: "2" },
  { pincode: 761103, serviceable: "Yes", tier: "2" },
  { pincode: 761104, serviceable: "Yes", tier: "2" },
  { pincode: 761106, serviceable: "Yes", tier: "2" },
  { pincode: 761107, serviceable: "Yes", tier: "2" },
  { pincode: 761108, serviceable: "Yes", tier: "2" },
  { pincode: 761110, serviceable: "Yes", tier: "2" },
  { pincode: 761114, serviceable: "Yes", tier: "2" },
  { pincode: 761115, serviceable: "Yes", tier: "2" },
  { pincode: 761116, serviceable: "Yes", tier: "2" },
  { pincode: 761117, serviceable: "Yes", tier: "2" },
  { pincode: 761118, serviceable: "Yes", tier: "2" },
  { pincode: 761122, serviceable: "Yes", tier: "2" },
  { pincode: 761123, serviceable: "Yes", tier: "2" },
  { pincode: 761124, serviceable: "Yes", tier: "2" },
  { pincode: 761133, serviceable: "Yes", tier: "2" },
  { pincode: 761146, serviceable: "Yes", tier: "2" },
  { pincode: 761200, serviceable: "Yes", tier: "2" },
  { pincode: 761201, serviceable: "Yes", tier: "2" },
  { pincode: 761206, serviceable: "Yes", tier: "2" },
  { pincode: 761208, serviceable: "Yes", tier: "2" },
  { pincode: 761210, serviceable: "Yes", tier: "2" },
  { pincode: 761211, serviceable: "Yes", tier: "2" },
  { pincode: 762001, serviceable: "Yes", tier: "3" },
  { pincode: 762002, serviceable: "Yes", tier: "3" },
  { pincode: 762010, serviceable: "Yes", tier: "3" },
  { pincode: 762012, serviceable: "Yes", tier: "3" },
  { pincode: 762013, serviceable: "Yes", tier: "2" },
  { pincode: 762014, serviceable: "Yes", tier: "2" },
  { pincode: 762019, serviceable: "Yes", tier: "3" },
  { pincode: 762029, serviceable: "Yes", tier: "3" },
  { pincode: 762100, serviceable: "Yes", tier: "3" },
  { pincode: 762103, serviceable: "Yes", tier: "3" },
  { pincode: 763001, serviceable: "Yes", tier: "3" },
  { pincode: 763002, serviceable: "Yes", tier: "3" },
  { pincode: 763003, serviceable: "Yes", tier: "3" },
  { pincode: 763004, serviceable: "Yes", tier: "3" },
  { pincode: 763008, serviceable: "Yes", tier: "3" },
  { pincode: 764001, serviceable: "Yes", tier: "3" },
  { pincode: 764003, serviceable: "Yes", tier: "3" },
  { pincode: 764004, serviceable: "Yes", tier: "3" },
  { pincode: 764005, serviceable: "Yes", tier: "3" },
  { pincode: 764006, serviceable: "Yes", tier: "3" },
  { pincode: 764011, serviceable: "Yes", tier: "3" },
  { pincode: 764020, serviceable: "Yes", tier: "3" },
  { pincode: 764021, serviceable: "Yes", tier: "3" },
  { pincode: 764036, serviceable: "Yes", tier: "3" },
  { pincode: 764043, serviceable: "Yes", tier: "3" },
  { pincode: 764044, serviceable: "Yes", tier: "3" },
  { pincode: 764045, serviceable: "Yes", tier: "3" },
  { pincode: 764048, serviceable: "Yes", tier: "3" },
  { pincode: 764049, serviceable: "Yes", tier: "3" },
  { pincode: 764051, serviceable: "Yes", tier: "3" },
  { pincode: 764056, serviceable: "Yes", tier: "3" },
  { pincode: 764058, serviceable: "Yes", tier: "3" },
  { pincode: 764059, serviceable: "Yes", tier: "3" },
  { pincode: 764063, serviceable: "Yes", tier: "3" },
  { pincode: 764070, serviceable: "Yes", tier: "3" },
  { pincode: 764071, serviceable: "Yes", tier: "3" },
  { pincode: 764078, serviceable: "Yes", tier: "3" },
  { pincode: 764085, serviceable: "Yes", tier: "3" },
  { pincode: 765001, serviceable: "Yes", tier: "2" },
  { pincode: 765002, serviceable: "Yes", tier: "2" },
  { pincode: 765017, serviceable: "Yes", tier: "2" },
  { pincode: 765018, serviceable: "Yes", tier: "2" },
  { pincode: 766001, serviceable: "Yes", tier: "3" },
  { pincode: 766002, serviceable: "Yes", tier: "3" },
  { pincode: 766014, serviceable: "Yes", tier: "3" },
  { pincode: 766020, serviceable: "Yes", tier: "3" },
  { pincode: 766027, serviceable: "Yes", tier: "3" },
  { pincode: 766104, serviceable: "Yes", tier: "3" },
  { pincode: 766105, serviceable: "Yes", tier: "3" },
  { pincode: 766107, serviceable: "Yes", tier: "3" },
  { pincode: 767001, serviceable: "Yes", tier: "2" },
  { pincode: 767002, serviceable: "Yes", tier: "2" },
  { pincode: 767016, serviceable: "Yes", tier: "2" },
  { pincode: 767017, serviceable: "Yes", tier: "2" },
  { pincode: 767018, serviceable: "Yes", tier: "2" },
  { pincode: 767019, serviceable: "Yes", tier: "2" },
  { pincode: 767020, serviceable: "Yes", tier: "2" },
  { pincode: 767033, serviceable: "Yes", tier: "3" },
  { pincode: 767039, serviceable: "Yes", tier: "3" },
  { pincode: 767040, serviceable: "Yes", tier: "3" },
  { pincode: 767065, serviceable: "Yes", tier: "2" },
  { pincode: 767066, serviceable: "Yes", tier: "3" },
  { pincode: 767067, serviceable: "Yes", tier: "2" },
  { pincode: 767070, serviceable: "Yes", tier: "3" },
  { pincode: 767071, serviceable: "Yes", tier: "2" },
  { pincode: 768001, serviceable: "Yes", tier: "2" },
  { pincode: 768002, serviceable: "Yes", tier: "2" },
  { pincode: 768003, serviceable: "Yes", tier: "2" },
  { pincode: 768004, serviceable: "Yes", tier: "2" },
  { pincode: 768005, serviceable: "Yes", tier: "2" },
  { pincode: 768006, serviceable: "Yes", tier: "2" },
  { pincode: 768016, serviceable: "Yes", tier: "2" },
  { pincode: 768017, serviceable: "Yes", tier: "2" },
  { pincode: 768018, serviceable: "Yes", tier: "2" },
  { pincode: 768019, serviceable: "Yes", tier: "2" },
  { pincode: 768020, serviceable: "Yes", tier: "2" },
  { pincode: 768027, serviceable: "Yes", tier: "2" },
  { pincode: 768028, serviceable: "Yes", tier: "2" },
  { pincode: 768040, serviceable: "Yes", tier: "2" },
  { pincode: 768106, serviceable: "Yes", tier: "2" },
  { pincode: 768108, serviceable: "Yes", tier: "2" },
  { pincode: 768109, serviceable: "Yes", tier: "2" },
  { pincode: 768118, serviceable: "Yes", tier: "2" },
  { pincode: 768119, serviceable: "Yes", tier: "2" },
  { pincode: 768201, serviceable: "Yes", tier: "2" },
  { pincode: 768202, serviceable: "Yes", tier: "2" },
  { pincode: 768203, serviceable: "Yes", tier: "2" },
  { pincode: 768204, serviceable: "Yes", tier: "2" },
  { pincode: 768210, serviceable: "Yes", tier: "2" },
  { pincode: 768211, serviceable: "Yes", tier: "2" },
  { pincode: 768216, serviceable: "Yes", tier: "2" },
  { pincode: 768217, serviceable: "Yes", tier: "2" },
  { pincode: 768218, serviceable: "Yes", tier: "2" },
  { pincode: 768224, serviceable: "Yes", tier: "2" },
  { pincode: 768225, serviceable: "Yes", tier: "2" },
  { pincode: 768233, serviceable: "Yes", tier: "2" },
  { pincode: 768234, serviceable: "Yes", tier: "2" },
  { pincode: 769001, serviceable: "Yes", tier: "2" },
  { pincode: 769002, serviceable: "Yes", tier: "2" },
  { pincode: 769003, serviceable: "Yes", tier: "2" },
  { pincode: 769004, serviceable: "Yes", tier: "2" },
  { pincode: 769005, serviceable: "Yes", tier: "2" },
  { pincode: 769006, serviceable: "Yes", tier: "2" },
  { pincode: 769007, serviceable: "Yes", tier: "2" },
  { pincode: 769008, serviceable: "Yes", tier: "2" },
  { pincode: 769009, serviceable: "Yes", tier: "2" },
  { pincode: 769010, serviceable: "Yes", tier: "2" },
  { pincode: 769011, serviceable: "Yes", tier: "2" },
  { pincode: 769012, serviceable: "Yes", tier: "2" },
  { pincode: 769013, serviceable: "Yes", tier: "2" },
  { pincode: 769014, serviceable: "Yes", tier: "2" },
  { pincode: 769015, serviceable: "Yes", tier: "2" },
  { pincode: 769016, serviceable: "Yes", tier: "2" },
  { pincode: 769042, serviceable: "Yes", tier: "2" },
  { pincode: 770001, serviceable: "Yes", tier: "2" },
  { pincode: 770002, serviceable: "Yes", tier: "2" },
  { pincode: 770016, serviceable: "Yes", tier: "2" },
  { pincode: 770017, serviceable: "Yes", tier: "2" },
  { pincode: 770018, serviceable: "Yes", tier: "2" },
  { pincode: 770025, serviceable: "Yes", tier: "2" },
  { pincode: 770031, serviceable: "Yes", tier: "2" },
  { pincode: 770034, serviceable: "Yes", tier: "2" },
  { pincode: 770070, serviceable: "Yes", tier: "2" },
  { pincode: 770072, serviceable: "Yes", tier: "2" },
  { pincode: 777888, serviceable: "Yes", tier: "1" },
  { pincode: 781001, serviceable: "Yes", tier: "1" },
  { pincode: 781002, serviceable: "Yes", tier: "1" },
  { pincode: 781003, serviceable: "Yes", tier: "1" },
  { pincode: 781004, serviceable: "Yes", tier: "1" },
  { pincode: 781005, serviceable: "Yes", tier: "1" },
  { pincode: 781006, serviceable: "Yes", tier: "1" },
  { pincode: 781007, serviceable: "Yes", tier: "1" },
  { pincode: 781008, serviceable: "Yes", tier: "1" },
  { pincode: 781009, serviceable: "Yes", tier: "1" },
  { pincode: 781010, serviceable: "Yes", tier: "1" },
  { pincode: 781011, serviceable: "Yes", tier: "1" },
  { pincode: 781012, serviceable: "Yes", tier: "1" },
  { pincode: 781013, serviceable: "Yes", tier: "1" },
  { pincode: 781014, serviceable: "Yes", tier: "1" },
  { pincode: 781015, serviceable: "Yes", tier: "1" },
  { pincode: 781016, serviceable: "Yes", tier: "1" },
  { pincode: 781017, serviceable: "Yes", tier: "1" },
  { pincode: 781018, serviceable: "Yes", tier: "1" },
  { pincode: 781019, serviceable: "Yes", tier: "1" },
  { pincode: 781020, serviceable: "Yes", tier: "1" },
  { pincode: 781021, serviceable: "Yes", tier: "1" },
  { pincode: 781022, serviceable: "Yes", tier: "1" },
  { pincode: 781023, serviceable: "Yes", tier: "1" },
  { pincode: 781024, serviceable: "Yes", tier: "1" },
  { pincode: 781025, serviceable: "Yes", tier: "1" },
  { pincode: 781026, serviceable: "Yes", tier: "1" },
  { pincode: 781027, serviceable: "Yes", tier: "1" },
  { pincode: 781028, serviceable: "Yes", tier: "1" },
  { pincode: 781029, serviceable: "Yes", tier: "1" },
  { pincode: 781030, serviceable: "Yes", tier: "2" },
  { pincode: 781031, serviceable: "Yes", tier: "1" },
  { pincode: 781032, serviceable: "Yes", tier: "1" },
  { pincode: 781033, serviceable: "Yes", tier: "1" },
  { pincode: 781034, serviceable: "Yes", tier: "1" },
  { pincode: 781035, serviceable: "Yes", tier: "1" },
  { pincode: 781036, serviceable: "Yes", tier: "1" },
  { pincode: 781037, serviceable: "Yes", tier: "1" },
  { pincode: 781038, serviceable: "Yes", tier: "1" },
  { pincode: 781039, serviceable: "Yes", tier: "2" },
  { pincode: 781040, serviceable: "Yes", tier: "1" },
  { pincode: 781071, serviceable: "Yes", tier: "1" },
  { pincode: 781101, serviceable: "Yes", tier: "2" },
  { pincode: 781102, serviceable: "Yes", tier: "2" },
  { pincode: 781103, serviceable: "Yes", tier: "2" },
  { pincode: 781104, serviceable: "Yes", tier: "2" },
  { pincode: 781121, serviceable: "Yes", tier: "2" },
  { pincode: 781122, serviceable: "Yes", tier: "2" },
  { pincode: 781123, serviceable: "Yes", tier: "2" },
  { pincode: 781124, serviceable: "Yes", tier: "2" },
  { pincode: 781125, serviceable: "Yes", tier: "1" },
  { pincode: 781128, serviceable: "Yes", tier: "1" },
  { pincode: 781131, serviceable: "Yes", tier: "2" },
  { pincode: 781132, serviceable: "Yes", tier: "2" },
  { pincode: 781133, serviceable: "Yes", tier: "2" },
  { pincode: 781134, serviceable: "Yes", tier: "2" },
  { pincode: 781150, serviceable: "Yes", tier: "1" },
  { pincode: 781171, serviceable: "Yes", tier: "1" },
  { pincode: 781301, serviceable: "Yes", tier: "2" },
  { pincode: 781303, serviceable: "Yes", tier: "2" },
  { pincode: 781304, serviceable: "Yes", tier: "2" },
  { pincode: 781306, serviceable: "Yes", tier: "2" },
  { pincode: 781309, serviceable: "Yes", tier: "2" },
  { pincode: 781310, serviceable: "Yes", tier: "2" },
  { pincode: 781313, serviceable: "Yes", tier: "2" },
  { pincode: 781314, serviceable: "Yes", tier: "2" },
  { pincode: 781315, serviceable: "Yes", tier: "2" },
  { pincode: 781316, serviceable: "Yes", tier: "2" },
  { pincode: 781317, serviceable: "Yes", tier: "2" },
  { pincode: 781318, serviceable: "Yes", tier: "2" },
  { pincode: 781319, serviceable: "Yes", tier: "2" },
  { pincode: 781325, serviceable: "Yes", tier: "2" },
  { pincode: 781326, serviceable: "Yes", tier: "2" },
  { pincode: 781334, serviceable: "Yes", tier: "2" },
  { pincode: 781335, serviceable: "Yes", tier: "2" },
  { pincode: 781337, serviceable: "Yes", tier: "2" },
  { pincode: 781338, serviceable: "Yes", tier: "2" },
  { pincode: 781339, serviceable: "Yes", tier: "2" },
  { pincode: 781340, serviceable: "Yes", tier: "2" },
  { pincode: 781341, serviceable: "Yes", tier: "2" },
  { pincode: 781346, serviceable: "Yes", tier: "2" },
  { pincode: 781347, serviceable: "Yes", tier: "2" },
  { pincode: 781348, serviceable: "Yes", tier: "2" },
  { pincode: 781349, serviceable: "Yes", tier: "2" },
  { pincode: 781351, serviceable: "Yes", tier: "2" },
  { pincode: 781352, serviceable: "Yes", tier: "2" },
  { pincode: 781353, serviceable: "Yes", tier: "2" },
  { pincode: 781354, serviceable: "Yes", tier: "2" },
  { pincode: 781360, serviceable: "Yes", tier: "3" },
  { pincode: 781365, serviceable: "Yes", tier: "2" },
  { pincode: 781366, serviceable: "Yes", tier: "2" },
  { pincode: 781367, serviceable: "Yes", tier: "3" },
  { pincode: 781369, serviceable: "Yes", tier: "2" },
  { pincode: 781370, serviceable: "Yes", tier: "2" },
  { pincode: 781371, serviceable: "Yes", tier: "2" },
  { pincode: 781374, serviceable: "Yes", tier: "2" },
  { pincode: 781376, serviceable: "Yes", tier: "2" },
  { pincode: 781378, serviceable: "Yes", tier: "2" },
  { pincode: 781380, serviceable: "Yes", tier: "2" },
  { pincode: 781381, serviceable: "Yes", tier: "2" },
  { pincode: 781382, serviceable: "Yes", tier: "2" },
  { pincode: 782001, serviceable: "Yes", tier: "2" },
  { pincode: 782002, serviceable: "Yes", tier: "2" },
  { pincode: 782003, serviceable: "Yes", tier: "2" },
  { pincode: 782102, serviceable: "Yes", tier: "2" },
  { pincode: 782105, serviceable: "Yes", tier: "2" },
  { pincode: 782120, serviceable: "Yes", tier: "2" },
  { pincode: 782135, serviceable: "Yes", tier: "2" },
  { pincode: 782136, serviceable: "Yes", tier: "2" },
  { pincode: 782137, serviceable: "Yes", tier: "2" },
  { pincode: 782138, serviceable: "Yes", tier: "2" },
  { pincode: 782139, serviceable: "Yes", tier: "2" },
  { pincode: 782140, serviceable: "Yes", tier: "2" },
  { pincode: 782143, serviceable: "Yes", tier: "2" },
  { pincode: 782402, serviceable: "Yes", tier: "2" },
  { pincode: 782410, serviceable: "Yes", tier: "2" },
  { pincode: 782429, serviceable: "Yes", tier: "2" },
  { pincode: 782435, serviceable: "Yes", tier: "2" },
  { pincode: 782439, serviceable: "Yes", tier: "2" },
  { pincode: 782440, serviceable: "Yes", tier: "2" },
  { pincode: 782442, serviceable: "Yes", tier: "2" },
  { pincode: 782445, serviceable: "Yes", tier: "2" },
  { pincode: 782446, serviceable: "Yes", tier: "2" },
  { pincode: 782447, serviceable: "Yes", tier: "3" },
  { pincode: 782460, serviceable: "Yes", tier: "3" },
  { pincode: 782461, serviceable: "Yes", tier: "3" },
  { pincode: 782462, serviceable: "Yes", tier: "3" },
  { pincode: 782480, serviceable: "Yes", tier: "2" },
  { pincode: 783101, serviceable: "Yes", tier: "3" },
  { pincode: 783120, serviceable: "Yes", tier: "3" },
  { pincode: 783121, serviceable: "Yes", tier: "3" },
  { pincode: 783122, serviceable: "Yes", tier: "3" },
  { pincode: 783124, serviceable: "Yes", tier: "3" },
  { pincode: 783125, serviceable: "Yes", tier: "3" },
  { pincode: 783126, serviceable: "Yes", tier: "3" },
  { pincode: 783133, serviceable: "Yes", tier: "3" },
  { pincode: 783134, serviceable: "Yes", tier: "3" },
  { pincode: 783301, serviceable: "Yes", tier: "3" },
  { pincode: 783333, serviceable: "Yes", tier: "3" },
  { pincode: 783336, serviceable: "Yes", tier: "3" },
  { pincode: 783337, serviceable: "Yes", tier: "3" },
  { pincode: 783345, serviceable: "Yes", tier: "3" },
  { pincode: 783346, serviceable: "Yes", tier: "3" },
  { pincode: 783347, serviceable: "Yes", tier: "3" },
  { pincode: 783354, serviceable: "Yes", tier: "3" },
  { pincode: 783360, serviceable: "Yes", tier: "3" },
  { pincode: 783361, serviceable: "Yes", tier: "3" },
  { pincode: 783369, serviceable: "Yes", tier: "3" },
  { pincode: 783370, serviceable: "Yes", tier: "3" },
  { pincode: 783373, serviceable: "Yes", tier: "2" },
  { pincode: 783375, serviceable: "Yes", tier: "2" },
  { pincode: 783376, serviceable: "Yes", tier: "3" },
  { pincode: 783380, serviceable: "Yes", tier: "2" },
  { pincode: 783381, serviceable: "Yes", tier: "2" },
  { pincode: 783385, serviceable: "Yes", tier: "2" },
  { pincode: 783390, serviceable: "Yes", tier: "2" },
  { pincode: 783391, serviceable: "Yes", tier: "2" },
  { pincode: 783392, serviceable: "Yes", tier: "2" },
  { pincode: 783394, serviceable: "Yes", tier: "2" },
  { pincode: 784001, serviceable: "Yes", tier: "3" },
  { pincode: 784010, serviceable: "Yes", tier: "2" },
  { pincode: 784025, serviceable: "Yes", tier: "2" },
  { pincode: 784026, serviceable: "Yes", tier: "2" },
  { pincode: 784027, serviceable: "Yes", tier: "2" },
  { pincode: 784028, serviceable: "Yes", tier: "2" },
  { pincode: 784101, serviceable: "Yes", tier: "2" },
  { pincode: 784104, serviceable: "Yes", tier: "2" },
  { pincode: 784105, serviceable: "Yes", tier: "2" },
  { pincode: 784110, serviceable: "Yes", tier: "3" },
  { pincode: 784115, serviceable: "Yes", tier: "2" },
  { pincode: 784117, serviceable: "Yes", tier: "3" },
  { pincode: 784125, serviceable: "Yes", tier: "2" },
  { pincode: 784145, serviceable: "Yes", tier: "2" },
  { pincode: 784149, serviceable: "Yes", tier: "2" },
  { pincode: 784150, serviceable: "Yes", tier: "2" },
  { pincode: 784153, serviceable: "Yes", tier: "2" },
  { pincode: 784154, serviceable: "Yes", tier: "3" },
  { pincode: 784160, serviceable: "Yes", tier: "3" },
  { pincode: 784161, serviceable: "Yes", tier: "3" },
  { pincode: 784163, serviceable: "Yes", tier: "3" },
  { pincode: 784164, serviceable: "Yes", tier: "3" },
  { pincode: 784168, serviceable: "Yes", tier: "3" },
  { pincode: 784169, serviceable: "Yes", tier: "3" },
  { pincode: 784170, serviceable: "Yes", tier: "3" },
  { pincode: 784171, serviceable: "Yes", tier: "3" },
  { pincode: 784172, serviceable: "Yes", tier: "3" },
  { pincode: 784174, serviceable: "Yes", tier: "5" },
  { pincode: 784175, serviceable: "Yes", tier: "5" },
  { pincode: 784176, serviceable: "Yes", tier: "5" },
  { pincode: 784177, serviceable: "Yes", tier: "5" },
  { pincode: 784178, serviceable: "Yes", tier: "3" },
  { pincode: 784180, serviceable: "Yes", tier: "5" },
  { pincode: 784189, serviceable: "Yes", tier: "5" },
  { pincode: 784501, serviceable: "Yes", tier: "2" },
  { pincode: 784502, serviceable: "Yes", tier: "2" },
  { pincode: 784504, serviceable: "Yes", tier: "2" },
  { pincode: 784505, serviceable: "Yes", tier: "2" },
  { pincode: 784506, serviceable: "Yes", tier: "2" },
  { pincode: 784521, serviceable: "Yes", tier: "2" },
  { pincode: 784525, serviceable: "Yes", tier: "2" },
  { pincode: 785001, serviceable: "Yes", tier: "2" },
  { pincode: 785002, serviceable: "Yes", tier: "2" },
  { pincode: 785004, serviceable: "Yes", tier: "2" },
  { pincode: 785005, serviceable: "Yes", tier: "2" },
  { pincode: 785006, serviceable: "Yes", tier: "2" },
  { pincode: 785007, serviceable: "Yes", tier: "2" },
  { pincode: 785008, serviceable: "Yes", tier: "2" },
  { pincode: 785009, serviceable: "Yes", tier: "2" },
  { pincode: 785010, serviceable: "Yes", tier: "2" },
  { pincode: 785013, serviceable: "Yes", tier: "2" },
  { pincode: 785101, serviceable: "Yes", tier: "2" },
  { pincode: 785102, serviceable: "Yes", tier: "2" },
  { pincode: 785107, serviceable: "Yes", tier: "2" },
  { pincode: 785108, serviceable: "Yes", tier: "2" },
  { pincode: 785111, serviceable: "Yes", tier: "2" },
  { pincode: 785112, serviceable: "Yes", tier: "2" },
  { pincode: 785609, serviceable: "Yes", tier: "2" },
  { pincode: 785610, serviceable: "Yes", tier: "2" },
  { pincode: 785612, serviceable: "Yes", tier: "2" },
  { pincode: 785613, serviceable: "Yes", tier: "2" },
  { pincode: 785615, serviceable: "Yes", tier: "2" },
  { pincode: 785618, serviceable: "Yes", tier: "2" },
  { pincode: 785619, serviceable: "Yes", tier: "2" },
  { pincode: 785621, serviceable: "Yes", tier: "2" },
  { pincode: 785622, serviceable: "Yes", tier: "2" },
  { pincode: 785625, serviceable: "Yes", tier: "2" },
  { pincode: 785626, serviceable: "Yes", tier: "2" },
  { pincode: 785630, serviceable: "Yes", tier: "2" },
  { pincode: 785636, serviceable: "Yes", tier: "2" },
  { pincode: 785640, serviceable: "Yes", tier: "2" },
  { pincode: 785661, serviceable: "Yes", tier: "2" },
  { pincode: 785662, serviceable: "Yes", tier: "2" },
  { pincode: 785665, serviceable: "Yes", tier: "2" },
  { pincode: 785669, serviceable: "Yes", tier: "2" },
  { pincode: 785670, serviceable: "Yes", tier: "2" },
  { pincode: 785671, serviceable: "Yes", tier: "2" },
  { pincode: 785672, serviceable: "Yes", tier: "2" },
  { pincode: 785680, serviceable: "Yes", tier: "2" },
  { pincode: 785681, serviceable: "Yes", tier: "2" },
  { pincode: 785682, serviceable: "Yes", tier: "2" },
  { pincode: 785683, serviceable: "Yes", tier: "2" },
  { pincode: 785684, serviceable: "Yes", tier: "2" },
  { pincode: 785685, serviceable: "Yes", tier: "3" },
  { pincode: 785686, serviceable: "Yes", tier: "3" },
  { pincode: 785687, serviceable: "Yes", tier: "2" },
  { pincode: 785688, serviceable: "Yes", tier: "3" },
  { pincode: 785689, serviceable: "Yes", tier: "3" },
  { pincode: 785690, serviceable: "Yes", tier: "3" },
  { pincode: 785691, serviceable: "Yes", tier: "3" },
  { pincode: 785692, serviceable: "Yes", tier: "3" },
  { pincode: 785696, serviceable: "Yes", tier: "2" },
  { pincode: 785699, serviceable: "Yes", tier: "2" },
  { pincode: 785700, serviceable: "Yes", tier: "2" },
  { pincode: 785701, serviceable: "Yes", tier: "3" },
  { pincode: 785702, serviceable: "Yes", tier: "2" },
  { pincode: 785703, serviceable: "Yes", tier: "2" },
  { pincode: 785704, serviceable: "Yes", tier: "2" },
  { pincode: 785705, serviceable: "Yes", tier: "2" },
  { pincode: 786001, serviceable: "Yes", tier: "2" },
  { pincode: 786002, serviceable: "Yes", tier: "2" },
  { pincode: 786003, serviceable: "Yes", tier: "2" },
  { pincode: 786004, serviceable: "Yes", tier: "2" },
  { pincode: 786005, serviceable: "Yes", tier: "2" },
  { pincode: 786006, serviceable: "Yes", tier: "2" },
  { pincode: 786007, serviceable: "Yes", tier: "2" },
  { pincode: 786008, serviceable: "Yes", tier: "2" },
  { pincode: 786010, serviceable: "Yes", tier: "2" },
  { pincode: 786012, serviceable: "Yes", tier: "2" },
  { pincode: 786102, serviceable: "Yes", tier: "2" },
  { pincode: 786125, serviceable: "Yes", tier: "2" },
  { pincode: 786126, serviceable: "Yes", tier: "2" },
  { pincode: 786145, serviceable: "Yes", tier: "2" },
  { pincode: 786146, serviceable: "Yes", tier: "2" },
  { pincode: 786147, serviceable: "Yes", tier: "2" },
  { pincode: 786148, serviceable: "Yes", tier: "2" },
  { pincode: 786150, serviceable: "Yes", tier: "3" },
  { pincode: 786151, serviceable: "Yes", tier: "3" },
  { pincode: 786152, serviceable: "Yes", tier: "3" },
  { pincode: 786153, serviceable: "Yes", tier: "3" },
  { pincode: 786156, serviceable: "Yes", tier: "3" },
  { pincode: 786159, serviceable: "Yes", tier: "3" },
  { pincode: 786160, serviceable: "Yes", tier: "3" },
  { pincode: 786170, serviceable: "Yes", tier: "2" },
  { pincode: 786171, serviceable: "Yes", tier: "2" },
  { pincode: 786173, serviceable: "Yes", tier: "2" },
  { pincode: 786179, serviceable: "Yes", tier: "3" },
  { pincode: 786181, serviceable: "Yes", tier: "2" },
  { pincode: 786182, serviceable: "Yes", tier: "2" },
  { pincode: 786183, serviceable: "Yes", tier: "2" },
  { pincode: 786184, serviceable: "Yes", tier: "2" },
  { pincode: 786187, serviceable: "Yes", tier: "2" },
  { pincode: 786188, serviceable: "Yes", tier: "3" },
  { pincode: 786189, serviceable: "Yes", tier: "2" },
  { pincode: 786190, serviceable: "Yes", tier: "3" },
  { pincode: 786191, serviceable: "Yes", tier: "2" },
  { pincode: 786192, serviceable: "Yes", tier: "2" },
  { pincode: 786601, serviceable: "Yes", tier: "2" },
  { pincode: 786602, serviceable: "Yes", tier: "2" },
  { pincode: 786610, serviceable: "Yes", tier: "2" },
  { pincode: 786611, serviceable: "Yes", tier: "2" },
  { pincode: 786612, serviceable: "Yes", tier: "2" },
  { pincode: 786614, serviceable: "Yes", tier: "2" },
  { pincode: 786621, serviceable: "Yes", tier: "2" },
  { pincode: 786622, serviceable: "Yes", tier: "2" },
  { pincode: 786623, serviceable: "Yes", tier: "2" },
  { pincode: 786692, serviceable: "Yes", tier: "2" },
  { pincode: 787001, serviceable: "Yes", tier: "5" },
  { pincode: 787023, serviceable: "Yes", tier: "5" },
  { pincode: 787026, serviceable: "Yes", tier: "2" },
  { pincode: 787031, serviceable: "Yes", tier: "5" },
  { pincode: 787032, serviceable: "Yes", tier: "5" },
  { pincode: 787034, serviceable: "Yes", tier: "2" },
  { pincode: 787035, serviceable: "Yes", tier: "2" },
  { pincode: 787051, serviceable: "Yes", tier: "5" },
  { pincode: 787053, serviceable: "Yes", tier: "2" },
  { pincode: 787054, serviceable: "Yes", tier: "3" },
  { pincode: 787055, serviceable: "Yes", tier: "2" },
  { pincode: 787056, serviceable: "Yes", tier: "5" },
  { pincode: 787057, serviceable: "Yes", tier: "2" },
  { pincode: 787059, serviceable: "Yes", tier: "2" },
  { pincode: 787060, serviceable: "Yes", tier: "2" },
  { pincode: 787061, serviceable: "Yes", tier: "2" },
  { pincode: 787110, serviceable: "Yes", tier: "2" },
  { pincode: 788001, serviceable: "Yes", tier: "3" },
  { pincode: 788002, serviceable: "Yes", tier: "3" },
  { pincode: 788003, serviceable: "Yes", tier: "3" },
  { pincode: 788004, serviceable: "Yes", tier: "3" },
  { pincode: 788005, serviceable: "Yes", tier: "3" },
  { pincode: 788006, serviceable: "Yes", tier: "3" },
  { pincode: 788007, serviceable: "Yes", tier: "3" },
  { pincode: 788009, serviceable: "Yes", tier: "3" },
  { pincode: 788010, serviceable: "Yes", tier: "3" },
  { pincode: 788011, serviceable: "Yes", tier: "3" },
  { pincode: 788014, serviceable: "Yes", tier: "3" },
  { pincode: 788015, serviceable: "Yes", tier: "3" },
  { pincode: 788098, serviceable: "Yes", tier: "5" },
  { pincode: 788101, serviceable: "Yes", tier: "5" },
  { pincode: 788102, serviceable: "Yes", tier: "5" },
  { pincode: 788103, serviceable: "Yes", tier: "5" },
  { pincode: 788104, serviceable: "Yes", tier: "5" },
  { pincode: 788106, serviceable: "Yes", tier: "5" },
  { pincode: 788107, serviceable: "Yes", tier: "5" },
  { pincode: 788150, serviceable: "Yes", tier: "5" },
  { pincode: 788151, serviceable: "Yes", tier: "5" },
  { pincode: 788152, serviceable: "Yes", tier: "5" },
  { pincode: 788155, serviceable: "Yes", tier: "5" },
  { pincode: 788160, serviceable: "Yes", tier: "5" },
  { pincode: 788163, serviceable: "Yes", tier: "5" },
  { pincode: 788164, serviceable: "Yes", tier: "5" },
  { pincode: 788165, serviceable: "Yes", tier: "5" },
  { pincode: 788166, serviceable: "Yes", tier: "5" },
  { pincode: 788168, serviceable: "Yes", tier: "5" },
  { pincode: 788709, serviceable: "Yes", tier: "5" },
  { pincode: 788710, serviceable: "Yes", tier: "5" },
  { pincode: 788711, serviceable: "Yes", tier: "5" },
  { pincode: 788712, serviceable: "Yes", tier: "5" },
  { pincode: 788713, serviceable: "Yes", tier: "5" },
  { pincode: 788719, serviceable: "Yes", tier: "5" },
  { pincode: 788720, serviceable: "Yes", tier: "5" },
  { pincode: 788722, serviceable: "Yes", tier: "5" },
  { pincode: 788723, serviceable: "Yes", tier: "5" },
  { pincode: 788733, serviceable: "Yes", tier: "5" },
  { pincode: 788781, serviceable: "Yes", tier: "5" },
  { pincode: 788819, serviceable: "Yes", tier: "5" },
  { pincode: 788820, serviceable: "Yes", tier: "5" },
  { pincode: 791102, serviceable: "Yes", tier: "2" },
  { pincode: 791110, serviceable: "Yes", tier: "3" },
  { pincode: 791111, serviceable: "Yes", tier: "2" },
  { pincode: 791113, serviceable: "Yes", tier: "2" },
  { pincode: 791120, serviceable: "Yes", tier: "3" },
  { pincode: 791123, serviceable: "Yes", tier: "3" },
  { pincode: 792110, serviceable: "Yes", tier: "3" },
  { pincode: 793001, serviceable: "Yes", tier: "2" },
  { pincode: 793002, serviceable: "Yes", tier: "2" },
  { pincode: 793003, serviceable: "Yes", tier: "2" },
  { pincode: 793004, serviceable: "Yes", tier: "2" },
  { pincode: 793005, serviceable: "Yes", tier: "2" },
  { pincode: 793006, serviceable: "Yes", tier: "2" },
  { pincode: 793007, serviceable: "Yes", tier: "2" },
  { pincode: 793008, serviceable: "Yes", tier: "2" },
  { pincode: 793010, serviceable: "Yes", tier: "2" },
  { pincode: 793011, serviceable: "Yes", tier: "2" },
  { pincode: 793014, serviceable: "Yes", tier: "2" },
  { pincode: 793017, serviceable: "Yes", tier: "2" },
  { pincode: 793018, serviceable: "Yes", tier: "2" },
  { pincode: 793019, serviceable: "Yes", tier: "2" },
  { pincode: 793022, serviceable: "Yes", tier: "2" },
  { pincode: 793150, serviceable: "Yes", tier: "3" },
  { pincode: 793160, serviceable: "Yes", tier: "2" },
  { pincode: 793200, serviceable: "Yes", tier: "2" },
  { pincode: 793210, serviceable: "Yes", tier: "2" },
  { pincode: 794001, serviceable: "Yes", tier: "3" },
  { pincode: 795001, serviceable: "Yes", tier: "2" },
  { pincode: 795002, serviceable: "Yes", tier: "2" },
  { pincode: 795003, serviceable: "Yes", tier: "2" },
  { pincode: 795004, serviceable: "Yes", tier: "2" },
  { pincode: 795005, serviceable: "Yes", tier: "2" },
  { pincode: 795008, serviceable: "Yes", tier: "2" },
  { pincode: 795009, serviceable: "Yes", tier: "2" },
  { pincode: 795011, serviceable: "Yes", tier: "2" },
  { pincode: 795103, serviceable: "Yes", tier: "3" },
  { pincode: 795126, serviceable: "Yes", tier: "2" },
  { pincode: 795134, serviceable: "Yes", tier: "2" },
  { pincode: 795138, serviceable: "Yes", tier: "3" },
  { pincode: 795140, serviceable: "Yes", tier: "2" },
  { pincode: 796001, serviceable: "Yes", tier: "3" },
  { pincode: 796004, serviceable: "Yes", tier: "3" },
  { pincode: 796005, serviceable: "Yes", tier: "3" },
  { pincode: 796007, serviceable: "Yes", tier: "3" },
  { pincode: 796008, serviceable: "Yes", tier: "3" },
  { pincode: 796009, serviceable: "Yes", tier: "3" },
  { pincode: 796012, serviceable: "Yes", tier: "3" },
  { pincode: 796014, serviceable: "Yes", tier: "3" },
  { pincode: 796691, serviceable: "Yes", tier: "5" },
  { pincode: 796701, serviceable: "Yes", tier: "5" },
  { pincode: 797001, serviceable: "Yes", tier: "2" },
  { pincode: 797004, serviceable: "Yes", tier: "2" },
  { pincode: 797103, serviceable: "Yes", tier: "2" },
  { pincode: 797111, serviceable: "Yes", tier: "3" },
  { pincode: 797112, serviceable: "Yes", tier: "2" },
  { pincode: 797113, serviceable: "Yes", tier: "2" },
  { pincode: 797115, serviceable: "Yes", tier: "2" },
  { pincode: 797116, serviceable: "Yes", tier: "2" },
  { pincode: 797117, serviceable: "Yes", tier: "2" },
  { pincode: 797121, serviceable: "Yes", tier: "2" },
  { pincode: 798601, serviceable: "Yes", tier: "3" },
  { pincode: 798612, serviceable: "Yes", tier: "3" },
  { pincode: 798618, serviceable: "Yes", tier: "3" },
  { pincode: 798620, serviceable: "Yes", tier: "3" },
  { pincode: 798623, serviceable: "Yes", tier: "3" },
  { pincode: 798627, serviceable: "Yes", tier: "3" },
  { pincode: 799001, serviceable: "Yes", tier: "2" },
  { pincode: 799002, serviceable: "Yes", tier: "2" },
  { pincode: 799003, serviceable: "Yes", tier: "2" },
  { pincode: 799004, serviceable: "Yes", tier: "2" },
  { pincode: 799005, serviceable: "Yes", tier: "2" },
  { pincode: 799006, serviceable: "Yes", tier: "2" },
  { pincode: 799007, serviceable: "Yes", tier: "2" },
  { pincode: 799008, serviceable: "Yes", tier: "2" },
  { pincode: 799009, serviceable: "Yes", tier: "2" },
  { pincode: 799010, serviceable: "Yes", tier: "2" },
  { pincode: 799011, serviceable: "Yes", tier: "2" },
  { pincode: 799012, serviceable: "Yes", tier: "2" },
  { pincode: 799013, serviceable: "Yes", tier: "2" },
  { pincode: 799014, serviceable: "Yes", tier: "2" },
  { pincode: 799015, serviceable: "Yes", tier: "2" },
  { pincode: 799022, serviceable: "Yes", tier: "2" },
  { pincode: 799035, serviceable: "Yes", tier: "2" },
  { pincode: 799046, serviceable: "Yes", tier: "2" },
  { pincode: 799101, serviceable: "Yes", tier: "2" },
  { pincode: 799103, serviceable: "Yes", tier: "2" },
  { pincode: 799104, serviceable: "Yes", tier: "2" },
  { pincode: 799105, serviceable: "Yes", tier: "2" },
  { pincode: 799113, serviceable: "Yes", tier: "2" },
  { pincode: 799114, serviceable: "Yes", tier: "2" },
  { pincode: 799115, serviceable: "Yes", tier: "2" },
  { pincode: 799120, serviceable: "Yes", tier: "2" },
  { pincode: 799125, serviceable: "Yes", tier: "2" },
  { pincode: 799130, serviceable: "Yes", tier: "2" },
  { pincode: 799131, serviceable: "Yes", tier: "2" },
  { pincode: 799132, serviceable: "Yes", tier: "2" },
  { pincode: 799204, serviceable: "Yes", tier: "2" },
  { pincode: 799210, serviceable: "Yes", tier: "2" },
  { pincode: 799211, serviceable: "Yes", tier: "2" },
  { pincode: 799250, serviceable: "Yes", tier: "3" },
  { pincode: 799253, serviceable: "Yes", tier: "3" },
  { pincode: 799254, serviceable: "Yes", tier: "3" },
  { pincode: 799256, serviceable: "Yes", tier: "3" },
  { pincode: 799260, serviceable: "Yes", tier: "3" },
  { pincode: 799261, serviceable: "Yes", tier: "3" },
  { pincode: 799263, serviceable: "Yes", tier: "3" },
  { pincode: 799264, serviceable: "Yes", tier: "3" },
  { pincode: 799270, serviceable: "Yes", tier: "3" },
  { pincode: 799277, serviceable: "Yes", tier: "3" },
  { pincode: 799278, serviceable: "Yes", tier: "2" },
  { pincode: 799279, serviceable: "Yes", tier: "3" },
  { pincode: 799280, serviceable: "Yes", tier: "3" },
  { pincode: 799281, serviceable: "Yes", tier: "3" },
  { pincode: 799282, serviceable: "Yes", tier: "3" },
  { pincode: 799287, serviceable: "Yes", tier: "2" },
  { pincode: 799289, serviceable: "Yes", tier: "2" },
  { pincode: 800001, serviceable: "Yes", tier: "2" },
  { pincode: 800002, serviceable: "Yes", tier: "2" },
  { pincode: 800003, serviceable: "Yes", tier: "2" },
  { pincode: 800004, serviceable: "Yes", tier: "2" },
  { pincode: 800005, serviceable: "Yes", tier: "2" },
  { pincode: 800006, serviceable: "Yes", tier: "2" },
  { pincode: 800007, serviceable: "Yes", tier: "2" },
  { pincode: 800008, serviceable: "Yes", tier: "2" },
  { pincode: 800009, serviceable: "Yes", tier: "2" },
  { pincode: 800010, serviceable: "Yes", tier: "2" },
  { pincode: 800011, serviceable: "Yes", tier: "2" },
  { pincode: 800012, serviceable: "Yes", tier: "2" },
  { pincode: 800013, serviceable: "Yes", tier: "2" },
  { pincode: 800014, serviceable: "Yes", tier: "2" },
  { pincode: 800015, serviceable: "Yes", tier: "2" },
  { pincode: 800016, serviceable: "Yes", tier: "2" },
  { pincode: 800017, serviceable: "Yes", tier: "2" },
  { pincode: 800018, serviceable: "Yes", tier: "2" },
  { pincode: 800019, serviceable: "Yes", tier: "2" },
  { pincode: 800020, serviceable: "Yes", tier: "2" },
  { pincode: 800021, serviceable: "Yes", tier: "2" },
  { pincode: 800022, serviceable: "Yes", tier: "2" },
  { pincode: 800023, serviceable: "Yes", tier: "2" },
  { pincode: 800024, serviceable: "Yes", tier: "2" },
  { pincode: 800025, serviceable: "Yes", tier: "2" },
  { pincode: 800026, serviceable: "Yes", tier: "2" },
  { pincode: 800027, serviceable: "Yes", tier: "2" },
  { pincode: 800028, serviceable: "Yes", tier: "2" },
  { pincode: 800030, serviceable: "Yes", tier: "2" },
  { pincode: 801102, serviceable: "Yes", tier: "3" },
  { pincode: 801103, serviceable: "Yes", tier: "3" },
  { pincode: 801104, serviceable: "Yes", tier: "3" },
  { pincode: 801105, serviceable: "Yes", tier: "3" },
  { pincode: 801106, serviceable: "Yes", tier: "3" },
  { pincode: 801108, serviceable: "Yes", tier: "3" },
  { pincode: 801109, serviceable: "Yes", tier: "3" },
  { pincode: 801110, serviceable: "Yes", tier: "3" },
  { pincode: 801111, serviceable: "Yes", tier: "3" },
  { pincode: 801112, serviceable: "Yes", tier: "3" },
  { pincode: 801113, serviceable: "Yes", tier: "3" },
  { pincode: 801302, serviceable: "Yes", tier: "3" },
  { pincode: 801304, serviceable: "Yes", tier: "3" },
  { pincode: 801306, serviceable: "Yes", tier: "3" },
  { pincode: 801501, serviceable: "Yes", tier: "2" },
  { pincode: 801503, serviceable: "Yes", tier: "3" },
  { pincode: 801505, serviceable: "Yes", tier: "2" },
  { pincode: 801506, serviceable: "Yes", tier: "2" },
  { pincode: 801507, serviceable: "Yes", tier: "3" },
  { pincode: 802101, serviceable: "Yes", tier: "3" },
  { pincode: 802102, serviceable: "Yes", tier: "3" },
  { pincode: 802103, serviceable: "Yes", tier: "3" },
  { pincode: 802111, serviceable: "Yes", tier: "3" },
  { pincode: 802112, serviceable: "Yes", tier: "3" },
  { pincode: 802113, serviceable: "Yes", tier: "3" },
  { pincode: 802116, serviceable: "Yes", tier: "3" },
  { pincode: 802117, serviceable: "Yes", tier: "3" },
  { pincode: 802118, serviceable: "Yes", tier: "3" },
  { pincode: 802119, serviceable: "Yes", tier: "3" },
  { pincode: 802120, serviceable: "Yes", tier: "3" },
  { pincode: 802122, serviceable: "Yes", tier: "3" },
  { pincode: 802123, serviceable: "Yes", tier: "3" },
  { pincode: 802125, serviceable: "Yes", tier: "3" },
  { pincode: 802126, serviceable: "Yes", tier: "3" },
  { pincode: 802130, serviceable: "Yes", tier: "3" },
  { pincode: 802133, serviceable: "Yes", tier: "3" },
  { pincode: 802134, serviceable: "Yes", tier: "3" },
  { pincode: 802135, serviceable: "Yes", tier: "3" },
  { pincode: 802136, serviceable: "Yes", tier: "3" },
  { pincode: 802151, serviceable: "Yes", tier: "3" },
  { pincode: 802152, serviceable: "Yes", tier: "3" },
  { pincode: 802153, serviceable: "Yes", tier: "3" },
  { pincode: 802154, serviceable: "Yes", tier: "3" },
  { pincode: 802156, serviceable: "Yes", tier: "5" },
  { pincode: 802157, serviceable: "Yes", tier: "5" },
  { pincode: 802158, serviceable: "Yes", tier: "3" },
  { pincode: 802159, serviceable: "Yes", tier: "3" },
  { pincode: 802160, serviceable: "Yes", tier: "5" },
  { pincode: 802161, serviceable: "Yes", tier: "5" },
  { pincode: 802162, serviceable: "Yes", tier: "5" },
  { pincode: 802163, serviceable: "Yes", tier: "5" },
  { pincode: 802165, serviceable: "Yes", tier: "3" },
  { pincode: 802166, serviceable: "Yes", tier: "3" },
  { pincode: 802183, serviceable: "Yes", tier: "3" },
  { pincode: 802201, serviceable: "Yes", tier: "5" },
  { pincode: 802202, serviceable: "Yes", tier: "3" },
  { pincode: 802203, serviceable: "Yes", tier: "5" },
  { pincode: 802204, serviceable: "Yes", tier: "3" },
  { pincode: 802205, serviceable: "Yes", tier: "3" },
  { pincode: 802206, serviceable: "Yes", tier: "5" },
  { pincode: 802207, serviceable: "Yes", tier: "3" },
  { pincode: 802209, serviceable: "Yes", tier: "3" },
  { pincode: 802210, serviceable: "Yes", tier: "5" },
  { pincode: 802211, serviceable: "Yes", tier: "3" },
  { pincode: 802212, serviceable: "Yes", tier: "3" },
  { pincode: 802213, serviceable: "Yes", tier: "3" },
  { pincode: 802214, serviceable: "Yes", tier: "3" },
  { pincode: 802215, serviceable: "Yes", tier: "3" },
  { pincode: 802216, serviceable: "Yes", tier: "3" },
  { pincode: 802217, serviceable: "Yes", tier: "3" },
  { pincode: 802218, serviceable: "Yes", tier: "3" },
  { pincode: 802219, serviceable: "Yes", tier: "5" },
  { pincode: 802220, serviceable: "Yes", tier: "3" },
  { pincode: 802221, serviceable: "Yes", tier: "3" },
  { pincode: 802223, serviceable: "Yes", tier: "3" },
  { pincode: 802226, serviceable: "Yes", tier: "3" },
  { pincode: 802229, serviceable: "Yes", tier: "3" },
  { pincode: 802301, serviceable: "Yes", tier: "5" },
  { pincode: 802302, serviceable: "Yes", tier: "5" },
  { pincode: 802311, serviceable: "Yes", tier: "5" },
  { pincode: 802312, serviceable: "Yes", tier: "5" },
  { pincode: 802314, serviceable: "Yes", tier: "5" },
  { pincode: 802316, serviceable: "Yes", tier: "5" },
  { pincode: 802351, serviceable: "Yes", tier: "3" },
  { pincode: 802352, serviceable: "Yes", tier: "5" },
  { pincode: 803101, serviceable: "Yes", tier: "3" },
  { pincode: 803108, serviceable: "Yes", tier: "3" },
  { pincode: 803110, serviceable: "Yes", tier: "3" },
  { pincode: 803111, serviceable: "Yes", tier: "3" },
  { pincode: 803113, serviceable: "Yes", tier: "3" },
  { pincode: 803114, serviceable: "Yes", tier: "3" },
  { pincode: 803115, serviceable: "Yes", tier: "3" },
  { pincode: 803116, serviceable: "Yes", tier: "3" },
  { pincode: 803117, serviceable: "Yes", tier: "3" },
  { pincode: 803118, serviceable: "Yes", tier: "3" },
  { pincode: 803121, serviceable: "Yes", tier: "3" },
  { pincode: 803201, serviceable: "Yes", tier: "3" },
  { pincode: 803202, serviceable: "Yes", tier: "3" },
  { pincode: 803203, serviceable: "Yes", tier: "3" },
  { pincode: 803211, serviceable: "Yes", tier: "3" },
  { pincode: 803212, serviceable: "Yes", tier: "3" },
  { pincode: 803213, serviceable: "Yes", tier: "3" },
  { pincode: 803214, serviceable: "Yes", tier: "3" },
  { pincode: 803215, serviceable: "Yes", tier: "3" },
  { pincode: 803221, serviceable: "Yes", tier: "3" },
  { pincode: 803301, serviceable: "Yes", tier: "3" },
  { pincode: 803302, serviceable: "Yes", tier: "3" },
  { pincode: 803303, serviceable: "Yes", tier: "3" },
  { pincode: 803306, serviceable: "Yes", tier: "3" },
  { pincode: 803307, serviceable: "Yes", tier: "3" },
  { pincode: 804401, serviceable: "Yes", tier: "3" },
  { pincode: 804402, serviceable: "Yes", tier: "3" },
  { pincode: 804404, serviceable: "Yes", tier: "3" },
  { pincode: 804406, serviceable: "Yes", tier: "3" },
  { pincode: 804408, serviceable: "Yes", tier: "3" },
  { pincode: 804417, serviceable: "Yes", tier: "3" },
  { pincode: 804418, serviceable: "Yes", tier: "3" },
  { pincode: 804419, serviceable: "Yes", tier: "3" },
  { pincode: 804420, serviceable: "Yes", tier: "3" },
  { pincode: 804422, serviceable: "Yes", tier: "3" },
  { pincode: 804423, serviceable: "Yes", tier: "3" },
  { pincode: 804424, serviceable: "Yes", tier: "3" },
  { pincode: 804425, serviceable: "Yes", tier: "3" },
  { pincode: 804426, serviceable: "Yes", tier: "3" },
  { pincode: 804427, serviceable: "Yes", tier: "3" },
  { pincode: 804429, serviceable: "Yes", tier: "3" },
  { pincode: 804430, serviceable: "Yes", tier: "3" },
  { pincode: 804432, serviceable: "Yes", tier: "3" },
  { pincode: 804434, serviceable: "Yes", tier: "3" },
  { pincode: 804451, serviceable: "Yes", tier: "5" },
  { pincode: 804452, serviceable: "Yes", tier: "5" },
  { pincode: 804453, serviceable: "Yes", tier: "5" },
  { pincode: 804454, serviceable: "Yes", tier: "3" },
  { pincode: 805102, serviceable: "Yes", tier: "3" },
  { pincode: 805103, serviceable: "Yes", tier: "3" },
  { pincode: 805104, serviceable: "Yes", tier: "3" },
  { pincode: 805106, serviceable: "Yes", tier: "3" },
  { pincode: 805107, serviceable: "Yes", tier: "3" },
  { pincode: 805108, serviceable: "Yes", tier: "3" },
  { pincode: 805109, serviceable: "Yes", tier: "3" },
  { pincode: 805110, serviceable: "Yes", tier: "3" },
  { pincode: 805111, serviceable: "Yes", tier: "3" },
  { pincode: 805112, serviceable: "Yes", tier: "3" },
  { pincode: 805113, serviceable: "Yes", tier: "3" },
  { pincode: 805121, serviceable: "Yes", tier: "3" },
  { pincode: 805122, serviceable: "Yes", tier: "3" },
  { pincode: 805123, serviceable: "Yes", tier: "3" },
  { pincode: 805124, serviceable: "Yes", tier: "3" },
  { pincode: 805125, serviceable: "Yes", tier: "3" },
  { pincode: 805126, serviceable: "Yes", tier: "3" },
  { pincode: 805127, serviceable: "Yes", tier: "3" },
  { pincode: 805129, serviceable: "Yes", tier: "3" },
  { pincode: 805130, serviceable: "Yes", tier: "3" },
  { pincode: 805131, serviceable: "Yes", tier: "3" },
  { pincode: 805132, serviceable: "Yes", tier: "3" },
  { pincode: 805133, serviceable: "Yes", tier: "3" },
  { pincode: 805141, serviceable: "Yes", tier: "3" },
  { pincode: 805236, serviceable: "Yes", tier: "3" },
  { pincode: 811101, serviceable: "Yes", tier: "5" },
  { pincode: 811102, serviceable: "Yes", tier: "5" },
  { pincode: 811103, serviceable: "Yes", tier: "5" },
  { pincode: 811104, serviceable: "Yes", tier: "5" },
  { pincode: 811105, serviceable: "Yes", tier: "5" },
  { pincode: 811106, serviceable: "Yes", tier: "3" },
  { pincode: 811107, serviceable: "Yes", tier: "3" },
  { pincode: 811112, serviceable: "Yes", tier: "3" },
  { pincode: 811201, serviceable: "Yes", tier: "5" },
  { pincode: 811202, serviceable: "Yes", tier: "5" },
  { pincode: 811211, serviceable: "Yes", tier: "5" },
  { pincode: 811212, serviceable: "Yes", tier: "5" },
  { pincode: 811213, serviceable: "Yes", tier: "5" },
  { pincode: 811214, serviceable: "Yes", tier: "5" },
  { pincode: 811302, serviceable: "Yes", tier: "3" },
  { pincode: 811304, serviceable: "Yes", tier: "5" },
  { pincode: 811305, serviceable: "Yes", tier: "5" },
  { pincode: 811307, serviceable: "Yes", tier: "5" },
  { pincode: 811308, serviceable: "Yes", tier: "5" },
  { pincode: 811309, serviceable: "Yes", tier: "3" },
  { pincode: 811310, serviceable: "Yes", tier: "3" },
  { pincode: 811311, serviceable: "Yes", tier: "3" },
  { pincode: 811312, serviceable: "Yes", tier: "5" },
  { pincode: 811313, serviceable: "Yes", tier: "5" },
  { pincode: 811315, serviceable: "Yes", tier: "5" },
  { pincode: 811317, serviceable: "Yes", tier: "5" },
  { pincode: 811538, serviceable: "Yes", tier: "3" },
  { pincode: 812001, serviceable: "Yes", tier: "3" },
  { pincode: 812002, serviceable: "Yes", tier: "3" },
  { pincode: 812003, serviceable: "Yes", tier: "3" },
  { pincode: 812004, serviceable: "Yes", tier: "3" },
  { pincode: 812005, serviceable: "Yes", tier: "3" },
  { pincode: 812006, serviceable: "Yes", tier: "3" },
  { pincode: 812007, serviceable: "Yes", tier: "3" },
  { pincode: 813101, serviceable: "Yes", tier: "5" },
  { pincode: 813102, serviceable: "Yes", tier: "5" },
  { pincode: 813103, serviceable: "Yes", tier: "5" },
  { pincode: 813104, serviceable: "Yes", tier: "5" },
  { pincode: 813105, serviceable: "Yes", tier: "3" },
  { pincode: 813107, serviceable: "Yes", tier: "5" },
  { pincode: 813108, serviceable: "Yes", tier: "3" },
  { pincode: 813109, serviceable: "Yes", tier: "5" },
  { pincode: 813110, serviceable: "Yes", tier: "5" },
  { pincode: 813113, serviceable: "Yes", tier: "3" },
  { pincode: 813128, serviceable: "Yes", tier: "5" },
  { pincode: 813202, serviceable: "Yes", tier: "5" },
  { pincode: 813203, serviceable: "Yes", tier: "5" },
  { pincode: 813204, serviceable: "Yes", tier: "5" },
  { pincode: 813205, serviceable: "Yes", tier: "5" },
  { pincode: 813206, serviceable: "Yes", tier: "5" },
  { pincode: 813207, serviceable: "Yes", tier: "5" },
  { pincode: 813209, serviceable: "Yes", tier: "5" },
  { pincode: 813210, serviceable: "Yes", tier: "3" },
  { pincode: 813211, serviceable: "Yes", tier: "5" },
  { pincode: 813213, serviceable: "Yes", tier: "3" },
  { pincode: 813214, serviceable: "Yes", tier: "5" },
  { pincode: 813221, serviceable: "Yes", tier: "5" },
  { pincode: 813222, serviceable: "Yes", tier: "5" },
  { pincode: 814101, serviceable: "Yes", tier: "3" },
  { pincode: 814102, serviceable: "Yes", tier: "3" },
  { pincode: 814103, serviceable: "Yes", tier: "3" },
  { pincode: 814110, serviceable: "Yes", tier: "3" },
  { pincode: 814111, serviceable: "Yes", tier: "3" },
  { pincode: 814112, serviceable: "Yes", tier: "3" },
  { pincode: 814113, serviceable: "Yes", tier: "3" },
  { pincode: 814114, serviceable: "Yes", tier: "3" },
  { pincode: 814115, serviceable: "Yes", tier: "3" },
  { pincode: 814116, serviceable: "Yes", tier: "3" },
  { pincode: 814118, serviceable: "Yes", tier: "3" },
  { pincode: 814119, serviceable: "Yes", tier: "3" },
  { pincode: 814120, serviceable: "Yes", tier: "3" },
  { pincode: 814122, serviceable: "Yes", tier: "3" },
  { pincode: 814133, serviceable: "Yes", tier: "3" },
  { pincode: 814141, serviceable: "Yes", tier: "3" },
  { pincode: 814142, serviceable: "Yes", tier: "3" },
  { pincode: 814143, serviceable: "Yes", tier: "3" },
  { pincode: 814144, serviceable: "Yes", tier: "3" },
  { pincode: 814145, serviceable: "Yes", tier: "3" },
  { pincode: 814147, serviceable: "Yes", tier: "3" },
  { pincode: 814148, serviceable: "Yes", tier: "3" },
  { pincode: 814150, serviceable: "Yes", tier: "3" },
  { pincode: 814153, serviceable: "Yes", tier: "3" },
  { pincode: 814154, serviceable: "Yes", tier: "3" },
  { pincode: 814156, serviceable: "Yes", tier: "3" },
  { pincode: 814157, serviceable: "Yes", tier: "3" },
  { pincode: 814158, serviceable: "Yes", tier: "3" },
  { pincode: 814160, serviceable: "Yes", tier: "5" },
  { pincode: 814165, serviceable: "Yes", tier: "3" },
  { pincode: 814166, serviceable: "Yes", tier: "5" },
  { pincode: 814167, serviceable: "Yes", tier: "3" },
  { pincode: 815301, serviceable: "Yes", tier: "3" },
  { pincode: 815302, serviceable: "Yes", tier: "3" },
  { pincode: 815311, serviceable: "Yes", tier: "3" },
  { pincode: 815312, serviceable: "Yes", tier: "3" },
  { pincode: 815351, serviceable: "Yes", tier: "5" },
  { pincode: 815352, serviceable: "Yes", tier: "5" },
  { pincode: 815354, serviceable: "Yes", tier: "5" },
  { pincode: 815355, serviceable: "Yes", tier: "5" },
  { pincode: 815357, serviceable: "Yes", tier: "5" },
  { pincode: 816104, serviceable: "Yes", tier: "3" },
  { pincode: 816107, serviceable: "Yes", tier: "3" },
  { pincode: 816108, serviceable: "Yes", tier: "5" },
  { pincode: 816109, serviceable: "Yes", tier: "5" },
  { pincode: 816115, serviceable: "Yes", tier: "5" },
  { pincode: 816116, serviceable: "Yes", tier: "5" },
  { pincode: 816118, serviceable: "Yes", tier: "3" },
  { pincode: 816120, serviceable: "Yes", tier: "5" },
  { pincode: 816129, serviceable: "Yes", tier: "5" },
  { pincode: 821101, serviceable: "Yes", tier: "5" },
  { pincode: 821102, serviceable: "Yes", tier: "5" },
  { pincode: 821103, serviceable: "Yes", tier: "5" },
  { pincode: 821106, serviceable: "Yes", tier: "5" },
  { pincode: 821107, serviceable: "Yes", tier: "3" },
  { pincode: 821108, serviceable: "Yes", tier: "5" },
  { pincode: 821109, serviceable: "Yes", tier: "5" },
  { pincode: 821111, serviceable: "Yes", tier: "3" },
  { pincode: 821112, serviceable: "Yes", tier: "3" },
  { pincode: 821115, serviceable: "Yes", tier: "3" },
  { pincode: 821307, serviceable: "Yes", tier: "3" },
  { pincode: 821309, serviceable: "Yes", tier: "3" },
  { pincode: 821310, serviceable: "Yes", tier: "3" },
  { pincode: 822101, serviceable: "Yes", tier: "3" },
  { pincode: 822102, serviceable: "Yes", tier: "3" },
  { pincode: 822110, serviceable: "Yes", tier: "3" },
  { pincode: 822111, serviceable: "Yes", tier: "3" },
  { pincode: 822114, serviceable: "Yes", tier: "3" },
  { pincode: 822121, serviceable: "Yes", tier: "3" },
  { pincode: 822124, serviceable: "Yes", tier: "3" },
  { pincode: 822128, serviceable: "Yes", tier: "3" },
  { pincode: 822132, serviceable: "Yes", tier: "3" },
  { pincode: 822133, serviceable: "Yes", tier: "3" },
  { pincode: 823001, serviceable: "Yes", tier: "3" },
  { pincode: 823002, serviceable: "Yes", tier: "3" },
  { pincode: 823003, serviceable: "Yes", tier: "3" },
  { pincode: 823004, serviceable: "Yes", tier: "3" },
  { pincode: 823005, serviceable: "Yes", tier: "3" },
  { pincode: 824101, serviceable: "Yes", tier: "5" },
  { pincode: 824102, serviceable: "Yes", tier: "5" },
  { pincode: 824103, serviceable: "Yes", tier: "5" },
  { pincode: 824111, serviceable: "Yes", tier: "5" },
  { pincode: 824112, serviceable: "Yes", tier: "5" },
  { pincode: 824113, serviceable: "Yes", tier: "5" },
  { pincode: 824114, serviceable: "Yes", tier: "5" },
  { pincode: 824120, serviceable: "Yes", tier: "3" },
  { pincode: 824121, serviceable: "Yes", tier: "5" },
  { pincode: 824123, serviceable: "Yes", tier: "5" },
  { pincode: 824124, serviceable: "Yes", tier: "5" },
  { pincode: 824143, serviceable: "Yes", tier: "5" },
  { pincode: 824202, serviceable: "Yes", tier: "5" },
  { pincode: 824231, serviceable: "Yes", tier: "3" },
  { pincode: 824301, serviceable: "Yes", tier: "5" },
  { pincode: 824302, serviceable: "Yes", tier: "5" },
  { pincode: 824303, serviceable: "Yes", tier: "5" },
  { pincode: 825101, serviceable: "Yes", tier: "3" },
  { pincode: 825102, serviceable: "Yes", tier: "3" },
  { pincode: 825103, serviceable: "Yes", tier: "3" },
  { pincode: 825301, serviceable: "Yes", tier: "3" },
  { pincode: 825302, serviceable: "Yes", tier: "3" },
  { pincode: 825311, serviceable: "Yes", tier: "3" },
  { pincode: 825314, serviceable: "Yes", tier: "3" },
  { pincode: 825316, serviceable: "Yes", tier: "3" },
  { pincode: 825325, serviceable: "Yes", tier: "3" },
  { pincode: 825330, serviceable: "Yes", tier: "3" },
  { pincode: 825336, serviceable: "Yes", tier: "3" },
  { pincode: 825401, serviceable: "Yes", tier: "3" },
  { pincode: 825402, serviceable: "Yes", tier: "3" },
  { pincode: 825403, serviceable: "Yes", tier: "3" },
  { pincode: 825404, serviceable: "Yes", tier: "3" },
  { pincode: 825407, serviceable: "Yes", tier: "3" },
  { pincode: 825408, serviceable: "Yes", tier: "3" },
  { pincode: 825409, serviceable: "Yes", tier: "3" },
  { pincode: 825410, serviceable: "Yes", tier: "3" },
  { pincode: 825413, serviceable: "Yes", tier: "3" },
  { pincode: 825418, serviceable: "Yes", tier: "3" },
  { pincode: 825421, serviceable: "Yes", tier: "3" },
  { pincode: 826001, serviceable: "Yes", tier: "3" },
  { pincode: 826003, serviceable: "Yes", tier: "3" },
  { pincode: 826004, serviceable: "Yes", tier: "3" },
  { pincode: 826005, serviceable: "Yes", tier: "3" },
  { pincode: 826006, serviceable: "Yes", tier: "3" },
  { pincode: 826106, serviceable: "Yes", tier: "3" },
  { pincode: 827001, serviceable: "Yes", tier: "3" },
  { pincode: 827003, serviceable: "Yes", tier: "3" },
  { pincode: 827004, serviceable: "Yes", tier: "3" },
  { pincode: 827006, serviceable: "Yes", tier: "3" },
  { pincode: 827009, serviceable: "Yes", tier: "3" },
  { pincode: 827010, serviceable: "Yes", tier: "3" },
  { pincode: 827011, serviceable: "Yes", tier: "3" },
  { pincode: 827012, serviceable: "Yes", tier: "3" },
  { pincode: 827013, serviceable: "Yes", tier: "3" },
  { pincode: 827014, serviceable: "Yes", tier: "3" },
  { pincode: 827015, serviceable: "Yes", tier: "3" },
  { pincode: 827302, serviceable: "Yes", tier: "3" },
  { pincode: 827611, serviceable: "Yes", tier: "3" },
  { pincode: 828101, serviceable: "Yes", tier: "3" },
  { pincode: 828103, serviceable: "Yes", tier: "3" },
  { pincode: 828104, serviceable: "Yes", tier: "3" },
  { pincode: 828105, serviceable: "Yes", tier: "3" },
  { pincode: 828106, serviceable: "Yes", tier: "3" },
  { pincode: 828107, serviceable: "Yes", tier: "3" },
  { pincode: 828108, serviceable: "Yes", tier: "3" },
  { pincode: 828109, serviceable: "Yes", tier: "3" },
  { pincode: 828110, serviceable: "Yes", tier: "3" },
  { pincode: 828111, serviceable: "Yes", tier: "3" },
  { pincode: 828112, serviceable: "Yes", tier: "3" },
  { pincode: 828113, serviceable: "Yes", tier: "3" },
  { pincode: 828114, serviceable: "Yes", tier: "3" },
  { pincode: 828115, serviceable: "Yes", tier: "3" },
  { pincode: 828116, serviceable: "Yes", tier: "3" },
  { pincode: 828117, serviceable: "Yes", tier: "3" },
  { pincode: 828119, serviceable: "Yes", tier: "3" },
  { pincode: 828120, serviceable: "Yes", tier: "3" },
  { pincode: 828121, serviceable: "Yes", tier: "3" },
  { pincode: 828122, serviceable: "Yes", tier: "3" },
  { pincode: 828123, serviceable: "Yes", tier: "3" },
  { pincode: 828124, serviceable: "Yes", tier: "3" },
  { pincode: 828125, serviceable: "Yes", tier: "3" },
  { pincode: 828126, serviceable: "Yes", tier: "3" },
  { pincode: 828127, serviceable: "Yes", tier: "3" },
  { pincode: 828128, serviceable: "Yes", tier: "3" },
  { pincode: 828129, serviceable: "Yes", tier: "3" },
  { pincode: 828130, serviceable: "Yes", tier: "3" },
  { pincode: 828131, serviceable: "Yes", tier: "3" },
  { pincode: 828132, serviceable: "Yes", tier: "3" },
  { pincode: 828133, serviceable: "Yes", tier: "3" },
  { pincode: 828134, serviceable: "Yes", tier: "3" },
  { pincode: 828135, serviceable: "Yes", tier: "3" },
  { pincode: 828201, serviceable: "Yes", tier: "3" },
  { pincode: 828206, serviceable: "Yes", tier: "3" },
  { pincode: 828301, serviceable: "Yes", tier: "3" },
  { pincode: 828302, serviceable: "Yes", tier: "3" },
  { pincode: 828303, serviceable: "Yes", tier: "3" },
  { pincode: 828304, serviceable: "Yes", tier: "3" },
  { pincode: 828305, serviceable: "Yes", tier: "3" },
  { pincode: 828306, serviceable: "Yes", tier: "3" },
  { pincode: 828307, serviceable: "Yes", tier: "3" },
  { pincode: 828309, serviceable: "Yes", tier: "3" },
  { pincode: 828401, serviceable: "Yes", tier: "3" },
  { pincode: 828402, serviceable: "Yes", tier: "3" },
  { pincode: 828403, serviceable: "Yes", tier: "3" },
  { pincode: 828404, serviceable: "Yes", tier: "3" },
  { pincode: 829101, serviceable: "Yes", tier: "3" },
  { pincode: 829102, serviceable: "Yes", tier: "3" },
  { pincode: 829103, serviceable: "Yes", tier: "3" },
  { pincode: 829104, serviceable: "Yes", tier: "3" },
  { pincode: 829105, serviceable: "Yes", tier: "3" },
  { pincode: 829106, serviceable: "Yes", tier: "3" },
  { pincode: 829107, serviceable: "Yes", tier: "3" },
  { pincode: 829108, serviceable: "Yes", tier: "3" },
  { pincode: 829109, serviceable: "Yes", tier: "3" },
  { pincode: 829110, serviceable: "Yes", tier: "3" },
  { pincode: 829111, serviceable: "Yes", tier: "3" },
  { pincode: 829112, serviceable: "Yes", tier: "3" },
  { pincode: 829113, serviceable: "Yes", tier: "3" },
  { pincode: 829114, serviceable: "Yes", tier: "3" },
  { pincode: 829115, serviceable: "Yes", tier: "3" },
  { pincode: 829116, serviceable: "Yes", tier: "3" },
  { pincode: 829117, serviceable: "Yes", tier: "3" },
  { pincode: 829118, serviceable: "Yes", tier: "3" },
  { pincode: 829119, serviceable: "Yes", tier: "3" },
  { pincode: 829121, serviceable: "Yes", tier: "3" },
  { pincode: 829122, serviceable: "Yes", tier: "3" },
  { pincode: 829123, serviceable: "Yes", tier: "3" },
  { pincode: 829124, serviceable: "Yes", tier: "3" },
  { pincode: 829125, serviceable: "Yes", tier: "3" },
  { pincode: 829126, serviceable: "Yes", tier: "3" },
  { pincode: 829127, serviceable: "Yes", tier: "3" },
  { pincode: 829128, serviceable: "Yes", tier: "3" },
  { pincode: 829129, serviceable: "Yes", tier: "3" },
  { pincode: 829130, serviceable: "Yes", tier: "3" },
  { pincode: 829131, serviceable: "Yes", tier: "3" },
  { pincode: 829132, serviceable: "Yes", tier: "3" },
  { pincode: 829133, serviceable: "Yes", tier: "3" },
  { pincode: 829134, serviceable: "Yes", tier: "3" },
  { pincode: 829135, serviceable: "Yes", tier: "3" },
  { pincode: 829138, serviceable: "Yes", tier: "3" },
  { pincode: 829143, serviceable: "Yes", tier: "3" },
  { pincode: 829144, serviceable: "Yes", tier: "3" },
  { pincode: 829149, serviceable: "Yes", tier: "3" },
  { pincode: 829150, serviceable: "Yes", tier: "3" },
  { pincode: 829203, serviceable: "Yes", tier: "3" },
  { pincode: 829206, serviceable: "Yes", tier: "3" },
  { pincode: 829207, serviceable: "Yes", tier: "3" },
  { pincode: 829301, serviceable: "Yes", tier: "3" },
  { pincode: 831001, serviceable: "Yes", tier: "2" },
  { pincode: 831002, serviceable: "Yes", tier: "2" },
  { pincode: 831003, serviceable: "Yes", tier: "2" },
  { pincode: 831004, serviceable: "Yes", tier: "2" },
  { pincode: 831005, serviceable: "Yes", tier: "2" },
  { pincode: 831006, serviceable: "Yes", tier: "2" },
  { pincode: 831007, serviceable: "Yes", tier: "2" },
  { pincode: 831008, serviceable: "Yes", tier: "2" },
  { pincode: 831009, serviceable: "Yes", tier: "2" },
  { pincode: 831010, serviceable: "Yes", tier: "2" },
  { pincode: 831011, serviceable: "Yes", tier: "2" },
  { pincode: 831012, serviceable: "Yes", tier: "2" },
  { pincode: 831013, serviceable: "Yes", tier: "2" },
  { pincode: 831014, serviceable: "Yes", tier: "2" },
  { pincode: 831015, serviceable: "Yes", tier: "2" },
  { pincode: 831016, serviceable: "Yes", tier: "2" },
  { pincode: 831017, serviceable: "Yes", tier: "2" },
  { pincode: 831018, serviceable: "Yes", tier: "2" },
  { pincode: 831019, serviceable: "Yes", tier: "2" },
  { pincode: 831020, serviceable: "Yes", tier: "2" },
  { pincode: 831021, serviceable: "Yes", tier: "5" },
  { pincode: 831035, serviceable: "Yes", tier: "2" },
  { pincode: 832102, serviceable: "Yes", tier: "3" },
  { pincode: 832103, serviceable: "Yes", tier: "3" },
  { pincode: 832104, serviceable: "Yes", tier: "3" },
  { pincode: 832105, serviceable: "Yes", tier: "2" },
  { pincode: 832106, serviceable: "Yes", tier: "3" },
  { pincode: 832107, serviceable: "Yes", tier: "2" },
  { pincode: 832108, serviceable: "Yes", tier: "2" },
  { pincode: 832109, serviceable: "Yes", tier: "2" },
  { pincode: 832110, serviceable: "Yes", tier: "2" },
  { pincode: 832111, serviceable: "Yes", tier: "3" },
  { pincode: 832302, serviceable: "Yes", tier: "3" },
  { pincode: 832303, serviceable: "Yes", tier: "3" },
  { pincode: 832304, serviceable: "Yes", tier: "3" },
  { pincode: 833102, serviceable: "Yes", tier: "3" },
  { pincode: 833103, serviceable: "Yes", tier: "3" },
  { pincode: 833105, serviceable: "Yes", tier: "3" },
  { pincode: 833201, serviceable: "Yes", tier: "3" },
  { pincode: 833202, serviceable: "Yes", tier: "3" },
  { pincode: 833212, serviceable: "Yes", tier: "3" },
  { pincode: 833215, serviceable: "Yes", tier: "3" },
  { pincode: 833217, serviceable: "Yes", tier: "3" },
  { pincode: 833218, serviceable: "Yes", tier: "3" },
  { pincode: 834001, serviceable: "Yes", tier: "2" },
  { pincode: 834002, serviceable: "Yes", tier: "2" },
  { pincode: 834003, serviceable: "Yes", tier: "2" },
  { pincode: 834004, serviceable: "Yes", tier: "2" },
  { pincode: 834005, serviceable: "Yes", tier: "2" },
  { pincode: 834006, serviceable: "Yes", tier: "2" },
  { pincode: 834007, serviceable: "Yes", tier: "2" },
  { pincode: 834008, serviceable: "Yes", tier: "2" },
  { pincode: 834009, serviceable: "Yes", tier: "2" },
  { pincode: 834010, serviceable: "Yes", tier: "2" },
  { pincode: 834011, serviceable: "Yes", tier: "2" },
  { pincode: 834012, serviceable: "Yes", tier: "2" },
  { pincode: 834013, serviceable: "Yes", tier: "2" },
  { pincode: 835103, serviceable: "Yes", tier: "2" },
  { pincode: 835207, serviceable: "Yes", tier: "3" },
  { pincode: 835208, serviceable: "Yes", tier: "3" },
  { pincode: 835213, serviceable: "Yes", tier: "3" },
  { pincode: 835215, serviceable: "Yes", tier: "2" },
  { pincode: 835217, serviceable: "Yes", tier: "3" },
  { pincode: 835219, serviceable: "Yes", tier: "3" },
  { pincode: 835222, serviceable: "Yes", tier: "2" },
  { pincode: 835223, serviceable: "Yes", tier: "3" },
  { pincode: 835224, serviceable: "Yes", tier: "3" },
  { pincode: 835226, serviceable: "Yes", tier: "3" },
  { pincode: 835228, serviceable: "Yes", tier: "3" },
  { pincode: 835233, serviceable: "Yes", tier: "3" },
  { pincode: 835235, serviceable: "Yes", tier: "3" },
  { pincode: 835302, serviceable: "Yes", tier: "3" },
  { pincode: 835325, serviceable: "Yes", tier: "3" },
  { pincode: 841101, serviceable: "Yes", tier: "2" },
  { pincode: 841201, serviceable: "Yes", tier: "3" },
  { pincode: 841202, serviceable: "Yes", tier: "3" },
  { pincode: 841203, serviceable: "Yes", tier: "3" },
  { pincode: 841204, serviceable: "Yes", tier: "3" },
  { pincode: 841205, serviceable: "Yes", tier: "3" },
  { pincode: 841206, serviceable: "Yes", tier: "3" },
  { pincode: 841207, serviceable: "Yes", tier: "3" },
  { pincode: 841208, serviceable: "Yes", tier: "3" },
  { pincode: 841209, serviceable: "Yes", tier: "3" },
  { pincode: 841211, serviceable: "Yes", tier: "3" },
  { pincode: 841212, serviceable: "Yes", tier: "3" },
  { pincode: 841213, serviceable: "Yes", tier: "3" },
  { pincode: 841214, serviceable: "Yes", tier: "3" },
  { pincode: 841216, serviceable: "Yes", tier: "3" },
  { pincode: 841217, serviceable: "Yes", tier: "2" },
  { pincode: 841218, serviceable: "Yes", tier: "3" },
  { pincode: 841219, serviceable: "Yes", tier: "3" },
  { pincode: 841220, serviceable: "Yes", tier: "3" },
  { pincode: 841221, serviceable: "Yes", tier: "2" },
  { pincode: 841222, serviceable: "Yes", tier: "2" },
  { pincode: 841223, serviceable: "Yes", tier: "3" },
  { pincode: 841225, serviceable: "Yes", tier: "3" },
  { pincode: 841226, serviceable: "Yes", tier: "3" },
  { pincode: 841227, serviceable: "Yes", tier: "3" },
  { pincode: 841231, serviceable: "Yes", tier: "3" },
  { pincode: 841232, serviceable: "Yes", tier: "3" },
  { pincode: 841233, serviceable: "Yes", tier: "3" },
  { pincode: 841236, serviceable: "Yes", tier: "3" },
  { pincode: 841237, serviceable: "Yes", tier: "3" },
  { pincode: 841238, serviceable: "Yes", tier: "3" },
  { pincode: 841239, serviceable: "Yes", tier: "3" },
  { pincode: 841240, serviceable: "Yes", tier: "3" },
  { pincode: 841241, serviceable: "Yes", tier: "3" },
  { pincode: 841244, serviceable: "Yes", tier: "3" },
  { pincode: 841245, serviceable: "Yes", tier: "3" },
  { pincode: 841286, serviceable: "Yes", tier: "3" },
  { pincode: 841287, serviceable: "Yes", tier: "3" },
  { pincode: 841301, serviceable: "Yes", tier: "3" },
  { pincode: 841302, serviceable: "Yes", tier: "3" },
  { pincode: 841305, serviceable: "Yes", tier: "3" },
  { pincode: 841311, serviceable: "Yes", tier: "3" },
  { pincode: 841313, serviceable: "Yes", tier: "3" },
  { pincode: 841316, serviceable: "Yes", tier: "3" },
  { pincode: 841401, serviceable: "Yes", tier: "3" },
  { pincode: 841402, serviceable: "Yes", tier: "3" },
  { pincode: 841403, serviceable: "Yes", tier: "3" },
  { pincode: 841405, serviceable: "Yes", tier: "5" },
  { pincode: 841411, serviceable: "Yes", tier: "3" },
  { pincode: 841412, serviceable: "Yes", tier: "3" },
  { pincode: 841414, serviceable: "Yes", tier: "3" },
  { pincode: 841415, serviceable: "Yes", tier: "3" },
  { pincode: 841418, serviceable: "Yes", tier: "3" },
  { pincode: 841419, serviceable: "Yes", tier: "3" },
  { pincode: 841421, serviceable: "Yes", tier: "3" },
  { pincode: 841422, serviceable: "Yes", tier: "3" },
  { pincode: 841423, serviceable: "Yes", tier: "5" },
  { pincode: 841424, serviceable: "Yes", tier: "3" },
  { pincode: 841427, serviceable: "Yes", tier: "5" },
  { pincode: 841428, serviceable: "Yes", tier: "5" },
  { pincode: 841436, serviceable: "Yes", tier: "5" },
  { pincode: 841438, serviceable: "Yes", tier: "5" },
  { pincode: 841439, serviceable: "Yes", tier: "3" },
  { pincode: 841440, serviceable: "Yes", tier: "5" },
  { pincode: 841442, serviceable: "Yes", tier: "3" },
  { pincode: 841446, serviceable: "Yes", tier: "3" },
  { pincode: 841501, serviceable: "Yes", tier: "5" },
  { pincode: 841503, serviceable: "Yes", tier: "5" },
  { pincode: 841505, serviceable: "Yes", tier: "5" },
  { pincode: 841506, serviceable: "Yes", tier: "3" },
  { pincode: 842001, serviceable: "Yes", tier: "3" },
  { pincode: 842002, serviceable: "Yes", tier: "3" },
  { pincode: 842003, serviceable: "Yes", tier: "3" },
  { pincode: 842004, serviceable: "Yes", tier: "3" },
  { pincode: 842005, serviceable: "Yes", tier: "3" },
  { pincode: 842008, serviceable: "Yes", tier: "3" },
  { pincode: 843101, serviceable: "Yes", tier: "3" },
  { pincode: 843102, serviceable: "Yes", tier: "3" },
  { pincode: 843103, serviceable: "Yes", tier: "3" },
  { pincode: 843104, serviceable: "Yes", tier: "3" },
  { pincode: 843105, serviceable: "Yes", tier: "3" },
  { pincode: 843106, serviceable: "Yes", tier: "3" },
  { pincode: 843107, serviceable: "Yes", tier: "3" },
  { pincode: 843108, serviceable: "Yes", tier: "3" },
  { pincode: 843109, serviceable: "Yes", tier: "3" },
  { pincode: 843110, serviceable: "Yes", tier: "3" },
  { pincode: 843111, serviceable: "Yes", tier: "3" },
  { pincode: 843112, serviceable: "Yes", tier: "3" },
  { pincode: 843113, serviceable: "Yes", tier: "3" },
  { pincode: 843114, serviceable: "Yes", tier: "3" },
  { pincode: 843115, serviceable: "Yes", tier: "3" },
  { pincode: 843116, serviceable: "Yes", tier: "3" },
  { pincode: 843117, serviceable: "Yes", tier: "3" },
  { pincode: 843118, serviceable: "Yes", tier: "3" },
  { pincode: 843119, serviceable: "Yes", tier: "3" },
  { pincode: 843120, serviceable: "Yes", tier: "3" },
  { pincode: 843121, serviceable: "Yes", tier: "3" },
  { pincode: 843122, serviceable: "Yes", tier: "3" },
  { pincode: 843123, serviceable: "Yes", tier: "3" },
  { pincode: 843124, serviceable: "Yes", tier: "3" },
  { pincode: 843125, serviceable: "Yes", tier: "3" },
  { pincode: 843126, serviceable: "Yes", tier: "3" },
  { pincode: 843127, serviceable: "Yes", tier: "3" },
  { pincode: 843128, serviceable: "Yes", tier: "3" },
  { pincode: 843129, serviceable: "Yes", tier: "3" },
  { pincode: 843130, serviceable: "Yes", tier: "3" },
  { pincode: 843131, serviceable: "Yes", tier: "3" },
  { pincode: 843132, serviceable: "Yes", tier: "3" },
  { pincode: 843141, serviceable: "Yes", tier: "3" },
  { pincode: 843146, serviceable: "Yes", tier: "3" },
  { pincode: 843301, serviceable: "Yes", tier: "3" },
  { pincode: 843302, serviceable: "Yes", tier: "3" },
  { pincode: 843311, serviceable: "Yes", tier: "3" },
  { pincode: 843312, serviceable: "Yes", tier: "3" },
  { pincode: 843314, serviceable: "Yes", tier: "3" },
  { pincode: 843315, serviceable: "Yes", tier: "3" },
  { pincode: 843316, serviceable: "Yes", tier: "3" },
  { pincode: 843317, serviceable: "Yes", tier: "3" },
  { pincode: 843320, serviceable: "Yes", tier: "3" },
  { pincode: 843321, serviceable: "Yes", tier: "3" },
  { pincode: 843322, serviceable: "Yes", tier: "3" },
  { pincode: 843323, serviceable: "Yes", tier: "3" },
  { pincode: 843324, serviceable: "Yes", tier: "3" },
  { pincode: 843325, serviceable: "Yes", tier: "3" },
  { pincode: 843327, serviceable: "Yes", tier: "3" },
  { pincode: 843328, serviceable: "Yes", tier: "3" },
  { pincode: 843329, serviceable: "Yes", tier: "3" },
  { pincode: 843330, serviceable: "Yes", tier: "3" },
  { pincode: 843331, serviceable: "Yes", tier: "3" },
  { pincode: 843332, serviceable: "Yes", tier: "3" },
  { pincode: 843334, serviceable: "Yes", tier: "3" },
  { pincode: 843351, serviceable: "Yes", tier: "3" },
  { pincode: 843360, serviceable: "Yes", tier: "3" },
  { pincode: 844101, serviceable: "Yes", tier: "2" },
  { pincode: 844102, serviceable: "Yes", tier: "2" },
  { pincode: 844103, serviceable: "Yes", tier: "2" },
  { pincode: 844111, serviceable: "Yes", tier: "3" },
  { pincode: 844112, serviceable: "Yes", tier: "3" },
  { pincode: 844113, serviceable: "Yes", tier: "2" },
  { pincode: 844114, serviceable: "Yes", tier: "3" },
  { pincode: 844115, serviceable: "Yes", tier: "2" },
  { pincode: 844116, serviceable: "Yes", tier: "3" },
  { pincode: 844117, serviceable: "Yes", tier: "2" },
  { pincode: 844118, serviceable: "Yes", tier: "3" },
  { pincode: 844119, serviceable: "Yes", tier: "2" },
  { pincode: 844120, serviceable: "Yes", tier: "3" },
  { pincode: 844121, serviceable: "Yes", tier: "2" },
  { pincode: 844122, serviceable: "Yes", tier: "3" },
  { pincode: 844123, serviceable: "Yes", tier: "3" },
  { pincode: 844124, serviceable: "Yes", tier: "3" },
  { pincode: 844125, serviceable: "Yes", tier: "3" },
  { pincode: 844126, serviceable: "Yes", tier: "3" },
  { pincode: 844127, serviceable: "Yes", tier: "3" },
  { pincode: 844128, serviceable: "Yes", tier: "2" },
  { pincode: 844501, serviceable: "Yes", tier: "3" },
  { pincode: 844502, serviceable: "Yes", tier: "2" },
  { pincode: 844503, serviceable: "Yes", tier: "2" },
  { pincode: 844504, serviceable: "Yes", tier: "2" },
  { pincode: 844505, serviceable: "Yes", tier: "3" },
  { pincode: 844507, serviceable: "Yes", tier: "3" },
  { pincode: 845103, serviceable: "Yes", tier: "5" },
  { pincode: 845106, serviceable: "Yes", tier: "5" },
  { pincode: 845301, serviceable: "Yes", tier: "5" },
  { pincode: 845305, serviceable: "Yes", tier: "5" },
  { pincode: 845306, serviceable: "Yes", tier: "5" },
  { pincode: 845307, serviceable: "Yes", tier: "5" },
  { pincode: 845401, serviceable: "Yes", tier: "3" },
  { pincode: 845411, serviceable: "Yes", tier: "3" },
  { pincode: 845412, serviceable: "Yes", tier: "3" },
  { pincode: 845414, serviceable: "Yes", tier: "3" },
  { pincode: 845415, serviceable: "Yes", tier: "3" },
  { pincode: 845416, serviceable: "Yes", tier: "3" },
  { pincode: 845417, serviceable: "Yes", tier: "3" },
  { pincode: 845419, serviceable: "Yes", tier: "3" },
  { pincode: 845420, serviceable: "Yes", tier: "3" },
  { pincode: 845422, serviceable: "Yes", tier: "3" },
  { pincode: 845425, serviceable: "Yes", tier: "3" },
  { pincode: 845426, serviceable: "Yes", tier: "3" },
  { pincode: 845427, serviceable: "Yes", tier: "3" },
  { pincode: 845429, serviceable: "Yes", tier: "3" },
  { pincode: 845430, serviceable: "Yes", tier: "3" },
  { pincode: 845431, serviceable: "Yes", tier: "3" },
  { pincode: 845433, serviceable: "Yes", tier: "5" },
  { pincode: 845434, serviceable: "Yes", tier: "3" },
  { pincode: 845435, serviceable: "Yes", tier: "3" },
  { pincode: 845436, serviceable: "Yes", tier: "3" },
  { pincode: 845437, serviceable: "Yes", tier: "3" },
  { pincode: 845438, serviceable: "Yes", tier: "5" },
  { pincode: 845440, serviceable: "Yes", tier: "5" },
  { pincode: 845449, serviceable: "Yes", tier: "5" },
  { pincode: 845450, serviceable: "Yes", tier: "5" },
  { pincode: 845451, serviceable: "Yes", tier: "5" },
  { pincode: 845452, serviceable: "Yes", tier: "5" },
  { pincode: 845453, serviceable: "Yes", tier: "5" },
  { pincode: 845454, serviceable: "Yes", tier: "5" },
  { pincode: 845455, serviceable: "Yes", tier: "5" },
  { pincode: 845456, serviceable: "Yes", tier: "5" },
  { pincode: 845458, serviceable: "Yes", tier: "3" },
  { pincode: 845459, serviceable: "Yes", tier: "5" },
  { pincode: 846001, serviceable: "Yes", tier: "3" },
  { pincode: 846002, serviceable: "Yes", tier: "3" },
  { pincode: 846003, serviceable: "Yes", tier: "3" },
  { pincode: 846004, serviceable: "Yes", tier: "3" },
  { pincode: 846005, serviceable: "Yes", tier: "3" },
  { pincode: 846006, serviceable: "Yes", tier: "3" },
  { pincode: 846007, serviceable: "Yes", tier: "3" },
  { pincode: 846008, serviceable: "Yes", tier: "3" },
  { pincode: 846009, serviceable: "Yes", tier: "3" },
  { pincode: 847101, serviceable: "Yes", tier: "3" },
  { pincode: 847103, serviceable: "Yes", tier: "3" },
  { pincode: 847104, serviceable: "Yes", tier: "3" },
  { pincode: 847106, serviceable: "Yes", tier: "3" },
  { pincode: 847107, serviceable: "Yes", tier: "3" },
  { pincode: 847109, serviceable: "Yes", tier: "5" },
  { pincode: 847115, serviceable: "Yes", tier: "3" },
  { pincode: 847121, serviceable: "Yes", tier: "5" },
  { pincode: 847123, serviceable: "Yes", tier: "3" },
  { pincode: 847211, serviceable: "Yes", tier: "5" },
  { pincode: 847212, serviceable: "Yes", tier: "5" },
  { pincode: 847222, serviceable: "Yes", tier: "5" },
  { pincode: 847225, serviceable: "Yes", tier: "5" },
  { pincode: 847226, serviceable: "Yes", tier: "5" },
  { pincode: 847227, serviceable: "Yes", tier: "5" },
  { pincode: 847229, serviceable: "Yes", tier: "5" },
  { pincode: 847230, serviceable: "Yes", tier: "5" },
  { pincode: 847232, serviceable: "Yes", tier: "5" },
  { pincode: 847233, serviceable: "Yes", tier: "3" },
  { pincode: 847234, serviceable: "Yes", tier: "5" },
  { pincode: 847236, serviceable: "Yes", tier: "5" },
  { pincode: 847238, serviceable: "Yes", tier: "5" },
  { pincode: 847240, serviceable: "Yes", tier: "5" },
  { pincode: 847306, serviceable: "Yes", tier: "3" },
  { pincode: 847337, serviceable: "Yes", tier: "5" },
  { pincode: 847401, serviceable: "Yes", tier: "5" },
  { pincode: 847402, serviceable: "Yes", tier: "5" },
  { pincode: 847403, serviceable: "Yes", tier: "5" },
  { pincode: 847404, serviceable: "Yes", tier: "5" },
  { pincode: 847407, serviceable: "Yes", tier: "5" },
  { pincode: 847408, serviceable: "Yes", tier: "5" },
  { pincode: 847409, serviceable: "Yes", tier: "5" },
  { pincode: 847410, serviceable: "Yes", tier: "5" },
  { pincode: 847411, serviceable: "Yes", tier: "5" },
  { pincode: 847428, serviceable: "Yes", tier: "3" },
  { pincode: 847429, serviceable: "Yes", tier: "3" },
  { pincode: 848101, serviceable: "Yes", tier: "3" },
  { pincode: 848102, serviceable: "Yes", tier: "3" },
  { pincode: 848113, serviceable: "Yes", tier: "3" },
  { pincode: 848114, serviceable: "Yes", tier: "3" },
  { pincode: 848115, serviceable: "Yes", tier: "3" },
  { pincode: 848117, serviceable: "Yes", tier: "3" },
  { pincode: 848121, serviceable: "Yes", tier: "3" },
  { pincode: 848122, serviceable: "Yes", tier: "3" },
  { pincode: 848125, serviceable: "Yes", tier: "3" },
  { pincode: 848127, serviceable: "Yes", tier: "3" },
  { pincode: 848129, serviceable: "Yes", tier: "3" },
  { pincode: 848130, serviceable: "Yes", tier: "3" },
  { pincode: 848131, serviceable: "Yes", tier: "3" },
  { pincode: 848132, serviceable: "Yes", tier: "3" },
  { pincode: 848133, serviceable: "Yes", tier: "3" },
  { pincode: 848134, serviceable: "Yes", tier: "3" },
  { pincode: 848160, serviceable: "Yes", tier: "3" },
  { pincode: 848203, serviceable: "Yes", tier: "5" },
  { pincode: 848210, serviceable: "Yes", tier: "3" },
  { pincode: 848211, serviceable: "Yes", tier: "3" },
  { pincode: 848236, serviceable: "Yes", tier: "3" },
  { pincode: 848301, serviceable: "Yes", tier: "3" },
  { pincode: 848302, serviceable: "Yes", tier: "3" },
  { pincode: 848502, serviceable: "Yes", tier: "3" },
  { pincode: 848503, serviceable: "Yes", tier: "3" },
  { pincode: 848505, serviceable: "Yes", tier: "3" },
  { pincode: 851101, serviceable: "Yes", tier: "3" },
  { pincode: 851111, serviceable: "Yes", tier: "3" },
  { pincode: 851112, serviceable: "Yes", tier: "3" },
  { pincode: 851113, serviceable: "Yes", tier: "3" },
  { pincode: 851114, serviceable: "Yes", tier: "3" },
  { pincode: 851115, serviceable: "Yes", tier: "3" },
  { pincode: 851116, serviceable: "Yes", tier: "3" },
  { pincode: 851117, serviceable: "Yes", tier: "3" },
  { pincode: 851118, serviceable: "Yes", tier: "3" },
  { pincode: 851126, serviceable: "Yes", tier: "3" },
  { pincode: 851127, serviceable: "Yes", tier: "3" },
  { pincode: 851128, serviceable: "Yes", tier: "3" },
  { pincode: 851129, serviceable: "Yes", tier: "3" },
  { pincode: 851130, serviceable: "Yes", tier: "3" },
  { pincode: 851131, serviceable: "Yes", tier: "3" },
  { pincode: 851132, serviceable: "Yes", tier: "3" },
  { pincode: 851133, serviceable: "Yes", tier: "3" },
  { pincode: 851134, serviceable: "Yes", tier: "3" },
  { pincode: 851135, serviceable: "Yes", tier: "3" },
  { pincode: 851202, serviceable: "Yes", tier: "5" },
  { pincode: 851203, serviceable: "Yes", tier: "5" },
  { pincode: 851204, serviceable: "Yes", tier: "5" },
  { pincode: 851205, serviceable: "Yes", tier: "5" },
  { pincode: 851210, serviceable: "Yes", tier: "3" },
  { pincode: 851211, serviceable: "Yes", tier: "3" },
  { pincode: 851212, serviceable: "Yes", tier: "5" },
  { pincode: 851213, serviceable: "Yes", tier: "5" },
  { pincode: 851214, serviceable: "Yes", tier: "5" },
  { pincode: 851218, serviceable: "Yes", tier: "3" },
  { pincode: 852105, serviceable: "Yes", tier: "5" },
  { pincode: 852106, serviceable: "Yes", tier: "5" },
  { pincode: 852107, serviceable: "Yes", tier: "5" },
  { pincode: 852108, serviceable: "Yes", tier: "5" },
  { pincode: 852109, serviceable: "Yes", tier: "5" },
  { pincode: 852111, serviceable: "Yes", tier: "5" },
  { pincode: 852113, serviceable: "Yes", tier: "5" },
  { pincode: 852114, serviceable: "Yes", tier: "5" },
  { pincode: 852115, serviceable: "Yes", tier: "5" },
  { pincode: 852121, serviceable: "Yes", tier: "5" },
  { pincode: 852122, serviceable: "Yes", tier: "5" },
  { pincode: 852127, serviceable: "Yes", tier: "5" },
  { pincode: 852128, serviceable: "Yes", tier: "5" },
  { pincode: 852130, serviceable: "Yes", tier: "5" },
  { pincode: 852131, serviceable: "Yes", tier: "5" },
  { pincode: 852132, serviceable: "Yes", tier: "5" },
  { pincode: 852133, serviceable: "Yes", tier: "5" },
  { pincode: 852138, serviceable: "Yes", tier: "5" },
  { pincode: 852139, serviceable: "Yes", tier: "5" },
  { pincode: 852201, serviceable: "Yes", tier: "5" },
  { pincode: 852202, serviceable: "Yes", tier: "5" },
  { pincode: 852212, serviceable: "Yes", tier: "5" },
  { pincode: 852218, serviceable: "Yes", tier: "5" },
  { pincode: 852221, serviceable: "Yes", tier: "5" },
  { pincode: 853201, serviceable: "Yes", tier: "5" },
  { pincode: 853202, serviceable: "Yes", tier: "5" },
  { pincode: 853204, serviceable: "Yes", tier: "5" },
  { pincode: 853205, serviceable: "Yes", tier: "5" },
  { pincode: 854103, serviceable: "Yes", tier: "5" },
  { pincode: 854105, serviceable: "Yes", tier: "5" },
  { pincode: 854106, serviceable: "Yes", tier: "5" },
  { pincode: 854107, serviceable: "Yes", tier: "5" },
  { pincode: 854108, serviceable: "Yes", tier: "5" },
  { pincode: 854109, serviceable: "Yes", tier: "5" },
  { pincode: 854113, serviceable: "Yes", tier: "5" },
  { pincode: 854115, serviceable: "Yes", tier: "5" },
  { pincode: 854202, serviceable: "Yes", tier: "5" },
  { pincode: 854205, serviceable: "Yes", tier: "5" },
  { pincode: 854301, serviceable: "Yes", tier: "5" },
  { pincode: 854302, serviceable: "Yes", tier: "5" },
  { pincode: 854303, serviceable: "Yes", tier: "5" },
  { pincode: 854304, serviceable: "Yes", tier: "5" },
  { pincode: 854305, serviceable: "Yes", tier: "5" },
  { pincode: 854306, serviceable: "Yes", tier: "5" },
  { pincode: 854311, serviceable: "Yes", tier: "5" },
  { pincode: 854312, serviceable: "Yes", tier: "5" },
  { pincode: 854316, serviceable: "Yes", tier: "3" },
  { pincode: 854318, serviceable: "Yes", tier: "3" },
  { pincode: 854325, serviceable: "Yes", tier: "5" },
  { pincode: 854326, serviceable: "Yes", tier: "5" },
  { pincode: 854327, serviceable: "Yes", tier: "5" },
  { pincode: 854328, serviceable: "Yes", tier: "3" },
  { pincode: 854329, serviceable: "Yes", tier: "5" },
  { pincode: 854330, serviceable: "Yes", tier: "5" },
  { pincode: 854332, serviceable: "Yes", tier: "3" },
  { pincode: 854335, serviceable: "Yes", tier: "3" },
  { pincode: 854336, serviceable: "Yes", tier: "3" },
  { pincode: 854337, serviceable: "Yes", tier: "5" },
  { pincode: 855105, serviceable: "Yes", tier: "5" },
  { pincode: 855107, serviceable: "Yes", tier: "3" },
  { pincode: 855108, serviceable: "Yes", tier: "3" },
  { pincode: 855114, serviceable: "Yes", tier: "5" },
  { pincode: 855115, serviceable: "Yes", tier: "3" },
  { pincode: 855117, serviceable: "Yes", tier: "3" },
];
